webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var SortingService = function () {
  function SortingService(component, initialField, initialSort, callback) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SortingService);

    this.field = initialField;
    this.sort = initialSort;
    this.component = component;
    this.callback = callback;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SortingService, [{
    key: "byField",
    value: function byField(field) {
      this.field = field;
      this.runCallback();
    }
  }, {
    key: "sortBy",
    value: function sortBy(sort) {
      this.sort = sort;
      this.runCallback();
    }
  }, {
    key: "setup",
    value: function setup(field, sort) {
      this.field = field;
      this.sort = sort;
      this.runCallback();
    }
  }, {
    key: "matchSort",
    value: function matchSort(sort) {
      return this.sort === sort;
    }
  }, {
    key: "matchField",
    value: function matchField(field) {
      return this.field === field;
    }
  }, {
    key: "matchPair",
    value: function matchPair(field, sort) {
      return this.matchField(field) && this.matchSort(sort);
    }
  }, {
    key: "runCallback",
    value: function runCallback() {
      this.callback();
    }
  }, {
    key: "getRequestParams",
    value: function getRequestParams() {
      return {
        o: this.field,
        s: this.sort
      };
    }
  }]);

  return SortingService;
}();

/* harmony default export */ __webpack_exports__["a"] = (SortingService);

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = {};
        if (data.error) {
          details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
            icon: 'times',
            type: 'danger'
          }, data);
        } else {
          details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
            icon: 'check',
            type: 'success'
          }, data);
        }

        _this3.bus.$emit('created-entry', details);

        if (!data.error && typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      var fields = ['mean_price', 'sale_price', 'commission', 'discount_margin'];
      fields.forEach(function (field) {
        payload[field] = payload[field].replace('.', '').replace(',', '.');
      });

      var percentFields = [];

      percentFields.forEach(function (percentField) {
        payload[percentField] = payload[percentField].replace('%', '').replace('_', '');
      });

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/edit',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      var fields = ['mean_price', 'sale_price', 'commission', 'discount_margin'];
      fields.forEach(function (field) {
        payload[field] = payload[field].replace('.', '').replace(',', '.');
      });

      var percentFields = [];

      percentFields.forEach(function (percentField) {
        payload[percentField] = payload[percentField].replace('%', '').replace('_', '');
      });
      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('http://vendas.vipcarseminovos.com.br/api/v1/' + this.basePath, {
        params: {
          q: 'tenant_id:' + localStorage.getItem('current-tenant-idkey'),
          sf: 'tenant_id:=',
          'only-available': true
        }
      }).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      }).catch(function (error) {
        return alert(error);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      params.tenant_id = localStorage.getItem('current-tenant-idkey');

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  account_mov_type: {
    label: 'Tipo Conta Movimentação',
    component: 'text-field',
    list: true,
    icon: 'tag',
    placeholder: 'Preencha a Conta de Movimentação',
    name: 'account_mov_type'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'account-mov-type';
var __defaultOrderBy = 'account_mov_type';
var __defaultSortBy = 'asc';
var __defaultIcon = 'tag';
var __defaultResourceLabel = 'Tipo de Conta de Movimentação';
var __defaultSingularResource = 'Tipo de Conta';
var __listSearchFields = 'account_mov_type:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  description: {
    label: 'Conta de Movimentação',
    component: 'text-field',
    list: true,
    icon: 'external-link',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha a Conta de Movimentação',
    name: 'description'
  },
  account_mov_type_id: {
    label: 'Tipo de Conta',
    component: 'entity-field',
    usingAsProvider: '/account-mov-type',
    usingAsLabel: 'account_mov_type',
    resourceKey: 'relation_account_mov_type',
    usingAsValue: 'id_key',
    list: true,
    orderBy: 'account_mov_types.account_mov_type',
    icon: 'external-link',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o Tipo de Conta',
    name: 'account_mov_type_id'
  },
  bank_name: {
    label: 'Nome do Banco',
    component: 'text-field',
    icon: 'institution',
    wrapperClass: 'col-lg-6',
    list: true,
    placeholder: 'Preencha o Nome do banco',
    name: 'bank_name'
  },
  agency: {
    label: 'Agência',
    component: 'text-field',
    icon: 'home',
    wrapperClass: 'col-lg-6',
    list: true,
    placeholder: 'Preencha a Agência',
    name: 'agency'
  },
  account: {
    label: 'Conta Corrente',
    component: 'text-field',
    icon: 'credit-card',
    wrapperClass: 'col-lg-6',
    list: false,
    placeholder: 'Preencha a Conta Corrente',
    name: 'account'
  },
  initial_balance: {
    label: 'Saldo Inicial',
    component: 'monetary-field',
    icon: 'dollar',
    wrapperClass: 'col-lg-6',
    list: false,
    placeholder: 'Preencha o Saldo Inicial',
    name: 'initial_balance'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'account-mov';
var __defaultOrderBy = 'description';
var __defaultSortBy = 'asc';
var __defaultIcon = 'exchange';
var __defaultResourceLabel = 'Conta de Movimentação';
var __defaultSingularResource = 'Conta de Movimentação';
var __listSearchFields = 'description:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
var __fields = [{
  label: 'Nome - Operadora de Cartão',
  component: 'text-field',
  list: true,
  icon: 'edit',
  placeholder: 'Nome - Operadora de Cartão',
  name: 'description'
}, {
  label: 'Taxa cobrada à vista',
  component: 'percent-field',
  list: false,
  icon: 'edit',
  placeholder: 'Preencha a taxa cobrada À VISTA',
  name: 'debit_percent_in_cash'
}, {
  label: 'Tipo de Repasse',
  component: 'select-field',
  list: false,
  icon: 'edit',
  placeholder: 'Preencha o tipo de repasse',
  name: 'debit_pass_through_type'
}, {
  label: 'Dia repasse',
  component: 'text-field',
  list: false,
  icon: 'edit',
  placeholder: 'Preencha o dia de repasse',
  name: 'debit_pass_through_day'
}, {
  label: 'Taxa cobrada À VISTA',
  component: 'percent-field',
  list: false,
  icon: 'edit',
  placeholder: 'Preencha a taxa cobrada À VISTA',
  name: 'credit_percent_in_cash'
}, {
  label: 'Taxa cobrada PARCELADO LOJA',
  component: 'percent-field',
  list: false,
  icon: 'edit',
  placeholder: 'Preencha a taxa cobrada PARCELADO LOJA',
  name: 'credit_in_installment_store'
}, {
  label: 'Taxa cobrada PARCELADO ADMINISTRADORA',
  component: 'percent-field',
  list: false,
  icon: 'edit',
  placeholder: 'Preencha a taxa cobrada PARCELADO ADMINISTRADORA',
  name: 'credit_in_installment_administrator'
}, {
  label: 'Tipo de Repasse',
  component: 'select-field',
  list: false,
  icon: 'edit',
  placeholder: 'Preencha o tipo de repasse',
  name: 'credit_pass_through_type'
}, {
  label: 'Dia repasse',
  component: 'text-field',
  list: false,
  icon: 'edit',
  placeholder: 'Preencha o dia de repasse',
  name: 'credit_pass_through_day'
}, {
  label: 'Ativo',
  component: 'select-field',
  list: true,
  icon: 'edit',
  placeholder: 'Selecione se estiver ativo',
  name: 'active'
}];

var __defaultBasePath = 'card-operators';
var __defaultOrderBy = 'description';
var __defaultSortBy = 'asc';
var __defaultIcon = 'credit-card';
var __defaultResourceLabel = 'Operadores de Cartão';
var __defaultSingularResource = 'Operadora de cartão';
var __listSearchFields = 'description:ilike';








/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  account_mov_type: {
    label: 'Nome',
    component: 'text-field',
    list: true,
    icon: 'tag',
    placeholder: 'Preencha o nome da categoria',
    name: 'description'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'categories-pendency';
var __defaultOrderBy = 'description';
var __defaultSortBy = 'asc';
var __defaultIcon = 'tag';
var __defaultResourceLabel = 'Categorias de Pendência';
var __defaultSingularResource = 'Categoria de Pendência';
var __listSearchFields = 'description:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  description: {
    label: 'Nome',
    component: 'text-field',
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o nome do item do checklist',
    name: 'description'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'checklist-items';
var __defaultOrderBy = 'description';
var __defaultSortBy = 'asc';
var __defaultIcon = 'tag';
var __defaultResourceLabel = 'Itens do Checklist';
var __defaultSingularResource = 'Item do checklist';
var __listSearchFields = 'description:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        if (data.data.duplicated) {
          return;
        }

        _this3.bus.$emit('created-entry', details);
        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  name: {
    label: 'Nome',
    group: 1,
    component: 'text-field',
    list: true,
    icon: '',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o Nome',
    name: 'name'
  },
  father: {
    label: 'Nome Pai',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o nome do Pai',
    name: 'father'
  },
  mother: {
    label: 'Nome Mãe',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o nome da Mãe',
    name: 'mother'
  },
  cpf: {
    label: 'CPF/CNPJ',
    group: 1,
    component: 'masked-field',
    mask: '111.111.111-11',
    list: true,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o CPF/CNPJ',
    name: 'cpf'
  },
  rg: {
    label: 'RG',
    group: 1,
    component: 'text-field',
    list: true,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o RG',
    name: 'rg'
  },
  expedition_date: {
    label: 'Data de Expedição',
    group: 1,
    component: 'masked-field',
    mask: '11/11/1111',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a data de expedição',
    name: 'expedition_date'
  },
  state_expedition: {
    label: 'UF Expedição',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o UF de expedição',
    name: 'state_expedition'
  },
  birthday: {
    label: 'Data de Nascimento',
    group: 1,
    component: 'masked-field',
    mask: '11/11/1111',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha a data de nascimento',
    name: 'birthday'
  },
  gender: {
    label: 'Sexo',
    group: 1,
    component: 'select-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o Sexo',
    name: 'gender',
    selectOptions: [{ label: 'Masculino', value: 'M' }, { label: 'Feminino', value: 'F' }]
  },
  naturalness: {
    label: 'Naturalidade',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a Naturalidade',
    name: 'naturalness'
  },
  civil_state: {
    label: 'Estado Civil',
    group: 1,
    component: 'select-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Estado Civil',
    name: 'civil_state',
    selectOptions: [{ label: 'Solteiro(a)', value: 'S' }, { label: 'Viúvo(a)', value: 'V' }, { label: 'Casado(a)', value: 'C' }, { label: 'Divorciado(a)', value: 'D' }, { label: 'Separado(a)', value: 'SP' }]
  },
  cnh: {
    label: 'CNH',
    group: 1,
    component: 'select-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Possui CNH ?',
    name: 'cnh',
    selectOptions: [{ label: 'SIM', value: true }, { label: 'NÃO', value: false }]
  },
  residential_address: {
    label: 'Endereço Residência',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-4',
    placeholder: 'Preencha o Endereço',
    name: 'residential_address'
  },
  city: {
    label: 'Cidade',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha a Cidade',
    name: 'city'
  },
  neighborhood: {
    label: 'Bairro',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o Bairro',
    name: 'neighborhood'
  },
  zipcode: {
    label: 'CEP',
    group: 1,
    component: 'masked-field',
    list: false,
    icon: '',
    mask: '11.111-111',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o CEP',
    name: 'zipcode'
  },
  residence_time: {
    label: 'Tempo na residência',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o tempo na residência',
    name: 'residence_time'
  },
  phone: {
    label: 'Telefone Fixo',
    group: 1,
    component: 'masked-field',
    mask: '1111-1111',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Telefone fixo',
    name: 'phone'
  },
  phone_type: {
    label: 'Tipo do telefone',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o tipo do telefone',
    name: 'phone_type',
    selectOptions: [{ label: 'Principal', value: 'P' }, { label: 'Recado', value: 'R' }]
  },
  cell_phone: {
    label: 'Telefone Celular',
    group: 1,
    component: 'masked-field',
    mask: '(11) 1 1111-1111',
    list: true,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o telefone celular',
    name: 'cell_phone'
  },
  residence_type: {
    label: 'Tipo de residência',
    group: 1,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o tipo de residência',
    name: 'residence_type'
  },
  obs: {
    label: 'Observações',
    group: 1,
    component: 'textarea-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-12',
    placeholder: 'Observações',
    name: 'obs'
  },
  company_name: {
    label: 'Nome da empresa',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o Nome da empresa',
    name: 'company_name'
  },
  company_cnpj: {
    label: 'CNPJ',
    group: 2,
    component: 'masked-field',
    mask: '11.111.111/1111-11',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o CNPJ',
    name: 'company_cnpj'
  },
  company_accountant: {
    label: 'Nome Contador',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o Nome do contador',
    name: 'company_accountant'
  },
  company_address: {
    label: 'Endereço',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Endereço da empresa',
    name: 'company_address'
  },
  company_neighborhood: {
    label: 'Bairro',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Bairro da empresa',
    name: 'company_neighborhood'
  },
  company_zipcode: {
    label: 'CEP',
    group: 2,
    component: 'masked-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o CEP',
    mask: '11.111-111',
    name: 'company_zipcode'
  },
  company_city: {
    label: 'Cidade',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a Cidade',
    name: 'company_city'
  },
  company_role: {
    label: 'Função',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-4',
    placeholder: 'Preencha o Função',
    name: 'company_role'
  },
  company_work_time: {
    label: 'Tempo na empresa',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o tempo na empresa',
    name: 'company_work_time'
  },
  company_income: {
    label: 'Renda',
    group: 2,
    component: 'monetary-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a renda',
    name: 'company_income'
  },
  compony_income_others: {
    label: 'Outras Rendas',
    group: 2,
    component: 'monetary-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha as Outras Rendas',
    name: 'compony_income_others'
  },
  company_bank: {
    label: 'Banco',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Nome do Banco',
    name: 'company_bank'
  },
  company_agency: {
    label: 'Agência',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a Agência',
    name: 'company_agency'
  },
  company_account: {
    label: 'Conta Corrente',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a Conta Corrente',
    name: 'company_account'
  },
  company_time: {
    label: 'Tempo',
    group: 2,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Tempo',
    name: 'company_time'
  },
  guarantor_name: {
    label: 'Nome Avalista/Conjuge',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o Nome do Avalista/Conjuge',
    name: 'guarantor_name'
  },
  guarantor_cpf: {
    label: 'CPF',
    group: 3,
    component: 'masked-field',
    mask: '111.111.111-11',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o CPF',
    name: 'guarantor_cpf'
  },
  guarantor_rg: {
    label: 'RG',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o RG',
    name: 'guarantor_rg'
  },
  guarantor_expedition_date: {
    label: 'Data de Expedição',
    group: 3,
    component: 'masked-field',
    mask: '11/11/1111',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a Data de Expedição',
    name: 'guarantor_expedition_date'
  },
  guarantor_birthday: {
    label: 'Data de nascimento',
    group: 3,
    component: 'masked-field',
    mask: '11/11/1111',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a data de nascimento',
    name: 'guarantor_birthday'
  },
  guarantor_dependents: {
    label: 'Nº Dependentes',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o Nº Dependentes',
    name: 'guarantor_dependents'
  },
  guarantor_father: {
    label: 'Nome do Pai',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o nome do Pai',
    name: 'guarantor_father'
  },
  guarantor_mother: {
    label: 'Nome da Mãe',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o Nome da mãe',
    name: 'guarantor_mother'
  },
  guarantor_company: {
    label: 'Nome da Empresa',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o Nome da empresa',
    name: 'guarantor_company'
  },
  guarantor_company_address: {
    label: 'Endereço da Empresa',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-4',
    placeholder: 'Preencha o Endereço da Empresa',
    name: 'guarantor_company_address'
  },
  guarantor_neighborhood: {
    label: 'Bairro',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Bairro',
    name: 'guarantor_neighborhood'
  },
  guarantor_zipcode: {
    label: 'CEP',
    group: 3,
    component: 'masked-field',
    mask: '11.111-111',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o CÈP',
    name: 'guarantor_zipcode'
  },
  guarantor_city: {
    label: 'Cidade',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a Cidade',
    name: 'guarantor_city'
  },
  guarantor_role: {
    label: 'Função',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-5',
    placeholder: 'Preencha a Função',
    name: 'guarantor_role'
  },
  guarantor_company_work_time: {
    label: 'Tempo na Empresa',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o tempo na empresa',
    name: 'guarantor_company_work_time'
  },
  guarantor_cell_phone_company: {
    label: 'Telefone Empresa',
    group: 3,
    component: 'text-field',
    mask: '1111-1111',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Telefone da empresa',
    name: 'guarantor_cell_phone_company'
  },
  guarantor_income: {
    label: 'Renda',
    group: 3,
    component: 'monetary-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha a Renda',
    name: 'guarantor_income'
  },
  guarantor_profession: {
    label: 'Profissão',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha a profissão',
    name: 'guarantor_profession'
  },
  guarantor_bank: {
    label: 'Banco',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-4',
    placeholder: 'Preencha o Banco',
    name: 'guarantor_bank'
  },
  guarantor_agency: {
    label: 'Agência',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-4',
    placeholder: 'Preencha o número da agência',
    name: 'guarantor_agency'
  },
  guarantor_account: {
    label: 'Conta Corrente',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-4',
    placeholder: 'Preencha o número da conta',
    name: 'guarantor_account'
  },
  guarantor_time: {
    label: 'Tempo',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o tempo',
    name: 'guarantor_time'
  },
  guarantor_reference_name: {
    label: 'Referência ',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Nome da Referência',
    name: 'guarantor_reference_name'
  },
  guarantor_reference_phone: {
    label: 'Contato da Referência',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Telefone da Referência',
    name: 'guarantor_reference_phone'
  },
  guarantor_reference2_name: {
    label: 'Referência Adicional',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Nome da Referência Adicional',
    name: 'guarantor_reference2_name'
  },
  guarantor_reference2_phone: {
    label: 'Contato da Referência Adicional',
    group: 3,
    component: 'text-field',
    list: false,
    icon: '',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o Telefone da Referência Adicional',
    name: 'guarantor_reference2_phone'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'customers';
var __defaultOrderBy = 'name';
var __defaultSortBy = 'asc';
var __defaultIcon = 'group';
var __defaultResourceLabel = 'Pessoas';
var __defaultSingularResource = 'Pessoa';
var __listSearchFields = 'name:ilike;cpf:ilike;rg:ilike;cell_phone:ilike;';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  name: {
    label: 'Nome',
    component: 'text-field',
    list: true,
    icon: 'user',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o Nome',
    name: 'name'
  },
  profile_id: {
    label: 'Perfil',
    component: 'entity-field',
    usingAsProvider: '/profiles',
    usingAsLabel: 'description',
    resourceKey: 'profile',
    usingAsValue: 'id_key',
    list: true,
    orderBy: 'proiles.description',
    icon: 'tag',
    wrapperClass: 'col-lg-12',
    placeholder: 'Selecione o perfil',
    name: 'profile_id'
  },
  login: {
    label: 'Login',
    component: 'text-field',
    list: true,
    icon: 'address-card-o',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o login',
    name: 'login'
  },
  email: {
    label: 'Email',
    component: 'text-field',
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o email',
    name: 'email'
  },
  password: {
    label: 'Senha',
    component: 'text-field',
    list: false,
    icon: 'key',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha a senha',
    name: 'password'
  },
  active: {
    label: 'Ativo',
    component: 'select-field',
    selectOptions: [{ value: 'true', label: 'SIM' }, { value: 'false', label: 'NÃO' }],
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Selecione se estiver ativo',
    name: 'active'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'employees';
var __defaultOrderBy = 'login';
var __defaultSortBy = 'asc';
var __defaultIcon = 'users';
var __defaultResourceLabel = 'Funcionários';
var __defaultSingularResource = 'Funcionário';
var __listSearchFields = 'name:ilike;login:ilike;email:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  description: {
    label: 'Nome',
    component: 'text-field',
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o nome do item do checklist',
    name: 'description'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'expense-types';
var __defaultOrderBy = 'description';
var __defaultSortBy = 'asc';
var __defaultIcon = 'tag';
var __defaultResourceLabel = 'Tipos de Despesa';
var __defaultSingularResource = 'Tipo de Despesa';
var __listSearchFields = 'description:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  name: {
    label: 'Financeira',
    component: 'text-field',
    list: true,
    icon: 'address-card-o',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o nome da Financeira',
    name: 'name'
  },
  cnpj: {
    label: 'CNPJ',
    component: 'masked-field',
    icon: 'institution',
    wrapperClass: 'col-lg-6',
    list: true,
    placeholder: 'Preencha o Nome do banco',
    mask: '11.111.111/1111-11',
    name: 'cnpj'
  },
  percentage_taxes: {
    label: 'Percentual de Impostos Descontados sobre o retorno',
    component: 'percent-field',
    list: false,
    icon: 'percent',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o Percentual de Imposto',
    name: 'percentage_taxes'
  },
  contact_name: {
    label: 'Nome do Contato',
    component: 'text-field',
    icon: 'user',
    wrapperClass: 'col-lg-4',
    list: true,
    placeholder: 'Preencha o Nome do Contato',
    name: 'contact_name'
  },
  cell_phone: {
    label: 'Telefone Celular',
    component: 'masked-field',
    icon: 'mobile-phone',
    wrapperClass: 'col-lg-4',
    mask: '(11) 1 1111-1111',
    list: false,
    placeholder: 'Preencha o telefone celular',
    name: 'cell_phone'
  },
  cell_phone_2: {
    label: 'Telefone Celular Adicional',
    component: 'masked-field',
    icon: 'mobile-phone',
    wrapperClass: 'col-lg-4',
    mask: '(11) 1 1111-1111',
    list: false,
    placeholder: 'Preencha o telefone celular adicional',
    name: 'cell_phone_2'
  },
  address: {
    label: 'Endereço',
    component: 'text-field',
    icon: 'map-marker',
    wrapperClass: 'col-lg-4',
    list: false,
    placeholder: 'Preencha o Endereço',
    name: 'address'
  },
  address_number: {
    label: 'Número Endereço',
    component: 'text-field',
    icon: 'map-o',
    wrapperClass: 'col-lg-2',
    list: false,
    placeholder: 'Preencha o Número do endereço',
    name: 'address_number'
  },
  complement: {
    label: 'Complemento',
    component: 'text-field',
    icon: 'map-signs',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha o Complemento',
    name: 'complement'
  },
  neighborhood: {
    label: 'Bairro',
    component: 'text-field',
    icon: 'location-arrow',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha o Bairro',
    name: 'neighborhood'
  },
  zipcode: {
    label: 'CEP',
    component: 'masked-field',
    icon: 'edit',
    mask: '11.111-111',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha o CEP',
    name: 'zipcode'
  },
  state: {
    label: 'Estado',
    component: 'text-field',
    icon: 'location-arrow',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha o Estado',
    name: 'state'
  },
  city: {
    label: 'Cidade',
    component: 'text-field',
    icon: 'location-arrow',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha a Cidade',
    name: 'city'
  },
  phone: {
    label: 'Telefone',
    component: 'masked-field',
    icon: 'phone-square',
    wrapperClass: 'col-lg-3',
    mask: '1111-1111',
    list: false,
    placeholder: 'Preencha o telefone fixo',
    name: 'phone'
  },
  email: {
    label: 'Email',
    component: 'text-field',
    icon: 'at',
    wrapperClass: 'col-lg-12',
    list: true,
    placeholder: 'Preencha o email',
    name: 'email'
  },
  active: {
    label: 'Ativo',
    component: 'select-field',
    selectOptions: [{ value: 'true', label: 'SIM' }, { value: 'false', label: 'NÃO' }],
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Selecione se estiver ativo',
    name: 'active'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'finantial';
var __defaultOrderBy = 'name';
var __defaultSortBy = 'asc';
var __defaultIcon = 'institution';
var __defaultResourceLabel = 'Financeiras';
var __defaultSingularResource = 'Financeira';
var __listSearchFields = 'name:ilike;cnpj:ilike;contact_name:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  description: {
    label: 'Descrição',
    component: 'text-field',
    list: true,
    icon: 'external-link',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha a Descrição',
    name: 'description'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'payment-method';
var __defaultOrderBy = 'description';
var __defaultSortBy = 'asc';
var __defaultIcon = 'credit-card';
var __defaultResourceLabel = 'Tipos de Pagamento';
var __defaultSingularResource = 'Tipo de Pagamento';
var __listSearchFields = 'description:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  description: {
    label: 'Descrição',
    component: 'text-field',
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Descrição',
    name: 'description'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'profiles';
var __defaultOrderBy = 'description';
var __defaultSortBy = 'asc';
var __defaultIcon = 'tags';
var __defaultResourceLabel = 'Perfis';
var __defaultSingularResource = 'Perfil';
var __listSearchFields = 'description:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  name: {
    label: 'Fornecedor',
    component: 'text-field',
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o nome da Fornecedor',
    name: 'name'
  },
  cnpj_cpf: {
    label: 'CNPJ / CPF',
    component: 'masked-field',
    icon: 'address-card-o',
    wrapperClass: 'col-lg-6',
    list: true,
    placeholder: 'Preencha o CNPJ/CPF',
    mask: '11.111.111/1111-11',
    name: 'cnpj_cpf'
  },
  contact: {
    label: 'Contato',
    component: 'text-field',
    list: true,
    icon: 'user',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o Nome do Contato',
    name: 'contact'
  },
  cell_phone: {
    label: 'Celular',
    component: 'masked-field',
    icon: 'mobile-phone',
    wrapperClass: 'col-lg-4',
    list: true,
    mask: '(11) 1 1111-1111',
    placeholder: 'Preencha o Celular',
    name: 'cell_phone'
  },
  cell_phone_2: {
    label: 'Celular Adicional',
    component: 'masked-field',
    icon: 'mobile-phone',
    wrapperClass: 'col-lg-4',
    mask: '(11) 1 1111-1111',
    list: false,
    placeholder: 'Preencha o telefone celular adicional',
    name: 'cell_phone_2'
  },
  activity_branch: {
    label: 'Ramo de Atividade',
    component: 'text-field',
    icon: 'industry',
    wrapperClass: 'col-lg-4',
    list: false,
    placeholder: 'Preencha o ramo de atividade',
    name: 'activity_branch'
  },
  address: {
    label: 'Endereço',
    component: 'text-field',
    icon: 'map-marker',
    wrapperClass: 'col-lg-4',
    list: false,
    placeholder: 'Preencha o Endereço',
    name: 'address'
  },
  address_number: {
    label: 'Número Endereço',
    component: 'text-field',
    icon: 'map-o',
    wrapperClass: 'col-lg-2',
    list: false,
    placeholder: 'Preencha o Número do endereço',
    name: 'address_number'
  },
  address_complement: {
    label: 'Complemento',
    component: 'text-field',
    icon: 'map-signs',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha o Complemento',
    name: 'address_complement'
  },
  neighborhood: {
    label: 'Bairro',
    component: 'text-field',
    icon: 'location-arrow',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha o Bairro',
    name: 'neighborhood'
  },
  zipcode: {
    label: 'CEP',
    component: 'masked-field',
    icon: 'edit',
    mask: '11.111-111',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha o CEP',
    name: 'zipcode'
  },
  state: {
    label: 'Estado',
    component: 'text-field',
    icon: 'location-arrow',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha o Estado',
    name: 'state'
  },
  city: {
    label: 'Cidade',
    component: 'text-field',
    icon: 'location-arrow',
    wrapperClass: 'col-lg-3',
    list: false,
    placeholder: 'Preencha a Cidade',
    name: 'city'
  },
  phone: {
    label: 'Telefone',
    component: 'masked-field',
    icon: 'phone-square',
    wrapperClass: 'col-lg-3',
    mask: '1111-1111',
    list: false,
    placeholder: 'Preencha o telefone fixo',
    name: 'phone'
  },
  email: {
    label: 'Email',
    component: 'text-field',
    icon: 'at',
    wrapperClass: 'col-lg-12',
    list: false,
    placeholder: 'Preencha o email',
    name: 'email'
  },
  active: {
    label: 'Ativo',
    component: 'select-field',
    selectOptions: [{ value: 'true', label: 'SIM' }, { value: 'false', label: 'NÃO' }],
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Selecione se estiver ativo',
    name: 'active'
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultBasePath = 'providers';
var __defaultOrderBy = 'name';
var __defaultSortBy = 'asc';
var __defaultIcon = 'industry';
var __defaultResourceLabel = 'Fornecedores';
var __defaultSingularResource = 'Fornecedor';
var __listSearchFields = 'name:ilike;cnpj_cpf:ilike;activity_branch:ilike;email:ilike;contact:ilike;cell_phone:ilike';









/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __fields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __defaultBasePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __defaultOrderBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __defaultSortBy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __defaultIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __defaultResourceLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __defaultSingularResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __listSearchFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __defaultFieldList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __defaultFieldsDetail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __defaultFieldAmountSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __defaultFieldICMSSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __defaultFieldPISSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __defaultFieldCOFINSSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var __fields = {
  state_id: {
    label: 'Situação',
    component: 'select-field',
    selectOptions: [{ value: '1', label: 'Disponível' }, { value: '2', label: 'Indisponível' }],
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Selecione se estiver disponível',
    name: 'state_id',
    readonly: true,
    group: 1
  },
  tenant_id: {
    label: 'Unidade',
    component: 'entity-field',
    usingAsProvider: '/available-tenants-to-transfer',
    usingAsLabel: 'tenant_fancy_name',
    resourceKey: 'tenant',
    usingAsValue: 'tenant_id',
    list: true,
    orderBy: 'tenants.tenant_fancy_name',
    icon: 'external-link',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha a Unidade',
    name: 'tenant_id'
  },
  brand: {
    label: 'Marca',
    component: 'entity-field',
    editComponent: 'text-field',
    usingAsProvider: '/vehicle-brands',
    usingAsLabel: 'brand',

    usingAsValue: 'brand',
    hasRelated: true,
    related: {
      formField: 'model',
      searchFieldAs: 'brand.brand'
    },
    list: true,
    icon: 'tags',
    wrapperClass: 'col-lg-6',
    placeholder: '',
    name: 'brand',
    disableEdit: false,
    group: 1
  },
  model: {
    label: 'Modelo',
    component: 'entity-field',
    editComponent: 'text-field',
    usingAsProvider: '/vehicle-models',

    usingAsLabel: 'description',
    usingAsValue: 'description',
    hasRelated: true,
    related: {
      formField: 'year',
      searchFieldAs: 'model.description'
    },
    lazy: true,
    list: true,
    icon: 'certificate',
    wrapperClass: 'col-lg-6',
    placeholder: '',
    name: 'model',
    disableEdit: false,
    group: 1
  },
  year: {
    label: 'Ano',
    component: 'entity-field',
    editComponent: 'text-field',
    usingAsProvider: '/vehicle-years',
    usingAsLabel: 'description',
    usingAsValue: 'description',
    lazy: true,
    list: true,
    icon: 'calendar',
    wrapperClass: 'col-lg-6',
    placeholder: '',
    name: 'year',
    disableEdit: false,
    group: 1
  },
  vehicle_fipe_id: {
    label: 'Veículo',
    component: 'entity-field',
    editComponent: 'text-field',
    usingAsProvider: '/vehicle-fipes',
    usingAsLabel: 'full_name',
    usingAsValue: 'id_key',
    lazy: true,
    list: false,
    icon: 'car',
    wrapperClass: 'col-lg-6',
    placeholder: '',
    name: 'vehicle_fipe_id',
    disableEdit: false,
    group: 1
  },
  km: {
    label: 'KM',
    component: 'text-field',
    list: false,
    icon: 'tachometer',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha o KM do veículo',
    name: 'km',
    group: 1
  },
  color: {
    label: 'Cor',
    component: 'text-field',
    list: true,
    icon: 'paint-brush',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a cor do veículo',
    name: 'color',
    group: 1
  },
  fabrication_year: {
    label: 'Ano Fab/Ano Modelo',
    component: 'masked-field',
    mask: '1111/1111',
    list: false,
    icon: 'industry',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o ano de fabricação/modelo',
    name: 'fabrication_year',
    group: 1
  },
  commutation: {
    label: 'Câmbio',
    component: 'text-field',
    list: false,
    icon: 'edit',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha o câmbio do veículo',
    name: 'commutation',
    group: 1
  },
  number_ports: {
    label: 'Quantidade de Portas',
    component: 'text-field',
    list: false,
    icon: 'circle',
    wrapperClass: 'col-lg-6',
    placeholder: 'Preencha a quantidade de portas',
    name: 'number_ports',
    group: 1
  },
  plate: {
    label: 'Placa',
    component: 'text-field',
    list: true,
    icon: 'address-card',
    wrapperClass: 'col-lg-4',
    placeholder: 'Preencha a placa',
    name: 'plate',
    group: 1
  },
  renavam: {
    label: 'Renavam',
    component: 'text-field',
    list: false,
    icon: 'tag',
    wrapperClass: 'col-lg-8',
    placeholder: 'Preencha o renavam',
    name: 'renavam',
    group: 1
  },
  chassi: {
    label: 'Chassi',
    component: 'text-field',
    list: false,
    icon: 'tags',
    wrapperClass: 'col-lg-12',
    placeholder: 'Preencha o chassi',
    name: 'chassi',
    group: 1
  },
  _detail_full_name: {
    label: 'Descrição',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'car',
    wrapperClass: 'col-lg-8',
    details: true,
    placeholder: '',
    name: 'detail_full_name',
    group: 1
  },
  _detail_year: {
    label: 'Ano do Modelo',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'calendar',
    wrapperClass: 'col-lg-4',
    details: true,
    placeholder: '',
    name: 'detail_year',
    group: 1
  },
  _detail_brand: {
    label: 'Marca',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tags',
    wrapperClass: 'col-lg-4',
    details: true,
    placeholder: '',
    name: 'detail_brand',
    group: 1
  },
  _detail_model: {
    label: 'Modelo',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'certificate',
    wrapperClass: 'col-lg-4',
    details: true,
    placeholder: '',
    name: 'detail_model',
    group: 1
  },
  detail_fipe_code: {
    label: 'Código FIPE',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'key',
    wrapperClass: 'col-lg-4',
    details: true,
    placeholder: '',
    name: 'detail_fipe_code',
    group: 1
  },
  detail_reference_month: {
    label: 'Referência',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'calendar',
    wrapperClass: 'col-lg-6',
    details: true,
    placeholder: '',
    name: 'detail_reference_month',
    group: 1
  },
  detail_amount: {
    label: 'Preço médio',
    component: 'monetary-field',
    lazy: true,
    list: false,
    icon: 'dollar',
    wrapperClass: 'col-lg-6',
    details: true,
    placeholder: '',
    name: 'detail_amount',
    group: 1
  },
  detail_fuel: {
    label: 'Combustível',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tachometer',
    wrapperClass: 'col-lg-6',
    details: true,
    placeholder: '',
    name: 'detail_fuel',
    group: 1
  },
  detail_vehicle_type: {
    label: 'Tipo de Veículo FIPE',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tag',
    wrapperClass: 'col-lg-6',
    details: true,
    placeholder: '',
    name: 'detail_vehicle_type',
    group: 1
  },
  consigned: {
    label: 'Veículo Consignado?',
    component: 'select-field',
    selectOptions: [{ value: 0, label: 'Não' }, { value: 1, label: 'Sim' }],
    list: true,
    icon: 'edit',
    wrapperClass: 'col-lg-12',
    placeholder: 'Selecione se estiver disponível',
    name: 'consigned',
    group: 2
  },
  provider_id: {
    label: 'Fornecedor',
    component: 'entity-field',
    usingAsProvider: '/customers',
    usingAsLabel: 'name',
    resourceKey: 'name',
    usingAsValue: 'id_key',
    list: false,
    group: 2,
    orderBy: 'customers.name',
    icon: 'industry',
    wrapperClass: 'col-lg-12',
    placeholder: 'Selecione o forneceodr',
    name: 'provider_id'
  },
  acquisition_date: {
    label: 'Data de aquisição',
    group: 2,
    component: 'masked-field',
    mask: '11/11/1111',
    list: false,
    icon: 'calendar',
    wrapperClass: 'col-lg-3',
    placeholder: 'Preencha a data de aquisição',
    name: 'acquisition_date'
  },
  mean_price: {
    label: 'Valor de aquisição',
    component: 'monetary-field',
    lazy: true,
    list: false,
    icon: 'dollar',
    wrapperClass: 'col-lg-3',
    placeholder: 'Valor de aquisição',
    name: 'mean_price',
    group: 2
  },
  sale_price: {
    label: 'Preço de Venda',
    component: 'monetary-field',
    lazy: true,
    list: true,
    icon: 'dollar',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha o preço de venda',
    name: 'sale_price',
    group: 2
  },
  commission: {
    label: 'Comissão de venda',
    component: 'monetary-field',
    lazy: true,
    list: false,
    icon: 'dollar',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha a comissão de venda (em R$)',
    name: 'commission',
    group: 2
  },
  discount_margin: {
    label: 'Margem de Desconto (R$)',
    component: 'monetary-field',
    lazy: true,
    list: false,
    icon: 'dollar',
    wrapperClass: 'col-lg-2',
    placeholder: 'Preencha a margem de desconto (em R$)',
    name: 'discount_margin',
    group: 2
  },
  detail_vehicle_type2s: {
    label: 'Tipo de Veículo FIPE',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tag',
    wrapperClass: 'col-lg-4',
    placeholder: '',
    name: 'detail_vehicle_type2s',
    group: 3
  },
  detail_vehicle_type2s1: {
    label: 'Tipo de Veículo FIPE',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tag',
    wrapperClass: 'col-lg-4',
    placeholder: '',
    name: 'detail_vehicle_type2s',
    group: 3
  },
  detail_vehicle_type2s222: {
    label: 'Tipo de Veículo FIPE',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tag',
    wrapperClass: 'col-lg-4',
    placeholder: '',
    name: 'detail_vehicle_type2s',
    group: 3
  },
  detail_vehicle_type2s123123: {
    label: 'Tipo de Veículo FIPE',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tag',
    wrapperClass: 'col-lg-4',
    placeholder: '',
    name: 'detail_vehicle_type2s',
    group: 3
  },
  detail_vehicle_type2s12: {
    label: 'Tipo de Veículo FIPE',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tag',
    wrapperClass: 'col-lg-4',
    placeholder: '',
    name: 'detail_vehicle_type2s',
    group: 3
  },
  detail_vehicle_type2s23: {
    label: 'Tipo de Veículo FIPE',
    component: 'text-field',
    lazy: true,
    list: false,
    icon: 'tag',
    wrapperClass: 'col-lg-4',
    placeholder: '',
    name: 'detail_vehicle_type2s',
    group: 3
  },

  icms_rate: {
    label: 'Taxa de Imposto (%)',
    component: 'percent-field',
    list: false,
    wrapperClass: 'col-lg-2',
    placeholder: 'Taxa de Imposto',
    name: 'icms_rate',
    group: 4
  },
  icms_basetax_st_reduction: {
    label: 'Base Tax ST Reduction',
    component: 'percent-field',
    list: false,
    wrapperClass: 'col-lg-2',
    placeholder: 'Base Tax ST Reduction',
    name: 'icms_basetax_st_reduction',
    group: 4
  },
  icms_basetax_modality: {
    label: 'ICMS Base Tax Modality',
    component: 'text-field',
    list: false,
    wrapperClass: 'col-lg-2',
    placeholder: 'ICMS Base Tax Modality',
    name: 'icms_basetax_modality',
    group: 4
  },
  icms_cst: {
    label: 'ICMS CST',
    component: 'text-field',
    list: false,
    wrapperClass: 'col-lg-3',
    placeholder: 'ICMS CST',
    name: 'icms_cst',
    group: 4
  },
  icms_origin: {
    label: 'Origem ICMS',
    component: 'text-field',
    list: false,
    wrapperClass: 'col-lg-3',
    placeholder: 'Origem ICMS',
    name: 'icms_origin',
    group: 4
  },

  pis_rate: {
    label: 'PIS RATE',
    component: 'percent-field',
    list: false,
    wrapperClass: 'col-lg-6',
    placeholder: 'Taxa de Imposto',
    name: 'pis_rate',
    group: 5
  },
  pis_cst: {
    label: 'PIS CST',
    component: 'text-field',
    list: false,
    wrapperClass: 'col-lg-6',
    placeholder: 'Base Tax ST Reduction',
    name: 'pis_cst',
    group: 5
  },

  cofins_rate: {
    label: 'COFINS Rate',
    component: 'percent-field',
    list: false,
    wrapperClass: 'col-lg-6',
    placeholder: 'ICMS Base Tax Modality',
    name: 'cofins_rate',
    group: 6
  },
  cofins_cst: {
    label: 'COFINS CST',
    component: 'text-field',
    list: false,
    wrapperClass: 'col-lg-6',
    placeholder: 'ICMS CST',
    name: 'cofins_cst',
    group: 6
  }
};

var __defaultFieldList = [];

var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__fields);

var __defaultFieldAmountSection = [];

fields.forEach(function (field) {
  if (__fields[field].group === 2) {
    __defaultFieldAmountSection.push(__fields[field]);
  }
});

fields.forEach(function (field) {
  if (__fields[field].list === true) {
    __defaultFieldList.push(__fields[field]);
  }
});

var __defaultFieldsDetail = [];

fields.forEach(function (field) {
  if (__fields[field].details === true) {
    __defaultFieldsDetail.push(__fields[field]);
  }
});

var __defaultFieldICMSSection = [];

fields.forEach(function (field) {
  if (__fields[field].group === 4) {
    __defaultFieldICMSSection.push(__fields[field]);
  }
});

var __defaultFieldPISSection = [];

fields.forEach(function (field) {
  if (__fields[field].group === 5) {
    __defaultFieldPISSection.push(__fields[field]);
  }
});

var __defaultFieldCOFINSSection = [];

fields.forEach(function (field) {
  if (__fields[field].group === 6) {
    __defaultFieldCOFINSSection.push(__fields[field]);
  }
});

var __defaultBasePath = 'vehicle-entry';
var __defaultOrderBy = 'fipe_brand';
var __defaultSortBy = 'asc';
var __defaultIcon = 'car';
var __defaultResourceLabel = 'Entrada de Veículos';
var __defaultSingularResource = 'Entrada de Veículo';
var __listSearchFields = 'fipe_brand:ilike;fipe_model:ilike;color:ilike;fabrication_year:ilike;plate:ilike';














/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var UrlMatcherService = function () {
  function UrlMatcherService() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UrlMatcherService);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UrlMatcherService, [{
    key: "self",
    value: function self(model, type) {
      return model.links.find(function (link) {
        return link.type === type;
      }).uri;
    }
  }]);

  return UrlMatcherService;
}();

/* harmony default export */ __webpack_exports__["a"] = (UrlMatcherService);

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(457),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1064),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1047),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };
      payload['initial_balance'] = payload['initial_balance'].replace(',', '.');
      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      payload['initial_balance'] = payload['initial_balance'].replace(',', '.');

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = 'account-plans';
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      var fields = ['debit_percent_in_cash', 'credit_percent_in_cash', 'credit_in_installment_store', 'credit_in_installment_administrator'];

      fields.forEach(function (field) {
        payload[field] = payload[field].replace('%', '');
      });

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      var fields = ['debit_percent_in_cash', 'credit_percent_in_cash', 'credit_in_installment_store', 'credit_in_installment_administrator'];

      fields.forEach(function (field) {
        payload[field] = payload[field].replace('%', '');
      });

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };
      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };
      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      var fields = ['percentage_taxes'];

      fields.forEach(function (field) {
        payload[field] = payload[field].replace('%', '');
      });

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      var fields = ['percentage_taxes'];

      fields.forEach(function (field) {
        payload[field] = payload[field].replace('%', '');
      });

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component, basePath) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = basePath;
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = 'tenants';
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this3.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',
          url: _this4.basePath + '/' + data.data.id + '/show',
          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback) {
      this.http.get('' + this.basePath).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Api = function () {
  function Api(component) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.component = component;
    this.basePath = 'vehicle-sale';
    this.http = this.component.$root.axios;
    this.bus = this.component.$root.bus;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'find',
    value: function find(id, callback) {
      var _this = this;

      this.http.get(this.basePath + '/' + id).then(function (_ref) {
        var data = _ref.data;

        callback(data);
        _this.bus.$emit('refreshed-entry');
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id, callback) {
      var _this2 = this;

      var defaultCallback = function defaultCallback(_ref2) {
        var data = _ref2.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({ icon: 'trash', type: 'success' }, data);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        var events = ['deleted', 'show-alert'];

        events.forEach(function (e) {
          return _this2.bus.$emit(e, details);
        });
      };

      this.http.post(this.basePath + '/' + id, {
        '_method': 'DELETE'
      }).then(defaultCallback);
    }
  }, {
    key: 'create',
    value: function create(payload, callback) {
      var _this3 = this;

      var defaultCallback = function defaultCallback(_ref3) {
        var data = _ref3.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',

          type: 'success'
        }, data);

        _this3.bus.$emit('created-entry', details);

        if (typeof callback !== 'undefined') {
          callback(details);
        }

        _this3.bus.$emit('show-alert', details);
      };

      payload['discount'] = String(payload['discount']).replace('.', '').replace(',', '.');
      this.http.post('' + this.basePath, payload).then(defaultCallback);
    }
  }, {
    key: 'update',
    value: function update(id, payload, callback) {
      var _this4 = this;

      var defaultCallback = function defaultCallback(_ref4) {
        var data = _ref4.data;

        var details = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])({
          icon: 'check',

          type: 'success'
        }, data);

        _this4.bus.$emit('form-saved', details);

        if (callback !== 'undefined') {
          callback(data.data);
        }

        _this4.bus.$emit('show-alert', details);
      };

      this.http.put(this.basePath + '/' + id, payload).then(defaultCallback);
    }
  }, {
    key: 'paginated',
    value: function paginated(callback, verified) {
      this.http.get('' + this.basePath, {
        params: {
          q: 'entry.tenant_id:' + localStorage.getItem('current-tenant-idkey'),
          sf: 'entry.tenant_id',
          'verified': verified
        }
      }).then(function (_ref5) {
        var data = _ref5.data;

        callback(data.data);
      });
    }
  }, {
    key: 'useSortService',
    value: function useSortService(service) {
      this.sortService = service;

      return this;
    }
  }, {
    key: 'performSearch',
    value: function performSearch(params, callback) {
      var _this5 = this;

      var parameters = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["merge"])(params, this.sortService.getRequestParams() || {});

      this.http.get('' + this.basePath, {
        params: parameters
      }).then(function (_ref6) {
        var data = _ref6.data;

        callback(data.data);
        _this5.bus.$emit('searched', data.data);
      });
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = (Api);

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1067),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(951),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1068),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(993),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(978),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(965),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1070),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(996),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1040),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(984),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1057),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1032),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1076),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1066),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_locale_pt__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_locale_pt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_es5_locale_pt__);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  iconfont: 'md',
  lang: {
    locales: { pt: __WEBPACK_IMPORTED_MODULE_3_vuetify_es5_locale_pt___default.a },
    current: 'pt'
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NovoEstoque__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_NovoEstoque___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_NovoEstoque__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ReportsV2__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ReportsV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ReportsV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Report__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Report___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Report__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Config__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router_Tenant__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router_VehicleSale__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router_AccountPlan__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router_AccountMovType__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router_CardOperators__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router_AccountMov__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router_Finantial__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__router_Provider__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__router_Employee__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router_Customer__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__router_VehicleEntry__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__router_ChecklistItem__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__router_ExpenseType__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__router_Profile__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__router_PaymentMethod__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__router_CategoryPendencyVehicle__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Resources_ExpenseVehiclePlate_ListPage__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Resources_ExpenseVehiclePlate_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_Resources_ExpenseVehiclePlate_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Resources_NotasFiscaisList__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Resources_NotasFiscaisList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_Resources_NotasFiscaisList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Resources_GeneralExpense_MainPage__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Resources_GeneralExpense_MainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_Resources_GeneralExpense_MainPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Resources_BillToReceive__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Resources_BillToReceive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_Resources_BillToReceive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Resources_BillToPay__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Resources_BillToPay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Resources_BillToPay__);





























__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Dashboard___default.a
  }, {
    path: '/estoque',
    name: 'Estoque',
    component: __WEBPACK_IMPORTED_MODULE_4__components_NovoEstoque___default.a
  }, {
    path: '/reports-v2',
    name: 'ReportsV2',
    component: __WEBPACK_IMPORTED_MODULE_5__components_ReportsV2___default.a
  }, {
    path: '/nfe',
    name: 'NotasFiscais',
    component: __WEBPACK_IMPORTED_MODULE_25__components_Resources_NotasFiscaisList___default.a
  }, {
    path: '/reports',
    name: 'Reports',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Report___default.a
  }, {
    path: '/expense-vehicle-plate',
    name: 'ExpenseVehiclePlate',
    component: __WEBPACK_IMPORTED_MODULE_24__components_Resources_ExpenseVehiclePlate_ListPage___default.a
  }, {
    path: '/expenses',
    name: 'GeneralExpense',
    component: __WEBPACK_IMPORTED_MODULE_26__components_Resources_GeneralExpense_MainPage___default.a
  }, {
    path: '/configurations',
    name: 'Config',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Config___default.a
  }, {
    path: '/receive',
    name: 'Receive',
    component: __WEBPACK_IMPORTED_MODULE_27__components_Resources_BillToReceive___default.a
  }, {
    path: '/pay',
    name: 'Pay',
    component: __WEBPACK_IMPORTED_MODULE_28__components_Resources_BillToPay___default.a
  }].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_8__router_Tenant__["a" /* tenantRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_10__router_AccountPlan__["a" /* accountPlanRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_11__router_AccountMovType__["a" /* accountMovTypeRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_12__router_CardOperators__["a" /* cardOperatorsRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_13__router_AccountMov__["a" /* accountMovRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_14__router_Finantial__["a" /* finantialRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_15__router_Provider__["a" /* providerRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_16__router_Employee__["a" /* employeesRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_17__router_Customer__["a" /* customersRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_18__router_VehicleEntry__["a" /* vehicleEntryRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_19__router_ChecklistItem__["a" /* checklistItemRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_20__router_ExpenseType__["a" /* expenseTypesRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_21__router_Profile__["a" /* profileRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_9__router_VehicleSale__["a" /* vehicleSalesRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_22__router_PaymentMethod__["a" /* paymentMethodRoutes */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_23__router_CategoryPendencyVehicle__["a" /* categoryPendencyVehicleRoutes */]))
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_user_state__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_user_actions__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_user_mutations__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_reserveVehicle_state__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_reserveVehicle_actions__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_reserveVehicle_mutations__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_breadcrumbs__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_breadcrumbs_actions__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_breadcrumbs_mutations__ = __webpack_require__(433);















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
  modules: {
    user: {
      namespaced: true,
      state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_3__store_user_state__["a" /* stateUser */]),
      actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4__store_user_actions__["a" /* actionUser */]),
      mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_5__store_user_mutations__["a" /* mutationsUser */])
    },
    breadcrumb: {
      namespaced: true,
      state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_9__store_breadcrumbs__["a" /* stateBreadcrumb */]),
      actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__store_breadcrumbs_actions__["a" /* actionBreadcrumb */]),
      mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_11__store_breadcrumbs_mutations__["a" /* mutationsBreadcrumb */])
    },
    reserveVehicle: {
      state: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6__store_reserveVehicle_state__["a" /* stateReserveVehicle */]),
      actions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__store_reserveVehicle_actions__["a" /* actionsReserveVehicle */]),
      mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__store_reserveVehicle_mutations__["a" /* mutationsReserveVehicle */])
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 387 */,
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1049),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(450),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(451),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(453),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(454),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(456),
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__plugins_vuetify__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vee_validate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Fields_TextField__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Fields_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Fields_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Fields_SelectField__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Fields_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Fields_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Fields_EntityField__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Fields_EntityField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Fields_EntityField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Fields_PercentField__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Fields_PercentField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Fields_PercentField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Fields_MaskedField__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Fields_MaskedField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Fields_MaskedField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Fields_MonetaryField__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Fields_MonetaryField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_Fields_MonetaryField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Fields_CheckboxField__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Fields_CheckboxField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_Fields_CheckboxField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Fields_TextAreaField__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Fields_TextAreaField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_Fields_TextAreaField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_masked_input__ = __webpack_require__(395);


















var numeral = __webpack_require__(47);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate___default.a, {
  delay: 300
});

var language = {
  delimiters: {
    thousands: '.',
    decimal: ','
  },
  abbreviations: {
    thousand: 'mil',
    million: 'milhões',
    billion: 'b',
    trillion: 't'
  },
  ordinal: function ordinal(number) {
    return 'º';
  },
  currency: {
    symbol: 'R$'
  }
};

numeral.register('locale', 'pt-br', language);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('text-field', __WEBPACK_IMPORTED_MODULE_8__components_Fields_TextField___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('select-field', __WEBPACK_IMPORTED_MODULE_9__components_Fields_SelectField___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('entity-field', __WEBPACK_IMPORTED_MODULE_10__components_Fields_EntityField___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('percent-field', __WEBPACK_IMPORTED_MODULE_11__components_Fields_PercentField___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('checkbox-field', __WEBPACK_IMPORTED_MODULE_14__components_Fields_CheckboxField___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('masked-input', __WEBPACK_IMPORTED_MODULE_17_vue_masked_input__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('monetary-field', __WEBPACK_IMPORTED_MODULE_13__components_Fields_MonetaryField___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('masked-field', __WEBPACK_IMPORTED_MODULE_12__components_Fields_MaskedField___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('textarea-field', __WEBPACK_IMPORTED_MODULE_15__components_Fields_TextAreaField___default.a);

var bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]();

var API_ENDPOINT;

if (false) {
  API_ENDPOINT = 'https://api-vendasvipcar.msbtec.com.br/api/v1/';
} else {
  API_ENDPOINT = 'https://api-vendasvipcar.msbtec.com.br/api/v1/';
}

var axios = __WEBPACK_IMPORTED_MODULE_5_axios___default.a.create({
  baseURL: API_ENDPOINT
});

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  data: function data() {
    return {
      axios: axios,
      bus: bus,
      API_ENDPOINT: API_ENDPOINT,
      numeral: numeral
    };
  },
  created: function created() {
    this.$validator.extend('float', {
      getMessage: function getMessage(field) {
        return 'O campo ' + field + ' est\xE1 inv\xE1lido. (Ex: 40,00)';
      },
      validate: function validate(value) {
        return value.match(/^-?\d*(.\d+,?\d*)?%?$/) !== null;
      }
    });

    this.$validator.extend('integer', {
      getMessage: function getMessage(field) {
        return 'O campo ' + field + ' deve ser um n\xFAmero inteiro. (Ex: 40)';
      },
      validate: function validate(value) {
        return !isNaN(value) && parseInt(Number(value)) == value && !isNaN(parseInt(value, 10));
      }
    });

    this.$validator.extend('date_format', {
      getMessage: function getMessage(field) {
        return 'O campo ' + field + ' est\xE1 inv\xE1lido.';
      },
      validate: function validate(value) {
        return __WEBPACK_IMPORTED_MODULE_16_moment___default()(value).isValid();
      }
    });
  },

  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App___default.a }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountMovTypeRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountMovType_ListPage__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountMovType_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountMovType_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountMovType_Show_ShowPage__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountMovType_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountMovType_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountMovType_Create_CreatePage__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountMovType_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountMovType_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountMovType_Edit_EditPage__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountMovType_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountMovType_Edit_EditPage__);





var accountMovTypeRoutes = [{
  path: '/account-mov-type',
  name: 'AccountMovTypeList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountMovType_ListPage___default.a
}, {
  path: '/account-mov-type/:id/show',
  name: 'AccountMovTypeShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountMovType_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/account-mov-type/:id/edit',
  name: 'AccountMovTypeEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountMovType_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/account-mov-type/create',
  name: 'AccountMovTypeCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountMovType_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountMovRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountMov_ListPage__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountMov_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountMov_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountMov_Show_ShowPage__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountMov_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountMov_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountMov_Create_CreatePage__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountMov_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountMov_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountMov_Edit_EditPage__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountMov_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountMov_Edit_EditPage__);





var accountMovRoutes = [{
  path: '/account-mov',
  name: 'AccountMovList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountMov_ListPage___default.a
}, {
  path: '/account-mov/:id/show',
  name: 'AccountMovShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountMov_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/account-mov/:id/edit',
  name: 'AccountMovEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountMov_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/account-mov/create',
  name: 'AccountMovCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountMov_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accountPlanRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountPlan_ListPage__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountPlan_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountPlan_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_ShowPage__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountPlan_Edit_EditPage__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountPlan_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountPlan_Edit_EditPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountPlan_Create_CreatePage__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountPlan_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountPlan_Create_CreatePage__);





var accountPlanRoutes = [{
  path: '/account-plans',
  name: 'AccountPlanList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_AccountPlan_ListPage___default.a
}, {
  path: '/account-plans/:id/show',
  name: 'AccountPlanShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/account-plans/:id/edit',
  name: 'AccountPlanEdit',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_AccountPlan_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/account-plans/create',
  name: 'AccountPlanCreate',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountPlan_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cardOperatorsRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_CardOperators_ListPage__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_CardOperators_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_CardOperators_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_CardOperators_Show_ShowPage__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_CardOperators_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_CardOperators_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_CardOperators_Create_CreatePage__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_CardOperators_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_CardOperators_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_CardOperators_Edit_EditPage__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_CardOperators_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_CardOperators_Edit_EditPage__);





var cardOperatorsRoutes = [{
  path: '/card-operators',
  name: 'CardOperatorsList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_CardOperators_ListPage___default.a
}, {
  path: '/card-operators/:id/show',
  name: 'CardOperatorsShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_CardOperators_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/card-operators/:id/edit',
  name: 'CardOperatorsEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_CardOperators_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/card-operators/create',
  name: 'CardOperatorsCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_CardOperators_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return categoryPendencyVehicleRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_CategoryPendencyVehicle_ListPage__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_CategoryPendencyVehicle_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_CategoryPendencyVehicle_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_CategoryPendencyVehicle_Show_ShowPage__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_CategoryPendencyVehicle_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_CategoryPendencyVehicle_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_CategoryPendencyVehicle_Create_CreatePage__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_CategoryPendencyVehicle_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_CategoryPendencyVehicle_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_CategoryPendencyVehicle_Edit_EditPage__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_CategoryPendencyVehicle_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_CategoryPendencyVehicle_Edit_EditPage__);





var categoryPendencyVehicleRoutes = [{
  path: '/categories-pendency',
  name: 'CategoryPendencyVehicleList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_CategoryPendencyVehicle_ListPage___default.a
}, {
  path: '/categories-pendency/:id/show',
  name: 'CategoryPendencyVehicleShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_CategoryPendencyVehicle_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/categories-pendency/:id/edit',
  name: 'CategoryPendencyVehicleEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_CategoryPendencyVehicle_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/categories-pendency/create',
  name: 'CategoryPendencyVehicleCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_CategoryPendencyVehicle_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checklistItemRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_ChecklistItem_ListPage__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_ChecklistItem_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_ChecklistItem_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_ChecklistItem_Show_ShowPage__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_ChecklistItem_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_ChecklistItem_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_ChecklistItem_Create_CreatePage__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_ChecklistItem_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_ChecklistItem_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_ChecklistItem_Edit_EditPage__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_ChecklistItem_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_ChecklistItem_Edit_EditPage__);





var checklistItemRoutes = [{
  path: '/checklist-items',
  name: 'ChecklistItemList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_ChecklistItem_ListPage___default.a
}, {
  path: '/checklist-items/:id/show',
  name: 'ChecklistItemShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_ChecklistItem_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/checklist-items/:id/edit',
  name: 'ChecklistItemEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_ChecklistItem_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/checklist-items/create',
  name: 'ChecklistItemCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_ChecklistItem_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customersRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Customer_ListPage__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Customer_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_Customer_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Customer_Show_ShowPage__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Customer_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Customer_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Customer_Create_CreatePage__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Customer_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_Customer_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Customer_Edit_EditPage__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Customer_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_Customer_Edit_EditPage__);





var customersRoutes = [{
  path: '/customers',
  name: 'CustomerList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_Customer_ListPage___default.a
}, {
  path: '/customers/:id/show',
  name: 'CustomerShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Customer_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/customers/:id/edit',
  name: 'CustomerEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_Customer_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/customers/create',
  name: 'CustomerCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_Customer_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return employeesRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Employee_ListPage__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Employee_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_Employee_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Employee_Show_ShowPage__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Employee_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Employee_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Employee_Create_CreatePage__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Employee_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_Employee_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Employee_Edit_EditPage__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Employee_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_Employee_Edit_EditPage__);





var employeesRoutes = [{
  path: '/employees',
  name: 'EmployeeList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_Employee_ListPage___default.a
}, {
  path: '/employees/:id/show',
  name: 'EmployeeShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Employee_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/employees/:id/edit',
  name: 'EmployeeEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_Employee_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/employees/create',
  name: 'EmployeeCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_Employee_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expenseTypesRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_ExpenseType_ListPage__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_ExpenseType_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_ExpenseType_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_ExpenseType_Show_ShowPage__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_ExpenseType_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_ExpenseType_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_ExpenseType_Create_CreatePage__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_ExpenseType_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_ExpenseType_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_ExpenseType_Edit_EditPage__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_ExpenseType_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_ExpenseType_Edit_EditPage__);





var expenseTypesRoutes = [{
  path: '/expense-types',
  name: 'ExpenseTypeList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_ExpenseType_ListPage___default.a
}, {
  path: '/expense-types/:id/show',
  name: 'ExpenseTypeShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_ExpenseType_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/expense-types/:id/edit',
  name: 'ExpenseTypeEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_ExpenseType_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/expense-types/create',
  name: 'ExpenseTypeCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_ExpenseType_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return finantialRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Finantial_ListPage__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Finantial_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_Finantial_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Finantial_Show_ShowPage__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Finantial_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Finantial_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Finantial_Create_CreatePage__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Finantial_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_Finantial_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Finantial_Edit_EditPage__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Finantial_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_Finantial_Edit_EditPage__);





var finantialRoutes = [{
  path: '/finantial',
  name: 'FinantialList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_Finantial_ListPage___default.a
}, {
  path: '/finantial/:id/show',
  name: 'FinantialShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Finantial_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/finantial/:id/edit',
  name: 'FinantialEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_Finantial_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/finantial/create',
  name: 'FinantialCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_Finantial_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return paymentMethodRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_PaymentMethod_ListPage__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_PaymentMethod_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_PaymentMethod_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_PaymentMethod_Show_ShowPage__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_PaymentMethod_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_PaymentMethod_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_PaymentMethod_Create_CreatePage__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_PaymentMethod_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_PaymentMethod_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_PaymentMethod_Edit_EditPage__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_PaymentMethod_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_PaymentMethod_Edit_EditPage__);





var paymentMethodRoutes = [{
  path: '/payment-method',
  name: 'PaymentMethodList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_PaymentMethod_ListPage___default.a
}, {
  path: '/payment-method/:id/show',
  name: 'PaymentMethodShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_PaymentMethod_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/payment-method/:id/edit',
  name: 'PaymentMethodEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_PaymentMethod_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/payment-method/create',
  name: 'PaymentMethodCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_PaymentMethod_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return profileRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Profile_ListPage__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Profile_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_Profile_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Profile_Show_ShowPage__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Profile_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Profile_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Profile_Create_CreatePage__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Profile_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_Profile_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Profile_Edit_EditPage__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Profile_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_Profile_Edit_EditPage__);





var profileRoutes = [{
  path: '/profiles',
  name: 'ProfileList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_Profile_ListPage___default.a
}, {
  path: '/profiles/:id/show',
  name: 'ProfileShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Profile_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/profiles/:id/edit',
  name: 'ProfileEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_Profile_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/profiles/create',
  name: 'ProfileCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_Profile_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return providerRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Provider_ListPage__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Provider_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_Provider_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Provider_Show_ShowPage__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Provider_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Provider_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Provider_Create_CreatePage__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Provider_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_Provider_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Provider_Edit_EditPage__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Provider_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_Provider_Edit_EditPage__);





var providerRoutes = [{
  path: '/providers',
  name: 'ProvidersList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_Provider_ListPage___default.a
}, {
  path: '/providers/:id/show',
  name: 'ProvidersShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Provider_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/providers/:id/edit',
  name: 'ProvidersEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_Provider_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/providers/create',
  name: 'ProvidersCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_Provider_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return tenantRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Tenants_ListPage__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_Tenants_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_Tenants_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_ShowPage__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Tenants_Create_CreatePage__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_Tenants_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_Tenants_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Tenants_Edit_EditPage__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_Tenants_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_Tenants_Edit_EditPage__);





var tenantRoutes = [{
  path: '/tenants',
  name: 'TenantsList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_Tenants_ListPage___default.a
}, {
  path: '/tenants/:id/show',
  name: 'TenantsShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/tenants/:id/edit',
  name: 'TenantsEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_Tenants_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/tenants/create',
  name: 'TenantsCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_Tenants_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vehicleEntryRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleEntry_ListPage__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleEntry_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleEntry_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleEntry_Show_ShowPage__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleEntry_Show_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleEntry_Show_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_VehicleEntry_Create_CreatePage__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_VehicleEntry_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_VehicleEntry_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_VehicleEntry_Edit_EditPage__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_VehicleEntry_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_VehicleEntry_Edit_EditPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Resources_VehicleEntry_Edit_ReturnPage__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Resources_VehicleEntry_Edit_ReturnPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Resources_VehicleEntry_Edit_ReturnPage__);






var vehicleEntryRoutes = [{
  path: '/vehicle-entry',
  name: 'VehicleEntryList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleEntry_ListPage___default.a
}, {
  path: '/vehicle-entry/:id/show',
  name: 'VehicleEntryShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleEntry_Show_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/vehicle-entry/:id/edit',
  name: 'VehicleEntryEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_VehicleEntry_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/vehicle-entry/create',
  name: 'VehicleEntryCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_VehicleEntry_Create_CreatePage___default.a,
  props: { formReadonly: false }
}, {
  path: '/vehicle-entry/:id/return',
  name: 'VehicleEntryReturn',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Resources_VehicleEntry_Edit_ReturnPage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vehicleSalesRoutes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleSale_ListPage__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleSale_ListPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleSale_ListPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleSale_ShowPage__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleSale_ShowPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleSale_ShowPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_VehicleSale_Create_CreatePage__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Resources_VehicleSale_Create_CreatePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Resources_VehicleSale_Create_CreatePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_VehicleSale_Edit_EditPage__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_VehicleSale_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Resources_VehicleSale_Edit_EditPage__);





var vehicleSalesRoutes = [{
  path: '/vehicle-sale',
  name: 'VehicleSaleList',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleSale_ListPage___default.a
}, {
  path: '/vehicle-sale/:id/show',
  name: 'VehicleSaleShow',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleSale_ShowPage___default.a,
  props: { formReadonly: true }
}, {
  path: '/vehicle-sale/:id/edit',
  name: 'VehicleSaleEdit',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Resources_VehicleSale_Edit_EditPage___default.a,
  props: { formReadonly: false }
}, {
  path: '/vehicle-sale/create/:entry_id?',
  name: 'VehicleSaleCreate',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Resources_VehicleSale_Create_CreatePage___default.a,
  props: { formReadonly: false }
}];

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionBreadcrumb; });
var actionBreadcrumb = {
  PUSH_BREADCRUMB_ITEM: function PUSH_BREADCRUMB_ITEM(_ref, _ref2) {
    var commit = _ref.commit;
    var stack = _ref2.stack;

    commit('CLEAR_BREADCRUMB');

    stack.forEach(function (item) {
      commit('PUSH_BREADCRUMB_ITEM', item);
    });
  },
  POP_BREADCRUMB_ITEM: function POP_BREADCRUMB_ITEM(_ref3, label) {
    var commit = _ref3.commit;

    commit('POP_BREADCRUMB_ITEM', label);
  },
  CLEAR_BREADCRUMB: function CLEAR_BREADCRUMB() {}
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stateBreadcrumb; });
var stateBreadcrumb = {
  list: []
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutationsBreadcrumb; });
var mutationsBreadcrumb = {
  PUSH_BREADCRUMB_ITEM: function PUSH_BREADCRUMB_ITEM(store, item) {
    store.list.push(item);
  },
  CLEAR_BREADCRUMB: function CLEAR_BREADCRUMB(store) {
    store.list = [{
      label: 'Início',
      url: '/',
      icon: 'home'
    }];
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionsReserveVehicle; });
var actionsReserveVehicle = {
  CHANGE_VISIBILITY: function CHANGE_VISIBILITY(_ref, payload) {
    var commit = _ref.commit;

    commit('CHANGE_VISIBILITY', payload);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutationsReserveVehicle; });
var mutationsReserveVehicle = {
  CHANGE_VISIBILITY: function CHANGE_VISIBILITY(state, payload) {
    state.open = !state.open;
    state.veiculoSelecionado = payload.entry || {};
    state.reserva = payload.reserva || {};
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stateReserveVehicle; });
var stateReserveVehicle = {
  open: false,
  veiculoSelecionado: {},
  reserva: {
    observacoes: ''
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actionUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var actionUser = {
  logout: function logout(_ref, router) {
    var commit = _ref.commit;

    localStorage.setItem('id', '');
    localStorage.setItem('authenticated', false);
    localStorage.setItem('userName', '');
    localStorage.setItem('email', '');
    localStorage.setItem('created_at', '');
    localStorage.setItem('token', '');

    commit('LOGOUT_USER');
    router.push({ name: 'Dashboard' });
  },
  login: function login(_ref2, _ref3) {
    var commit = _ref2.commit;
    var user = _ref3.user,
        token = _ref3.token,
        profile = _ref3.profile;

    localStorage.setItem('id', user['id']);
    localStorage.setItem('authenticated', true);
    localStorage.setItem('userName', user.name);
    localStorage.setItem('email', user.email);
    localStorage.setItem('created_at', user.created_at);
    localStorage.setItem('token', token);
    localStorage.setItem('profile', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(profile));

    commit('LOGIN_USER', {
      user: user,
      token: token
    });
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutationsUser; });
var mutationsUser = {
  LOGOUT_USER: function LOGOUT_USER(state) {
    state.userName = null;
    state.email = null;
    state.created_at = null;
    state.token = null;
    state.authenticated = false;
  },
  LOGIN_USER: function LOGIN_USER(state, _ref) {
    var user = _ref.user,
        token = _ref.token;

    state.userName = user.name;
    state.email = user.email;
    state.token = token;
    state.authenticated = true;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return stateUser; });
var stateUser = {
  id: window.localStorage.getItem('id'),
  userName: window.localStorage.getItem('userName'),
  email: window.localStorage.getItem('email'),
  authenticated: window.localStorage.getItem('authenticated') === 'true',
  token: window.localStorage.getItem('token'),
  profile: JSON.parse(window.localStorage.getItem('profile'))
};

/* unused harmony default export */ var _unused_webpack_default_export = ({});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_template_css_bootstrap_min_css__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_template_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_template_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_template_css_font_awesome_css__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_template_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_template_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_template_css_smartadmin_production_min_css__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_template_css_smartadmin_production_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__static_template_css_smartadmin_production_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_template_css_smartadmin_skins_min_css__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__static_template_css_smartadmin_skins_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__static_template_css_smartadmin_skins_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_template_js_bootstrap_bootstrap_min_js__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__static_template_js_bootstrap_bootstrap_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__static_template_js_bootstrap_bootstrap_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_template_js_custom_js__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__static_template_js_custom_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__static_template_js_custom_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_template_js_notification_SmartNotification_min_js__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__static_template_js_notification_SmartNotification_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__static_template_js_notification_SmartNotification_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_template_js_smartwidgets_jarvis_widget_min_js__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__static_template_js_smartwidgets_jarvis_widget_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__static_template_js_smartwidgets_jarvis_widget_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_template_js_plugin_select2_select2_min_js__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_template_js_plugin_select2_select2_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_template_js_plugin_select2_select2_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_template_js_plugin_bootstrap_slider_bootstrap_slider_min_js__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_template_js_plugin_bootstrap_slider_bootstrap_slider_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_template_js_plugin_bootstrap_slider_bootstrap_slider_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_template_js_plugin_fastclick_fastclick_min_js__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__static_template_js_plugin_fastclick_fastclick_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__static_template_js_plugin_fastclick_fastclick_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_template_js_plugin_masked_input_jquery_maskedinput_min_js__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__static_template_js_plugin_masked_input_jquery_maskedinput_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__static_template_js_plugin_masked_input_jquery_maskedinput_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_template_js_plugin_easy_pie_chart_jquery_easy_pie_chart_min_js__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__static_template_js_plugin_easy_pie_chart_jquery_easy_pie_chart_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__static_template_js_plugin_easy_pie_chart_jquery_easy_pie_chart_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_template_js_plugin_sparkline_jquery_sparkline_min_js__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__static_template_js_plugin_sparkline_jquery_sparkline_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__static_template_js_plugin_sparkline_jquery_sparkline_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_template_js_plugin_jquery_validate_jquery_validate_min_js__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__static_template_js_plugin_jquery_validate_jquery_validate_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__static_template_js_plugin_jquery_validate_jquery_validate_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_template_js_plugin_msie_fix_jquery_mb_browser_min_js__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__static_template_js_plugin_msie_fix_jquery_mb_browser_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__static_template_js_plugin_msie_fix_jquery_mb_browser_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_template_js_plugin_flot_jquery_flot_cust_min_js__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__static_template_js_plugin_flot_jquery_flot_cust_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__static_template_js_plugin_flot_jquery_flot_cust_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_template_js_plugin_flot_jquery_flot_resize_min_js__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__static_template_js_plugin_flot_jquery_flot_resize_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__static_template_js_plugin_flot_jquery_flot_resize_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_template_js_plugin_vectormap_jquery_jvectormap_1_2_2_min_js__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__static_template_js_plugin_vectormap_jquery_jvectormap_1_2_2_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__static_template_js_plugin_vectormap_jquery_jvectormap_1_2_2_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_template_js_plugin_vectormap_jquery_jvectormap_world_mill_en_js__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__static_template_js_plugin_vectormap_jquery_jvectormap_world_mill_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__static_template_js_plugin_vectormap_jquery_jvectormap_world_mill_en_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_template_js_plugin_flot_jquery_flot_tooltip_min_js__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__static_template_js_plugin_flot_jquery_flot_tooltip_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__static_template_js_plugin_flot_jquery_flot_tooltip_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_template_js_plugin_fullcalendar_jquery_fullcalendar_min_js__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__static_template_js_plugin_fullcalendar_jquery_fullcalendar_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__static_template_js_plugin_fullcalendar_jquery_fullcalendar_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_template_css_style_css__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__static_template_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__static_template_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_LoginInfo__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_LoginInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_LoginInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_TopButtons__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_TopButtons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_TopButtons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_PageFooter__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_PageFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_PageFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_NavLeft__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_NavLeft___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_NavLeft__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Auth_LoginPage__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Auth_LoginPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_Auth_LoginPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Messages_Message__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Messages_Message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_Messages_Message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Breadcrumb__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Breadcrumb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_Breadcrumb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuex__ = __webpack_require__(8);






































/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'login-info': __WEBPACK_IMPORTED_MODULE_24__components_LoginInfo___default.a,
    'top-buttons': __WEBPACK_IMPORTED_MODULE_25__components_TopButtons___default.a,
    'page-footer': __WEBPACK_IMPORTED_MODULE_26__components_PageFooter___default.a,
    'nav-left': __WEBPACK_IMPORTED_MODULE_27__components_NavLeft___default.a,
    'login-page': __WEBPACK_IMPORTED_MODULE_28__components_Auth_LoginPage___default.a,
    Message: __WEBPACK_IMPORTED_MODULE_30__components_Messages_Message___default.a,
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_31__components_Breadcrumb___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    '$route': function $route(to, from) {
      if (!this.authenticated && from.path !== '/') {
        __WEBPACK_IMPORTED_MODULE_29_jquery___default()('body').removeClass('smart-style-3 fixed-header fixed-navigation fixed-ribbon fixed-page-footer');
      }
    }
  },
  created: function created() {
    this.$root.axios.defaults.headers.common.Authorization = 'Bearer ' + this.token;
  },
  mounted: function mounted() {
    var _this = this;

    if (this.authenticated) {
      this.$root.axios.get('protected').catch(function (response) {
        _this.logout(_this.$router);
      });

      this.afterLogged();
    }

    this.$root.bus.$on('logged', function () {
      _this.afterLogged();
    });

    this.$router.beforeEach(function (to, from, next) {
      _this.$root.bus.$emit('close-alert');
      next();
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_32_vuex__["b" /* mapActions */])('user', ['logout']), {
    afterLogged: function afterLogged() {
      __WEBPACK_IMPORTED_MODULE_29_jquery___default()('body').addClass('smart-style-2 fixed-header fixed-navigation fixed-ribbon fixed-page-footer');
    }
  })
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      email: '',
      password: '',
      emailRule: '',
      passwordRule: '',
      loginIsValid: false,
      submitted: false,
      message: '',
      title: '',
      icon: '',
      needTenant: false,
      availableTenants: [],
      selectedTenant: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    }
  })),
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$root.axios.get('auth/login/rules').then(function (_ref) {
      var data = _ref.data;

      var rules = data.rules;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + 'Rule'] = rules[prop];
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    hideMessage: function hideMessage() {
      this.submitted = false;
    },
    doLogin: function doLogin(loginReponse) {
      var _this2 = this;

      this.loginIsValid = !this.loginIsValid;
      this.submitted = true;
      this.title = 'Login efetuado';
      this.message = 'Aguarde o credenciamento...';
      this.icon = 'check-circle';

      this.$root.axios.get('profiles/' + loginReponse.user.profile_id, {
        headers: {
          'Authorization': 'Bearer ' + loginReponse.token
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        var callbackDebounced = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
          loginReponse.profile = data.data;
          _this2.login(loginReponse);
          _this2.$root.bus.$emit('logged');
          window.location.reload();
        }, 2000);
        callbackDebounced();
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])('user', ['login']), {
    attempt: function attempt() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.$root.axios.post('auth/login', {
          email: _this3.email,
          password: _this3.password
        }).then(function (_ref3) {
          var data = _ref3.data;

          var userResponse = data;
          localStorage.id = data.user.id;
          _this3.$root.axios.get('user-tenants', {
            params: {
              'q': 'user_id:' + data.user.id,
              'sf': 'user_id:='
            },
            headers: {
              'Authorization': 'Bearer ' + data.token
            }
          }).then(function (_ref4) {
            var data = _ref4.data;

            var response = data.data.data;
            if (response.length === 0) {
              _this3.loginIsValid = false;
              _this3.submitted = true;
              _this3.title = 'Falha ao entrar';
              _this3.message = 'Usuário sem permissão nas unidades...';
              _this3.icon = 'times-circle';
            } else {
              if (response.length === 1) {
                window.localStorage.setItem('current-tenant', response[0].tenant.id);
                window.localStorage.setItem('current-tenant-idkey', response[0].tenant.id_key);
                _this3.doLogin(userResponse);
              } else {
                if (_this3.selectedTenant) {
                  window.localStorage.setItem('current-tenant-idkey', _this3.selectedTenant);
                  _this3.doLogin(userResponse);
                } else {
                  _this3.needTenant = true;
                  _this3.availableTenants = response;
                }
              }
            }
          });
        }).catch(function () {
          _this3.loginIsValid = false;
          _this3.submitted = true;
          _this3.title = 'Não autorizado';
          _this3.message = 'Verifique seu usuário/senha.';
          _this3.icon = 'times';
        });
      }).catch(function () {
        _this3.loginIsValid = false;
        _this3.submitted = true;
        _this3.title = 'Falha ao entrar';
        _this3.message = 'Verifique os dados preenchidos.';
        _this3.icon = 'times';
      });
    }
  })
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Auth_LoginForm__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Auth_LoginForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Auth_LoginForm__);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'login-form': __WEBPACK_IMPORTED_MODULE_0__components_Auth_LoginForm___default.a
  }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Breadcrumb',
  data: function data() {
    return {
      currentRoute: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    'trackList': function trackList(state) {
      return state.breadcrumb.list;
    }
  })),
  watch: {
    '$route': function $route(to, from) {
      this.currentRoute = to.path;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.bus.$on('push-breadcrumb', function (stack) {
      _this.$store.dispatch('breadcrumb/PUSH_BREADCRUMB_ITEM', stack);
    });
  }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  methods: {
    save: function save() {
      this.$root.axios.post('set-nf-config', {
        icms_rate: this.icms_rate,
        icms_basetax_st_reduction: this.icms_basetax_st_reduction,
        icms_basetax_modality: this.icms_basetax_modality,
        icms_cst: this.icms_cst,
        icms_origin: this.icms_origin,
        pis_rate: this.pis_rate,
        pis_cst: this.pis_cst,
        cofins_rate: this.cofins_rate,
        cofins_cst: this.cofins_cst
      }).then(function (res) {
        alert('Salvo com sucesso');
      }).catch(function (res) {
        alert('Falha ao salvar');
      });
    },
    setModel: function setModel(e) {
      var _this = this;

      var reader = new FileReader();
      var file = e.target.files[0];

      reader.addEventListener('load', function () {
        _this.file = reader.result;
      }, false);

      reader.readAsDataURL(file);
    },
    saveTemplate: function saveTemplate(e) {
      var _this2 = this;

      this.$root.axios.post('templates', {
        file: this.file,
        name: this.name,
        description: this.type
      }).then(function () {
        _this2.refresh();
      });
    },
    upload: function upload(e, id) {
      var _this3 = this;

      var reader = new FileReader();
      var file = e.target.files[0];

      reader.addEventListener('load', function () {
        _this3.$root.axios.put('templates/' + id, {
          image: reader.result
        }).then(function (_ref) {
          var data = _ref.data;

          console.log(data);
        });
      }, false);

      reader.readAsDataURL(file);
    },
    seeTemplate: function seeTemplate(id) {
      this.$root.axios.get('templates/' + id).then(function (_ref2) {
        var data = _ref2.data;

        var a = document.createElement('a');
        a.download = data.data.name + '.docx';
        a.href = data.data.file;
        a.click();
        if (a.remove) a.remove();
      });
    },
    refresh: function refresh() {
      var _this4 = this;

      this.$root.axios('/templates', {
        params: {
          'f': 'description;id;name;created_at;updated_at'
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this4.templates = data.data.data;
      });
    },
    deleteTemplate: function deleteTemplate(id) {
      var _this5 = this;

      this.$root.axios.delete('templates/' + id, {
        params: {
          'method': 'DELETE'
        }
      }).then(function () {
        _this5.refresh();
      });
    }
  },
  data: function data() {
    return {
      templates: [],
      name: null,
      file: null,
      type: null,
      icms_rate: null,
      icms_basetax_st_reduction: null,
      icms_basetax_modality: null,
      icms_cst: null,
      icms_origin: null,
      pis_rate: null,
      pis_cst: null,
      cofins_rate: null,
      cofins_cst: null,
      macros: []
    };
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$root.axios.get('/macros').then(function (data) {
      _this6.macros = data.data;
    });

    this.$root.axios.get('/get-config', {
      params: {
        'icms_rate': 'icms_rate',
        'icms_basetax_st_reduction': 'icms_basetax_st_reduction',
        'icms_basetax_modality': 'icms_basetax_modality',
        'icms_cst': 'icms_cst',
        'icms_origin': 'icms_origin',
        'pis_rate': 'pis_rate',
        'pis_cst': 'pis_cst',
        'cofins_rate': 'cofins_rate',
        'cofins_cst': 'cofins_cst'
      }
    }).then(function (_ref4) {
      var data = _ref4.data;

      data.forEach(function (_ref5) {
        var key = _ref5.key,
            value = _ref5.value;

        _this6[key] = value;
      });
    });

    this.refresh();
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Resources_VehicleEntry_Api__ = __webpack_require__(23);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    },
    searchTermOthersEntities: function searchTermOthersEntities(term) {
      this.searchTermIsDirtyOthersEntities = true;
      this.searchOthers(term);
    }
  },
  methods: {
    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.entityEntries = data.data.data;
      };

      this.$root.axios.get('entries-by-tenant/' + localStorage.getItem('current-tenant-idkey'), {
        params: {
          q: term,
          sf: 'fipe_brand:ilike;fipe_model:ilike;color:ilike;plate:ilike;fabrication_year:ilike',
          'only-available': true
        }
      }).then(callback);
    }, 500),
    searchOthers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this2 = this;

      this.$root.axios.get('/tenants', {
        params: {
          q: 'id:' + localStorage.getItem('current-tenant-idkey'),
          sf: 'id:!='
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.othersTenants = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["map"])(data.data.data, function (e) {
          return e.id;
        });
        _this2.$root.axios.get('/entries-by-tenant/' + _this2.othersTenants.join(','), {
          params: {
            q: term,
            'only-available': true,
            sf: 'fipe_vehicle:ilike;plate:ilike;renavam:ilike'
          }
        }).then(function (_ref3) {
          var data = _ref3.data;

          _this2.entriesOthersEntities = data.data.data;
          _this2.searchTermIsDirtyOthersEntities = false;
        });
      });
    }, 500)
  },
  data: function data() {
    return {
      entityEntries: [],
      negotiations: [],
      entityPendencies: [],
      entriesOthersEntities: [],
      othersTenants: [],
      currentTenant: null,
      searchTerm: '',
      searchTermIsDirty: false,
      searchTermOthersEntities: '',
      searchTermIsDirtyOthersEntities: false
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    this.api = new __WEBPACK_IMPORTED_MODULE_4__components_Resources_VehicleEntry_Api__["a" /* default */](this, 'vehicle-entry');
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this3.search(_this3.searchTerm);
    });
    this.$root.axios.get('/vehicle-entry', {
      params: {
        'q': 'tenant_id:' + localStorage.getItem('current-tenant-idkey'),
        'sf': 'tenant_id:=',
        'only-available': true
      }
    }).then(function (_ref4) {
      var data = _ref4.data;

      _this3.entityEntries = data.data.data;
    });

    this.$root.axios.get('/tenants', {
      params: {
        q: 'id:' + localStorage.getItem('current-tenant-idkey'),
        sf: 'id:!='
      }
    }).then(function (_ref5) {
      var data = _ref5.data;

      _this3.othersTenants = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["map"])(data.data.data, function (e) {
        return e.id;
      });
      _this3.$root.axios.get('/entries-by-tenant/' + _this3.othersTenants.join(','), {
        params: {
          'only-available': true
        }
      }).then(function (_ref6) {
        var data = _ref6.data;

        _this3.entriesOthersEntities = data.data.data;
      });
    });
  }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AbstractField',
  props: {
    mask: {
      type: String
    },
    value: {
      default: ''
    },
    wrapperClass: {
      type: String,
      default: 'col-lg-12'
    },
    customError: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    failed: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    if (this.name === '') {
      console.warn('field ' + this.label + ' attribute [name] cannot be undefined');
    }
  },

  computed: {
    getIcon: function getIcon() {
      return this.readonly ? 'fa-ban' : 'fa-edit';
    },
    innerValue: {
      get: function get() {
        return String(this.value);
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {
      default: ''
    },
    usingAsProvider: {
      type: String,
      default: ''
    },
    wrapperClass: {
      type: String,
      default: 'col-lg-12'
    },
    usingAsLabel: {
      type: String
    },
    usingAsValue: {
      type: String
    },
    customError: {
      type: String,
      default: ''
    },
    orderBy: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    failed: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    selectOptions: {},
    hasRelated: {
      type: Boolean
    },
    related: {},
    lazy: {
      default: false
    }
  },
  created: function created() {
    this.options = this.selectOptions || [];
  },
  data: function data() {
    return {
      loading: null
    };
  },

  computed: {
    innerValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        if (value != null) {
          this.$emit('input', value);
        }
      }
    }
  }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AbstractField',
  props: {
    mask: {
      type: String
    },
    value: {
      default: ''
    },
    wrapperClass: {
      type: String,
      default: 'col-lg-12'
    },
    customError: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    failed: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    if (this.name === '') {
      console.warn('field ' + this.label + ' attribute [name] cannot be undefined');
    }
  },

  computed: {
    getIcon: function getIcon() {
      return this.readonly ? 'fa-ban' : 'fa-edit';
    },
    innerValue: {
      get: function get() {
        return String(this.value);
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AbstractField',
  props: {
    mask: {
      type: String
    },
    value: {
      default: ''
    },
    wrapperClass: {
      type: String,
      default: 'col-lg-12'
    },
    customError: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    failed: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    if (this.name === '') {
      console.warn('field ' + this.label + ' attribute [name] cannot be undefined');
    }
  },

  computed: {
    getIcon: function getIcon() {
      return this.readonly ? 'fa-ban' : 'fa-edit';
    },
    innerValue: {
      get: function get() {
        return String(this.value);
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractCheckboxField__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractCheckboxField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractCheckboxField__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TextField',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractCheckboxField___default.a],
  data: function data() {
    return {
      type: 'checkbox'
    };
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractSelectField__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractSelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractSelectField__);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractSelectField___default.a],
  created: function created() {
    var _this = this;

    if (!this.lazy) {
      this.refreshOptions();
    }

    this.$root.bus.$on('select-' + this.name + '-outdated', function (payload) {
      _this.options = [];
      _this.innerValue = '';
      if (typeof payload.query !== 'undefined') {
        _this.refreshOptions(payload.query);
      } else if (typeof payload.option !== 'undefined') {
        _this.refreshOptions({
          q: payload.related.searchFieldAs + ':' + payload.option.label
        });
      }
    });
  },

  methods: {
    refreshOptions: function refreshOptions() {
      var _this2 = this;

      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (this.usingAsLabel !== 'full_name') {
        query.o = this.orderBy || this.usingAsLabel;
        query.s = 'asc';
      }

      this.loading = true;
      this.$root.axios.get(this.usingAsProvider, {
        params: query
      }).then(function (_ref) {
        var data = _ref.data;

        var tempOptions = data.data.data;
        var options = [];
        tempOptions.forEach(function (option) {
          var tempOption = {
            label: option[_this2.usingAsLabel],
            value: option[_this2.usingAsValue]
          };
          options.push(tempOption);
        });
        if (options.length === 1) {
          _this2.innerValue = options[0].value;
        }

        _this2.options = options;
        _this2.loading = false;
      });
    }
  },
  data: function data() {
    return {
      type: 'entity-type',
      options: [],
      customMessage: null
    };
  },

  computed: {
    innerValue: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        if (value != null) {
          if (this.hasRelated) {
            this.$root.bus.$emit('select-' + this.related.formField + '-outdated', {
              'value': value,
              'related': this.related,
              'option': this.options.filter(function (option) {
                return option.value === value;
              })[0]
            });
          }
          this.$emit('input', value);
        }
      }
    }
  }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField__);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField___default.a],
  data: function data() {
    return {
      type: 'masked-field'
    };
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField__);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField___default.a],
  data: function data() {
    return {
      type: 'monetary'
    };
  },

  computed: {
    innerValue: {
      get: function get() {
        return 'R$ ' + String(this.value);
      },
      set: function set(value) {
        var val = value.replace(/[^\d.,]/g, '');

        this.$emit('input', val);
      }
    }
  }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PercentField',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField___default.a],
  data: function data() {
    return {
      type: 'percent'
    };
  },

  computed: {
    innerValue: {
      get: function get() {
        if (this.value.indexOf('%') !== this.value.length - 1) {
          return String(this.value) + '%';
        }
        return String(this.value);
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractSelectField__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractSelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractSelectField__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SelectField',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractSelectField___default.a],
  data: function data() {
    return {
      type: 'text',
      options: []
    };
  }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextAreaField__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextAreaField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextAreaField__);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextAreaField___default.a],
  data: function data() {
    return {
      type: 'text-area'
    };
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'TextField',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__components_Fields_AbstractTextField___default.a],
  data: function data() {
    return {
      type: 'text'
    };
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    userName: function userName(state) {
      return state.user.userName;
    }
  }))
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      message: null,
      type: null,
      url: '',
      icon: null
    };
  },

  name: 'Message',
  created: function created() {
    var _this = this;

    this.$root.bus.$on('show-alert', function (details) {
      _this.show = true;
      var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(details);

      keys.forEach(function (key) {
        _this[key] = details[key];
      });
    });
    this.$root.bus.$on('deleted', function () {
      _this.$root.bus.$emit('close-alert');
    });
    this.$root.bus.$on('close-alert', function () {
      _this.show = false;
      _this.message = null;
      _this.type = null;
      _this.url = '';
      _this.icon = null;
    });
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }))
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Resources_VehicleEntry_Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_select__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_select_dist_vue_select_css__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Reserva__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Reserva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Reserva__);



















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'estoque',
  components: {
    vSelect: __WEBPACK_IMPORTED_MODULE_13_vue_select___default.a,
    Reserva: __WEBPACK_IMPORTED_MODULE_15__Reserva___default.a
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    },
    reserveVehicle: function reserveVehicle(state) {
      return state.reserveVehicle;
    },
    reserveOpen: function reserveOpen(state) {
      return state.reserveVehicle.open;
    }
  })),
  watch: {
    reserveOpen: function reserveOpen(val) {
      var _this = this;

      if (val === false) {
        console.log('mudou');
        setTimeout(function () {
          return _this.pegaDadosNovamente();
        }, 500);
      }
    },
    vehicleFilter: function vehicleFilter() {
      var filtro = this.vehicleFilter;
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      var filtroUpperCase = filtro.toUpperCase();
      filtroTotal.map(function (item) {
        var dadoUpperCase = item.full_name.toUpperCase();
        if (dadoUpperCase.match(filtroUpperCase)) {
          filtrados.push(item);
        }
      });

      this.vehicleResults = filtrados;
      this.noRepeatPlease();
    },
    yearFilter: function yearFilter() {
      var filtro = this.yearFilter;
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      filtro.map(function (dado) {
        var dadoUm = dado + '/' + (dado + 1);
        var dadoDois = dado - 1 + '/' + dado;
        var dadoTres = dado + '/' + dado;

        filtroTotal.map(function (item) {
          if (item.fabrication_year === dadoUm || item.fabrication_year === dadoDois || item.fabrication_year === dadoTres) {
            filtrados.push(item);
          }
        });
      });

      this.yearResults = filtrados;
      this.noRepeatPlease();
    },
    brandFilter: function brandFilter() {
      var filtro = this.brandFilter;
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      filtro.map(function (dado) {
        filtroTotal.map(function (item) {
          if (item.brand.toUpperCase() === dado) {
            filtrados.push(item);
          }
        });
      });

      this.brandResults = filtrados;
      this.noRepeatPlease();
    },
    plateFilter: function plateFilter() {
      var filtro = this.plateFilter;
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      filtro.map(function (dado) {
        filtroTotal.map(function (item) {
          if (item.plate.toUpperCase() === dado) {
            filtrados.push(item);
          }
        });
      });

      this.plateResults = filtrados;
      this.noRepeatPlease();
    },
    colorFilter: function colorFilter() {
      var filtro = this.colorFilter;
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      filtro.map(function (dado) {
        filtroTotal.map(function (item) {
          if (item.color.toUpperCase() === dado) {
            filtrados.push(item);
          }
        });
      });

      this.colorResults = filtrados;
      this.noRepeatPlease();
    },
    tenantFilter: function tenantFilter() {
      var filtro = this.tenantFilter;
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      filtro.map(function (dado) {
        filtroTotal.map(function (item) {
          if (item.tenant_fancy_name.toUpperCase() === dado) {
            filtrados.push(item);
          }
        });
      });

      this.tenantResults = filtrados;
      this.noRepeatPlease();
    },
    priceFilter: function priceFilter() {
      var filtro = parseFloat(this.priceFilter);
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      filtroTotal.map(function (item) {
        var salePrice = parseFloat(item.sale_price);

        if (salePrice <= filtro) {
          filtrados.push(item);
        }
      });

      this.priceResults = filtrados;
      this.noRepeatPlease();
    },
    daysFilter: function daysFilter() {
      var _this2 = this;

      var filtro = parseInt(this.daysFilter);
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      filtroTotal.map(function (item) {
        var totalDeDias = _this2.totalOfDays(item.created_at);
        if (totalDeDias >= filtro) {
          filtrados.push(item);
        }
      });

      this.daysResults = filtrados;
      setTimeout(function () {
        return _this2.noRepeatPlease();
      }, 1000);
    },

    lastActionFilter: function lastActionFilter() {
      var filtro = this.lastActionFilter;
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      var filtroUpperCase = filtro.toUpperCase();
      filtroTotal.map(function (item) {
        var dadoUpperCase = item.description.toUpperCase();
        if (dadoUpperCase.match(filtroUpperCase)) {
          filtrados.push(item);
        }
      });

      this.lastActionResults = filtrados;
      this.noRepeatPlease();
    },
    actionsFilter: function actionsFilter() {
      var filtro = this.actionsFilter;
      var filtroTotal = this.filteredEntriesBkp;
      var filtrados = [];

      if (filtro) {
        filtroTotal.map(function (item) {
          var dado = parseInt(item.state_id);
          if (dado === 3) {
            filtrados.push(item);
          }
        });
        this.actionsResults = filtrados;
      } else {
        this.actionsResults = [];
      }
      this.noRepeatPlease();
    },
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    },
    filterSearch: function filterSearch(term) {
      this.filter(term);
    },
    searchTermOthersEntities: function searchTermOthersEntities(term) {
      this.searchTermIsDirtyOthersEntities = true;
      this.searchOthers(term);
    },
    'show.vehicle': function showVehicle() {},
    'show.year': function showYear() {},
    'show.brand': function showBrand() {},
    'show.plate': function showPlate() {},
    'show.color': function showColor() {},
    'show.tenant': function showTenant() {},
    'show.price': function showPrice() {},
    'show.days': function showDays() {},
    filters: function filters() {},
    'filters.vehicle': function filtersVehicle() {},
    'filters.year': function filtersYear() {},
    'filters.brand': function filtersBrand() {},
    'filters.plate': function filtersPlate() {},
    'filters.color': function filtersColor() {},
    'filters.tenant': function filtersTenant() {},
    'filters.price': function filtersPrice() {},
    'filters.days': function filtersDays() {},
    entriesOthersEntities: function entriesOthersEntities() {
      this.filteredEntries = this.entriesOthersEntities;
    }
  },
  methods: {
    pegaDadosNovamente: function pegaDadosNovamente() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
        var token, config;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                token = localStorage.token;
                config = {
                  headers: {
                    'Authorization': 'bearer' + token
                  }
                };
                _context.next = 4;
                return _this3.$root.axios.get('http://vendas.vipcarseminovos.com.br/api/v1/entries/estoque/', config).then(function (_ref) {
                  var data = _ref.data;

                  _this3.entriesOthersEntities = data.data;
                  _this3.filteredEntriesBkp = data.data;
                  _this3.filteredEntries = data.data;
                }).catch(function (error) {
                  return alert('erro ' + error);
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },

    abreReserva: function abreReserva(entry) {
      var _this4 = this;

      if (entry.state_id === 3) {
        this.$root.axios.get('http://vendas.vipcarseminovos.com.br/api/v1/entries/reserva/' + entry.id_reserva).then(function (res) {
          var reserva = res.data.data;
          var entrada = entry;
          var payload = {
            entry: entrada,
            reserva: reserva
          };
          _this4.$store.dispatch('CHANGE_VISIBILITY', payload);
        }).catch(function () {
          alert('erro');
        });
      } else {
        var payload = {
          entry: entry,
          reserva: {}
        };
        this.$store.dispatch('CHANGE_VISIBILITY', payload);
      }
    },
    daysSort: function daysSort() {
      this.ordenaDisable = true;
      var ordena = this.ordena;

      this.ordena = !this.ordena;

      var dadosPO = this.filteredEntries;
      var dadosParaOrdenar = dadosPO;
      var self = this;
      var dadosOrdenados = null;
      if (ordena) {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return self.totalOfDays(a.created_at) - self.totalOfDays(b.created_at);
        });
      } else {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return self.totalOfDays(b.created_at) - self.totalOfDays(a.created_at);
        });
      }

      this.filteredEntries = dadosOrdenados;
      this.ordenaDisable = false;
    },
    priceSort: function priceSort() {
      this.ordenaDisable = true;
      var ordena = this.ordena;

      this.ordena = !this.ordena;

      var dadosPO = this.filteredEntries;
      var dadosParaOrdenar = dadosPO;
      var dadosOrdenados = null;
      if (ordena) {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return parseFloat(a.sale_price) - parseFloat(b.sale_price);
        });
      } else {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return parseFloat(b.sale_price) - parseFloat(a.sale_price);
        });
      }

      this.filteredEntries = dadosOrdenados;
      this.ordenaDisable = false;
    },
    yearSort: function yearSort() {
      this.ordenaDisable = true;
      var ordena = this.ordena;

      this.ordena = !this.ordena;

      var dadosPO = this.filteredEntries;
      var dadosParaOrdenar = dadosPO;
      var dadosOrdenados = null;
      if (ordena) {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return a.fabrication_year.localeCompare(b.fabrication_year);
        });
      } else {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return b.fabrication_year.localeCompare(a.fabrication_year);
        });
      }

      this.filteredEntries = dadosOrdenados;
      this.ordenaDisable = false;
    },
    vehicleSort: function vehicleSort() {
      this.ordenaDisable = true;
      var ordena = this.ordena;

      this.ordena = !this.ordena;

      var dadosPO = this.filteredEntries;
      var dadosParaOrdenar = dadosPO;
      var dadosOrdenados = null;
      if (ordena) {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return a.full_name.localeCompare(b.full_name);
        });
      } else {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return b.full_name.localeCompare(a.full_name);
        });
      }

      this.filteredEntries = dadosOrdenados;
      this.ordenaDisable = false;
    },
    brandSort: function brandSort() {
      this.ordenaDisable = true;
      var ordena = this.ordena;

      this.ordena = !this.ordena;

      var dadosPO = this.filteredEntries;
      var dadosParaOrdenar = dadosPO;
      var dadosOrdenados = null;
      if (ordena) {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return a.brand.localeCompare(b.brand);
        });
      } else {
        dadosOrdenados = dadosParaOrdenar.sort(function (a, b) {
          return b.brand.localeCompare(a.brand);
        });
      }

      this.filteredEntries = dadosOrdenados;
      this.ordenaDisable = false;
    },
    noRepeatPlease: function noRepeatPlease() {
      var vehicle = this.vehicleResults;
      var year = this.yearResults;
      var brand = this.brandResults;
      var plate = this.plateResults;
      var color = this.colorResults;
      var tenant = this.tenantResults;
      var price = this.priceResults;
      var days = this.daysResults;
      var lastAction = this.lastActionResults;
      var actions = this.actionsResults;

      var vehicleCode = this.vehicleResults.length === 0 ? '0' : '1';
      var yearCode = this.yearResults.length === 0 ? '0' : '1';
      var brandCode = this.brandResults.length === 0 ? '0' : '1';
      var plateCode = this.plateResults.length === 0 ? '0' : '1';
      var colorCode = this.colorResults.length === 0 ? '0' : '1';
      var tenantCode = this.tenantResults.length === 0 ? '0' : '1';
      var priceCode = this.priceResults.length === 0 ? '0' : '1';
      var daysCode = this.daysResults.length === 0 ? '0' : '1';
      var lastActionCode = this.lastActionResults.length === 0 ? '0' : '1';
      var actionsCode = this.actionsResults.length === 0 ? '0' : '1';

      var codigo = vehicleCode + yearCode + brandCode + plateCode + colorCode + tenantCode + priceCode + daysCode + lastActionCode + actionsCode;

      var resultadosFiltrados = [];
      var resultadosNaoFiltrados = [];

      vehicle.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      year.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      brand.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      plate.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      color.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      tenant.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      price.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      days.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      lastAction.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      actions.map(function (v) {
        return resultadosNaoFiltrados.push(v);
      });

      resultadosNaoFiltrados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = dado.plate;

        resultadosFiltrados.map(function (dadoExistente) {
          if (dadoExistente.plate === dadoAtual) {
            dadoExiste = true;
          }
        });


        if (dadoExiste) {} else {
          return resultadosFiltrados.push(dado);
        }
      });

      this.resultadosNaoFiltrados = resultadosNaoFiltrados;
      this.afterNoRepeat(resultadosFiltrados, codigo);
    },
    afterNoRepeat: function afterNoRepeat(resultadosFiltrados, codigo) {
      var _this5 = this;

      var vehicle = this.vehicleResults;
      var year = this.yearResults;
      var brand = this.brandResults;
      var plate = this.plateResults;
      var color = this.colorResults;
      var tenant = this.tenantResults;
      var price = this.priceResults;
      var days = this.daysResults;
      var lastAction = this.lastActionResults;
      var actions = this.actionsResults;

      var segundoFiltro = resultadosFiltrados;
      var resultadoSegundoFiltro = [];
      segundoFiltro.map(function (item) {
        var um = '0';
        var dois = '0';
        var tres = '0';
        var quatro = '0';
        var cinco = '0';
        var seis = '0';
        var sete = '0';
        var oito = '0';
        var nove = '0';
        var dez = '0';

        if (vehicle.length === 0) {
          um = '0';
        } else {
          vehicle.map(function (v) {
            if (v.full_name === item.full_name) {
              um = '1';
            }
          });
        }

        if (year.length === 0) {
          dois = '0';
        } else {
          year.map(function (v) {
            var dado = parseInt(item.fipe_year);
            var dadoUm = dado + '/' + (dado + 1);
            var dadoDois = dado - 1 + '/' + dado;
            if (v.fabrication_year === dadoUm || v.fabrication_year === dadoDois) {
              dois = '1';
            }
          });
        }

        if (brand.length === 0) {
          tres = '0';
        } else {
          brand.map(function (v) {
            if (v.brand === item.brand) {
              tres = '1';
            }
          });
        }

        if (plate.length === 0) {
          quatro = '0';
        } else {
          plate.map(function (v) {
            if (v.plate === item.plate) {
              quatro = '1';
            }
          });
        }

        if (color.length === 0) {
          cinco = '0';
        } else {
          color.map(function (v) {
            if (v.color === item.color) {
              cinco = '1';
            }
          });
        }

        if (tenant.length === 0) {
          seis = '0';
        } else {
          tenant.map(function (v) {
            if (v.tenant_fancy_name === item.tenant_fancy_name) {
              seis = '1';
            }
          });
        }

        if (price.length === 0) {
          sete = '0';
        } else {
          price.map(function (v) {
            if (parseFloat(item.sale_price) <= parseFloat(v.sale_price)) {
              sete = '1';
            }
          });
        }

        if (days.length === 0) {
          oito = '0';
        } else {
          days.map(function (v) {
            if (_this5.totalOfDays(item.created_at) >= _this5.totalOfDays(v.created_at)) {
              oito = '1';
            }
          });
        }

        if (lastAction.length === 0) {
          nove = '0';
        } else {
          lastAction.map(function (v) {
            if (v.description === item.description) {
              nove = '1';
            }
          });
        }

        if (actions.length === 0) {
          nove = '0';
        } else {
          actions.map(function (v) {
            if (v.state_id === item.state_id) {
              dez = '1';
            }
          });
        }

        var codigoGerado = um + dois + tres + quatro + cinco + seis + sete + oito + nove + dez;

        if (codigoGerado === codigo) {
          resultadoSegundoFiltro.push(item);
        }
      });

      if (codigo === '0000000000') {
        var bkp = this.filteredEntriesBkp;
        this.filteredEntries = bkp;
      } else {
        this.filteredEntries = resultadoSegundoFiltro;
      }
    },

    filterVehicle: function filterVehicle(result) {
      var dados = result;
      var dadosSearch = [];
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = dado.full_name.toUpperCase();

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var dadoSort = dadosSearch.sort();
      this.vehicleForSearch = dadoSort;
    },

    filterYear: function filterYear(result) {
      var dados = result;
      var dadosSearch = [];
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = parseInt(dado.fipe_year);

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var yearSortidos = dadosSearch.sort();
      this.yearForSearch = yearSortidos;
    },

    filterBrand: function filterBrand(result) {
      var dados = result;
      var dadosSearch = [];
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = dado.brand.toUpperCase();

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var brandSortidos = dadosSearch.sort();
      this.brandForSearch = brandSortidos;
    },

    filterPlate: function filterPlate(result) {
      var dados = result;
      var dadosSearch = [];
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = dado.plate.toUpperCase();

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var plateSortidas = dadosSearch.sort();
      this.plateForSearch = plateSortidas;
    },

    filterColor: function filterColor(result) {
      var dados = result;
      var dadosSearch = [];
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = dado.color.toUpperCase();

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var colorSortida = dadosSearch.sort();
      this.colorForSearch = colorSortida;
    },

    filterTenant: function filterTenant(result) {
      var dados = result;
      var dadosSearch = [];
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = dado.tenant_fancy_name.toUpperCase();

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var tenantSortida = dadosSearch.sort();
      this.tenantForSearch = tenantSortida;
    },

    filterPrice: function filterPrice(result) {
      var dados = result;
      var dadosSearch = [];
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = parseFloat(dado.sale_price);

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var priceSortido = dadosSearch.sort();
      this.priceForSearch = priceSortido;
    },

    filterDays: function filterDays(result) {
      var dados = result;
      var dadosSearch = [];
      var self = this;
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAt = dado.created_at;
        var dadoAtual = self.totalOfDays(dadoAt);

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var daysSearch = dadosSearch.sort();
      this.daysForSearch = daysSearch;
    },

    filterLastAction: function filterLastAction(result) {
      var dados = result;
      var dadosSearch = [];
      dados.map(function (dado) {
        var dadoExiste = false;
        var dadoAtual = dado.description.toUpperCase();

        dadosSearch.map(function (dadoExistente) {
          if (dadoExistente === dadoAtual) {
            dadoExiste = true;
          }
        });

        if (dadoExiste) {} else {
          dadosSearch.push(dadoAtual);
        }
      });
      var lastActionSortida = dadosSearch.sort();
      this.lastActionForSearch = lastActionSortida;
    },
    addFilter: function addFilter(field, searchTerm) {
      this.filters = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.filters, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, field, new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a([].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.filters[field]), [searchTerm]))));
    },
    removeFilter: function removeFilter(field, searchTerm) {
      var result = this.filters[field].filter(function (x) {
        return x !== searchTerm;
      });
      this.filters = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, this.filters, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, field, new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(result)));
    },
    filter: function filter(searchTerms) {
      if (searchTerms === null || searchTerms === [] || searchTerms === '') {
        this.filteredEntries = this.entriesOthersEntities;
        return;
      }
      var result = [];
      var condicoes = searchTerms.split(',');
      this.entriesOthersEntities.map(function (x) {

        var strBusca = x.full_name + ' - ' + x.fabrication_year + ' - ' + x.brand + ' - ' + x.plate + ' - ' + x.sale_price_formatted + ' - ' + x.ultimo_movimento + ' - ' + x.color + ' - ' + x.tenant.tenant_fancy_name;

        var match = true;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(condicoes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var c = _step.value;

            if (!strBusca.toLowerCase().includes(c.toLowerCase())) {
              match = false;
              return;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        if (match) {
          result.push(x);
        }
      });
      this.filteredEntries = result;
    },
    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["debounce"])(function (term) {
      var _this6 = this;

      var callback = function callback(_ref2) {
        var data = _ref2.data;

        _this6.searchTermIsDirty = false;
        _this6.entityEntries = data.data;
      };

      this.$root.axios.get('entries-by-tenant/' + localStorage.getItem('current-tenant-idkey'), {
        params: {
          q: term,
          sf: 'fipe_brand:ilike;fipe_model:ilike;color:ilike;plate:ilike;fabrication_year:ilike',
          'only-available': true
        }
      }).then(callback);
    }, 500),
    searchOthers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["debounce"])(function (term) {
      var _this7 = this;

      this.$root.axios.get('/tenants', {
        params: {
          q: 'id:' + localStorage.getItem('current-tenant-idkey'),
          sf: 'id:!='
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this7.othersTenants = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["map"])(data.data.data, function (e) {
          return e.id;
        });
        _this7.$root.axios.get('/entries-by-tenant/' + _this7.othersTenants.join(','), {
          params: {
            q: term,
            'only-available': true,
            sf: 'fipe_vehicle:ilike;plate:ilike;renavam:ilike'
          }
        }).then(function (_ref4) {
          var data = _ref4.data;

          _this7.entriesOthersEntities = data.data.data;
          _this7.searchTermIsDirtyOthersEntities = false;
        });
      });
    }, 500),
    toggleCol: function toggleCol() {
      var col = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (col) {
        if (col === 'vehicle') {
          this.show.vehicle = !this.show.vehicle;
        }
        if (col === 'year') {
          this.show.year = !this.show.year;
        }
        if (col === 'brand') {
          this.show.brand = !this.show.brand;
        }
        if (col === 'plate') {
          this.show.plate = !this.show.plate;
        }
        if (col === 'color') {
          this.show.color = !this.show.color;
        }
        if (col === 'tenant') {
          this.show.tenant = !this.show.tenant;
        }
        if (col === 'price') {
          this.show.price = !this.show.price;
        }
        if (col === 'days') {
          this.show.days = !this.show.days;
        }
        if (col === 'lastAction') {
          this.show.lastAction = !this.show.lastAction;
        }
      }
      this.salvaEstadoDasColunas();
    },
    salvaEstadoDasColunas: function salvaEstadoDasColunas() {
      var _this8 = this;

      var show = this.show;
      var userId = localStorage.id;
      var token = localStorage.token;

      var config = {
        headers: {
          'Authorization': 'bearer' + token,
          'Content-Type': 'application/json'
        }
      };

      var showStringfy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(show);
      var body = {
        list_preferences: showStringfy
      };
      this.$root.axios.post('http://vendas.vipcarseminovos.com.br/api/v1/employees/' + userId + '/update_listprefs', body, config).then(function (res) {
        _this8.respostaDoServidor = res;
      }).catch(function (error) {
        _this8.respostaDoServidor = error;
      });
    },
    totalOfDays: function totalOfDays(initial) {
      var now = new Date();
      var resp = __WEBPACK_IMPORTED_MODULE_12_moment___default()(now).diff(initial, 'days');
      return resp;
    }
  },
  data: function data() {
    return {
      ordena: true,
      ordenaDisable: false,
      show: {
        vehicle: true,
        year: true,
        brand: true,
        plate: true,
        color: true,
        tenant: true,
        price: true,
        days: true,
        lastAction: true
      },

      vehicleForSearch: [],
      yearForSearch: [],
      brandForSearch: [],
      plateForSearch: [],
      colorForSearch: [],
      tenantForSearch: [],
      priceForSearch: [],
      daysForSearch: [],
      lastActionForSearch: [],

      vehicleFilter: '',
      yearFilter: [],
      brandFilter: [],
      plateFilter: [],
      colorFilter: [],
      tenantFilter: [],
      priceFilter: '',
      daysFilter: '',
      lastActionFilter: '',
      actionsFilter: false,

      vehicleResults: [],
      yearResults: [],
      brandResults: [],
      plateResults: [],
      colorResults: [],
      tenantResults: [],
      priceResults: [],
      daysResults: [],
      lastActionResults: [],
      actionsResults: [],

      filterOptions: true,
      entityEntries: [],
      negotiations: [],
      entityPendencies: [],
      entriesOthersEntities: [],
      othersTenants: [],
      currentTenant: null,
      searchTerm: '',
      searchTermIsDirty: false,
      searchTermOthersEntities: '',
      searchTermIsDirtyOthersEntities: false,
      filteredEntries: [],
      filteredEntriesBkp: [],
      filters: {
        vehicle: null,
        year: null,
        brand: null,
        plate: null,
        color: null,
        tenant: null,
        price: null,
        days: null
      },
      filterSearch: [],
      resultadosNaoFiltrados: [],
      respostaDoServidor: null
    };
  },
  created: function created() {
    var _this9 = this;

    this.api = new __WEBPACK_IMPORTED_MODULE_11__components_Resources_VehicleEntry_Api__["a" /* default */](this, 'vehicle-entry');
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_10__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this9.search(_this9.searchTerm);
    });
    this.$root.axios.get('/vehicle-entry', {
      params: {
        q: 'tenant_id:' + localStorage.getItem('current-tenant-idkey'),
        sf: 'tenant_id:=',
        'only-available': true
      }
    }).then(function (_ref5) {
      var data = _ref5.data;

      _this9.entityEntries = data.data.data;
    });

    this.$root.axios.get('/tenants', {
      params: {}
    }).then(function (_ref6) {
      var data = _ref6.data;

      _this9.othersTenants = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash__["map"])(data.data.data, function (e) {
        return e.id;
      });
      _this9.$root.axios.get('http://vendas.vipcarseminovos.com.br/api/v1/entries/estoque/').then(function (_ref7) {
        var data = _ref7.data;

        _this9.entriesOthersEntities = data.data;
        _this9.filteredEntriesBkp = data.data;

        _this9.filterYear(data.data);
        _this9.filterBrand(data.data);
        _this9.filterPlate(data.data);
        _this9.filterColor(data.data);
        _this9.filterTenant(data.data);
      });
    });
    this.$root.axios.get('http://vendas.vipcarseminovos.com.br/api/v1/employees/' + localStorage.id + '/get_listprefs', {
      headers: {
        'Authorization': 'Bearer ' + localStorage.token
      }
    }).then(function (res) {
      var listaPreferencia = res.data.data[0].list_preferences;
      if (listaPreferencia !== null) {
        _this9.show = JSON.parse(listaPreferencia);
      }
    }).catch(function () {
      return console.log('erro:');
    });
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LastActivity__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LastActivity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LastActivity__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'last-activity': __WEBPACK_IMPORTED_MODULE_0__components_LastActivity___default.a
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    numeral: function numeral() {
      return __WEBPACK_IMPORTED_MODULE_3_numeral___default.a;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  methods: {
    clear_all: function clear_all() {
      this.entries_values = [];
      this.registry = [];
      this.entries_tenant = [];
      this.date_entries_first = null;
      this.date_entries_end = null;
      this.date_sales_first = null;
      this.date_sales_end = null;
      this.date_stopped_entries_first = null;
      this.date_stopped_entries_end = null;
      this.date_pendencies_first = null;
      this.date_pendencies_end = null;
      this.date_employee_sales_first = null;
      this.date_employee_sales_end = null;
      this.employee_sales_user = 'all';
    },
    validateEntries: function validateEntries(tipo) {
      var _this = this;

      if (tipo === 'sales-ranking-tenant' || tipo === 'sales-ranking-employee') {
        this.entries_tenant = this.tenants.map(function (tenant) {
          return tenant.id_key;
        });
      }

      if ((this.date_entries_first && this.date_entries_end || this.date_sales_first && this.date_sales_end || this.date_stopped_entries_first && this.date_stopped_entries_end || this.date_pendencies_first && this.date_pendencies_end || this.date_employee_sales_first && this.date_employee_sales_end || this.date_vehicle_expenses_first && this.date_vehicle_expenses_end || this.date_ranking_sales_tenant_initial && this.date_ranking_sales_tenant_end || this.date_ranking_sales_employee_initial && this.date_ranking_sales_employee_end) && this.entries_tenant.length > 0) {
        var callbackDebounced = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function () {
          if (tipo === 'entries') {
            _this.current = 'entries';
            _this.refresh('/entries/report-1', {
              params: {
                initial_date: _this.date_entries_first,
                end_date: _this.date_entries_end,
                tenants: _this.entries_tenant
              }
            });
          } else if (tipo === 'sales') {
            _this.current = 'sales';
            _this.refresh('/sales/report-1', {
              params: {
                initial_date: _this.date_sales_first,
                end_date: _this.date_sales_end,
                tenants: _this.entries_tenant
              }
            });
          } else if (tipo === 'stopped_entries') {
            _this.current = 'stopped_entries';
            _this.refresh('/entries/report-2', {
              params: {
                initial_date: _this.date_stopped_entries_first,
                end_date: _this.date_stopped_entries_end,
                tenants: _this.entries_tenant
              }
            });
          } else if (tipo === 'pendencies') {
            _this.current = 'pendencies';
            _this.refresh('/entries/report-3', {
              params: {
                initial_date: _this.date_pendencies_first,
                end_date: _this.date_pendencies_end,
                tenants: _this.entries_tenant
              }
            });
          } else if (tipo === 'employee-sales') {
            _this.current = 'employee-sales';
            _this.refresh('/entries/report-4', {
              params: {
                initial_date: _this.date_employee_sales_first,
                end_date: _this.date_employee_sales_end,
                tenants: _this.entries_tenant,
                user: _this.employee_sales_user
              }
            });
          } else if (tipo === 'expenses-vehicles') {
            _this.current = 'expenses-vehicles';
            _this.refresh('/entries/report-5', {
              params: {
                initial_date: _this.date_vehicle_expenses_first,
                end_date: _this.date_vehicle_expenses_end,
                tenants: _this.entries_tenant,
                state: _this.expense_vehicle_state_selected,
                vendor: _this.expense_vehicles_vendor_selected
              }
            });
          } else if (tipo === 'sales-ranking-tenant') {
            _this.current = 'sales-ranking-tenant';
            _this.refresh('/entries/report-6', {
              params: {
                initial_date: _this.date_ranking_sales_tenant_initial,
                end_date: _this.date_ranking_sales_tenant_end
              }
            });
          } else if (tipo === 'sales-ranking-employee') {
            _this.current = 'sales-ranking-employee';
            _this.refresh('/entries/report-7', {
              params: {
                initial_date: _this.date_ranking_sales_employee_initial,
                end_date: _this.date_ranking_sales_employee_end
              }
            });
          }
        }, 500);
        callbackDebounced();
      }
    },
    refresh: function refresh(endpoint, params) {
      var _this2 = this;

      this.$root.axios.get(endpoint, params).then(function (data) {
        _this2.registry = data.data.data;
        _this2.entries_values = data.data;
      });
    }
  },
  data: function data() {
    return {
      entries_values: [],
      registry: [],
      tenants: [],
      entries_tenant: [],
      date_entries_first: null,
      date_entries_end: null,
      date_sales_first: null,
      date_sales_end: null,
      date_stopped_entries_first: null,
      date_stopped_entries_end: null,
      date_pendencies_first: null,
      date_pendencies_end: null,
      date_employee_sales_first: null,
      date_employee_sales_end: null,
      current: null,
      employee_sales_user: 'all',
      employees_sales_list: [],
      expenses_vehicles_states: [{ id: 'todas', label: 'Todas' }, { id: 'pendente', label: 'Pendente' }, { id: 'pago', label: 'Pago' }],
      date_vehicle_expenses_first: null,
      date_vehicle_expenses_end: null,
      expense_vehicle_state_selected: null,
      expense_vehicles_vendors: [],
      expense_vehicles_vendor_selected: null,
      date_ranking_sales_tenant_initial: null,
      date_ranking_sales_tenant_end: null,
      date_ranking_sales_employee_initial: null,
      date_ranking_sales_employee_end: null
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    __WEBPACK_IMPORTED_MODULE_3_numeral___default.a.locale('pt-br');
    this.current = this.$route.params.aba;

    this.$root.axios.get('employees').then(function (_ref) {
      var data = _ref.data.data.data;

      _this3.employees_sales_list = data;
    });

    this.$root.axios.get('/customers').then(function (_ref2) {
      var data = _ref2.data.data.data;

      _this3.expense_vehicles_vendors = data;
    });

    this.$root.axios('/tenants', {
      params: {
        'o': 'tenant_fancy_name',
        's': 'desc'
      }
    }).then(function (_ref3) {
      var data = _ref3.data;

      _this3.tenants = data.data.data;
    });
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ReportsV2',
  mounted: function mounted() {
    var _this = this;

    this.$root.axios.get('report-v2-page').then(function (data) {
      _this.data = data.data;
    });
  },
  data: function data() {
    return {
      data: ''
    };
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment_locale_pt_br__);







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      observacoes: '',
      carregando: false,
      success: false,
      successMessage: '',
      error: false,
      errorMessage: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    reserveVehicle: function reserveVehicle(state) {
      return state.reserveVehicle;
    },
    user: function user(state) {
      return state.user;
    }
  })),
  filters: {
    status: function status(val) {
      if (!val) return '';
      if (val === 3) {
        return 'Veículo Reservado';
      } else {
        return 'Disponível Para Reserva';
      }
    },
    dataReserva: function dataReserva(val) {
      if (!val) {
        return __WEBPACK_IMPORTED_MODULE_2_moment___default()().locale('pt-br').format('LL');
      }
      var dataDaReserva = __WEBPACK_IMPORTED_MODULE_2_moment___default()(val).locale('pt-br').format('LL');
      return dataDaReserva;
    }
  },
  methods: {
    montaReserva: function montaReserva(reserveVehicle) {
      var _this = this;

      this.carregando = true;
      var token = localStorage.token;
      var obsVendedor = this.observacoes;
      var idVeiculo = reserveVehicle.veiculoSelecionado.id;

      var config = {
        headers: {
          'Authorization': 'bearer' + token
        }
      };

      var body = {
        entry_id: idVeiculo,
        obs: obsVendedor
      };
      this.$root.axios.post('http://vendas.vipcarseminovos.com.br/api/v1/entries/reservar/' + idVeiculo, body, config).then(function (res) {
        _this.success = true;
        _this.successMessage = 'A Reserva foi feita';
        _this.carregando = false;
      }).catch(function (error) {
        _this.error = true;
        _this.errorMessage = error.message;
        _this.carregando = false;
      });
      var r = {
        entry: {},
        reserva: {}
      };
      this.$store.dispatch('CHANGE_VISIBILITY', r);
    },
    cancelaReserva: function cancelaReserva(reserveVehicle, user) {
      var _this2 = this;

      this.carregando = true;


      var idVeiculo = reserveVehicle.veiculoSelecionado.id_reserva;
      var idUser = parseInt(user.id);
      if (reserveVehicle.veiculoSelecionado.vendedor_id === idUser || user.profile.description === 'Gerencia') {
        this.$root.axios.post('http://vendas.vipcarseminovos.com.br/api/v1/entries/cancelar_reserva/' + idVeiculo).then(function (res) {
          _this2.carregando = false;
          _this2.success = true;
          _this2.successMessage = 'A Reserva foi cancelada';
        }).catch(function (error) {
          _this2.error = true;
          _this2.carregando = false;
          _this2.errorMessage = error.message;
        });
        var r = {
          entry: {},
          reserva: {}
        };
        this.$store.dispatch('CHANGE_VISIBILITY', r);
      } else {
        alert('Você não tem permissão para cancelar esta reserva');
      }
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(64);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(64);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(64);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(64);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(64);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(64);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(65);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(65);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(65);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(65);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __defaultSingularResource */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(65);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      id: '',
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __defaultSingularResource */],
      start_date: '',
      end_date: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    __fields: function __fields() {
      return {
        start_date: {
          label: 'Data início',
          group: 1,
          component: 'masked-field',
          mask: '11/11/1111',
          list: true,
          icon: 'calendar',
          wrapperClass: 'col-lg-6',
          placeholder: 'Preencha a data',
          name: 'start_date'
        },
        end_date: {
          label: 'Data fim',
          group: 1,
          component: 'masked-field',
          mask: '11/11/1111',
          list: true,
          icon: 'calendar',
          wrapperClass: 'col-lg-6',
          placeholder: 'Preencha a data',
          name: 'end_date'
        }
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    generate: function generate() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        var url = _this.$root.API_ENDPOINT + 'account-mov-report';
        window.open(url + '?id=' + _this.id + '&start_date=' + _this.start_date + '&end_date=' + _this.end_date);
      }).catch(function () {});
    },
    openModal: function openModal(id) {
      this.id = id;
      __webpack_provided_window_dot_jQuery('.modal').modal();
    },
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this2 = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this2.searchTermIsDirty = false;
        _this2.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this3 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this3.search(_this3.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this4.$router.push('/' + _this4.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this4.models = data;
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(65);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountPlan_Api__ = __webpack_require__(124);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  name: 'tenant-form',
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$root.axios.get('account-plans/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  created: function created() {
    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountPlan_Api__["a" /* default */](this);
  },
  data: function data() {
    return {
      name: '',
      abbreviation: '',
      type: '',
      typeKey: '',
      active: '',
      isActive: false,
      readonly: false,
      name_rule: '',
      abbreviation_rule: '',
      type_rule: '',
      active_rule: '',
      type_options: [{ value: 'E', label: 'Entrada' }, { value: 'S', label: 'Saída' }],
      active_options: [{ value: 'true', label: 'SIM' }, { value: 'false', label: 'NÃO' }]
    };
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        var data = _this2._data;

        data.type = _this2._data.typeKey;
        data.active = _this2._data.isActive;

        _this2.api.create(data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/account-plans');
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/account-plans');
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Create_CreateForm__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/account-plans');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/account-plans/create');
    });
  },

  methods: {
    create: function create() {
      this.$refs.form.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.form.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.form.destroy();
    }
  },
  components: {
    AccountPlanForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Create_CreateForm___default.a
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Fields_SelectField__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Fields_SelectField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Fields_SelectField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_url_URLMatcherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Resources_AccountPlan_Api__ = __webpack_require__(124);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  name: 'tenant-form',
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$root.axios.get('account-plans/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  created: function created() {
    this.readonly = this.formReadonly;
    this.matcher = new __WEBPACK_IMPORTED_MODULE_4__services_url_URLMatcherService__["a" /* default */]();
    this.api = new __WEBPACK_IMPORTED_MODULE_6__components_Resources_AccountPlan_Api__["a" /* default */](this);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    return {
      id: '',
      name: '',
      abbreviation: '',
      type: '',
      typeKey: '',
      active: '',
      isActive: false,
      created_at: '',
      updated_at: '',
      readonly: false,
      name_rule: '',
      abbreviation_rule: '',
      type_rule: '',
      active_rule: '',
      type_options: [{ value: 'E', label: 'Entrada' }, { value: 'S', label: 'Saída' }],
      active_options: [{ value: 'true', label: 'SIM' }, { value: 'false', label: 'NÃO' }]
    };
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);

        keys.forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        var data = _this3._data;

        data.type = _this3._data.typeKey;
        data.active = _this3._data.isActive;

        _this3.api.update(_this3.id, data, function () {
          _this3.$router.push('/account-plans');
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/account-plans');
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  },
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField___default.a, SelectField: __WEBPACK_IMPORTED_MODULE_3__components_Fields_SelectField___default.a
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Edit_EditForm__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/account-plans');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/account-plans/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: 'Planos de Conta', url: '/account-plans', icon: 'list' }, { label: 'Editar', url: '/account-plans/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.form.allowEdit();
      this.$refs.form.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.form.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.form.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.form.destroy();
    }
  },
  components: {
    AccountPlanForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Edit_EditForm___default.a
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountPlan_Api__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'List',
  data: function data() {
    return {
      basePath: 'account-plans',
      models: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: 'asc',
      orderBy: 'name'
    };
  },

  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: 'name:ilike;abbreviation:ilike;type:ilike'
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.sortingService = new __WEBPACK_IMPORTED_MODULE_2__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/account-plans/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: 'Planos de conta', url: '/account-plans', icon: 'list' }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_3__components_Resources_AccountPlan_Api__["a" /* default */](this);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Edit_EditForm__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: 'Planos de Conta', url: '/account-plans', icon: 'list' }, { label: 'Detalhes', url: '/account-plans/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/account-plans');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/account-plans/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.form.allowEdit();
      this.$refs.form.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.form.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.form.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.form.destroy();
    }
  },
  components: {
    AccountPlanForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_AccountPlan_Edit_EditForm___default.a
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'BillToReceive',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    __fields: function __fields() {
      return {
        account_mov: {
          label: 'Tipo de Conta',
          component: 'entity-field',
          usingAsProvider: '/account-mov',
          usingAsLabel: 'description',
          resourceKey: 'relation_account_mov_type',
          usingAsValue: 'id',
          list: true,
          orderBy: 'account_mov_types.account_mov_type',
          icon: 'external-link',
          wrapperClass: 'col-lg-6',
          placeholder: 'Preencha o Tipo de Conta',
          name: 'account_mov'
        },
        date: {
          label: 'Data',
          group: 1,
          component: 'masked-field',
          mask: '11/11/1111',
          list: true,
          icon: 'calendar',
          wrapperClass: 'col-lg-6',
          placeholder: 'Preencha a data',
          name: 'date'
        }
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  methods: {
    mark: function mark(id, type) {
      this.id = id;
      this.type = type;
      __webpack_provided_window_dot_jQuery('.modal').modal();
    },
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        _this.$root.axios.get('/mark-as-paid', { params: {
            id: _this.id,
            date: _this.date,
            account_mov: _this.account_mov,
            type: _this.type
          } }).then(function (_ref) {
          var data = _ref.data;

          if (data.status) {
            _this.load();
            __webpack_provided_window_dot_jQuery('.modal').modal('hide');
          }
        });
      });
    },
    load: function load() {
      var _this2 = this;

      this.$root.axios.get('/vehicle-expenses-tenant', {
        params: {
          'tenant_id': localStorage.getItem('current-tenant-idkey')
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.vehicleExpenses = data.data.data;
      });
    }
  },
  mounted: function mounted() {
    this.load();
  },
  data: function data() {
    return {
      account_mov: '',
      date: '',
      id: '',
      type: '',
      vehicleExpenses: []
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'BillToReceive',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    __fields: function __fields() {
      return {
        account_mov: {
          label: 'Tipo de Conta',
          component: 'entity-field',
          usingAsProvider: '/account-mov',
          usingAsLabel: 'description',
          resourceKey: 'relation_account_mov_type',
          usingAsValue: 'id',
          list: true,
          orderBy: 'account_mov_types.account_mov_type',
          icon: 'external-link',
          wrapperClass: 'col-lg-6',
          placeholder: 'Preencha o Tipo de Conta',
          name: 'account_mov'
        },
        date: {
          label: 'Data',
          group: 1,
          component: 'masked-field',
          mask: '11/11/1111',
          list: true,
          icon: 'calendar',
          wrapperClass: 'col-lg-6',
          placeholder: 'Preencha a data',
          name: 'date'
        }
      };
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  methods: {
    mark: function mark(id, type) {
      this.id = id;
      this.type = type;
      __webpack_provided_window_dot_jQuery('.modal').modal();
    },
    save: function save() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        _this.$root.axios.get('/mark-as-paid', { params: {
            id: _this.id,
            date: _this.date,
            account_mov: _this.account_mov,
            type: _this.type
          } }).then(function (_ref) {
          var data = _ref.data;

          if (data.status) {
            _this.load();
            __webpack_provided_window_dot_jQuery('.modal').modal('hide');
          }
        });
      });
    },
    load: function load() {
      var _this2 = this;

      this.$root.axios.get('/account-mov').then(function (_ref2) {
        var data = _ref2.data;

        _this2.accounts = data.data.data;
      });

      this.$root.axios.get('/vehicle-expenses-tenant', {
        params: {
          'tenant_id': localStorage.getItem('current-tenant-idkey')
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this2.vehicleExpenses = data.data.data;
      });

      this.$root.axios.get('/account-customer').then(function (_ref4) {
        var data = _ref4.data;

        _this2.accountCustomers = data.data.data;
      });

      this.$root.axios.get('/vehicle-sale', {
        params: {
          'tenant_id': localStorage.getItem('current-tenant-idkey')
        }
      }).then(function (_ref5) {
        var data = _ref5.data;

        _this2.sales = data.data.data;
      });
    }
  },
  mounted: function mounted() {
    this.load();
  },
  data: function data() {
    return {
      account_mov: '',
      date: '',
      id: '',
      type: '',
      accounts: [],
      vehicleExpenses: [],
      accountCustomers: [],
      sales: []
    };
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metadata__ = __webpack_require__(66);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_5__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_5__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};
    __WEBPACK_IMPORTED_MODULE_5__metadata__["e" /* __fields */].forEach(function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(66);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metadata__ = __webpack_require__(66);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_5__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_5__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __WEBPACK_IMPORTED_MODULE_5__metadata__["e" /* __fields */].forEach(function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(66);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(66);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */].filter(function (field) {
      return field.list;
    });
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(66);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(67);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(67);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(67);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(67);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(67);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(67);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(68);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(68);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(68);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(68);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(68);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_4__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(68);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(70);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        if (rules[prop].indexOf('d/m/Y') < 0) {
          _this[prop + '_rule'] = rules[prop];
        }
      });
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false,
      cpf: undefined,
      type: undefined
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          if (data.duplicated) {
            alert('CPF/CNPJ Já cadastrado no sistema');
            return;
          }

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(70);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(70);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    },
    group: {
      type: Number
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (el) {
        return el.group === _this.group;
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        if (!rules[prop].indexOf('d/m/Y')) {
          _this2[prop + '_rule'] = rules[prop];
        }
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData, {
      cpf: undefined,
      type: 'pf',
      cpf_changed: false
    });
  },

  watch: {
    cpf: function cpf(v) {
      var _this3 = this;

      if (this.group === 1 && !this.cpf_changed) {
        var len = v.length === 18 ? 'pj' : 'pf';
        var f = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["debounce"])(function () {
          _this3.type = len;
          _this3.cpf_changed = true;
        }, 1000);
        f();
      }
    }
  },
  methods: {
    fetch: function fetch() {
      var _this4 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          if (key === 'cpf' && _this4.group === 1) {
            _this4[key] = data[key];
          } else {
            _this4[key] = data[key];
          }
        });

        _this4.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    destroy: function destroy() {
      var _this5 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this5.$router.push('/' + _this5.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this6 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.readonly = false;
        resolve(_this6.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form-' + _this6.group + ' [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Edit_EditForm__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExpenseForm__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExpenseForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ExpenseForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata__ = __webpack_require__(70);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }), {
    forms: function forms() {
      return [this.$refs.customFormPersonalData, this.$refs.customFormOffice, this.$refs.customFormGuaranter];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["b" /* __defaultIcon */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["a" /* __defaultSingularResource */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["e" /* __fields */];
    }
  }),
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_7__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.forms.forEach(function (form) {
        form.allowEdit();
        form.clearState();
      });
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      var _this2 = this;

      var data = {};
      var promises = [];
      this.forms.forEach(function (form) {
        promises.push(form.$validator.validateAll().then(function () {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#tab-main-form-' + form.group).css('color', '#333');
          form.__fields.forEach(function (field) {
            data[field.name] = form.$data[field.name];
          });
        }).catch(function (e) {
          __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#tab-main-form-' + form.group).css('color', 'red');
        }));
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        var errorsCount = 0;
        _this2.forms.forEach(function (form) {
          data['id'] = form.$data['id'];
          errorsCount += form.$validator.errorBag.errors.length;
        });
        if (errorsCount === 0) {
          var api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](_this2, _this2.basePath);
          api.update(data.id, data, function () {
            _this2.$router.push('/' + _this2.basePath);
          });
        }
      });
    },
    disableEdit: function disableEdit() {
      this.readonly = true;

      this.forms.forEach(function (form) {
        form.disableEdit();
      });
    },
    destroy: function destroy() {
      this.$refs.customFormPersonalData.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_2__Edit_EditForm___default.a, ExpenseForm: __WEBPACK_IMPORTED_MODULE_5__ExpenseForm___default.a
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);









/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_4_numeral___default.a.locale('pt-br');

    this.__fields = {
      payment_method_id: {
        label: 'Tipo',
        component: 'entity-field',
        usingAsProvider: '/payment-method',
        usingAsLabel: 'description',
        usingAsValue: 'id_key',
        list: true,
        icon: 'tag',
        wrapperClass: 'col-lg-3',
        placeholder: '',
        name: 'payment_method_id',
        group: 1
      },
      number: {
        label: 'Número',
        component: 'text-field',
        list: true,
        icon: 'edit',
        wrapperClass: 'col-lg-2',
        placeholder: 'Número',
        name: 'number'
      },
      value: {
        label: 'Valor',
        component: 'monetary-field',
        list: true,
        icon: 'dollar',
        wrapperClass: 'col-lg-3',
        details: true,
        placeholder: '',
        name: 'value',
        group: 1
      },
      due: {
        label: 'Vencimento',
        group: 1,
        component: 'masked-field',
        mask: '11/11/1111',
        list: true,
        icon: 'calendar',
        wrapperClass: 'col-lg-2',
        placeholder: 'Preencha a data de vencimento',
        name: 'due'
      }
    };

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_2__Api__["a" /* default */](this, this.basePath);
    this.customer_id = this.$route.params.id;
  },
  mounted: function mounted() {
    this.refresh();
  },
  data: function data() {
    return {
      numeral: __WEBPACK_IMPORTED_MODULE_4_numeral___default.a,
      customer_id: undefined,
      due: undefined,
      private_id: undefined,
      payment_method_id: undefined,
      value: undefined,
      number: undefined,
      paid: undefined,
      readonly: false,
      __fields: {},
      expenses: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }), {
    pendente: function pendente() {
      return this.expenses.filter(function (e) {
        return !e.paid;
      });
    },
    pago: function pago() {
      return this.expenses.filter(function (e) {
        return e.paid;
      });
    }
  }),
  methods: {
    markAsPaid: function markAsPaid(expense) {
      var _this = this;

      this.$root.axios.post('account-customer/' + expense.id + '/mark-as-paid').then(function () {
        _this.reset();
        _this.refresh();
      });
    },
    clearAndFocusSearch: function clearAndFocusSearch() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('[name=optional-items-search]').focus();
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    reset: function reset() {
      this.due = undefined;
      this.number = undefined;
      this.payment_method_id = undefined;
      this.value = undefined;
      this.paid = undefined;
      this.private_id = undefined;
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        if (_this2.private_id) {
          _this2.$root.axios.put('/account-customer/' + _this2.private_id, _this2._data).then(function (data) {
            _this2.reset();
            _this2.refresh();
          });
        } else {
          _this2._data.paid = false;
          _this2.$root.axios.post('/account-customer', _this2._data).then(function (data) {
            _this2.reset();
            _this2.refresh();
          });
        }
      }).catch(function () {});
    },
    refresh: function refresh() {
      var _this3 = this;

      this.$root.axios.get('/account-customer', {
        params: {
          'customer_id': this.customer_id
        }
      }).then(function (_ref) {
        var data = _ref.data;

        _this3.expenses = data.data.data;
      });
    },
    edit: function edit(expense) {
      this.private_id = expense.id;
      this.number = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(expense.number) === 'object' ? undefined : expense.number;
      this.due = expense.due;
      this.payment_method_id = expense.payment_method_id;
      this.paid = expense.paid;
      this.value = expense.value;
    },
    destroy: function destroy(id) {
      var _this4 = this;

      this.$root.axios.post('account-customer/' + id, {
        _method: 'DELETE'
      }).then(function () {
        _this4.reset();
        _this4.refresh();
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(70);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Api__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata__ = __webpack_require__(70);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_4__metadata__["a" /* __defaultSingularResource */];
    },
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_4__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_4__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_4__metadata__["c" /* __defaultResourceLabel */];
    },
    forms: function forms() {
      return [this.$refs.customFormPersonalData, this.$refs.customFormOffice, this.$refs.customFormGuaranter];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.forms.forEach(function (form) {
        form.allowEdit();
        form.clearState();
      });
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      var _this2 = this;

      var data = {};
      var promises = [];
      this.forms.forEach(function (form) {
        promises.push(form.$validator.validateAll().then(function () {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#tab-main-form-' + form.group).css('color', '#333');
          form.__fields.forEach(function (field) {
            data[field.name] = form.$data[field.name];
          });
        }).catch(function (e) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#tab-main-form-' + form.group).css('color', 'red');
        }));
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        var errorsCount = 0;
        _this2.forms.forEach(function (form) {
          data['id'] = form.$data['id'];
          errorsCount += form.$validator.errorBag.errors.length;
        });
        if (errorsCount === 0) {
          var api = new __WEBPACK_IMPORTED_MODULE_3__Api__["a" /* default */](_this2, _this2.basePath);
          api.update(data.id, data, function () {
            _this2.$router.push('/' + _this2.basePath);
          });
        }
      });
    },
    disableEdit: function disableEdit() {
      this.readonly = true;

      this.forms.forEach(function (form) {
        form.disableEdit();
      });
    },
    destroy: function destroy() {
      this.$refs.customFormPersonalData.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(71);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
    this.$root.axios.get('tenants').then(function (_ref2) {
      var data = _ref2.data;

      _this.availableTenants = data.data.data;
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false,
      availableTenants: [],
      userTenants: []
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        console.log(_this2._data);
        _this2.api.create(_this2._data, function (_ref3) {
          var data = _ref3.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(71);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(71);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.$root.axios.get('tenants').then(function (_ref2) {
      var data = _ref2.data;

      _this.availableTenants = data.data.data;
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      userTenants: [],
      availableTenants: [],
      readonly: false,
      tenant: []
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref3) {
        var data = _ref3.data;

        _this2.userTenants = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(data.tenant.data, function (f) {
          return f.tenant_id;
        });
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(71);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(71);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_4__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(71);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(72);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(72);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(72);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(72);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(72);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_4__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(72);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleEntry_Edit_EditPage__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleEntry_Edit_EditPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleEntry_Edit_EditPage__);



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ListPage',

  data: function data() {
    return {
      searchField: '',
      vehicle: {},
      vehicles: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    var id = this.$route.query.x;
    if (typeof id !== 'undefined') {
      this.$root.axios.get('vehicle-entry/' + id).then(function (_ref) {
        var data = _ref.data.data;

        _this.setVehicle(data);
      });
    }

    this.$root.axios.get('/vehicle-entry').then(function (_ref2) {
      var data = _ref2.data;

      _this.vehicles = data.data.data;

      var options = _this.vehicles.map(function (entry) {
        return entry.plate;
      });
      window.jQuertPolyfill('#search-by-plate').autocomplete({
        source: options,
        select: function select(event, ui) {
          _this.searchField = ui.item.value;
          _this.search();
        }
      });
    });
  },

  methods: {
    setVehicle: function setVehicle(vehicle) {
      this.$router.push({
        path: 'expense-vehicle-plate',
        query: {
          x: vehicle.id,
          a: 'hr8'
        }
      });
      this.vehicle = vehicle;
    },
    search: function search() {
      var _this2 = this;

      this.$root.axios.get('vehicle-entry', {
        params: {
          q: 'plate:' + this.searchField,
          sf: 'plate:='
        }
      }).then(function (_ref3) {
        var data = _ref3.data.data.data;

        if (data.length === 1) {
          _this2.setVehicle(data[0]);
        } else {
          _this2.vehicle = {};
          _this2.$router.push({
            path: 'expense-vehicle-plate'
          });
        }
      });
    }
  },
  components: {
    EditPage: __WEBPACK_IMPORTED_MODULE_0__components_Resources_VehicleEntry_Edit_EditPage___default.a
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(73);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(73);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(73);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(73);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(73);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(73);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2_numeral___default.a.locale('pt-br');
    this.__fields = {
      date: {
        label: 'Data',
        group: 1,
        component: 'masked-field',
        mask: '11/11/1111',
        list: true,
        icon: 'calendar',
        wrapperClass: 'col-lg-3',
        placeholder: 'Preencha a data',
        name: 'date',
        rules: 'required'
      },
      expense_type_id: {
        label: 'Tipo de Despesa',
        component: 'entity-field',
        usingAsProvider: '/expense-types',
        usingAsLabel: 'description',
        usingAsValue: 'id_key',
        list: true,
        icon: 'tag',
        wrapperClass: 'col-lg-4',
        placeholder: '',
        name: 'expense_type_id',
        group: 1,
        rules: 'required'
      },
      amount: {
        label: 'Valor',
        component: 'monetary-field',
        list: true,
        icon: 'dollar',
        wrapperClass: 'col-lg-2',
        details: true,
        placeholder: '',
        name: 'amount',
        group: 1,
        rules: 'required'
      },
      paid: {
        label: 'Pago',
        component: 'select-field',
        selectOptions: [{ value: true, label: 'SIM' }, { value: false, label: 'NÃO' }],
        list: true,
        icon: 'edit',
        wrapperClass: 'col-lg-3',
        placeholder: 'Pago',
        name: 'paid',
        group: 1,
        rules: 'required'
      },
      payment_date: {
        label: 'Data de Pagamento',
        group: 1,
        component: 'masked-field',
        mask: '11/11/1111',
        list: true,
        icon: 'calendar',
        wrapperClass: 'col-lg-2',
        placeholder: 'Preencha a data',
        name: 'payment_date',
        rules: ''
      },
      account_mov_id: {
        label: 'Conta',
        component: 'entity-field',
        usingAsProvider: '/account-mov',
        usingAsLabel: 'description',
        usingAsValue: 'id',
        list: true,
        icon: 'exchange',
        wrapperClass: 'col-lg-3',
        placeholder: '',
        name: 'account_mov_id',
        orderBy: 'description',
        group: 1,
        rules: 'required'
      },
      customer_id: {
        label: 'Fornecedor',
        component: 'entity-field',
        usingAsProvider: '/customers',
        usingAsLabel: 'name_with_cpf',
        usingAsValue: 'id_key',
        list: true,
        icon: 'users',
        wrapperClass: 'col-lg-7',
        placeholder: '',
        name: 'customer_id',
        orderBy: 'name',
        group: 1,
        rules: 'required'
      },
      description: {
        label: 'Observações',
        component: 'textarea-field',
        list: true,
        icon: 'external-link',
        name: 'description',
        rules: ''
      }
    };
    this.readonly = this.formEditable;
  },
  mounted: function mounted() {
    this.refresh();
  },
  data: function data() {
    return {
      numeral: __WEBPACK_IMPORTED_MODULE_2_numeral___default.a,
      date: undefined,
      expense_type_id: undefined,
      amount: undefined,
      paid: undefined,
      payment_date: undefined,
      account_mov_id: undefined,
      customer_id: undefined,
      description: undefined,
      private_id: undefined,
      readonly: false,
      __fields: {},
      expenses: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }), {
    pendente: function pendente() {
      return this.expenses.filter(function (e) {
        return !e.paid;
      });
    },
    pago: function pago() {
      return this.expenses.filter(function (e) {
        return e.paid;
      });
    }
  }),
  methods: {
    checkReadOnly: function checkReadOnly(field) {
      return field.name === 'payment_date' && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"])(this.paid) || !this.paid) || this.readonly;
    },

    isNil: function isNil() {
      return __WEBPACK_IMPORTED_MODULE_4_lodash__["isNil"];
    },
    clearAndFocusSearch: function clearAndFocusSearch() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[name=optional-items-search]').focus();
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    reset: function reset() {
      this.date = undefined;
      this.expense_type_id = undefined;
      this.amount = undefined;
      this.paid = undefined;
      this.payment_date = undefined;
      this.account_mov_id = undefined;
      this.customer_id = undefined;
      this.description = undefined;
      this.private_id = undefined;
    },
    create: function create() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        if (_this.private_id) {
          _this.$root.axios.put('/general-expenses/' + _this.private_id, _this._data).then(function (data) {
            _this.reset();
            _this.refresh();
          });
        } else {
          _this.$root.axios.post('/general-expenses', _this._data).then(function (data) {
            _this.reset();
            _this.refresh();
          });
        }
      }).catch(function () {});
    },
    refresh: function refresh() {
      var _this2 = this;

      this.$root.axios.get('/general-expenses').then(function (_ref) {
        var data = _ref.data;

        _this2.expenses = data.data.data;
      });
    },
    edit: function edit(expense) {
      this.private_id = expense.id;
      this.date = expense.date;
      this.payment_date = expense.payment_date;
      this.customer_id = expense.customer_id;
      this.expense_type_id = expense.expense_type_id;
      this.paid = expense.paid;
      this.account_mov_id = expense.account_mov_id;
      this.description = expense.description;
      this.amount = expense.amount;
    },
    destroy: function destroy(id) {
      var _this3 = this;

      this.$root.axios.post('general-expenses/' + id, {
        _method: 'DELETE'
      }).then(function () {
        _this3.reset();
        _this3.refresh();
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      loading: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  methods: {
    cancelar: function cancelar(id) {
      this.$root.axios.post('nfe-status', {
        id: id, status: 'cancelar'
      });
    },
    download: function download(id, mode) {
      this.$root.axios.post('nfe-download', { id: id, mode: mode }).then(function (_ref) {
        var data = _ref.data;

        window.open(data['uri']);
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.$root.axios.get('nfe-list').then(function (_ref2) {
      var data = _ref2.data;

      _this.loading = false;
      _this.models = data;
    });
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(74);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(74);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(74);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(74);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __defaultSingularResource */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(74);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(74);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(75);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);
    this.$root.axios.get('profiles/get-map').then(function (_ref) {
      var data = _ref.data;

      _this.map = data.data;
    });

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref2) {
      var data = _ref2.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      readonly: false,
      selectedPermissions: [],
      map: []
    }, dynamicData);
  },

  methods: {
    allSelected: function allSelected() {
      var total = 0;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(this.map, function (item, index) {
        total += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(item.actions).length;
      });

      return this.selectedPermissions.length === total;
    },
    allModuleSelected: function allModuleSelected(module) {
      var total = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.map[module].actions);
      var selected = this.selectedPermissions.filter(function (e) {
        return e.includes(module);
      });
      return total.length === selected.length;
    },
    checkallmodules: function checkallmodules() {
      var _this2 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(this.map, function (item, index) {
        return _this2.checkall(index);
      });
    },
    checkall: function checkall(module) {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(this.map, function (item, index) {
        if (index === module) {
          var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(item.actions);
          keys.forEach(function (k) {
            if (_this3.selectedPermissions.find(function (e) {
              return module + '|' + k === e;
            })) {
              _this3.selectedPermissions = _this3.selectedPermissions.filter(function (e) {
                return module + '|' + k !== e;
              });
            } else {
              _this3.selectedPermissions.push(module + '|' + k);
            }
          });
        }
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this4 = this;

      this.$validator.validateAll().then(function () {
        _this4.api.create(_this4._data, function (_ref3) {
          var data = _ref3.data;

          _this4.$router.push('/' + _this4.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this5 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this5.$router.push('/' + _this5.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this6 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.readonly = false;
        resolve(_this6.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(75);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(75);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);
    this.$root.axios.get('profiles/get-map').then(function (_ref) {
      var data = _ref.data;

      _this.map = data.data;
    });

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref2) {
      var data = _ref2.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });

      _this.readonly = _this.formReadonly;
      _this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](_this, _this.basePath);
      _this.id = _this.$route.params.id;
      _this.fetch();
    });
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      readonly: false,
      selectedPermissions: [],
      map: []
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref3) {
        var data = _ref3.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          if (key !== 'map') {
            _this2[key] = data[key];
          } else {
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data[key]).forEach(function (module) {
              data[key][module].forEach(function (action) {
                _this2.selectedPermissions.push(module + '|' + action);
              });
            });
          }
        });
      });
    },
    allSelected: function allSelected() {
      var total = 0;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(this.map, function (item, index) {
        total += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(item.actions).length;
      });

      return this.selectedPermissions.length === total;
    },
    allModuleSelected: function allModuleSelected(module) {
      var total = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.map[module].actions);
      var selected = this.selectedPermissions.filter(function (e) {
        return e.includes(module);
      });
      return total.length === selected.length;
    },
    checkallmodules: function checkallmodules() {
      var _this3 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(this.map, function (item, index) {
        return _this3.checkall(index);
      });
    },
    checkall: function checkall(module) {
      var _this4 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(this.map, function (item, index) {
        if (index === module) {
          var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(item.actions);
          keys.forEach(function (k) {
            if (_this4.selectedPermissions.find(function (e) {
              return module + '|' + k === e;
            })) {
              _this4.selectedPermissions = _this4.selectedPermissions.filter(function (e) {
                return module + '|' + k !== e;
              });
            } else {
              _this4.selectedPermissions.push(module + '|' + k);
            }
          });
        }
      });
    },
    clearState: function clearState() {},
    update: function update() {
      var _this5 = this;

      this.$validator.validateAll().then(function () {
        _this5.api.update(_this5.id, _this5._data, function () {
          _this5.$router.push('/' + _this5.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this6 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this6.$router.push('/' + _this6.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this7 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this7.readonly = false;
        resolve(_this7.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(75);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __defaultSingularResource */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(75);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_4__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(75);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = true;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(76);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/' + _this2.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/' + _this3.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(76);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.customForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Create_CreateForm___default.a
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(76);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;

      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });

    this.readonly = this.formReadonly;
    this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_6__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
      id: null,
      readonly: false
    }, dynamicData);
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function (e) {
        console.log(e);
      });
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(76);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(76);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      models: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["f" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["g" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["h" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["i" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/' + _this3.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(76);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.customForm.allowEdit();
      this.$refs.customForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.customForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_url_URLMatcherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Resources_Tenants_Api__ = __webpack_require__(134);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  name: 'tenant-form',
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$root.axios.get('tenants/rules/create').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  created: function created() {
    this.readonly = this.formEditable;
    this.matcher = new __WEBPACK_IMPORTED_MODULE_3__services_url_URLMatcherService__["a" /* default */]();
    this.api = new __WEBPACK_IMPORTED_MODULE_5__components_Resources_Tenants_Api__["a" /* default */](this);
  },
  data: function data() {
    return {
      tenant_name: '',
      address: '',
      tenant_fancy_name: '',
      phone_number: '',
      cnpj: '',
      readonly: false,
      tenant_name_rule: '',
      tenant_fancy_name_rule: '',
      phone_number_rule: '',
      cnpj_rule: '',
      address_rule: ''
    };
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this2 = this;

      this.$validator.validateAll().then(function () {
        _this2.api.create(_this2._data, function (_ref2) {
          var data = _ref2.data;

          _this2.$router.push('/tenants');
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this3 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this3.$router.push('/tenants');
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this4 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.readonly = false;
        resolve(_this4.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  },
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField___default.a
  }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Create_CreateForm__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/tenants');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/tenants/create');
    });
  },

  methods: {
    create: function create() {
      this.$refs.tenantForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.tenantForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.tenantForm.destroy();
    }
  },
  components: {
    TenantForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Create_CreateForm___default.a
  }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_url_URLMatcherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Resources_Tenants_Api__ = __webpack_require__(134);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  name: 'tenant-form',
  beforeCreate: function beforeCreate() {
    var _this = this;

    this.$root.axios.get('tenants/rules/update').then(function (_ref) {
      var data = _ref.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this[prop + '_rule'] = rules[prop];
      });
    });
  },
  created: function created() {
    this.readonly = this.formReadonly;
    this.matcher = new __WEBPACK_IMPORTED_MODULE_3__services_url_URLMatcherService__["a" /* default */]();
    this.api = new __WEBPACK_IMPORTED_MODULE_5__components_Resources_Tenants_Api__["a" /* default */](this);
    this.id = this.$route.params.id;
    this.fetch();
  },
  data: function data() {
    return {
      id: '',
      tenant_name: '',
      address: '',
      tenant_fancy_name: '',
      phone_number: '',
      cnpj: '',
      created_at: '',
      updated_at: '',
      readonly: false,
      tenant_name_rule: '',
      tenant_fancy_name_rule: '',
      phone_number_rule: '',
      cnpj_rule: '',
      address_rule: ''
    };
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      this.api.find(this.id, function (_ref2) {
        var data = _ref2.data;

        var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data);

        keys.forEach(function (key) {
          _this2[key] = data[key];
        });

        _this2.clearState();
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    update: function update() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.update(_this3.id, _this3._data, function () {
          _this3.$router.push('/tenants');
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref3) {
        var data = _ref3.data;

        _this4.$router.push('/tenants');
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  },
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField___default.a
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/tenants');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/tenants/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: 'Lojas', url: '/tenants', icon: 'building' }, { label: 'Editar', url: '/tenants/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.tenantForm.allowEdit();
      this.$refs.tenantForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.tenantForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.tenantForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.tenantForm.destroy();
    }
  },
  components: {
    TenantForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm___default.a
  }
});

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_url_URLMatcherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Resources_Tenants_Api__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(8);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'List',
  data: function data() {
    return {
      models: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: 'asc',
      orderBy: 'tenant_name'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    destroy: function destroy(id) {
      this.api.delete(id);
      this.search(this.searchTerm);
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref) {
        var data = _ref.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        sf: 'tenant_name:ilike;tenant_fancy_name:ilike;phone_number:ilike;cnpj:ilike'
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this2 = this;

    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this2.search(_this2.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this3.$router.push('/tenants/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: 'Lojas', url: '/tenants', icon: 'building' }]
    });

    this.matcher = new __WEBPACK_IMPORTED_MODULE_1__services_url_URLMatcherService__["a" /* default */]();

    this.api = new __WEBPACK_IMPORTED_MODULE_4__components_Resources_Tenants_Api__["a" /* default */](this);

    this.models = this.api.paginated(function (_ref2) {
      var data = _ref2.data;

      _this3.models = data;
    });
  }
});

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: 'Lojas', url: '/tenants', icon: 'building' }, { label: 'Detalhes', url: '/tenants/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/tenants');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/tenants/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.tenantForm.allowEdit();
      this.$refs.tenantForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.tenantForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.tenantForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.tenantForm.destroy();
    }
  },
  components: {
    TenantForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm___default.a
  }
});

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateVehicleDataForm__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Create_CreateVehicleDataForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Create_CreateVehicleDataForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(77);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null,
      showTabs: false
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* __defaultSingularResource */];
    },
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_3__metadata__["e" /* __fields */];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_3__metadata__["b" /* __defaultIcon */] }, { label: 'Criar', url: '/' + this.basePath + '/create', icon: 'check' }]
    });
  },

  methods: {
    create: function create() {
      this.$refs.formVehicleCreate.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.customForm.disableEdit();
    },
    saved: function saved() {
      this.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.customForm.destroy();
    }
  },
  components: {
    'form-vehicle-create': __WEBPACK_IMPORTED_MODULE_1__Create_CreateVehicleDataForm___default.a
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata__ = __webpack_require__(77);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    group: {
      type: Number
    },
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }), {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["e" /* __fields */];
    },
    __formFields: function __formFields() {
      var _this = this;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["filter"])(__WEBPACK_IMPORTED_MODULE_7__metadata__["e" /* __fields */], function (el) {
        return el.group === _this.group && typeof el.details === 'undefined' || el.details === false;
      });
    },
    showVehiclePanel: function showVehiclePanel() {
      return this.year.length && this.model.length && this.brand.length && this.vehicle.length;
    },
    __defaultFieldAmountSection: function __defaultFieldAmountSection() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["f" /* __defaultFieldAmountSection */];
    },
    __defaultFieldsDetail: function __defaultFieldsDetail() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["g" /* __defaultFieldsDetail */];
    },
    __defaultFieldICMSSection: function __defaultFieldICMSSection() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["h" /* __defaultFieldICMSSection */];
    },
    __defaultFieldPISSection: function __defaultFieldPISSection() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["i" /* __defaultFieldPISSection */];
    },
    __defaultFieldCOFINSSection: function __defaultFieldCOFINSSection() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["j" /* __defaultFieldCOFINSSection */];
    }
  }),
  watch: {
    year: function year(value) {
      if (value === '') {
        this.$root.bus.$emit('select-vehicle_fipe_id-outdated', {});
      } else {
        var details = value.split(' ');

        this.$root.bus.$emit('select-vehicle_fipe_id-outdated', {
          'value': value,
          query: {
            q: 'year:' + details[0] + ';brand:' + this.brand + ';model:' + this.model + ';fuel:' + details[1],
            sf: 'year:ilike;brand:ilike;model:ilike;fuel:ilike',
            _and: true
          }
        });
      }
    },
    vehicle_fipe_id: function vehicle_fipe_id(value) {
      var _this2 = this;

      if (value === '') {
        this.detailsCar = {};
      } else {
        this.$root.axios.get('vehicle-fipes/' + value).then(function (_ref) {
          var data = _ref.data;

          var vehicle = data.data;
          _this2.detailsCar = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["mapKeys"])(vehicle, function (value, key) {
            return 'detail_' + key;
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);
    this.$root.axios.get('get-config?icms_rate&icms_basetax_st_reduction&icms_basetax_modality&icms_cst&icms_origin&pis_rate&pis_cst&cofins_rate&cofins_cst').then(function (_ref2) {
      var data = _ref2.data;

      data.forEach(function (item) {
        _this3[item.key] = item.value;
      });
    }).catch(function (err) {
      alert('Ocorreu um erro ao buscar as configurações de nota fiscal');
      throw new Error(err);
    });
    this.$root.axios.get(this.basePath + '/rules/create').then(function (_ref3) {
      var data = _ref3.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this3[prop + '_rule'] = rules[prop];
      });
    });
  },
  data: function data() {
    var dynamicData = {};

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_7__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      id: 1,
      readonly: false,
      detailsCar: {}
    }, dynamicData);
  },

  methods: {
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this4 = this;

      this._data.tenant_id = localStorage.getItem('current-tenant-idkey');
      this.$validator.validateAll().then(function () {
        _this4.api.create(_this4._data, function (_ref4) {
          var data = _ref4.data;

          _this4.id = data.id_key;
          _this4.$router.push('/vehicle-entry/' + data.id + '/edit');
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this5 = this;

      this.api.delete(this.id, function (_ref5) {
        var data = _ref5.data;

        _this5.$router.push('/' + _this5.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this6 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.readonly = false;
        resolve(_this6.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_jquery___default()('.superbox').SuperBox();
    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_1__Api__["a" /* default */](this, this.basePath);
    this.$root.axios.get('entry-attachments', {
      params: {
        q: 'entry_id:' + this.$parent.$refs.customFormPersonalData.id,
        sf: 'entry_id:=',
        f: 'id;title;content;entry_id;created_at;updated_at',
        o: 'id'
      }
    }).then(function (_ref) {
      var data = _ref.data;

      _this.imageList = data.data.data;
    });
  },

  computed: {
    currentTenant: function currentTenant() {
      return localStorage.getItem('current-tenant-idkey');
    },
    showImage: function showImage() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentImage).length > 0;
    }
  },
  data: function data() {
    return {
      readonly: false,
      currentImage: {},
      selectImageName: '',
      imageList: []
    };
  },

  methods: {
    download: function download(image) {
      this.$root.axios.get('entry-attachments/' + image.id).then(function (_ref2) {
        var data = _ref2.data;

        var a = document.createElement('a');
        a.download = image.title;
        a.href = data.data.content;
        a.click();
        if (a.remove) a.remove();
      });
    },
    getExtension: function getExtension(title) {
      var lista = {
        'pdf': 'file-pdf-o',
        'doc': 'file-word-o',
        'docx': 'file-word-o',
        'xls': 'file-excel-o',
        'xlsx': 'file-excel-o',
        'mp3': 'file-sound-o',
        'wav': 'file-sound-o',
        'aiff': 'file-sound-o',
        'acc': 'file-sound-o',
        'ogg': 'file-sound-o',
        'wma': 'file-sound-o',
        'flac': 'file-sound-o',
        'pcm': 'file-sound-o',
        'zip': 'file-archive-o',
        'tar': 'file-archive-o',
        '7z': 'file-archive-o',
        'bmp': 'file-image-o',
        'exif': 'file-image-o',
        'gif': 'file-image-o',
        'ico': 'file-image-o',
        'iff': 'file-image-o',
        'jng': 'file-image-o',
        'jpeg': 'file-image-o',
        'jpg': 'file-image-o',
        'jfif': 'file-image-o',
        'pcf': 'file-image-o',
        'pcx': 'file-image-o',
        'psd': 'file-image-o',
        'tiff': 'file-image-o',
        'tif': 'file-image-o',
        'eps': 'file-image-o',
        'svg': 'file-image-o',
        'v2d': 'file-image-o',
        'vnd': 'file-image-o',
        'png': 'file-image-o',
        'webp': 'file-image-o'
      };
      var re = /(?:\.([^.]+))?$/;
      var ext = re.exec(title)[1];

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(lista).includes(ext)) {
        return lista[ext];
      } else {
        return 'file-o';
      }
    },
    appendMedia: function appendMedia(e) {
      var _this2 = this;

      var reader = new FileReader();
      var file = e.target.files[0];
      this.selectImageName = file.name;

      reader.addEventListener('load', function () {
        _this2.$root.axios.post('entry-attachments', {
          image: reader.result,
          title: file.name,
          entry_id: _this2.$parent.$refs.customFormPersonalData.id
        }).then(function (_ref3) {
          var data = _ref3.data;

          _this2.$root.axios.get('entry-attachments/' + data.data.id, {
            params: {
              'f': 'id;title;content;entry_id;created_at;updated_at'
            }
          }).then(function (_ref4) {
            var data = _ref4.data;

            _this2.imageList.push(data.data);
          });
        });
      }, false);

      reader.readAsDataURL(file);
    },
    selectImage: function selectImage(img) {
      var _this3 = this;

      this.$root.axios.get('entry-attachments/' + img.id, {
        'f': 'id;title;content;entry_id;created_at;updated_at'
      }).then(function (_ref5) {
        var data = _ref5.data;

        _this3.currentImage = data.data;
      });
    },
    deleteImage: function deleteImage(idKey) {
      var _this4 = this;

      this.$root.axios.post('entry-attachments/' + idKey, {
        '_method': 'DELETE'
      }).then(function (_ref6) {
        var data = _ref6.data;

        _this4.imageList = _this4.imageList.filter(function (e) {
          return e.id_key !== idKey;
        });
        data.type = 'success';
        data.icon = 'trash';
        _this4.currentImage = {};

        _this4.$root.bus.$emit('show-alert', data);
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this5 = this;

      this.$validator.validateAll().then(function () {
        _this5.api.create(_this5._data, function (_ref7) {
          var data = _ref7.data;

          _this5.$router.push('/' + _this5.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this6 = this;

      this.api.delete(this.id, function (_ref8) {
        var data = _ref8.data;

        _this6.$router.push('/' + _this6.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_0__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get('checklist-items').then(function (_ref) {
      var data = _ref.data;

      _this.checklistItems = data.data.data;
    });

    this.$root.axios.get('checklist-item-entries', {
      params: {
        q: 'entry_id:' + this.$parent.$refs.customFormPersonalData.id,
        sf: 'entry_id:='
      }
    }).then(function (_ref2) {
      var data = _ref2.data;

      _this.selectedChecklistItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(data.data.data, 'checklist_item_id');
    });
  },

  computed: {
    currentTenant: function currentTenant() {
      return localStorage.getItem('current-tenant-idkey');
    },
    searchedChecklistItems: function searchedChecklistItems() {
      var _this2 = this;

      return this.checklistItems.filter(function (option) {
        return option.description.toUpperCase().includes(_this2.search.toUpperCase());
      });
    },
    totalChecked: function totalChecked() {
      return this.selectedChecklistItems.length;
    },
    totalUnchecked: function totalUnchecked() {
      return this.checklistItems.length - this.selectedChecklistItems.length;
    },
    totalItems: function totalItems() {
      return this.checklistItems.length;
    }
  },
  data: function data() {
    return {
      id: null,
      readonly: false,
      detailsCar: {},
      checklistItems: [],
      selectedChecklistItems: [],
      search: ''
    };
  },

  methods: {
    clearAndFocusSearch: function clearAndFocusSearch() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[name=checklist-items-search]').focus();
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.create(_this3._data, function (_ref3) {
          var data = _ref3.data;

          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__metadata__ = __webpack_require__(77);











/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    },
    group: {
      type: Number
    }
  },
  watch: {
    full_name: function full_name(v) {
      this.vehicle_fipe_id = v;
    },
    '$route': function $route(to, from) {
      this.$parent.refreshed = false;
      this.createdFunction();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
    unidadesDiferentes: function unidadesDiferentes() {
      return Number(this.currentTenant) !== Number(this.in_tenant);
    },
    currentTenant: function currentTenant() {
      return localStorage.getItem('current-tenant-idkey');
    },
    __defaultFieldAmountSection: function __defaultFieldAmountSection() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["f" /* __defaultFieldAmountSection */];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  }), {
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_7__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["filter"])(__WEBPACK_IMPORTED_MODULE_7__metadata__["e" /* __fields */], function (el) {
        return !el.name.startsWith('detail');
      });
    }
  }),
  created: function created() {
    this.createdFunction();
  },
  data: function data() {
    var dynamicData = {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["map"])(__WEBPACK_IMPORTED_MODULE_7__metadata__["e" /* __fields */], function (field) {
      var ruleKey = field.name + '_rule';
      dynamicData[field.name] = '';
      dynamicData[ruleKey] = '';
    });

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
      id: null,
      sales: [],
      readonly: false,
      full_name: null,
      in_tenant: undefined,
      lockStateId: false
    }, dynamicData);
  },

  methods: {
    createdFunction: function createdFunction() {
      var _this = this;

      this.$root.axios.get(this.basePath + '/rules/update').then(function (_ref) {
        var data = _ref.data;

        var rules = data.data.rules;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules).forEach(function (prop, index) {
          if (prop !== 'vehicle_fipe_id') {
            _this[prop + '_rule'] = rules[prop];
          }
        });
      });

      this.readonly = this.formReadonly;
      this.api = new __WEBPACK_IMPORTED_MODULE_5__Api__["a" /* default */](this, this.basePath);
      this.id = this.$route.params.id || this.$route.query.x;
      this.fetch();
    },
    getReadonlyStateField: function getReadonlyStateField(field) {
      if (field.name === 'mean_price' || field.name === 'sale_price' || field.name === 'commission') {
        if (this.profile.map['vehicle-entries'].includes('edit-acquisition-price')) {
          return false;
        } else {
          return true;
        }
      }
    },
    checkComponentType: function checkComponentType(field) {
      if (field.editComponent) {
        return field.editComponent;
      } else {
        return field.component;
      }
    },
    emitNFE: function emitNFE() {
      var _this2 = this;

      this.$root.axios.post('vehicle-sale/emit-nfe/' + this.id).then(function (_ref2) {
        var data = _ref2.data;

        if (data.error) {
          alert('Houve um erro ao emitir a nota fiscal.');
        } else {
          _this2.sales[0].nf = data.nf_id;
          alert('Aguardando geração do DANFE. Consulte o Módulo Financeiro > Notas Fiscais para imprimir.');
        }
      });
    },
    getKeyValue: function getKeyValue(field) {
      if (field.name === 'vehicle_fipe_id') {
        return 'full_name';
      }
      return field['name'];
    },
    fetch: function fetch() {
      var _this3 = this;

      this.api.find(this.id, function (_ref3) {
        var data = _ref3.data,
            sales = _ref3.sales;

        if (sales.length) {
          _this3.lockStateId = true;
        }

        _this3.sales = sales;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
          _this3[key] = data[key];
          if (key === 'tenant_id') {
            _this3.in_tenant = data.tenant_id;
          }
        });

        _this3.clearState();
        _this3.$parent.refreshed = true;
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this5 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.readonly = false;
        resolve(_this5.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#main-form-' + _this5.group + ' [type=text]').first().focus() : '';
      });
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Edit_AttachmentForm__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Edit_AttachmentForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Edit_AttachmentForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edit_EditForm__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Edit_OptionalsForm__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Edit_OptionalsForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Edit_OptionalsForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Edit_ChecklistItemsForm__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Edit_ChecklistItemsForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Edit_ChecklistItemsForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Edit_MediaForm__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Edit_MediaForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Edit_MediaForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Edit_PendencyForm__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Edit_PendencyForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Edit_PendencyForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Edit_HistoricForm__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Edit_HistoricForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Edit_HistoricForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Edit_ExpenseForm__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Edit_ExpenseForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Edit_ExpenseForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Edit_FinancialPage__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Edit_FinancialPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Edit_FinancialPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__metadata__ = __webpack_require__(77);


















/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    },
    expenseVehiclePlate: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    currentTenant: function currentTenant() {
      return localStorage.getItem('current-tenant-idkey');
    },
    forms: function forms() {
      return [this.$refs.customFormPersonalData, this.$refs.formOptional, this.$refs.formChecklistItem];
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_vuex__["a" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }), {
    defaultIcon: function defaultIcon() {
      return __WEBPACK_IMPORTED_MODULE_14__metadata__["b" /* __defaultIcon */];
    },
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_14__metadata__["a" /* __defaultSingularResource */];
    },
    defaultResourceLabel: function defaultResourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_14__metadata__["c" /* __defaultResourceLabel */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_14__metadata__["d" /* __defaultBasePath */];
    },
    __fields: function __fields() {
      return __WEBPACK_IMPORTED_MODULE_14__metadata__["e" /* __fields */];
    }
  }),
  data: function data() {
    return {
      readonly: null,
      refreshed: false
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: '' + this.defaultResourceLabel, url: '/' + this.basePath, icon: '' + __WEBPACK_IMPORTED_MODULE_14__metadata__["b" /* __defaultIcon */] }, { label: 'Editar', url: '/' + this.basePath + '/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },
  mounted: function mounted() {
    if (this.$route.query.a) {
      __WEBPACK_IMPORTED_MODULE_11_jquery___default()('[href="#' + this.$route.query.a + '"]').click();
    }
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.forms.forEach(function (form) {
        form.allowEdit();
        form.clearState();
      });
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      var _this2 = this;

      var data = {};
      var promises = [];
      this.forms.forEach(function (form) {
        promises.push(form.$validator.validateAll().then(function () {
          __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#tab-main-form-' + form.group).css('color', '#333');
          form.__fields.forEach(function (field) {
            data[field.name] = form.$data[field.name];
          });
        }).catch(function (e) {
          __WEBPACK_IMPORTED_MODULE_11_jquery___default()('#tab-main-form-' + form.group).css('color', 'red');
        }));
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        var errorsCount = 0;
        _this2.forms.forEach(function (form) {
          errorsCount += form.$validator.errorBag.errors.length;
        });
        if (errorsCount === 0) {
          var api = new __WEBPACK_IMPORTED_MODULE_12__Api__["a" /* default */](_this2, _this2.basePath);
          data.selectedOptionalItems = _this2.$refs.formOptional.selectedOptionalItems;
          data.selectedChecklistItems = _this2.$refs.formChecklistItem.selectedChecklistItems;
          api.update(_this2.$refs.customFormPersonalData.id, data, function () {
            _this2.$router.push('/' + _this2.basePath);
          });
        }
      });
    },
    disableEdit: function disableEdit() {
      this.readonly = true;

      this.forms.forEach(function (form) {
        form.disableEdit();
      });
    },
    destroy: function destroy() {
      this.$refs.customFormPersonalData.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_3__Edit_EditForm___default.a,
    'form-media': __WEBPACK_IMPORTED_MODULE_6__Edit_MediaForm___default.a,
    'form-optional': __WEBPACK_IMPORTED_MODULE_4__Edit_OptionalsForm___default.a,
    'form-checklist-item': __WEBPACK_IMPORTED_MODULE_5__Edit_ChecklistItemsForm___default.a,
    'form-pendency': __WEBPACK_IMPORTED_MODULE_7__Edit_PendencyForm___default.a,
    'form-attachment': __WEBPACK_IMPORTED_MODULE_2__Edit_AttachmentForm___default.a,
    'form-historic': __WEBPACK_IMPORTED_MODULE_8__Edit_HistoricForm___default.a,
    'form-expense': __WEBPACK_IMPORTED_MODULE_9__Edit_ExpenseForm___default.a,
    'financial-page': __WEBPACK_IMPORTED_MODULE_10__Edit_FinancialPage___default.a
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3_numeral___default.a.locale('pt-br');
    this.__fields = {
      date: {
        label: 'Data',
        group: 1,
        component: 'masked-field',
        mask: '11/11/1111',
        list: true,
        icon: 'calendar',
        wrapperClass: 'col-lg-2',
        placeholder: 'Preencha a data',
        name: 'date'
      },
      expense_type_id: {
        label: 'Tipo de Despesa',
        component: 'entity-field',
        usingAsProvider: '/expense-types',
        usingAsLabel: 'description',
        usingAsValue: 'id_key',
        list: true,
        icon: 'tag',
        wrapperClass: 'col-lg-3',
        placeholder: '',
        name: 'expense_type_id',
        group: 1
      },
      customer_id: {
        label: 'Fornecedor',
        component: 'entity-field',
        usingAsProvider: '/customers',
        usingAsLabel: 'name_with_cpf',
        usingAsValue: 'id_key',
        list: true,
        icon: 'tag',
        wrapperClass: 'col-lg-3',
        placeholder: '',
        name: 'customer_id',
        orderBy: 'name',
        group: 1
      },
      amount: {
        label: 'Valor',
        component: 'monetary-field',
        list: true,
        icon: 'dollar',
        wrapperClass: 'col-lg-2',
        details: true,
        placeholder: '',
        name: 'amount',
        group: 1
      }
    };
    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_1__Api__["a" /* default */](this, this.basePath);
    this.entry_id = this.$parent.$refs.customFormPersonalData.id_key;
  },
  mounted: function mounted() {
    this.refresh();
  },
  data: function data() {
    return {
      numeral: __WEBPACK_IMPORTED_MODULE_3_numeral___default.a,
      entry_id: undefined,
      date: undefined,
      private_id: undefined,
      expense_type_id: undefined,
      customer_id: undefined,
      amount: undefined,
      paid: undefined,
      readonly: false,
      __fields: {},
      expenses: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  }), {
    pendente: function pendente() {
      return this.expenses.filter(function (e) {
        return !e.paid;
      });
    },
    pago: function pago() {
      return this.expenses.filter(function (e) {
        return e.paid;
      });
    },
    pendenteAtrasada: function pendenteAtrasada() {
      return this.expenses.filter(function (e) {
        return !e.paid && __WEBPACK_IMPORTED_MODULE_4_moment___default()(e.date, 'DD/MM/YYYY').isBefore(__WEBPACK_IMPORTED_MODULE_4_moment___default()());
      });
    },
    pendenteEmDia: function pendenteEmDia() {
      return this.expenses.filter(function (e) {
        return !e.paid && __WEBPACK_IMPORTED_MODULE_4_moment___default()(e.date, 'DD/MM/YYYY').isSameOrAfter(__WEBPACK_IMPORTED_MODULE_4_moment___default()());
      });
    },
    totalAmountPendenteAtrasada: function totalAmountPendenteAtrasada() {
      var total = this.pendenteAtrasada.reduce(function (total, expense) {
        var temp = Number(expense.amount.replace('.', '').replace(',', '.'));
        return total + temp;
      }, 0);

      return total;
    },
    totalAmountPendenteEmDia: function totalAmountPendenteEmDia() {
      var total = this.pendenteEmDia.reduce(function (total, expense) {
        var temp = Number(expense.amount.replace('.', '').replace(',', '.'));
        return total + temp;
      }, 0);

      return total;
    },
    totalAmountExpenses: function totalAmountExpenses() {
      return this.totalAmountPendente + this.totalAmountPago;
    },
    totalAmountPendente: function totalAmountPendente() {
      var total = this.pendente.reduce(function (total, expense) {
        var temp = Number(expense.amount.replace('.', '').replace(',', '.'));
        return total + temp;
      }, 0);

      return total;
    },
    totalAmountPago: function totalAmountPago() {
      var total = this.pago.reduce(function (total, expense) {
        var temp = Number(expense.amount.replace('.', '').replace(',', '.'));
        return total + temp;
      }, 0);

      return total;
    }
  }),
  methods: {
    clearAndFocusSearch: function clearAndFocusSearch() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('[name=optional-items-search]').focus();
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    reset: function reset() {
      this.date = undefined;
      this.customer_id = undefined;
      this.expense_type_id = undefined;
      this.amount = undefined;
      this.paid = undefined;
      this.private_id = undefined;
    },
    create: function create() {
      var _this = this;

      this.$validator.validateAll().then(function () {
        _this._data.paid = false;

        if (_this.private_id) {
          _this.$root.axios.put('/vehicle-expenses/' + _this.private_id, _this._data).then(function (data) {
            _this.reset();
            _this.refresh();
          });
        } else {
          _this.$root.axios.post('/vehicle-expenses', _this._data).then(function (data) {
            _this.reset();
            _this.refresh();
          });
        }
      }).catch(function () {});
    },
    refresh: function refresh() {
      var _this2 = this;

      this.$root.axios.get('/vehicle-expenses', {
        params: {
          'entry_id': this.entry_id
        }
      }).then(function (_ref) {
        var data = _ref.data;

        _this2.expenses = data.data.data;
      });
    },
    edit: function edit(expense) {
      this.private_id = expense.id;
      this.date = expense.date;
      this.customer_id = expense.customer_id;
      this.expense_type_id = expense.expense_type_id;
      this.paid = expense.paid;
      this.amount = expense.amount;
    },
    destroy: function destroy(id) {
      var _this3 = this;

      this.$root.axios.post('vehicle-expenses/' + id, {
        _method: 'DELETE'
      }).then(function () {
        _this3.reset();
        _this3.refresh();
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    vehicleData: function vehicleData() {
      return this.$parent.$refs.customFormPersonalData;
    },
    expenseData: function expenseData() {
      return this.$parent.$refs.expenseForm;
    },
    totalGeralResumoFinanceiro: function totalGeralResumoFinanceiro() {
      return __WEBPACK_IMPORTED_MODULE_0_numeral___default()(this.sale.price_raw).subtract(__WEBPACK_IMPORTED_MODULE_0_numeral___default()(this.expenseData.totalAmountExpenses).value()).subtract(__WEBPACK_IMPORTED_MODULE_0_numeral___default()(this.vehicleData.commission).value()).subtract(__WEBPACK_IMPORTED_MODULE_0_numeral___default()(this.vehicleData.mean_price).value());
    }
  },
  methods: {
    numeral: __WEBPACK_IMPORTED_MODULE_0_numeral___default.a,
    moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
    print: function print() {
      window.print();
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$root.axios.get('vehicle-sale/by-entry/' + this.vehicleData.id).then(function (_ref) {
      var data = _ref.data;

      if (typeof data.data !== 'undefined') {
        if (data.data.data.length === 1) {
          _this.sale = data.data.data[0];
        }
      }
    });
  },
  data: function data() {
    return {
      sale: {}
    };
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.entry_id = this.$parent.$refs.customFormPersonalData.id_key;
    this.refresh();
  },
  created: function created() {
    this.__fields = {
      date: {
        label: 'Data',
        group: 1,
        component: 'masked-field',
        mask: '11/11/1111',
        list: true,
        icon: 'calendar',
        wrapperClass: 'col-lg-2',
        placeholder: 'Preencha a data',
        name: 'date'
      },
      description: {
        label: 'Lançamento manual no histórico',
        component: 'textarea-field',
        icon: 'tag',
        wrapperClass: 'col-lg-8',
        placeholder: '',
        name: 'description',
        group: 1
      }
    };
    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_1__Api__["a" /* default */](this, this.basePath);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    currentTenant: function currentTenant() {
      return localStorage.getItem('current-tenant-idkey');
    },
    moment: function moment() {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default.a;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapState */])({
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  data: function data() {
    return {
      id: this.$parent.$refs.customFormPersonalData.id,
      private_id: null,
      entry_id: this.$parent.$refs.customFormPersonalData.id,
      readonly: false,
      date: '',
      occurrence: '',
      description: '',
      prediction_at: '',
      pendencies: [],
      __fields: {}
    };
  },

  methods: {
    concluir: function concluir(id) {
      var _this = this;

      this.$root.axios.post('/historic-vehicles/mark-as-finished/' + id).then(function (_ref) {
        var data = _ref.data;

        _this.refresh();
      });
    },
    drop: function drop(id) {
      var _this2 = this;

      this.$root.axios.post('/historic-vehicles/' + id, {
        '_method': 'DELETE'
      }).then(function (data) {
        _this2.refresh();
      });
    },
    edit: function edit(id) {
      var _this3 = this;

      this.$root.axios.get('/historic-vehicles/' + id).then(function (_ref2) {
        var data = _ref2.data;

        _this3.date = data.data.date;
        _this3.occurrence = data.data.occurrence;
        _this3.description = data.data.description;
        _this3.prediction_at = data.data.prediction_at;
        _this3.private_id = data.data.id;
      });
    },
    refresh: function refresh() {
      var _this4 = this;

      this.$root.axios.get('/historic-vehicles', {
        params: {
          'entry_id': this.$parent.$refs.customFormPersonalData.id,
          'o': 'date;id',
          's': 'desc'
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this4.pendencies = data.data.data;
      });
    },
    clearAndFocusSearch: function clearAndFocusSearch() {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('[name=optional-items-search]').focus();
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this5 = this;

      this.$validator.validateAll().then(function () {
        if (_this5.private_id) {
          _this5.$root.axios.put('/historic-vehicles/' + _this5.private_id, _this5._data).then(function (data) {
            _this5.refresh();
            _this5.private_id = null;
            _this5.date = '';
            _this5.occurrence = '';
            _this5.description = '';
            _this5.prediction_at = '';
            _this5.private_id = '';
          });
        } else {
          _this5.$root.axios.post('/historic-vehicles', _this5._data).then(function (data) {
            _this5.refresh();
          });
        }
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this6 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this6.$router.push('/' + _this6.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$route': function $route() {
      this.$forceUpdate();
    }
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_jquery___default()('.superbox').SuperBox();
    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_2__Api__["a" /* default */](this, this.basePath);
    this.$root.axios.get('entry-medias', {
      params: {
        q: 'entry_id:' + this.$parent.$refs.customFormPersonalData.id,
        sf: 'entry_id:=',
        f: 'id;thumbnail;created_at;updated_at;entry_id'
      }
    }).then(function (_ref) {
      var data = _ref.data;

      _this.imageList = data.data.data;
    });
  },

  computed: {
    currentTenant: function currentTenant() {
      return localStorage.getItem('current-tenant-idkey');
    },
    showImage: function showImage() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.currentImage).length > 0;
    }
  },
  data: function data() {
    return {
      readonly: false,
      currentImage: {},
      selectImageName: '',
      imageList: []
    };
  },

  methods: {
    appendMedia: function appendMedia(e) {
      var _this2 = this;

      var chain = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        resolve();
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash__["reduce"])(e.target.files, function (chain, file) {
        chain.then(function () {
          var reader = new FileReader();

          _this2.selectImageName = file.name;

          reader.addEventListener('load', function () {
            _this2.$root.axios.post('entry-medias', {
              image: reader.result,
              entry_id: _this2.$parent.$refs.customFormPersonalData.id
            }).then(function (_ref2) {
              var data = _ref2.data;

              _this2.$root.axios.get('entry-medias/' + data.data.id, {
                params: {
                  'f': 'entry_id;id;created_at;updated_at;thumbnail'
                }
              }).then(function (_ref3) {
                var data = _ref3.data;

                _this2.imageList.push(data.data);
              });
            });
          }, false);

          reader.readAsDataURL(file);
        });
        return chain;
      }, chain);
    },
    selectImage: function selectImage(img) {
      var _this3 = this;

      this.$root.axios.get('entry-medias/' + img.id, {
        'f': 'entry_id;id;image;create_at;updated_at'
      }).then(function (_ref4) {
        var data = _ref4.data;

        _this3.currentImage = data.data;
      });
    },
    deleteImage: function deleteImage() {
      var _this4 = this;

      this.$root.axios.post('entry-medias/' + this.currentImage.id, {
        '_method': 'DELETE'
      }).then(function (_ref5) {
        var data = _ref5.data;

        _this4.imageList = _this4.imageList.filter(function (e) {
          return e.id_key !== _this4.currentImage.id_key;
        });
        data.type = 'success';
        data.icon = 'trash';
        _this4.currentImage = {};

        _this4.$root.bus.$emit('show-alert', data);
      });
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this5 = this;

      this.$validator.validateAll().then(function () {
        _this5.api.create(_this5._data, function (_ref6) {
          var data = _ref6.data;

          _this5.$router.push('/' + _this5.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this6 = this;

      this.api.delete(this.id, function (_ref7) {
        var data = _ref7.data;

        _this6.$router.push('/' + _this6.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_0__Api__["a" /* default */](this, this.basePath);

    this.$root.axios.get('optional-items').then(function (_ref) {
      var data = _ref.data;

      _this.optionalItems = data.data.data;
    });

    this.$root.axios.get('optional-item-entries', {
      params: {
        q: 'entry_id:' + this.$parent.$refs.customFormPersonalData.id,
        sf: 'entry_id:='
      }
    }).then(function (_ref2) {
      var data = _ref2.data;

      _this.selectedOptionalItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["map"])(data.data.data, 'optional_item_id');
    });
  },

  computed: {
    currentTenant: function currentTenant() {
      return localStorage.getItem('current-tenant-idkey');
    },
    totalChecked: function totalChecked() {
      return this.selectedOptionalItems.length;
    },
    totalUnchecked: function totalUnchecked() {
      return this.optionalItems.length - this.selectedOptionalItems.length;
    },
    totalItems: function totalItems() {
      return this.optionalItems.length;
    },
    searchedOptionalItems: function searchedOptionalItems() {
      var _this2 = this;

      return this.optionalItems.filter(function (option) {
        return option.fullname.toUpperCase().includes(_this2.search.toUpperCase());
      });
    }
  },
  data: function data() {
    return {
      id: null,
      id_key: null,
      readonly: false,
      detailsCar: {},
      optionalItems: [],
      selectedOptionalItems: [],
      search: ''
    };
  },

  methods: {
    clearAndFocusSearch: function clearAndFocusSearch() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('[name=optional-items-search]').focus();
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this3 = this;

      this.$validator.validateAll().then(function () {
        _this3.api.create(_this3._data, function (_ref3) {
          var data = _ref3.data;

          _this3.$router.push('/' + _this3.basePath);
        });
      }).catch(function () {});
    },
    destroy: function destroy() {
      var _this4 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this4.$router.push('/' + _this4.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.$refs['ref_employee_assigned_id'][0].refreshOptions({
      entry_id: this.$parent.$refs.customFormPersonalData.id
    });
    this.entry_id = this.$parent.$refs.customFormPersonalData.id_key;
    this.refresh();
  },
  created: function created() {
    this.__fields = {
      date: {
        label: 'Data',
        group: 1,
        component: 'masked-field',
        mask: '11/11/1111',
        list: true,
        icon: 'calendar',
        wrapperClass: 'col-lg-6',
        placeholder: 'Preencha a data da pendência',
        name: 'date'
      },
      prediction_at: {
        label: 'Previsão',
        group: 1,
        component: 'masked-field',
        mask: '11/11/1111',
        list: true,
        icon: 'calendar',
        wrapperClass: 'col-lg-6',
        placeholder: 'Preencha a previsão de conclusão',
        name: 'prediction_at'
      },
      occurrence: {
        label: 'Ocorrência',
        component: 'text-field',
        icon: 'edit',
        wrapperClass: 'col-lg-6',
        placeholder: '',
        name: 'occurrence',
        group: 1
      },
      description: {
        label: 'Descrição',
        component: 'text-field',
        icon: 'edit',
        wrapperClass: 'col-lg-6',
        placeholder: '',
        name: 'description',
        group: 1
      },
      conclusion: {
        label: 'Descrição da Conclusão',
        component: 'textarea-field',
        icon: 'edit',
        wrapperClass: 'col-lg-12',
        placeholder: '',
        name: 'conclusion',
        group: 2
      },
      category_pendency_vehicle_id: {
        group: 1,
        label: 'Tipo de pendência',
        component: 'entity-field',
        usingAsProvider: '/categories-pendency',
        usingAsLabel: 'description',
        resourceKey: 'category_pendency_vehicle',
        usingAsValue: 'id_key',
        list: true,
        orderBy: 'category_pendency_vehicle.description',
        icon: 'tag',
        wrapperClass: 'col-lg-12',
        placeholder: 'Preencha o Tipo de pendência',
        name: 'category_pendency_vehicle_id'
      },
      employee_assigned_id: {
        group: 1,
        label: 'Atribuição para usuário',
        component: 'entity-field',
        usingAsProvider: '/employees-by-stock',
        usingAsLabel: 'name',
        resourceKey: 'assigned_employee',
        usingAsValue: 'id_key',
        list: true,
        lazy: true,
        orderBy: 'employees.name',
        icon: 'user',
        wrapperClass: 'col-lg-12',
        placeholder: 'Atribuição para usuário',
        name: 'employee_assigned_id'
      }
    };
    this.readonly = this.formEditable;
    this.api = new __WEBPACK_IMPORTED_MODULE_2__Api__["a" /* default */](this, this.basePath);
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
    __fields_group1: function __fields_group1() {
      var _this = this;

      var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.__fields);
      var result = [];
      fields.forEach(function (field) {
        if (_this.__fields[field].group === 1) {
          result.push(_this.__fields[field]);
        }
      });

      return result;
    },
    __fields_group2: function __fields_group2() {
      var _this2 = this;

      var fields = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.__fields);
      var result = [];
      fields.forEach(function (field) {
        if (_this2.__fields[field].group === 2) {
          result.push(_this2.__fields[field]);
        }
      });

      return result;
    },
    currentTenant: function currentTenant() {
      return localStorage.getItem('current-tenant-idkey');
    },
    moment: function moment() {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default.a;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    user: function user(state) {
      return state.user;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  data: function data() {
    return {
      id: this.$parent.$refs.customFormPersonalData.id,
      private_id: undefined,
      entry_id: this.$parent.$refs.customFormPersonalData.id,
      readonly: false,
      date: '',
      occurrence: '',
      description: '',
      prediction_at: '',
      conclusion: undefined,
      category_pendency_vehicle_id: undefined,
      employee_assigned_id: undefined,
      pendencies: [],
      __fields: {}
    };
  },

  methods: {
    openModal: function openModal(id) {
      this.conclusion = undefined;
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#modal-pendency').data('pendency_id', id).modal('show');
    },
    concluir: function concluir() {
      var _this3 = this;

      this.$root.axios.post('/pendency-vehicles/mark-as-finished/' + __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#modal-pendency').data('pendency_id'), {
        conclusion: this.conclusion
      }).then(function (_ref) {
        var data = _ref.data;

        _this3.refresh();
        __WEBPACK_IMPORTED_MODULE_3_jquery___default()('#modal-pendency').data('pendency_id', undefined).modal('hide');
      });
    },
    drop: function drop(id) {
      var _this4 = this;

      this.$root.axios.post('/pendency-vehicles/' + id, {
        '_method': 'DELETE'
      }).then(function (data) {
        _this4.refresh();
      });
    },
    edit: function edit(id) {
      var _this5 = this;

      this.$root.axios.get('/pendency-vehicles/' + id).then(function (_ref2) {
        var data = _ref2.data;

        _this5.date = data.data.date;
        _this5.occurrence = data.data.occurrence;
        _this5.description = data.data.description;
        _this5.prediction_at = data.data.prediction_at;
        _this5.private_id = data.data.id;
        _this5.employee_assigned_id = data.data.assigned_employee.id_key;
        _this5.category_pendency_vehicle_id = data.data.category_pendency_vehicle.id_key;
      });
    },
    refresh: function refresh() {
      var _this6 = this;

      this.$root.axios.get('/pendency-vehicles', {
        params: {
          'entry_id': this.$parent.$refs.customFormPersonalData.id,
          'o': 'id'
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this6.pendencies = data.data.data;
      });
    },
    clearAndFocusSearch: function clearAndFocusSearch() {
      __WEBPACK_IMPORTED_MODULE_3_jquery___default()('[name=optional-items-search]').focus();
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this7 = this;

      this.$validator.validateAll().then(function () {
        if (_this7.private_id) {
          _this7.$root.axios.put('/pendency-vehicles/' + _this7.private_id, _this7._data).then(function (data) {
            _this7.refresh();
            _this7.private_id = undefined;
            _this7.date = '';
            _this7.occurrence = '';
            _this7.description = '';
            _this7.prediction_at = '';
            _this7.category_pendency_vehicle_id = undefined;
            _this7.employee_assigned_id = undefined;
          });
        } else {
          _this7.$root.axios.post('/pendency-vehicles', _this7._data).then(function (data) {
            _this7.refresh();
          });
        }
      }).catch(function (e) {
        return console.log(e);
      });
    },
    destroy: function destroy() {
      var _this8 = this;

      this.api.delete(this.id, function (_ref4) {
        var data = _ref4.data;

        _this8.private_id = undefined;
        _this8.date = '';
        _this8.occurrence = '';
        _this8.description = '';
        _this8.prediction_at = '';
        _this8.category_pendency_vehicle_id = undefined;
        _this8.employee_assigned_id = undefined;
        _this8.$router.push('/' + _this8.basePath);
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      this.readonly = false;
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_numeral__);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    entry_id: function entry_id(newId) {
      var _this = this;

      if (newId === '') {
        return;
      }

      this.$root.axios.get('vehicle-expenses/', {
        params: {
          entry_id: newId
        }
      }).then(function (_ref) {
        var data = _ref.data.data.data;

        _this.expenses = data;
      });
    }
  },
  name: 'tenant-form',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0_numeral___default.a.locale('pt-br');
  },

  computed: {
    currentTenant: function currentTenant() {
      return window.localStorage.getItem('current-tenant-idkey');
    }
  },
  methods: {
    save: function save() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.$root.axios.post('vehicle-entry/return-vehicle', {
            entry_id: _this2.entry_id,
            customer_id: _this2.customer_id
          }).then(function () {
            _this2.$router.push('/vehicle-entry');
          });
        }
      });
    }
  },
  data: function data() {
    return {
      entry_id: undefined,
      customer_id: undefined,
      expenses: []
    };
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleEntry_Edit_ReturnForm__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleEntry_Edit_ReturnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleEntry_Edit_ReturnForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null,
      filhocarregado: false
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/vehicle-sale');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/vehicle-sale/create');
    });
  },

  methods: {
    carregado: function carregado() {
      this.filhocarregado = true;
    },
    create: function create() {
      this.$refs.tenantForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.tenantForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.tenantForm.destroy();
    }
  },
  components: {
    TenantForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleEntry_Edit_ReturnForm___default.a
  }
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__metadata__ = __webpack_require__(77);










/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapState */])({
    user: function user(state) {
      return state.user;
    },
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  data: function data() {
    return {
      models: [],
      templates: [],
      basePath: __WEBPACK_IMPORTED_MODULE_6__metadata__["d" /* __defaultBasePath */],
      icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */],
      resourceLabel: __WEBPACK_IMPORTED_MODULE_6__metadata__["c" /* __defaultResourceLabel */],
      fieldsTable: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["k" /* __defaultSortBy */],
      orderBy: __WEBPACK_IMPORTED_MODULE_6__metadata__["l" /* __defaultOrderBy */],
      singularResource: __WEBPACK_IMPORTED_MODULE_6__metadata__["a" /* __defaultSingularResource */]
    };
  },

  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    }
  },
  methods: {
    enviaParaVenda: function enviaParaVenda(model) {
      var _this = this;

      if (model.state_id === 3) {
        var token = localStorage.token;
        var config = {
          headers: {
            'Authorization': 'bearer' + token
          }
        };
        this.$root.axios.get('http://vendas.vipcarseminovos.com.br/api/v1/entries/estoque/', config).then(function (_ref) {
          var data = _ref.data;

          var respServer = data.data;
          _this.matchReserva(respServer, model);
        }).catch(function (error) {
          return alert('error: ' + error.message);
        });
      } else {
        this.$router.push('vehicle-sale/create/' + model.id);
      }
    },
    matchReserva: function matchReserva(respServer, model) {
      var _this2 = this;

      var veiculoSelecionado = model;
      var all = respServer;
      all.map(function (veiculo) {
        console.log('ok' + veiculo.id);
        if (veiculo.plate === veiculoSelecionado.plate) {
          console.log('---------OK_------------------------------------------------------------------------------------------------');

          var idUserAtual = parseInt(localStorage.id);
          console.log('ij: ' + idUserAtual);
          var idUserReserva = parseInt(veiculo.vendedor_id);
          console.log('ij: ' + idUserReserva);

          if (idUserAtual === idUserReserva) {
            _this2.$router.push('vehicle-sale/create/' + veiculo.id);
          } else {
            alert('Somente o usuário que reservou pode iniciar a venda.');
          }
        }
      });
    },
    showTemplate: function showTemplate(id, entryId) {
      this.$root.axios.get('entries/document/' + id + '/' + localStorage.getItem('current-tenant-idkey') + '/' + entryId).then(function (_ref2) {
        var data = _ref2.data;

        var a = document.createElement('a');
        a.download = data.data.name + '.docx';
        a.href = data.data.raw;
        a.click();
        if (a.remove) a.remove();
      });
    },
    destroy: function destroy(id) {
      if (confirm('Deseja realmente excluir esta entrada?')) {
        this.api.delete(id);
        this.search(this.searchTerm);
      }
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash__["debounce"])(function (term) {
      var _this3 = this;

      var callback = function callback(_ref3) {
        var data = _ref3.data;

        _this3.searchTermIsDirty = false;
        _this3.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: 'fipe_brand:' + term + ';fipe_model:' + term + ';color:' + term + ';fabrication_year:' + term + ';plate:' + term + ';tenant_id:' + localStorage.getItem('current-tenant-idkey'),
        'only-available': true,
        sf: __WEBPACK_IMPORTED_MODULE_6__metadata__["m" /* __listSearchFields */]
      }, callback);
    }, 500)
  },
  created: function created() {
    var _this4 = this;

    this.fieldsTable = __WEBPACK_IMPORTED_MODULE_6__metadata__["n" /* __defaultFieldList */];
    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this4.search(_this4.searchTerm);
    });
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$root.axios.get('templates', {
      params: {
        'q': 'description:ENTRADA',
        'sf': 'description',
        'f': 'id;name;description;created_at;updated_at'
      }
    }).then(function (_ref4) {
      var data = _ref4.data;

      _this5.templates = data.data.data;
    });
    this.$root.bus.$on('breadcrumb-search', function () {
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this5.$router.push('/' + _this5.basePath + '/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: __WEBPACK_IMPORTED_MODULE_6__metadata__["b" /* __defaultIcon */] }]
    });

    this.api = new __WEBPACK_IMPORTED_MODULE_4__Api__["a" /* default */](this, this.basePath);

    this.models = this.api.paginated(function (_ref5) {
      var data = _ref5.data;

      _this5.models = data;
    });
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Api__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metadata__ = __webpack_require__(77);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },

  computed: {
    defaultSingularResource: function defaultSingularResource() {
      return __WEBPACK_IMPORTED_MODULE_4__metadata__["a" /* __defaultSingularResource */];
    },
    icon: function icon() {
      return __WEBPACK_IMPORTED_MODULE_4__metadata__["b" /* __defaultIcon */];
    },
    basePath: function basePath() {
      return __WEBPACK_IMPORTED_MODULE_4__metadata__["d" /* __defaultBasePath */];
    },
    resourceLabel: function resourceLabel() {
      return __WEBPACK_IMPORTED_MODULE_4__metadata__["c" /* __defaultResourceLabel */];
    },
    forms: function forms() {
      return [this.$refs.customFormPersonalData, this.$refs.customFormOffice, this.$refs.customFormGuaranter];
    }
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: this.resourceLabel, url: '/' + this.basePath, icon: this.icon }, { label: 'Detalhes', url: '/' + this.basePath + '/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/' + _this.basePath);
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/' + _this.basePath + '/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.forms.forEach(function (form) {
        form.allowEdit();
        form.clearState();
      });
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      var _this2 = this;

      var data = {};
      var promises = [];
      this.forms.forEach(function (form) {
        promises.push(form.$validator.validateAll().then(function () {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#tab-main-form-' + form.group).css('color', '#333');
          form.__fields.forEach(function (field) {
            data[field.name] = form.$data[field.name];
          });
        }).catch(function (e) {
          __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#tab-main-form-' + form.group).css('color', 'red');
        }));
      });

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        var errorsCount = 0;
        _this2.forms.forEach(function (form) {
          data['id'] = form.$data['id'];
          errorsCount += form.$validator.errorBag.errors.length;
        });
        if (errorsCount === 0) {
          var api = new __WEBPACK_IMPORTED_MODULE_3__Api__["a" /* default */](_this2, _this2.basePath);
          api.update(data.id, data, function () {
            _this2.$router.push('/' + _this2.basePath);
          });
        }
      });
    },
    disableEdit: function disableEdit() {
      this.readonly = true;

      this.forms.forEach(function (form) {
        form.disableEdit();
      });
    },
    destroy: function destroy() {
      this.$refs.customFormPersonalData.destroy();
    }
  },
  components: {
    CustomForm: __WEBPACK_IMPORTED_MODULE_1__Edit_EditForm___default.a
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_url_URLMatcherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Resources_VehicleSale_Api__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_numeral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_numeral__);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    formEditable: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    values_payments: function values_payments() {
      this.atualizaValorDistribuido();
    },
    discount: function discount() {
      this.atualizaValorFinal();
    },
    entry_id: function entry_id(newId) {
      var _this = this;

      if (newId === '') {
        this.sale_price_formatted = null;
        this.discount_max = null;
        return;
      }
      this.$root.axios.get('vehicle-entry/' + newId).then(function (_ref) {
        var data = _ref.data;

        _this.sale_price_formatted = data.data.sale_price_formatted;
        _this.final_price_label = _this.sale_price_formatted;
        _this.price = data.data.sale_price;
        _this.discount_max = data.data.discount_margin_formatted;
        _this.discount_max_raw = data.data.discount_margin;
      });
    }
  },
  name: 'tenant-form',
  computed: {
    distributed_ok: function distributed_ok() {
      var v1 = String(this.distributed_value).substr(0, String(this.distributed_value).indexOf(',')).replace('.', '').replace(',', '').replace('R$', '');
      var v2 = String(this.price).substr(0, String(this.price).indexOf(',')).replace('R$', '').replace(',', '').replace('.', '');
      var v3 = String(this.discount).replace('R$', '').replace(',', '').replace('.', '');

      return Number(v1) + Number(v3) >= Number(v2);
    },
    currentTenant: function currentTenant() {
      return window.localStorage.getItem('current-tenant-idkey');
    }
  },
  beforeCreate: function beforeCreate() {
    var _this2 = this;

    if (this.$route.params.entry_id) {
      this.$root.axios.get('/decrypt', {
        params: {
          payload: this.$route.params.entry_id
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        _this2.entry_id = data.key;
      });
    }
    this.$root.axios.get('vehicle-sale/rules/create').then(function (_ref3) {
      var data = _ref3.data;

      var rules = data.data.rules;
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(rules);
      keys.forEach(function (prop, index) {
        _this2[prop + '_rule'] = rules[prop];
      });
    });
    this.$root.axios.get('payment-method').then(function (_ref4) {
      var data = _ref4.data;

      _this2.payment_methods = data.data.data;
    });
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_7_numeral___default.a.locale('pt-br');

    this.$emit('carregado');
    this.readonly = this.formEditable;
    this.matcher = new __WEBPACK_IMPORTED_MODULE_3__services_url_URLMatcherService__["a" /* default */]();
    this.api = new __WEBPACK_IMPORTED_MODULE_5__components_Resources_VehicleSale_Api__["a" /* default */](this);
  },
  data: function data() {
    return {
      customer_id: null,
      price: null,
      sale_price_formatted: null,
      entry_id: null,
      discount_max: null,
      discount_max_raw: null,
      discount: 0,
      invalid_discount: false,
      final_price_label: null,
      payment_methods: [],
      payment_methods_selected: [],
      values_payments: [],
      date_payments: [],
      details_payments: [],
      distributed_value: 0
    };
  },

  methods: {
    atualizaValorFinal: function atualizaValorFinal() {
      if (this.price) {
        var discount = String(this.discount).replace('R$', '').replace(',', '').replace('.', '');
        var total = this.distributed_value_raw - Number(discount);
        this.final_price_label = __WEBPACK_IMPORTED_MODULE_7_numeral___default()(total).format('$ 0,0.00');
      }
    },
    atualizaValorDistribuido: function atualizaValorDistribuido() {
      var _this3 = this;

      var values = [];
      this.values_payments.forEach(function (item) {
        values.push(Number(item.replace('.', '').replace(',', '.')));
      });
      var value = values.reduce(function (sum, current) {
        return sum + current;
      }, 0);
      if (!isNaN(value)) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash__["debounce"])(function () {
          _this3.distributed_value = __WEBPACK_IMPORTED_MODULE_7_numeral___default()(value).format('$ 0,0.00');
          _this3.distributed_value_raw = value;
          _this3.atualizaValorFinal();
        }, 1)();
      }
    },
    selectPayment: function selectPayment(index) {
      this.values_payments[index] = '';
      this.date_payments[index] = null;
      this.details_payments[index] = null;
      this.atualizaValorDistribuido();
    },
    validateDiscount: function validateDiscount(event) {
      var discount = Number(event.target.value.replace('.', '').replace(',', '.'));

      if (discount > this.discount_max_raw.replace('.', '').replace(',', '.') || discount > this.distributed_value_raw) {
        this.invalid_discount = true;
        this.discount = 0;
        return;
      }

      this.invalid_discount = false;
    },
    clearState: function clearState() {
      this.errors.clear();
      this.fields.reset();
    },
    create: function create() {
      var _this4 = this;

      if (!this.discount) {
        this.discount = 0;
      }
      var data = this._data;
      data['values_payments'].map(function (item) {
        return item.replace('.', '').replace(',', '.');
      });
      this.$validator.validateAll().then(function () {
        _this4.api.create(data, function (_ref5) {
          var data = _ref5.data;

          _this4.$router.push('/vehicle-sale');
        });
      }).catch(function (errors) {});
    },
    destroy: function destroy() {
      var _this5 = this;

      this.api.delete(this.id, function (_ref6) {
        var data = _ref6.data;

        _this5.$router.push('/vehicle-sale');
      });
    },
    disableEdit: function disableEdit() {
      this.fetch();
      this.readonly = true;
    },
    allowEdit: function allowEdit() {
      var _this6 = this;

      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this6.readonly = false;
        resolve(_this6.readonly);
      }).then(function (readonly) {
        !readonly ? __WEBPACK_IMPORTED_MODULE_4_jquery___default()('#main-form [type=text]').first().focus() : '';
      });
    }
  },
  components: {
    TextField: __WEBPACK_IMPORTED_MODULE_2__components_Fields_TextField___default.a
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleSale_Create_CreateForm__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleSale_Create_CreateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleSale_Create_CreateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null,
      filhocarregado: false
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/vehicle-sale');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/vehicle-sale/create');
    });
  },

  methods: {
    carregado: function carregado() {
      this.filhocarregado = true;
    },
    create: function create() {
      this.$refs.tenantForm.create();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.tenantForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.tenantForm.destroy();
    }
  },
  components: {
    TenantForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_VehicleSale_Create_CreateForm___default.a
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Show',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/tenants');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/tenants/create');
    });

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: 'Lojas', url: '/tenants', icon: 'building' }, { label: 'Editar', url: '/tenants/' + this.$route.params.id + '/edit', icon: 'edit' }]
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.tenantForm.allowEdit();
      this.$refs.tenantForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.tenantForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.tenantForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.tenantForm.destroy();
    }
  },
  components: {
    TenantForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm___default.a
  }
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_url_URLMatcherService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Resources_VehicleSale_Api__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'List',
  data: function data() {
    return {
      models: [],
      searchTerm: '',
      searchTermIsDirty: false,
      sortBy: 'desc',
      orderBy: 'created_at',
      templates: [],
      verified: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    moment: function moment() {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default.a;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapState */])({
    authenticated: function authenticated(state) {
      return state.user.authenticated;
    },
    token: function token(state) {
      return state.user.token;
    },
    profile: function profile(state) {
      return state.user.profile;
    }
  })),
  watch: {
    searchTerm: function searchTerm(term) {
      this.searchTermIsDirty = true;
      this.search(term);
    },
    $route: function $route() {
      console.log(this);
      this.mountMethod();
    }
  },
  methods: {
    homologarVenda: function homologarVenda(model) {
      this.$root.axios.post('/vehicle-sale/' + model.id_key + '/verify').then(function () {
        alert('Venda Homologada com Sucesso!');
        model.verified = true;
      });
    },
    destroy: function destroy(id) {
      if (confirm('Deseja realmente Estornar esta venda?')) {
        this.api.delete(id);
        this.search(this.searchTerm);
      }
    },
    showTemplate: function showTemplate(id, saleId) {
      this.$root.axios.get('/vehicle-sale/contract/' + id + '/' + saleId).then(function (_ref) {
        var data = _ref.data;

        var a = document.createElement('a');
        a.download = data.data.name + '.docx';
        a.href = data.data.raw;
        a.click();
        if (a.remove) a.remove();
      });
    },

    search: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["debounce"])(function (term) {
      var _this = this;

      var callback = function callback(_ref2) {
        var data = _ref2.data;

        _this.searchTermIsDirty = false;
        _this.models = data;
      };

      this.api.useSortService(this.sortingService).performSearch({
        q: term,
        tenant_id: localStorage.getItem('current-tenant-idkey'),
        sf: 'customer.name:ilike;customer.cpf:ilike;entry.fipe_vehicle:ilike;entry.plate:ilike',
        verified: this.verified
      }, callback);
    }, 500),
    mountMethod: function mountMethod() {
      var _this2 = this;

      this.verified = this.$route.query.verified;
      this.$root.axios.get('templates', {
        params: {
          'q': 'description:SAIDA',
          'sf': 'description',
          'f': 'id;name;description;created_at;updated_at'
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        _this2.templates = data.data.data;
      });

      this.$root.bus.$on('breadcrumb-search', function () {
        __WEBPACK_IMPORTED_MODULE_5_jquery___default()('#search-field').first().focus();
      });

      this.$root.bus.$on('breadcrumb-add', function () {
        _this2.$router.push('/vehicle-sale/create');
      });

      this.$root.bus.$emit('push-breadcrumb', {
        stack: [{ label: 'Saídas', url: '/vehicle-sale', icon: 'sign-out' }]
      });

      this.matcher = new __WEBPACK_IMPORTED_MODULE_1__services_url_URLMatcherService__["a" /* default */]();

      this.api = new __WEBPACK_IMPORTED_MODULE_4__components_Resources_VehicleSale_Api__["a" /* default */](this);

      this.models = this.api.paginated(function (_ref4) {
        var data = _ref4.data;

        _this2.models = data;
      }, this.verified);
    }
  },
  created: function created() {
    var _this3 = this;

    this.sortingService = new __WEBPACK_IMPORTED_MODULE_3__services_sorting_sortingService__["a" /* default */](this, this.orderBy, this.sortBy, function () {
      _this3.search(_this3.searchTerm);
    });
  },
  mounted: function mounted() {
    this.mountMethod();
  }
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ShowPage',
  props: {
    formReadonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      readonly: null
    };
  },
  created: function created() {
    var _this = this;

    this.readonly = this.formReadonly;

    this.$root.bus.$emit('push-breadcrumb', {
      stack: [{ label: 'Lojas', url: '/tenants', icon: 'building' }, { label: 'Detalhes', url: '/tenants/' + this.$route.params.id + '/show', icon: 'th' }]
    });

    this.$root.bus.$on('breadcrumb-search', function () {
      new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this.$router.push('/tenants');
        resolve();
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_2_jquery___default()('#search-field').first().focus();
      });
    });

    this.$root.bus.$on('breadcrumb-add', function () {
      _this.$router.push('/tenants/create');
    });
  },

  methods: {
    allowEdit: function allowEdit() {
      this.readonly = false;
      this.$refs.tenantForm.allowEdit();
      this.$refs.tenantForm.clearState();
    },
    saved: function saved() {
      this.disableEdit();
    },
    update: function update() {
      this.$refs.tenantForm.update();
    },
    disableEdit: function disableEdit() {
      this.readonly = true;
      this.$refs.tenantForm.disableEdit();
    },
    destroy: function destroy() {
      this.$refs.tenantForm.destroy();
    }
  },
  components: {
    TenantForm: __WEBPACK_IMPORTED_MODULE_1__components_Resources_Tenants_Edit_EditForm___default.a
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tenants: [],
      vehicles: [],
      search: undefined,
      current: localStorage.getItem('current-tenant-idkey')
    };
  },
  created: function created() {
    var _this = this;

    this.$root.axios.get('/available-tenants-to-transfer').then(function (_ref) {
      var data = _ref.data;

      _this.tenants = data.data.data;
    });
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$root.axios.get('http://vendas.vipcarseminovos.com.br/api/v1/entries/searchEntry').then(function (_ref2) {
      var data = _ref2.data;

      _this2.vehicles = data.data;

      var options = _this2.vehicles.map(function (entry) {
        console.log();
        var date = __WEBPACK_IMPORTED_MODULE_2_moment___default()(entry.created_at, 'YYYY-MM-DD').format('DD/MM/YYYY');
        return 'Placa:' + entry.plate + ', Entrada: ' + date;
      });
      window.jQuertPolyfill('#search-fld').autocomplete({
        source: options,
        select: function select(event, ui) {
          var selectedVehicle = null;
          var allVehicles = _this2.vehicles;
          allVehicles.filter(function (item) {
            if (ui.item.value.match(item.plate)) {
              selectedVehicle = item;
            }
          });

          _this2.$router.push('/vehicle-entry/' + selectedVehicle.id + '/edit');
          _this2.$router.push({ name: 'VehicleEntryEdit'
          });
          _this2.search = undefined;
        }
      });
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])('user', ['logout', 'login']), {
    logoutUser: function logoutUser() {
      this.logout(this.$router);
    },
    doLogin: function doLogin(loginReponse) {
      var _this3 = this;

      var profile = JSON.parse(localStorage.getItem('profile'));
      this.$root.axios.get('profiles/' + profile.id, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (_ref3) {
        var data = _ref3.data;

        loginReponse.profile = data.data;
        _this3.login({
          'token': localStorage.getItem('token'),
          'profile': loginReponse.profile,
          'user': {
            created_at: localStorage.getItem('created_at'),
            name: localStorage.getItem('userName'),
            email: localStorage.getItem('email')
          }
        });
        window.localStorage.setItem('current-tenant-idkey', _this3.current);
        _this3.$root.bus.$emit('logged');
        window.location.reload();
      });
    }
  })
});

/***/ }),
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */,
/* 834 */,
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 238,
	"./af.js": 238,
	"./ar": 245,
	"./ar-dz": 239,
	"./ar-dz.js": 239,
	"./ar-kw": 240,
	"./ar-kw.js": 240,
	"./ar-ly": 241,
	"./ar-ly.js": 241,
	"./ar-ma": 242,
	"./ar-ma.js": 242,
	"./ar-sa": 243,
	"./ar-sa.js": 243,
	"./ar-tn": 244,
	"./ar-tn.js": 244,
	"./ar.js": 245,
	"./az": 246,
	"./az.js": 246,
	"./be": 247,
	"./be.js": 247,
	"./bg": 248,
	"./bg.js": 248,
	"./bm": 249,
	"./bm.js": 249,
	"./bn": 250,
	"./bn.js": 250,
	"./bo": 251,
	"./bo.js": 251,
	"./br": 252,
	"./br.js": 252,
	"./bs": 253,
	"./bs.js": 253,
	"./ca": 254,
	"./ca.js": 254,
	"./cs": 255,
	"./cs.js": 255,
	"./cv": 256,
	"./cv.js": 256,
	"./cy": 257,
	"./cy.js": 257,
	"./da": 258,
	"./da.js": 258,
	"./de": 261,
	"./de-at": 259,
	"./de-at.js": 259,
	"./de-ch": 260,
	"./de-ch.js": 260,
	"./de.js": 261,
	"./dv": 262,
	"./dv.js": 262,
	"./el": 263,
	"./el.js": 263,
	"./en-SG": 264,
	"./en-SG.js": 264,
	"./en-au": 265,
	"./en-au.js": 265,
	"./en-ca": 266,
	"./en-ca.js": 266,
	"./en-gb": 267,
	"./en-gb.js": 267,
	"./en-ie": 268,
	"./en-ie.js": 268,
	"./en-il": 269,
	"./en-il.js": 269,
	"./en-nz": 270,
	"./en-nz.js": 270,
	"./eo": 271,
	"./eo.js": 271,
	"./es": 274,
	"./es-do": 272,
	"./es-do.js": 272,
	"./es-us": 273,
	"./es-us.js": 273,
	"./es.js": 274,
	"./et": 275,
	"./et.js": 275,
	"./eu": 276,
	"./eu.js": 276,
	"./fa": 277,
	"./fa.js": 277,
	"./fi": 278,
	"./fi.js": 278,
	"./fo": 279,
	"./fo.js": 279,
	"./fr": 282,
	"./fr-ca": 280,
	"./fr-ca.js": 280,
	"./fr-ch": 281,
	"./fr-ch.js": 281,
	"./fr.js": 282,
	"./fy": 283,
	"./fy.js": 283,
	"./ga": 284,
	"./ga.js": 284,
	"./gd": 285,
	"./gd.js": 285,
	"./gl": 286,
	"./gl.js": 286,
	"./gom-latn": 287,
	"./gom-latn.js": 287,
	"./gu": 288,
	"./gu.js": 288,
	"./he": 289,
	"./he.js": 289,
	"./hi": 290,
	"./hi.js": 290,
	"./hr": 291,
	"./hr.js": 291,
	"./hu": 292,
	"./hu.js": 292,
	"./hy-am": 293,
	"./hy-am.js": 293,
	"./id": 294,
	"./id.js": 294,
	"./is": 295,
	"./is.js": 295,
	"./it": 297,
	"./it-ch": 296,
	"./it-ch.js": 296,
	"./it.js": 297,
	"./ja": 298,
	"./ja.js": 298,
	"./jv": 299,
	"./jv.js": 299,
	"./ka": 300,
	"./ka.js": 300,
	"./kk": 301,
	"./kk.js": 301,
	"./km": 302,
	"./km.js": 302,
	"./kn": 303,
	"./kn.js": 303,
	"./ko": 304,
	"./ko.js": 304,
	"./ku": 305,
	"./ku.js": 305,
	"./ky": 306,
	"./ky.js": 306,
	"./lb": 307,
	"./lb.js": 307,
	"./lo": 308,
	"./lo.js": 308,
	"./lt": 309,
	"./lt.js": 309,
	"./lv": 310,
	"./lv.js": 310,
	"./me": 311,
	"./me.js": 311,
	"./mi": 312,
	"./mi.js": 312,
	"./mk": 313,
	"./mk.js": 313,
	"./ml": 314,
	"./ml.js": 314,
	"./mn": 315,
	"./mn.js": 315,
	"./mr": 316,
	"./mr.js": 316,
	"./ms": 318,
	"./ms-my": 317,
	"./ms-my.js": 317,
	"./ms.js": 318,
	"./mt": 319,
	"./mt.js": 319,
	"./my": 320,
	"./my.js": 320,
	"./nb": 321,
	"./nb.js": 321,
	"./ne": 322,
	"./ne.js": 322,
	"./nl": 324,
	"./nl-be": 323,
	"./nl-be.js": 323,
	"./nl.js": 324,
	"./nn": 325,
	"./nn.js": 325,
	"./pa-in": 326,
	"./pa-in.js": 326,
	"./pl": 327,
	"./pl.js": 327,
	"./pt": 328,
	"./pt-br": 180,
	"./pt-br.js": 180,
	"./pt.js": 328,
	"./ro": 329,
	"./ro.js": 329,
	"./ru": 330,
	"./ru.js": 330,
	"./sd": 331,
	"./sd.js": 331,
	"./se": 332,
	"./se.js": 332,
	"./si": 333,
	"./si.js": 333,
	"./sk": 334,
	"./sk.js": 334,
	"./sl": 335,
	"./sl.js": 335,
	"./sq": 336,
	"./sq.js": 336,
	"./sr": 338,
	"./sr-cyrl": 337,
	"./sr-cyrl.js": 337,
	"./sr.js": 338,
	"./ss": 339,
	"./ss.js": 339,
	"./sv": 340,
	"./sv.js": 340,
	"./sw": 341,
	"./sw.js": 341,
	"./ta": 342,
	"./ta.js": 342,
	"./te": 343,
	"./te.js": 343,
	"./tet": 344,
	"./tet.js": 344,
	"./tg": 345,
	"./tg.js": 345,
	"./th": 346,
	"./th.js": 346,
	"./tl-ph": 347,
	"./tl-ph.js": 347,
	"./tlh": 348,
	"./tlh.js": 348,
	"./tr": 349,
	"./tr.js": 349,
	"./tzl": 350,
	"./tzl.js": 350,
	"./tzm": 352,
	"./tzm-latn": 351,
	"./tzm-latn.js": 351,
	"./tzm.js": 352,
	"./ug-cn": 353,
	"./ug-cn.js": 353,
	"./uk": 354,
	"./uk.js": 354,
	"./ur": 355,
	"./ur.js": 355,
	"./uz": 357,
	"./uz-latn": 356,
	"./uz-latn.js": 356,
	"./uz.js": 357,
	"./vi": 358,
	"./vi.js": 358,
	"./x-pseudo": 359,
	"./x-pseudo.js": 359,
	"./yo": 360,
	"./yo.js": 360,
	"./zh-cn": 361,
	"./zh-cn.js": 361,
	"./zh-hk": 362,
	"./zh-hk.js": 362,
	"./zh-tw": 363,
	"./zh-tw.js": 363
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 835;

/***/ }),
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(952),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(968),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1080),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(826)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  "data-v-58313a3a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(821)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(969),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(961),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1055),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(991),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(985),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(827)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  "data-v-5949b7f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(1075),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(1042),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(822)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(994),
  /* scopeId */
  "data-v-3f3715de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(1065),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(1054),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(1033),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(955),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(963),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(966),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1072),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(954),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(987),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1056),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(992),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1034),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(830)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1053),
  /* scopeId */
  "data-v-95d4d1fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(824)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  "data-v-531712bd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(956),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(974),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(972),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(989),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(970),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(986),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(496),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(995),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(976),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1060),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1051),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(981),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(983),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(962),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(967),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(982),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1077),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1044),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1058),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(975),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1073),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1046),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1071),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(964),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1039),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1030),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(988),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1074),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(957),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1038),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1035),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(990),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(958),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1061),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(979),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(960),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(959),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1041),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1036),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1059),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1031),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1048),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1081),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(971),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1029),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1062),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1052),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(825)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(977),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(828)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1043),
  /* scopeId */
  "data-v-7b7fadd7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(823)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  "data-v-45f12f6e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(832)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1079),
  /* scopeId */
  "data-v-fe1f9fd0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(831)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1063),
  /* scopeId */
  "data-v-c26b37b0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(829)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1050),
  /* scopeId */
  "data-v-83fe5b52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(953),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1037),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1078),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1028),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1045),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(980),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1069),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(973),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 951 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.submitted) ? _c('div', {
    staticClass: "alert fade",
    class: {
      'alert-danger': !_vm.loginIsValid && _vm.submitted,
        'in': _vm.submitted,
        'alert-success': _vm.loginIsValid && _vm.submitted
    }
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": _vm.hideMessage
    }
  }, [_vm._v("\n          ×\n        ")]), _vm._v(" "), _c('i', {
    class: 'fa-fw fa fa-' + _vm.icon
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.title) + "!")]), _vm._v(" " + _vm._s(_vm.message) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('section', [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "input",
    class: {
      'state-error': _vm.fields.failed('email'),
        'state-success': _vm.fields.valid('email')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.emailRule),
      expression: "emailRule"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.failed('email')),
      expression: "fields.failed('email')"
    }]
  }, [_c('i', {
    staticClass: "fa text-danger fa-warning"
  }), _vm._v("\n          " + _vm._s(_vm.errors.first('email')) + "\n        ")])])]), _vm._v(" "), _c('section', [_vm._m(2), _vm._v(" "), _c('label', {
    staticClass: "input",
    class: {
      'state-error': _vm.fields.failed('password'),
        'state-success': _vm.fields.valid('password')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.passwordRule),
      expression: "passwordRule"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fields.failed('password')),
      expression: "fields.failed('password')"
    }]
  }, [_c('i', {
    staticClass: "fa text-danger fa-warning"
  }), _vm._v("\n          " + _vm._s(_vm.errors.first('password')) + "\n        ")])])]), _vm._v(" "), (_vm.needTenant) ? _c('section', [_vm._m(4), _vm._v(" "), _c('label', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTenant),
      expression: "selectedTenant"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTenant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" <== Selecione ==> ")]), _vm._v(" "), _vm._l((_vm.availableTenants), function(tenant) {
    return _c('option', {
      domProps: {
        "value": tenant.tenant.id_key
      }
    }, [_vm._v(_vm._s(tenant.tenant.tenant_fancy_name))])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('footer', [_c('button', {
    staticClass: "btn btn-block btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.attempt
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v(" Entrar\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-at"
  }), _vm._v(" Email\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', {
    staticClass: "tooltip tooltip-top-right"
  }, [_c('i', {
    staticClass: "fa fa-lock txt-color-teal"
  }), _vm._v("\n          Preencha o Email\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-key"
  }), _vm._v(" Senha\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', {
    staticClass: "tooltip tooltip-top-right"
  }, [_c('i', {
    staticClass: "fa fa-lock txt-color-teal"
  }), _vm._v("\n          Preencha a senha\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Unidade\n      ")])
}]}

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal modal-pendency fade",
    attrs: {
      "id": "modal-pendency",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "95%"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "smart-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.__fields_group2), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({}),
        expression: "{}"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "lazy": field.lazy,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.concluir
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Fechar pendência\n          ")]), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields_group1), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (field.name !== 'employee_assigned_id' ? 'required' : {}),
        expression: "field.name !== 'employee_assigned_id' ? 'required': {}"
      }],
      ref: 'ref_' + field.name,
      refInFor: true,
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly || (typeof(_vm.private_id) !== 'undefined' && field.name === 'employee_assigned_id' && !_vm.profile.map['vehicle-entries'].includes('change-assigned-employee-pendencies')),
        "lazy": field.lazy,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-md-1"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), (!_vm.private_id) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "4px 5px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Criar nova pendência\n          ")]) : _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "padding": "4px 5px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar pendência\n          ")])])], 2)]), _vm._v(" "), (_vm.pendencies.length) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.pendencies), function(pendency) {
    return _c('tr', {
      class: !pendency.completed_at ? 'danger' : 'success'
    }, [_c('td', [_vm._v(_vm._s(pendency.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.category_pendency_vehicle.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.occurrence))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.prediction_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.completed_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.employee.name))]), _vm._v(" "), _c('td', [(!pendency.completed_at && Number(_vm.user.id) === Number(pendency.assigned_employee.id_key)) ? _c('a', {
      staticClass: "btn btn-primary padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal(pendency.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    }), _vm._v(" Concluir")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "btn btn-default padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.edit(pendency.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Editar")]), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('delete-pendencies')) ? _c('a', {
      staticClass: "btn btn-danger padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.drop(pendency.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir")]) : _vm._e()])])
  }), 0)]) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-lg text-primary fa-inbox"
  }), _vm._v(" Não existem pendências para este veículo!\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" Fechamento de Pendência")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" Voltar\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Tipo de Pendência")]), _vm._v(" "), _c('th', [_vm._v("Ocorrência")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Previsão")]), _vm._v(" "), _c('th', [_vm._v("Encerrado Em")]), _vm._v(" "), _c('th', [_vm._v("Encerrado por")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Ações")])])])
}]}

/***/ }),
/* 954 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(this.resourceLabel.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 955 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "using-as-value": field.usingAsValue,
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c(_vm.__fields[0].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[0]['name'] + '_rule']),
      expression: "$data[__fields[0]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[0].label,
      "name": _vm.__fields[0].name,
      "icon": _vm.__fields[0].icon,
      "label": _vm.__fields[0].label,
      "placeholder": _vm.__fields[0].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[0].name),
      "valid": _vm.fields.valid(_vm.__fields[0].name),
      "failed": _vm.fields.failed(_vm.__fields[0].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[0]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[0]['name'], $$v)
      },
      expression: "$data[__fields[0]['name']]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c(_vm.__fields[9].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[9]['name'] + '_rule']),
      expression: "$data[__fields[9]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "select-options": [{
        value: 'true',
        label: 'SIM'
      }, {
        value: 'false',
        label: 'NÃO'
      }],
      "data-vv-as": _vm.__fields[9].label,
      "name": _vm.__fields[9].name,
      "icon": _vm.__fields[9].icon,
      "label": _vm.__fields[9].label,
      "placeholder": _vm.__fields[9].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[9].name),
      "valid": _vm.fields.valid(_vm.__fields[9].name),
      "failed": _vm.fields.failed(_vm.__fields[9].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[9]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[9]['name'], $$v)
      },
      expression: "$data[__fields[9]['name']]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-lg-6"
  }, [_vm._m(0), _vm._v(" "), _c(_vm.__fields[1].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[1]['name'] + '_rule']),
      expression: "$data[__fields[1]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[1].label,
      "name": _vm.__fields[1].name,
      "icon": _vm.__fields[1].icon,
      "label": _vm.__fields[1].label,
      "placeholder": _vm.__fields[1].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[1].name),
      "valid": _vm.fields.valid(_vm.__fields[1].name),
      "failed": _vm.fields.failed(_vm.__fields[1].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[1]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[1]['name'], $$v)
      },
      expression: "$data[__fields[1]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[2].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[2]['name'] + '_rule']),
      expression: "$data[__fields[2]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "select-options": [{
        label: 'Repasse Todo dia',
        value: 1
      }, {
        label: 'Repasse em',
        value: 2
      }],
      "data-vv-as": _vm.__fields[2].label,
      "name": _vm.__fields[2].name,
      "icon": _vm.__fields[2].icon,
      "label": _vm.__fields[2].label,
      "placeholder": _vm.__fields[2].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[2].name),
      "valid": _vm.fields.valid(_vm.__fields[2].name),
      "failed": _vm.fields.failed(_vm.__fields[2].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[2]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[2]['name'], $$v)
      },
      expression: "$data[__fields[2]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[3].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[3]['name'] + '_rule']),
      expression: "$data[__fields[3]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "wrapperClass": "col-lg-12",
      "data-vv-as": _vm.__fields[3].label,
      "name": _vm.__fields[3].name,
      "icon": _vm.__fields[3].icon,
      "label": _vm.__fields[3].label,
      "placeholder": _vm.__fields[3].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[3].name),
      "valid": _vm.fields.valid(_vm.__fields[3].name),
      "failed": _vm.fields.failed(_vm.__fields[3].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[3]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[3]['name'], $$v)
      },
      expression: "$data[__fields[3]['name']]"
    }
  }, [_c('span', {
    attrs: {
      "slot": "complement-message"
    },
    slot: "complement-message"
  }, [(_vm.debit_pass_through_type == 1) ? _c('span', [_vm._v("\n                REPASSE TODO "), _c('span', {
    staticClass: "bootstrap-label label-primary"
  }, [_vm._v("DIA " + _vm._s(_vm.debit_pass_through_day))]), _vm._v(" DE CADA MÊS\n              ")]) : (_vm.debit_pass_through_type == 2) ? _c('span', [_vm._v("\n                REPASSE EM "), _c('span', {
    staticClass: "bootstrap-label label-primary"
  }, [_vm._v(_vm._s(_vm.debit_pass_through_day) + " DIAS")]), _vm._v(" CORRIDOS APÓS BAIXA DO LANÇAMENTO FINANCEIRO\n              ")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-lg-6"
  }, [_vm._m(1), _vm._v(" "), _c(_vm.__fields[4].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[4]['name'] + '_rule']),
      expression: "$data[__fields[4]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[4].label,
      "name": _vm.__fields[4].name,
      "icon": _vm.__fields[4].icon,
      "label": _vm.__fields[4].label,
      "placeholder": _vm.__fields[4].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[4].name),
      "valid": _vm.fields.valid(_vm.__fields[4].name),
      "failed": _vm.fields.failed(_vm.__fields[4].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[4]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[4]['name'], $$v)
      },
      expression: "$data[__fields[4]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[5].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[5]['name'] + '_rule']),
      expression: "$data[__fields[5]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[5].label,
      "name": _vm.__fields[5].name,
      "icon": _vm.__fields[5].icon,
      "label": _vm.__fields[5].label,
      "placeholder": _vm.__fields[5].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[5].name),
      "valid": _vm.fields.valid(_vm.__fields[5].name),
      "failed": _vm.fields.failed(_vm.__fields[5].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[5]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[5]['name'], $$v)
      },
      expression: "$data[__fields[5]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[6].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[6]['name'] + '_rule']),
      expression: "$data[__fields[6]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[6].label,
      "name": _vm.__fields[6].name,
      "icon": _vm.__fields[6].icon,
      "label": _vm.__fields[6].label,
      "placeholder": _vm.__fields[6].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[6].name),
      "valid": _vm.fields.valid(_vm.__fields[6].name),
      "failed": _vm.fields.failed(_vm.__fields[6].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[6]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[6]['name'], $$v)
      },
      expression: "$data[__fields[6]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[7].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[7]['name'] + '_rule']),
      expression: "$data[__fields[7]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "select-options": [{
        label: 'Repasse Todo dia',
        value: 1
      }, {
        label: 'Repasse em',
        value: 2
      }],
      "data-vv-as": _vm.__fields[7].label,
      "name": _vm.__fields[7].name,
      "icon": _vm.__fields[7].icon,
      "label": _vm.__fields[7].label,
      "placeholder": _vm.__fields[7].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[7].name),
      "valid": _vm.fields.valid(_vm.__fields[7].name),
      "failed": _vm.fields.failed(_vm.__fields[7].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[7]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[7]['name'], $$v)
      },
      expression: "$data[__fields[7]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[8].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[8]['name'] + '_rule']),
      expression: "$data[__fields[8]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[8].label,
      "name": _vm.__fields[8].name,
      "icon": _vm.__fields[8].icon,
      "label": _vm.__fields[8].label,
      "placeholder": _vm.__fields[8].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[8].name),
      "valid": _vm.fields.valid(_vm.__fields[8].name),
      "failed": _vm.fields.failed(_vm.__fields[8].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[8]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[8]['name'], $$v)
      },
      expression: "$data[__fields[8]['name']]"
    }
  }, [_c('span', {
    attrs: {
      "slot": "complement-message"
    },
    slot: "complement-message"
  }, [(_vm.credit_pass_through_type == 1) ? _c('span', [_vm._v("\n              REPASSE TODO "), _c('span', {
    staticClass: "bootstrap-label label-primary"
  }, [_vm._v("DIA " + _vm._s(_vm.credit_pass_through_day))]), _vm._v(" DE CADA MÊS\n              ")]) : (_vm.credit_pass_through_type == 2) ? _c('span', [_vm._v("\n              REPASSE EM "), _c('span', {
    staticClass: "bootstrap-label label-primary"
  }, [_vm._v(_vm._s(_vm.credit_pass_through_day) + " DIAS")]), _vm._v(" CORRIDOS APÓS BAIXA DO LANÇAMENTO FINANCEIRO\n              ")]) : _vm._e()])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Dédito ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Crédito ")])
}]}

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['finantial'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['finantial'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['name']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['cnpj']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['contact_name']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['email']))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: {
        'label-success': model['active'],
          'label-danger': !model['active']
      }
    }, [_vm._v("\n                          " + _vm._s(model['active'] ? 'SIM' : 'NÃO') + "\n                      ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['finantial'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['finantial'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['finantial'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 958 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-credit-card fa-fw"
  }), _vm._v("  Tipos de pagamentos\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do tipo de pagamento\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 959 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-tags fa-fw"
  }), _vm._v("  Perfis\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do Perfil\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 960 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "using-as-value": field.usingAsValue,
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-tag"
  }), _vm._v(" Marcar Todos\n          "), _c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    },
    domProps: {
      "checked": _vm.allSelected()
    },
    on: {
      "click": _vm.checkallmodules
    }
  }), _vm._v(" "), _c('i')])]), _vm._v(" "), _vm._l((_vm.map), function(details, module) {
    return [_c('div', {
      staticClass: "col-md-4"
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2"
      }
    }, [_c('label', {
      staticClass: "checkbox"
    }, [_c('i', {
      staticClass: "fa fa-lg fa-tag"
    }), _vm._v(" " + _vm._s(details.name.toUpperCase()) + "\n                      "), _c('input', {
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "checked": _vm.allModuleSelected(module)
      },
      on: {
        "click": function($event) {
          return _vm.checkall(module)
        }
      }
    }), _vm._v(" "), _c('i')])])])]), _vm._v(" "), _c('tbody', [_vm._l((details.actions), function(action, actionKey) {
      return [_c('tr', [_c('td', [_c('label', {
        staticClass: "checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedPermissions),
          expression: "selectedPermissions"
        }],
        attrs: {
          "type": "checkbox",
          "name": "checkbox-inline"
        },
        domProps: {
          "value": module + '|' + actionKey,
          "checked": Array.isArray(_vm.selectedPermissions) ? _vm._i(_vm.selectedPermissions, module + '|' + actionKey) > -1 : (_vm.selectedPermissions)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.selectedPermissions,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = module + '|' + actionKey,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.selectedPermissions = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.selectedPermissions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedPermissions = $$c
            }
          }
        }
      }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(action.description) + "\n                      ")])])])]
    })], 2)])])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 961 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    class: 'col ' + _vm.wrapperClass
  }, [_c('label', {
    staticClass: "label"
  }, [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v(" " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('label', {
    staticClass: "textarea",
    class: {
      'state-error': _vm.customError, 'state-success': _vm.valid
    }
  }, [_c('i', {
    staticClass: "icon-append fa",
    class: _vm.getIcon
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    attrs: {
      "name": _vm.name,
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.innerValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('b', {
    staticClass: "tooltip tooltip-top-right"
  }, [_c('i', {
    staticClass: "fa fa-check txt-color-teal"
  }), _vm._v(" " + _vm._s(_vm.placeholder) + "\n      ")]), _vm._v(" "), _c('span', [_vm._v("  \n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customError),
      expression: "customError"
    }]
  }, [_c('i', {
    staticClass: "fa text-danger fa-warning"
  }), _vm._v(" " + _vm._s(_vm.customError) + "\n        ")])]), _vm._v(" "), _c('span', [_vm._t("complement-message")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(this.defaultSingularResource.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 963 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  Lojas\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da conta de movimentação\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 964 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 965 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 966 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 967 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 center col-sm-12 col-md-12 col-lg-4 col-lg-offset-4"
  }, [_c('div', {
    staticClass: "center well no-padding"
  }, [_c('form', {
    staticClass: "smart-form client-form",
    attrs: {
      "action": "index.html",
      "id": "login-form"
    }
  }, [_vm._m(0), _vm._v(" "), _c('login-form')], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('i', {
    staticClass: "fa fa-lg fa-lock"
  }), _vm._v(" ÁREA RESTRITA\n            ")])
}]}

/***/ }),
/* 969 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    class: 'col ' + _vm.wrapperClass
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_c('label', {
    staticClass: "toggle"
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    attrs: {
      "type": "checkbox",
      "name": _vm.name
    },
    domProps: {
      "checked": Array.isArray(_vm.innerValue) ? _vm._i(_vm.innerValue, null) > -1 : (_vm.innerValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.innerValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.innerValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.innerValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.innerValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    attrs: {
      "data-swchon-text": "SIM",
      "data-swchoff-text": "NÃO"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 970 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_vm._l((_vm.__fields), function(field) {
    return [_c('div', {
      staticClass: "row"
    }, [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })], 1)]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 971 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['providers'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['providers'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['name']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['cnpj_cpf']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['contact']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['cell_phone']))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: {
        'label-success': model['active'],
          'label-danger': !model['active']
      }
    }, [_vm._v("\n                          " + _vm._s(model['active'] ? 'SIM' : 'NÃO') + "\n                      ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['providers'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['providers'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['providers'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 972 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['card-operators'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['card-operators'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("\n                      " + _vm._s(_vm.fieldsTable[0].label) + "\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair(_vm.fieldsTable[0].name, 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup(_vm.fieldsTable[0].name, 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup(_vm.fieldsTable[0].name, 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('th', [_vm._v("\n                      " + _vm._s(_vm.fieldsTable[1].label) + "\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair(_vm.fieldsTable[1].name, 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup(_vm.fieldsTable[1].name, 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup(_vm.fieldsTable[1].name, 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(model[_vm.fieldsTable[0].name]) + "\n                    ")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: {
        'label-success': model[_vm.fieldsTable[1].name],
          'label-danger': !model[_vm.fieldsTable[1].name]
      }
    }, [_vm._v("\n                          " + _vm._s(model[_vm.fieldsTable[1].name] ? 'SIM' : 'NÃO') + "\n                      ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['card-operators'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['card-operators'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['card-operators'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 973 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.tenantForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  Lojas\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da Loja\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('tenant-form', {
    ref: "tenantForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 974 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 975 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['employees'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['employees'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['name']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['profile']['description']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['login']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['email']))]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "label",
      class: {
        'label-success': model['active'],
          'label-danger': !model['active']
      }
    }, [_vm._v("\n                          " + _vm._s(model['active'] ? 'SIM' : 'NÃO') + "\n                      ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['employees'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['employees'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['employees'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 976 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(this.resourceLabel.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 977 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('div', {
    staticClass: "col col-md-6"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__formFields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly || field.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-6"
  }, [_c('fieldset', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldsDetail), function(field) {
    return [_c(field.component, {
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": true,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data['detailsCar'][field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data['detailsCar'], field['name'], $$v)
        },
        expression: "$data['detailsCar'][field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-12"
  }, [_c('fieldset', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldAmountSection), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-12"
  }, [_c('fieldset', [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldICMSSection), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-12"
  }, [_c('fieldset', [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldPISSection), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col col-md-12"
  }, [_c('fieldset', [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__defaultFieldCOFINSSection), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "lazy": field.lazy,
        "using-as-value": field.usingAsValue,
        "has-related": field.hasRelated,
        "related": field.related,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Dados Gerais")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo - Detalhes Tabela "), _c('b', [_vm._v("FIPE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Aquisição")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" ICMS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" PIS")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', [_c('i', {
    staticClass: "fa fa-exchange"
  }), _vm._v(" COFINS")])
}]}

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_vm._l((_vm.__fields), function(field) {
    return [_c('div', {
      staticClass: "row"
    }, [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })], 1)]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(this.resourceLabel.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 980 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.tenantForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  Lojas\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da Loja\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('tenant-form', {
    ref: "tenantForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 981 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n        ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n        ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n          ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-sortable",
    attrs: {
      "id": "wid-id-11",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-togglebutton": "false",
      "data-widget-deletebutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "widget-tab-1"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.profile.map['customers'].includes('index-account-customer')) ? _c('li', [_vm._m(4)]) : _vm._e()]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "tab-content m-b-10 padding-10"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "hr1"
    }
  }, [_c('custom-form', {
    ref: "customFormPersonalData",
    attrs: {
      "group": 1,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr2"
    }
  }, [_c('custom-form', {
    ref: "customFormOffice",
    attrs: {
      "group": 2,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr3"
    }
  }, [_c('custom-form', {
    ref: "customFormGuaranter",
    attrs: {
      "group": 3,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), (_vm.profile.map['customers'].includes('index-account-customer')) ? _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr4"
    }
  }, [_c('expense-form', {
    ref: "formExpense",
    attrs: {
      "group": 4,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "pull-right",
    staticStyle: {
      "right": "20px"
    }
  }, [_c('strong', [_vm._v("DADOS DO CLIENTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-1",
      "href": "#hr1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-address-card-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS GERAIS ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-2",
      "href": "#hr2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-briefcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS PROFISSIONAIS ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-3",
      "href": "#hr3"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" CÔNJUGE/AVALISTA ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-4",
      "href": "#hr4"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-dollar"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" FINANCEIRO ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "jarviswidget-loader"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
}]}

/***/ }),
/* 983 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['checklist-items'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['checklist-items'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
      return _c('td', [(field.component !== 'entity-field') ? [_vm._v("\n                      " + _vm._s(model[field.name]) + "\n                      ")] : (field.component === 'entity-field') ? [(model[field['resourceKey']] !== null) ? [_vm._v("\n                          " + _vm._s(model[field['resourceKey']][field['usingAsLabel']]) + "\n                        ")] : _vm._e()] : _vm._e()], 2)
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['checklist-items'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['checklist-items'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['checklist-items'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])], 2)
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 984 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      },
      "title": "Início"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Início")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/estoque'
      },
      "title": "Estoque"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-list-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Estoque")])])], 1), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-entries') || _vm.profile.map.hasOwnProperty('checklist-items') || _vm.profile.map.hasOwnProperty('expense-types')) ? _c('li', [_vm._m(0), _vm._v(" "), _c('ul', [(_vm.profile.map.hasOwnProperty('vehicle-entries')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-entry'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-in"
  }), _vm._v(" Entrada de veículos\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-sale')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-sale',
        query: {
          'verified': 'unverified',
          't': 'Negociações'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Negociações\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-sale')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-sale',
        query: {
          'verified': 'verified',
          't': 'Saídas'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Saídas\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('checklist-items')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/checklist-items'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check-square-o"
  }), _vm._v(" Itens do checklist\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('expense-types')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/expense-types'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-window-restore"
  }), _vm._v(" Tipos de despesas\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('expense-types')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/payment-method'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-credit-card"
  }), _vm._v(" Tipos de Pagamento\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('categories-pendency')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/categories-pendency'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag"
  }), _vm._v(" Categorias de Pendência\n          ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._m(1), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/expense-vehicle-plate'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-car"
  }), _vm._v(" Despesa de veículo\n          ")])], 1), _vm._v(" "), _c('li', [(_vm.profile.map.hasOwnProperty('general-expenses')) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/expenses'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-refresh"
  }), _vm._v(" Despesas Gerais\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(_vm.profile.map.hasOwnProperty('account-mov')) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/receive'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-in"
  }), _vm._v(" A Receber\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('li', [(_vm.profile.map.hasOwnProperty('account-mov')) ? _c('router-link', {
    attrs: {
      "to": {
        path: '/pay'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" A Pagar\n          ")]) : _vm._e()], 1)])]), _vm._v(" "), (_vm.profile.map.hasOwnProperty('customers')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/customers'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-group"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Pessoas")])])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('employees')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/employees'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-user"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v(" Funcionários")])])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('finantial')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/finantial'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-institution"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v(" Financeiras ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('account-mov') || _vm.profile.map.hasOwnProperty('card-operators') || _vm.profile.map.hasOwnProperty('account-plans') || _vm.profile.map.hasOwnProperty('account-types')) ? _c('li', [_vm._m(2), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/nfe'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-archive"
  }), _vm._v(" Notas Fiscais\n          ")])], 1), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-sale')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-sale',
        query: {
          'verified': 'unverified',
          't': 'Negociações'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Negociações\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('vehicle-sale')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/vehicle-sale',
        query: {
          'verified': 'verified',
          't': 'Saídas'
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-sign-out"
  }), _vm._v(" Saídas\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('account-mov')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/account-mov'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-exchange"
  }), _vm._v(" Contas de Mov.\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('card-operators')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/card-operators'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-credit-card"
  }), _vm._v(" Operadoras Cartão\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('account-plans')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/account-plans'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-list"
  }), _vm._v(" Planos de contas\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('account-types')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/account-mov-type'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-tag"
  }), _vm._v(" Tipos de Conta\n          ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('profiles')) ? _c('li', [_c('router-link', {
    attrs: {
      "href": "#",
      "to": {
        path: '/profiles'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-tags"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Perfis")])])], 1) : _vm._e(), _vm._v(" "), (_vm.profile.map.hasOwnProperty('tenants')) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tenants'
      },
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-building"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Unidades")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/reports'
      },
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Relatórios")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/reports-v2'
      },
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-file"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Relatórios v2")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/configurations'
      },
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-cog"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Configurações")])])], 1), _vm._v(" "), _vm._m(3)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-car"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Veículos ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-money"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Entrada / Saída ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-dollar"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Financeiro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://webmail-seguro.com.br/vipcarseminovos.com.br/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-fw fa-at"
  }), _vm._v(" "), _c('span', {
    staticClass: "menu-item-parent"
  }, [_vm._v("Email")])])])
}]}

/***/ }),
/* 986 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 987 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.name_rule),
      expression: "name_rule"
    }],
    attrs: {
      "placeholder": "Preencha o nome",
      "label": "Nome",
      "icon": "edit",
      "readonly": _vm.readonly,
      "name": "name",
      "custom-error": _vm.errors.first('name'),
      "valid": _vm.fields.valid('name'),
      "failed": _vm.fields.failed('name')
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.abbreviation_rule),
      expression: "abbreviation_rule"
    }],
    attrs: {
      "placeholder": "Preencha o Sigla",
      "label": "Sigla",
      "icon": "edit",
      "readonly": _vm.readonly,
      "name": "abbreviation",
      "custom-error": _vm.errors.first('abbreviation'),
      "valid": _vm.fields.valid('abbreviation'),
      "failed": _vm.fields.failed('abbreviation')
    },
    model: {
      value: (_vm.abbreviation),
      callback: function($$v) {
        _vm.abbreviation = $$v
      },
      expression: "abbreviation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.type_rule),
      expression: "type_rule"
    }],
    attrs: {
      "label": "Tipo",
      "icon": "edit",
      "readonly": _vm.readonly,
      "name": "type",
      "select-options": _vm.type_options,
      "custom-error": _vm.errors.first('type'),
      "valid": _vm.fields.valid('type'),
      "failed": _vm.fields.failed('type')
    },
    model: {
      value: (_vm.typeKey),
      callback: function($$v) {
        _vm.typeKey = $$v
      },
      expression: "typeKey"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.active_rule),
      expression: "active_rule"
    }],
    attrs: {
      "label": "Ativo",
      "icon": "edit",
      "readonly": _vm.readonly,
      "name": "isActive",
      "select-options": _vm.active_options,
      "custom-error": _vm.errors.first('isActive'),
      "valid": _vm.fields.valid('isActive'),
      "failed": _vm.fields.failed('isActive')
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 989 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(this.resourceLabel.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 990 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.$parent.create($event)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "using-as-value": field.usingAsValue,
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    class: 'alert fade in alert-' + _vm.type
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.show = false
      }
    }
  }, [_vm._v("\n    ×\n  ")]), _vm._v(" "), _c('i', {
    class: 'fa-fw fa fa-' + _vm.icon
  }), _vm._v("\n  " + _vm._s(_vm.message) + "\n  "), (_vm.url.length) ? _c('router-link', {
    attrs: {
      "to": _vm.url
    }
  }, [_vm._v("Ver registro")]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v("\n              Lista de Planos de conta cadastrados\n              "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['account-plans'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['account-plans'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/account-plans/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar novo Plano de conta")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("\n                      Nome\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('name', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('name', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('name', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Sigla\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('sigla', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('sigla', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('sigla', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Tipo\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('type', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('type', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('type', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Ativo\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('active', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('active', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('active', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(5, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.abbreviation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.type))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "label",
      class: model.isActive ? 'label-success' : 'label-danger'
    }, [_vm._v("\n                        " + _vm._s(model.active) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['account-plans'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-plans'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-plans'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-list fa-fw"
  }), _vm._v(" \n        Planos de Conta\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 993 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c(_vm.__fields[0].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[0]['name'] + '_rule']),
      expression: "$data[__fields[0]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[0].label,
      "name": _vm.__fields[0].name,
      "icon": _vm.__fields[0].icon,
      "label": _vm.__fields[0].label,
      "placeholder": _vm.__fields[0].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[0].name),
      "valid": _vm.fields.valid(_vm.__fields[0].name),
      "failed": _vm.fields.failed(_vm.__fields[0].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[0]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[0]['name'], $$v)
      },
      expression: "$data[__fields[0]['name']]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c(_vm.__fields[9].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[9]['name'] + '_rule']),
      expression: "$data[__fields[9]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "select-options": [{
        value: 'true',
        label: 'SIM'
      }, {
        value: 'false',
        label: 'NÃO'
      }],
      "data-vv-as": _vm.__fields[9].label,
      "name": _vm.__fields[9].name,
      "icon": _vm.__fields[9].icon,
      "label": _vm.__fields[9].label,
      "placeholder": _vm.__fields[9].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[9].name),
      "valid": _vm.fields.valid(_vm.__fields[9].name),
      "failed": _vm.fields.failed(_vm.__fields[9].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[9]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[9]['name'], $$v)
      },
      expression: "$data[__fields[9]['name']]"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-lg-6"
  }, [_vm._m(0), _vm._v(" "), _c(_vm.__fields[1].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[1]['name'] + '_rule']),
      expression: "$data[__fields[1]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[1].label,
      "name": _vm.__fields[1].name,
      "icon": _vm.__fields[1].icon,
      "label": _vm.__fields[1].label,
      "placeholder": _vm.__fields[1].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[1].name),
      "valid": _vm.fields.valid(_vm.__fields[1].name),
      "failed": _vm.fields.failed(_vm.__fields[1].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[1]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[1]['name'], $$v)
      },
      expression: "$data[__fields[1]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[2].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[2]['name'] + '_rule']),
      expression: "$data[__fields[2]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "select-options": [{
        label: 'Repasse Todo dia',
        value: 1
      }, {
        label: 'Repasse em',
        value: 2
      }],
      "data-vv-as": _vm.__fields[2].label,
      "name": _vm.__fields[2].name,
      "icon": _vm.__fields[2].icon,
      "label": _vm.__fields[2].label,
      "placeholder": _vm.__fields[2].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[2].name),
      "valid": _vm.fields.valid(_vm.__fields[2].name),
      "failed": _vm.fields.failed(_vm.__fields[2].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[2]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[2]['name'], $$v)
      },
      expression: "$data[__fields[2]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[3].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[3]['name'] + '_rule']),
      expression: "$data[__fields[3]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "wrapperClass": "col-lg-12",
      "data-vv-as": _vm.__fields[3].label,
      "name": _vm.__fields[3].name,
      "icon": _vm.__fields[3].icon,
      "label": _vm.__fields[3].label,
      "placeholder": _vm.__fields[3].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[3].name),
      "valid": _vm.fields.valid(_vm.__fields[3].name),
      "failed": _vm.fields.failed(_vm.__fields[3].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[3]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[3]['name'], $$v)
      },
      expression: "$data[__fields[3]['name']]"
    }
  }, [_c('span', {
    attrs: {
      "slot": "complement-message"
    },
    slot: "complement-message"
  }, [(_vm.debit_pass_through_type == 1) ? _c('span', [_vm._v("\n              REPASSE TODO "), _c('span', {
    staticClass: "bootstrap-label label-primary"
  }, [_vm._v("DIA " + _vm._s(_vm.debit_pass_through_day))]), _vm._v(" DE CADA MÊS\n            ")]) : (_vm.debit_pass_through_type == 2) ? _c('span', [_vm._v("\n              REPASSE EM "), _c('span', {
    staticClass: "bootstrap-label label-primary"
  }, [_vm._v(_vm._s(_vm.debit_pass_through_day) + " DIAS")]), _vm._v(" CORRIDOS APÓS BAIXA DO LANÇAMENTO FINANCEIRO\n            ")]) : _vm._e()])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-lg-6"
  }, [_vm._m(1), _vm._v(" "), _c(_vm.__fields[4].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[4]['name'] + '_rule']),
      expression: "$data[__fields[4]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[4].label,
      "name": _vm.__fields[4].name,
      "icon": _vm.__fields[4].icon,
      "label": _vm.__fields[4].label,
      "placeholder": _vm.__fields[4].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[4].name),
      "valid": _vm.fields.valid(_vm.__fields[4].name),
      "failed": _vm.fields.failed(_vm.__fields[4].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[4]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[4]['name'], $$v)
      },
      expression: "$data[__fields[4]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[5].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[5]['name'] + '_rule']),
      expression: "$data[__fields[5]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[5].label,
      "name": _vm.__fields[5].name,
      "icon": _vm.__fields[5].icon,
      "label": _vm.__fields[5].label,
      "placeholder": _vm.__fields[5].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[5].name),
      "valid": _vm.fields.valid(_vm.__fields[5].name),
      "failed": _vm.fields.failed(_vm.__fields[5].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[5]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[5]['name'], $$v)
      },
      expression: "$data[__fields[5]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[6].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[6]['name'] + '_rule']),
      expression: "$data[__fields[6]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[6].label,
      "name": _vm.__fields[6].name,
      "icon": _vm.__fields[6].icon,
      "label": _vm.__fields[6].label,
      "placeholder": _vm.__fields[6].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[6].name),
      "valid": _vm.fields.valid(_vm.__fields[6].name),
      "failed": _vm.fields.failed(_vm.__fields[6].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[6]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[6]['name'], $$v)
      },
      expression: "$data[__fields[6]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[7].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[7]['name'] + '_rule']),
      expression: "$data[__fields[7]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "select-options": [{
        label: 'Repasse Todo dia',
        value: 1
      }, {
        label: 'Repasse em',
        value: 2
      }],
      "data-vv-as": _vm.__fields[7].label,
      "name": _vm.__fields[7].name,
      "icon": _vm.__fields[7].icon,
      "label": _vm.__fields[7].label,
      "placeholder": _vm.__fields[7].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[7].name),
      "valid": _vm.fields.valid(_vm.__fields[7].name),
      "failed": _vm.fields.failed(_vm.__fields[7].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[7]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[7]['name'], $$v)
      },
      expression: "$data[__fields[7]['name']]"
    }
  }), _vm._v(" "), _c(_vm.__fields[8].component, {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.$data[_vm.__fields[8]['name'] + '_rule']),
      expression: "$data[__fields[8]['name'] + '_rule']"
    }],
    tag: "component",
    attrs: {
      "data-vv-as": _vm.__fields[8].label,
      "name": _vm.__fields[8].name,
      "icon": _vm.__fields[8].icon,
      "label": _vm.__fields[8].label,
      "placeholder": _vm.__fields[8].placeholder,
      "readonly": _vm.readonly,
      "custom-error": _vm.errors.first(_vm.__fields[8].name),
      "valid": _vm.fields.valid(_vm.__fields[8].name),
      "failed": _vm.fields.failed(_vm.__fields[8].name)
    },
    model: {
      value: (_vm.$data[_vm.__fields[8]['name']]),
      callback: function($$v) {
        _vm.$set(_vm.$data, _vm.__fields[8]['name'], $$v)
      },
      expression: "$data[__fields[8]['name']]"
    }
  }, [_c('span', {
    attrs: {
      "slot": "complement-message"
    },
    slot: "complement-message"
  }, [(_vm.credit_pass_through_type == 1) ? _c('span', [_vm._v("\n            REPASSE TODO "), _c('span', {
    staticClass: "bootstrap-label label-primary"
  }, [_vm._v("DIA " + _vm._s(_vm.credit_pass_through_day))]), _vm._v(" DE CADA MÊS\n            ")]) : (_vm.credit_pass_through_type == 2) ? _c('span', [_vm._v("\n            REPASSE EM "), _c('span', {
    staticClass: "bootstrap-label label-primary"
  }, [_vm._v(_vm._s(_vm.credit_pass_through_day) + " DIAS")]), _vm._v(" CORRIDOS APÓS BAIXA DO LANÇAMENTO FINANCEIRO\n            ")]) : _vm._e()])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Dédito ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Crédito ")])
}]}

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('v-snackbar', {
    attrs: {
      "color": "green lighten-1",
      "absolute": "absolute"
    },
    model: {
      value: (_vm.success),
      callback: function($$v) {
        _vm.success = $$v
      },
      expression: "success"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.successMessage))])]), _c('v-snackbar', {
    attrs: {
      "color": "red lighten-1",
      "absolute": "absolute"
    },
    model: {
      value: (_vm.error),
      callback: function($$v) {
        _vm.error = $$v
      },
      expression: "error"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])]), _c('v-dialog', {
    attrs: {
      "width": "700",
      "persistent": "persistent",
      "app": "app",
      "absolute": "absolute"
    },
    model: {
      value: (_vm.reserveVehicle.open),
      callback: function($$v) {
        _vm.$set(_vm.reserveVehicle, "open", $$v)
      },
      expression: "reserveVehicle.open"
    }
  }, [_c('v-card', [_c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "pl-2 pr-2",
    staticStyle: {
      "height": "20px",
      "display": "flex",
      "flex-direction": "row, align-items: center",
      "justify-content": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "small": "small",
      "flat": "flat",
      "icon": "icon"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("book")])], 1), _c('h5', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Reserva de Veículo")]), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "small": "small",
      "outline": "outline",
      "color": "red lighten-3"
    },
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('CHANGE_VISIBILITY', _vm.resetaDados = null)
      }
    }
  }, [_c('span', {
    staticClass: "red--text"
  }, [_vm._v("fechar")])])], 1), _c('v-divider')], 1), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "flex-wrap": "wrap"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "xs4"
    }
  }, [_c('div', {
    staticClass: "ml-2 mr-1 pa-2 elevation-0",
    staticStyle: {
      "border-radius": "4px",
      "border": "1px solid #090",
      "background-color": "#f2f2f2"
    },
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "centraliza"
  }, [_c('v-icon', [_vm._v("person")]), (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? false : true) ? _c('h5', {
    staticClass: "text-xs-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm.user.userName))]) : _vm._e(), (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? true : false) ? _c('h5', {
    staticClass: "text-xs-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm.reserveVehicle.veiculoSelecionado.user_reserva))]) : _vm._e()], 1)])], 1)]), _c('v-flex', {
    attrs: {
      "xs4": "xs4"
    }
  }, [_c('div', {
    staticClass: "ml-2 mr-1 pa-2 elevation-0",
    staticStyle: {
      "border-radius": "4px",
      "border": "1px solid #090",
      "background-color": "#f2f2f2"
    },
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "centraliza"
  }, [_c('v-icon', [_vm._v("date_range")]), _c('h5', {
    staticClass: "text-xs-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("dataReserva")(_vm.reserveVehicle.veiculoSelecionado.data_reserva)))])], 1)])], 1)]), _c('v-flex', {
    attrs: {
      "xs4": "xs4"
    }
  }, [_c('div', {
    staticClass: "ml-2 mr-1 pa-2 elevation-0",
    staticStyle: {
      "border-radius": "4px",
      "background-color": "#f2f2f2"
    },
    style: (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? 'border: 1px solid #900' : 'border-left: 1px solid #090'),
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('div', {
    staticClass: "centraliza"
  }, [_c('v-icon', {
    attrs: {
      "color": _vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? 'red lighten-2' : 'green'
    }
  }, [_vm._v("bookmark")]), _c('h5', {
    staticClass: "text-xs-center font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("status")(_vm.reserveVehicle.veiculoSelecionado.state_id)))])], 1)])], 1)]), _c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [_c('v-divider')], 1), _c('v-flex', {
    attrs: {
      "xs12": "xs12"
    }
  }, [(_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? false : true) ? _c('v-textarea', {
    staticClass: "ma-2",
    attrs: {
      "box": "box",
      "color": "green"
    },
    model: {
      value: (_vm.observacoes),
      callback: function($$v) {
        _vm.observacoes = $$v
      },
      expression: "observacoes"
    }
  }) : _vm._e(), (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? true : false) ? _c('v-textarea', {
    staticClass: "ma-2",
    attrs: {
      "disabled": "disabled",
      "box": "box",
      "color": "green"
    },
    model: {
      value: (_vm.reserveVehicle.reserva.observacoes),
      callback: function($$v) {
        _vm.$set(_vm.reserveVehicle.reserva, "observacoes", $$v)
      },
      expression: "reserveVehicle.reserva.observacoes"
    }
  }) : _vm._e()], 1), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "xs12": "xs12"
    }
  }, [(_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? true : false) ? _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "red lighten-2"
    },
    on: {
      "click": function($event) {
        return _vm.cancelaReserva(_vm.reserveVehicle, _vm.user)
      }
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Cancelar Reserva")]), _c('v-icon', {
    staticClass: "mb-1 mt-1 ml-2",
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")]), (_vm.carregando) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "indeterminate",
      "size": "20"
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.reserveVehicle.veiculoSelecionado.state_id === 3 ? false : true) ? _c('v-btn', {
    attrs: {
      "block": "block",
      "color": "green"
    },
    on: {
      "click": function($event) {
        return _vm.montaReserva(_vm.reserveVehicle)
      }
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Reservar Veículo")]), _c('v-icon', {
    staticClass: "mb-1 mt-1 ml-2",
    attrs: {
      "color": "white"
    }
  }, [_vm._v("check")]), (_vm.carregando) ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "indeterminate",
      "size": "20"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['account-types'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['account-types'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)])])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(1, true), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
      return _c('td', [_vm._v(" " + _vm._s(model[field.name]))])
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['account-types'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-types'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-types'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])], 2)
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 996 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 997 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [(_vm.profile.map['customers'].includes('create-account-customer') || _vm.profile.map['customers'].includes('edit-account-customer')) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "order-by": field.orderBy,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-md-4 pull-right"
  }, [(typeof(_vm.private_id) === 'undefined' && _vm.profile.map['customers'].includes('create-account-customer')) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Criar novo item\n          ")]) : (typeof(_vm.private_id) !== 'undefined' && _vm.profile.map['customers'].includes('edit-account-customer')) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar Item\n          ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['customers'].includes('create-account-customer') || _vm.profile.map['customers'].includes('edit-account-customer')) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.reset
    }
  }, [(typeof(_vm.private_id) === 'undefined') ? _c('span', [_c('i', {
    staticClass: "fa fa-eraser"
  }), _vm._v(" Limpar\n              ")]) : _c('span', [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancelar Edição\n              ")])]) : _vm._e()])], 2) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.profile.map['customers'].includes('show-account-customer')) ? _c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "hr2"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#iss1",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning text-danger"
  }), _vm._v(" Pendencias (" + _vm._s(_vm.pendente.length) + ")\n          ")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#iss2",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Histórico(" + _vm._s(_vm.pago.length) + ")\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content padding-10"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "iss1"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.pendente), function(expense, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/payment-method/" + (expense.payment_method.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-credit-card"
    }), _vm._v(" " + _vm._s(expense.payment_method.description) + "\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.number))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(expense.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.due))]), _vm._v(" "), _c('td', [(typeof(_vm.private_id) === 'undefined' && _vm.profile.map['customers'].includes('edit-account-customer')) ? _c('a', {
      staticClass: "btn btn-default padding-5",
      on: {
        "click": function($event) {
          return _vm.edit(expense)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Editar\n                  ")]) : _vm._e(), _vm._v(" "), (typeof(_vm.private_id) === 'undefined' && _vm.profile.map['customers'].includes('delete-account-customer')) ? _c('a', {
      staticClass: "btn btn-danger padding-5",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(expense.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir\n                  ")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "iss2"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pago), function(expense, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/payment-method/" + (expense.payment_method.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-credit-card"
    }), _vm._v(" " + _vm._s(expense.payment_method.description) + "\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.number))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(expense.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.due))]), _vm._v(" "), _c('td', [(typeof(_vm.private_id) === 'undefined' && _vm.profile.map['customers'].includes('edit-account-customer')) ? _c('a', {
      staticClass: "btn btn-default padding-5",
      on: {
        "click": function($event) {
          return _vm.edit(expense)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Editar\n                  ")]) : _vm._e(), _vm._v(" "), (typeof(_vm.private_id) === 'undefined' && _vm.profile.map['customers'].includes('delete-account-customer')) ? _c('a', {
      staticClass: "btn btn-danger padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(expense.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir\n                  ")]) : _vm._e()])])
  }), 0)])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Número")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("Data de Vencimento")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "15%"
    }
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("Data de Vencimento")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Ações")])])])
}]}

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [(_vm.loading) ? _c('tr', [_vm._m(3)]) : _vm._l((_vm.models), function(model) {
    return _c('tr', [_c('td', [_vm._v(" " + _vm._s(model.id) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(" " + _vm._s(model.number) + " ")]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "1%"
      }
    }, [_vm._v(" " + _vm._s('-') + " ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(model.status) + " ")]), _vm._v(" "), _c('td', [(model.status !== 'MergeAuthorizationProtocolCompleted') ? _c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.cancelar(model.id)
        }
      }
    }, [_vm._v("Cancelar")]) : _vm._e(), _vm._v(" "), (model.status === 'MergeAuthorizationProtocolCompleted') ? _c('span', [_c('a', {
      staticClass: "btn btn-success",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.download(model.id, 'pdf')
        }
      }
    }, [_vm._v("PDF")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-primary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.download(model.id, 'xml')
        }
      }
    }, [_vm._v("XML")])]) : _vm._e()])])
  })], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-archive"
  }), _vm._v(" \r\n          Notas Fiscais\r\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v("\r\n                Lista de Notas Fiscais\r\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Nº Nota")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "fa-3x"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v("\r\n                        Aguarde, carregando notas fiscais.\r\n                      ")])
}]}

/***/ }),
/* 1001 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "value": "pf",
      "checked": "checked",
      "autocomplete": "off",
      "name": "type"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "pf")
    },
    on: {
      "change": function($event) {
        _vm.type = "pf"
      }
    }
  }), _vm._v(" Pessoa Física\n          ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "value": "pj",
      "autocomplete": "off",
      "name": "type"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "pj")
    },
    on: {
      "change": function($event) {
        _vm.type = "pj"
      }
    }
  }), _vm._v("\nPessoa Jurídica\n              "), _vm._m(1)])]), _vm._v(" "), _vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field['name'] === 'cpf' && _vm.type === 'pf' ? field.mask : field['name'] === 'cpf' && _vm.type === 'pj' ? '11.111.111/1111-11' : field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Tipo de cadastro\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("   "), _c('span', {
    staticStyle: {
      "display": "none"
    }
  })])
}]}

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('legend', [_c('i', {
    staticClass: "fa fa fa-list-ul"
  }), _vm._v(" \n      CHECKLIST\n      "), _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "bootstrap-label label-success",
    staticStyle: {
      "position": "relative",
      "top": "-4px",
      "margin-right": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.totalChecked) + " Selecionados\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-label label-danger",
    staticStyle: {
      "position": "relative",
      "top": "-4px",
      "margin-right": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.totalUnchecked) + " Selecionados\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-label label-primary",
    staticStyle: {
      "position": "relative",
      "top": "-4px"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalItems) + " Total\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', [_c('label', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input-lg",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "checklist-items-search",
      "placeholder": "Pesquisar..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.searchedChecklistItems), function(checklistItem) {
    return _c('section', [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', {
      staticClass: "toggle",
      class: {
        'toogle-active': _vm.selectedChecklistItems.includes(checklistItem.id)
      }
    }, [(_vm.selectedChecklistItems.includes(checklistItem.id)) ? _c('b', {
      staticClass: "fa fa-lg fa-check-square-o"
    }) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedChecklistItems),
        expression: "selectedChecklistItems"
      }],
      attrs: {
        "disabled": _vm.$parent.$refs.customFormPersonalData && _vm.$parent.$refs.customFormPersonalData.unidadesDiferentes,
        "type": "checkbox",
        "name": "name"
      },
      domProps: {
        "value": checklistItem.id,
        "checked": Array.isArray(_vm.selectedChecklistItems) ? _vm._i(_vm.selectedChecklistItems, checklistItem.id) > -1 : (_vm.selectedChecklistItems)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedChecklistItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = checklistItem.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedChecklistItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedChecklistItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedChecklistItems = $$c
          }
        }, _vm.clearAndFocusSearch]
      }
    }), _vm._v("\n            " + _vm._s(checklistItem.description) + "\n            "), _c('i', {
      attrs: {
        "data-swchon-text": "SIM",
        "data-swchoff-text": "NÃO"
      }
    })])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['account-types'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['account-types'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)])])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(1, true), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
      return _c('td', [_vm._v(" " + _vm._s(model[field.name]))])
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['account-types'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-types'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-types'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])], 2)
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(this.defaultSingularResource.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "margin": "4px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Finalizar Devolução\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('entity-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Cliente",
      "usingAsProvider": "/customers",
      "usingAsLabel": "name",
      "usingAsValue": "id",
      "orderBy": "name",
      "icon": "user",
      "wrapperClass": "col-lg-6",
      "placeholder": "Selecione o Cliente",
      "name": "customer_id",
      "custom-error": _vm.errors.first('customer_id'),
      "valid": _vm.fields.valid('customer_id'),
      "failed": _vm.fields.failed('customer_id')
    },
    model: {
      value: (_vm.customer_id),
      callback: function($$v) {
        _vm.customer_id = $$v
      },
      expression: "customer_id"
    }
  }), _vm._v(" "), _c('entity-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Veículo",
      "usingAsProvider": '/entries-by-tenant/' + _vm.currentTenant + '?only-available=true' + '&q=consigned:1;state_id:1&sf=consigned:=;state_id:=&_and=true',
      "usingAsLabel": "fipe_vehicle_renavam_plate",
      "usingAsValue": "id_key",
      "orderBy": "fipe_vehicle",
      "icon": "car",
      "wrapperClass": "col-lg-6",
      "placeholder": "Selecione o Veículo",
      "name": "entry_id",
      "custom-error": _vm.errors.first('entry_id'),
      "valid": _vm.fields.valid('entry_id'),
      "failed": _vm.fields.failed('entry_id')
    },
    model: {
      value: (_vm.entry_id),
      callback: function($$v) {
        _vm.entry_id = $$v
      },
      expression: "entry_id"
    }
  })], 1), _vm._v(" "), (_vm.expenses.length) ? _c('fieldset', [_c('legend', [_vm._v("Despesas")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.expenses), function(expense, index) {
    return _c('tr', {
      class: {
        'bg-success': expense.paid, 'bg-danger': !expense.paid
      }
    }, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.expense_type.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("R$ " + _vm._s(expense.amount))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.paid ? 'SIM' : 'NÃO'))])])
  }), 0)])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-info-circle"
  }), _vm._v("\n            Despesas do veículo "), _c('b', [_vm._v("marcadas como paga")]), _vm._v(", serão lançados como "), _c('b', [_vm._v("despesas não pagas")]), _vm._v(" na conta do cliente\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-info"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-info-circle"
  }), _vm._v("\n            O veículo será marcado como indisponível automaticamente\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n                    DESPESAS DO VEÍCULO\n                  ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Pago")])])])
}]}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  Planos de Contas\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: '/account-plans'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do Plano de Conta\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('account-plan-form', {
    ref: "form",
    attrs: {
      "form-readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-md-1"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(" ")]), _vm._v(" "), (!_vm.private_id) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "4px 5px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Lançar no Histórico\n          ")]) : _vm._e()])], 2)]), _vm._v(" "), (_vm.pendencies.length) ? _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.pendencies), function(pendency) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(pendency.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pendency.employee.name))]), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('delete-historic')) ? _c('td', [_c('a', {
      staticClass: "btn btn-danger padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.drop(pendency.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir")])]) : _vm._e()])
  }), 0)]) : _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-lg text-primary fa-inbox"
  }), _vm._v(" Não existem entradas no histórico para este veículo!\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Usuário")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "25%"
    }
  }, [_vm._v("Ações")])])])
}]}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-right hidden-print"
  }, [_c('div', {
    staticClass: "btn-header pull-right",
    attrs: {
      "id": "hide-menu"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "data-action": "toggleMenu",
      "title": "Collapse Menu"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reorder"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn-header transparent pull-right",
    attrs: {
      "id": "logout"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "title": "Sign Out",
      "data-action": "userLogout",
      "data-logout-msg": "You can improve your security further after logging out by closing this opened browser"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.logoutUser($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })])])]), _vm._v(" "), _c('form', {
    staticClass: "header-search pull-right",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.current),
      expression: "current"
    }],
    staticClass: "form-control mb-1",
    attrs: {
      "id": "select-1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.current = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.doLogin]
    }
  }, _vm._l((_vm.tenants), function(tenant) {
    return _c('option', {
      domProps: {
        "value": tenant.tenant_id
      }
    }, [_vm._v(_vm._s(tenant.tenant_fancy_name))])
  }), 0)]), _vm._v(" "), _c('form', {
    staticClass: "header-search pull-left",
    staticStyle: {
      "min-width": "500px"
    },
    attrs: {
      "action": "search.html"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input-lg ui-autocomplete-input",
    staticStyle: {
      "font-size": "inherit !important"
    },
    attrs: {
      "id": "search-fld",
      "type": "text",
      "name": "param",
      "placeholder": "Buscar veículo por Placa / Data de Entrada",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0);",
      "id": "cancel-search-js",
      "title": "Cancel Search"
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.tenantForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  Lojas\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da Loja\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('tenant-form', {
    ref: "tenantForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(this.resourceLabel.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile.map.hasOwnProperty('account-mov')) ? _c('div', [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_vm._v("\n      Pagamentos a receber\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.profile.map['tenants'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.sales), function(sale) {
    return (sale.payments_methods.data.some(function (d) { return typeof d.paid_at === 'object'; })) ? _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(sale.customer.name_with_cpf) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(sale.entry.fipe_vehicle_with_renavam))]), _vm._v(" "), _c('td', [_c('table', {
      staticClass: "table table-condensed"
    }, [_vm._m(2, true), _vm._v(" "), _c('tbody', _vm._l((sale.payments_methods.data), function(pag) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(pag.value_formatted))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pag.date_formatted))]), _vm._v(" "), _c('td', [_c('a', {
        staticClass: "btn btn-primary btn-sm",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.mark(pag.id_key, 'venda')
          }
        }
      }, [_vm._v("Confirmar")])])])
    }), 0)])])]) : _vm._e()
  }), 0)])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(3), _vm._v(" "), (_vm.profile.map['tenants'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "height": "150px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover"
  }, [_vm._m(4), _vm._v(" "), _c('tbody', _vm._l((_vm.accountCustomers), function(pag) {
    return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(pag.customer.name) + " (" + _vm._s(pag.customer.cpf) + ")\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pag.due))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pag.payment_method.description))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(pag.value))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.mark(pag.id_key, 'financeiro')
        }
      }
    }, [_vm._v("Confirmar")])])])
  }), 0)])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "smart-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.id = '';
        _vm.type = '';
        _vm.account_mov = '';
        _vm.date = ''
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Salvar")])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("\n              Listagem de pagamentos a receber (Vendas)\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Veículo")]), _vm._v(" "), _c('th', [_vm._v("Pagamentos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Confirmação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("\n              Listagem de pagamentos a receber (Financeiro do cliente)\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Venc.")]), _vm._v(" "), _c('th', [_vm._v("Forma Pag.")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmação de Recebimento")])])
}]}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v("\n              Lista de lojas cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['tenants'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['tenants'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova Loja")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("\n                      Nome Fantasia\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('tenant_fancy_name', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('tenant_fancy_name', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('tenant_fancy_name', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Razão Social\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('tenant_name', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('tenant_name', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('tenant_name', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('th', [_vm._v("\n                      CNPJ\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('cnpj', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('cnpj', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('cnpj', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Contato\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('phone_number', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('phone_number', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('phone_number', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(5, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.tenant_fancy_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.tenant_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.phone_number))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['tenants'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: _vm.matcher.self(model, 'show') + '/show'
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['tenants'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: _vm.matcher.self(model, 'update') + '/edit'
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['tenants'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v(" \n        Lojas\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-info"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "show-shortcut",
      "data-action": "toggleShortcut"
    }
  }, [_c('span', [_vm._v("\n        " + _vm._s(_vm.userName) + "\n      ")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-down"
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_vm._l((_vm.__fields), function(field) {
    return [_c('div', {
      staticClass: "row"
    }, [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })], 1)]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-sortable",
    attrs: {
      "id": "wid-id-11",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-togglebutton": "false",
      "data-widget-deletebutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "widget-tab-1"
    }
  }, [_vm._m(1), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), (_vm.showTabs) ? _c('li', {
    class: {
      'bg-color-orange': false
    }
  }, [_vm._m(8)]) : _vm._e()]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "tab-content m-b-10 padding-10"
  }, [_c('div', {
    staticClass: "tab-pane active in fade",
    attrs: {
      "id": "hr1"
    }
  }, [_c('form-vehicle-create', {
    ref: "formVehicleCreate",
    attrs: {
      "group": 1,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "pull-right",
    staticStyle: {
      "right": "20px"
    }
  }, [_c('strong', [_vm._v("DADOS DO VEÍCULO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-1",
      "href": "#hr1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-car"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-2",
      "href": "#hr2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check-square-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" OPCIONAIS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-3",
      "href": "#hr3"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-photo"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" MÍDIAS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-4",
      "href": "#hr4"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-paperclip"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" ANEXOS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-5",
      "href": "#hr5"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-list-ul"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" CHECKLIST ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-7",
      "href": "#hr7"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DESPESAS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-8",
      "href": "#hr8"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-clock-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" HISTÓRICO ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-9",
      "href": "#hr9"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-copy"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" FINANCEIRO ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "jarviswidget-loader"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
}]}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-blueLight m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('index')) ? _c('button', {
    staticClass: "btn btn-sm m-r-10 btn-primary pull-right",
    staticStyle: {
      "border-radius": "0px !important",
      "height": "33px !important"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/vehicle-entry')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Ver todos")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    class: 'fa ' + (_vm.searchTermIsDirty ? 'fa-spinner fa-pulse' : 'fa-search')
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "max-height": "150px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.entityEntries.length) ? _vm._l((_vm.entityEntries), function(entry) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(entry.full_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.tenant.tenant_fancy_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.renavam))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.sale_price_formatted))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "1%"
      }
    }, [(_vm.profile.map['vehicle-entries'].includes('edit')) ? _c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'VehicleEntryEdit',
            params: {
              id: entry.id
            }
          })
        }
      }
    }, [_vm._v("\n                          Detalhes\n                        ")]) : _vm._e()])])
  }) : [_c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [(!_vm.searchTerm.length) ? [_c('i', {
    staticClass: "text-info fa fa-2x fa-inbox"
  }), _vm._v(" "), _c('h5', [_vm._v(" Não há veículos para esta unidade.\n                                "), (_vm.profile.map['vehicle-entries'].includes('create')) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.$router.push("/vehicle-entry/create")
      }
    }
  }, [_vm._v("\n                                   Clique aqui para criar nova entrada "), _c('i', {
    staticClass: "fa fa-fw fa-plus-circle"
  })]) : _vm._e()])] : [_c('i', {
    staticClass: "text-info fa fa-2x fa-inbox"
  }), _vm._v(" "), _c('h5', [_vm._v(" Não há veículos para esta busca.\n                                "), (_vm.profile.map['vehicle-entries'].includes('create')) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.searchTerm = ''
      }
    }
  }, [_vm._v("\n                                    Limpar filtro "), _c('i', {
    staticClass: "fa fa-fw fa-times-circle"
  })]) : _vm._e()])]], 2)])])]], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-orange m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm m-r-10 bg-color-orange pull-right",
    staticStyle: {
      "border-radius": "0px !important",
      "height": "33px !important"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Reports',
          params: {
            aba: 'pendencies'
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Ver todos")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "",
      "type": "text"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "height": "150px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.entityEntries), function(entry) {
    return (entry.pendencies.data.filter(function (e) { return !e.completed_at && Number(_vm.user.id) === Number(e.assigned_employee.id_key); }).length > 0) ? _c('tr', [_c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(entry.full_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("\n                        " + _vm._s(entry.pendencies.data.filter(function (e) { return !e.completed_at && Number(_vm.user.id) === Number(e.assigned_employee.id_key); }).length) + " Pendência(s) aguardando ação\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(entry.pendencies.data.filter(function (e) { return e.due && Number(_vm.user.id) === Number(e.assigned_employee.id_key); }).length) ? _c('i', {
      staticClass: "fa fa-warning fa-2x text-danger",
      attrs: {
        "title": "PENDÊNCIA ATRASADA"
      }
    }) : _c('i', {
      staticClass: "fa fa-clock-o text-success fa-2x",
      attrs: {
        "title": "PENDÊNCIA EM DIA"
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: '/vehicle-entry/' + entry.id + '/edit',
            query: {
              a: 'hr6'
            }
          })
        }
      }
    }, [_vm._v("\n                          Verificar pendências\n                        ")])])]) : _vm._e()
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-red m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_vm._m(4), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm m-r-10 bg-color-red pull-right",
    staticStyle: {
      "border-radius": "0px !important",
      "height": "33px !important"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'Reports',
          params: {
            aba: 'pendencies'
          }
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-warning"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Ver todos")])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "",
      "type": "text"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "height": "150px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.entityEntries), function(entry) {
    return (entry.pendencies.data.filter(function (e) { return !e.completed_at; }).length > 0) ? _c('tr', [_c('td', {
      attrs: {
        "width": "40%"
      }
    }, [_vm._v(_vm._s(entry.full_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("\n                        " + _vm._s(entry.pendencies.data.filter(function (e) { return !e.completed_at; }).length) + " Pendência(s) aguardando ação\n                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(entry.pendencies.data.filter(function (e) { return e.due; }).length) ? _c('i', {
      staticClass: "fa fa-warning fa-2x text-danger",
      attrs: {
        "title": "PENDÊNCIA ATRASADA"
      }
    }) : _c('i', {
      staticClass: "fa fa-clock-o text-success fa-2x",
      attrs: {
        "title": "PENDÊNCIA EM DIA"
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: '/vehicle-entry/' + entry.id + '/edit',
            query: {
              a: 'hr6'
            }
          })
        }
      }
    }, [_vm._v("\n                          Verificar pendências\n                        ")])])]) : _vm._e()
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-blue m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    class: 'fa ' + (_vm.searchTermIsDirtyOthersEntities ? 'fa-spinner fa-pulse' : 'fa-search')
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTermOthersEntities),
      expression: "searchTermOthersEntities"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTermOthersEntities)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTermOthersEntities = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "max-height": "150px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('show-details-entries-other-entities')) ? _c('th', [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Ações")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [(_vm.entriesOthersEntities.length) ? _vm._l((_vm.entriesOthersEntities), function(entry) {
    return _c('tr', [_c('td', {
      attrs: {
        "width": "25%"
      }
    }, [_vm._v(_vm._s(entry.fipe_vehicle))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.tenant.tenant_fancy_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "10%"
      }
    }, [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.renavam))]), _vm._v(" "), _c('td', {
      attrs: {
        "width": "15%"
      }
    }, [_vm._v(_vm._s(entry.sale_price_formatted))]), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('show-details-entries-other-entities')) ? _c('td', {
      attrs: {
        "width": "1%"
      }
    }, [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'VehicleEntryEdit',
            params: {
              id: entry.id
            }
          })
        }
      }
    }, [_vm._v("\n                          Detalhes\n                        ")])]) : _vm._e()])
  }) : [_vm._m(13)]], 2)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-lg fa-car"
  }), _vm._v("\n            Últimos 5 carros adicionados no estoque \n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Loja")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" Placa")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-id-card"
  }), _vm._v(" Renavam")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Preço")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-bell fa-lg"
  }), _vm._v("\n              Minhas Pendências\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" Placa")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Pendências")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Situação")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_c('i', {
    staticClass: "fa fa-warning fa-lg"
  }), _vm._v("\n              Veículos com Pendência\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" Placa")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Pendências")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Situação")]), _vm._v(" "), _c('th', [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-archive fa-lg"
  }), _vm._v("\n              Estoque em outras lojas\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Veículo")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-car"
  }), _vm._v(" Ano Fab/Ano Modelo")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-building"
  }), _vm._v(" Unidade")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _vm._v(" Placa")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-id-card"
  }), _vm._v(" Renavam")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Preço")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "5"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "text-info fa fa-2x fa-inbox"
  }), _vm._v(" "), _c('h5', [_vm._v("Não há veículos cadastrados nas demais unidades.")])])])])
}]}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12",
    staticStyle: {
      "margin-bottom": "80px"
    }
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-blue m-t-10",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-12 col-lg-12"
  }, [_c('h6', {
    staticClass: "mb-0 font-weight-thin"
  }, [_vm._v("Exibir/Ocultar Colunas:")]), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.vehicle === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('vehicle'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Veículo ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.vehicle === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.year === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('year'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Mod/Fab ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.year === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.brand === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('brand'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Marca ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.brand === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.plate === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('plate'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Placa ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.plate === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.color === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('color'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("cor ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.color === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.tenant === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('tenant'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Loja ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.tenant === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.price === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('price'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Preço ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.price === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.days === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('days'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Dias em estoque ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.days === true ? 'visibility' : 'visibility_off'))])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mb-2 ml-0 mr-0",
    class: {
      active: _vm.show.vehicle, inactive: !_vm.show.vehicle
    },
    attrs: {
      "small": "",
      "flat": "",
      "outline": "",
      "color": _vm.show.lastAction === true ? 'green' : 'red'
    },
    on: {
      "click": function () { return this$1.toggleCol('lastAction'); }
    }
  }, [_c('span', {
    staticClass: "font-weight-bold body-1"
  }, [_vm._v("Ultima ação ")]), _c('v-icon', {}, [_vm._v(_vm._s(_vm.show.lastAction === true ? 'visibility' : 'visibility_off'))])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive custom-scroll",
    staticStyle: {
      "min-height": "350px",
      "overflow-y": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-condensed table-bordered"
  }, [_c('thead', [_c('tr', {
    staticClass: "pb-0 mb-0"
  }, [(_vm.show.vehicle) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleFilter),
      expression: "vehicleFilter"
    }],
    staticStyle: {
      "padding-left": "5px",
      "border": "1px solid #3333",
      "border-radius": "5px",
      "height": "28px"
    },
    domProps: {
      "value": (_vm.vehicleFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleFilter = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.year) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.yearForSearch,
      "reduce": function (ano) { return ano; },
      "label": "ano"
    },
    model: {
      value: (_vm.yearFilter),
      callback: function($$v) {
        _vm.yearFilter = $$v
      },
      expression: "yearFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.brand) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.brandForSearch,
      "reduce": function (marca) { return marca; },
      "label": "marca"
    },
    model: {
      value: (_vm.brandFilter),
      callback: function($$v) {
        _vm.brandFilter = $$v
      },
      expression: "brandFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.plate) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.plateForSearch,
      "reduce": function (placa) { return placa; },
      "label": "placa"
    },
    model: {
      value: (_vm.plateFilter),
      callback: function($$v) {
        _vm.plateFilter = $$v
      },
      expression: "plateFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.color) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.colorForSearch,
      "reduce": function (cor) { return cor; },
      "label": "cor"
    },
    model: {
      value: (_vm.colorFilter),
      callback: function($$v) {
        _vm.colorFilter = $$v
      },
      expression: "colorFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.tenant) ? _c('th', [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.tenantForSearch,
      "reduce": function (loja) { return loja; },
      "label": "loja"
    },
    model: {
      value: (_vm.tenantFilter),
      callback: function($$v) {
        _vm.tenantFilter = $$v
      },
      expression: "tenantFilter"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.show.price) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.priceFilter),
      expression: "priceFilter"
    }],
    staticStyle: {
      "width": "70px",
      "padding-left": "5px",
      "border": "1px solid #3333",
      "border-radius": "5px",
      "height": "28px"
    },
    domProps: {
      "value": (_vm.priceFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.priceFilter = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.days) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.daysFilter),
      expression: "daysFilter"
    }],
    staticStyle: {
      "width": "50px",
      "padding-left": "5px",
      "border": "1px solid #3333",
      "border-radius": "5px",
      "height": "28px"
    },
    domProps: {
      "value": (_vm.daysFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.daysFilter = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.show.lastAction) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lastActionFilter),
      expression: "lastActionFilter"
    }],
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "padding-left": "5px",
      "border": "1px solid #3333",
      "border-radius": "5px",
      "height": "28px"
    },
    domProps: {
      "value": (_vm.lastActionFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lastActionFilter = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.actionsFilter),
      expression: "actionsFilter"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.actionsFilter) ? _vm._i(_vm.actionsFilter, null) > -1 : (_vm.actionsFilter)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.actionsFilter,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.actionsFilter = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.actionsFilter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.actionsFilter = $$c
        }
      }
    }
  }), _vm._v(" Reservados\n                ")])])]), _vm._v(" "), _c('thead', [_c('tr', [(_vm.show.vehicle) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Veículo")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.ordenaDisable,
      "small": "",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.vehicleSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.show.year) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Mod/Fab")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.ordenaDisable,
      "small": "",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.yearSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.show.brand) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Brand")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.ordenaDisable,
      "small": "",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.brandSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.show.plate) ? _c('th', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.show.color) ? _c('th', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.show.tenant) ? _c('th', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.show.price) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Preço")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": _vm.ordenaDisable,
      "small": "",
      "icon": "",
      "flat": ""
    },
    on: {
      "click": _vm.priceSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.show.days) ? _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', [_vm._v("Dias em estoque")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "disabled": _vm.ordenaDisable
    },
    on: {
      "click": _vm.daysSort
    }
  }, [(_vm.ordena) ? _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_upward")]) : _c('v-icon', {
    staticClass: "mb-1",
    attrs: {
      "size": "17"
    }
  }, [_vm._v("arrow_downward")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.show.lastAction) ? _c('th', [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "min-height": "700px",
      "max-width": "100%"
    }
  }, [(_vm.entriesOthersEntities.length) ? _vm._l((_vm.filteredEntries), function(entry, i) {
    return _c('tr', {
      key: i + 'table',
      staticStyle: {
        "min-height": "700px",
        "max-width": "100%"
      }
    }, [(_vm.show.vehicle) ? _c('td', [_vm._v(_vm._s(entry.full_name) + " ")]) : _vm._e(), _vm._v(" "), (_vm.show.year) ? _c('td', [_vm._v(_vm._s(entry.fabrication_year))]) : _vm._e(), _vm._v(" "), (_vm.show.brand) ? _c('td', [_vm._v(_vm._s(entry.brand))]) : _vm._e(), _vm._v(" "), (_vm.show.plate) ? _c('td', [_vm._v(_vm._s(entry.plate))]) : _vm._e(), _vm._v(" "), (_vm.show.color) ? _c('td', [_vm._v(_vm._s(entry.color))]) : _vm._e(), _vm._v(" "), (_vm.show.tenant) ? _c('td', [_vm._v(_vm._s(entry.tenant_fancy_name))]) : _vm._e(), _vm._v(" "), (_vm.show.price) ? _c('td', [_vm._v("R$ " + _vm._s(entry.sale_price))]) : _vm._e(), _vm._v(" "), (_vm.show.days) ? _c('td', {
      class: {
        overdue: _vm.totalOfDays(entry.created_at) >= 60
      }
    }, [_vm._v(_vm._s(_vm.totalOfDays(entry.created_at)))]) : _vm._e(), _vm._v(" "), (_vm.show.lastAction) ? _c('td', [_vm._v(_vm._s(entry.description))]) : _vm._e(), _vm._v(" "), _c('td', [(_vm.profile.map['vehicle-entries'].includes('info')) ? _c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            name: 'VehicleEntryEdit',
            params: {
              id: entry.id
            }
          })
        }
      }
    }, [_vm._v("Detalhes")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.abreReserva(entry)
        }
      }
    }, [(entry.state_id === 3) ? _c('span', {
      staticClass: "red--text"
    }, [_vm._v("Reservado")]) : _c('span', {
      staticClass: "green--text"
    }, [_vm._v("Reservar")])])])])
  }) : [_vm._m(6)]], 2)])])])])]), _vm._v(" "), _c('Reserva')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "block",
      "width": "100%"
    }
  }, [_c('strong', [_c('i', {
    staticClass: "fa fa-archive fa-lg"
  }), _vm._v("\n          Veículos disponíveis\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Placa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Cor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Loja")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Última Ação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "nowrap",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "mb-2"
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "10"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "text-info fa fa-2x fa-inbox"
  }), _vm._v(" "), _c('h5', [_vm._v("Não há veículos cadastrados")])])])])
}]}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [(_vm.profile.map['vehicle-entries'].includes('create-expense') || _vm.profile.map['vehicle-entries'].includes('edit-expense')) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "order-by": field.orderBy,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-md-4 pull-right"
  }, [(typeof(_vm.private_id) === 'undefined' && _vm.profile.map['vehicle-entries'].includes('create-expense')) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Criar nova despesa\n          ")]) : (typeof(_vm.private_id) !== 'undefined' && _vm.profile.map['vehicle-entries'].includes('edit-expense')) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar Despesa\n          ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('create-expense') || _vm.profile.map['vehicle-entries'].includes('edit-expense')) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.reset
    }
  }, [(typeof(_vm.private_id) === 'undefined') ? _c('span', [_c('i', {
    staticClass: "fa fa-eraser"
  }), _vm._v(" Limpar\n              ")]) : _c('span', [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancelar Edição\n              ")])]) : _vm._e()])], 2) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('h4', [_vm._v("Despesas: " + _vm._s(_vm.numeral(_vm.totalAmountExpenses).format('$ 0,0.00')))]), _vm._v(" "), _c('h5', {
    staticClass: "text-success"
  }, [_vm._v("Pago: " + _vm._s(_vm.numeral(_vm.totalAmountPago).format('$ 0,0.00')))]), _vm._v(" "), _c('h5', {
    staticClass: "text-danger"
  }, [_vm._v("A pagar: " + _vm._s(_vm.numeral(_vm.totalAmountPendente).format('$ 0,0.00')))])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "hr2"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#iss1",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning text-danger"
  }), _vm._v(" A pagar (" + _vm._s(_vm.pendente.length) + ")\n          ")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#iss2",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" Pago (" + _vm._s(_vm.pago.length) + ")\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content padding-10"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "iss1"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.pendente), function(expense, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/expense-types/" + (expense.expense_type.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-window-restore"
    }), _vm._v(" " + _vm._s(expense.expense_type.description) + "\n                  ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/customers/" + (expense.customer.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v("\n                      " + _vm._s(expense.customer.name) + " (" + _vm._s(expense.customer.cpf) + ")\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(expense.amount))]), _vm._v(" "), _c('td', [(_vm.profile.map['vehicle-entries'].includes('edit-expense')) ? _c('a', {
      staticClass: "btn btn-default padding-5",
      on: {
        "click": function($event) {
          return _vm.edit(expense)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Editar\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('delete-expense')) ? _c('a', {
      staticClass: "btn btn-danger padding-5",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(expense.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir\n                  ")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "iss2"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.pago), function(expense, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/expense-types/" + (expense.expense_type.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-window-restore"
    }), _vm._v(" " + _vm._s(expense.expense_type.description) + "\n                  ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/customers/" + (expense.customer.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v("\n                      " + _vm._s(expense.customer.name) + " (" + _vm._s(expense.customer.cpf) + ")\n                  ")])], 1), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(expense.amount))]), _vm._v(" "), _c('td', [(typeof(_vm.private_id) === 'undefined' && _vm.profile.map['vehicle-entries'].includes('edit-expense')) ? _c('a', {
      staticClass: "btn btn-default padding-5",
      on: {
        "click": function($event) {
          return _vm.edit(expense)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Editar\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('delete-expense')) ? _c('a', {
      staticClass: "btn btn-danger padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(expense.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir\n                  ")]) : _vm._e()])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Tipo de Despesa")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Fornecedor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Tipo de Despesa")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Fornecedor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Ações")])])])
}]}

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": 'main-form-' + this.group
    }
  }, [_c('section', {
    staticClass: "col col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "value": "pf",
      "checked": "checked",
      "autocomplete": "off",
      "name": "type"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "pf")
    },
    on: {
      "change": function($event) {
        _vm.type = "pf"
      }
    }
  }), _vm._v(" Pessoa Física\n          ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "type": "radio",
      "value": "pj",
      "autocomplete": "off",
      "name": "type"
    },
    domProps: {
      "checked": _vm._q(_vm.type, "pj")
    },
    on: {
      "change": function($event) {
        _vm.type = "pj"
      }
    }
  }), _vm._v("Pessoa Jurídica\n              "), _vm._m(1)])]), _vm._v(" "), _vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field['name'] === 'cpf' && _vm.type === 'pf' ? field.mask : field['name'] === 'cpf' && _vm.type === 'pj' ? '11.111.111/1111-11' : field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Tipo de cadastro\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("   "), _c('span', {
    staticStyle: {
      "display": "none"
    }
  })])
}]}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-reply fa-fw"
  }), _vm._v("  Devolução de veículo consignado\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: '/vehicle-entry'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), (_vm.filhocarregado) ? _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.$refs.tenantForm.distributed_ok,
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Devolução\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('tenant-form', {
    ref: "tenantForm",
    attrs: {
      "readonly": _vm.readonly
    },
    on: {
      "carregado": _vm.carregado
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-reply"
  })])
}]}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper-breadcrumb col-xs-12 col-sm-7 col-md-7 col-lg-4"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, _vm._l((_vm.trackList), function(track, index) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: track.url
        }
      }
    }, [_c('i', {
      class: 'fa fa-' + track.icon
    }), _vm._v("\n          " + _vm._s(track.label) + "\n        ")])], 1)
  }), 0)]), _vm._v(" "), (_vm.currentRoute === '/') ? _c('div', {
    staticClass: "wrapper-indicators col-xs-12 col-sm-5 col-md-5 col-lg-8"
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    attrs: {
      "id": "sparks"
    }
  }, [_c('li', {
    staticClass: "sparks-info"
  }, [_c('h5', [_vm._v(" Negociações em andamento "), _c('span', {
    staticClass: "txt-color-blue"
  }, [_vm._v("R$ 0")])])]), _vm._v(" "), _c('li', {
    staticClass: "sparks-info"
  }, [_c('h5', [_vm._v(" Neg. Pendentes\n          "), _c('span', {
    staticClass: "txt-color-purple"
  }, [_vm._v("\n               0%\n          ")])])]), _vm._v(" "), _c('li', {
    staticClass: "sparks-info"
  }, [_c('h5', [_vm._v("\n          Neg. Concluídas "), _c('span', {
    staticClass: "txt-color-greenDark"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v(" 0")])]), _vm._v(" "), _c('div', {
    staticClass: "sparkline txt-color-greenDark hidden-mobile hidden-md hidden-sm"
  })])])
}]}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n      "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n        ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n        ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-sortable",
    attrs: {
      "id": "wid-id-11",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-togglebutton": "false",
      "data-widget-deletebutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "role": "widget"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "tab-content m-b-10 padding-10"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "hr1"
    }
  }, [_c('custom-form', {
    ref: "customFormPersonalData",
    attrs: {
      "group": 1,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr2"
    }
  }, [_c('custom-form', {
    ref: "customFormOffice",
    attrs: {
      "group": 2,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr3"
    }
  }, [_c('custom-form', {
    ref: "customFormGuaranter",
    attrs: {
      "group": 3,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticClass: "pull-right",
    staticStyle: {
      "right": "20px"
    }
  }, [_c('strong', [_vm._v("DADOS DO CLIENTE")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "widget-tab-1"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-1",
      "href": "#hr1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-address-card-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS GERAIS ")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-2",
      "href": "#hr2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-briefcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS PROFISSIONAIS ")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-3",
      "href": "#hr3"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" CÔNJUGE/AVALISTA ")])])])]), _vm._v(" "), _c('span', {
    staticClass: "jarviswidget-loader"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])
}]}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.tenantForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  Lojas\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/tenants/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da Loja\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('tenant-form', {
    ref: "tenantForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['expense-types'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['expense-types'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
      return _c('td', [(field.component !== 'entity-field') ? [_vm._v("\n                      " + _vm._s(model[field.name]) + "\n                      ")] : (field.component === 'entity-field') ? [(model[field['resourceKey']] !== null) ? [_vm._v("\n                          " + _vm._s(model[field['resourceKey']][field['usingAsLabel']]) + "\n                        ")] : _vm._e()] : _vm._e()], 2)
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['expense-types'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['expense-types'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['expense-types'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])], 2)
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.availableTenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.userTenants),
        expression: "userTenants"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id,
        "checked": Array.isArray(_vm.userTenants) ? _vm._i(_vm.userTenants, tenant.id) > -1 : (_vm.userTenants)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.userTenants,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.userTenants = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.userTenants = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.userTenants = $$c
          }
        }
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n            ")])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-lg fa-building"
  }), _vm._v(" Unidades")])
}]}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form form-inline",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('entity-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Cliente",
      "usingAsProvider": "/customers",
      "usingAsLabel": "name",
      "usingAsValue": "id",
      "orderBy": "name",
      "icon": "user",
      "wrapperClass": "col-lg-12",
      "placeholder": "Selecione o Cliente",
      "name": "customer_id",
      "custom-error": _vm.errors.first('customer_id'),
      "valid": _vm.fields.valid('customer_id'),
      "failed": _vm.fields.failed('customer_id')
    },
    model: {
      value: (_vm.customer_id),
      callback: function($$v) {
        _vm.customer_id = $$v
      },
      expression: "customer_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('entity-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "Veículo",
      "usingAsProvider": '/entries-by-tenant/' + _vm.currentTenant + '?only-available=true',
      "usingAsLabel": "fipe_vehicle_renavam_plate",
      "usingAsValue": "id_key",
      "orderBy": "fipe_vehicle",
      "icon": "car",
      "wrapperClass": "col-lg-12",
      "placeholder": "Selecione o Veículo",
      "name": "entry_id",
      "custom-error": _vm.errors.first('entry_id'),
      "valid": _vm.fields.valid('entry_id'),
      "failed": _vm.fields.failed('entry_id')
    },
    model: {
      value: (_vm.entry_id),
      callback: function($$v) {
        _vm.entry_id = $$v
      },
      expression: "entry_id"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.payment_methods), function(payment_method, index) {
    return _c('section', [_c('div', {
      staticClass: "col-md-12"
    }, [_c('label', [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_methods_selected),
        expression: "payment_methods_selected"
      }],
      attrs: {
        "data-vv-name": "payment_methods_selected",
        "type": "checkbox",
        "disabled": !_vm.entry_id,
        "name": "payment_methods_selected"
      },
      domProps: {
        "value": payment_method.id_key,
        "checked": Array.isArray(_vm.payment_methods_selected) ? _vm._i(_vm.payment_methods_selected, payment_method.id_key) > -1 : (_vm.payment_methods_selected)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.payment_methods_selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = payment_method.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.payment_methods_selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.payment_methods_selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.payment_methods_selected = $$c
          }
        }, function($event) {
          return _vm.selectPayment(index)
        }]
      }
    }), _vm._v(" " + _vm._s(payment_method.description) + "\n        ")])]), _vm._v(" "), _c('div', [_c('label', {
      staticClass: "input col-md-2"
    }, [(_vm.payment_methods_selected.includes(payment_method.id_key)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.values_payments[index]),
        expression: "values_payments[index]"
      }],
      attrs: {
        "placeholder": "Valor",
        "name": "values_payments"
      },
      domProps: {
        "value": (_vm.values_payments[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.values_payments, index, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.payment_methods_selected.includes(payment_method.id_key) && typeof(_vm.values_payments[index]) !== 'undefined' && _vm.values_payments[index].match(/^-?\d*(.\d+,?\d*)?%?$/) === null) ? _c('span', [_vm._v("Valor inválido")]) : _vm._e()]), _vm._v(" "), _c('label', {
      staticClass: "input col-md-2",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [(_vm.payment_methods_selected.includes(payment_method.id_key)) ? _c('masked-input', {
      attrs: {
        "placeholder": "Data",
        "type": "text",
        "autocomplete": "off",
        "name": "date",
        "mask": "11/11/1111"
      },
      model: {
        value: (_vm.date_payments[index]),
        callback: function($$v) {
          _vm.$set(_vm.date_payments, index, $$v)
        },
        expression: "date_payments[index]"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('label', {
      staticClass: "input col-md-7",
      staticStyle: {
        "margin-left": "5px"
      }
    }, [(_vm.payment_methods_selected.includes(payment_method.id_key)) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.details_payments[index]),
        expression: "details_payments[index]"
      }],
      attrs: {
        "placeholder": "Observação",
        "name": "values_payments"
      },
      domProps: {
        "value": (_vm.details_payments[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.details_payments, index, $event.target.value)
        }
      }
    }) : _vm._e()])])])
  }), _vm._v(" "), _c('section', {
    staticClass: "col-md-12"
  }, [(_vm.errors.has('payment_methods_selected')) ? _c('span', [_c('i', {
    staticClass: "fa fa-warning text-danger"
  }), _vm._v(" " + _vm._s(_vm.errors.first('payment_methods_selected')) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "col-md-8",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.distributed_value),
      expression: "distributed_value"
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.distributed_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.distributed_value = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.distributed_ok) ? _c('span', [_vm._v("Distribuição concluída com sucesso.")]) : _c('span', [_vm._v("Total distribuído deve ser igual ou maior ao preço (" + _vm._s(_vm.price) + ") ")])]), _vm._v(" "), _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('section', {
    staticClass: "col-md-8",
    staticStyle: {
      "margin-right": "20px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('label', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sale_price_formatted),
      expression: "sale_price_formatted"
    }],
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.sale_price_formatted)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sale_price_formatted = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('section', {
    staticClass: "col-md-3"
  }, [_c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('span', [_vm._v("Desconto "), (_vm.entry_id) ? _c('span', [_vm._v("(máximo: " + _vm._s(_vm.discount_max) + ")")]) : _vm._e()])]), _vm._v(" "), _c('label', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    attrs: {
      "disabled": !_vm.entry_id,
      "type": "text"
    },
    domProps: {
      "value": (_vm.discount)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.discount = $event.target.value
      }, _vm.validateDiscount]
    }
  })]), _vm._v(" "), (_vm.invalid_discount) ? _c('span', [_vm._v("Valor do desconto inválido")]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('label', {
    staticClass: "input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.final_price_label
    }
  })]), _vm._v(" "), _c('span', [_vm._v(" ")])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('span', [_vm._v("Total distribuído")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('span', [_vm._v("Preço")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label"
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('span', [_vm._v("Preço Final")])])
}]}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(this.defaultSingularResource.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.form.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  Planos\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/account-plans')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/account-plans/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do Plano de conta\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('account-plan-form', {
    ref: "form",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(1), _vm._v(" "), _c('h2', [_vm._v("\n        Detalhes da Loja\n      ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n      ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n      ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [(_vm.profile.map['general-expenses'].includes('create') || _vm.profile.map['general-expenses'].includes('edit')) ? _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (field.rules),
        expression: "field.rules"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "order-by": field.orderBy,
        "placeholder": field.placeholder,
        "readonly": _vm.checkReadOnly(field),
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "col col-md-4 pull-right"
  }, [(typeof(_vm.private_id) === 'undefined' && _vm.profile.map['general-expenses'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" Criar nova despesa\n                ")]) : (typeof(_vm.private_id) !== 'undefined' && _vm.profile.map['general-expenses'].includes('edit')) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.create
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Editar Despesa\n                ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['general-expenses'].includes('create') || _vm.profile.map['general-expenses'].includes('edit')) ? _c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "padding": "4px 14px"
    },
    on: {
      "click": _vm.reset
    }
  }, [(typeof(_vm.private_id) === 'undefined') ? _c('span', [_c('i', {
    staticClass: "fa fa-eraser"
  }), _vm._v(" Limpar\n                    ")]) : _c('span', [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Cancelar Edição\n                    ")])]) : _vm._e()])], 2) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.profile.map['general-expenses'].includes('index')) ? _c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "hr2"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#iss1",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-warning text-danger"
  }), _vm._v(" A pagar (" + _vm._s(_vm.pendente.length) + ")\n                ")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#iss2",
      "data-toggle": "tab"
    }
  }, [_c('i', {
    staticClass: "fa fa-check text-success"
  }), _vm._v(" Pago (" + _vm._s(_vm.pago.length) + ")\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content padding-10"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "iss1"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.pendente), function(expense, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/expense-types/" + (expense.expense_type.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-window-restore"
    }), _vm._v(" " + _vm._s(expense.expense_type.description) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/customers/" + (expense.customer.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v("\n                            " + _vm._s(expense.customer.name) + " (" + _vm._s(expense.customer.cpf) + ")\n                        ")])], 1), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(expense.amount))]), _vm._v(" "), _c('td', [(_vm.profile.map['general-expenses'].includes('edit')) ? _c('a', {
      staticClass: "btn btn-default padding-5",
      on: {
        "click": function($event) {
          return _vm.edit(expense)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Editar\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['general-expenses'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-danger padding-5",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(expense.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir\n                        ")]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "iss2"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.pago), function(expense, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/expense-types/" + (expense.expense_type.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-window-restore"
    }), _vm._v(" " + _vm._s(expense.expense_type.description) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("/customers/" + (expense.customer.id) + "/edit")
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    }), _vm._v("\n                            " + _vm._s(expense.customer.name) + " (" + _vm._s(expense.customer.cpf) + ")\n                        ")])], 1), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(expense.amount))]), _vm._v(" "), _c('td', [(typeof(_vm.private_id) === 'undefined' && _vm.profile.map['general-expenses'].includes('edit')) ? _c('a', {
      staticClass: "btn btn-default padding-5",
      on: {
        "click": function($event) {
          return _vm.edit(expense)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" Editar\n                        ")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger padding-5",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.destroy(expense.id) && _vm.profile.map['general-expenses'].includes('delete')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir\n                        ")])])])
  }), 0)])])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-book"
  }), _vm._v("  Despesas Gerais\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-book"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Tipo de Despesa")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Fornecedor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "1%"
    }
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Tipo de Despesa")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Fornecedor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "19%"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Ações")])])])
}]}

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['profiles'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['profiles'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
      return _c('td', [(field.component !== 'entity-field') ? [_vm._v("\n                      " + _vm._s(model[field.name]) + "\n                      ")] : (field.component === 'entity-field') ? [(model[field['resourceKey']] !== null) ? [_vm._v("\n                          " + _vm._s(model[field['resourceKey']][field['usingAsLabel']]) + "\n                        ")] : _vm._e()] : _vm._e()], 2)
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['profiles'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['profiles'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])], 2)
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-car'
  }), _vm._v("  Entrada de Veículos\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-car'
  }), _vm._v("\n              Lista de entradas de veículos cadastradas\n              "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['vehicle-entries'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push("/vehicle-entry/create")
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova Entrada de veículo")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(1, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['brand']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['model']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['fabrication_year']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['color']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['plate']))]), _vm._v(" "), _c('td', [(model['state_id'] == 1) ? _c('span', {
      staticClass: "label label-success"
    }, [_vm._v("\n                        " + _vm._s(model['state_label']) + "\n                      ")]) : (model['state_id'] == 2) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n                        " + _vm._s(model['state_label']) + "\n                      ")]) : (model['state_id'] == 3) ? _c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("\n                        Reservado\n                      ")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model['sale_price_formatted']))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(model.consigned == 1) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "title": "Devolver Veículo Consignado",
        "to": {
          path: ("/vehicle-entry/" + (model.id) + "/return")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-reply"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btn-group"
    }, [_vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, _vm._l((_vm.templates), function(template) {
      return _c('li', [_c('a', {
        attrs: {
          "href": "#",
          "title": template.name
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.showTemplate(template.id, model['id_key'])
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-file-o"
      }), _vm._v(" " + _vm._s(template.name))])])
    }), 0)]), _vm._v(" "), (model.state_id === 3 || model.state_id === 1 && _vm.profile.map['vehicle-sale'].includes('create')) ? _c('a', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Iniciar uma Nova Venda"
      },
      on: {
        "click": function($event) {
          return _vm.enviaParaVenda(model)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-dollar"
    })]) : _vm._e(), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "title": "Editar Dados do Veículo",
        "to": {
          path: ("vehicle-entry/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "title": "Excluir Entrada"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-trash"
    })]) : _vm._e()], 1)])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_vm._v("Cor")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v("Preço de Venda")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "title": "Emitir Documentos",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-file-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(this.defaultSingularResource.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchField),
      expression: "searchField"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-by-plate",
      "placeholder": "Placa do Veículo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchField)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchField = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-block btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.search($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar\n          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [(typeof(_vm.vehicle.id) !== 'undefined') ? _c('edit-page', {
    attrs: {
      "expense-vehicle-plate": true
    }
  }) : _c('div', {
    staticClass: "jarviswidget jarviswidget-sortable",
    attrs: {
      "id": "wid-id-0",
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_vm._v("Veículo Não localizado")])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-car"
  }), _vm._v(" \n    Despesas de veículo\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" Placa\n        ")])
}]}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "widget-body",
    staticStyle: {
      "margin": "15px"
    }
  }, [_c('div', {
    staticClass: "panel-group smart-accordion-default",
    attrs: {
      "id": "accordion"
    }
  }, [(_vm.profile.map['reports'].includes('entries')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c1"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "c1"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [(_vm.registry.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_vm._v(" Valor Total de Aquisições\n                      "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.entries_values.total_mean_price
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_vm._v(" Valor Total de Vendas\n                      "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.entries_values.total_sale_price
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('entries')
      }
    },
    model: {
      value: (_vm.date_entries_first),
      callback: function($$v) {
        _vm.date_entries_first = $$v
      },
      expression: "date_entries_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('entries')
      }
    },
    model: {
      value: (_vm.date_entries_end),
      callback: function($$v) {
        _vm.date_entries_end = $$v
      },
      expression: "date_entries_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('entries')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.acquisition_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.color))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.mean_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.sale_price))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.profile.map['reports'].includes('sales')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c2"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "c2"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [(_vm.registry.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_vm._v(" Valor Total de Aquisições\n                      "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.entries_values.total_mean_price
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_vm._v(" Valor Total de Vendas\n                      "), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.entries_values.total_sale_price
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales')
      }
    },
    model: {
      value: (_vm.date_sales_first),
      callback: function($$v) {
        _vm.date_sales_first = $$v
      },
      expression: "date_sales_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales')
      }
    },
    model: {
      value: (_vm.date_sales_end),
      callback: function($$v) {
        _vm.date_sales_end = $$v
      },
      expression: "date_sales_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('sales')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(3), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.creation_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.color))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.mean_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.sale_price))])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.profile.map['reports'].includes('stock')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    staticClass: "collapsed",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c3"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    attrs: {
      "id": "c3"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('stopped_entries')
      }
    },
    model: {
      value: (_vm.date_stopped_entries_first),
      callback: function($$v) {
        _vm.date_stopped_entries_first = $$v
      },
      expression: "date_stopped_entries_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('stopped_entries')
      }
    },
    model: {
      value: (_vm.date_stopped_entries_end),
      callback: function($$v) {
        _vm.date_stopped_entries_end = $$v
      },
      expression: "date_stopped_entries_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('stopped_entries')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.creation_date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fabrication_year))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.color))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.mean_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.sale_price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.due) + " dias")])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.profile.map['reports'].includes('pendencies')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'pendencies'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c4"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'pendencies'
    },
    attrs: {
      "id": "c4"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('pendencies')
      }
    },
    model: {
      value: (_vm.date_pendencies_first),
      callback: function($$v) {
        _vm.date_pendencies_first = $$v
      },
      expression: "date_pendencies_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('pendencies')
      }
    },
    model: {
      value: (_vm.date_pendencies_end),
      callback: function($$v) {
        _vm.date_pendencies_end = $$v
      },
      expression: "date_pendencies_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('pendencies')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(entry.fipe_brand))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.fipe_model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.total))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.$router.push({
            path: '/vehicle-entry/' + entry.id + '/edit'
          })
        }
      }
    }, [_vm._v("\n                            Verificar pendências\n                          ")])])])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.profile.map['reports'].includes('sales-by-user')) ? _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'employee-sales'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c5"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'employee-sales'
    },
    attrs: {
      "id": "c5"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('employee-sales')
      }
    },
    model: {
      value: (_vm.date_employee_sales_first),
      callback: function($$v) {
        _vm.date_employee_sales_first = $$v
      },
      expression: "date_employee_sales_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('employee-sales')
      }
    },
    model: {
      value: (_vm.date_employee_sales_end),
      callback: function($$v) {
        _vm.date_employee_sales_end = $$v
      },
      expression: "date_employee_sales_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-12"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employee_sales_user),
      expression: "employee_sales_user"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.employee_sales_user = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.validateEntries('employee-sales')
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("Todos")]), _vm._v(" "), _vm._l((_vm.employees_sales_list), function(employee) {
    return _c('option', {
      domProps: {
        "value": employee.id_key
      }
    }, [_vm._v("\n                          " + _vm._s(employee.name) + " (" + _vm._s(employee.login) + ")\n                        ")])
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('employee-sales')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(9), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return (_vm.current === 'employee-sales') ? _c('tr', [_c('td', [_vm._v(_vm._s(entry[0].name))]), _vm._v(" "), _c('td', _vm._l((entry), function(sale) {
      return _c('div', [_vm._v("\n                        " + _vm._s(sale.fipe_vehicle) + " - PLACA: " + _vm._s(sale.plate) + " | "), _c('span', {
        staticClass: "label label-success"
      }, [_vm._v("Total da Venda: " + _vm._s(_vm.numeral(sale.total).format('$ 0,0.00')))]), _vm._v(" "), _c('label', {
        staticClass: "label label-info"
      }, [_vm._v("\n                           Comissão: " + _vm._s(_vm.numeral(sale.commission).format('$ 0,0.00')) + "\n                        ")])])
    }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numeral(entry[0].total_geral).format('$ 0,0.00')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.numeral(entry[0].comission_geral).format('$ 0,0.00')))])]) : _vm._e()
  }), 0)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'expenses-vehicles'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c6"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'expenses-vehicles'
    },
    attrs: {
      "id": "c6"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('expenses-vehicles')
      }
    },
    model: {
      value: (_vm.date_vehicle_expenses_first),
      callback: function($$v) {
        _vm.date_vehicle_expenses_first = $$v
      },
      expression: "date_vehicle_expenses_first"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('expenses-vehicles')
      }
    },
    model: {
      value: (_vm.date_vehicle_expenses_end),
      callback: function($$v) {
        _vm.date_vehicle_expenses_end = $$v
      },
      expression: "date_vehicle_expenses_end"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expense_vehicle_state_selected),
      expression: "expense_vehicle_state_selected"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.expense_vehicle_state_selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.validateEntries('expenses-vehicles')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                          <== Selecione ==>\n                        ")]), _vm._v(" "), _vm._l((_vm.expenses_vehicles_states), function(state) {
    return _c('option', {
      domProps: {
        "value": state.id
      }
    }, [_vm._v("\n                          " + _vm._s(state.label) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expense_vehicles_vendor_selected),
      expression: "expense_vehicles_vendor_selected"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.expense_vehicles_vendor_selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.validateEntries('expenses-vehicles')
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                          <== Selecione um fornecedor ==>\n                        ")]), _vm._v(" "), _vm._l((_vm.expense_vehicles_vendors), function(vendor) {
    return _c('option', {
      domProps: {
        "value": vendor.id_key
      }
    }, [_vm._v("\n                          " + _vm._s(vendor.name_with_cpf) + "\n                        ")])
  })], 2)])]), _vm._v(" "), _c('section', {
    staticClass: "col col-12"
  }, [_c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.tenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.entries_tenant),
        expression: "entries_tenant"
      }],
      attrs: {
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.entries_tenant) ? _vm._i(_vm.entries_tenant, tenant.id_key) > -1 : (_vm.entries_tenant)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.entries_tenant,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.entries_tenant = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.entries_tenant = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.entries_tenant = $$c
          }
        }, function($event) {
          return _vm.validateEntries('expenses-vehicles')
        }]
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n                        ")])]
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(entry) {
    return (_vm.current === 'expenses-vehicles') ? _c('tr', {
      class: {
        'bg-success': entry.paid, 'bg-danger': !entry.paid
      }
    }, [_c('td', [_vm._v(_vm._s(entry.date))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": ("vehicle-entry/" + (entry.id) + "/edit")
      }
    }, [_vm._v("\n                          " + _vm._s(entry.plate) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(entry.vendor))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("R$ " + _vm._s(entry.amount))])]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'sales-ranking-tenant'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c7"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(12)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'sales-ranking-tenant'
    },
    attrs: {
      "id": "c7"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales-ranking-tenant')
      }
    },
    model: {
      value: (_vm.date_ranking_sales_tenant_initial),
      callback: function($$v) {
        _vm.date_ranking_sales_tenant_initial = $$v
      },
      expression: "date_ranking_sales_tenant_initial"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales-ranking-tenant')
      }
    },
    model: {
      value: (_vm.date_ranking_sales_tenant_end),
      callback: function($$v) {
        _vm.date_ranking_sales_tenant_end = $$v
      },
      expression: "date_ranking_sales_tenant_end"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(13), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(tenant) {
    return (_vm.current === 'sales-ranking-tenant') ? _c('tr', [_c('td', [_vm._v(_vm._s(tenant.tenant_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tenant.tenant_fancy_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("R$ " + _vm._s(tenant.total))])]) : _vm._e()
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_c('a', {
    class: {
      'collapsed': _vm.current !== 'sales-ranking-employee'
    },
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#c8"
    },
    on: {
      "click": _vm.clear_all
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-angle-up pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-lg fa-angle-down pull-right"
  }), _vm._v(" "), _vm._m(14)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse",
    class: {
      'in': _vm.current === 'sales-ranking-employee'
    },
    attrs: {
      "id": "c8"
    }
  }, [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "novalidate": "novalidate"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data inicial",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales-ranking-employee')
      }
    },
    model: {
      value: (_vm.date_ranking_sales_employee_initial),
      callback: function($$v) {
        _vm.date_ranking_sales_employee_initial = $$v
      },
      expression: "date_ranking_sales_employee_initial"
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "col col-md-6"
  }, [_c('label', {
    staticClass: "input"
  }, [_c('i', {
    staticClass: "icon-append fa fa-calendar"
  }), _vm._v(" "), _c('masked-input', {
    attrs: {
      "placeholder": "Data final",
      "type": "text",
      "autocomplete": "off",
      "name": "date",
      "mask": "11/11/1111"
    },
    on: {
      "input": function($event) {
        return _vm.validateEntries('sales-ranking-employee')
      }
    },
    model: {
      value: (_vm.date_ranking_sales_employee_end),
      callback: function($$v) {
        _vm.date_ranking_sales_employee_end = $$v
      },
      expression: "date_ranking_sales_employee_end"
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body no-padding",
    staticStyle: {
      "margin-top": "10px",
      "margin-bottom": "10px"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-condensed"
  }, [_vm._m(15), _vm._v(" "), _c('tbody', _vm._l((_vm.registry), function(user) {
    return (_vm.current === 'sales-ranking-employee') ? _c('tr', [_c('td', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("R$ " + _vm._s(user.total))])]) : _vm._e()
  }), 0)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-sign-in"
  }), _vm._v(" Entrada de Veículos\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data de Aquisição")]), _vm._v(" "), _c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_vm._v("Cor")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Valor da Aquisição")]), _vm._v(" "), _c('th', [_vm._v("Valor de Venda")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  }), _vm._v(" Vendas\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data da Venda")]), _vm._v(" "), _c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_vm._v("Cor")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Valor da Aquisição")]), _vm._v(" "), _c('th', [_vm._v("Valor Vendido")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-car"
  }), _vm._v(" Estoque parado\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Criado em")]), _vm._v(" "), _c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Ano Fab/Ano Modelo")]), _vm._v(" "), _c('th', [_vm._v("Cor")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Valor da Aquisição")]), _vm._v(" "), _c('th', [_vm._v("Valor de Venda")]), _vm._v(" "), _c('th', [_vm._v("Parado há")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-warning"
  }), _vm._v(" Pendências\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Marca")]), _vm._v(" "), _c('th', [_vm._v("Modelo")]), _vm._v(" "), _c('th', [_vm._v("Placa")]), _vm._v(" "), _c('th', [_vm._v("Pendências")]), _vm._v(" "), _c('th', [_vm._v("Ver detalhes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-user"
  }), _vm._v(" Vendas Por Vendedor\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Vendas")]), _vm._v(" "), _c('th', [_vm._v("Total Vendido")]), _vm._v(" "), _c('th', [_vm._v("Comissão Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-money"
  }), _vm._v(" Despesas de Veículos\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Data de vencimento")]), _vm._v(" "), _c('th', [_vm._v("Veículo")]), _vm._v(" "), _c('th', [_vm._v("Despesa")]), _vm._v(" "), _c('th', [_vm._v("Fornecedor")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-building"
  }), _vm._v(" Ranking de Vendas por loja\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome Fantasia")]), _vm._v(" "), _c('th', [_vm._v("Razão Social")]), _vm._v(" "), _c('th', [_vm._v("Total em Vendas")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-lg fa-user"
  }), _vm._v(" Ranking de Vendas por vendedor\n                   ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "75%"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Total em Vendas")])])])
}]}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('section', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Imagem")]), _vm._v(" "), _c('div', {
    staticClass: "input input-file"
  }, [_c('span', {
    staticClass: "button"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        return _vm.appendMedia($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar anexos neste computador\n      ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Clique em \"Pesquisar Anexo\" para adicionar novos anexos",
      "readonly": ""
    },
    domProps: {
      "value": _vm.selectImageName
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "superbox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImage),
      expression: "showImage"
    }],
    staticClass: "superbox-show",
    staticStyle: {
      "display": "block",
      "max-height": "350px"
    }
  }, [_c('img', {
    staticClass: "superbox-current-img",
    staticStyle: {
      "opacity": "1"
    },
    attrs: {
      "src": _vm.currentImage.image,
      "height": "250px"
    }
  }), _vm._v(" "), _c('span', [_c('p', [_c('a', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": _vm.deleteImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Excluir")])])]), _vm._v(" "), _c('div', {
    staticClass: "superbox-close txt-color-white",
    on: {
      "click": function($event) {
        _vm.currentImage = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg"
  })])]), _vm._v(" "), _vm._l((_vm.imageList), function(image) {
    return _c('div', {
      staticClass: "superbox-list"
    }, [_c('div', {
      staticClass: "text-center"
    }, [_c('i', {
      class: 'fa text-primary fa-3x fa-' + _vm.getExtension(image.title)
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      ref: 'item-' + image.id,
      refInFor: true,
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.download(image)
        }
      }
    }, [_vm._v(_vm._s(image.title))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger",
      staticStyle: {
        "margin-top": "5px",
        "padding": "2px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteImage(image.id_key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir\n              ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "superbox-float"
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart\n fa-fw"
  }), _vm._v("  Vendas\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: '/vehicle-sale'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), (_vm.filhocarregado) ? _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": !_vm.$refs.tenantForm.distributed_ok,
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Nova Venda\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('tenant-form', {
    ref: "tenantForm",
    attrs: {
      "readonly": _vm.readonly
    },
    on: {
      "carregado": _vm.carregado
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  })])
}]}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.tenant_name_rule),
      expression: "tenant_name_rule"
    }],
    attrs: {
      "placeholder": "Preencha a Razão Social",
      "label": "Razão Social",
      "icon": "building",
      "readonly": _vm.readonly,
      "name": "tenant_name",
      "custom-error": _vm.errors.first('tenant_name'),
      "valid": _vm.fields.valid('tenant_name'),
      "failed": _vm.fields.failed('tenant_name')
    },
    model: {
      value: (_vm.tenant_name),
      callback: function($$v) {
        _vm.tenant_name = $$v
      },
      expression: "tenant_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.tenant_fancy_name_rule),
      expression: "tenant_fancy_name_rule"
    }],
    attrs: {
      "placeholder": "Preencha o Nome Fantasia",
      "label": "Nome Fantasia",
      "icon": "address-book",
      "readonly": _vm.readonly,
      "name": "tenant_fancy_name",
      "custom-error": _vm.errors.first('tenant_fancy_name'),
      "valid": _vm.fields.valid('tenant_fancy_name'),
      "failed": _vm.fields.failed('tenant_fancy_name')
    },
    model: {
      value: (_vm.tenant_fancy_name),
      callback: function($$v) {
        _vm.tenant_fancy_name = $$v
      },
      expression: "tenant_fancy_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.cnpj_rule),
      expression: "cnpj_rule"
    }],
    attrs: {
      "placeholder": "Preencha o CNPJ",
      "label": "CNPJ",
      "icon": "address-card-o",
      "readonly": _vm.readonly,
      "name": "cnpj",
      "custom-error": _vm.errors.first('cnpj'),
      "valid": _vm.fields.valid('cnpj'),
      "failed": _vm.fields.failed('cnpj')
    },
    model: {
      value: (_vm.cnpj),
      callback: function($$v) {
        _vm.cnpj = $$v
      },
      expression: "cnpj"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.address_rule),
      expression: "address_rule"
    }],
    attrs: {
      "placeholder": "Preencha o Endereço",
      "label": "Endereço",
      "icon": "map-signs",
      "readonly": _vm.readonly,
      "name": "address",
      "custom-error": _vm.errors.first('address'),
      "valid": _vm.fields.valid('address'),
      "failed": _vm.fields.failed('address')
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.phone_number_rule),
      expression: "phone_number_rule"
    }],
    attrs: {
      "placeholder": "Preencha o Telefone",
      "label": "Telefone",
      "icon": "phone",
      "readonly": _vm.readonly,
      "name": "phone_number",
      "custom-error": _vm.errors.first('phone_number'),
      "valid": _vm.fields.valid('phone_number'),
      "failed": _vm.fields.failed('phone_number')
    },
    model: {
      value: (_vm.phone_number),
      callback: function($$v) {
        _vm.phone_number = $$v
      },
      expression: "phone_number"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.authenticated) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "header"
    }
  }, [_vm._m(0), _vm._v(" "), _c('top-buttons')], 1), _vm._v(" "), _c('aside', {
    staticClass: "hidden-print",
    attrs: {
      "id": "left-panel"
    }
  }, [_c('login-info'), _vm._v(" "), _c('nav-left')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto !important"
    },
    attrs: {
      "id": "main",
      "role": "main"
    }
  }, [_c('div', {
    staticClass: "hidden-print",
    attrs: {
      "id": "ribbon"
    }
  }, [_c('breadcrumb'), _vm._v(" "), (this.$router.history.current.path !== '/') ? _c('span', {
    staticClass: "ribbon-button-alignment pull-right"
  }, [_c('span', {
    staticClass: "btn btn-ribbon",
    attrs: {
      "data-title": "search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.bus.$emit('breadcrumb-search')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Pesquisar")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    attrs: {
      "clas": "row"
    }
  }, [_c('message', {
    staticClass: "hidden-print"
  }), _vm._v(" "), _c('router-view')], 1)])]), _vm._v(" "), _c('page-footer')], 1) : _c('div', [_c('login-page')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "logo-group"
    }
  }, [_c('span', {
    attrs: {
      "id": "logo"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/template/img/logo-pale.jpg",
      "width": "100%",
      "alt": "MSB Tech"
    }
  })])])
}]}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', [_c('legend', [_c('i', {
    staticClass: "fa fa-check-square-o"
  }), _vm._v(" ITENS OPCIONAIS\n      "), _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticClass: "bootstrap-label label-success",
    staticStyle: {
      "position": "relative",
      "top": "-4px",
      "margin-right": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.totalChecked) + " Selecionados\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-label label-danger",
    staticStyle: {
      "position": "relative",
      "top": "-4px",
      "margin-right": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.totalUnchecked) + " Selecionados\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "bootstrap-label label-primary",
    staticStyle: {
      "position": "relative",
      "top": "-4px"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalItems) + " Total\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', [_c('label', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "input-lg",
    attrs: {
      "autocomplete": "off",
      "type": "text",
      "name": "optional-items-search",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.searchedOptionalItems), function(optionalItem) {
    return _c('section', {
      staticClass: "col col-md-6"
    }, [_c('div', [_c('label', {
      staticClass: "toggle",
      class: {
        'toogle-active': _vm.selectedOptionalItems.includes(optionalItem.id_key)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedOptionalItems),
        expression: "selectedOptionalItems"
      }],
      attrs: {
        "disabled": _vm.$parent.$refs.customFormPersonalData && _vm.$parent.$refs.customFormPersonalData.unidadesDiferentes,
        "type": "checkbox",
        "name": "name"
      },
      domProps: {
        "value": optionalItem.id_key,
        "checked": Array.isArray(_vm.selectedOptionalItems) ? _vm._i(_vm.selectedOptionalItems, optionalItem.id_key) > -1 : (_vm.selectedOptionalItems)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.selectedOptionalItems,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = optionalItem.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedOptionalItems = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedOptionalItems = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedOptionalItems = $$c
          }
        }, _vm.clearAndFocusSearch]
      }
    }), _vm._v("\n            " + _vm._s(optionalItem.fullname)), _c('i', {
      attrs: {
        "data-swchon-text": "SIM",
        "data-swchoff-text": "NÃO"
      }
    })])])])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  Lojas\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: '/tenants'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da Loja\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('tenant-form', {
    ref: "tenantForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.profile.map.hasOwnProperty('account-mov')) ? _c('div', [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_vm._v("\n      Pagamentos a receber\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.profile.map['tenants'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "height": "150px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.vehicleExpenses), function(pagExp) {
    return _c('tr', [_c('td', [_vm._v("\n                      " + _vm._s(pagExp.id_key) + "\n\n                      " + _vm._s(pagExp.customer.name_with_cpf) + "\n                    ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pagExp.expense_type.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pagExp.entry.fipe_vehicle_with_renavam))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(pagExp.date))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(pagExp.amount))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.mark(pagExp.id_key, 'despesa')
        }
      }
    }, [_vm._v("Confirmar")])])])
  }), 0)])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "smart-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.id = '';
        _vm.type = '';
        _vm.account_mov = '';
        _vm.date = ''
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Salvar")])])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    staticClass: "fa fa-sign-in"
  }), _vm._v("\n              Listagem de itens a pagar (Despesas de veículos)\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Origem")]), _vm._v(" "), _c('th', [_vm._v("Veículo.")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Valor")]), _vm._v(" "), _c('th', [_vm._v("Ações")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmação de Pagamento")])])
}]}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 col-sm-6 text-right hidden-xs"
  }, [_c('div', {
    staticClass: "txt-color-white inline-block"
  })])
}]}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.form.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-list fa-fw"
  }), _vm._v(" Planos\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/account-plans')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/account-plans/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do Plano de Conta\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('account-plan-form', {
    ref: "form",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "using-as-value": field.usingAsValue,
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-tag"
  }), _vm._v(" Marcar Todos\n          "), _c('input', {
    attrs: {
      "disabled": _vm.formEditable,
      "type": "checkbox",
      "name": "checkbox-inline"
    },
    domProps: {
      "checked": _vm.allSelected()
    },
    on: {
      "click": _vm.checkallmodules
    }
  }), _vm._v(" "), _c('i')])]), _vm._v(" "), _vm._l((_vm.map), function(details, module) {
    return [_c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "height": "640px"
      }
    }, [_c('table', {
      staticClass: "table table-bordered"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "text-center",
      attrs: {
        "colspan": "2"
      }
    }, [_c('label', {
      staticClass: "checkbox"
    }, [_c('i', {
      staticClass: "fa fa-lg fa-tag"
    }), _vm._v(" " + _vm._s(details.name.toUpperCase()) + "\n                      "), _c('input', {
      attrs: {
        "disabled": _vm.formEditable,
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "checked": _vm.allModuleSelected(module)
      },
      on: {
        "click": function($event) {
          return _vm.checkall(module)
        }
      }
    }), _vm._v(" "), _c('i')])])])]), _vm._v(" "), _c('tbody', [_vm._l((details.actions), function(action, actionKey) {
      return [_c('tr', [_c('td', [_c('label', {
        staticClass: "checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selectedPermissions),
          expression: "selectedPermissions"
        }],
        attrs: {
          "disabled": _vm.formEditable,
          "type": "checkbox",
          "name": "checkbox-inline"
        },
        domProps: {
          "value": module + '|' + actionKey,
          "checked": Array.isArray(_vm.selectedPermissions) ? _vm._i(_vm.selectedPermissions, module + '|' + actionKey) > -1 : (_vm.selectedPermissions)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.selectedPermissions,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = module + '|' + actionKey,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.selectedPermissions = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.selectedPermissions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.selectedPermissions = $$c
            }
          }
        }
      }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(action.description) + "\n                      ")])])])]
    })], 2)])])]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(this.resourceLabel.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": true
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['account-mov'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['account-mov'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
      return _c('td', [(field.component !== 'entity-field') ? [_vm._v("\n                      " + _vm._s(model[field.name]) + "\n                      ")] : (field.component === 'entity-field') ? [(model[field['resourceKey']] !== null) ? [_vm._v("\n                          " + _vm._s(model[field['resourceKey']][field['usingAsLabel']]) + "\n                        ")] : _vm._e()] : _vm._e()], 2)
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['account-mov'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-mov'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-mov'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])], 2)
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.tenant_name_rule),
      expression: "tenant_name_rule"
    }],
    attrs: {
      "placeholder": "Preencha a Razão Social",
      "label": "Razão Social",
      "icon": "building",
      "readonly": _vm.readonly,
      "name": "tenant_name",
      "custom-error": _vm.errors.first('tenant_name'),
      "valid": _vm.fields.valid('tenant_name'),
      "failed": _vm.fields.failed('tenant_name')
    },
    model: {
      value: (_vm.tenant_name),
      callback: function($$v) {
        _vm.tenant_name = $$v
      },
      expression: "tenant_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.tenant_fancy_name_rule),
      expression: "tenant_fancy_name_rule"
    }],
    attrs: {
      "placeholder": "Preencha o Nome Fantasia",
      "label": "Nome Fantasia",
      "icon": "address-book",
      "readonly": _vm.readonly,
      "name": "tenant_fancy_name",
      "custom-error": _vm.errors.first('tenant_fancy_name'),
      "valid": _vm.fields.valid('tenant_fancy_name'),
      "failed": _vm.fields.failed('tenant_fancy_name')
    },
    model: {
      value: (_vm.tenant_fancy_name),
      callback: function($$v) {
        _vm.tenant_fancy_name = $$v
      },
      expression: "tenant_fancy_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.cnpj_rule),
      expression: "cnpj_rule"
    }],
    attrs: {
      "placeholder": "Preencha o CNPJ",
      "label": "CNPJ",
      "icon": "address-card-o",
      "readonly": _vm.readonly,
      "name": "cnpj",
      "custom-error": _vm.errors.first('cnpj'),
      "valid": _vm.fields.valid('cnpj'),
      "failed": _vm.fields.failed('cnpj')
    },
    model: {
      value: (_vm.cnpj),
      callback: function($$v) {
        _vm.cnpj = $$v
      },
      expression: "cnpj"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.address_rule),
      expression: "address_rule"
    }],
    attrs: {
      "placeholder": "Preencha o Endereço",
      "label": "Endereço",
      "icon": "map-signs",
      "readonly": _vm.readonly,
      "name": "address",
      "custom-error": _vm.errors.first('address'),
      "valid": _vm.fields.valid('address'),
      "failed": _vm.fields.failed('address')
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.phone_number_rule),
      expression: "phone_number_rule"
    }],
    attrs: {
      "placeholder": "Preencha o Telefone",
      "label": "Telefone",
      "icon": "phone",
      "readonly": _vm.readonly,
      "name": "phone_number",
      "custom-error": _vm.errors.first('phone_number'),
      "valid": _vm.fields.valid('phone_number'),
      "failed": _vm.fields.failed('phone_number')
    },
    model: {
      value: (_vm.phone_number),
      callback: function($$v) {
        _vm.phone_number = $$v
      },
      expression: "phone_number"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(_vm.$parent.$refs.customFormPersonalData && !_vm.$parent.$refs.customFormPersonalData.unidadesDiferentes) ? _c('section', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Imagem")]), _vm._v(" "), _c('div', {
    staticClass: "input input-file"
  }, [_c('span', {
    staticClass: "button"
  }, [_c('input', {
    attrs: {
      "multiple": "multiple",
      "accept": "image/x-png,image/gif,image/jpeg",
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        return _vm.appendMedia($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar imagens neste computador\n      ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Clique em \"Pesquisar Imagens\" para adicionar novas imagens",
      "readonly": ""
    },
    domProps: {
      "value": _vm.selectImageName
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "superbox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImage),
      expression: "showImage"
    }],
    staticClass: "superbox-show",
    staticStyle: {
      "display": "block",
      "max-height": "350px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "superbox-current-img",
    staticStyle: {
      "opacity": "1"
    },
    attrs: {
      "src": _vm.currentImage.image,
      "height": "250px"
    }
  }), _vm._v(" "), (_vm.$parent.$refs.customFormPersonalData && !_vm.$parent.$refs.customFormPersonalData.unidadesDiferentes) ? _c('span', [_c('p', [_c('a', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": _vm.deleteImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Excluir")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "superbox-close txt-color-white",
    on: {
      "click": function($event) {
        _vm.currentImage = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg"
  })])]), _vm._v(" "), _vm._l((_vm.imageList), function(image) {
    return _c('div', {
      staticClass: "superbox-list"
    }, [_c('img', {
      staticClass: "superbox-img",
      attrs: {
        "src": image.thumbnail,
        "data-img": image.thumbnail
      },
      on: {
        "click": function($event) {
          return _vm.selectImage(image)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "superbox-float"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "myModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "95%"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.currentImage.image
    }
  })]), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('p', [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#myModal"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  }), _vm._v(" Ver em tela cheia\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n                ×\n              ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "myModalLabel"
    }
  }, [_vm._v("Visualizador - Tela Cheia")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                Voltar\n              ")])])
}]}

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    class: 'col ' + _vm.wrapperClass
  }, [_c('label', {
    staticClass: "label"
  }, [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v(" " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('label', {
    staticClass: "input",
    class: {
      'state-error': _vm.customError, 'state-success': _vm.valid
    }
  }, [_c('i', {
    staticClass: "icon-append fa",
    class: _vm.getIcon
  }), _vm._v(" "), (_vm.type === 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "name": _vm.name,
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.innerValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue = $event.target.value
      }
    }
  }) : (_vm.type === 'percent') ? _c('masked-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "name": _vm.name,
      "mask": "11\\.11\\%",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.innerValue),
      callback: function($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'monetary') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "name": _vm.name,
      "disabled": _vm.readonly
    },
    domProps: {
      "value": (_vm.innerValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.innerValue = $event.target.value
      }
    }
  }) : (_vm.type === 'masked-field') ? _c('masked-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "name": _vm.name,
      "mask": _vm.mask,
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.innerValue),
      callback: function($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue"
    }
  }) : _vm._e(), _vm._v(" "), _c('b', {
    staticClass: "tooltip tooltip-top-right"
  }, [_c('i', {
    staticClass: "fa fa-check txt-color-teal"
  }), _vm._v(" " + _vm._s(_vm.placeholder) + "\n      ")]), _vm._v(" "), _c('span', [_vm._v("  \n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customError),
      expression: "customError"
    }]
  }, [_c('i', {
    staticClass: "fa text-danger fa-warning"
  }), _vm._v(" " + _vm._s(_vm.customError) + "\n        ")])]), _vm._v(" "), _c('span', [_vm._t("complement-message")], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_vm._l((_vm.__fields), function(field) {
    return [_c('div', {
      staticClass: "row"
    }, [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "data-vv-as": field.label,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })], 1)]
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [(!_vm.expenseVehiclePlate) ? _c('h1', {
    staticClass: "page-title txt-color-blueDark hidden-print"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create/"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n        ")]), _vm._v(" "), (_vm.$refs.customFormPersonalData && _vm.$refs.customFormPersonalData.state_id == 1 && _vm.profile.map['vehicle-sale'].includes('create') && !_vm.$refs.customFormPersonalData.unidadesDiferentes) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        path: ("/vehicle-sale/create/" + (_vm.$refs.customFormPersonalData.id))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" Iniciar Venda\n        ")]) : _vm._e(), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n        ")]) : _c('span', [(_vm.$refs.customFormPersonalData && !_vm.$refs.customFormPersonalData.unidadesDiferentes) ? _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$refs.customFormPersonalData && !_vm.$refs.customFormPersonalData.unidadesDiferentes) ? _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n          ")]) : _vm._e(), _vm._v(" "), (_vm.$refs.customFormPersonalData && !_vm.$refs.customFormPersonalData.unidadesDiferentes) ? _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n          ")]) : _vm._e()])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-sortable",
    attrs: {
      "id": "wid-id-11",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-togglebutton": "false",
      "data-widget-deletebutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticClass: "pull-right",
    staticStyle: {
      "right": "20px"
    }
  }, [_c('strong', [_vm._v("DADOS DO VEÍCULO")]), _vm._v(" "), (_vm.refreshed) ? _c('b', {
    staticClass: "visible-print-inline"
  }, [_vm._v(": " + _vm._s(_vm.$refs.customFormPersonalData._data.plate))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs hidden-print",
    attrs: {
      "id": "widget-tab-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expenseVehiclePlate),
      expression: "!expenseVehiclePlate"
    }]
  }, [_vm._m(1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expenseVehiclePlate),
      expression: "!expenseVehiclePlate"
    }]
  }, [_vm._m(2)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expenseVehiclePlate),
      expression: "!expenseVehiclePlate"
    }]
  }, [_vm._m(3)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expenseVehiclePlate),
      expression: "!expenseVehiclePlate"
    }]
  }, [_vm._m(4)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expenseVehiclePlate),
      expression: "!expenseVehiclePlate"
    }]
  }, [_vm._m(5)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expenseVehiclePlate),
      expression: "!expenseVehiclePlate"
    }]
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-7",
      "href": "#hr7"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.historicForm.refresh()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-calendar text-primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" Histórico ")])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('show-financial-tab')) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expenseVehiclePlate),
      expression: "!expenseVehiclePlate"
    }]
  }, [_vm._m(7)]) : _vm._e()]), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "tab-content m-b-10 padding-10"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "hr1"
    }
  }, [_c('custom-form', {
    ref: "customFormPersonalData",
    attrs: {
      "group": 1,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr2"
    }
  }, [(_vm.refreshed) ? _c('form-optional', {
    ref: "formOptional",
    attrs: {
      "group": 2,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr3"
    }
  }, [(_vm.refreshed) ? _c('form-checklist-item', {
    ref: "formChecklistItem",
    attrs: {
      "group": 3,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr4"
    }
  }, [(_vm.refreshed) ? _c('form-media', {
    ref: "formMedia",
    attrs: {
      "group": 4,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr5"
    }
  }, [(_vm.refreshed) ? _c('form-attachment', {
    ref: "formAttachment",
    attrs: {
      "group": 5,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr6"
    }
  }, [(_vm.refreshed) ? _c('form-pendency', {
    ref: "formPendency",
    attrs: {
      "group": 6,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr7"
    }
  }, [(_vm.refreshed) ? _c('form-historic', {
    ref: "historicForm",
    attrs: {
      "group": 6,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr8"
    }
  }, [(_vm.refreshed) ? _c('form-expense', {
    ref: "expenseForm",
    attrs: {
      "group": 7,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr9"
    }
  }, [(_vm.refreshed) ? _c('financial-page', {
    ref: "financialPage",
    attrs: {
      "group": 9,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  }) : _vm._e()], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-1",
      "href": "#hr1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-address-card-o text-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS GERAIS ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-2",
      "href": "#hr2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-briefcase txt-color-teal"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" OPCIONAIS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-3",
      "href": "#hr3"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle txt-color-teal"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" CHECKLIST ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-4",
      "href": "#hr4"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-photo text-primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" MÍDIAS ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-5",
      "href": "#hr5"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-paperclip text-primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" Anexos ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-6",
      "href": "#hr6"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-times text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" Pendências ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-8",
      "href": "#hr8"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-money text-primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v("\n              Despesas ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-9",
      "href": "#hr9"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-dollar text-primary"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v("\n              Financeiro ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "jarviswidget-loader"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
}]}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    class: 'col ' + _vm.wrapperClass
  }, [_c('label', {
    staticClass: "label"
  }, [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v(" "), (!_vm.loading) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _c('span', [_vm._v("Carregando, aguarde...")])]), _vm._v(" "), _c('label', {
    staticClass: "select",
    class: {
      'state-error': _vm.customError, 'state-success': _vm.valid
    }
  }, [_c('i', {
    staticClass: "icon-append"
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerValue),
      expression: "innerValue"
    }],
    attrs: {
      "disabled": _vm.readonly || _vm.options.length === 0,
      "name": _vm.name
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.innerValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("<== Selecione ==>")]), _vm._v(" "), _vm._l((_vm.options), function(option) {
    return _c('option', {
      domProps: {
        "value": option.value
      }
    }, [_vm._v("\n          " + _vm._s(option.label) + "\n        ")])
  })], 2)]), _vm._v(" "), _c('span', [_vm._v("\n       \n      "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customError),
      expression: "customError"
    }]
  }, [_c('i', {
    staticClass: "fa fa-warning text-danger"
  }), _vm._v(" " + _vm._s(_vm.customError) + "\n      ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('i', {
    staticClass: "fa fa-refresh text-success fa-lg fa-spin"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_vm._v("Carrengado...")])])])])])
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.name_rule),
      expression: "name_rule"
    }],
    attrs: {
      "placeholder": "Preencha o nome",
      "label": "Nome",
      "icon": "edit",
      "readonly": _vm.readonly,
      "name": "name",
      "custom-error": _vm.errors.first('name'),
      "valid": _vm.fields.valid('name'),
      "failed": _vm.fields.failed('name')
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.abbreviation_rule),
      expression: "abbreviation_rule"
    }],
    attrs: {
      "placeholder": "Preencha o Sigla",
      "label": "Sigla",
      "icon": "edit",
      "readonly": _vm.readonly,
      "name": "abbreviation",
      "custom-error": _vm.errors.first('abbreviation'),
      "valid": _vm.fields.valid('abbreviation'),
      "failed": _vm.fields.failed('abbreviation')
    },
    model: {
      value: (_vm.abbreviation),
      callback: function($$v) {
        _vm.abbreviation = $$v
      },
      expression: "abbreviation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.type_rule),
      expression: "type_rule"
    }],
    attrs: {
      "label": "Tipo",
      "icon": "edit",
      "readonly": _vm.readonly,
      "name": "type",
      "select-options": _vm.type_options,
      "custom-error": _vm.errors.first('type'),
      "valid": _vm.fields.valid('type'),
      "failed": _vm.fields.failed('type')
    },
    model: {
      value: (_vm.typeKey),
      callback: function($$v) {
        _vm.typeKey = $$v
      },
      expression: "typeKey"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.active_rule),
      expression: "active_rule"
    }],
    attrs: {
      "label": "Ativo",
      "icon": "edit",
      "readonly": _vm.readonly,
      "name": "isActive",
      "select-options": _vm.active_options,
      "custom-error": _vm.errors.first('isActive'),
      "valid": _vm.fields.valid('isActive'),
      "failed": _vm.fields.failed('isActive')
    },
    model: {
      value: (_vm.isActive),
      callback: function($$v) {
        _vm.isActive = $$v
      },
      expression: "isActive"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _vm._v(" \n        " + _vm._s(_vm.$route.query.t) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v("\n              Lista desta unidade "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['vehicle-sale'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Nome, Cpf ou Veículo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-4 text-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-3 text-right"
  }, [(_vm.profile.map['vehicle-sale'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push('/vehicle-sale/create')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova saída")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("\n                      Cliente\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('tenant_fancy_name', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('tenant_fancy_name', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('tenant_fancy_name', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Veículo\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('tenant_name', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('tenant_name', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('tenant_name', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Valor da Venda (Com desconto)\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('cnpj', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('cnpj', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('cnpj', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Placa\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('cnpj', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('cnpj', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('cnpj', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('th', [_vm._v("\n                      Data\n                      "), _c('span', {
    staticClass: "pull-right"
  }, [(_vm.sortingService.matchPair('phone_number', 'desc')) ? _c('a', {
    staticClass: "btn btn-xs bg-color-blueLight btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('phone_number', 'asc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-desc"
  })]) : _c('a', {
    staticClass: "btn btn-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.sortingService.setup('phone_number', 'desc')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sort-alpha-asc"
  })]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Ações")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(5, true), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.customer.name) + " (" + _vm._s(model.customer.cpf) + ")")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.entry.fipe_vehicle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(model.entry.plate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.moment(model.created_at).format('DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(!model.verified && _vm.profile.map['vehicle-sale'].includes('verify-sales')) ? _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "title": "Homologar Venda"
      },
      on: {
        "click": function($event) {
          return _vm.homologarVenda(model)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-lg fa-star text-warning"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "btn-group"
    }, [_vm._m(6, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, _vm._l((_vm.templates), function(template) {
      return _c('li', [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": [function($event) {
            return _vm.showTemplate(template.id, model['id'])
          }, function($event) {
            $event.preventDefault();
          }]
        }
      }, [_c('i', {
        staticClass: "fa fa-file-o"
      }), _vm._v(" " + _vm._s(template.name))])])
    }), 0)]), _vm._v(" "), (_vm.profile.map['vehicle-entries'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: ("vehicle-entry/" + (model.entry.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-exchange"
    }), _vm._v(" Detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['vehicle-sale'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Estornar Venda\n                    ")]) : _vm._e()], 1)])])
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-o"
  }), _vm._v(" Emitir Documentos "), _c('span', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    }
  }, [_c('fieldset', [_c('section', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inline-group"
  }, [_vm._l((_vm.availableTenants), function(tenant) {
    return [_c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.userTenants),
        expression: "userTenants"
      }],
      attrs: {
        "disabled": _vm.formReadonly,
        "type": "checkbox",
        "name": "checkbox-inline"
      },
      domProps: {
        "value": tenant.id_key,
        "checked": Array.isArray(_vm.userTenants) ? _vm._i(_vm.userTenants, tenant.id_key) > -1 : (_vm.userTenants)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.userTenants,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = tenant.id_key,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.userTenants = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.userTenants = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.userTenants = $$c
          }
        }
      }
    }), _vm._v(" "), _c('i'), _vm._v(" " + _vm._s(tenant.tenant_name) + "\n              ")])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.readonly,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('i', {
    staticClass: "fa fa-lg fa-building"
  }), _vm._v(" Unidades")])
}]}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.create($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-building fa-fw"
  }), _vm._v("  " + _vm._s(_vm.defaultResourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        path: ("/" + _vm.basePath)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.create($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar ( ALT + SHIFT +  S )\n          ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "readonly": _vm.readonly
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['account-mov'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['account-mov'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
      return _c('td', [(field.component !== 'entity-field') ? [_vm._v("\n                      " + _vm._s(model[field.name]) + "\n                      ")] : (field.component === 'entity-field') ? [(model[field['resourceKey']] !== null) ? [_vm._v("\n                          " + _vm._s(model[field['resourceKey']][field['usingAsLabel']]) + "\n                        ")] : _vm._e()] : _vm._e()], 2)
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [_c('a', {
      staticClass: "btn btn-sm btn-default",
      on: {
        "click": function($event) {
          return _vm.openModal(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" Extrato da conta\n                        ")]), _vm._v(" "), (_vm.profile.map['account-mov'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    })]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-mov'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e(), _vm._v(" "), (_vm.profile.map['account-mov'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1)])], 2)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "smart-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._l((_vm.__fields), function(field) {
    return [_c(field.component, {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[field['name']]),
        callback: function($$v) {
          _vm.$set(_vm.$data, field['name'], $$v)
        },
        expression: "$data[field['name']]"
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.id = '';
        _vm.type = '';
        _vm.account_mov = '';
        _vm.date = ''
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.generate()
      }
    }
  }, [_vm._v("Salvar")])])])])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmação de Pagamento")])])
}]}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n        "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes do " + _vm._s(this.defaultSingularResource.toLowerCase()) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer hidden-print"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('last-activity')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_c('span', {
    staticClass: "txt-color-white"
  }, [_vm._v("MSB Tech © 2017")])])
}]}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": 'main-form-' + this.group
    }
  }, [_c('fieldset', [_c('legend', [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" Dados Gerais\n          "), (_vm.sales.length > 0) ? _c('span', [(typeof(_vm.sales[0].nf) === 'object') ? _c('a', {
    staticClass: "btn btn-primary pull-right",
    staticStyle: {
      "padding": "4px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.emitNFE($event)
      }
    }
  }, [_vm._v("\n              Emitir Nota Fiscal\n            ")]) : _vm._e(), _vm._v(" "), (typeof(_vm.sales[0].nf) === 'string') ? _c('a', {
    staticClass: "btn btn-success pull-right",
    staticStyle: {
      "padding": "4px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.emitNFE($event)
      }
    }
  }, [_vm._v("\n              Imprimir DANFE\n            ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.__fields), function(field) {
    return [(field.name !== 'mean_price' || (field.name == 'mean_price' && _vm.profile.map['vehicle-entries'].includes('show-acquisition-price'))) ? _c(_vm.checkComponentType(field), {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (_vm.$data[field['name'] + '_rule']),
        expression: "$data[field['name'] + '_rule']"
      }],
      tag: "component",
      attrs: {
        "wrapper-class": field.wrapperClass,
        "data-vv-as": field.label,
        "lazy": field.lazy,
        "select-options": field.selectOptions,
        "using-as-provider": field.usingAsProvider,
        "using-as-label": field.usingAsLabel,
        "order-by": field.orderBy,
        "has-related": field.hasRelated,
        "related": field.related,
        "mask": field.mask,
        "using-as-value": field.usingAsValue,
        "name": field.name,
        "icon": field.icon,
        "label": field.label,
        "placeholder": field.placeholder,
        "readonly": _vm.getReadonlyStateField(field) || _vm.unidadesDiferentes,
        "custom-error": _vm.errors.first(field.name),
        "valid": _vm.fields.valid(field.name),
        "failed": _vm.fields.failed(field.name)
      },
      model: {
        value: (_vm.$data[_vm.getKeyValue(field)]),
        callback: function($$v) {
          _vm.$set(_vm.$data, _vm.getKeyValue(field), $$v)
        },
        expression: "$data[getKeyValue(field)]"
      }
    }) : _vm._e()]
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.icon
  }), _vm._v(" \n        " + _vm._s(_vm.resourceLabel) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken",
    attrs: {
      "role": "widget"
    }
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', [_c('strong', [_c('i', {
    class: 'fa fa-' + _vm.icon
  }), _vm._v("\n              Lista de " + _vm._s(_vm.resourceLabel.toLowerCase()) + " cadastradas "), (_vm.searchTerm.length) ? _c('span', [_vm._v(" - Filtro por: " + _vm._s(_vm.searchTerm))]) : _vm._e()])])]), _vm._v(" "), (_vm.profile.map['customers'].includes('index')) ? _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "widget-body-toolbar"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9 col-sm-5 col-md-5 col-lg-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [(_vm.searchTermIsDirty) ? _c('span', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse"
  })]) : _c('i', {
    staticClass: "fa fa-search"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.searchTerm),
      expression: "searchTerm",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "search-field",
      "placeholder": "Filtros",
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3 col-sm-7 col-md-7 col-lg-7 text-right"
  }, [(_vm.profile.map['customers'].includes('create')) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile"
  }, [_vm._v("Criar nova " + _vm._s(_vm.singularResource))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-condensed table-hover has-tickbox"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
    return _c('th', [_vm._v("\n                      " + _vm._s(field.label) + "\n                      "), (field.component !== 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.name, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.name, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(0, true)]) : _vm._e(), _vm._v(" "), (field.component === 'entity-field') ? _c('span', {
      staticClass: "pull-right"
    }, [(_vm.sortingService.matchPair(field.orderBy, 'desc')) ? _c('a', {
      staticClass: "btn btn-xs bg-color-blueLight btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'asc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-desc"
    })]) : _c('a', {
      staticClass: "btn btn-xs btn-default",
      on: {
        "click": function($event) {
          return _vm.sortingService.setup(field.orderBy, 'desc')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sort-alpha-asc"
    })]), _vm._v(" "), _vm._m(1, true)]) : _vm._e()])
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30%"
    }
  }, [_vm._v("Ações")])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.models), function(model) {
    return _c('tr', [_vm._m(2, true), _vm._v(" "), _vm._l((_vm.fieldsTable), function(field) {
      return _c('td', [(field.component !== 'entity-field') ? [_vm._v("\n                      " + _vm._s(model[field.name]) + "\n                      ")] : (field.component === 'entity-field') ? [(model[field['resourceKey']] !== null) ? [_vm._v("\n                          " + _vm._s(model[field['resourceKey']][field['usingAsLabel']]) + "\n                        ")] : _vm._e()] : _vm._e()], 2)
    }), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "pull-right"
    }, [(_vm.profile.map['customers'].includes('show')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/show")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-external-link"
    }), _vm._v(" Ver detalhes\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['customers'].includes('edit')) ? _c('router-link', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "to": {
          path: (_vm.basePath + "/" + (model.id) + "/edit")
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Editar\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.profile.map['customers'].includes('delete')) ? _c('a', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.destroy(model.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Deletar\n                    ")]) : _vm._e()], 1)])], 2)
  }), 0)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-xs btn-default"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "smart-form"
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "checkbox-inline"
    }
  }), _vm._v(" "), _c('i')])])
}]}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + this.icon
  }), _vm._v(" " + _vm._s(_vm.resourceLabel) + "\n      "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n        ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n        ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados \n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-sortable",
    attrs: {
      "id": "wid-id-11",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-togglebutton": "false",
      "data-widget-deletebutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "role": "widget"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('div', {
    staticClass: "tab-content m-b-10 padding-10"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "hr1"
    }
  }, [_c('custom-form', {
    ref: "customFormPersonalData",
    attrs: {
      "group": 1,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr2"
    }
  }, [_c('custom-form', {
    ref: "customFormOffice",
    attrs: {
      "group": 2,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "hr3"
    }
  }, [_c('custom-form', {
    ref: "customFormGuaranter",
    attrs: {
      "group": 3,
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_c('h2', {
    staticClass: "pull-right",
    staticStyle: {
      "right": "20px"
    }
  }, [_c('strong', [_vm._v("DADOS DO CLIENTE")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "widget-tab-1"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-1",
      "href": "#hr1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-address-card-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS GERAIS ")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-2",
      "href": "#hr2"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-briefcase"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" DADOS PROFISSIONAIS ")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "id": "tab-main-form-3",
      "href": "#hr3"
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-user-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-mobile hidden-tablet"
  }, [_vm._v(" CÔNJUGE/AVALISTA ")])])])]), _vm._v(" "), _c('span', {
    staticClass: "jarviswidget-loader"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])
}]}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "visible-print-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-stripped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Valor FIPE")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.numeral(_vm.vehicleData.fipe_amount).format('$ 0,0.00')))])])]), _vm._v(" "), _c('tr', {
    staticClass: "bg-danger"
  }, [_c('td', {
    staticClass: "text-danger"
  }, [_vm._v("Valor de Compra")]), _vm._v(" "), _c('td', {
    staticClass: "text-danger text-right"
  }, [_c('b', [_vm._v("- " + _vm._s(_vm.numeral(_vm.vehicleData.mean_price).format('$ 0,0.00')) + " [-]")])])]), _vm._v(" "), _c('tr', {
    staticClass: "bg-danger"
  }, [_c('td', {
    staticClass: "text-danger"
  }, [_vm._v("Despesas")]), _vm._v(" "), _c('td', {
    staticClass: "text-danger text-right"
  }, [_c('b', [_vm._v("- " + _vm._s(_vm.numeral(_vm.expenseData.totalAmountExpenses).format('$ 0,0.00')) + " [-]")])])]), _vm._v(" "), _c('tr', {
    staticClass: "bg-danger"
  }, [_c('td', {
    staticClass: "text-danger"
  }, [_vm._v("Comissões")]), _vm._v(" "), _c('td', {
    staticClass: "text-danger text-right"
  }, [_c('b', [_vm._v("- " + _vm._s(_vm.numeral(_vm.vehicleData.commission).format('$ 0,0.00')) + " [-]")])])]), _vm._v(" "), _c('tr', {
    staticClass: "bg-success"
  }, [_c('td', {
    staticClass: "text-success"
  }, [_vm._v("Valor de Venda")]), _vm._v(" "), _c('td', {
    staticClass: "text-success text-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.numeral(_vm.sale.price_raw || 0).format('$ 0,0.00')) + " [+]")])])]), _vm._v(" "), _c('tr', {
    staticClass: "bg-info"
  }, [_c('td', [_vm._v("Total Geral")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.totalGeralResumoFinanceiro.format('$ 0,0.00')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table table-stripped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "bg-danger"
  }, [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "text-danger text-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.numeral(_vm.expenseData.totalAmountPendenteAtrasada).format('$ 0,0.00')))])])]), _vm._v(" "), _c('tr', {
    staticClass: "bg-success"
  }, [_vm._m(3), _vm._v(" "), _c('td', {
    staticClass: "text-success text-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.numeral(_vm.expenseData.totalAmountPendenteEmDia).format('$ 0,0.00')))])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_c('b', [_vm._v(_vm._s(_vm.numeral(_vm.expenseData.totalAmountPago).format('$ 0,0.00')))])])]), _vm._v(" "), _c('tr', {
    staticClass: "bg-info"
  }, [_c('td', [_vm._v("Total Geral")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.numeral(_vm.expenseData.totalAmountExpenses).format('$ 0,0.00')))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table-bordered table-stripped table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("\n              HISTÓRICO FINANCEIRO\n              "), _c('b', {
    staticClass: "pull-right",
    on: {
      "click": _vm.print
    }
  }, [_c('i', {
    staticClass: "fa fa-print fa-lg"
  })])])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "text-danger bg-danger"
  }, [_c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicleData.acquisition_date))]), _vm._v(" "), _c('td', [_vm._v("Compra")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n              - " + _vm._s(_vm.numeral(this.vehicleData.mean_price).format('$ 0,0.00')) + " [-]\n            ")])]), _vm._v(" "), _c('tr', {
    staticClass: "text-danger bg-danger"
  }, [_c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.vehicleData.acquisition_date))]), _vm._v(" "), _c('td', [_vm._v("Comissões")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("\n              - " + _vm._s(_vm.numeral(this.vehicleData.commission).format('$ 0,0.00')) + " [-]\n            ")])]), _vm._v(" "), _vm._l((_vm.expenseData.expenses), function(expense, index) {
    return _c('tr', {
      staticClass: "text-danger bg-danger"
    }, [_c('td', [_vm._v(_vm._s(3 + index))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.expense_type.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("- R$ " + _vm._s(expense.amount) + " [-]")])])
  }), _vm._v(" "), (typeof(_vm.sale.payments_methods) !== 'undefined') ? _vm._l((_vm.sale.payments_methods.data), function(payment, index) {
    return _c('tr', {
      staticClass: "text-success bg-success"
    }, [_c('td', [_vm._v(_vm._s(_vm.expenseData.pago.length + 3 + (++index)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.moment(payment.date, 'YYYY-MM-DD').format('DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(payment.payment_method.description))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.numeral(payment.value).format('$ 0,0.00')) + " [+]")])])
  }) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "bg-info"
  }, [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("TOTAL: ")]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    class: _vm.totalGeralResumoFinanceiro.value() < 0 ? 'text-danger' : 'text-success',
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.totalGeralResumoFinanceiro.format('$ 0,0.00')))])])])], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("RESUMO FINANCEIRO")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("RESUMO DESPESAS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-danger"
  }, [_c('b', [_vm._v("Despesas vencidas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-success"
  }, [_c('b', [_vm._v("Despesas a vencer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('b', [_vm._v("Despesas pagas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v("Data")]), _vm._v(" "), _c('th', [_vm._v("Descrição")]), _vm._v(" "), _c('th', [_vm._v("Valor")])])
}]}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget",
    attrs: {
      "id": "wid-id-5",
      "data-widget-colorbutton": "false",
      "data-widget-editbutton": "false",
      "data-widget-fullscreenbutton": "false",
      "data-widget-custombutton": "false",
      "data-widget-sortable": "false"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "widget-body"
  }, [_c('div', {
    staticClass: "tabs-left"
  }, [_c('ul', {
    staticClass: "nav nav-tabs tabs-left",
    attrs: {
      "id": "demo-pill-nav"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), (false) ? _c('li', [_vm._m(5)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-content col-md-9"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab-r1"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nome Relatório")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Modelo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "accept": "application/msword",
      "type": "file"
    },
    on: {
      "change": _vm.setModel
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Área")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ENTRADA"
    }
  }, [_vm._v("ENTRADA DE VEÍCULOS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SAIDA"
    }
  }, [_vm._v("SAÍDA DE VEÍCULOS")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveTemplate($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n                        Salvar\n                      ")])])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hovered"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.templates), function(template) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(template.description))]), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "accept": "application/msword",
        "type": "file"
      },
      on: {
        "change": function($event) {
          return _vm.upload($event, template.id)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-default",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.seeTemplate(template.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle fa-lg"
    }), _vm._v(" Ver modelo atual\n                        ")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteTemplate(template.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash fa-lg"
    }), _vm._v(" Apagar Modelo\n                        ")])])])
  }), 0), _vm._v(" "), _c('tfoot')])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-r2"
    }
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("ENTRADA")]), _vm._v(" "), _c('td', [_c('ul', [_vm._l((_vm.macros.entrada), function(value, macro) {
    return _c('li', [_vm._v(_vm._s(macro) + " - "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("Ex: " + _vm._s(value))])])
  }), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_RAZAOSOCIAL")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_NOMEFANTASIA")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_ENDERECO")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_TELEFONE")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_RAZAOSOCIAL")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_NOMEFANTASIA")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_ENDERECO")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_TELEFONE")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_NOME")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CPF_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_IE_RG")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_DATA_NASCIMENTO")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_ESTADO_CIVIL")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_ENDERECORESIDENCIA")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CELULAR")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CIDADE")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_BAIRRO")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CEP")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_NOME")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_MARCA")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_MODELO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_ANOFABRICACAO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_ANO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_COR")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_KM")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_CAMBIO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_NUMEROPORTAS")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_RENAVAM")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_PLACA")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_CHASSI")])], 2)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("SAÍDA")]), _vm._v(" "), _c('td', [_c('ul', [_vm._l((_vm.macros.saida), function(value, macro) {
    return _c('li', [_vm._v(_vm._s(macro) + " - "), _c('span', {
      staticClass: "label label-primary"
    }, [_vm._v("Ex: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(value)
      }
    })])])
  }), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_RAZAOSOCIAL")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_NOMEFANTASIA")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_ENDERECO")]), _vm._v(" "), _c('li', [_vm._v("UNIDADELOGADA_TELEFONE")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_RAZAOSOCIAL")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_NOMEFANTASIA")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_ENDERECO")]), _vm._v(" "), _c('li', [_vm._v("UNIDADEENTRADA_TELEFONE")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_NOME")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CPF_CNPJ")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_IE_RG")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_DATA_NASCIMENTO")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_ESTADO_CIVIL")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_ENDERECORESIDENCIA")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CELULAR")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CIDADE")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_BAIRRO")]), _vm._v(" "), _c('li', [_vm._v("FORNECEDOR_CEP")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_NOME")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_MARCA")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_MODELO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_ANOFABRICACAO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_ANO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_COR")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_KM")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_CAMBIO")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_NUMEROPORTAS")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_RENAVAM")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_PLACA")]), _vm._v(" "), _c('li', [_vm._v("VEICULO_CHASSI")]), _vm._v(" "), _c('li', [_vm._v("VENDA_PRECO")]), _vm._v(" "), _c('li', [_vm._v("VENDA_DESCONTO")]), _vm._v(" "), _c('li', [_vm._v("VENDA_DATA")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_NOME")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CPF")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_NATURALIDADE")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_ESTADO_CIVIL")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_RG")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_RGDATAEXPEDICAO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_ESTADOEXPEDICAO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_DATANASCIMENTO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_SEXO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_ESTADOCIVIL")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CNH")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_NOMEPAI")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_NOMEMAE")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_ENDERECORESIDENCIA")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CIDADE")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_BAIRRO")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CEP")]), _vm._v(" "), _c('li', [_vm._v("CLIENTE_CELULAR")])], 2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab-r4"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Taxa de Imposto (EX: 3%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_rate),
      expression: "icms_rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_rate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" Base Tax ST Reduction EX: (Ex: 10%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_basetax_st_reduction),
      expression: "icms_basetax_st_reduction"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_basetax_st_reduction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_basetax_st_reduction = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v(" ICMS Base Tax Modality (Ex: 1)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_basetax_modality),
      expression: "icms_basetax_modality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_basetax_modality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_basetax_modality = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("ICMS CST (Ex: 3)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_cst),
      expression: "icms_cst"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_cst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_cst = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v(" Origem ICMS (Ex: 9)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icms_origin),
      expression: "icms_origin"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.icms_origin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.icms_origin = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("  PIS rate (Ex: 6,50%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pis_rate),
      expression: "pis_rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pis_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pis_rate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("PIS CST (Ex: 12)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pis_cst),
      expression: "pis_cst"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pis_cst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pis_cst = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("  COFINS rate (Ex: 12.50%)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cofins_rate),
      expression: "cofins_rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cofins_rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cofins_rate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-3 control-label"
  }, [_vm._v("COFINS CST (Ex: 1)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cofins_cst),
      expression: "cofins_cst"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.cofins_cst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cofins_cst = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_vm._v("Salvar")])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-cog"
  }), _vm._v(" \n    Configurações\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("Tabela de configurações")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab-r1",
      "data-toggle": "tab"
    }
  }, [_c('span', {
    staticClass: "badge bg-color-blue txt-color-white"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })]), _vm._v("\n                Relatórios\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#tab-r2",
      "data-toggle": "tab"
    }
  }, [_c('span', {
    staticClass: "badge bg-color-blue txt-color-white"
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  })]), _vm._v(" Macros")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#tab-r4",
      "data-toggle": "tab"
    }
  }, [_c('span', {
    staticClass: "badge bg-color-blue txt-color-white"
  }, [_c('i', {
    staticClass: "fa fa-file"
  })]), _vm._v(" NF-e ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#tab-r3",
      "data-toggle": "tab"
    }
  }, [_c('span', {
    staticClass: "badge bg-color-greenLight txt-color-white"
  }, [_vm._v("0")]), _vm._v(" Item 3")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("\n                        RELATÓRIO\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        ÁREA\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        MODELO\n                      ")]), _vm._v(" "), _c('td', [_vm._v("\n                        MODELO ATUAL\n                      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ÁREA")]), _vm._v(" "), _c('th', [_vm._v("MACROS")])])])
}]}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 83) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.update($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 67) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.disableEdit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 88) { return null; }
        if (!$event.altKey) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.$refs.customForm.destroy($event)
      }]
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_c('h1', {
    staticClass: "page-title txt-color-blueDark"
  }, [_c('i', {
    class: 'fa fa-fw fa-' + _vm.defaultIcon
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left fa-lg fa-fw"
  }), _vm._v(" Voltar\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push(("/" + _vm.basePath + "/create"))
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-lg fa-fw"
  }), _vm._v(" Cadastrar novo\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('a', {
    staticClass: "btn btn-default",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.allowEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit fa-lg fa-fw"
  }), _vm._v(" Editar este registro\n          ")]) : _c('span', [_c('a', {
    staticClass: "btn btn-success",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.update($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-lg fa-fw"
  }), _vm._v(" Salvar dados ( ALT + SHIFT +  S )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-warning",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.disableEdit($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo fa-fw"
  }), _vm._v(" Cancelar Alteração ( ALT + SHIFT +  C )\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.destroy
    }
  }, [_c('i', {
    staticClass: "fa fa-trash fa-fw"
  }), _vm._v(" Excluir registro ( ALT + SHIFT +  X )\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "jarviswidget jarviswidget-color-darken"
  }, [_c('header', {
    attrs: {
      "role": "heading"
    }
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n            Detalhes da " + _vm._s(_vm.defaultSingularResource) + "\n          ")]), _vm._v(" "), (_vm.readonly) ? _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-orange pull-right"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Somente leitura\n          ")]) : _c('span', {
    staticClass: "badge m-t-5 m-r-5 bg-color-greenLight pull-right"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Edição\n          ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "role": "content"
    }
  }, [_c('div', {
    staticClass: "widget-body no-padding"
  }, [_c('custom-form', {
    ref: "customForm",
    attrs: {
      "form-readonly": _vm.readonly
    },
    on: {
      "form-saved": _vm.saved
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "widget-icon"
  }, [_c('i', {
    staticClass: "fa fa-th"
  })])
}]}

/***/ }),
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-27 */if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){return a(b.target).is(this)?b.handleObj.handler.apply(this,arguments):void 0}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.2.0",d.prototype.close=function(b){function c(){f.detach().trigger("closed.bs.alert").remove()}var d=a(this),e=d.attr("data-target");e||(e=d.attr("href"),e=e&&e.replace(/.*(?=#[^\s]*$)/,""));var f=a(e);b&&b.preventDefault(),f.length||(f=d.hasClass("alert")?d:d.parent()),f.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",c).emulateTransitionEnd(150):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.2.0",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),d[e](null==f[b]?this.options[b]:f[b]),setTimeout(a.proxy(function(){"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")&&(c.prop("checked")&&this.$element.hasClass("active")?a=!1:b.find(".active").removeClass("active")),a&&c.prop("checked",!this.$element.hasClass("active")).trigger("change")}a&&this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target);d.hasClass("btn")||(d=d.closest(".btn")),b.call(d,"toggle"),c.preventDefault()})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b).on("keydown.bs.carousel",a.proxy(this.keydown,this)),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=this.sliding=this.interval=this.$active=this.$items=null,"hover"==this.options.pause&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.2.0",c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0},c.prototype.keydown=function(a){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.to=function(b){var c=this,d=this.getItemIndex(this.$active=this.$element.find(".item.active"));return b>this.$items.length-1||0>b?void 0:this.sliding?this.$element.one("slid.bs.carousel",function(){c.to(b)}):d==b?this.pause().cycle():this.slide(b>d?"next":"prev",a(this.$items[b]))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){return this.sliding?void 0:this.slide("next")},c.prototype.prev=function(){return this.sliding?void 0:this.slide("prev")},c.prototype.slide=function(b,c){var d=this.$element.find(".item.active"),e=c||d[b](),f=this.interval,g="next"==b?"left":"right",h="next"==b?"first":"last",i=this;if(!e.length){if(!this.options.wrap)return;e=this.$element.find(".item")[h]()}if(e.hasClass("active"))return this.sliding=!1;var j=e[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:g});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,f&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(e)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:g});return a.support.transition&&this.$element.hasClass("slide")?(e.addClass(b),e[0].offsetWidth,d.addClass(g),e.addClass(g),d.one("bsTransitionEnd",function(){e.removeClass([b,g].join(" ")).addClass("active"),d.removeClass(["active",g].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(1e3*d.css("transition-duration").slice(0,-1))):(d.removeClass("active"),e.addClass("active"),this.sliding=!1,this.$element.trigger(m)),f&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this},a(document).on("click.bs.carousel.data-api","[data-slide], [data-slide-to]",function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}}),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.collapse"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b);!e&&f.toggle&&"show"==b&&(b=!b),e||d.data("bs.collapse",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.transitioning=null,this.options.parent&&(this.$parent=a(this.options.parent)),this.options.toggle&&this.toggle()};c.VERSION="3.2.0",c.DEFAULTS={toggle:!0},c.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},c.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var c=a.Event("show.bs.collapse");if(this.$element.trigger(c),!c.isDefaultPrevented()){var d=this.$parent&&this.$parent.find("> .panel > .in");if(d&&d.length){var e=d.data("bs.collapse");if(e&&e.transitioning)return;b.call(d,"hide"),e||d.data("bs.collapse",null)}var f=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[f](0),this.transitioning=1;var g=function(){this.$element.removeClass("collapsing").addClass("collapse in")[f](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return g.call(this);var h=a.camelCase(["scroll",f].join("-"));this.$element.one("bsTransitionEnd",a.proxy(g,this)).emulateTransitionEnd(350)[f](this.$element[0][h])}}},c.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse").removeClass("in"),this.transitioning=1;var d=function(){this.transitioning=0,this.$element.trigger("hidden.bs.collapse").removeClass("collapsing").addClass("collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(d,this)).emulateTransitionEnd(350):d.call(this)}}},c.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()};var d=a.fn.collapse;a.fn.collapse=b,a.fn.collapse.Constructor=c,a.fn.collapse.noConflict=function(){return a.fn.collapse=d,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(c){var d,e=a(this),f=e.attr("data-target")||c.preventDefault()||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""),g=a(f),h=g.data("bs.collapse"),i=h?"toggle":e.data(),j=e.attr("data-parent"),k=j&&a(j);h&&h.transitioning||(k&&k.find('[data-toggle="collapse"][data-parent="'+j+'"]').not(e).addClass("collapsed"),e[g.hasClass("in")?"addClass":"removeClass"]("collapsed")),b.call(g,i)})}(jQuery),+function(a){"use strict";function b(b){b&&3===b.which||(a(e).remove(),a(f).each(function(){var d=c(a(this)),e={relatedTarget:this};d.hasClass("open")&&(d.trigger(b=a.Event("hide.bs.dropdown",e)),b.isDefaultPrevented()||d.removeClass("open").trigger("hidden.bs.dropdown",e))}))}function c(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.2.0",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=c(e),g=f.hasClass("open");if(b(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a('<div class="dropdown-backdrop"/>').insertAfter(a(this)).on("click",b);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus"),f.toggleClass("open").trigger("shown.bs.dropdown",h)}return!1}},g.prototype.keydown=function(b){if(/(38|40|27)/.test(b.keyCode)){var d=a(this);if(b.preventDefault(),b.stopPropagation(),!d.is(".disabled, :disabled")){var e=c(d),g=e.hasClass("open");if(!g||g&&27==b.keyCode)return 27==b.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.divider):visible a",i=e.find('[role="menu"]'+h+', [role="listbox"]'+h);if(i.length){var j=i.index(i.filter(":focus"));38==b.keyCode&&j>0&&j--,40==b.keyCode&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",b).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f+', [role="menu"], [role="listbox"]',g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$backdrop=this.isShown=null,this.scrollbarWidth=0,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.2.0",c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var c=this,d=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(d),this.isShown||d.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.$body.addClass("modal-open"),this.setScrollbar(),this.escape(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.backdrop(function(){var d=a.support.transition&&c.$element.hasClass("fade");c.$element.parent().length||c.$element.appendTo(c.$body),c.$element.show().scrollTop(0),d&&c.$element[0].offsetWidth,c.$element.addClass("in").attr("aria-hidden",!1),c.enforceFocus();var e=a.Event("shown.bs.modal",{relatedTarget:b});d?c.$element.find(".modal-dialog").one("bsTransitionEnd",function(){c.$element.trigger("focus").trigger(e)}).emulateTransitionEnd(300):c.$element.trigger("focus").trigger(e)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.$body.removeClass("modal-open"),this.resetScrollbar(),this.escape(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").attr("aria-hidden",!0).off("click.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(300):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keyup.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keyup.dismiss.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var c=this,d=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var e=a.support.transition&&d;if(this.$backdrop=a('<div class="modal-backdrop '+d+'" />').appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus.call(this.$element[0]):this.hide.call(this))},this)),e&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;e?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(150):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var f=function(){c.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",f).emulateTransitionEnd(150):f()}else b&&b()},c.prototype.checkScrollbar=function(){document.body.clientWidth>=window.innerWidth||(this.scrollbarWidth=this.scrollbarWidth||this.measureScrollbar())},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.scrollbarWidth&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right","")},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;(e||"destroy"!=b)&&(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=this.options=this.enabled=this.timeout=this.hoverState=this.$element=null,this.init("tooltip",a,b)};c.VERSION="3.2.0",c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(this.options.viewport.selector||this.options.viewport);for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show()},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var c=a.contains(document.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!c)return;var d=this,e=this.tip(),f=this.getUID(this.type);this.setContent(),e.attr("id",f),this.$element.attr("aria-describedby",f),this.options.animation&&e.addClass("fade");var g="function"==typeof this.options.placement?this.options.placement.call(this,e[0],this.$element[0]):this.options.placement,h=/\s?auto?\s?/i,i=h.test(g);i&&(g=g.replace(h,"")||"top"),e.detach().css({top:0,left:0,display:"block"}).addClass(g).data("bs."+this.type,this),this.options.container?e.appendTo(this.options.container):e.insertAfter(this.$element);var j=this.getPosition(),k=e[0].offsetWidth,l=e[0].offsetHeight;if(i){var m=g,n=this.$element.parent(),o=this.getPosition(n);g="bottom"==g&&j.top+j.height+l-o.scroll>o.height?"top":"top"==g&&j.top-o.scroll-l<0?"bottom":"right"==g&&j.right+k>o.width?"left":"left"==g&&j.left-k<o.left?"right":g,e.removeClass(m).addClass(g)}var p=this.getCalculatedOffset(g,j,k,l);this.applyPlacement(p,g);var q=function(){d.$element.trigger("shown.bs."+d.type),d.hoverState=null};a.support.transition&&this.$tip.hasClass("fade")?e.one("bsTransitionEnd",q).emulateTransitionEnd(150):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top=b.top+g,b.left=b.left+h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=k.left?2*k.left-e+i:2*k.top-f+j,m=k.left?"left":"top",n=k.left?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(l,d[0][n],m)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c,a?50*(1-a/b)+"%":"")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(){function b(){"in"!=c.hoverState&&d.detach(),c.$element.trigger("hidden.bs."+c.type)}var c=this,d=this.tip(),e=a.Event("hide.bs."+this.type);return this.$element.removeAttr("aria-describedby"),this.$element.trigger(e),e.isDefaultPrevented()?void 0:(d.removeClass("in"),a.support.transition&&this.$tip.hasClass("fade")?d.one("bsTransitionEnd",b).emulateTransitionEnd(150):b(),this.hoverState=null,this)},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName;return a.extend({},"function"==typeof c.getBoundingClientRect?c.getBoundingClientRect():null,{scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop(),width:d?a(window).width():b.outerWidth(),height:d?a(window).height():b.outerHeight()},d?{top:0,left:0}:b.offset())},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.width&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){return this.$tip=this.$tip||a(this.options.template)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.validate=function(){this.$element[0].parentNode||(this.hide(),this.$element=null,this.options=null)},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){clearTimeout(this.timeout),this.hide().$element.off("."+this.type).removeData("bs."+this.type)};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;(e||"destroy"!=b)&&(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.2.0",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").empty()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")},c.prototype.tip=function(){return this.$tip||(this.$tip=a(this.options.template)),this.$tip};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){var e=a.proxy(this.process,this);this.$body=a("body"),this.$scrollElement=a(a(c).is("body")?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",e),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.2.0",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b="offset",c=0;a.isWindow(this.$scrollElement[0])||(b="position",c=this.$scrollElement.scrollTop()),this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight();var d=this;this.$body.find(this.selector).map(function(){var d=a(this),e=d.data("target")||d.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[b]().top+c,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){d.offsets.push(this[0]),d.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<=e[0])return g!=(a=f[0])&&this.activate(a);for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(!e[a+1]||b<=e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){this.activeTarget=b,a(this.selector).parentsUntil(this.options.target,".active").removeClass("active");var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.2.0",c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a")[0],f=a.Event("show.bs.tab",{relatedTarget:e});if(b.trigger(f),!f.isDefaultPrevented()){var g=a(d);this.activate(b.closest("li"),c),this.activate(g,g.parent(),function(){b.trigger({type:"shown.bs.tab",relatedTarget:e})})}}},c.prototype.activate=function(b,c,d){function e(){f.removeClass("active").find("> .dropdown-menu > .active").removeClass("active"),b.addClass("active"),g?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu")&&b.closest("li.dropdown").addClass("active"),d&&d()}var f=c.find("> .active"),g=d&&a.support.transition&&f.hasClass("fade");g?f.one("bsTransitionEnd",e).emulateTransitionEnd(150):e(),f.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this},a(document).on("click.bs.tab.data-api",'[data-toggle="tab"], [data-toggle="pill"]',function(c){c.preventDefault(),b.call(a(this),"show")})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=this.unpin=this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.2.0",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=a(document).height(),d=this.$target.scrollTop(),e=this.$element.offset(),f=this.options.offset,g=f.top,h=f.bottom;"object"!=typeof f&&(h=g=f),"function"==typeof g&&(g=f.top(this.$element)),"function"==typeof h&&(h=f.bottom(this.$element));var i=null!=this.unpin&&d+this.unpin<=e.top?!1:null!=h&&e.top+this.$element.height()>=b-h?"bottom":null!=g&&g>=d?"top":!1;if(this.affixed!==i){null!=this.unpin&&this.$element.css("top","");var j="affix"+(i?"-"+i:""),k=a.Event(j+".bs.affix");this.$element.trigger(k),k.isDefaultPrevented()||(this.affixed=i,this.unpin="bottom"==i?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(j).trigger(a.Event(j.replace("affix","affixed"))),"bottom"==i&&this.$element.offset({top:b-this.$element.height()-h}))}}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},d.offsetBottom&&(d.offset.bottom=d.offsetBottom),d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*!
Chosen, a Select Box Enhancer for jQuery and Prototype
by Patrick Filler for Harvest, http://getharvest.com

Version 1.7.0
Full source at https://github.com/harvesthq/chosen
Copyright (c) 2011-2017 Harvest http://getharvest.com

MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
This file is generated by `grunt build`, do not edit it by hand.
*/
(function() {
  var $, AbstractChosen, Chosen, SelectParser, _ref,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  SelectParser = (function() {
    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function(child) {
      if (child.nodeName.toUpperCase() === "OPTGROUP") {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function(group) {
      var group_position, option, _i, _len, _ref, _results;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: this.escapeExpression(group.label),
        title: group.title ? group.title : void 0,
        children: 0,
        disabled: group.disabled,
        classes: group.className
      });
      _ref = group.childNodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        _results.push(this.add_option(option, group_position, group.disabled));
      }
      return _results;
    };

    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === "OPTION") {
        if (option.text !== "") {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            title: option.title ? option.title : void 0,
            selected: option.selected,
            disabled: group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            group_label: group_position != null ? this.parsed[group_position].label : null,
            classes: option.className,
            style: option.style.cssText
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true
          });
        }
        return this.options_index += 1;
      }
    };

    SelectParser.prototype.escapeExpression = function(text) {
      var map, unsafe_chars;
      if ((text == null) || text === false) {
        return "";
      }
      if (!/[\&\<\>\"\'\`]/.test(text)) {
        return text;
      }
      map = {
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;"
      };
      unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
      return text.replace(unsafe_chars, function(chr) {
        return map[chr] || "&amp;";
      });
    };

    return SelectParser;

  })();

  SelectParser.select_to_array = function(select) {
    var child, parser, _i, _len, _ref;
    parser = new SelectParser();
    _ref = select.childNodes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      child = _ref[_i];
      parser.add_node(child);
    }
    return parser.parsed;
  };

  AbstractChosen = (function() {
    function AbstractChosen(form_field, options) {
      this.form_field = form_field;
      this.options = options != null ? options : {};
      this.label_click_handler = __bind(this.label_click_handler, this);
      if (!AbstractChosen.browser_is_supported()) {
        return;
      }
      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.on_ready();
    }

    AbstractChosen.prototype.set_default_values = function() {
      var _this = this;
      this.click_test_action = function(evt) {
        return _this.test_active_click(evt);
      };
      this.activate_action = function(evt) {
        return _this.activate_field(evt);
      };
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.is_rtl = this.options.rtl || /\bchosen-rtl\b/.test(this.form_field.className);
      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.group_search = this.options.group_search != null ? this.options.group_search : true;
      this.search_contains = this.options.search_contains || false;
      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      this.inherit_select_classes = this.options.inherit_select_classes || false;
      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
      this.case_sensitive_search = this.options.case_sensitive_search || false;
      return this.hide_results_on_select = this.options.hide_results_on_select != null ? this.options.hide_results_on_select : true;
    };

    AbstractChosen.prototype.set_default_text = function() {
      if (this.form_field.getAttribute("data-placeholder")) {
        this.default_text = this.form_field.getAttribute("data-placeholder");
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
      }
      this.default_text = this.escape_html(this.default_text);
      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
    };

    AbstractChosen.prototype.choice_label = function(item) {
      if (this.include_group_label_in_selected && (item.group_label != null)) {
        return "<b class='group-name'>" + item.group_label + "</b>" + item.html;
      } else {
        return item.html;
      }
    };

    AbstractChosen.prototype.mouse_enter = function() {
      return this.mouse_on_container = true;
    };

    AbstractChosen.prototype.mouse_leave = function() {
      return this.mouse_on_container = false;
    };

    AbstractChosen.prototype.input_focus = function(evt) {
      var _this = this;
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout((function() {
            return _this.container_mousedown();
          }), 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };

    AbstractChosen.prototype.input_blur = function(evt) {
      var _this = this;
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout((function() {
          return _this.blur_test();
        }), 100);
      }
    };

    AbstractChosen.prototype.label_click_handler = function(evt) {
      if (this.is_multiple) {
        return this.container_mousedown(evt);
      } else {
        return this.activate_field();
      }
    };

    AbstractChosen.prototype.results_option_build = function(options) {
      var content, data, data_content, shown_results, _i, _len, _ref;
      content = '';
      shown_results = 0;
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        data = _ref[_i];
        data_content = '';
        if (data.group) {
          data_content = this.result_add_group(data);
        } else {
          data_content = this.result_add_option(data);
        }
        if (data_content !== '') {
          shown_results++;
          content += data_content;
        }
        if (options != null ? options.first : void 0) {
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.single_set_selected_text(this.choice_label(data));
          }
        }
        if (shown_results >= this.max_shown_results) {
          break;
        }
      }
      return content;
    };

    AbstractChosen.prototype.result_add_option = function(option) {
      var classes, option_el;
      if (!option.search_match) {
        return '';
      }
      if (!this.include_option_in_results(option)) {
        return '';
      }
      classes = [];
      if (!option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("active-result");
      }
      if (option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("disabled-result");
      }
      if (option.selected) {
        classes.push("result-selected");
      }
      if (option.group_array_index != null) {
        classes.push("group-option");
      }
      if (option.classes !== "") {
        classes.push(option.classes);
      }
      option_el = document.createElement("li");
      option_el.className = classes.join(" ");
      option_el.style.cssText = option.style;
      option_el.setAttribute("data-option-array-index", option.array_index);
      option_el.innerHTML = option.search_text;
      if (option.title) {
        option_el.title = option.title;
      }
      return this.outerHTML(option_el);
    };

    AbstractChosen.prototype.result_add_group = function(group) {
      var classes, group_el;
      if (!(group.search_match || group.group_match)) {
        return '';
      }
      if (!(group.active_options > 0)) {
        return '';
      }
      classes = [];
      classes.push("group-result");
      if (group.classes) {
        classes.push(group.classes);
      }
      group_el = document.createElement("li");
      group_el.className = classes.join(" ");
      group_el.innerHTML = group.search_text;
      if (group.title) {
        group_el.title = group.title;
      }
      return this.outerHTML(group_el);
    };

    AbstractChosen.prototype.results_update_field = function() {
      this.set_default_text();
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.results_build();
      if (this.results_showing) {
        return this.winnow_results();
      }
    };

    AbstractChosen.prototype.reset_single_select_options = function() {
      var result, _i, _len, _ref, _results;
      _ref = this.results_data;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        result = _ref[_i];
        if (result.selected) {
          _results.push(result.selected = false);
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    AbstractChosen.prototype.results_toggle = function() {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function(evt) {
      if (this.results_showing) {
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.winnow_results = function() {
      var escapedSearchText, highlightRegex, option, regex, results, results_group, searchText, startpos, text, _i, _len, _ref;
      this.no_results_clear();
      results = 0;
      searchText = this.get_search_text();
      escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      regex = this.get_search_regex(escapedSearchText);
      highlightRegex = this.get_highlight_regex(escapedSearchText);
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        option.search_match = false;
        results_group = null;
        if (this.include_option_in_results(option)) {
          if (option.group) {
            option.group_match = false;
            option.active_options = 0;
          }
          if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
            results_group = this.results_data[option.group_array_index];
            if (results_group.active_options === 0 && results_group.search_match) {
              results += 1;
            }
            results_group.active_options += 1;
          }
          option.search_text = option.group ? option.label : option.html;
          if (!(option.group && !this.group_search)) {
            option.search_match = this.search_string_match(option.search_text, regex);
            if (option.search_match && !option.group) {
              results += 1;
            }
            if (option.search_match) {
              if (searchText.length) {
                startpos = option.search_text.search(highlightRegex);
                text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
                option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
              }
              if (results_group != null) {
                results_group.group_match = true;
              }
            } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
              option.search_match = true;
            }
          }
        }
      }
      this.result_clear_highlight();
      if (results < 1 && searchText.length) {
        this.update_results_content("");
        return this.no_results(searchText);
      } else {
        this.update_results_content(this.results_option_build());
        return this.winnow_results_set_highlight();
      }
    };

    AbstractChosen.prototype.get_search_regex = function(escaped_search_string) {
      var regex_anchor, regex_flag;
      regex_anchor = this.search_contains ? "" : "^";
      regex_flag = this.case_sensitive_search ? "" : "i";
      return new RegExp(regex_anchor + escaped_search_string, regex_flag);
    };

    AbstractChosen.prototype.get_highlight_regex = function(escaped_search_string) {
      var regex_anchor, regex_flag;
      regex_anchor = this.search_contains ? "" : "\\b";
      regex_flag = this.case_sensitive_search ? "" : "i";
      return new RegExp(regex_anchor + escaped_search_string, regex_flag);
    };

    AbstractChosen.prototype.search_string_match = function(search_string, regex) {
      var part, parts, _i, _len;
      if (regex.test(search_string)) {
        return true;
      } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
        parts = search_string.replace(/\[|\]/g, "").split(" ");
        if (parts.length) {
          for (_i = 0, _len = parts.length; _i < _len; _i++) {
            part = parts[_i];
            if (regex.test(part)) {
              return true;
            }
          }
        }
      }
    };

    AbstractChosen.prototype.choices_count = function() {
      var option, _i, _len, _ref;
      if (this.selected_option_count != null) {
        return this.selected_option_count;
      }
      this.selected_option_count = 0;
      _ref = this.form_field.options;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        if (option.selected) {
          this.selected_option_count += 1;
        }
      }
      return this.selected_option_count;
    };

    AbstractChosen.prototype.choices_click = function(evt) {
      evt.preventDefault();
      this.activate_field();
      if (!(this.results_showing || this.is_disabled)) {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.keydown_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
        case 8:
          this.backstroke_length = this.get_search_field_value().length;
          break;
        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }
          this.mouse_on_container = false;
          break;
        case 13:
          if (this.results_showing) {
            evt.preventDefault();
          }
          break;
        case 27:
          if (this.results_showing) {
            evt.preventDefault();
          }
          break;
        case 32:
          if (this.disable_search) {
            evt.preventDefault();
          }
          break;
        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;
        case 40:
          evt.preventDefault();
          this.keydown_arrow();
          break;
      }
    };

    AbstractChosen.prototype.keyup_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
        case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
            this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            this.results_search();
          }
          break;
        case 13:
          evt.preventDefault();
          if (this.results_showing) {
            this.result_select(evt);
          }
          break;
        case 27:
          if (this.results_showing) {
            this.results_hide();
          }
          break;
        case 9:
        case 16:
        case 17:
        case 18:
        case 38:
        case 40:
        case 91:
          break;
        default:
          this.results_search();
          break;
      }
    };

    AbstractChosen.prototype.clipboard_event_checker = function(evt) {
      var _this = this;
      if (this.is_disabled) {
        return;
      }
      return setTimeout((function() {
        return _this.results_search();
      }), 50);
    };

    AbstractChosen.prototype.container_width = function() {
      if (this.options.width != null) {
        return this.options.width;
      } else {
        return "" + this.form_field.offsetWidth + "px";
      }
    };

    AbstractChosen.prototype.include_option_in_results = function(option) {
      if (this.is_multiple && (!this.display_selected_options && option.selected)) {
        return false;
      }
      if (!this.display_disabled_options && option.disabled) {
        return false;
      }
      if (option.empty) {
        return false;
      }
      return true;
    };

    AbstractChosen.prototype.search_results_touchstart = function(evt) {
      this.touch_started = true;
      return this.search_results_mouseover(evt);
    };

    AbstractChosen.prototype.search_results_touchmove = function(evt) {
      this.touch_started = false;
      return this.search_results_mouseout(evt);
    };

    AbstractChosen.prototype.search_results_touchend = function(evt) {
      if (this.touch_started) {
        return this.search_results_mouseup(evt);
      }
    };

    AbstractChosen.prototype.outerHTML = function(element) {
      var tmp;
      if (element.outerHTML) {
        return element.outerHTML;
      }
      tmp = document.createElement("div");
      tmp.appendChild(element);
      return tmp.innerHTML;
    };

    AbstractChosen.prototype.get_single_html = function() {
      return "<a class=\"chosen-single chosen-default\">\n  <span>" + this.default_text + "</span>\n  <div><b></b></div>\n</a>\n<div class=\"chosen-drop\">\n  <div class=\"chosen-search\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" />\n  </div>\n  <ul class=\"chosen-results\"></ul>\n</div>";
    };

    AbstractChosen.prototype.get_multi_html = function() {
      return "<ul class=\"chosen-choices\">\n  <li class=\"search-field\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" value=\"" + this.default_text + "\" />\n  </li>\n</ul>\n<div class=\"chosen-drop\">\n  <ul class=\"chosen-results\"></ul>\n</div>";
    };

    AbstractChosen.prototype.get_no_results_html = function(terms) {
      return "<li class=\"no-results\">\n  " + this.results_none_found + " <span>" + terms + "</span>\n</li>";
    };

    AbstractChosen.browser_is_supported = function() {
      if ("Microsoft Internet Explorer" === window.navigator.appName) {
        return document.documentMode >= 8;
      }
      if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
        return false;
      }
      return true;
    };

    AbstractChosen.default_multiple_text = "Select Some Options";

    AbstractChosen.default_single_text = "Select an Option";

    AbstractChosen.default_no_result_text = "No results match";

    return AbstractChosen;

  })();

  $ = jQuery;

  $.fn.extend({
    chosen: function(options) {
      if (!AbstractChosen.browser_is_supported()) {
        return this;
      }
      return this.each(function(input_field) {
        var $this, chosen;
        $this = $(this);
        chosen = $this.data('chosen');
        if (options === 'destroy') {
          if (chosen instanceof Chosen) {
            chosen.destroy();
          }
          return;
        }
        if (!(chosen instanceof Chosen)) {
          $this.data('chosen', new Chosen(this, options));
        }
      });
    }
  });

  Chosen = (function(_super) {
    __extends(Chosen, _super);

    function Chosen() {
      _ref = Chosen.__super__.constructor.apply(this, arguments);
      return _ref;
    }

    Chosen.prototype.setup = function() {
      this.form_field_jq = $(this.form_field);
      return this.current_selectedIndex = this.form_field.selectedIndex;
    };

    Chosen.prototype.set_up_html = function() {
      var container_classes, container_props;
      container_classes = ["chosen-container"];
      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }
      if (this.is_rtl) {
        container_classes.push("chosen-rtl");
      }
      container_props = {
        'class': container_classes.join(' '),
        'title': this.form_field.title
      };
      if (this.form_field.id.length) {
        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
      }
      this.container = $("<div />", container_props);
      this.container.width(this.container_width());
      if (this.is_multiple) {
        this.container.html(this.get_multi_html());
      } else {
        this.container.html(this.get_single_html());
      }
      this.form_field_jq.hide().after(this.container);
      this.dropdown = this.container.find('div.chosen-drop').first();
      this.search_field = this.container.find('input').first();
      this.search_results = this.container.find('ul.chosen-results').first();
      this.search_field_scale();
      this.search_no_results = this.container.find('li.no-results').first();
      if (this.is_multiple) {
        this.search_choices = this.container.find('ul.chosen-choices').first();
        this.search_container = this.container.find('li.search-field').first();
      } else {
        this.search_container = this.container.find('div.chosen-search').first();
        this.selected_item = this.container.find('.chosen-single').first();
      }
      this.results_build();
      this.set_tab_index();
      return this.set_label_behavior();
    };

    Chosen.prototype.on_ready = function() {
      return this.form_field_jq.trigger("chosen:ready", {
        chosen: this
      });
    };

    Chosen.prototype.register_observers = function() {
      var _this = this;
      this.container.bind('touchstart.chosen', function(evt) {
        _this.container_mousedown(evt);
      });
      this.container.bind('touchend.chosen', function(evt) {
        _this.container_mouseup(evt);
      });
      this.container.bind('mousedown.chosen', function(evt) {
        _this.container_mousedown(evt);
      });
      this.container.bind('mouseup.chosen', function(evt) {
        _this.container_mouseup(evt);
      });
      this.container.bind('mouseenter.chosen', function(evt) {
        _this.mouse_enter(evt);
      });
      this.container.bind('mouseleave.chosen', function(evt) {
        _this.mouse_leave(evt);
      });
      this.search_results.bind('mouseup.chosen', function(evt) {
        _this.search_results_mouseup(evt);
      });
      this.search_results.bind('mouseover.chosen', function(evt) {
        _this.search_results_mouseover(evt);
      });
      this.search_results.bind('mouseout.chosen', function(evt) {
        _this.search_results_mouseout(evt);
      });
      this.search_results.bind('mousewheel.chosen DOMMouseScroll.chosen', function(evt) {
        _this.search_results_mousewheel(evt);
      });
      this.search_results.bind('touchstart.chosen', function(evt) {
        _this.search_results_touchstart(evt);
      });
      this.search_results.bind('touchmove.chosen', function(evt) {
        _this.search_results_touchmove(evt);
      });
      this.search_results.bind('touchend.chosen', function(evt) {
        _this.search_results_touchend(evt);
      });
      this.form_field_jq.bind("chosen:updated.chosen", function(evt) {
        _this.results_update_field(evt);
      });
      this.form_field_jq.bind("chosen:activate.chosen", function(evt) {
        _this.activate_field(evt);
      });
      this.form_field_jq.bind("chosen:open.chosen", function(evt) {
        _this.container_mousedown(evt);
      });
      this.form_field_jq.bind("chosen:close.chosen", function(evt) {
        _this.close_field(evt);
      });
      this.search_field.bind('blur.chosen', function(evt) {
        _this.input_blur(evt);
      });
      this.search_field.bind('keyup.chosen', function(evt) {
        _this.keyup_checker(evt);
      });
      this.search_field.bind('keydown.chosen', function(evt) {
        _this.keydown_checker(evt);
      });
      this.search_field.bind('focus.chosen', function(evt) {
        _this.input_focus(evt);
      });
      this.search_field.bind('cut.chosen', function(evt) {
        _this.clipboard_event_checker(evt);
      });
      this.search_field.bind('paste.chosen', function(evt) {
        _this.clipboard_event_checker(evt);
      });
      if (this.is_multiple) {
        return this.search_choices.bind('click.chosen', function(evt) {
          _this.choices_click(evt);
        });
      } else {
        return this.container.bind('click.chosen', function(evt) {
          evt.preventDefault();
        });
      }
    };

    Chosen.prototype.destroy = function() {
      $(this.container[0].ownerDocument).unbind('click.chosen', this.click_test_action);
      if (this.form_field_label.length > 0) {
        this.form_field_label.unbind('click.chosen');
      }
      if (this.search_field[0].tabIndex) {
        this.form_field_jq[0].tabIndex = this.search_field[0].tabIndex;
      }
      this.container.remove();
      this.form_field_jq.removeData('chosen');
      return this.form_field_jq.show();
    };

    Chosen.prototype.search_field_disabled = function() {
      this.is_disabled = this.form_field.disabled || this.form_field_jq.parents('fieldset').is(':disabled');
      this.container.toggleClass('chosen-disabled', this.is_disabled);
      this.search_field[0].disabled = this.is_disabled;
      if (!this.is_multiple) {
        this.selected_item.unbind('focus.chosen', this.activate_field);
      }
      if (this.is_disabled) {
        return this.close_field();
      } else if (!this.is_multiple) {
        return this.selected_item.bind('focus.chosen', this.activate_field);
      }
    };

    Chosen.prototype.container_mousedown = function(evt) {
      var _ref1;
      if (this.is_disabled) {
        return;
      }
      if (evt && ((_ref1 = evt.type) === 'mousedown' || _ref1 === 'touchstart') && !this.results_showing) {
        evt.preventDefault();
      }
      if (!((evt != null) && ($(evt.target)).hasClass("search-choice-close"))) {
        if (!this.active_field) {
          if (this.is_multiple) {
            this.search_field.val("");
          }
          $(this.container[0].ownerDocument).bind('click.chosen', this.click_test_action);
          this.results_show();
        } else if (!this.is_multiple && evt && (($(evt.target)[0] === this.selected_item[0]) || $(evt.target).parents("a.chosen-single").length)) {
          evt.preventDefault();
          this.results_toggle();
        }
        return this.activate_field();
      }
    };

    Chosen.prototype.container_mouseup = function(evt) {
      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.search_results_mousewheel = function(evt) {
      var delta;
      if (evt.originalEvent) {
        delta = evt.originalEvent.deltaY || -evt.originalEvent.wheelDelta || evt.originalEvent.detail;
      }
      if (delta != null) {
        evt.preventDefault();
        if (evt.type === 'DOMMouseScroll') {
          delta = delta * 40;
        }
        return this.search_results.scrollTop(delta + this.search_results.scrollTop());
      }
    };

    Chosen.prototype.blur_test = function(evt) {
      if (!this.active_field && this.container.hasClass("chosen-container-active")) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function() {
      $(this.container[0].ownerDocument).unbind("click.chosen", this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClass("chosen-container-active");
      this.clear_backstroke();
      this.show_search_field_default();
      this.search_field_scale();
      return this.search_field.blur();
    };

    Chosen.prototype.activate_field = function() {
      if (this.is_disabled) {
        return;
      }
      this.container.addClass("chosen-container-active");
      this.active_field = true;
      this.search_field.val(this.search_field.val());
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function(evt) {
      var active_container;
      active_container = $(evt.target).closest('.chosen-container');
      if (active_container.length && this.container[0] === active_container[0]) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function() {
      this.parsing = true;
      this.selected_option_count = null;
      this.results_data = SelectParser.select_to_array(this.form_field);
      if (this.is_multiple) {
        this.search_choices.find("li.search-choice").remove();
      } else if (!this.is_multiple) {
        this.single_set_selected_text();
        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.search_field[0].readOnly = true;
          this.container.addClass("chosen-container-single-nosearch");
        } else {
          this.search_field[0].readOnly = false;
          this.container.removeClass("chosen-container-single-nosearch");
        }
      }
      this.update_results_content(this.results_option_build({
        first: true
      }));
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      return this.parsing = false;
    };

    Chosen.prototype.result_do_highlight = function(el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
      if (el.length) {
        this.result_clear_highlight();
        this.result_highlight = el;
        this.result_highlight.addClass("highlighted");
        maxHeight = parseInt(this.search_results.css("maxHeight"), 10);
        visible_top = this.search_results.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = this.result_highlight.position().top + this.search_results.scrollTop();
        high_bottom = high_top + this.result_highlight.outerHeight();
        if (high_bottom >= visible_bottom) {
          return this.search_results.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
          return this.search_results.scrollTop(high_top);
        }
      }
    };

    Chosen.prototype.result_clear_highlight = function() {
      if (this.result_highlight) {
        this.result_highlight.removeClass("highlighted");
      }
      return this.result_highlight = null;
    };

    Chosen.prototype.results_show = function() {
      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
        this.form_field_jq.trigger("chosen:maxselected", {
          chosen: this
        });
        return false;
      }
      this.container.addClass("chosen-with-drop");
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.val(this.get_search_field_value());
      this.winnow_results();
      return this.form_field_jq.trigger("chosen:showing_dropdown", {
        chosen: this
      });
    };

    Chosen.prototype.update_results_content = function(content) {
      return this.search_results.html(content);
    };

    Chosen.prototype.results_hide = function() {
      if (this.results_showing) {
        this.result_clear_highlight();
        this.container.removeClass("chosen-with-drop");
        this.form_field_jq.trigger("chosen:hiding_dropdown", {
          chosen: this
        });
      }
      return this.results_showing = false;
    };

    Chosen.prototype.set_tab_index = function(el) {
      var ti;
      if (this.form_field.tabIndex) {
        ti = this.form_field.tabIndex;
        this.form_field.tabIndex = -1;
        return this.search_field[0].tabIndex = ti;
      }
    };

    Chosen.prototype.set_label_behavior = function() {
      this.form_field_label = this.form_field_jq.parents("label");
      if (!this.form_field_label.length && this.form_field.id.length) {
        this.form_field_label = $("label[for='" + this.form_field.id + "']");
      }
      if (this.form_field_label.length > 0) {
        return this.form_field_label.bind('click.chosen', this.label_click_handler);
      }
    };

    Chosen.prototype.show_search_field_default = function() {
      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
        this.search_field.val(this.default_text);
        return this.search_field.addClass("default");
      } else {
        this.search_field.val("");
        return this.search_field.removeClass("default");
      }
    };

    Chosen.prototype.search_results_mouseup = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target.length) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function(evt) {
      var target;
      target = $(evt.target).hasClass("active-result") ? $(evt.target) : $(evt.target).parents(".active-result").first();
      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function(evt) {
      if ($(evt.target).hasClass("active-result" || $(evt.target).parents('.active-result').first())) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choice_build = function(item) {
      var choice, close_link,
        _this = this;
      choice = $('<li />', {
        "class": "search-choice"
      }).html("<span>" + (this.choice_label(item)) + "</span>");
      if (item.disabled) {
        choice.addClass('search-choice-disabled');
      } else {
        close_link = $('<a />', {
          "class": 'search-choice-close',
          'data-option-array-index': item.array_index
        });
        close_link.bind('click.chosen', function(evt) {
          return _this.choice_destroy_link_click(evt);
        });
        choice.append(close_link);
      }
      return this.search_container.before(choice);
    };

    Chosen.prototype.choice_destroy_link_click = function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!this.is_disabled) {
        return this.choice_destroy($(evt.target));
      }
    };

    Chosen.prototype.choice_destroy = function(link) {
      if (this.result_deselect(link[0].getAttribute("data-option-array-index"))) {
        if (this.active_field) {
          this.search_field.focus();
        } else {
          this.show_search_field_default();
        }
        if (this.is_multiple && this.choices_count() > 0 && this.get_search_field_value().length < 1) {
          this.results_hide();
        }
        link.parents('li').first().remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function() {
      this.reset_single_select_options();
      this.form_field.options[0].selected = true;
      this.single_set_selected_text();
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.trigger_form_field_change();
      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function() {
      this.current_selectedIndex = this.form_field.selectedIndex;
      return this.selected_item.find("abbr").remove();
    };

    Chosen.prototype.result_select = function(evt) {
      var high, item;
      if (this.result_highlight) {
        high = this.result_highlight;
        this.result_clear_highlight();
        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
          this.form_field_jq.trigger("chosen:maxselected", {
            chosen: this
          });
          return false;
        }
        if (this.is_multiple) {
          high.removeClass("active-result");
        } else {
          this.reset_single_select_options();
        }
        high.addClass("result-selected");
        item = this.results_data[high[0].getAttribute("data-option-array-index")];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        this.selected_option_count = null;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.single_set_selected_text(this.choice_label(item));
        }
        if (!(this.is_multiple && (!this.hide_results_on_select || (evt.metaKey || evt.ctrlKey)))) {
          this.results_hide();
          this.show_search_field_default();
        }
        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
          this.trigger_form_field_change({
            selected: this.form_field.options[item.options_index].value
          });
        }
        this.current_selectedIndex = this.form_field.selectedIndex;
        evt.preventDefault();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.single_set_selected_text = function(text) {
      if (text == null) {
        text = this.default_text;
      }
      if (text === this.default_text) {
        this.selected_item.addClass("chosen-default");
      } else {
        this.single_deselect_control_build();
        this.selected_item.removeClass("chosen-default");
      }
      return this.selected_item.find("span").html(text);
    };

    Chosen.prototype.result_deselect = function(pos) {
      var result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        this.selected_option_count = null;
        this.result_clear_highlight();
        if (this.results_showing) {
          this.winnow_results();
        }
        this.trigger_form_field_change({
          deselected: this.form_field.options[result_data.options_index].value
        });
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function() {
      if (!this.allow_single_deselect) {
        return;
      }
      if (!this.selected_item.find("abbr").length) {
        this.selected_item.find("span").first().after("<abbr class=\"search-choice-close\"></abbr>");
      }
      return this.selected_item.addClass("chosen-single-with-deselect");
    };

    Chosen.prototype.get_search_field_value = function() {
      return this.search_field.val();
    };

    Chosen.prototype.get_search_text = function() {
      return this.escape_html($.trim(this.get_search_field_value()));
    };

    Chosen.prototype.escape_html = function(text) {
      return $('<div/>').text(text).html();
    };

    Chosen.prototype.winnow_results_set_highlight = function() {
      var do_high, selected_results;
      selected_results = !this.is_multiple ? this.search_results.find(".result-selected.active-result") : [];
      do_high = selected_results.length ? selected_results.first() : this.search_results.find(".active-result").first();
      if (do_high != null) {
        return this.result_do_highlight(do_high);
      }
    };

    Chosen.prototype.no_results = function(terms) {
      var no_results_html;
      no_results_html = this.get_no_results_html(terms);
      this.search_results.append(no_results_html);
      return this.form_field_jq.trigger("chosen:no_results", {
        chosen: this
      });
    };

    Chosen.prototype.no_results_clear = function() {
      return this.search_results.find(".no-results").remove();
    };

    Chosen.prototype.keydown_arrow = function() {
      var next_sib;
      if (this.results_showing && this.result_highlight) {
        next_sib = this.result_highlight.nextAll("li.active-result").first();
        if (next_sib) {
          return this.result_do_highlight(next_sib);
        }
      } else {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function() {
      var prev_sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        prev_sibs = this.result_highlight.prevAll("li.active-result");
        if (prev_sibs.length) {
          return this.result_do_highlight(prev_sibs.first());
        } else {
          if (this.choices_count() > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function() {
      var next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.find("a").first());
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings("li.search-choice").last();
        if (next_available_destroy.length && !next_available_destroy.hasClass("search-choice-disabled")) {
          this.pending_backstroke = next_available_destroy;
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClass("search-choice-focus");
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function() {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClass("search-choice-focus");
      }
      return this.pending_backstroke = null;
    };

    Chosen.prototype.search_field_scale = function() {
      var container_width, div, style, style_block, styles, width, _i, _len;
      if (!this.is_multiple) {
        return;
      }
      style_block = {
        position: 'absolute',
        left: '-1000px',
        top: '-1000px',
        display: 'none',
        whiteSpace: 'pre'
      };
      styles = ['fontSize', 'fontStyle', 'fontWeight', 'fontFamily', 'lineHeight', 'textTransform', 'letterSpacing'];
      for (_i = 0, _len = styles.length; _i < _len; _i++) {
        style = styles[_i];
        style_block[style] = this.search_field.css(style);
      }
      div = $('<div />').css(style_block);
      div.text(this.get_search_field_value());
      $('body').append(div);
      width = div.width() + 25;
      div.remove();
      container_width = this.container.outerWidth();
      width = Math.min(container_width - 10, width);
      return this.search_field.width(width);
    };

    Chosen.prototype.trigger_form_field_change = function(extra) {
      this.form_field_jq.trigger("input", extra);
      return this.form_field_jq.trigger("change", extra);
    };

    return Chosen;

  })(AbstractChosen);

}).call(this);


/*!
Chosen, a Select Box Enhancer for jQuery and Prototype
by Patrick Filler for Harvest, http://getharvest.com

Version 1.7.0
Full source at https://github.com/harvesthq/chosen
Copyright (c) 2011-2017 Harvest http://getharvest.com

MIT License, https://github.com/harvesthq/chosen/blob/master/LICENSE.md
This file is generated by `grunt build`, do not edit it by hand.
*/

(function() {
  var AbstractChosen, SelectParser, _ref,
    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  SelectParser = (function() {
    function SelectParser() {
      this.options_index = 0;
      this.parsed = [];
    }

    SelectParser.prototype.add_node = function(child) {
      if (child.nodeName.toUpperCase() === "OPTGROUP") {
        return this.add_group(child);
      } else {
        return this.add_option(child);
      }
    };

    SelectParser.prototype.add_group = function(group) {
      var group_position, option, _i, _len, _ref, _results;
      group_position = this.parsed.length;
      this.parsed.push({
        array_index: group_position,
        group: true,
        label: this.escapeExpression(group.label),
        title: group.title ? group.title : void 0,
        children: 0,
        disabled: group.disabled,
        classes: group.className
      });
      _ref = group.childNodes;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        _results.push(this.add_option(option, group_position, group.disabled));
      }
      return _results;
    };

    SelectParser.prototype.add_option = function(option, group_position, group_disabled) {
      if (option.nodeName.toUpperCase() === "OPTION") {
        if (option.text !== "") {
          if (group_position != null) {
            this.parsed[group_position].children += 1;
          }
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            value: option.value,
            text: option.text,
            html: option.innerHTML,
            title: option.title ? option.title : void 0,
            selected: option.selected,
            disabled: group_disabled === true ? group_disabled : option.disabled,
            group_array_index: group_position,
            group_label: group_position != null ? this.parsed[group_position].label : null,
            classes: option.className,
            style: option.style.cssText
          });
        } else {
          this.parsed.push({
            array_index: this.parsed.length,
            options_index: this.options_index,
            empty: true
          });
        }
        return this.options_index += 1;
      }
    };

    SelectParser.prototype.escapeExpression = function(text) {
      var map, unsafe_chars;
      if ((text == null) || text === false) {
        return "";
      }
      if (!/[\&\<\>\"\'\`]/.test(text)) {
        return text;
      }
      map = {
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;"
      };
      unsafe_chars = /&(?!\w+;)|[\<\>\"\'\`]/g;
      return text.replace(unsafe_chars, function(chr) {
        return map[chr] || "&amp;";
      });
    };

    return SelectParser;

  })();

  SelectParser.select_to_array = function(select) {
    var child, parser, _i, _len, _ref;
    parser = new SelectParser();
    _ref = select.childNodes;
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      child = _ref[_i];
      parser.add_node(child);
    }
    return parser.parsed;
  };

  AbstractChosen = (function() {
    function AbstractChosen(form_field, options) {
      this.form_field = form_field;
      this.options = options != null ? options : {};
      this.label_click_handler = __bind(this.label_click_handler, this);
      if (!AbstractChosen.browser_is_supported()) {
        return;
      }
      this.is_multiple = this.form_field.multiple;
      this.set_default_text();
      this.set_default_values();
      this.setup();
      this.set_up_html();
      this.register_observers();
      this.on_ready();
    }

    AbstractChosen.prototype.set_default_values = function() {
      var _this = this;
      this.click_test_action = function(evt) {
        return _this.test_active_click(evt);
      };
      this.activate_action = function(evt) {
        return _this.activate_field(evt);
      };
      this.active_field = false;
      this.mouse_on_container = false;
      this.results_showing = false;
      this.result_highlighted = null;
      this.is_rtl = this.options.rtl || /\bchosen-rtl\b/.test(this.form_field.className);
      this.allow_single_deselect = (this.options.allow_single_deselect != null) && (this.form_field.options[0] != null) && this.form_field.options[0].text === "" ? this.options.allow_single_deselect : false;
      this.disable_search_threshold = this.options.disable_search_threshold || 0;
      this.disable_search = this.options.disable_search || false;
      this.enable_split_word_search = this.options.enable_split_word_search != null ? this.options.enable_split_word_search : true;
      this.group_search = this.options.group_search != null ? this.options.group_search : true;
      this.search_contains = this.options.search_contains || false;
      this.single_backstroke_delete = this.options.single_backstroke_delete != null ? this.options.single_backstroke_delete : true;
      this.max_selected_options = this.options.max_selected_options || Infinity;
      this.inherit_select_classes = this.options.inherit_select_classes || false;
      this.display_selected_options = this.options.display_selected_options != null ? this.options.display_selected_options : true;
      this.display_disabled_options = this.options.display_disabled_options != null ? this.options.display_disabled_options : true;
      this.include_group_label_in_selected = this.options.include_group_label_in_selected || false;
      this.max_shown_results = this.options.max_shown_results || Number.POSITIVE_INFINITY;
      this.case_sensitive_search = this.options.case_sensitive_search || false;
      return this.hide_results_on_select = this.options.hide_results_on_select != null ? this.options.hide_results_on_select : true;
    };

    AbstractChosen.prototype.set_default_text = function() {
      if (this.form_field.getAttribute("data-placeholder")) {
        this.default_text = this.form_field.getAttribute("data-placeholder");
      } else if (this.is_multiple) {
        this.default_text = this.options.placeholder_text_multiple || this.options.placeholder_text || AbstractChosen.default_multiple_text;
      } else {
        this.default_text = this.options.placeholder_text_single || this.options.placeholder_text || AbstractChosen.default_single_text;
      }
      this.default_text = this.escape_html(this.default_text);
      return this.results_none_found = this.form_field.getAttribute("data-no_results_text") || this.options.no_results_text || AbstractChosen.default_no_result_text;
    };

    AbstractChosen.prototype.choice_label = function(item) {
      if (this.include_group_label_in_selected && (item.group_label != null)) {
        return "<b class='group-name'>" + item.group_label + "</b>" + item.html;
      } else {
        return item.html;
      }
    };

    AbstractChosen.prototype.mouse_enter = function() {
      return this.mouse_on_container = true;
    };

    AbstractChosen.prototype.mouse_leave = function() {
      return this.mouse_on_container = false;
    };

    AbstractChosen.prototype.input_focus = function(evt) {
      var _this = this;
      if (this.is_multiple) {
        if (!this.active_field) {
          return setTimeout((function() {
            return _this.container_mousedown();
          }), 50);
        }
      } else {
        if (!this.active_field) {
          return this.activate_field();
        }
      }
    };

    AbstractChosen.prototype.input_blur = function(evt) {
      var _this = this;
      if (!this.mouse_on_container) {
        this.active_field = false;
        return setTimeout((function() {
          return _this.blur_test();
        }), 100);
      }
    };

    AbstractChosen.prototype.label_click_handler = function(evt) {
      if (this.is_multiple) {
        return this.container_mousedown(evt);
      } else {
        return this.activate_field();
      }
    };

    AbstractChosen.prototype.results_option_build = function(options) {
      var content, data, data_content, shown_results, _i, _len, _ref;
      content = '';
      shown_results = 0;
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        data = _ref[_i];
        data_content = '';
        if (data.group) {
          data_content = this.result_add_group(data);
        } else {
          data_content = this.result_add_option(data);
        }
        if (data_content !== '') {
          shown_results++;
          content += data_content;
        }
        if (options != null ? options.first : void 0) {
          if (data.selected && this.is_multiple) {
            this.choice_build(data);
          } else if (data.selected && !this.is_multiple) {
            this.single_set_selected_text(this.choice_label(data));
          }
        }
        if (shown_results >= this.max_shown_results) {
          break;
        }
      }
      return content;
    };

    AbstractChosen.prototype.result_add_option = function(option) {
      var classes, option_el;
      if (!option.search_match) {
        return '';
      }
      if (!this.include_option_in_results(option)) {
        return '';
      }
      classes = [];
      if (!option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("active-result");
      }
      if (option.disabled && !(option.selected && this.is_multiple)) {
        classes.push("disabled-result");
      }
      if (option.selected) {
        classes.push("result-selected");
      }
      if (option.group_array_index != null) {
        classes.push("group-option");
      }
      if (option.classes !== "") {
        classes.push(option.classes);
      }
      option_el = document.createElement("li");
      option_el.className = classes.join(" ");
      option_el.style.cssText = option.style;
      option_el.setAttribute("data-option-array-index", option.array_index);
      option_el.innerHTML = option.search_text;
      if (option.title) {
        option_el.title = option.title;
      }
      return this.outerHTML(option_el);
    };

    AbstractChosen.prototype.result_add_group = function(group) {
      var classes, group_el;
      if (!(group.search_match || group.group_match)) {
        return '';
      }
      if (!(group.active_options > 0)) {
        return '';
      }
      classes = [];
      classes.push("group-result");
      if (group.classes) {
        classes.push(group.classes);
      }
      group_el = document.createElement("li");
      group_el.className = classes.join(" ");
      group_el.innerHTML = group.search_text;
      if (group.title) {
        group_el.title = group.title;
      }
      return this.outerHTML(group_el);
    };

    AbstractChosen.prototype.results_update_field = function() {
      this.set_default_text();
      if (!this.is_multiple) {
        this.results_reset_cleanup();
      }
      this.result_clear_highlight();
      this.results_build();
      if (this.results_showing) {
        return this.winnow_results();
      }
    };

    AbstractChosen.prototype.reset_single_select_options = function() {
      var result, _i, _len, _ref, _results;
      _ref = this.results_data;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        result = _ref[_i];
        if (result.selected) {
          _results.push(result.selected = false);
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    AbstractChosen.prototype.results_toggle = function() {
      if (this.results_showing) {
        return this.results_hide();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.results_search = function(evt) {
      if (this.results_showing) {
        return this.winnow_results();
      } else {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.winnow_results = function() {
      var escapedSearchText, highlightRegex, option, regex, results, results_group, searchText, startpos, text, _i, _len, _ref;
      this.no_results_clear();
      results = 0;
      searchText = this.get_search_text();
      escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
      regex = this.get_search_regex(escapedSearchText);
      highlightRegex = this.get_highlight_regex(escapedSearchText);
      _ref = this.results_data;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        option.search_match = false;
        results_group = null;
        if (this.include_option_in_results(option)) {
          if (option.group) {
            option.group_match = false;
            option.active_options = 0;
          }
          if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
            results_group = this.results_data[option.group_array_index];
            if (results_group.active_options === 0 && results_group.search_match) {
              results += 1;
            }
            results_group.active_options += 1;
          }
          option.search_text = option.group ? option.label : option.html;
          if (!(option.group && !this.group_search)) {
            option.search_match = this.search_string_match(option.search_text, regex);
            if (option.search_match && !option.group) {
              results += 1;
            }
            if (option.search_match) {
              if (searchText.length) {
                startpos = option.search_text.search(highlightRegex);
                text = option.search_text.substr(0, startpos + searchText.length) + '</em>' + option.search_text.substr(startpos + searchText.length);
                option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
              }
              if (results_group != null) {
                results_group.group_match = true;
              }
            } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
              option.search_match = true;
            }
          }
        }
      }
      this.result_clear_highlight();
      if (results < 1 && searchText.length) {
        this.update_results_content("");
        return this.no_results(searchText);
      } else {
        this.update_results_content(this.results_option_build());
        return this.winnow_results_set_highlight();
      }
    };

    AbstractChosen.prototype.get_search_regex = function(escaped_search_string) {
      var regex_anchor, regex_flag;
      regex_anchor = this.search_contains ? "" : "^";
      regex_flag = this.case_sensitive_search ? "" : "i";
      return new RegExp(regex_anchor + escaped_search_string, regex_flag);
    };

    AbstractChosen.prototype.get_highlight_regex = function(escaped_search_string) {
      var regex_anchor, regex_flag;
      regex_anchor = this.search_contains ? "" : "\\b";
      regex_flag = this.case_sensitive_search ? "" : "i";
      return new RegExp(regex_anchor + escaped_search_string, regex_flag);
    };

    AbstractChosen.prototype.search_string_match = function(search_string, regex) {
      var part, parts, _i, _len;
      if (regex.test(search_string)) {
        return true;
      } else if (this.enable_split_word_search && (search_string.indexOf(" ") >= 0 || search_string.indexOf("[") === 0)) {
        parts = search_string.replace(/\[|\]/g, "").split(" ");
        if (parts.length) {
          for (_i = 0, _len = parts.length; _i < _len; _i++) {
            part = parts[_i];
            if (regex.test(part)) {
              return true;
            }
          }
        }
      }
    };

    AbstractChosen.prototype.choices_count = function() {
      var option, _i, _len, _ref;
      if (this.selected_option_count != null) {
        return this.selected_option_count;
      }
      this.selected_option_count = 0;
      _ref = this.form_field.options;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        option = _ref[_i];
        if (option.selected) {
          this.selected_option_count += 1;
        }
      }
      return this.selected_option_count;
    };

    AbstractChosen.prototype.choices_click = function(evt) {
      evt.preventDefault();
      this.activate_field();
      if (!(this.results_showing || this.is_disabled)) {
        return this.results_show();
      }
    };

    AbstractChosen.prototype.keydown_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      if (stroke !== 8 && this.pending_backstroke) {
        this.clear_backstroke();
      }
      switch (stroke) {
        case 8:
          this.backstroke_length = this.get_search_field_value().length;
          break;
        case 9:
          if (this.results_showing && !this.is_multiple) {
            this.result_select(evt);
          }
          this.mouse_on_container = false;
          break;
        case 13:
          if (this.results_showing) {
            evt.preventDefault();
          }
          break;
        case 27:
          if (this.results_showing) {
            evt.preventDefault();
          }
          break;
        case 32:
          if (this.disable_search) {
            evt.preventDefault();
          }
          break;
        case 38:
          evt.preventDefault();
          this.keyup_arrow();
          break;
        case 40:
          evt.preventDefault();
          this.keydown_arrow();
          break;
      }
    };

    AbstractChosen.prototype.keyup_checker = function(evt) {
      var stroke, _ref;
      stroke = (_ref = evt.which) != null ? _ref : evt.keyCode;
      this.search_field_scale();
      switch (stroke) {
        case 8:
          if (this.is_multiple && this.backstroke_length < 1 && this.choices_count() > 0) {
            this.keydown_backstroke();
          } else if (!this.pending_backstroke) {
            this.result_clear_highlight();
            this.results_search();
          }
          break;
        case 13:
          evt.preventDefault();
          if (this.results_showing) {
            this.result_select(evt);
          }
          break;
        case 27:
          if (this.results_showing) {
            this.results_hide();
          }
          break;
        case 9:
        case 16:
        case 17:
        case 18:
        case 38:
        case 40:
        case 91:
          break;
        default:
          this.results_search();
          break;
      }
    };

    AbstractChosen.prototype.clipboard_event_checker = function(evt) {
      var _this = this;
      if (this.is_disabled) {
        return;
      }
      return setTimeout((function() {
        return _this.results_search();
      }), 50);
    };

    AbstractChosen.prototype.container_width = function() {
      if (this.options.width != null) {
        return this.options.width;
      } else {
        return "" + this.form_field.offsetWidth + "px";
      }
    };

    AbstractChosen.prototype.include_option_in_results = function(option) {
      if (this.is_multiple && (!this.display_selected_options && option.selected)) {
        return false;
      }
      if (!this.display_disabled_options && option.disabled) {
        return false;
      }
      if (option.empty) {
        return false;
      }
      return true;
    };

    AbstractChosen.prototype.search_results_touchstart = function(evt) {
      this.touch_started = true;
      return this.search_results_mouseover(evt);
    };

    AbstractChosen.prototype.search_results_touchmove = function(evt) {
      this.touch_started = false;
      return this.search_results_mouseout(evt);
    };

    AbstractChosen.prototype.search_results_touchend = function(evt) {
      if (this.touch_started) {
        return this.search_results_mouseup(evt);
      }
    };

    AbstractChosen.prototype.outerHTML = function(element) {
      var tmp;
      if (element.outerHTML) {
        return element.outerHTML;
      }
      tmp = document.createElement("div");
      tmp.appendChild(element);
      return tmp.innerHTML;
    };

    AbstractChosen.prototype.get_single_html = function() {
      return "<a class=\"chosen-single chosen-default\">\n  <span>" + this.default_text + "</span>\n  <div><b></b></div>\n</a>\n<div class=\"chosen-drop\">\n  <div class=\"chosen-search\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" />\n  </div>\n  <ul class=\"chosen-results\"></ul>\n</div>";
    };

    AbstractChosen.prototype.get_multi_html = function() {
      return "<ul class=\"chosen-choices\">\n  <li class=\"search-field\">\n    <input class=\"chosen-search-input\" type=\"text\" autocomplete=\"off\" value=\"" + this.default_text + "\" />\n  </li>\n</ul>\n<div class=\"chosen-drop\">\n  <ul class=\"chosen-results\"></ul>\n</div>";
    };

    AbstractChosen.prototype.get_no_results_html = function(terms) {
      return "<li class=\"no-results\">\n  " + this.results_none_found + " <span>" + terms + "</span>\n</li>";
    };

    AbstractChosen.browser_is_supported = function() {
      if ("Microsoft Internet Explorer" === window.navigator.appName) {
        return document.documentMode >= 8;
      }
      if (/iP(od|hone)/i.test(window.navigator.userAgent) || /IEMobile/i.test(window.navigator.userAgent) || /Windows Phone/i.test(window.navigator.userAgent) || /BlackBerry/i.test(window.navigator.userAgent) || /BB10/i.test(window.navigator.userAgent) || /Android.*Mobile/i.test(window.navigator.userAgent)) {
        return false;
      }
      return true;
    };

    AbstractChosen.default_multiple_text = "Select Some Options";

    AbstractChosen.default_single_text = "Select an Option";

    AbstractChosen.default_no_result_text = "No results match";

    return AbstractChosen;

  })();

  this.Chosen = (function(_super) {
    var triggerHtmlEvent;

    __extends(Chosen, _super);

    function Chosen() {
      _ref = Chosen.__super__.constructor.apply(this, arguments);
      return _ref;
    }

    Chosen.prototype.setup = function() {
      return this.current_selectedIndex = this.form_field.selectedIndex;
    };

    Chosen.prototype.set_default_values = function() {
      Chosen.__super__.set_default_values.call(this);
      return this.no_results_temp = new Template(this.get_no_results_html('#{terms}'));
    };

    Chosen.prototype.set_up_html = function() {
      var container_classes, container_props;
      container_classes = ["chosen-container"];
      container_classes.push("chosen-container-" + (this.is_multiple ? "multi" : "single"));
      if (this.inherit_select_classes && this.form_field.className) {
        container_classes.push(this.form_field.className);
      }
      if (this.is_rtl) {
        container_classes.push("chosen-rtl");
      }
      container_props = {
        'class': container_classes.join(' '),
        'title': this.form_field.title
      };
      if (this.form_field.id.length) {
        container_props.id = this.form_field.id.replace(/[^\w]/g, '_') + "_chosen";
      }
      this.container = new Element('div', container_props);
      this.container.setStyle({
        width: this.container_width()
      });
      if (this.is_multiple) {
        this.container.update(this.get_multi_html());
      } else {
        this.container.update(this.get_single_html());
      }
      this.form_field.hide().insert({
        after: this.container
      });
      this.dropdown = this.container.down('div.chosen-drop');
      this.search_field = this.container.down('input');
      this.search_results = this.container.down('ul.chosen-results');
      this.search_field_scale();
      this.search_no_results = this.container.down('li.no-results');
      if (this.is_multiple) {
        this.search_choices = this.container.down('ul.chosen-choices');
        this.search_container = this.container.down('li.search-field');
      } else {
        this.search_container = this.container.down('div.chosen-search');
        this.selected_item = this.container.down('.chosen-single');
      }
      this.results_build();
      this.set_tab_index();
      return this.set_label_behavior();
    };

    Chosen.prototype.on_ready = function() {
      return this.form_field.fire("chosen:ready", {
        chosen: this
      });
    };

    Chosen.prototype.register_observers = function() {
      var _this = this;
      this.container.observe("touchstart", function(evt) {
        return _this.container_mousedown(evt);
      });
      this.container.observe("touchend", function(evt) {
        return _this.container_mouseup(evt);
      });
      this.container.observe("mousedown", function(evt) {
        return _this.container_mousedown(evt);
      });
      this.container.observe("mouseup", function(evt) {
        return _this.container_mouseup(evt);
      });
      this.container.observe("mouseenter", function(evt) {
        return _this.mouse_enter(evt);
      });
      this.container.observe("mouseleave", function(evt) {
        return _this.mouse_leave(evt);
      });
      this.search_results.observe("mouseup", function(evt) {
        return _this.search_results_mouseup(evt);
      });
      this.search_results.observe("mouseover", function(evt) {
        return _this.search_results_mouseover(evt);
      });
      this.search_results.observe("mouseout", function(evt) {
        return _this.search_results_mouseout(evt);
      });
      this.search_results.observe("mousewheel", function(evt) {
        return _this.search_results_mousewheel(evt);
      });
      this.search_results.observe("DOMMouseScroll", function(evt) {
        return _this.search_results_mousewheel(evt);
      });
      this.search_results.observe("touchstart", function(evt) {
        return _this.search_results_touchstart(evt);
      });
      this.search_results.observe("touchmove", function(evt) {
        return _this.search_results_touchmove(evt);
      });
      this.search_results.observe("touchend", function(evt) {
        return _this.search_results_touchend(evt);
      });
      this.form_field.observe("chosen:updated", function(evt) {
        return _this.results_update_field(evt);
      });
      this.form_field.observe("chosen:activate", function(evt) {
        return _this.activate_field(evt);
      });
      this.form_field.observe("chosen:open", function(evt) {
        return _this.container_mousedown(evt);
      });
      this.form_field.observe("chosen:close", function(evt) {
        return _this.close_field(evt);
      });
      this.search_field.observe("blur", function(evt) {
        return _this.input_blur(evt);
      });
      this.search_field.observe("keyup", function(evt) {
        return _this.keyup_checker(evt);
      });
      this.search_field.observe("keydown", function(evt) {
        return _this.keydown_checker(evt);
      });
      this.search_field.observe("focus", function(evt) {
        return _this.input_focus(evt);
      });
      this.search_field.observe("cut", function(evt) {
        return _this.clipboard_event_checker(evt);
      });
      this.search_field.observe("paste", function(evt) {
        return _this.clipboard_event_checker(evt);
      });
      if (this.is_multiple) {
        return this.search_choices.observe("click", function(evt) {
          return _this.choices_click(evt);
        });
      } else {
        return this.container.observe("click", function(evt) {
          return evt.preventDefault();
        });
      }
    };

    Chosen.prototype.destroy = function() {
      var event, _i, _len, _ref1;
      this.container.ownerDocument.stopObserving("click", this.click_test_action);
      _ref1 = ['chosen:updated', 'chosen:activate', 'chosen:open', 'chosen:close'];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        event = _ref1[_i];
        this.form_field.stopObserving(event);
      }
      this.container.stopObserving();
      this.search_results.stopObserving();
      this.search_field.stopObserving();
      if (this.form_field_label != null) {
        this.form_field_label.stopObserving();
      }
      if (this.is_multiple) {
        this.search_choices.stopObserving();
        this.container.select(".search-choice-close").each(function(choice) {
          return choice.stopObserving();
        });
      } else {
        this.selected_item.stopObserving();
      }
      if (this.search_field.tabIndex) {
        this.form_field.tabIndex = this.search_field.tabIndex;
      }
      this.container.remove();
      return this.form_field.show();
    };

    Chosen.prototype.search_field_disabled = function() {
      var _ref1;
      this.is_disabled = this.form_field.disabled || ((_ref1 = this.form_field.up('fieldset')) != null ? _ref1.disabled : void 0) || false;
      if (this.is_disabled) {
        this.container.addClassName('chosen-disabled');
      } else {
        this.container.removeClassName('chosen-disabled');
      }
      this.search_field.disabled = this.is_disabled;
      if (!this.is_multiple) {
        this.selected_item.stopObserving('focus', this.activate_field);
      }
      if (this.is_disabled) {
        return this.close_field();
      } else if (!this.is_multiple) {
        return this.selected_item.observe('focus', this.activate_field);
      }
    };

    Chosen.prototype.container_mousedown = function(evt) {
      var _ref1;
      if (this.is_disabled) {
        return;
      }
      if (evt && ((_ref1 = evt.type) === 'mousedown' || _ref1 === 'touchstart') && !this.results_showing) {
        evt.preventDefault();
      }
      if (!((evt != null) && evt.target.hasClassName("search-choice-close"))) {
        if (!this.active_field) {
          if (this.is_multiple) {
            this.search_field.clear();
          }
          this.container.ownerDocument.observe("click", this.click_test_action);
          this.results_show();
        } else if (!this.is_multiple && evt && (evt.target === this.selected_item || evt.target.up("a.chosen-single"))) {
          this.results_toggle();
        }
        return this.activate_field();
      }
    };

    Chosen.prototype.container_mouseup = function(evt) {
      if (evt.target.nodeName === "ABBR" && !this.is_disabled) {
        return this.results_reset(evt);
      }
    };

    Chosen.prototype.search_results_mousewheel = function(evt) {
      var delta;
      delta = evt.deltaY || -evt.wheelDelta || evt.detail;
      if (delta != null) {
        evt.preventDefault();
        if (evt.type === 'DOMMouseScroll') {
          delta = delta * 40;
        }
        return this.search_results.scrollTop = delta + this.search_results.scrollTop;
      }
    };

    Chosen.prototype.blur_test = function(evt) {
      if (!this.active_field && this.container.hasClassName("chosen-container-active")) {
        return this.close_field();
      }
    };

    Chosen.prototype.close_field = function() {
      this.container.ownerDocument.stopObserving("click", this.click_test_action);
      this.active_field = false;
      this.results_hide();
      this.container.removeClassName("chosen-container-active");
      this.clear_backstroke();
      this.show_search_field_default();
      this.search_field_scale();
      return this.search_field.blur();
    };

    Chosen.prototype.activate_field = function() {
      if (this.is_disabled) {
        return;
      }
      this.container.addClassName("chosen-container-active");
      this.active_field = true;
      this.search_field.value = this.get_search_field_value();
      return this.search_field.focus();
    };

    Chosen.prototype.test_active_click = function(evt) {
      if (evt.target.up('.chosen-container') === this.container) {
        return this.active_field = true;
      } else {
        return this.close_field();
      }
    };

    Chosen.prototype.results_build = function() {
      this.parsing = true;
      this.selected_option_count = null;
      this.results_data = SelectParser.select_to_array(this.form_field);
      if (this.is_multiple) {
        this.search_choices.select("li.search-choice").invoke("remove");
      } else if (!this.is_multiple) {
        this.single_set_selected_text();
        if (this.disable_search || this.form_field.options.length <= this.disable_search_threshold) {
          this.search_field.readOnly = true;
          this.container.addClassName("chosen-container-single-nosearch");
        } else {
          this.search_field.readOnly = false;
          this.container.removeClassName("chosen-container-single-nosearch");
        }
      }
      this.update_results_content(this.results_option_build({
        first: true
      }));
      this.search_field_disabled();
      this.show_search_field_default();
      this.search_field_scale();
      return this.parsing = false;
    };

    Chosen.prototype.result_do_highlight = function(el) {
      var high_bottom, high_top, maxHeight, visible_bottom, visible_top;
      this.result_clear_highlight();
      this.result_highlight = el;
      this.result_highlight.addClassName("highlighted");
      maxHeight = parseInt(this.search_results.getStyle('maxHeight'), 10);
      visible_top = this.search_results.scrollTop;
      visible_bottom = maxHeight + visible_top;
      high_top = this.result_highlight.positionedOffset().top;
      high_bottom = high_top + this.result_highlight.getHeight();
      if (high_bottom >= visible_bottom) {
        return this.search_results.scrollTop = (high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0;
      } else if (high_top < visible_top) {
        return this.search_results.scrollTop = high_top;
      }
    };

    Chosen.prototype.result_clear_highlight = function() {
      if (this.result_highlight) {
        this.result_highlight.removeClassName('highlighted');
      }
      return this.result_highlight = null;
    };

    Chosen.prototype.results_show = function() {
      if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
        this.form_field.fire("chosen:maxselected", {
          chosen: this
        });
        return false;
      }
      this.container.addClassName("chosen-with-drop");
      this.results_showing = true;
      this.search_field.focus();
      this.search_field.value = this.get_search_field_value();
      this.winnow_results();
      return this.form_field.fire("chosen:showing_dropdown", {
        chosen: this
      });
    };

    Chosen.prototype.update_results_content = function(content) {
      return this.search_results.update(content);
    };

    Chosen.prototype.results_hide = function() {
      if (this.results_showing) {
        this.result_clear_highlight();
        this.container.removeClassName("chosen-with-drop");
        this.form_field.fire("chosen:hiding_dropdown", {
          chosen: this
        });
      }
      return this.results_showing = false;
    };

    Chosen.prototype.set_tab_index = function(el) {
      var ti;
      if (this.form_field.tabIndex) {
        ti = this.form_field.tabIndex;
        this.form_field.tabIndex = -1;
        return this.search_field.tabIndex = ti;
      }
    };

    Chosen.prototype.set_label_behavior = function() {
      this.form_field_label = this.form_field.up("label");
      if (this.form_field_label == null) {
        this.form_field_label = $$("label[for='" + this.form_field.id + "']").first();
      }
      if (this.form_field_label != null) {
        return this.form_field_label.observe("click", this.label_click_handler);
      }
    };

    Chosen.prototype.show_search_field_default = function() {
      if (this.is_multiple && this.choices_count() < 1 && !this.active_field) {
        this.search_field.value = this.default_text;
        return this.search_field.addClassName("default");
      } else {
        this.search_field.value = "";
        return this.search_field.removeClassName("default");
      }
    };

    Chosen.prototype.search_results_mouseup = function(evt) {
      var target;
      target = evt.target.hasClassName("active-result") ? evt.target : evt.target.up(".active-result");
      if (target) {
        this.result_highlight = target;
        this.result_select(evt);
        return this.search_field.focus();
      }
    };

    Chosen.prototype.search_results_mouseover = function(evt) {
      var target;
      target = evt.target.hasClassName("active-result") ? evt.target : evt.target.up(".active-result");
      if (target) {
        return this.result_do_highlight(target);
      }
    };

    Chosen.prototype.search_results_mouseout = function(evt) {
      if (evt.target.hasClassName('active-result') || evt.target.up('.active-result')) {
        return this.result_clear_highlight();
      }
    };

    Chosen.prototype.choice_build = function(item) {
      var choice, close_link,
        _this = this;
      choice = new Element('li', {
        "class": "search-choice"
      }).update("<span>" + (this.choice_label(item)) + "</span>");
      if (item.disabled) {
        choice.addClassName('search-choice-disabled');
      } else {
        close_link = new Element('a', {
          href: '#',
          "class": 'search-choice-close',
          rel: item.array_index
        });
        close_link.observe("click", function(evt) {
          return _this.choice_destroy_link_click(evt);
        });
        choice.insert(close_link);
      }
      return this.search_container.insert({
        before: choice
      });
    };

    Chosen.prototype.choice_destroy_link_click = function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (!this.is_disabled) {
        return this.choice_destroy(evt.target);
      }
    };

    Chosen.prototype.choice_destroy = function(link) {
      if (this.result_deselect(link.readAttribute("rel"))) {
        if (this.active_field) {
          this.search_field.focus();
        } else {
          this.show_search_field_default();
        }
        if (this.is_multiple && this.choices_count() > 0 && this.get_search_field_value().length < 1) {
          this.results_hide();
        }
        link.up('li').remove();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.results_reset = function() {
      this.reset_single_select_options();
      this.form_field.options[0].selected = true;
      this.single_set_selected_text();
      this.show_search_field_default();
      this.results_reset_cleanup();
      this.trigger_form_field_change();
      if (this.active_field) {
        return this.results_hide();
      }
    };

    Chosen.prototype.results_reset_cleanup = function() {
      var deselect_trigger;
      this.current_selectedIndex = this.form_field.selectedIndex;
      deselect_trigger = this.selected_item.down("abbr");
      if (deselect_trigger) {
        return deselect_trigger.remove();
      }
    };

    Chosen.prototype.result_select = function(evt) {
      var high, item;
      if (this.result_highlight) {
        high = this.result_highlight;
        this.result_clear_highlight();
        if (this.is_multiple && this.max_selected_options <= this.choices_count()) {
          this.form_field.fire("chosen:maxselected", {
            chosen: this
          });
          return false;
        }
        if (this.is_multiple) {
          high.removeClassName("active-result");
        } else {
          this.reset_single_select_options();
        }
        high.addClassName("result-selected");
        item = this.results_data[high.getAttribute("data-option-array-index")];
        item.selected = true;
        this.form_field.options[item.options_index].selected = true;
        this.selected_option_count = null;
        if (this.is_multiple) {
          this.choice_build(item);
        } else {
          this.single_set_selected_text(this.choice_label(item));
        }
        if (!(this.is_multiple && (!this.hide_results_on_select || (evt.metaKey || evt.ctrlKey)))) {
          this.results_hide();
          this.show_search_field_default();
        }
        if (this.is_multiple || this.form_field.selectedIndex !== this.current_selectedIndex) {
          this.trigger_form_field_change();
        }
        this.current_selectedIndex = this.form_field.selectedIndex;
        evt.preventDefault();
        return this.search_field_scale();
      }
    };

    Chosen.prototype.single_set_selected_text = function(text) {
      if (text == null) {
        text = this.default_text;
      }
      if (text === this.default_text) {
        this.selected_item.addClassName("chosen-default");
      } else {
        this.single_deselect_control_build();
        this.selected_item.removeClassName("chosen-default");
      }
      return this.selected_item.down("span").update(text);
    };

    Chosen.prototype.result_deselect = function(pos) {
      var result_data;
      result_data = this.results_data[pos];
      if (!this.form_field.options[result_data.options_index].disabled) {
        result_data.selected = false;
        this.form_field.options[result_data.options_index].selected = false;
        this.selected_option_count = null;
        this.result_clear_highlight();
        if (this.results_showing) {
          this.winnow_results();
        }
        this.trigger_form_field_change();
        this.search_field_scale();
        return true;
      } else {
        return false;
      }
    };

    Chosen.prototype.single_deselect_control_build = function() {
      if (!this.allow_single_deselect) {
        return;
      }
      if (!this.selected_item.down("abbr")) {
        this.selected_item.down("span").insert({
          after: "<abbr class=\"search-choice-close\"></abbr>"
        });
      }
      return this.selected_item.addClassName("chosen-single-with-deselect");
    };

    Chosen.prototype.get_search_field_value = function() {
      return this.search_field.value;
    };

    Chosen.prototype.get_search_text = function() {
      return this.escape_html(this.get_search_field_value().strip());
    };

    Chosen.prototype.escape_html = function(text) {
      return text.escapeHTML();
    };

    Chosen.prototype.winnow_results_set_highlight = function() {
      var do_high;
      if (!this.is_multiple) {
        do_high = this.search_results.down(".result-selected.active-result");
      }
      if (do_high == null) {
        do_high = this.search_results.down(".active-result");
      }
      if (do_high != null) {
        return this.result_do_highlight(do_high);
      }
    };

    Chosen.prototype.no_results = function(terms) {
      this.search_results.insert(this.no_results_temp.evaluate({
        terms: terms
      }));
      return this.form_field.fire("chosen:no_results", {
        chosen: this
      });
    };

    Chosen.prototype.no_results_clear = function() {
      var nr, _results;
      nr = null;
      _results = [];
      while (nr = this.search_results.down(".no-results")) {
        _results.push(nr.remove());
      }
      return _results;
    };

    Chosen.prototype.keydown_arrow = function() {
      var next_sib;
      if (this.results_showing && this.result_highlight) {
        next_sib = this.result_highlight.next('.active-result');
        if (next_sib) {
          return this.result_do_highlight(next_sib);
        }
      } else {
        return this.results_show();
      }
    };

    Chosen.prototype.keyup_arrow = function() {
      var actives, prevs, sibs;
      if (!this.results_showing && !this.is_multiple) {
        return this.results_show();
      } else if (this.result_highlight) {
        sibs = this.result_highlight.previousSiblings();
        actives = this.search_results.select("li.active-result");
        prevs = sibs.intersect(actives);
        if (prevs.length) {
          return this.result_do_highlight(prevs.first());
        } else {
          if (this.choices_count() > 0) {
            this.results_hide();
          }
          return this.result_clear_highlight();
        }
      }
    };

    Chosen.prototype.keydown_backstroke = function() {
      var next_available_destroy;
      if (this.pending_backstroke) {
        this.choice_destroy(this.pending_backstroke.down("a"));
        return this.clear_backstroke();
      } else {
        next_available_destroy = this.search_container.siblings().last();
        if (next_available_destroy && next_available_destroy.hasClassName("search-choice") && !next_available_destroy.hasClassName("search-choice-disabled")) {
          this.pending_backstroke = next_available_destroy;
          if (this.pending_backstroke) {
            this.pending_backstroke.addClassName("search-choice-focus");
          }
          if (this.single_backstroke_delete) {
            return this.keydown_backstroke();
          } else {
            return this.pending_backstroke.addClassName("search-choice-focus");
          }
        }
      }
    };

    Chosen.prototype.clear_backstroke = function() {
      if (this.pending_backstroke) {
        this.pending_backstroke.removeClassName("search-choice-focus");
      }
      return this.pending_backstroke = null;
    };

    Chosen.prototype.search_field_scale = function() {
      var container_width, div, style, style_block, styles, width, _i, _len;
      if (!this.is_multiple) {
        return;
      }
      style_block = {
        position: 'absolute',
        left: '-1000px',
        top: '-1000px',
        display: 'none',
        whiteSpace: 'pre'
      };
      styles = ['fontSize', 'fontStyle', 'fontWeight', 'fontFamily', 'lineHeight', 'textTransform', 'letterSpacing'];
      for (_i = 0, _len = styles.length; _i < _len; _i++) {
        style = styles[_i];
        style_block[style] = this.search_field.getStyle(style);
      }
      div = new Element('div').update(this.escape_html(this.get_search_field_value()));
      div.setStyle(style_block);
      document.body.appendChild(div);
      width = div.measure('width') + 25;
      div.remove();
      container_width = this.container.getWidth();
      width = Math.min(container_width - 10, width);
      return this.search_field.setStyle({
        width: width + 'px'
      });
    };

    Chosen.prototype.trigger_form_field_change = function() {
      triggerHtmlEvent(this.form_field, 'input');
      return triggerHtmlEvent(this.form_field, 'change');
    };

    triggerHtmlEvent = function(element, eventType) {
      var evt;
      if (element.dispatchEvent) {
        try {
          evt = new Event(eventType, {
            bubbles: true,
            cancelable: true
          });
        } catch (_error) {
          evt = document.createEvent('HTMLEvents');
          evt.initEvent(eventType, true, true);
        }
        return element.dispatchEvent(evt);
      } else {
        return element.fireEvent("on" + eventType, document.createEventObject());
      }
    };

    return Chosen;

  })(AbstractChosen);

}).call(this);


/*
  SuperBox v1.0.0
  by Todd Motto: http://www.toddmotto.com
  Latest version: https://github.com/toddmotto/superbox
  
  Copyright 2013 Todd Motto
  Licensed under the MIT license
  http://www.opensource.org/licenses/mit-license.php

  SuperBox, the lightbox reimagined. Fully responsive HTML5 image galleries.
*/
;(function($) {
    
  $.fn.SuperBox = function(options) {
    
    var superbox      = $('<div class="superbox-show"></div>');
    var superboximg   = $('<img src="" class="superbox-current-img">');
    var superboxclose = $('<div class="superbox-close"></div>');
    
    superbox.append(superboximg).append(superboxclose);
    
    return this.each(function() {
      
      $('.superbox-list').click(function() {
    
        var currentimg = $(this).find('.superbox-img');
        var imgData = currentimg.data('img');
        superboximg.attr('src', imgData);
        
        if($('.superbox-current-img').css('opacity') == 0) {
          $('.superbox-current-img').animate({opacity: 1});
        }
        
        if ($(this).next().hasClass('superbox-show')) {
          superbox.toggle();
        } else {
          superbox.insertAfter(this).css('display', 'block');
        }
        
        $('html, body').animate({
          scrollTop:superbox.position().top - currentimg.width()
        }, 'medium');
      
      });
            
      $('.superbox').on('click', '.superbox-close', function() {
        $('.superbox-current-img').animate({opacity: 0}, 200, function() {
          $('.superbox-show').slideUp();
        });
      });
      
    });
  };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */function SmartUnLoading(){$(".divMessageBox").fadeOut(300,function(){$(this).remove()}),$(".LoadingBoxContainer").fadeOut(300,function(){$(this).remove()})}function getInternetExplorerVersion(){var a=-1;if("Microsoft Internet Explorer"==navigator.appName){var b=navigator.userAgent,c=new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");null!=c.exec(b)&&(a=parseFloat(RegExp.$1))}return a}function checkVersion(){var a="You're not using Windows Internet Explorer.",b=getInternetExplorerVersion();b>-1&&(a=b>=8?"You're using a recent copy of Windows Internet Explorer.":"You should upgrade your copy of Windows Internet Explorer."),alert(a)}function isIE8orlower(){var a="0",b=getInternetExplorerVersion();return b>-1&&(a=b>=9?0:1),a}$.sound_path="sound/",$.sound_on=!0,jQuery(document).ready(function(){$("body").append("<div id='divSmallBoxes'></div>"),$("body").append("<div id='divMiniIcons'></div><div id='divbigBoxes'></div>")});var ExistMsg=0,SmartMSGboxCount=0,PrevTop=0;$.SmartMessageBox=function(a,b){var c,d;a=$.extend({title:"",content:"",NormalButton:void 0,ActiveButton:void 0,buttons:void 0,input:void 0,inputValue:void 0,placeholder:"",options:void 0},a);var e=0;if(e=1,0==isIE8orlower()){var f=document.createElement("audio");f.setAttribute("src",$.sound_path+"messagebox.mp3"),$.get(),f.addEventListener("load",function(){f.play()},!0),$.sound_on&&(f.pause(),f.play())}SmartMSGboxCount+=1,0==ExistMsg&&(ExistMsg=1,c="<div class='divMessageBox animated fadeIn fast' id='MsgBoxBack'></div>",$("body").append(c),1==isIE8orlower()&&$("#MsgBoxBack").addClass("MessageIE"));var g="",h=0;if(void 0!=a.input)switch(h=1,a.input=a.input.toLowerCase(),a.input){case"text":a.inputValue="string"===$.type(a.inputValue)?a.inputValue.replace(/'/g,"&#x27;"):a.inputValue,g="<input class='form-control' type='"+a.input+"' id='txt"+SmartMSGboxCount+"' placeholder='"+a.placeholder+"' value='"+a.inputValue+"'/><br/><br/>";break;case"password":g="<input class='form-control' type='"+a.input+"' id='txt"+SmartMSGboxCount+"' placeholder='"+a.placeholder+"'/><br/><br/>";break;case"select":if(void 0==a.options)alert("For this type of input, the options parameter is required.");else{g="<select class='form-control' id='txt"+SmartMSGboxCount+"'>";for(var i=0;i<=a.options.length-1;i++)"["==a.options[i]?j="":"]"==a.options[i]?(k+=1,j="<option>"+j+"</option>",g+=j):j+=a.options[i];g+="</select>"}break;default:alert("That type of input is not handled yet")}d="<div class='MessageBoxContainer animated fadeIn fast' id='Msg"+SmartMSGboxCount+"'>",d+="<div class='MessageBoxMiddle'>",d+="<span class='MsgTitle'>"+a.title+"</span class='MsgTitle'>",d+="<p class='pText'>"+a.content+"</p>",d+=g,d+="<div class='MessageBoxButtonSection'>",void 0==a.buttons&&(a.buttons="[Accept]"),a.buttons=$.trim(a.buttons),a.buttons=a.buttons.split("");var j="",k=0;void 0==a.NormalButton&&(a.NormalButton="#232323"),void 0==a.ActiveButton&&(a.ActiveButton="#ed145b");for(var i=0;i<=a.buttons.length-1;i++)"["==a.buttons[i]?j="":"]"==a.buttons[i]?(k+=1,j="<button id='bot"+k+"-Msg"+SmartMSGboxCount+"' class='btn btn-default btn-sm botTempo'> "+j+"</button>",d+=j):j+=a.buttons[i];d+="</div>",d+="</div>",d+="</div>",SmartMSGboxCount>1&&($(".MessageBoxContainer").hide(),$(".MessageBoxContainer").css("z-index",99999)),$(".divMessageBox").append(d),1==h&&$("#txt"+SmartMSGboxCount).focus(),$(".botTempo").hover(function(){$(this).attr("id")},function(){$(this).attr("id")}),$(".botTempo").click(function(){var a=$(this).attr("id"),c=a.substr(a.indexOf("-")+1),d=$.trim($(this).text());if(1==h){if("function"==typeof b){var e=c.replace("Msg",""),f=$("#txt"+e).val();b&&b(d,f)}}else"function"==typeof b&&b&&b(d);$("#"+c).addClass("animated fadeOut fast"),SmartMSGboxCount-=1,0==SmartMSGboxCount&&$("#MsgBoxBack").removeClass("fadeIn").addClass("fadeOut").delay(300).queue(function(){ExistMsg=0,$(this).remove()})})};var BigBoxes=0;$.bigBox=function(a,b){var c;if(a=$.extend({title:"",content:"",icon:void 0,number:void 0,color:void 0,sound:$.sound_on,sound_file:"bigbox",timeout:void 0,colortime:1500,colors:void 0},a),1==a.sound&&0==isIE8orlower()){var d=document.createElement("audio");navigator.userAgent.match("Firefox/")?d.setAttribute("src",$.sound_path+a.sound_file+".ogg"):d.setAttribute("src",$.sound_path+a.sound_file+".mp3"),$.get(),d.addEventListener("load",function(){d.play()},!0),$.sound_on&&(d.pause(),d.play())}BigBoxes+=1,c="<div id='bigBox"+BigBoxes+"' class='bigBox animated fadeIn fast'><div id='bigBoxColor"+BigBoxes+"'><i class='botClose fa fa-times' id='botClose"+BigBoxes+"'></i>",c+="<span>"+a.title+"</span>",c+="<p>"+a.content+"</p>",c+="<div class='bigboxicon'>",void 0==a.icon&&(a.icon="fa fa-cloud"),c+="<i class='"+a.icon+"'></i>",c+="</div>",c+="<div class='bigboxnumber'>",void 0!=a.number&&(c+=a.number),c+="</div></div>",c+="</div>",$("#divbigBoxes").append(c),void 0==a.color&&(a.color="#004d60"),$("#bigBox"+BigBoxes).css("background-color",a.color),$("#divMiniIcons").append("<div id='miniIcon"+BigBoxes+"' class='cajita animated fadeIn' style='background-color: "+a.color+";'><i class='"+a.icon+"'/></i></div>"),$("#miniIcon"+BigBoxes).bind("click",function(){var a=$(this).attr("id"),b=a.replace("miniIcon","bigBox"),c=a.replace("miniIcon","bigBoxColor");$(".cajita").each(function(){var a=$(this).attr("id"),b=a.replace("miniIcon","bigBox");$("#"+b).css("z-index",9998)}),$("#"+b).css("z-index",9999),$("#"+c).removeClass("animated fadeIn").delay(1).queue(function(){$(this).show(),$(this).addClass("animated fadeIn"),$(this).clearQueue()})});var e,f=$("#botClose"+BigBoxes),g=$("#bigBox"+BigBoxes),h=$("#miniIcon"+BigBoxes);if(void 0!=a.colors&&a.colors.length>0&&(f.attr("colorcount","0"),e=setInterval(function(){var b=f.attr("colorcount");f.animate({backgroundColor:a.colors[b].color}),g.animate({backgroundColor:a.colors[b].color}),h.animate({backgroundColor:a.colors[b].color}),b<a.colors.length-1?f.attr("colorcount",1*b+1):f.attr("colorcount",0)},a.colortime)),f.bind("click",function(){clearInterval(e),"function"==typeof b&&b&&b();var a=$(this).attr("id"),c=a.replace("botClose","bigBox"),d=a.replace("botClose","miniIcon");$("#"+c).removeClass("fadeIn fast"),$("#"+c).addClass("fadeOut fast").delay(300).queue(function(){$(this).clearQueue(),$(this).remove()}),$("#"+d).removeClass("fadeIn fast"),$("#"+d).addClass("fadeOut fast").delay(300).queue(function(){$(this).clearQueue(),$(this).remove()})}),void 0!=a.timeout){var i=BigBoxes;setTimeout(function(){clearInterval(e),$("#bigBox"+i).removeClass("fadeIn fast"),$("#bigBox"+i).addClass("fadeOut fast").delay(300).queue(function(){$(this).clearQueue(),$(this).remove()}),$("#miniIcon"+i).removeClass("fadeIn fast"),$("#miniIcon"+i).addClass("fadeOut fast").delay(300).queue(function(){$(this).clearQueue(),$(this).remove()})},a.timeout)}};var SmallBoxes=0,SmallCount=0,SmallBoxesAnchos=0;$.smallBox=function(a,b){var c;if(a=$.extend({title:"",content:"",icon:void 0,iconSmall:void 0,sound:$.sound_on,sound_file:"smallbox",color:void 0,timeout:void 0,colortime:1500,colors:void 0},a),1==a.sound&&0==isIE8orlower()){var d=document.createElement("audio");navigator.userAgent.match("Firefox/")?d.setAttribute("src",$.sound_path+a.sound_file+".ogg"):d.setAttribute("src",$.sound_path+a.sound_file+".mp3"),$.get(),d.addEventListener("load",function(){d.play()},!0),$.sound_on&&(d.pause(),d.play())}SmallBoxes+=1,c="";var e="",f="smallbox"+SmallBoxes;if(e=void 0==a.iconSmall?"<div class='miniIcono'></div>":"<div class='miniIcono'><i class='miniPic "+a.iconSmall+"'></i></div>",c=void 0==a.icon?"<div id='smallbox"+SmallBoxes+"' class='SmallBox animated fadeInRight fast'><div class='textoFull'><span>"+a.title+"</span><p>"+a.content+"</p></div>"+e+"</div>":"<div id='smallbox"+SmallBoxes+"' class='SmallBox animated fadeInRight fast'><div class='foto'><i class='"+a.icon+"'></i></div><div class='textoFoto'><span>"+a.title+"</span><p>"+a.content+"</p></div>"+e+"</div>",1==SmallBoxes)$("#divSmallBoxes").append(c),SmallBoxesAnchos=$("#smallbox"+SmallBoxes).height()+40;else{var g=$(".SmallBox").size();0==g?($("#divSmallBoxes").append(c),SmallBoxesAnchos=$("#smallbox"+SmallBoxes).height()+40):($("#divSmallBoxes").append(c),$("#smallbox"+SmallBoxes).css("top",SmallBoxesAnchos),SmallBoxesAnchos=SmallBoxesAnchos+$("#smallbox"+SmallBoxes).height()+20,$(".SmallBox").each(function(a){0==a?($(this).css("top",20),heightPrev=$(this).height()+40,SmallBoxesAnchos=$(this).height()+40):($(this).css("top",heightPrev),heightPrev=heightPrev+$(this).height()+20,SmallBoxesAnchos=SmallBoxesAnchos+$(this).height()+20)}))}var h=$("#smallbox"+SmallBoxes);void 0==a.color?h.css("background-color","#004d60"):h.css("background-color",a.color);var i;void 0!=a.colors&&a.colors.length>0&&(h.attr("colorcount","0"),i=setInterval(function(){var b=h.attr("colorcount");h.animate({backgroundColor:a.colors[b].color}),b<a.colors.length-1?h.attr("colorcount",1*b+1):h.attr("colorcount",0)},a.colortime)),void 0!=a.timeout&&setTimeout(function(){clearInterval(i);{var a=$(this).height()+20;$("#"+f).css("top")}0!=$("#"+f+":hover").length?$("#"+f).on("mouseleave",function(){SmallBoxesAnchos-=a,$("#"+f).remove(),"function"==typeof b&&b&&b();var c=0;$(".SmallBox").each(function(a){0==a?($(this).animate({top:20},300),c=$(this).height()+40,SmallBoxesAnchos=$(this).height()+40):($(this).animate({top:c},350),c=c+$(this).height()+20,SmallBoxesAnchos=SmallBoxesAnchos+$(this).height()+20)})}):(clearInterval(i),SmallBoxesAnchos-=a,"function"==typeof b&&b&&b(),$("#"+f).removeClass().addClass("SmallBox").animate({opacity:0},300,function(){$(this).remove();var a=0;$(".SmallBox").each(function(b){0==b?($(this).animate({top:20},300),a=$(this).height()+40,SmallBoxesAnchos=$(this).height()+40):($(this).animate({top:a}),a=a+$(this).height()+20,SmallBoxesAnchos=SmallBoxesAnchos+$(this).height()+20)})}))},a.timeout),$("#smallbox"+SmallBoxes).bind("click",function(){clearInterval(i),"function"==typeof b&&b&&b();{var a=$(this).height()+20;$(this).attr("id"),$(this).css("top")}SmallBoxesAnchos-=a,$(this).removeClass().addClass("SmallBox").animate({opacity:0},300,function(){$(this).remove();var a=0;$(".SmallBox").each(function(b){0==b?($(this).animate({top:20},300),a=$(this).height()+40,SmallBoxesAnchos=$(this).height()+40):($(this).animate({top:a},350),a=a+$(this).height()+20,SmallBoxesAnchos=SmallBoxesAnchos+$(this).height()+20)})})})};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(2)))

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a){var b=function(b,c){this.element=a(b),this.picker=a('<div class="slider"><div class="slider-track"><div class="slider-selection"></div><div class="slider-handle"></div><div class="slider-handle"></div></div><div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div></div>').insertBefore(this.element).prepend(this.element),this.id=this.element.data("slider-id")||c.id,this.id&&(this.picker[0].id=this.id),"undefined"!=typeof Modernizr&&Modernizr.touch&&(this.touchCapable=!0);var d=this.element.data("slider-tooltip")||c.tooltip;switch(this.tooltip=this.picker.find(".tooltip"),this.tooltipInner=this.tooltip.find("div.tooltip-inner"),this.orientation=this.element.data("slider-orientation")||c.orientation,this.orientation){case"vertical":this.picker.addClass("slider-vertical"),this.stylePos="top",this.mousePos="pageY",this.sizePos="offsetHeight",this.tooltip.addClass("right")[0].style.left="100%";break;default:this.picker.addClass("slider-horizontal").css("width",this.element.outerWidth()),this.orientation="horizontal",this.stylePos="left",this.mousePos="pageX",this.sizePos="offsetWidth",this.tooltip.addClass("top")[0].style.top=-this.tooltip.outerHeight()-14+"px"}this.min=this.element.data("slider-min")||c.min,this.max=this.element.data("slider-max")||c.max,this.step=this.element.data("slider-step")||c.step,this.value=this.element.data("slider-value")||c.value,this.value[1]&&(this.range=!0),this.selection=this.element.data("slider-selection")||c.selection,this.selectionEl=this.picker.find(".slider-selection"),"none"===this.selection&&this.selectionEl.addClass("hide"),this.selectionElStyle=this.selectionEl[0].style,this.handle1=this.picker.find(".slider-handle:first"),this.handle1Stype=this.handle1[0].style,this.handle2=this.picker.find(".slider-handle:last"),this.handle2Stype=this.handle2[0].style;var e=this.element.data("slider-handle")||c.handle;switch(e){case"round":this.handle1.addClass("round"),this.handle2.addClass("round");break;case"triangle":this.handle1.addClass("triangle"),this.handle2.addClass("triangle")}this.range?(this.value[0]=Math.max(this.min,Math.min(this.max,this.value[0])),this.value[1]=Math.max(this.min,Math.min(this.max,this.value[1]))):(this.value=[Math.max(this.min,Math.min(this.max,this.value))],this.handle2.addClass("hide"),this.value[1]="after"==this.selection?this.max:this.min),this.diff=this.max-this.min,this.percentage=[100*(this.value[0]-this.min)/this.diff,100*(this.value[1]-this.min)/this.diff,100*this.step/this.diff],this.offset=this.picker.offset(),this.size=this.picker[0][this.sizePos],this.formater=c.formater,this.layout(),this.picker.on(this.touchCapable?{touchstart:a.proxy(this.mousedown,this)}:{mousedown:a.proxy(this.mousedown,this)}),"show"===d?this.picker.on({mouseenter:a.proxy(this.showTooltip,this),mouseleave:a.proxy(this.hideTooltip,this)}):this.tooltip.addClass("hide")};b.prototype={constructor:b,over:!1,inDrag:!1,showTooltip:function(){this.tooltip.addClass("in"),this.over=!0},hideTooltip:function(){this.inDrag===!1&&this.tooltip.removeClass("in"),this.over=!1},layout:function(){this.handle1Stype[this.stylePos]=this.percentage[0]+"%",this.handle2Stype[this.stylePos]=this.percentage[1]+"%","vertical"==this.orientation?(this.selectionElStyle.top=Math.min(this.percentage[0],this.percentage[1])+"%",this.selectionElStyle.height=Math.abs(this.percentage[0]-this.percentage[1])+"%"):(this.selectionElStyle.left=Math.min(this.percentage[0],this.percentage[1])+"%",this.selectionElStyle.width=Math.abs(this.percentage[0]-this.percentage[1])+"%"),this.range?(this.tooltipInner.text(this.formater(this.value[0])+" : "+this.formater(this.value[1])),this.tooltip[0].style[this.stylePos]=this.size*(this.percentage[0]+(this.percentage[1]-this.percentage[0])/2)/100-("vertical"===this.orientation?this.tooltip.outerHeight()/2:this.tooltip.outerWidth()/2)+"px"):(this.tooltipInner.text(this.formater(this.value[0])),this.tooltip[0].style[this.stylePos]=this.size*this.percentage[0]/100-("vertical"===this.orientation?this.tooltip.outerHeight()/2:this.tooltip.outerWidth()/2)+"px")},mousedown:function(b){this.touchCapable&&"touchstart"===b.type&&(b=b.originalEvent),this.offset=this.picker.offset(),this.size=this.picker[0][this.sizePos];var c=this.getPercentage(b);if(this.range){var d=Math.abs(this.percentage[0]-c),e=Math.abs(this.percentage[1]-c);this.dragged=e>d?0:1}else this.dragged=0;this.percentage[this.dragged]=c,this.layout(),a(document).on(this.touchCapable?{touchmove:a.proxy(this.mousemove,this),touchend:a.proxy(this.mouseup,this)}:{mousemove:a.proxy(this.mousemove,this),mouseup:a.proxy(this.mouseup,this)}),this.inDrag=!0;var f=this.calculateValue();return this.element.trigger({type:"slideStart",value:f}).trigger({type:"slide",value:f}),!1},mousemove:function(a){this.touchCapable&&"touchmove"===a.type&&(a=a.originalEvent);var b=this.getPercentage(a);this.range&&(0===this.dragged&&this.percentage[1]<b?(this.percentage[0]=this.percentage[1],this.dragged=1):1===this.dragged&&this.percentage[0]>b&&(this.percentage[1]=this.percentage[0],this.dragged=0)),this.percentage[this.dragged]=b,this.layout();var c=this.calculateValue();return this.element.trigger({type:"slide",value:c}).data("value",c).prop("value",c),!1},mouseup:function(){a(document).off(this.touchCapable?{touchmove:this.mousemove,touchend:this.mouseup}:{mousemove:this.mousemove,mouseup:this.mouseup}),this.inDrag=!1,0==this.over&&this.hideTooltip(),this.element;var b=this.calculateValue();return this.element.trigger({type:"slideStop",value:b}).data("value",b).prop("value",b),!1},calculateValue:function(){var a;return this.range?(a=[this.min+Math.round(this.diff*this.percentage[0]/100/this.step)*this.step,this.min+Math.round(this.diff*this.percentage[1]/100/this.step)*this.step],this.value=a):(a=this.min+Math.round(this.diff*this.percentage[0]/100/this.step)*this.step,this.value=[a,this.value[1]]),a},getPercentage:function(a){this.touchCapable&&(a=a.touches[0]);var b=100*(a[this.mousePos]-this.offset[this.stylePos])/this.size;return b=Math.round(b/this.percentage[2])*this.percentage[2],Math.max(0,Math.min(100,b))},getValue:function(){return this.range?this.value:this.value[0]},setValue:function(a){this.value=a,this.range?(this.value[0]=Math.max(this.min,Math.min(this.max,this.value[0])),this.value[1]=Math.max(this.min,Math.min(this.max,this.value[1]))):(this.value=[Math.max(this.min,Math.min(this.max,this.value))],this.handle2.addClass("hide"),this.value[1]="after"==this.selection?this.max:this.min),this.diff=this.max-this.min,this.percentage=[100*(this.value[0]-this.min)/this.diff,100*(this.value[1]-this.min)/this.diff,100*this.step/this.diff],this.layout()}},a.fn.slider=function(c,d){return this.each(function(){var e=a(this),f=e.data("slider"),g="object"==typeof c&&c;f||e.data("slider",f=new b(this,a.extend({},a.fn.slider.defaults,g))),"string"==typeof c&&f[c](d)})},a.fn.slider.defaults={min:0,max:10,step:1,orientation:"horizontal",value:5,selection:"before",tooltip:"show",handle:"round",formater:function(a){return a}},a.fn.slider.Constructor=b}(__webpack_provided_window_dot_jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a){return a.easyPieChart=function(b,c){var d,e,f,g,h,i,j,k,l=this;return this.el=b,this.$el=a(b),this.$el.data("easyPieChart",this),this.init=function(){var b,d;return l.options=a.extend({},a.easyPieChart.defaultOptions,c),b=parseInt(l.$el.data("percent"),10),l.percentage=0,l.canvas=a("<canvas width='"+l.options.size+"' height='"+l.options.size+"'></canvas>").get(0),l.$el.append(l.canvas),"undefined"!=typeof G_vmlCanvasManager&&null!==G_vmlCanvasManager&&G_vmlCanvasManager.initElement(l.canvas),l.ctx=l.canvas.getContext("2d"),window.devicePixelRatio>1&&(d=window.devicePixelRatio,a(l.canvas).css({width:l.options.size,height:l.options.size}),l.canvas.width*=d,l.canvas.height*=d,l.ctx.scale(d,d)),l.ctx.translate(l.options.size/2,l.options.size/2),l.ctx.rotate(l.options.rotate*Math.PI/180),l.$el.addClass("easyPieChart"),l.$el.css({width:l.options.size,height:l.options.size,lineHeight:""+l.options.size+"px"}),l.update(b),l},this.update=function(a){return a=parseFloat(a)||0,l.options.animate===!1?f(a):e(l.percentage,a),l},j=function(){var a,b,c;for(l.ctx.fillStyle=l.options.scaleColor,l.ctx.lineWidth=1,c=[],a=b=0;24>=b;a=++b)c.push(d(a));return c},d=function(a){var b;b=a%6===0?0:.017*l.options.size,l.ctx.save(),l.ctx.rotate(a*Math.PI/12),l.ctx.fillRect(l.options.size/2-b,0,.05*-l.options.size+b,1),l.ctx.restore()},k=function(){var a;a=l.options.size/2-l.options.lineWidth/2,l.options.scaleColor!==!1&&(a-=.08*l.options.size),l.ctx.beginPath(),l.ctx.arc(0,0,a,0,2*Math.PI,!0),l.ctx.closePath(),l.ctx.strokeStyle=l.options.trackColor,l.ctx.lineWidth=l.options.lineWidth,l.ctx.stroke()},i=function(){l.options.scaleColor!==!1&&j(),l.options.trackColor!==!1&&k()},f=function(b){var c;i(),l.ctx.strokeStyle=a.isFunction(l.options.barColor)?l.options.barColor(b):l.options.barColor,l.ctx.lineCap=l.options.lineCap,l.ctx.lineWidth=l.options.lineWidth,c=l.options.size/2-l.options.lineWidth/2,l.options.scaleColor!==!1&&(c-=.08*l.options.size),l.ctx.save(),l.ctx.rotate(-Math.PI/2),l.ctx.beginPath(),l.ctx.arc(0,0,c,0,2*Math.PI*b/100,!1),l.ctx.stroke(),l.ctx.restore()},h=function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||function(a){return window.setTimeout(a,1e3/60)}}(),e=function(a,b){var c,d;l.options.onStart.call(l),l.percentage=b,d=Date.now(),c=function(){var e,j;return j=Date.now()-d,j<l.options.animate&&h(c),l.ctx.clearRect(-l.options.size/2,-l.options.size/2,l.options.size,l.options.size),i.call(l),e=[g(j,a,b-a,l.options.animate)],l.options.onStep.call(l,e),f.call(l,e),j>=l.options.animate?l.options.onStop.call(l):void 0},h(c)},g=function(a,b,c,d){var e,f;return e=function(a){return Math.pow(a,2)},f=function(a){return 1>a?e(a):2-e(a/2*-2+2)},a/=d/2,c/2*f(a)+b},this.init()},a.easyPieChart.defaultOptions={barColor:"#ef1e25",trackColor:"#f2f2f2",scaleColor:"#dfe0e0",lineCap:"round",rotate:0,size:110,lineWidth:3,animate:!1,onStart:a.noop,onStop:a.noop,onStep:a.noop},void(a.fn.easyPieChart=function(b){return a.each(this,function(c,d){var e,f;return e=a(d),e.data("easyPieChart")?void 0:(f=a.extend({},b,e.data()),e.data("easyPieChart",new a.easyPieChart(d,f)))})})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! SmartAdmin - v1.4.1 - 2014-06-22 */function FastClick(a){var b,c=this;if(this.trackingClick=!1,this.trackingClickStart=0,this.targetElement=null,this.lastTouchIdentifier=this.touchStartY=this.touchStartX=0,this.layer=a,!a||!a.nodeType)throw new TypeError("Layer must be a document node");this.onClick=function(){return FastClick.prototype.onClick.apply(c,arguments)},this.onMouse=function(){return FastClick.prototype.onMouse.apply(c,arguments)},this.onTouchStart=function(){return FastClick.prototype.onTouchStart.apply(c,arguments)},this.onTouchEnd=function(){return FastClick.prototype.onTouchEnd.apply(c,arguments)},this.onTouchCancel=function(){return FastClick.prototype.onTouchCancel.apply(c,arguments)},FastClick.notNeeded(a)||(this.deviceIsAndroid&&(a.addEventListener("mouseover",this.onMouse,!0),a.addEventListener("mousedown",this.onMouse,!0),a.addEventListener("mouseup",this.onMouse,!0)),a.addEventListener("click",this.onClick,!0),a.addEventListener("touchstart",this.onTouchStart,!1),a.addEventListener("touchend",this.onTouchEnd,!1),a.addEventListener("touchcancel",this.onTouchCancel,!1),Event.prototype.stopImmediatePropagation||(a.removeEventListener=function(b,c,d){var e=Node.prototype.removeEventListener;"click"===b?e.call(a,b,c.hijacked||c,d):e.call(a,b,c,d)},a.addEventListener=function(b,c,d){var e=Node.prototype.addEventListener;"click"===b?e.call(a,b,c.hijacked||(c.hijacked=function(a){a.propagationStopped||c(a)}),d):e.call(a,b,c,d)}),"function"==typeof a.onclick&&(b=a.onclick,a.addEventListener("click",function(a){b(a)},!1),a.onclick=null))}FastClick.prototype.deviceIsAndroid=0<navigator.userAgent.indexOf("Android"),FastClick.prototype.deviceIsIOS=/iP(ad|hone|od)/.test(navigator.userAgent),FastClick.prototype.deviceIsIOS4=FastClick.prototype.deviceIsIOS&&/OS 4_\d(_\d)?/.test(navigator.userAgent),FastClick.prototype.deviceIsIOSWithBadTarget=FastClick.prototype.deviceIsIOS&&/OS ([6-9]|\d{2})_\d/.test(navigator.userAgent),FastClick.prototype.needsClick=function(a){switch(a.nodeName.toLowerCase()){case"button":case"select":case"textarea":if(a.disabled)return!0;break;case"input":if(this.deviceIsIOS&&"file"===a.type||a.disabled)return!0;break;case"label":case"video":return!0}return/\bneedsclick\b/.test(a.className)},FastClick.prototype.needsFocus=function(a){switch(a.nodeName.toLowerCase()){case"textarea":case"select":return!0;case"input":switch(a.type){case"button":case"checkbox":case"file":case"image":case"radio":case"submit":return!1}return!a.disabled&&!a.readOnly;default:return/\bneedsfocus\b/.test(a.className)}},FastClick.prototype.sendClick=function(a,b){var c,d;document.activeElement&&document.activeElement!==a&&document.activeElement.blur(),d=b.changedTouches[0],c=document.createEvent("MouseEvents"),c.initMouseEvent("click",!0,!0,window,1,d.screenX,d.screenY,d.clientX,d.clientY,!1,!1,!1,!1,0,null),c.forwardedTouchEvent=!0,a.dispatchEvent(c)},FastClick.prototype.focus=function(a){var b;this.deviceIsIOS&&a.setSelectionRange?(b=a.value.length,a.setSelectionRange(b,b)):a.focus()},FastClick.prototype.updateScrollParent=function(a){var b,c;if(b=a.fastClickScrollParent,!b||!b.contains(a)){c=a;do{if(c.scrollHeight>c.offsetHeight){b=c,a.fastClickScrollParent=c;break}c=c.parentElement}while(c)}b&&(b.fastClickLastScrollTop=b.scrollTop)},FastClick.prototype.getTargetElementFromEventTarget=function(a){return a.nodeType===Node.TEXT_NODE?a.parentNode:a},FastClick.prototype.onTouchStart=function(a){var b,c,d;if(1<a.targetTouches.length)return!0;if(b=this.getTargetElementFromEventTarget(a.target),c=a.targetTouches[0],this.deviceIsIOS){if(d=window.getSelection(),d.rangeCount&&!d.isCollapsed)return!0;if(!this.deviceIsIOS4){if(c.identifier===this.lastTouchIdentifier)return a.preventDefault(),!1;this.lastTouchIdentifier=c.identifier,this.updateScrollParent(b)}}return this.trackingClick=!0,this.trackingClickStart=a.timeStamp,this.targetElement=b,this.touchStartX=c.pageX,this.touchStartY=c.pageY,200>a.timeStamp-this.lastClickTime&&a.preventDefault(),!0},FastClick.prototype.touchHasMoved=function(a){return a=a.changedTouches[0],10<Math.abs(a.pageX-this.touchStartX)||10<Math.abs(a.pageY-this.touchStartY)?!0:!1},FastClick.prototype.findControl=function(a){return void 0!==a.control?a.control:a.htmlFor?document.getElementById(a.htmlFor):a.querySelector("button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea")},FastClick.prototype.onTouchEnd=function(a){var b,c,d;if(d=this.targetElement,this.touchHasMoved(a)&&(this.trackingClick=!1,this.targetElement=null),!this.trackingClick)return!0;if(200>a.timeStamp-this.lastClickTime)return this.cancelNextClick=!0;if(this.lastClickTime=a.timeStamp,b=this.trackingClickStart,this.trackingClick=!1,this.trackingClickStart=0,this.deviceIsIOSWithBadTarget&&(d=a.changedTouches[0],d=document.elementFromPoint(d.pageX-window.pageXOffset,d.pageY-window.pageYOffset)),c=d.tagName.toLowerCase(),"label"===c){if(b=this.findControl(d)){if(this.focus(d),this.deviceIsAndroid)return!1;d=b}}else if(this.needsFocus(d))return 100<a.timeStamp-b||this.deviceIsIOS&&window.top!==window&&"input"===c?(this.targetElement=null,!1):(this.focus(d),this.deviceIsIOS4&&"select"===c||(this.targetElement=null,a.preventDefault()),!1);return this.deviceIsIOS&&!this.deviceIsIOS4&&(b=d.fastClickScrollParent)&&b.fastClickLastScrollTop!==b.scrollTop?!0:(this.needsClick(d)||(a.preventDefault(),this.sendClick(d,a)),!1)},FastClick.prototype.onTouchCancel=function(){this.trackingClick=!1,this.targetElement=null},FastClick.prototype.onMouse=function(a){return this.targetElement&&!a.forwardedTouchEvent&&a.cancelable&&(!this.needsClick(this.targetElement)||this.cancelNextClick)?(a.stopImmediatePropagation?a.stopImmediatePropagation():a.propagationStopped=!0,a.stopPropagation(),a.preventDefault(),!1):!0},FastClick.prototype.onClick=function(a){return this.trackingClick?(this.targetElement=null,this.trackingClick=!1,!0):"submit"===a.target.type&&0===a.detail?!0:(a=this.onMouse(a),a||(this.targetElement=null),a)},FastClick.prototype.destroy=function(){var a=this.layer;this.deviceIsAndroid&&(a.removeEventListener("mouseover",this.onMouse,!0),a.removeEventListener("mousedown",this.onMouse,!0),a.removeEventListener("mouseup",this.onMouse,!0)),a.removeEventListener("click",this.onClick,!0),a.removeEventListener("touchstart",this.onTouchStart,!1),a.removeEventListener("touchend",this.onTouchEnd,!1),a.removeEventListener("touchcancel",this.onTouchCancel,!1)},FastClick.notNeeded=function(a){var b;if("undefined"==typeof window.ontouchstart)return!0;if(/Chrome\/[0-9]+/.test(navigator.userAgent)){if(!FastClick.prototype.deviceIsAndroid)return!0;if((b=document.querySelector("meta[name=viewport]"))&&-1!==b.content.indexOf("user-scalable=no"))return!0}return"none"===a.style.msTouchAction?!0:!1},FastClick.attach=function(a){return new FastClick(a)}, true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return FastClick}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=FastClick.attach,module.exports.FastClick=FastClick):window.FastClick=FastClick;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a){a.color={},a.color.make=function(b,c,d,e){var f={};return f.r=b||0,f.g=c||0,f.b=d||0,f.a=null!=e?e:1,f.add=function(a,b){for(var c=0;c<a.length;++c)f[a.charAt(c)]+=b;return f.normalize()},f.scale=function(a,b){for(var c=0;c<a.length;++c)f[a.charAt(c)]*=b;return f.normalize()},f.toString=function(){return f.a>=1?"rgb("+[f.r,f.g,f.b].join(",")+")":"rgba("+[f.r,f.g,f.b,f.a].join(",")+")"},f.normalize=function(){function a(a,b,c){return a>b?a:b>c?c:b}return f.r=a(0,parseInt(f.r),255),f.g=a(0,parseInt(f.g),255),f.b=a(0,parseInt(f.b),255),f.a=a(0,f.a,1),f},f.clone=function(){return a.color.make(f.r,f.b,f.g,f.a)},f.normalize()},a.color.extract=function(b,c){var d;do{if(d=b.css(c).toLowerCase(),""!=d&&"transparent"!=d)break;b=b.parent()}while(!a.nodeName(b.get(0),"body"));return"rgba(0, 0, 0, 0)"==d&&(d="transparent"),a.color.parse(d)},a.color.parse=function(c){var d,e=a.color.make;if(d=/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/.exec(c))return e(parseInt(d[1],10),parseInt(d[2],10),parseInt(d[3],10));if(d=/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(c))return e(parseInt(d[1],10),parseInt(d[2],10),parseInt(d[3],10),parseFloat(d[4]));if(d=/rgb\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*\)/.exec(c))return e(2.55*parseFloat(d[1]),2.55*parseFloat(d[2]),2.55*parseFloat(d[3]));if(d=/rgba\(\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\%\s*,\s*([0-9]+(?:\.[0-9]+)?)\s*\)/.exec(c))return e(2.55*parseFloat(d[1]),2.55*parseFloat(d[2]),2.55*parseFloat(d[3]),parseFloat(d[4]));if(d=/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/.exec(c))return e(parseInt(d[1],16),parseInt(d[2],16),parseInt(d[3],16));if(d=/#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/.exec(c))return e(parseInt(d[1]+d[1],16),parseInt(d[2]+d[2],16),parseInt(d[3]+d[3],16));var f=a.trim(c).toLowerCase();return"transparent"==f?e(255,255,255,0):(d=b[f]||[0,0,0],e(d[0],d[1],d[2]))};var b={aqua:[0,255,255],azure:[240,255,255],beige:[245,245,220],black:[0,0,0],blue:[0,0,255],brown:[165,42,42],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgrey:[169,169,169],darkgreen:[0,100,0],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkviolet:[148,0,211],fuchsia:[255,0,255],gold:[255,215,0],green:[0,128,0],indigo:[75,0,130],khaki:[240,230,140],lightblue:[173,216,230],lightcyan:[224,255,255],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightyellow:[255,255,224],lime:[0,255,0],magenta:[255,0,255],maroon:[128,0,0],navy:[0,0,128],olive:[128,128,0],orange:[255,165,0],pink:[255,192,203],purple:[128,0,128],violet:[128,0,128],red:[255,0,0],silver:[192,192,192],white:[255,255,255],yellow:[255,255,0]}}(jQuery),function(a){function b(b,d,e,f){function g(a,b){b=[vb].concat(b);for(var c=0;c<a.length;++c)a[c].apply(this,b)}function h(){for(var b=0;b<f.length;++b){var c=f[b];c.init(vb),c.options&&a.extend(!0,hb,c.options)}}function j(b){var c;for(a.extend(!0,hb,b),null==hb.xaxis.color&&(hb.xaxis.color=hb.grid.color),null==hb.yaxis.color&&(hb.yaxis.color=hb.grid.color),null==hb.xaxis.tickColor&&(hb.xaxis.tickColor=hb.grid.tickColor),null==hb.yaxis.tickColor&&(hb.yaxis.tickColor=hb.grid.tickColor),null==hb.grid.borderColor&&(hb.grid.borderColor=hb.grid.color),null==hb.grid.tickColor&&(hb.grid.tickColor=a.color.parse(hb.grid.color).scale("a",.22).toString()),c=0;c<Math.max(1,hb.xaxes.length);++c)hb.xaxes[c]=a.extend(!0,{},hb.xaxis,hb.xaxes[c]);for(c=0;c<Math.max(1,hb.yaxes.length);++c)hb.yaxes[c]=a.extend(!0,{},hb.yaxis,hb.yaxes[c]);for(hb.xaxis.noTicks&&null==hb.xaxis.ticks&&(hb.xaxis.ticks=hb.xaxis.noTicks),hb.yaxis.noTicks&&null==hb.yaxis.ticks&&(hb.yaxis.ticks=hb.yaxis.noTicks),hb.x2axis&&(hb.xaxes[1]=a.extend(!0,{},hb.xaxis,hb.x2axis),hb.xaxes[1].position="top"),hb.y2axis&&(hb.yaxes[1]=a.extend(!0,{},hb.yaxis,hb.y2axis),hb.yaxes[1].position="right"),hb.grid.coloredAreas&&(hb.grid.markings=hb.grid.coloredAreas),hb.grid.coloredAreasColor&&(hb.grid.markingsColor=hb.grid.coloredAreasColor),hb.lines&&a.extend(!0,hb.series.lines,hb.lines),hb.points&&a.extend(!0,hb.series.points,hb.points),hb.bars&&a.extend(!0,hb.series.bars,hb.bars),null!=hb.shadowSize&&(hb.series.shadowSize=hb.shadowSize),c=0;c<hb.xaxes.length;++c)q(nb,c+1).options=hb.xaxes[c];for(c=0;c<hb.yaxes.length;++c)q(ob,c+1).options=hb.yaxes[c];for(var d in ub)hb.hooks[d]&&hb.hooks[d].length&&(ub[d]=ub[d].concat(hb.hooks[d]));g(ub.processOptions,[hb])}function k(a){gb=l(a),r(),s()}function l(b){for(var c=[],d=0;d<b.length;++d){var e=a.extend(!0,{},hb.series);null!=b[d].data?(e.data=b[d].data,delete b[d].data,a.extend(!0,e,b[d]),b[d].data=e.data):e.data=b[d],c.push(e)}return c}function m(a,b){var c=a[b+"axis"];return"object"==typeof c&&(c=c.n),"number"!=typeof c&&(c=1),c}function n(){return a.grep(nb.concat(ob),function(a){return a})}function o(a){var b,c,d={};for(b=0;b<nb.length;++b)c=nb[b],c&&c.used&&(d["x"+c.n]=c.c2p(a.left));for(b=0;b<ob.length;++b)c=ob[b],c&&c.used&&(d["y"+c.n]=c.c2p(a.top));return void 0!==d.x1&&(d.x=d.x1),void 0!==d.y1&&(d.y=d.y1),d}function p(a){var b,c,d,e={};for(b=0;b<nb.length;++b)if(c=nb[b],c&&c.used&&(d="x"+c.n,null==a[d]&&1==c.n&&(d="x"),null!=a[d])){e.left=c.p2c(a[d]);break}for(b=0;b<ob.length;++b)if(c=ob[b],c&&c.used&&(d="y"+c.n,null==a[d]&&1==c.n&&(d="y"),null!=a[d])){e.top=c.p2c(a[d]);break}return e}function q(b,c){return b[c-1]||(b[c-1]={n:c,direction:b==nb?"x":"y",options:a.extend(!0,{},b==nb?hb.xaxis:hb.yaxis)}),b[c-1]}function r(){var b,c=gb.length,d=[],e=[];for(b=0;b<gb.length;++b){var f=gb[b].color;null!=f&&(--c,"number"==typeof f?e.push(f):d.push(a.color.parse(gb[b].color)))}for(b=0;b<e.length;++b)c=Math.max(c,e[b]+1);var g=[],h=0;for(b=0;g.length<c;){var i;i=hb.colors.length==b?a.color.make(100,100,100):a.color.parse(hb.colors[b]);var j=h%2==1?-1:1;i.scale("rgb",1+j*Math.ceil(h/2)*.2),g.push(i),++b,b>=hb.colors.length&&(b=0,++h)}var k,l=0;for(b=0;b<gb.length;++b){if(k=gb[b],null==k.color?(k.color=g[l].toString(),++l):"number"==typeof k.color&&(k.color=g[k.color].toString()),null==k.lines.show){var n,o=!0;for(n in k)if(k[n]&&k[n].show){o=!1;break}o&&(k.lines.show=!0)}k.xaxis=q(nb,m(k,"x")),k.yaxis=q(ob,m(k,"y"))}}function s(){function b(a,b,c){b<a.datamin&&b!=-q&&(a.datamin=b),c>a.datamax&&c!=q&&(a.datamax=c)}var c,d,e,f,h,i,j,k,l,m,o=Number.POSITIVE_INFINITY,p=Number.NEGATIVE_INFINITY,q=Number.MAX_VALUE;for(a.each(n(),function(a,b){b.datamin=o,b.datamax=p,b.used=!1}),c=0;c<gb.length;++c)h=gb[c],h.datapoints={points:[]},g(ub.processRawData,[h,h.data,h.datapoints]);for(c=0;c<gb.length;++c){h=gb[c];var r=h.data,s=h.datapoints.format;if(s||(s=[],s.push({x:!0,number:!0,required:!0}),s.push({y:!0,number:!0,required:!0}),(h.bars.show||h.lines.show&&h.lines.fill)&&(s.push({y:!0,number:!0,required:!1,defaultValue:0}),h.bars.horizontal&&(delete s[s.length-1].y,s[s.length-1].x=!0)),h.datapoints.format=s),null==h.datapoints.pointsize)for(h.datapoints.pointsize=s.length,j=h.datapoints.pointsize,i=h.datapoints.points,insertSteps=h.lines.show&&h.lines.steps,h.xaxis.used=h.yaxis.used=!0,d=e=0;d<r.length;++d,e+=j){m=r[d];var t=null==m;if(!t)for(f=0;j>f;++f)k=m[f],l=s[f],l&&(l.number&&null!=k&&(k=+k,isNaN(k)?k=null:1/0==k?k=q:k==-1/0&&(k=-q)),null==k&&(l.required&&(t=!0),null!=l.defaultValue&&(k=l.defaultValue))),i[e+f]=k;if(t)for(f=0;j>f;++f)k=i[e+f],null!=k&&(l=s[f],l.x&&b(h.xaxis,k,k),l.y&&b(h.yaxis,k,k)),i[e+f]=null;else if(insertSteps&&e>0&&null!=i[e-j]&&i[e-j]!=i[e]&&i[e-j+1]!=i[e+1]){for(f=0;j>f;++f)i[e+j+f]=i[e+f];i[e+1]=i[e-j+1],e+=j}}}for(c=0;c<gb.length;++c)h=gb[c],g(ub.processDatapoints,[h,h.datapoints]);for(c=0;c<gb.length;++c){h=gb[c],i=h.datapoints.points,j=h.datapoints.pointsize;var u=o,v=o,w=p,x=p;for(d=0;d<i.length;d+=j)if(null!=i[d])for(f=0;j>f;++f)k=i[d+f],l=s[f],l&&k!=q&&k!=-q&&(l.x&&(u>k&&(u=k),k>w&&(w=k)),l.y&&(v>k&&(v=k),k>x&&(x=k)));if(h.bars.show){var y="left"==h.bars.align?0:-h.bars.barWidth/2;h.bars.horizontal?(v+=y,x+=y+h.bars.barWidth):(u+=y,w+=y+h.bars.barWidth)}b(h.xaxis,u,w),b(h.yaxis,v,x)}a.each(n(),function(a,b){b.datamin==o&&(b.datamin=null),b.datamax==p&&(b.datamax=null)})}function t(c,d){var e=document.createElement("canvas");return e.className=d,e.width=qb,e.height=rb,c||a(e).css({position:"absolute",left:0,top:0}),a(e).appendTo(b),fb&&(e.width=2*qb,e.height=2*rb,e.style.width=""+qb+"px",e.style.height=""+rb+"px"),e.getContext||(e=window.G_vmlCanvasManager.initElement(e)),e.getContext("2d").save(),fb&&e.getContext("2d").scale(2,2),e}function u(){if(qb=b.width(),rb=b.height(),0>=qb||0>=rb)throw"Invalid dimensions for plot, width = "+qb+", height = "+rb}function v(a){a.width!=qb&&(a.width=qb,fb&&(a.width=2*qb),a.style.width=""+qb+"px"),a.height!=rb&&(a.height=rb,fb&&(a.height=2*rb),a.style.height=""+rb+"px");var b=a.getContext("2d");b.restore(),b.save(),fb&&b.scale(2,2)}function w(){var c,d=b.children("canvas.base"),e=b.children("canvas.overlay");0==d.length||0==e?(b.html(""),b.css({padding:0}),"static"==b.css("position")&&b.css("position","relative"),u(),ib=t(!0,"base"),jb=t(!1,"overlay"),c=!1):(ib=d.get(0),jb=e.get(0),c=!0),lb=ib.getContext("2d"),mb=jb.getContext("2d"),kb=a([jb,ib]),c&&(b.data("plot").shutdown(),vb.resize(),mb.clearRect(0,0,qb,rb),kb.unbind(),b.children().not([ib,jb]).remove()),b.data("plot",vb)}function x(){hb.grid.hoverable&&(kb.mousemove(V),kb.mouseleave(W)),hb.grid.clickable&&kb.click(X),g(ub.bindEvents,[kb])}function y(){xb&&clearTimeout(xb),kb.unbind("mousemove",V),kb.unbind("mouseleave",W),kb.unbind("click",X),g(ub.shutdown,[kb])}function z(a){function b(a){return a}var c,d,e=a.options.transform||b,f=a.options.inverseTransform;"x"==a.direction?(c=a.scale=sb/Math.abs(e(a.max)-e(a.min)),d=Math.min(e(a.max),e(a.min))):(c=a.scale=tb/Math.abs(e(a.max)-e(a.min)),c=-c,d=Math.max(e(a.max),e(a.min))),a.p2c=e==b?function(a){return(a-d)*c}:function(a){return(e(a)-d)*c},a.c2p=f?function(a){return f(d+a/c)}:function(a){return d+a/c}}function A(c){function d(d,e){return a('<div style="position:absolute;top:-10000px;'+e+'font-size:smaller"><div class="'+c.direction+"Axis "+c.direction+c.n+'Axis">'+d.join("")+"</div></div>").appendTo(b)}var e,f,g,h=c.options,i=c.ticks||[],j=[],k=h.labelWidth,l=h.labelHeight;if("x"==c.direction){if(null==k&&(k=Math.floor(qb/(i.length>0?i.length:1))),null==l){for(j=[],e=0;e<i.length;++e)f=i[e].label,f&&j.push('<div class="tickLabel" style="float:left;width:'+k+'px">'+f+"</div>");j.length>0&&(j.push('<div style="clear:left"></div>'),g=d(j,"width:10000px;"),l=g.height(),g.remove())}}else if(null==k||null==l){for(e=0;e<i.length;++e)f=i[e].label,f&&j.push('<div class="tickLabel">'+f+"</div>");j.length>0&&(g=d(j,""),null==k&&(k=g.children().width()),null==l&&(l=g.find("div.tickLabel").height()),g.remove())}null==k&&(k=0),null==l&&(l=0),c.labelWidth=k,c.labelHeight=l}function B(b){var c=b.labelWidth,d=b.labelHeight,e=b.options.position,f=b.options.tickLength,g=hb.grid.axisMargin,h=hb.grid.labelMargin,i="x"==b.direction?nb:ob,j=a.grep(i,function(a){return a&&a.options.position==e&&a.reserveSpace});a.inArray(b,j)==j.length-1&&(g=0),null==f&&(f="full");var k=a.grep(i,function(a){return a&&a.reserveSpace}),l=0==a.inArray(b,k);l||"full"!=f||(f=5),isNaN(+f)||(h+=+f),"x"==b.direction?(d+=h,"bottom"==e?(pb.bottom+=d+g,b.box={top:rb-pb.bottom,height:d}):(b.box={top:pb.top+g,height:d},pb.top+=d+g)):(c+=h,"left"==e?(b.box={left:pb.left+g,width:c},pb.left+=c+g):(pb.right+=c+g,b.box={left:qb-pb.right,width:c})),b.position=e,b.tickLength=f,b.box.padding=h,b.innermost=l}function C(a){"x"==a.direction?(a.box.left=pb.left,a.box.width=sb):(a.box.top=pb.top,a.box.height=tb)}function D(){var b,c=n();if(a.each(c,function(a,b){b.show=b.options.show,null==b.show&&(b.show=b.used),b.reserveSpace=b.show||b.options.reserveSpace,E(b)}),allocatedAxes=a.grep(c,function(a){return a.reserveSpace}),pb.left=pb.right=pb.top=pb.bottom=0,hb.grid.show){for(a.each(allocatedAxes,function(a,b){F(b),G(b),H(b,b.ticks),A(b)}),b=allocatedAxes.length-1;b>=0;--b)B(allocatedAxes[b]);var d=hb.grid.minBorderMargin;if(null==d)for(d=0,b=0;b<gb.length;++b)d=Math.max(d,gb[b].points.radius+gb[b].points.lineWidth/2);for(var e in pb)pb[e]+=hb.grid.borderWidth,pb[e]=Math.max(d,pb[e])}sb=qb-pb.left-pb.right,tb=rb-pb.bottom-pb.top,a.each(c,function(a,b){z(b)}),hb.grid.show&&(a.each(allocatedAxes,function(a,b){C(b)}),M()),T()}function E(a){var b=a.options,c=+(null!=b.min?b.min:a.datamin),d=+(null!=b.max?b.max:a.datamax),e=d-c;if(0==e){var f=0==d?1:.01;null==b.min&&(c-=f),(null==b.max||null!=b.min)&&(d+=f)}else{var g=b.autoscaleMargin;null!=g&&(null==b.min&&(c-=e*g,0>c&&null!=a.datamin&&a.datamin>=0&&(c=0)),null==b.max&&(d+=e*g,d>0&&null!=a.datamax&&a.datamax<=0&&(d=0)))}a.min=c,a.max=d}function F(b){var d,e=b.options;d="number"==typeof e.ticks&&e.ticks>0?e.ticks:.3*Math.sqrt("x"==b.direction?qb:rb);var f,g,h,i,j,k,l,m=(b.max-b.min)/d;if("time"==e.mode){var n={second:1e3,minute:6e4,hour:36e5,day:864e5,month:2592e6,year:525949.2*60*1e3},o=[[1,"second"],[2,"second"],[5,"second"],[10,"second"],[30,"second"],[1,"minute"],[2,"minute"],[5,"minute"],[10,"minute"],[30,"minute"],[1,"hour"],[2,"hour"],[4,"hour"],[8,"hour"],[12,"hour"],[1,"day"],[2,"day"],[3,"day"],[.25,"month"],[.5,"month"],[1,"month"],[2,"month"],[3,"month"],[6,"month"],[1,"year"]],p=0;null!=e.minTickSize&&(p="number"==typeof e.tickSize?e.tickSize:e.minTickSize[0]*n[e.minTickSize[1]]);for(var j=0;j<o.length-1&&!(m<(o[j][0]*n[o[j][1]]+o[j+1][0]*n[o[j+1][1]])/2&&o[j][0]*n[o[j][1]]>=p);++j);f=o[j][0],h=o[j][1],"year"==h&&(k=Math.pow(10,Math.floor(Math.log(m/n.year)/Math.LN10)),l=m/n.year/k,f=1.5>l?1:3>l?2:7.5>l?5:10,f*=k),b.tickSize=e.tickSize||[f,h],g=function(a){var b=[],d=a.tickSize[0],e=a.tickSize[1],f=new Date(a.min),g=d*n[e];"second"==e&&f.setUTCSeconds(c(f.getUTCSeconds(),d)),"minute"==e&&f.setUTCMinutes(c(f.getUTCMinutes(),d)),"hour"==e&&f.setUTCHours(c(f.getUTCHours(),d)),"month"==e&&f.setUTCMonth(c(f.getUTCMonth(),d)),"year"==e&&f.setUTCFullYear(c(f.getUTCFullYear(),d)),f.setUTCMilliseconds(0),g>=n.minute&&f.setUTCSeconds(0),g>=n.hour&&f.setUTCMinutes(0),g>=n.day&&f.setUTCHours(0),g>=4*n.day&&f.setUTCDate(1),g>=n.year&&f.setUTCMonth(0);var h,i=0,j=Number.NaN;do if(h=j,j=f.getTime(),b.push(j),"month"==e)if(1>d){f.setUTCDate(1);var k=f.getTime();f.setUTCMonth(f.getUTCMonth()+1);var l=f.getTime();f.setTime(j+i*n.hour+(l-k)*d),i=f.getUTCHours(),f.setUTCHours(0)}else f.setUTCMonth(f.getUTCMonth()+d);else"year"==e?f.setUTCFullYear(f.getUTCFullYear()+d):f.setTime(j+g);while(j<a.max&&j!=h);return b},i=function(b,c){var d=new Date(b);if(null!=e.timeformat)return a.plot.formatDate(d,e.timeformat,e.monthNames);var f=c.tickSize[0]*n[c.tickSize[1]],g=c.max-c.min,h=e.twelveHourClock?" %p":"";return fmt=f<n.minute?"%h:%M:%S"+h:f<n.day?g<2*n.day?"%h:%M"+h:"%b %d %h:%M"+h:f<n.month?"%b %d":f<n.year?g<n.year?"%b":"%b %y":"%y",a.plot.formatDate(d,fmt,e.monthNames)}}else{var q=e.tickDecimals,r=-Math.floor(Math.log(m)/Math.LN10);null!=q&&r>q&&(r=q),k=Math.pow(10,-r),l=m/k,1.5>l?f=1:3>l?(f=2,l>2.25&&(null==q||q>=r+1)&&(f=2.5,++r)):f=7.5>l?5:10,f*=k,null!=e.minTickSize&&f<e.minTickSize&&(f=e.minTickSize),b.tickDecimals=Math.max(0,null!=q?q:r),b.tickSize=e.tickSize||f,g=function(a){var b,d=[],e=c(a.min,a.tickSize),f=0,g=Number.NaN;do b=g,g=e+f*a.tickSize,d.push(g),++f;while(g<a.max&&g!=b);return d},i=function(a,b){return a.toFixed(b.tickDecimals)}}if(null!=e.alignTicksWithAxis){var s=("x"==b.direction?nb:ob)[e.alignTicksWithAxis-1];if(s&&s.used&&s!=b){var t=g(b);if(t.length>0&&(null==e.min&&(b.min=Math.min(b.min,t[0])),null==e.max&&t.length>1&&(b.max=Math.max(b.max,t[t.length-1]))),g=function(a){var b,c,d=[];for(c=0;c<s.ticks.length;++c)b=(s.ticks[c].v-s.min)/(s.max-s.min),b=a.min+b*(a.max-a.min),d.push(b);return d},"time"!=b.mode&&null==e.tickDecimals){var u=Math.max(0,-Math.floor(Math.log(m)/Math.LN10)+1),v=g(b);v.length>1&&/\..*0$/.test((v[1]-v[0]).toFixed(u))||(b.tickDecimals=u)}}}b.tickGenerator=g,b.tickFormatter=a.isFunction(e.tickFormatter)?function(a,b){return""+e.tickFormatter(a,b)}:i}function G(b){var c=b.options.ticks,d=[];null==c||"number"==typeof c&&c>0?d=b.tickGenerator(b):c&&(d=a.isFunction(c)?c({min:b.min,max:b.max}):c);var e,f;for(b.ticks=[],e=0;e<d.length;++e){var g=null,h=d[e];"object"==typeof h?(f=+h[0],h.length>1&&(g=h[1])):f=+h,null==g&&(g=b.tickFormatter(f,b)),isNaN(f)||b.ticks.push({v:f,label:g})}}function H(a,b){a.options.autoscaleMargin&&b.length>0&&(null==a.options.min&&(a.min=Math.min(a.min,b[0].v)),null==a.options.max&&b.length>1&&(a.max=Math.max(a.max,b[b.length-1].v)))}function I(){lb.clearRect(0,0,qb,rb);var a=hb.grid;a.show&&a.backgroundColor&&K(),a.show&&!a.aboveData&&L();for(var b=0;b<gb.length;++b)g(ub.drawSeries,[lb,gb[b]]),N(gb[b]);g(ub.draw,[lb]),a.show&&a.aboveData&&L()}function J(a,b){var c,d,e,f,g=n();for(i=0;i<g.length;++i)if(c=g[i],c.direction==b&&(f=b+c.n+"axis",a[f]||1!=c.n||(f=b+"axis"),a[f])){d=a[f].from,e=a[f].to;break}if(a[f]||(c="x"==b?nb[0]:ob[0],d=a[b+"1"],e=a[b+"2"]),null!=d&&null!=e&&d>e){var h=d;d=e,e=h}return{from:d,to:e,axis:c}}function K(){lb.save(),lb.translate(pb.left,pb.top),lb.fillStyle=eb(hb.grid.backgroundColor,tb,0,"rgba(255, 255, 255, 0)"),lb.fillRect(0,0,sb,tb),lb.restore()}function L(){var b;lb.save(),lb.translate(pb.left,pb.top);var c=hb.grid.markings;if(c){if(a.isFunction(c)){var d=vb.getAxes();d.xmin=d.xaxis.min,d.xmax=d.xaxis.max,d.ymin=d.yaxis.min,d.ymax=d.yaxis.max,c=c(d)}for(b=0;b<c.length;++b){var e=c[b],f=J(e,"x"),g=J(e,"y");null==f.from&&(f.from=f.axis.min),null==f.to&&(f.to=f.axis.max),null==g.from&&(g.from=g.axis.min),null==g.to&&(g.to=g.axis.max),f.to<f.axis.min||f.from>f.axis.max||g.to<g.axis.min||g.from>g.axis.max||(f.from=Math.max(f.from,f.axis.min),f.to=Math.min(f.to,f.axis.max),g.from=Math.max(g.from,g.axis.min),g.to=Math.min(g.to,g.axis.max),(f.from!=f.to||g.from!=g.to)&&(f.from=f.axis.p2c(f.from),f.to=f.axis.p2c(f.to),g.from=g.axis.p2c(g.from),g.to=g.axis.p2c(g.to),f.from==f.to||g.from==g.to?(lb.beginPath(),lb.strokeStyle=e.color||hb.grid.markingsColor,lb.lineWidth=e.lineWidth||hb.grid.markingsLineWidth,lb.moveTo(f.from,g.from),lb.lineTo(f.to,g.to),lb.stroke()):(lb.fillStyle=e.color||hb.grid.markingsColor,lb.fillRect(f.from,g.to,f.to-f.from,g.from-g.to))))}}for(var d=n(),h=hb.grid.borderWidth,i=0;i<d.length;++i){var j,k,l,m,o=d[i],p=o.box,q=o.tickLength;if(o.show&&0!=o.ticks.length){for(lb.strokeStyle=o.options.tickColor||a.color.parse(o.options.color).scale("a",.22).toString(),lb.lineWidth=1,"x"==o.direction?(j=0,k="full"==q?"top"==o.position?0:tb:p.top-pb.top+("top"==o.position?p.height:0)):(k=0,j="full"==q?"left"==o.position?0:sb:p.left-pb.left+("left"==o.position?p.width:0)),o.innermost||(lb.beginPath(),l=m=0,"x"==o.direction?l=sb:m=tb,1==lb.lineWidth&&(j=Math.floor(j)+.5,k=Math.floor(k)+.5),lb.moveTo(j,k),lb.lineTo(j+l,k+m),lb.stroke()),lb.beginPath(),b=0;b<o.ticks.length;++b){var r=o.ticks[b].v;l=m=0,r<o.min||r>o.max||"full"==q&&h>0&&(r==o.min||r==o.max)||("x"==o.direction?(j=o.p2c(r),m="full"==q?-tb:q,"top"==o.position&&(m=-m)):(k=o.p2c(r),l="full"==q?-sb:q,"left"==o.position&&(l=-l)),1==lb.lineWidth&&("x"==o.direction?j=Math.floor(j)+.5:k=Math.floor(k)+.5),lb.moveTo(j,k),lb.lineTo(j+l,k+m))}lb.stroke()}}h&&(lb.lineWidth=h,lb.strokeStyle=hb.grid.borderColor,lb.strokeRect(-h/2,-h/2,sb+h,tb+h)),lb.restore()}function M(){b.find(".tickLabels").remove();for(var a=['<div class="tickLabels" style="font-size:smaller">'],c=n(),d=0;d<c.length;++d){var e=c[d],f=e.box;if(e.show){a.push('<div class="'+e.direction+"Axis "+e.direction+e.n+'Axis" style="color:'+e.options.color+'">');for(var g=0;g<e.ticks.length;++g){var h=e.ticks[g];if(!(!h.label||h.v<e.min||h.v>e.max)){var i,j={};"x"==e.direction?(i="center",j.left=Math.round(pb.left+e.p2c(h.v)-e.labelWidth/2),"bottom"==e.position?j.top=f.top+f.padding:j.bottom=rb-(f.top+f.height-f.padding)):(j.top=Math.round(pb.top+e.p2c(h.v)-e.labelHeight/2),"left"==e.position?(j.right=qb-(f.left+f.width-f.padding),i="right"):(j.left=f.left+f.padding,i="left")),j.width=e.labelWidth;var k=["position:absolute","text-align:"+i];for(var l in j)k.push(l+":"+j[l]+"px");a.push('<div class="tickLabel" style="'+k.join(";")+'">'+h.label+"</div>")}}a.push("</div>")}}a.push("</div>"),b.append(a.join(""))}function N(a){a.lines.show&&O(a),a.bars.show&&R(a),a.points.show&&P(a)}function O(a){function b(a,b,c,d,e){var f=a.points,g=a.pointsize,h=null,i=null;lb.beginPath();for(var j=g;j<f.length;j+=g){var k=f[j-g],l=f[j-g+1],m=f[j],n=f[j+1];if(null!=k&&null!=m){if(n>=l&&l<e.min){if(n<e.min)continue;k=(e.min-l)/(n-l)*(m-k)+k,l=e.min}else if(l>=n&&n<e.min){if(l<e.min)continue;m=(e.min-l)/(n-l)*(m-k)+k,n=e.min}if(l>=n&&l>e.max){if(n>e.max)continue;k=(e.max-l)/(n-l)*(m-k)+k,l=e.max}else if(n>=l&&n>e.max){if(l>e.max)continue;m=(e.max-l)/(n-l)*(m-k)+k,n=e.max}if(m>=k&&k<d.min){if(m<d.min)continue;l=(d.min-k)/(m-k)*(n-l)+l,k=d.min}else if(k>=m&&m<d.min){if(k<d.min)continue;n=(d.min-k)/(m-k)*(n-l)+l,m=d.min}if(k>=m&&k>d.max){if(m>d.max)continue;l=(d.max-k)/(m-k)*(n-l)+l,k=d.max}else if(m>=k&&m>d.max){if(k>d.max)continue;n=(d.max-k)/(m-k)*(n-l)+l,m=d.max}(k!=h||l!=i)&&lb.moveTo(d.p2c(k)+b,e.p2c(l)+c),h=m,i=n,lb.lineTo(d.p2c(m)+b,e.p2c(n)+c)}}lb.stroke()}function c(a,b,c){for(var d=a.points,e=a.pointsize,f=Math.min(Math.max(0,c.min),c.max),g=0,h=!1,i=1,j=0,k=0;;){if(e>0&&g>d.length+e)break;g+=e;var l=d[g-e],m=d[g-e+i],n=d[g],o=d[g+i];if(h){if(e>0&&null!=l&&null==n){k=g,e=-e,i=2;continue}if(0>e&&g==j+e){lb.fill(),h=!1,e=-e,i=1,g=j=k+e;continue}}if(null!=l&&null!=n){if(n>=l&&l<b.min){if(n<b.min)continue;m=(b.min-l)/(n-l)*(o-m)+m,l=b.min}else if(l>=n&&n<b.min){if(l<b.min)continue;o=(b.min-l)/(n-l)*(o-m)+m,n=b.min}if(l>=n&&l>b.max){if(n>b.max)continue;m=(b.max-l)/(n-l)*(o-m)+m,l=b.max}else if(n>=l&&n>b.max){if(l>b.max)continue;o=(b.max-l)/(n-l)*(o-m)+m,n=b.max}if(h||(lb.beginPath(),lb.moveTo(b.p2c(l),c.p2c(f)),h=!0),m>=c.max&&o>=c.max)lb.lineTo(b.p2c(l),c.p2c(c.max)),lb.lineTo(b.p2c(n),c.p2c(c.max));else if(m<=c.min&&o<=c.min)lb.lineTo(b.p2c(l),c.p2c(c.min)),lb.lineTo(b.p2c(n),c.p2c(c.min));else{var p=l,q=n;o>=m&&m<c.min&&o>=c.min?(l=(c.min-m)/(o-m)*(n-l)+l,m=c.min):m>=o&&o<c.min&&m>=c.min&&(n=(c.min-m)/(o-m)*(n-l)+l,o=c.min),m>=o&&m>c.max&&o<=c.max?(l=(c.max-m)/(o-m)*(n-l)+l,m=c.max):o>=m&&o>c.max&&m<=c.max&&(n=(c.max-m)/(o-m)*(n-l)+l,o=c.max),l!=p&&lb.lineTo(b.p2c(p),c.p2c(m)),lb.lineTo(b.p2c(l),c.p2c(m)),lb.lineTo(b.p2c(n),c.p2c(o)),n!=q&&(lb.lineTo(b.p2c(n),c.p2c(o)),lb.lineTo(b.p2c(q),c.p2c(o)))}}}}lb.save(),lb.translate(pb.left,pb.top),lb.lineJoin="round";var d=a.lines.lineWidth,e=a.shadowSize;if(d>0&&e>0){lb.lineWidth=e,lb.strokeStyle="rgba(0,0,0,0.1)";var f=Math.PI/18;b(a.datapoints,Math.sin(f)*(d/2+e/2),Math.cos(f)*(d/2+e/2),a.xaxis,a.yaxis),lb.lineWidth=e/2,b(a.datapoints,Math.sin(f)*(d/2+e/4),Math.cos(f)*(d/2+e/4),a.xaxis,a.yaxis)}lb.lineWidth=d,lb.strokeStyle=a.color;var g=S(a.lines,a.color,0,tb);g&&(lb.fillStyle=g,c(a.datapoints,a.xaxis,a.yaxis)),d>0&&b(a.datapoints,0,0,a.xaxis,a.yaxis),lb.restore()}function P(a){function b(a,b,c,d,e,f,g,h){for(var i=a.points,j=a.pointsize,k=0;k<i.length;k+=j){var l=i[k],m=i[k+1];null==l||l<f.min||l>f.max||m<g.min||m>g.max||(lb.beginPath(),l=f.p2c(l),m=g.p2c(m)+d,"circle"==h?lb.arc(l,m,b,0,e?Math.PI:2*Math.PI,!1):h(lb,l,m,b,e),lb.closePath(),c&&(lb.fillStyle=c,lb.fill()),lb.stroke())}}lb.save(),lb.translate(pb.left,pb.top);var c=a.points.lineWidth,d=a.shadowSize,e=a.points.radius,f=a.points.symbol;if(c>0&&d>0){var g=d/2;lb.lineWidth=g,lb.strokeStyle="rgba(0,0,0,0.1)",b(a.datapoints,e,null,g+g/2,!0,a.xaxis,a.yaxis,f),lb.strokeStyle="rgba(0,0,0,0.2)",b(a.datapoints,e,null,g/2,!0,a.xaxis,a.yaxis,f)}lb.lineWidth=c,lb.strokeStyle=a.color,b(a.datapoints,e,S(a.points,a.color),0,!1,a.xaxis,a.yaxis,f),lb.restore()}function Q(a,b,c,d,e,f,g,h,i,j,k,l){var m,n,o,p,q,r,s,t,u;k?(t=r=s=!0,q=!1,m=c,n=a,p=b+d,o=b+e,m>n&&(u=n,n=m,m=u,q=!0,r=!1)):(q=r=s=!0,t=!1,m=a+d,n=a+e,o=c,p=b,o>p&&(u=p,p=o,o=u,t=!0,s=!1)),n<h.min||m>h.max||p<i.min||o>i.max||(m<h.min&&(m=h.min,q=!1),n>h.max&&(n=h.max,r=!1),o<i.min&&(o=i.min,t=!1),p>i.max&&(p=i.max,s=!1),m=h.p2c(m),o=i.p2c(o),n=h.p2c(n),p=i.p2c(p),g&&(j.beginPath(),j.moveTo(m,o),j.lineTo(m,p),j.lineTo(n,p),j.lineTo(n,o),j.fillStyle=g(o,p),j.fill()),l>0&&(q||r||s||t)&&(j.beginPath(),j.moveTo(m,o+f),q?j.lineTo(m,p+f):j.moveTo(m,p+f),s?j.lineTo(n,p+f):j.moveTo(n,p+f),r?j.lineTo(n,o+f):j.moveTo(n,o+f),t?j.lineTo(m,o+f):j.moveTo(m,o+f),j.stroke()))}function R(a){function b(b,c,d,e,f,g,h){for(var i=b.points,j=b.pointsize,k=0;k<i.length;k+=j)null!=i[k]&&Q(i[k],i[k+1],i[k+2],c,d,e,f,g,h,lb,a.bars.horizontal,a.bars.lineWidth)}lb.save(),lb.translate(pb.left,pb.top),lb.lineWidth=a.bars.lineWidth,lb.strokeStyle=a.color;var c="left"==a.bars.align?0:-a.bars.barWidth/2,d=a.bars.fill?function(b,c){return S(a.bars,a.color,b,c)}:null;b(a.datapoints,c,c+a.bars.barWidth,0,d,a.xaxis,a.yaxis),lb.restore()}function S(b,c,d,e){var f=b.fill;if(!f)return null;if(b.fillColor)return eb(b.fillColor,d,e,c);var g=a.color.parse(c);return g.a="number"==typeof f?f:.4,g.normalize(),g.toString()}function T(){if(b.find(".legend").remove(),hb.legend.show){for(var c,d,e=[],f=!1,g=hb.legend.labelFormatter,h=0;h<gb.length;++h)c=gb[h],d=c.label,d&&(h%hb.legend.noColumns==0&&(f&&e.push("</tr>"),e.push("<tr>"),f=!0),g&&(d=g(d,c)),e.push('<td class="legendColorBox"><div style="'+hb.legend.labelBoxBorderColor+'"><div style="border:2px solid '+c.color+';overflow:hidden"></div></div></td><td class="legendLabel"><span>'+d+"</span></td>"));if(f&&e.push("</tr>"),0!=e.length){var i='<table style="font-size: 11px; color:'+hb.grid.color+'">'+e.join("")+"</table>";if(null!=hb.legend.container)a(hb.legend.container).html(i);else{var j="",k=hb.legend.position,l=hb.legend.margin;null==l[0]&&(l=[l,l]),"n"==k.charAt(0)?j+="top:"+(l[1]+pb.top)+"px;":"s"==k.charAt(0)&&(j+="bottom:"+(l[1]+pb.bottom)+"px;"),"e"==k.charAt(1)?j+="right:"+(l[0]+pb.right)+"px;":"w"==k.charAt(1)&&(j+="left:"+(l[0]+pb.left)+"px;");var m=a('<div class="legend">'+i.replace('style="','style="position:absolute;'+j+";")+"</div>").appendTo(b);if(0!=hb.legend.backgroundOpacity){var n=hb.legend.backgroundColor;null==n&&(n=hb.grid.backgroundColor,n=n&&"string"==typeof n?a.color.parse(n):a.color.extract(m,"background-color"),n.a=1,n=n.toString());var o=m.children();a('<div style="position:absolute;width:'+o.width()+"px;height:"+o.height()+"px;"+j+"background-color:"+n+';"> </div>').prependTo(m).css("opacity",hb.legend.backgroundOpacity)}}}}}function U(a,b,c){var d,e,f=hb.grid.mouseActiveRadius,g=f*f+1,h=null;for(d=gb.length-1;d>=0;--d)if(c(gb[d])){var i=gb[d],j=i.xaxis,k=i.yaxis,l=i.datapoints.points,m=i.datapoints.pointsize,n=j.c2p(a),o=k.c2p(b),p=f/j.scale,q=f/k.scale;if(j.options.inverseTransform&&(p=Number.MAX_VALUE),k.options.inverseTransform&&(q=Number.MAX_VALUE),i.lines.show||i.points.show)for(e=0;e<l.length;e+=m){var r=l[e],s=l[e+1];if(null!=r&&!(r-n>p||-p>r-n||s-o>q||-q>s-o)){var t=Math.abs(j.p2c(r)-a),u=Math.abs(k.p2c(s)-b),v=t*t+u*u;g>v&&(g=v,h=[d,e/m])}}if(i.bars.show&&!h){var w="left"==i.bars.align?0:-i.bars.barWidth/2,x=w+i.bars.barWidth;for(e=0;e<l.length;e+=m){var r=l[e],s=l[e+1],y=l[e+2];null!=r&&(gb[d].bars.horizontal?n<=Math.max(y,r)&&n>=Math.min(y,r)&&o>=s+w&&s+x>=o:n>=r+w&&r+x>=n&&o>=Math.min(y,s)&&o<=Math.max(y,s))&&(h=[d,e/m])}}}return h?(d=h[0],e=h[1],m=gb[d].datapoints.pointsize,{datapoint:gb[d].datapoints.points.slice(e*m,(e+1)*m),dataIndex:e,series:gb[d],seriesIndex:d}):null}function V(a){hb.grid.hoverable&&Y("plothover",a,function(a){return 0!=a.hoverable})}function W(a){hb.grid.hoverable&&Y("plothover",a,function(){return!1})}function X(a){Y("plotclick",a,function(a){return 0!=a.clickable})}function Y(a,c,d){var e=kb.offset(),f=c.pageX-e.left-pb.left,g=c.pageY-e.top-pb.top,h=o({left:f,top:g});h.pageX=c.pageX,h.pageY=c.pageY;var i=U(f,g,d);if(i&&(i.pageX=parseInt(i.series.xaxis.p2c(i.datapoint[0])+e.left+pb.left),i.pageY=parseInt(i.series.yaxis.p2c(i.datapoint[1])+e.top+pb.top)),hb.grid.autoHighlight){for(var j=0;j<wb.length;++j){var k=wb[j];k.auto!=a||i&&k.series==i.series&&k.point[0]==i.datapoint[0]&&k.point[1]==i.datapoint[1]||ab(k.series,k.point)}i&&_(i.series,i.datapoint,a)}b.trigger(a,[h,i])}function Z(){xb||(xb=setTimeout($,30))}function $(){xb=null,mb.save(),mb.clearRect(0,0,qb,rb),mb.translate(pb.left,pb.top);var a,b;for(a=0;a<wb.length;++a)b=wb[a],b.series.bars.show?db(b.series,b.point):cb(b.series,b.point);mb.restore(),g(ub.drawOverlay,[mb])}function _(a,b,c){if("number"==typeof a&&(a=gb[a]),"number"==typeof b){var d=a.datapoints.pointsize;b=a.datapoints.points.slice(d*b,d*(b+1))}var e=bb(a,b);-1==e?(wb.push({series:a,point:b,auto:c}),Z()):c||(wb[e].auto=!1)}function ab(a,b){null==a&&null==b&&(wb=[],Z()),"number"==typeof a&&(a=gb[a]),"number"==typeof b&&(b=a.data[b]);var c=bb(a,b);-1!=c&&(wb.splice(c,1),Z())}function bb(a,b){for(var c=0;c<wb.length;++c){var d=wb[c];if(d.series==a&&d.point[0]==b[0]&&d.point[1]==b[1])return c}return-1}function cb(b,c){var d=c[0],e=c[1],f=b.xaxis,g=b.yaxis;if(!(d<f.min||d>f.max||e<g.min||e>g.max)){var h=b.points.radius+b.points.lineWidth/2;mb.lineWidth=h,mb.strokeStyle=a.color.parse(b.color).scale("a",.5).toString();var i=1.5*h,d=f.p2c(d),e=g.p2c(e);mb.beginPath(),"circle"==b.points.symbol?mb.arc(d,e,i,0,2*Math.PI,!1):b.points.symbol(mb,d,e,i,!1),mb.closePath(),mb.stroke()}}function db(b,c){mb.lineWidth=b.bars.lineWidth,mb.strokeStyle=a.color.parse(b.color).scale("a",.5).toString();var d=a.color.parse(b.color).scale("a",.5).toString(),e="left"==b.bars.align?0:-b.bars.barWidth/2;Q(c[0],c[1],c[2]||0,e,e+b.bars.barWidth,0,function(){return d},b.xaxis,b.yaxis,mb,b.bars.horizontal,b.bars.lineWidth)}function eb(b,c,d,e){if("string"==typeof b)return b;for(var f=lb.createLinearGradient(0,d,0,c),g=0,h=b.colors.length;h>g;++g){var i=b.colors[g];if("string"!=typeof i){var j=a.color.parse(e);null!=i.brightness&&(j=j.scale("rgb",i.brightness)),null!=i.opacity&&(j.a*=i.opacity),i=j.toString()}f.addColorStop(g/(h-1),i)}return f}var fb=window.devicePixelRatio>1,gb=[],hb={colors:a.flot_color_array||["#931313","#638167","#65596B","#60747C","#B09B5B"],legend:{show:!0,noColumns:a.flot_noColumns||0,labelFormatter:null,labelBoxBorderColor:"",container:null,position:"ne",margin:a.flot_margin||[-5,-32],backgroundColor:a.flot_backgroundColor||"",backgroundOpacity:a.flot_backgroundOpacity||1},xaxis:{show:null,position:"bottom",mode:null,color:null,tickColor:null,transform:null,inverseTransform:null,min:null,max:null,autoscaleMargin:null,ticks:null,tickFormatter:null,labelWidth:null,labelHeight:null,reserveSpace:null,tickLength:null,alignTicksWithAxis:null,tickDecimals:null,tickSize:null,minTickSize:null,monthNames:null,timeformat:null,twelveHourClock:!1},yaxis:{autoscaleMargin:.02,position:"left"},xaxes:[],yaxes:[],series:{points:{show:!1,radius:3,lineWidth:2,fill:!0,fillColor:"#ffffff",symbol:"circle"},lines:{lineWidth:2,fill:!1,fillColor:null,steps:!1},bars:{show:!1,lineWidth:a.flot_bars_lineWidth||1,barWidth:1,fill:!0,fillColor:a.flot_bars_fillColor||{colors:[{opacity:.7},{opacity:1}]},align:"left",horizontal:!1},shadowSize:a.flot_shadowSize||0},grid:{show:!0,aboveData:!1,color:a.flot_grid_color||"#545454",backgroundColor:null,borderColor:a.flot_grid_borderColor||"#efefef",tickColor:a.flot_grid_tickColor||"rgba(0,0,0,0.06)",labelMargin:a.flot_grid_labelMargin||10,axisMargin:8,borderWidth:a.flot_grid_borderWidth||0,minBorderMargin:a.flot_grid_minBorderMargin||10,markings:null,markingsColor:"#f4f4f4",markingsLineWidth:2,clickable:!1,hoverable:!1,autoHighlight:!0,mouseActiveRadius:a.flot_grid_mouseActiveRadius||5},hooks:{}},ib=null,jb=null,kb=null,lb=null,mb=null,nb=[],ob=[],pb={left:0,right:0,top:0,bottom:0},qb=0,rb=0,sb=0,tb=0,ub={processOptions:[],processRawData:[],processDatapoints:[],drawSeries:[],draw:[],bindEvents:[],drawOverlay:[],shutdown:[]},vb=this;vb.setData=k,vb.setupGrid=D,vb.draw=I,vb.getPlaceholder=function(){return b
},vb.getCanvas=function(){return ib},vb.getPlotOffset=function(){return pb},vb.width=function(){return sb},vb.height=function(){return tb},vb.offset=function(){var a=kb.offset();return a.left+=pb.left,a.top+=pb.top,a},vb.getData=function(){return gb},vb.getAxes=function(){var b={};return a.each(nb.concat(ob),function(a,c){c&&(b[c.direction+(1!=c.n?c.n:"")+"axis"]=c)}),b},vb.getXAxes=function(){return nb},vb.getYAxes=function(){return ob},vb.c2p=o,vb.p2c=p,vb.getOptions=function(){return hb},vb.highlight=_,vb.unhighlight=ab,vb.triggerRedrawOverlay=Z,vb.pointOffset=function(a){return{left:parseInt(nb[m(a,"x")-1].p2c(+a.x)+pb.left),top:parseInt(ob[m(a,"y")-1].p2c(+a.y)+pb.top)}},vb.shutdown=y,vb.resize=function(){u(),v(ib),v(jb)},vb.hooks=ub,h(vb),j(e),w(),k(d),D(),I(),x();var wb=[],xb=null}function c(a,b){return b*Math.floor(a/b)}a.plot=function(c,d,e){var f=new b(a(c),d,e,a.plot.plugins);return f},a.plot.version="0.7",a.plot.plugins=[],a.plot.formatDate=function(a,b,c){var d=function(a){return a=""+a,1==a.length?"0"+a:a},e=[],f=!1,g=!1,h=a.getUTCHours(),i=12>h;null==c&&(c=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"]),-1!=b.search(/%p|%P/)&&(h>12?h-=12:0==h&&(h=12));for(var j=0;j<b.length;++j){var k=b.charAt(j);if(f){switch(k){case"h":k=""+h;break;case"H":k=d(h);break;case"M":k=d(a.getUTCMinutes());break;case"S":k=d(a.getUTCSeconds());break;case"d":k=""+a.getUTCDate();break;case"m":k=""+(a.getUTCMonth()+1);break;case"y":k=""+a.getUTCFullYear();break;case"b":k=""+c[a.getUTCMonth()];break;case"p":k=i?"am":"pm";break;case"P":k=i?"AM":"PM";break;case"0":k="",g=!0}k&&g&&(k=d(k),g=!1),e.push(k),g||(f=!1)}else"%"==k?f=!0:e.push(k)}return e.join("")}}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a,b,c){function d(){e=b[h](function(){f.each(function(){var b=a(this),c=b.width(),d=b.height(),e=a.data(this,j);(c!==e.w||d!==e.h)&&b.trigger(i,[e.w=c,e.h=d])}),d()},g[k])}var e,f=a([]),g=a.resize=a.extend(a.resize,{}),h="setTimeout",i="resize",j=i+"-special-event",k="delay",l="throttleWindow";g[k]=250,g[l]=!0,a.event.special[i]={setup:function(){if(!g[l]&&this[h])return!1;var b=a(this);f=f.add(b),a.data(this,j,{w:b.width(),h:b.height()}),1===f.length&&d()},teardown:function(){if(!g[l]&&this[h])return!1;var b=a(this);f=f.not(b),b.removeData(j),f.length||clearTimeout(e)},add:function(b){function d(b,d,f){var g=a(this),h=a.data(this,j);h.w=d!==c?d:g.width(),h.h=f!==c?f:g.height(),e.apply(this,arguments)}if(!g[l]&&this[h])return!1;var e;return a.isFunction(b)?(e=b,d):(e=b.handler,void(b.handler=d))}}}(jQuery,this),function(a){function b(a){function b(){var b=a.getPlaceholder();0!=b.width()&&0!=b.height()&&(a.resize(),a.setupGrid(),a.draw())}function c(a){a.getPlaceholder().resize(b)}function d(a){a.getPlaceholder().unbind("resize",b)}a.hooks.bindEvents.push(c),a.hooks.shutdown.push(d)}var c={};a.plot.plugins.push({init:b,options:c,name:"resize",version:"1.0"})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a){var b={tooltip:!1,tooltipOpts:{content:"%s | X: %x | Y: %y.2",dateFormat:"%y-%0m-%0d",shifts:{x:10,y:20},defaultTheme:!0}},c=function(b){var c={x:0,y:0},d=b.getOptions(),e=function(a){c.x=a.x,c.y=a.y},f=function(a){var b={x:0,y:0};b.x=a.pageX,b.y=a.pageY,e(b)},g=function(b){var c=new Date(b);return a.plot.formatDate(c,d.tooltipOpts.dateFormat)};b.hooks.bindEvents.push(function(b,e){var i,j=d.tooltipOpts,k=b.getPlaceholder();d.tooltip!==!1&&(a("#flotTip").length>0?i=a("#flotTip"):(i=a("<div />").attr("id","flotTip"),i.appendTo("body").hide().css({position:"absolute"}),j.defaultTheme&&i.css({background:"#fff","z-index":"100",padding:"0.4em 0.6em","border-radius":"0.5em","font-size":"0.8em",border:"1px solid #111"})),a(k).bind("plothover",function(a,b,e){if(e){var f;f="time"===d.xaxis.mode||"time"===d.xaxes[0].mode?h(j.content,e,g):h(j.content,e),i.html(f).css({left:c.x+j.shifts.x,top:c.y+j.shifts.y}).show()}else i.hide().html("")}),e.mousemove(f))});var h=function(a,b,c){var d=/%p\.{0,1}(\d{0,})/,e=/%s/,f=/%x\.{0,1}(\d{0,})/,g=/%y\.{0,1}(\d{0,})/;return"undefined"!=typeof b.series.percent&&(a=i(d,a,b.series.percent)),"undefined"!=typeof b.series.label&&(a=a.replace(e,b.series.label)),"function"==typeof c?a=a.replace(f,c(b.series.data[b.dataIndex][0])):"number"==typeof b.series.data[b.dataIndex][0]&&(a=i(f,a,b.series.data[b.dataIndex][0])),"number"==typeof b.series.data[b.dataIndex][1]&&(a=i(g,a,b.series.data[b.dataIndex][1])),a},i=function(a,b,c){var d;return"null"!==b.match(a)&&(""!==RegExp.$1&&(d=RegExp.$1,c=c.toFixed(d)),b=b.replace(a,c)),b}};a.plot.plugins.push({init:c,options:b,name:"tooltip",version:"0.4.4"})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a,b){function c(b){a.extend(!0,rb,b)}function d(c,d,j){function k(a){$?(y(),x(),G(),t(a)):l()}function l(){_=d.theme?"ui":"fc",c.addClass("fc"),d.isRTL&&c.addClass("fc-rtl"),d.theme&&c.addClass("ui-widget"),$=a("<div class='fc-content' style='position:relative'/>").prependTo(c),Y=new e(X,d),Z=Y.render(),Z&&c.prepend(Z),s(d.defaultView),a(window).resize(A),r()||n()}function n(){setTimeout(function(){!ab.start&&r()&&t()},0)}function o(){a(window).unbind("resize",A),Y.destroy(),$.remove(),c.removeClass("fc fc-rtl ui-widget")}function p(){return 0!==hb.offsetWidth}function r(){return 0!==a("body")[0].offsetWidth}function s(b){if(!ab||b!=ab.name){kb++,I();var c,d=ab;d?((d.beforeHide||O)(),N($,$.height()),d.element.hide()):N($,1),$.css("overflow","hidden"),ab=ib[b],ab?ab.element.show():ab=ib[b]=new ub[b](c=db=a("<div class='fc-view fc-view-"+b+"' style='position:absolute'/>").appendTo($),X),d&&Y.deactivateButton(d.name),Y.activateButton(b),t(),$.css("overflow",""),d&&N($,1),c||(ab.afterShow||O)(),kb--}}function t(a){if(p()){kb++,I(),cb===b&&y();var d=!1;!ab.start||a||lb<ab.start||lb>=ab.end?(ab.render(lb,a||0),z(!0),d=!0):ab.sizeDirty?(ab.clearEvents(),z(),d=!0):ab.eventsDirty&&(ab.clearEvents(),d=!0),ab.sizeDirty=!1,ab.eventsDirty=!1,B(d),bb=c.outerWidth(),Y.updateTitle(ab.title);var e=new Date;e>=ab.start&&e<ab.end?Y.disableButton("today"):Y.enableButton("today"),kb--,ab.trigger("viewDisplay",hb)}}function w(){x(),p()&&(y(),z(),I(),ab.clearEvents(),ab.renderEvents(mb),ab.sizeDirty=!1)}function x(){a.each(ib,function(a,b){b.sizeDirty=!0})}function y(){cb=d.contentHeight?d.contentHeight:d.height?d.height-(Z?Z.height():0)-J($):Math.round($.width()/Math.max(d.aspectRatio,.5))}function z(a){kb++,ab.setHeight(cb,a),db&&(db.css("position","relative"),db=null),ab.setWidth($.width(),a),kb--}function A(){if(!kb)if(ab.start){var a=++jb;setTimeout(function(){a==jb&&!kb&&p()&&bb!=(bb=c.outerWidth())&&(kb++,w(),ab.trigger("windowResize",hb),kb--)},200)}else n()}function B(a){!d.lazyFetching||fb(ab.visStart,ab.visEnd)?C():a&&F()}function C(){gb(ab.visStart,ab.visEnd)}function D(a){mb=a,F()}function E(a){F(a)}function F(a){G(),p()&&(ab.clearEvents(),ab.renderEvents(mb,a),ab.eventsDirty=!1)}function G(){a.each(ib,function(a,b){b.eventsDirty=!0})}function H(a,c,d){ab.select(a,c,d===b?!0:d)}function I(){ab&&ab.unselect()}function K(){t(-1)}function L(){t(1)}function M(){g(lb,-1),t()}function P(){g(lb,1),t()}function Q(){lb=new Date,t()}function R(a,b,c){a instanceof Date?lb=m(a):q(lb,a,b,c),t()}function S(a,c,d){a!==b&&g(lb,a),c!==b&&h(lb,c),d!==b&&i(lb,d),t()}function T(){return m(lb)}function U(){return ab}function V(a,c){return c===b?d[a]:void(("height"==a||"contentHeight"==a||"aspectRatio"==a)&&(d[a]=c,w()))}function W(a,b){return d[a]?d[a].apply(b||hb,Array.prototype.slice.call(arguments,2)):void 0}var X=this;X.options=d,X.render=k,X.destroy=o,X.refetchEvents=C,X.reportEvents=D,X.reportEventChange=E,X.rerenderEvents=F,X.changeView=s,X.select=H,X.unselect=I,X.prev=K,X.next=L,X.prevYear=M,X.nextYear=P,X.today=Q,X.gotoDate=R,X.incrementDate=S,X.formatDate=function(a,b){return u(a,b,d)},X.formatDates=function(a,b,c){return v(a,b,c,d)},X.getDate=T,X.getView=U,X.option=V,X.trigger=W,f.call(X,d,j);var Y,Z,$,_,ab,bb,cb,db,eb,fb=X.isFetchNeeded,gb=X.fetchEvents,hb=c[0],ib={},jb=0,kb=0,lb=new Date,mb=[];q(lb,d.year,d.month,d.date),d.droppable&&a(document).bind("dragstart",function(b,c){var e=b.target,f=a(e);if(!f.parents(".fc").length){var g=d.dropAccept;(a.isFunction(g)?g.call(e,f):f.is(g))&&(eb=e,ab.dragStart(eb,b,c))}}).bind("dragstop",function(a,b){eb&&(ab.dragStop(eb,a,b),eb=null)})}function e(b,c){function d(){m=c.theme?"ui":"fc";var b=c.header;return b?n=a("<table class='fc-header' style='width:100%'/>").append(a("<tr/>").append(f("left")).append(f("center")).append(f("right"))):void 0}function e(){n.remove()}function f(d){var e=a("<td class='fc-header-"+d+"'/>"),f=c.header[d];return f&&a.each(f.split(" "),function(d){d>0&&e.append("<span class='fc-header-space'/>");var f;a.each(this.split(","),function(d,g){if("title"==g)e.append("<span class='fc-header-title'><h2>&nbsp;</h2></span>"),f&&f.addClass(m+"-corner-right"),f=null;else{var h;if(b[g]?h=b[g]:ub[g]&&(h=function(){k.removeClass(m+"-state-hover"),b.changeView(g)}),h){var i=c.theme?S(c.buttonIcons,g):null,j=S(c.buttonText,g),k=a("<span class='fc-button fc-button-"+g+" "+m+"-state-default'><span class='fc-button-inner'><span class='fc-button-content'>"+(i?"<span class='fc-icon-wrap'><span class='ui-icon ui-icon-"+i+"'/></span>":j)+"</span><span class='fc-button-effect'><span></span></span></span></span>");k&&(k.click(function(){k.hasClass(m+"-state-disabled")||h()}).mousedown(function(){k.not("."+m+"-state-active").not("."+m+"-state-disabled").addClass(m+"-state-down")}).mouseup(function(){k.removeClass(m+"-state-down")}).hover(function(){k.not("."+m+"-state-active").not("."+m+"-state-disabled").addClass(m+"-state-hover")},function(){k.removeClass(m+"-state-hover").removeClass(m+"-state-down")}).appendTo(e),f||k.addClass(m+"-corner-left"),f=k)}}}),f&&f.addClass(m+"-corner-right")}),e}function g(a){n.find("h2").html(a)}function h(a){n.find("span.fc-button-"+a).addClass(m+"-state-active")}function i(a){n.find("span.fc-button-"+a).removeClass(m+"-state-active")}function j(a){n.find("span.fc-button-"+a).addClass(m+"-state-disabled")}function k(a){n.find("span.fc-button-"+a).removeClass(m+"-state-disabled")}var l=this;l.render=d,l.destroy=e,l.updateTitle=g,l.activateButton=h,l.deactivateButton=i,l.disableButton=j,l.enableButton=k;var m,n=a([])}function f(c,d){function e(a,b){return!y||y>a||b>z}function f(a,b){y=a,z=b,I=[];var c=++F,d=E.length;G=d;for(var e=0;d>e;e++)g(E[e],c)}function g(a,b){h(a,function(c){if(b==F){if(c){for(var d=0;d<c.length;d++)c[d].source=a,t(c[d]);I=I.concat(c)}G--,G||C(I)}})}function h(b,d){var e,f,g=tb.sourceFetchers;for(e=0;e<g.length;e++){if(f=g[e](b,y,z,d),f===!0)return;if("object"==typeof f)return void h(f,d)}var i=b.events;if(i)a.isFunction(i)?(q(),i(m(y),m(z),function(a){d(a),s()})):a.isArray(i)?d(i):d();else{var j=b.url;if(j){var k=b.success,l=b.error,n=b.complete,o=a.extend({},b.data||{}),p=$(b.startParam,c.startParam),r=$(b.endParam,c.endParam);p&&(o[p]=Math.round(+y/1e3)),r&&(o[r]=Math.round(+z/1e3)),q(),a.ajax(a.extend({},vb,b,{data:o,success:function(b){b=b||[];var c=Z(k,this,arguments);a.isArray(c)&&(b=c),d(b)},error:function(){Z(l,this,arguments),d()},complete:function(){Z(n,this,arguments),s()}}))}else d()}}function i(a){a=j(a),a&&(G++,g(a,F))}function j(b){return a.isFunction(b)||a.isArray(b)?b={events:b}:"string"==typeof b&&(b={url:b}),"object"==typeof b?(u(b),E.push(b),b):void 0}function k(b){E=a.grep(E,function(a){return!v(a,b)}),I=a.grep(I,function(a){return!v(a.source,b)}),C(I)}function l(a){var b,c,d=I.length,e=B().defaultEventEnd,f=a.start-a._start,g=a.end?a.end-(a._end||e(a)):0;for(b=0;d>b;b++)c=I[b],c._id==a._id&&c!=a&&(c.start=new Date(+c.start+f),c.end=a.end?new Date(c.end?+c.end+g:+e(c)+g):null,c.title=a.title,c.url=a.url,c.allDay=a.allDay,c.className=a.className,c.editable=a.editable,c.color=a.color,c.backgroudColor=a.backgroudColor,c.borderColor=a.borderColor,c.textColor=a.textColor,t(c));t(a),C(I)}function n(a,b){t(a),a.source||(b&&(D.events.push(a),a.source=D),I.push(a)),C(I)}function o(b){if(b){if(!a.isFunction(b)){var c=b+"";b=function(a){return a._id==c}}I=a.grep(I,b,!0);for(var d=0;d<E.length;d++)a.isArray(E[d].events)&&(E[d].events=a.grep(E[d].events,b,!0))}else{I=[];for(var d=0;d<E.length;d++)a.isArray(E[d].events)&&(E[d].events=[])}C(I)}function p(b){return a.isFunction(b)?a.grep(I,b):b?(b+="",a.grep(I,function(a){return a._id==b})):I}function q(){H++||A("loading",null,!0)}function s(){--H||A("loading",null,!1)}function t(a){var d=a.source||{},e=$(d.ignoreTimezone,c.ignoreTimezone);a._id=a._id||(a.id===b?"_fc"+wb++:a.id+""),a.date&&(a.start||(a.start=a.date),delete a.date),a._start=m(a.start=r(a.start,e)),a.end=r(a.end,e),a.end&&a.end<=a.start&&(a.end=null),a._end=a.end?m(a.end):null,a.allDay===b&&(a.allDay=$(d.allDayDefault,c.allDayDefault)),a.className?"string"==typeof a.className&&(a.className=a.className.split(/\s+/)):a.className=[]}function u(a){a.className?"string"==typeof a.className&&(a.className=a.className.split(/\s+/)):a.className=[];for(var b=tb.sourceNormalizers,c=0;c<b.length;c++)b[c](a)}function v(a,b){return a&&b&&w(a)==w(b)}function w(a){return("object"==typeof a?a.events||a.url:"")||a}var x=this;x.isFetchNeeded=e,x.fetchEvents=f,x.addEventSource=i,x.removeEventSource=k,x.updateEvent=l,x.renderEvent=n,x.removeEvents=o,x.clientEvents=p,x.normalizeEvent=t;for(var y,z,A=x.trigger,B=x.getView,C=x.reportEvents,D={events:[]},E=[D],F=0,G=0,H=0,I=[],J=0;J<d.length;J++)j(d[J])}function g(a,b,c){return a.setFullYear(a.getFullYear()+b),c||l(a),a}function h(a,b,c){if(+a){var d=a.getMonth()+b,e=m(a);for(e.setDate(1),e.setMonth(d),a.setMonth(d),c||l(a);a.getMonth()!=e.getMonth();)a.setDate(a.getDate()+(e>a?1:-1))}return a}function i(a,b,c){if(+a){var d=a.getDate()+b,e=m(a);e.setHours(9),e.setDate(d),a.setDate(d),c||l(a),j(a,e)}return a}function j(a,b){if(+a)for(;a.getDate()!=b.getDate();)a.setTime(+a+(b>a?1:-1)*zb)}function k(a,b){return a.setMinutes(a.getMinutes()+b),a}function l(a){return a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0),a}function m(a,b){return b?l(new Date(+a)):new Date(+a)}function n(){var a,b=0;do a=new Date(1970,b++,1);while(a.getHours());return a}function o(a,b,c){for(b=b||1;!a.getDay()||c&&1==a.getDay()||!c&&6==a.getDay();)i(a,b);return a}function p(a,b){return Math.round((m(a,!0)-m(b,!0))/yb)}function q(a,c,d,e){c!==b&&c!=a.getFullYear()&&(a.setDate(1),a.setMonth(0),a.setFullYear(c)),d!==b&&d!=a.getMonth()&&(a.setDate(1),a.setMonth(d)),e!==b&&a.setDate(e)}function r(a,c){return"object"==typeof a?a:"number"==typeof a?new Date(1e3*a):"string"==typeof a?a.match(/^\d+(\.\d+)?$/)?new Date(1e3*parseFloat(a)):(c===b&&(c=!0),s(a,c)||(a?new Date(a):null)):null}function s(a,b){var c=a.match(/^([0-9]{4})(-([0-9]{2})(-([0-9]{2})([T ]([0-9]{2}):([0-9]{2})(:([0-9]{2})(\.([0-9]+))?)?(Z|(([-+])([0-9]{2})(:?([0-9]{2}))?))?)?)?)?$/);if(!c)return null;var d=new Date(c[1],0,1);if(b||!c[13]){var e=new Date(c[1],0,1,9,0);c[3]&&(d.setMonth(c[3]-1),e.setMonth(c[3]-1)),c[5]&&(d.setDate(c[5]),e.setDate(c[5])),j(d,e),c[7]&&d.setHours(c[7]),c[8]&&d.setMinutes(c[8]),c[10]&&d.setSeconds(c[10]),c[12]&&d.setMilliseconds(1e3*Number("0."+c[12])),j(d,e)}else if(d.setUTCFullYear(c[1],c[3]?c[3]-1:0,c[5]||1),d.setUTCHours(c[7]||0,c[8]||0,c[10]||0,c[12]?1e3*Number("0."+c[12]):0),c[14]){var f=60*Number(c[16])+(c[18]?Number(c[18]):0);f*="-"==c[15]?1:-1,d=new Date(+d+60*f*1e3)}return d}function t(a){if("number"==typeof a)return 60*a;if("object"==typeof a)return 60*a.getHours()+a.getMinutes();var b=a.match(/(\d+)(?::(\d+))?\s*(\w+)?/);if(b){var c=parseInt(b[1],10);return b[3]&&(c%=12,"p"==b[3].toLowerCase().charAt(0)&&(c+=12)),60*c+(b[2]?parseInt(b[2],10):0)}}function u(a,b,c){return v(a,null,b,c)}function v(a,b,c,d){d=d||rb;var e,f,g,h,i=a,j=b,k=c.length,l="";for(e=0;k>e;e++)if(f=c.charAt(e),"'"==f){for(g=e+1;k>g;g++)if("'"==c.charAt(g)){i&&(l+=g==e+1?"'":c.substring(e+1,g),e=g);break}}else if("("==f){for(g=e+1;k>g;g++)if(")"==c.charAt(g)){var m=u(i,c.substring(e+1,g),d);parseInt(m.replace(/\D/,""),10)&&(l+=m),e=g;break}}else if("["==f){for(g=e+1;k>g;g++)if("]"==c.charAt(g)){var n=c.substring(e+1,g),m=u(i,n,d);m!=u(j,n,d)&&(l+=m),e=g;break}}else if("{"==f)i=b,j=a;else if("}"==f)i=a,j=b;else{for(g=k;g>e;g--)if(h=Bb[c.substring(e,g)]){i&&(l+=h(i,d)),e=g-1;break}g==e&&i&&(l+=f)}return l}function w(a){return a.end?x(a.end,a.allDay):i(m(a.start),1)}function x(a,b){return a=m(a),b||a.getHours()||a.getMinutes()?i(a,1):l(a)}function y(a,b){return 100*(b.msLength-a.msLength)+(a.event.start-b.event.start)}function z(a,b){return a.end>b.start&&a.start<b.end}function A(a,b,c,d){var e,f,g,h,i,j,k,l,n=[],o=a.length;for(e=0;o>e;e++)f=a[e],g=f.start,h=b[e],h>c&&d>g&&(c>g?(i=m(c),k=!1):(i=g,k=!0),h>d?(j=m(d),l=!1):(j=h,l=!0),n.push({event:f,start:i,end:j,isStart:k,isEnd:l,msLength:j-i}));return n.sort(y)}function B(a){var b,c,d,e,f,g=[],h=a.length;for(b=0;h>b;b++){for(c=a[b],d=0;;){if(e=!1,g[d])for(f=0;f<g[d].length;f++)if(z(g[d][f],c)){e=!0;break}if(!e)break;d++}g[d]?g[d].push(c):g[d]=[c]}return g}function C(c,d,e){c.unbind("mouseover").mouseover(function(c){for(var f,g,h,i=c.target;i!=this;)f=i,i=i.parentNode;(g=f._fci)!==b&&(f._fci=b,h=d[g],e(h.event,h.element,h),a(c.target).trigger(c)),c.stopPropagation()})}function D(b,c,d){for(var e,f=0;f<b.length;f++)e=a(b[f]),e.width(Math.max(0,c-F(e,d)))}function E(b,c,d){for(var e,f=0;f<b.length;f++)e=a(b[f]),e.height(Math.max(0,c-J(e,d)))}function F(a,b){return G(a)+I(a)+(b?H(a):0)}function G(b){return(parseFloat(a.css(b[0],"paddingLeft",!0))||0)+(parseFloat(a.css(b[0],"paddingRight",!0))||0)}function H(b){return(parseFloat(a.css(b[0],"marginLeft",!0))||0)+(parseFloat(a.css(b[0],"marginRight",!0))||0)}function I(b){return(parseFloat(a.css(b[0],"borderLeftWidth",!0))||0)+(parseFloat(a.css(b[0],"borderRightWidth",!0))||0)}function J(a,b){return K(a)+M(a)+(b?L(a):0)}function K(b){return(parseFloat(a.css(b[0],"paddingTop",!0))||0)+(parseFloat(a.css(b[0],"paddingBottom",!0))||0)}function L(b){return(parseFloat(a.css(b[0],"marginTop",!0))||0)+(parseFloat(a.css(b[0],"marginBottom",!0))||0)}function M(b){return(parseFloat(a.css(b[0],"borderTopWidth",!0))||0)+(parseFloat(a.css(b[0],"borderBottomWidth",!0))||0)}function N(a,b){b="number"==typeof b?b+"px":b,a.each(function(a,c){c.style.cssText+=";min-height:"+b+";_height:"+b})}function O(){}function P(a,b){return a-b}function Q(a){return Math.max.apply(Math,a)}function R(a){return(10>a?"0":"")+a}function S(a,c){if(a[c]!==b)return a[c];for(var d,e=c.split(/(?=[A-Z])/),f=e.length-1;f>=0;f--)if(d=a[e[f].toLowerCase()],d!==b)return d;return a[""]}function T(a){return a.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/'/g,"&#039;").replace(/"/g,"&quot;").replace(/\n/g,"<br />")}function U(a){return a.id+"/"+a.className+"/"+a.style.cssText.replace(/(^|;)\s*(top|left|width|height)\s*:[^;]*/gi,"")}function V(a){a.attr("unselectable","on").css("MozUserSelect","none").bind("selectstart.ui",function(){return!1})}function W(a){a.children().removeClass("fc-first fc-last").filter(":first-child").addClass("fc-first").end().filter(":last-child").addClass("fc-last")}function X(a,b){a.each(function(a,c){c.className=c.className.replace(/^fc-\w*/,"fc-"+xb[b.getDay()])})}function Y(a,b){var c=a.source||{},d=a.color,e=c.color,f=b("eventColor"),g=a.backgroundColor||d||c.backgroundColor||e||b("eventBackgroundColor")||f,h=a.borderColor||d||c.borderColor||e||b("eventBorderColor")||f,i=a.textColor||c.textColor||b("eventTextColor"),j=[];return g&&j.push("background-color:"+g),h&&j.push("border-color:"+h),i&&j.push("color:"+i),j.join(";")}function Z(b,c,d){if(a.isFunction(b)&&(b=[b]),b){var e,f;for(e=0;e<b.length;e++)f=b[e].apply(c,d)||f;return f}}function $(){for(var a=0;a<arguments.length;a++)if(arguments[a]!==b)return arguments[a]}function _(a,b){function c(a,b){b&&(h(a,b),a.setDate(1));var c=m(a,!0);c.setDate(1);var j=h(m(c),1),k=m(c),l=m(j),n=e("firstDay"),p=e("weekends")?0:1;p&&(o(k),o(l,-1,!0)),i(k,-((k.getDay()-Math.max(n,p)+7)%7)),i(l,(7-l.getDay()+Math.max(n,p))%7);var q=Math.round((l-k)/(7*yb));"fixed"==e("weekMode")&&(i(l,7*(6-q)),q=6),d.title=g(c,e("titleFormat")),d.start=c,d.end=j,d.visStart=k,d.visEnd=l,f(6,q,p?5:7,!0)}var d=this;d.render=c,cb.call(d,a,b,"month");var e=d.opt,f=d.renderBasic,g=b.formatDate}function ab(a,b){function c(a,b){b&&i(a,7*b);var c=i(m(a),-((a.getDay()-e("firstDay")+7)%7)),h=i(m(c),7),j=m(c),k=m(h),l=e("weekends");l||(o(j),o(k,-1,!0)),d.title=g(j,i(m(k),-1),e("titleFormat")),d.start=c,d.end=h,d.visStart=j,d.visEnd=k,f(1,1,l?7:5,!1)}var d=this;d.render=c,cb.call(d,a,b,"basicWeek");var e=d.opt,f=d.renderBasic,g=b.formatDates}function bb(a,b){function c(a,b){b&&(i(a,b),e("weekends")||o(a,0>b?-1:1)),d.title=g(a,e("titleFormat")),d.start=d.visStart=m(a,!0),d.end=d.visEnd=i(m(d.start),1),f(1,1,1,!1)}var d=this;d.render=c,cb.call(d,a,b,"basicDay");var e=d.opt,f=d.renderBasic,g=b.formatDate}function cb(b,c,d){function e(a,b,c,d){$=b,_=c,f();var e=!O;e?g(a,d):tb(),h(e)}function f(){eb=rb("isRTL"),eb?(fb=-1,gb=_-1):(fb=1,gb=0),hb=rb("firstDay"),ib=rb("weekends")?0:1,kb=rb("theme")?"ui":"fc",pb=rb("columnFormat")}function g(c,d){var e,f,g,h,i=kb+"-widget-header",j=kb+"-widget-content";for(e="<table class='fc-border-separate' style='width:100%' cellspacing='0'><thead><tr>",f=0;_>f;f++)e+="<th class='fc- "+i+"'/>";for(e+="</tr></thead><tbody>",f=0;c>f;f++){for(e+="<tr class='fc-week"+f+"'>",g=0;_>g;g++)e+="<td class='fc- "+j+" fc-day"+(f*_+g)+"'><div>"+(d?"<div class='fc-day-number'/>":"")+"<div class='fc-day-content'><div style='position:relative'>&nbsp;</div></div></div></td>";e+="</tr>"}e+="</tbody></table>",h=a(e).appendTo(b),L=h.find("thead"),M=L.find("th"),O=h.find("tbody"),P=O.find("tr"),Q=O.find("td"),R=Q.filter(":first-child"),S=P.eq(0).find("div.fc-day-content div"),W(L.add(L.find("tr"))),W(P),P.eq(0).addClass("fc-first"),n(Q),T=a("<div style='position:absolute;z-index:8;top:0;left:0'/>").appendTo(b)}function h(b){var c,d,e,f=b||1==$,g=K.start.getMonth(),h=l(new Date);f&&M.each(function(b,e){c=a(e),d=F(b),c.html(xb(d,pb)),X(c,d)}),Q.each(function(b,e){c=a(e),d=F(b),d.getMonth()==g?c.removeClass("fc-other-month"):c.addClass("fc-other-month"),+d==+h?c.addClass(kb+"-state-highlight fc-today"):c.removeClass(kb+"-state-highlight fc-today"),c.find("div.fc-day-number").text(d.getDate()),f&&X(c,d)}),P.each(function(b,c){e=a(c),$>b?(e.show(),b==$-1?e.addClass("fc-last"):e.removeClass("fc-last")):e.hide()})}function j(b){Y=b;var c,d,e,f=Y-L.height();"variable"==rb("weekMode")?c=d=Math.floor(f/(1==$?2:6)):(c=Math.floor(f/$),d=f-c*($-1)),R.each(function(b,f){$>b&&(e=a(f),N(e.find("> div"),(b==$-1?d:c)-J(e)))})}function k(a){U=a,cb.clear(),Z=Math.floor(U/_),D(M.slice(0,-1),Z)}function n(a){a.click(o).mousedown(wb)}function o(a){if(!rb("selectable")){var b=parseInt(this.className.match(/fc\-day(\d+)/)[1]),c=F(b);sb("dayClick",this,c,!0,a)}}function q(a,b,c){c&&ab.build();for(var d=m(K.visStart),e=i(m(d),_),f=0;$>f;f++){var g=new Date(Math.max(d,a)),h=new Date(Math.min(e,b));if(h>g){var j,k;eb?(j=p(h,d)*fb+gb+1,k=p(g,d)*fb+gb+1):(j=p(g,d),k=p(h,d)),n(r(f,j,f,k-1))}i(d,7),i(e,7)}}function r(a,c,d,e){var f=ab.rect(a,c,d,e,b);return ub(f,b)}function s(a){return m(a)}function t(a,b){q(a,i(m(b),1),!0)}function u(){vb()}function v(a,b,c){var d=B(a),e=Q[d.row*_+d.col];sb("dayClick",e,a,b,c)}function w(a,b){bb.start(function(a){vb(),a&&r(a.row,a.col,a.row,a.col)},b)}function x(a,b,c){var d=bb.stop();if(vb(),d){var e=C(d);sb("drop",a,e,!0,b,c)}}function y(a){return m(a.start)}function z(a){return cb.left(a)}function A(a){return cb.right(a)}function B(a){return{row:Math.floor(p(a,K.visStart)/7),col:G(a.getDay())}}function C(a){return E(a.row,a.col)}function E(a,b){return i(m(K.visStart),7*a+b*fb+gb)}function F(a){return E(Math.floor(a/_),a%_)}function G(a){return(a-Math.max(hb,ib)+_)%_*fb+gb}function H(a){return P.eq(a)}function I(){return{left:0,right:U}}var K=this;K.renderBasic=e,K.setHeight=j,K.setWidth=k,K.renderDayOverlay=q,K.defaultSelectionEnd=s,K.renderSelection=t,K.clearSelection=u,K.reportDayClick=v,K.dragStart=w,K.dragStop=x,K.defaultEventEnd=y,K.getHoverListener=function(){return bb},K.colContentLeft=z,K.colContentRight=A,K.dayOfWeekCol=G,K.dateCell=B,K.cellDate=C,K.cellIsAllDay=function(){return!0},K.allDayRow=H,K.allDayBounds=I,K.getRowCnt=function(){return $},K.getColCnt=function(){return _},K.getColWidth=function(){return Z},K.getDaySegmentContainer=function(){return T},jb.call(K,b,c,d),mb.call(K),lb.call(K),db.call(K);var L,M,O,P,Q,R,S,T,U,Y,Z,$,_,ab,bb,cb,eb,fb,gb,hb,ib,kb,pb,rb=K.opt,sb=K.trigger,tb=K.clearEvents,ub=K.renderOverlay,vb=K.clearOverlays,wb=K.daySelectionMousedown,xb=c.formatDate;V(b.addClass("fc-grid")),ab=new nb(function(b,c){var d,e,f;M.each(function(b,g){d=a(g),e=d.offset().left,b&&(f[1]=e),f=[e],c[b]=f}),f[1]=e+d.outerWidth(),P.each(function(c,g){$>c&&(d=a(g),e=d.offset().top,c&&(f[1]=e),f=[e],b[c]=f)}),f[1]=e+d.outerHeight()}),bb=new ob(ab),cb=new qb(function(a){return S.eq(a)})}function db(){function b(a,b){n(a),C(d(a),b)}function c(){o(),t().empty()}function d(b){var c,d,e,f,h,j,k=y(),l=z(),n=m(g.visStart),o=i(m(n),l),p=a.map(b,w),q=[];for(c=0;k>c;c++){for(d=B(A(b,p,n,o)),e=0;e<d.length;e++)for(f=d[e],h=0;h<f.length;h++)j=f[h],j.row=c,j.level=e,q.push(j);i(n,7),i(o,7)}return q}function e(a,b,c){k(a)&&f(a,b),c.isEnd&&l(a)&&D(a,b,c),p(a,b)}function f(a,b){var c,d=u();b.draggable({zIndex:9,delay:50,opacity:h("dragOpacity"),revertDuration:h("dragRevertDuration"),start:function(e,f){j("eventDragStart",b,a,e,f),r(a,b),d.start(function(d,e,f,g){b.draggable("option","revert",!d||!f&&!g),x(),d?(c=7*f+g*(h("isRTL")?-1:1),v(i(m(a.start),c),i(w(a),c))):c=0},e,"drag")},stop:function(e,f){d.stop(),x(),j("eventDragStop",b,a,e,f),c?s(this,a,c,0,a.allDay,e,f):(b.css("filter",""),q(a,b))}})}var g=this;g.renderEvents=b,g.compileDaySegs=d,g.clearEvents=c,g.bindDaySeg=e,kb.call(g);var h=g.opt,j=g.trigger,k=g.isEventDraggable,l=g.isEventResizable,n=g.reportEvents,o=g.reportEventClear,p=g.eventElementHandlers,q=g.showEvents,r=g.hideEvents,s=g.eventDrop,t=g.getDaySegmentContainer,u=g.getHoverListener,v=g.renderDayOverlay,x=g.clearOverlays,y=g.getRowCnt,z=g.getColCnt,C=g.renderDaySegs,D=g.resizableDayEvent}function eb(a,b){function c(a,b){b&&i(a,7*b);var c=i(m(a),-((a.getDay()-e("firstDay")+7)%7)),h=i(m(c),7),j=m(c),k=m(h),l=e("weekends");l||(o(j),o(k,-1,!0)),d.title=g(j,i(m(k),-1),e("titleFormat")),d.start=c,d.end=h,d.visStart=j,d.visEnd=k,f(l?7:5)}var d=this;d.render=c,gb.call(d,a,b,"agendaWeek");var e=d.opt,f=d.renderAgenda,g=b.formatDates}function fb(a,b){function c(a,b){b&&(i(a,b),e("weekends")||o(a,0>b?-1:1));var c=m(a,!0),h=i(m(c),1);d.title=g(a,e("titleFormat")),d.start=d.visStart=c,d.end=d.visEnd=h,f(1)}var d=this;d.render=c,gb.call(d,a,b,"agendaDay");var e=d.opt,f=d.renderAgenda,g=b.formatDate}function gb(c,d,e){function f(a){Ib=a,g(),ab?Yb():h(),j()}function g(){Nb=Wb("theme")?"ui":"fc",Pb=Wb("weekends")?0:1,Ob=Wb("firstDay"),(Qb=Wb("isRTL"))?(Rb=-1,Sb=Ib-1):(Rb=1,Sb=0),Tb=t(Wb("minTime")),Ub=t(Wb("maxTime")),Vb=Wb("columnFormat")}function h(){var b,d,e,f,g,h=Nb+"-widget-header",i=Nb+"-widget-content",j=Wb("slotMinutes")%15==0;for(b="<table style='width:100%' class='fc-agenda-days fc-border-separate' cellspacing='0'><thead><tr><th class='fc-agenda-axis "+h+"'>&nbsp;</th>",d=0;Ib>d;d++)b+="<th class='fc- fc-col"+d+" "+h+"'/>";for(b+="<th class='fc-agenda-gutter "+h+"'>&nbsp;</th></tr></thead><tbody><tr><th class='fc-agenda-axis "+h+"'>&nbsp;</th>",d=0;Ib>d;d++)b+="<td class='fc- fc-col"+d+" "+i+"'><div><div class='fc-day-content'><div style='position:relative'>&nbsp;</div></div></div></td>";for(b+="<td class='fc-agenda-gutter "+i+"'>&nbsp;</td></tr></tbody></table>",ab=a(b).appendTo(c),bb=ab.find("thead"),cb=bb.find("th").slice(1,-1),db=ab.find("tbody"),eb=db.find("td").slice(0,-1),fb=eb.find("div.fc-day-content div"),gb=eb.eq(0),ib=gb.find("> div"),W(bb.add(bb.find("tr"))),W(db.add(db.find("tr"))),yb=bb.find("th:first"),zb=ab.find(".fc-agenda-gutter"),kb=a("<div style='position:absolute;z-index:2;left:0;width:100%'/>").appendTo(c),Wb("allDaySlot")?(pb=a("<div style='position:absolute;z-index:8;top:0;left:0'/>").appendTo(kb),b="<table style='width:100%' class='fc-agenda-allday' cellspacing='0'><tr><th class='"+h+" fc-agenda-axis'>"+Wb("allDayText")+"</th><td><div class='fc-day-content'><div style='position:relative'/></div></td><th class='"+h+" fc-agenda-gutter'>&nbsp;</th></tr></table>",rb=a(b).appendTo(kb),sb=rb.find("tr"),v(sb.find("td")),yb=yb.add(rb.find("th:first")),zb=zb.add(rb.find("th.fc-agenda-gutter")),kb.append("<div class='fc-agenda-divider "+h+"'><div class='fc-agenda-divider-inner'/></div>")):pb=a([]),tb=a("<div style='position:absolute;width:100%;overflow-x:hidden;overflow-y:auto'/>").appendTo(kb),ub=a("<div style='position:relative;width:100%;overflow:hidden'/>").appendTo(tb),vb=a("<div style='position:absolute;z-index:8;top:0;left:0'/>").appendTo(ub),b="<table class='fc-agenda-slots' style='width:100%' cellspacing='0'><tbody>",e=n(),f=k(m(e),Ub),k(e,Tb),Jb=0,d=0;f>e;d++)g=e.getMinutes(),b+="<tr class='fc-slot"+d+" "+(g?"fc-minor":"")+"'><th class='fc-agenda-axis "+h+"'>"+(j&&g?"&nbsp;":dc(e,Wb("axisFormat")))+"</th><td class='"+i+"'><div style='position:relative'>&nbsp;</div></td></tr>",k(e,Wb("slotMinutes")),Jb++;b+="</tbody></table>",wb=a(b).appendTo(ub),xb=wb.find("div:first"),w(wb.find("td")),yb=yb.add(wb.find("th:first"))}function j(){var a,b,c,d,e=l(new Date);for(a=0;Ib>a;a++)d=H(a),b=cb.eq(a),b.html(dc(d,Vb)),c=eb.eq(a),+d==+e?c.addClass(Nb+"-state-highlight fc-today"):c.removeClass(Nb+"-state-highlight fc-today"),X(b.add(c),d)}function o(a,c){a===b&&(a=Cb),Cb=a,ec={};var d=db.position().top,e=tb.position().top,f=Math.min(a-d,wb.height()+e+1);ib.height(f-J(gb)),kb.css("top",d),tb.height(f-e-1),Gb=xb.height()+1,c&&r()}function q(b){Bb=b,Mb.clear(),Db=0,D(yb.width("").each(function(b,c){Db=Math.max(Db,a(c).outerWidth())}),Db);var c=tb[0].clientWidth;Fb=tb.width()-c,Fb?(D(zb,Fb),zb.show().prev().removeClass("fc-last")):zb.hide().prev().addClass("fc-last"),Eb=Math.floor((c-Db)/Ib),D(cb.slice(0,-1),Eb)}function r(){function a(){tb.scrollTop(d)}var b=n(),c=m(b);c.setHours(Wb("firstHour"));var d=L(b,c)+1;a(),setTimeout(a,0)}function s(){Hb=tb.scrollTop()}function u(){tb.scrollTop(Hb)}function v(a){a.click(x).mousedown(bc)}function w(a){a.click(x).mousedown(U)}function x(a){if(!Wb("selectable")){var b=Math.min(Ib-1,Math.floor((a.pageX-ab.offset().left-Db)/Eb)),c=H(b),d=this.parentNode.className.match(/fc-slot(\d+)/);if(d){var e=parseInt(d[1])*Wb("slotMinutes"),f=Math.floor(e/60);c.setHours(f),c.setMinutes(e%60+Tb),Xb("dayClick",eb[b],c,!1,a)}else Xb("dayClick",eb[b],c,!0,a)}}function y(a,b,c){c&&Kb.build();var d,e,f=m(_.visStart);Qb?(d=p(b,f)*Rb+Sb+1,e=p(a,f)*Rb+Sb+1):(d=p(a,f),e=p(b,f)),d=Math.max(0,d),e=Math.min(Ib,e),e>d&&v(z(0,d,0,e-1))}function z(a,b,c,d){var e=Kb.rect(a,b,c,d,kb);return Zb(e,kb)}function A(a,b){for(var c=m(_.visStart),d=i(m(c),1),e=0;Ib>e;e++){var f=new Date(Math.max(c,a)),g=new Date(Math.min(d,b));if(g>f){var h=e*Rb+Sb,j=Kb.rect(0,h,0,h,ub),k=L(c,f),l=L(c,g);j.top=k,j.height=l-k,w(Zb(j,ub))}i(c,1),i(d,1)}}function B(a){return Mb.left(a)}function C(a){return Mb.right(a)}function F(a){return{row:Math.floor(p(a,_.visStart)/7),col:K(a.getDay())}}function G(a){var b=H(a.col),c=a.row;return Wb("allDaySlot")&&c--,c>=0&&k(b,Tb+c*Wb("slotMinutes")),b}function H(a){return i(m(_.visStart),a*Rb+Sb)}function I(a){return Wb("allDaySlot")&&!a.row}function K(a){return(a-Math.max(Ob,Pb)+Ib)%Ib*Rb+Sb}function L(a,c){if(a=m(a,!0),c<k(m(a),Tb))return 0;if(c>=k(m(a),Ub))return wb.height();var d=Wb("slotMinutes"),e=60*c.getHours()+c.getMinutes()-Tb,f=Math.floor(e/d),g=ec[f];return g===b&&(g=ec[f]=wb.find("tr:eq("+f+") td div")[0].offsetTop),Math.max(0,Math.round(g-1+Gb*(e%d/d)))}function M(){return{left:Db,right:Bb-Fb}}function N(){return sb}function O(a){var b=m(a.start);return a.allDay?b:k(b,Wb("defaultEventMinutes"))}function Q(a,b){return b?m(a):k(m(a),Wb("slotMinutes"))}function R(a,b,c){c?Wb("allDaySlot")&&y(a,i(m(b),1),!0):S(a,b)}function S(b,c){var d=Wb("selectHelper");if(Kb.build(),d){var e=p(b,_.visStart)*Rb+Sb;if(e>=0&&Ib>e){var f=Kb.rect(0,e,0,e,ub),g=L(b,b),h=L(b,c);if(h>g){if(f.top=g,f.height=h-g,f.left+=2,f.width-=5,a.isFunction(d)){var i=d(b,c);i&&(f.position="absolute",f.zIndex=8,Ab=a(i).css(f).appendTo(ub))}else f.isStart=!0,f.isEnd=!0,Ab=a(cc({title:"",start:b,end:c,className:["fc-select-helper"],editable:!1},f)),Ab.css("opacity",Wb("dragOpacity"));Ab&&(w(Ab),ub.append(Ab),D(Ab,f.width,!0),E(Ab,f.height,!0))}}}else A(b,c)}function T(){$b(),Ab&&(Ab.remove(),Ab=null)}function U(b){if(1==b.which&&Wb("selectable")){ac(b);var c;Lb.start(function(a,b){if(T(),a&&a.col==b.col&&!I(a)){var d=G(b),e=G(a);c=[d,k(m(d),Wb("slotMinutes")),e,k(m(e),Wb("slotMinutes"))].sort(P),S(c[0],c[3])}else c=null},b),a(document).one("mouseup",function(a){Lb.stop(),c&&(+c[0]==+c[1]&&Y(c[0],!1,a),_b(c[0],c[3],!1,a))})}}function Y(a,b,c){Xb("dayClick",eb[K(a.getDay())],a,b,c)}function Z(a,b){Lb.start(function(a){if($b(),a)if(I(a))z(a.row,a.col,a.row,a.col);else{var b=G(a),c=k(m(b),Wb("defaultEventMinutes"));A(b,c)}},b)}function $(a,b,c){var d=Lb.stop();$b(),d&&Xb("drop",a,G(d),I(d),b,c)}var _=this;_.renderAgenda=f,_.setWidth=q,_.setHeight=o,_.beforeHide=s,_.afterShow=u,_.defaultEventEnd=O,_.timePosition=L,_.dayOfWeekCol=K,_.dateCell=F,_.cellDate=G,_.cellIsAllDay=I,_.allDayRow=N,_.allDayBounds=M,_.getHoverListener=function(){return Lb},_.colContentLeft=B,_.colContentRight=C,_.getDaySegmentContainer=function(){return pb},_.getSlotSegmentContainer=function(){return vb},_.getMinMinute=function(){return Tb},_.getMaxMinute=function(){return Ub},_.getBodyContent=function(){return ub},_.getRowCnt=function(){return 1},_.getColCnt=function(){return Ib},_.getColWidth=function(){return Eb},_.getSlotHeight=function(){return Gb},_.defaultSelectionEnd=Q,_.renderDayOverlay=y,_.renderSelection=R,_.clearSelection=T,_.reportDayClick=Y,_.dragStart=Z,_.dragStop=$,jb.call(_,c,d,e),mb.call(_),lb.call(_),hb.call(_);var ab,bb,cb,db,eb,fb,gb,ib,kb,pb,rb,sb,tb,ub,vb,wb,xb,yb,zb,Ab,Bb,Cb,Db,Eb,Fb,Gb,Hb,Ib,Jb,Kb,Lb,Mb,Nb,Ob,Pb,Qb,Rb,Sb,Tb,Ub,Vb,Wb=_.opt,Xb=_.trigger,Yb=_.clearEvents,Zb=_.renderOverlay,$b=_.clearOverlays,_b=_.reportSelection,ac=_.unselect,bc=_.daySelectionMousedown,cc=_.slotSegHtml,dc=d.formatDate,ec={};V(c.addClass("fc-agenda")),Kb=new nb(function(b,c){function d(a){return Math.max(i,Math.min(j,a))}var e,f,g;cb.each(function(b,d){e=a(d),f=e.offset().left,b&&(g[1]=f),g=[f],c[b]=g}),g[1]=f+e.outerWidth(),Wb("allDaySlot")&&(e=sb,f=e.offset().top,b[0]=[f,f+e.outerHeight()]);for(var h=ub.offset().top,i=tb.offset().top,j=i+tb.outerHeight(),k=0;Jb>k;k++)b.push([d(h+Gb*k),d(h+Gb*(k+1))])}),Lb=new ob(Kb),Mb=new qb(function(a){return fb.eq(a)})}function hb(){function c(a,b){y(a);var c,d=a.length,g=[],i=[];for(c=0;d>c;c++)a[c].allDay?g.push(a[c]):i.push(a[c]);s("allDaySlot")&&(Q(e(g),b),G()),h(f(i),b)}function d(){z(),H().empty(),I().empty()}function e(b){var c,d,e,f,g=B(A(b,a.map(b,w),r.visStart,r.visEnd)),h=g.length,i=[];for(c=0;h>c;c++)for(d=g[c],e=0;e<d.length;e++)f=d[e],f.row=0,f.level=c,i.push(f);return i}function f(b){var c,d,e,f,h,j,l=S(),n=M(),o=L(),p=k(m(r.visStart),n),q=a.map(b,g),s=[];for(c=0;l>c;c++){for(d=B(A(b,q,p,k(m(p),o-n))),ib(d),e=0;e<d.length;e++)for(f=d[e],h=0;h<f.length;h++)j=f[h],j.col=c,j.level=e,s.push(j);i(p,1,!0)}return s}function g(a){return a.end?m(a.end):k(m(a.start),s("defaultEventMinutes"))}function h(c,d){var e,f,g,h,i,k,l,m,o,p,q,r,u,v,w,x,y,z,A,B,D,E,G=c.length,H="",K={},L={},M=I(),Q=S();for((B=s("isRTL"))?(D=-1,E=Q-1):(D=1,E=0),e=0;G>e;e++)f=c[e],g=f.event,h=N(f.start,f.start),i=N(f.start,f.end),k=f.col,l=f.level,m=f.forward||0,o=O(k*D+E),p=P(k*D+E)-o,p=Math.min(p-6,.95*p),q=l?p/(l+m+1):m?2*(p/(m+1)-6):p,r=o+p/(l+m+1)*l*D+(B?p-q:0),f.top=h,f.left=r,f.outerWidth=q,f.outerHeight=i-h,H+=j(g,f);for(M[0].innerHTML=H,u=M.children(),e=0;G>e;e++)f=c[e],g=f.event,v=a(u[e]),w=t("eventRender",g,g,v),w===!1?v.remove():(w&&w!==!0&&(v.remove(),v=a(w).css({position:"absolute",top:f.top,left:f.left}).appendTo(M)),f.element=v,g._id===d?n(g,v,f):v[0]._fci=e,Z(g,v));for(C(M,c,n),e=0;G>e;e++)f=c[e],(v=f.element)&&(y=K[x=f.key=U(v[0])],f.vsides=y===b?K[x]=J(v,!0):y,y=L[x],f.hsides=y===b?L[x]=F(v,!0):y,z=v.find("div.fc-event-content"),z.length&&(f.contentTop=z[0].offsetTop));for(e=0;G>e;e++)f=c[e],(v=f.element)&&(v[0].style.width=Math.max(0,f.outerWidth-f.hsides)+"px",A=Math.max(0,f.outerHeight-f.vsides),v[0].style.height=A+"px",g=f.event,f.contentTop!==b&&A-f.contentTop<10&&(v.find("div.fc-event-time").text(fb(g.start,s("timeFormat"))+" - "+g.title),v.find("div.fc-event-title").remove()),t("eventAfterRender",g,g,v))
}function j(a,b){var c="<",d=a.url,e=Y(a,s),f=e?" style='"+e+"'":"",g=["fc-event","fc-event-skin","fc-event-vert"];return u(a)&&g.push("fc-event-draggable"),b.isStart&&g.push("fc-corner-top"),b.isEnd&&g.push("fc-corner-bottom"),g=g.concat(a.className),a.source&&(g=g.concat(a.source.className||[])),c+=d?"a href='"+T(a.url)+"'":"div",c+=" class='"+g.join(" ")+"' style='position:absolute;z-index:8;top:"+b.top+"px;left:"+b.left+"px;"+e+"'><div class='fc-event-inner fc-event-skin'"+f+"><div class='fc-event-head fc-event-skin'"+f+"><div class='fc-event-time'>"+T(gb(a.start,a.end,s("timeFormat")))+"</div></div><div class='fc-event-content'><div class='fc-event-title'>"+T(a.title)+"</div></div><div class='fc-event-bg'></div></div>",b.isEnd&&v(a)&&(c+="<div class='ui-resizable-handle ui-resizable-s'>=</div>"),c+="</"+(d?"a":"div")+">"}function l(a,b,c){u(a)&&o(a,b,c.isStart),c.isEnd&&v(a)&&R(a,b,c),D(a,b)}function n(a,b,c){var d=b.find("div.fc-event-time");u(a)&&p(a,b,d),c.isEnd&&v(a)&&q(a,b,d),D(a,b)}function o(a,b,c){function d(){h||(b.width(e).height("").draggable("option","grid",null),h=!0)}var e,f,g,h=!0,j=s("isRTL")?-1:1,k=K(),l=V(),n=W(),o=M();b.draggable({zIndex:9,opacity:s("dragOpacity","month"),revertDuration:s("dragRevertDuration"),start:function(o,p){t("eventDragStart",b,a,o,p),_(a,b),e=b.width(),k.start(function(e,k,o,p){db(),e?(f=!1,g=p*j,e.row?c?h&&(b.width(l-10),E(b,n*Math.round((a.end?(a.end-a.start)/Ab:s("defaultEventMinutes"))/s("slotMinutes"))),b.draggable("option","grid",[l,1]),h=!1):f=!0:(cb(i(m(a.start),g),i(w(a),g)),d()),f=f||h&&!g):(d(),f=!0),b.draggable("option","revert",f)},o,"drag")},stop:function(c,e){if(k.stop(),db(),t("eventDragStop",b,a,c,e),f)d(),b.css("filter",""),$(a,b);else{var i=0;h||(i=Math.round((b.offset().top-X().offset().top)/n)*s("slotMinutes")+o-(60*a.start.getHours()+a.start.getMinutes())),ab(this,a,g,i,h,c,e)}}})}function p(a,b,c){function d(b){var d,e=k(m(a.start),b);a.end&&(d=k(m(a.end),b)),c.text(gb(e,d,s("timeFormat")))}function e(){l&&(c.css("display",""),b.draggable("option","grid",[q,r]),l=!1)}var f,g,h,j,l=!1,n=s("isRTL")?-1:1,o=K(),p=S(),q=V(),r=W();b.draggable({zIndex:9,scroll:!1,grid:[q,r],axis:1==p?"y":!1,opacity:s("dragOpacity"),revertDuration:s("dragRevertDuration"),start:function(d,k){t("eventDragStart",b,a,d,k),_(a,b),f=b.position(),h=j=0,o.start(function(d,f,h,j){b.draggable("option","revert",!d),db(),d&&(g=j*n,s("allDaySlot")&&!d.row?(l||(l=!0,c.hide(),b.draggable("option","grid",null)),cb(i(m(a.start),g),i(w(a),g))):e())},d,"drag")},drag:function(a,b){h=Math.round((b.position.top-f.top)/r)*s("slotMinutes"),h!=j&&(l||d(h),j=h)},stop:function(c,i){var j=o.stop();db(),t("eventDragStop",b,a,c,i),j&&(g||h||l)?ab(this,a,g,l?0:h,l,c,i):(e(),b.css("filter",""),b.css(f),d(0),$(a,b))}})}function q(a,b,c){var d,e,f=W();b.resizable({handles:{s:"div.ui-resizable-s"},grid:f,start:function(c,f){d=e=0,_(a,b),b.css("z-index",9),t("eventResizeStart",this,a,c,f)},resize:function(g,h){d=Math.round((Math.max(f,b.height())-h.originalSize.height)/f),d!=e&&(c.text(gb(a.start,d||a.end?k(x(a),s("slotMinutes")*d):null,s("timeFormat"))),e=d)},stop:function(c,e){t("eventResizeStop",this,a,c,e),d?bb(this,a,0,s("slotMinutes")*d,c,e):(b.css("z-index",8),$(a,b))}})}var r=this;r.renderEvents=c,r.compileDaySegs=e,r.clearEvents=d,r.slotSegHtml=j,r.bindDaySeg=l,kb.call(r);var s=r.opt,t=r.trigger,u=r.isEventDraggable,v=r.isEventResizable,x=r.eventEnd,y=r.reportEvents,z=r.reportEventClear,D=r.eventElementHandlers,G=r.setHeight,H=r.getDaySegmentContainer,I=r.getSlotSegmentContainer,K=r.getHoverListener,L=r.getMaxMinute,M=r.getMinMinute,N=r.timePosition,O=r.colContentLeft,P=r.colContentRight,Q=r.renderDaySegs,R=r.resizableDayEvent,S=r.getColCnt,V=r.getColWidth,W=r.getSlotHeight,X=r.getBodyContent,Z=r.reportEventElement,$=r.showEvents,_=r.hideEvents,ab=r.eventDrop,bb=r.eventResize,cb=r.renderDayOverlay,db=r.clearOverlays,eb=r.calendar,fb=eb.formatDate,gb=eb.formatDates}function ib(a){var b,c,d,e,f,g;for(b=a.length-1;b>0;b--)for(e=a[b],c=0;c<e.length;c++)for(f=e[c],d=0;d<a[b-1].length;d++)g=a[b-1][d],z(f,g)&&(g.forward=Math.max(g.forward||0,(f.forward||0)+1))}function jb(a,c,d){function e(a,b){var c=F[a];return"object"==typeof c?S(c,b||d):c}function f(a,b){return c.trigger.apply(c,[a,b||y].concat(Array.prototype.slice.call(arguments,2),[y]))}function g(a){return j(a)&&!e("disableDragging")}function h(a){return j(a)&&!e("disableResizing")}function j(a){return $(a.editable,(a.source||{}).editable,e("editable"))}function l(a){C={};var b,c,d=a.length;for(b=0;d>b;b++)c=a[b],C[c._id]?C[c._id].push(c):C[c._id]=[c]}function n(a){return a.end?m(a.end):z(a)}function o(a,b){D.push(b),E[a._id]?E[a._id].push(b):E[a._id]=[b]}function p(){D=[],E={}}function q(a,b){b.click(function(c){return b.hasClass("ui-draggable-dragging")||b.hasClass("ui-resizable-resizing")?void 0:f("eventClick",this,a,c)}).hover(function(b){f("eventMouseover",this,a,b)},function(b){f("eventMouseout",this,a,b)})}function r(a,b){t(a,b,"show")}function s(a,b){t(a,b,"hide")}function t(a,b,c){var d,e=E[a._id],f=e.length;for(d=0;f>d;d++)b&&e[d][0]==b[0]||e[d][c]()}function u(a,b,c,d,e,g,h){var i=b.allDay,j=b._id;w(C[j],c,d,e),f("eventDrop",a,b,c,d,e,function(){w(C[j],-c,-d,i),B(j)},g,h),B(j)}function v(a,b,c,d,e,g){var h=b._id;x(C[h],c,d),f("eventResize",a,b,c,d,function(){x(C[h],-c,-d),B(h)},e,g),B(h)}function w(a,c,d,e){d=d||0;for(var f,g=a.length,h=0;g>h;h++)f=a[h],e!==b&&(f.allDay=e),k(i(f.start,c,!0),d),f.end&&(f.end=k(i(f.end,c,!0),d)),A(f,F)}function x(a,b,c){c=c||0;for(var d,e=a.length,f=0;e>f;f++)d=a[f],d.end=k(i(n(d),b,!0),c),A(d,F)}var y=this;y.element=a,y.calendar=c,y.name=d,y.opt=e,y.trigger=f,y.isEventDraggable=g,y.isEventResizable=h,y.reportEvents=l,y.eventEnd=n,y.reportEventElement=o,y.reportEventClear=p,y.eventElementHandlers=q,y.showEvents=r,y.hideEvents=s,y.eventDrop=u,y.eventResize=v;var z=y.defaultEventEnd,A=c.normalizeEvent,B=c.reportEventChange,C={},D=[],E={},F=c.options}function kb(){function c(a,b){var c,d,i,m,q,r,s,t,u=N(),v=B(),w=D(),x=0,y=a.length;for(u[0].innerHTML=e(a),f(a,u.children()),g(a),h(a,u,b),j(a),k(a),l(a),c=n(),d=0;v>d;d++){for(i=0,m=[],q=0;w>q;q++)m[q]=0;for(;y>x&&(r=a[x]).row==d;){for(s=Q(m.slice(r.startCol,r.endCol)),r.top=s,s+=r.outerHeight,t=r.startCol;t<r.endCol;t++)m[t]=s;x++}c[d].height(Q(m))}p(a,o(c))}function d(b,c,d){var g,h,i,m=a("<div/>"),q=N(),r=b.length;for(m[0].innerHTML=e(b),g=m.children(),q.append(g),f(b,g),j(b),k(b),l(b),p(b,o(n())),g=[],h=0;r>h;h++)i=b[h].element,i&&(b[h].row===c&&i.css("top",d),g.push(i[0]));return a(g)}function e(a){var b,c,d,e,f,g,h,i,j,k,l=s("isRTL"),m=a.length,n=G(),o=n.left,p=n.right,q="";for(b=0;m>b;b++)c=a[b],d=c.event,f=["fc-event","fc-event-skin","fc-event-hori"],u(d)&&f.push("fc-event-draggable"),l?(c.isStart&&f.push("fc-corner-right"),c.isEnd&&f.push("fc-corner-left"),g=J(c.end.getDay()-1),h=J(c.start.getDay()),i=c.isEnd?H(g):o,j=c.isStart?I(h):p):(c.isStart&&f.push("fc-corner-left"),c.isEnd&&f.push("fc-corner-right"),g=J(c.start.getDay()),h=J(c.end.getDay()-1),i=c.isStart?H(g):o,j=c.isEnd?I(h):p),f=f.concat(d.className),d.source&&(f=f.concat(d.source.className||[])),e=d.url,k=Y(d,s),q+=e?"<a href='"+T(e)+"'":"<div",q+=" class='"+f.join(" ")+"' style='position:absolute;z-index:8;left:"+i+"px;"+k+"'><div class='fc-event-inner fc-event-skin'"+(k?" style='"+k+"'":"")+">",!d.allDay&&c.isStart&&(q+="<span class='fc-event-time'>"+T(P(d.start,d.end,s("timeFormat")))+"</span>"),q+="<span class='fc-event-title'>"+T(d.title)+"</span></div>",c.isEnd&&v(d)&&(q+="<div class='ui-resizable-handle ui-resizable-"+(l?"w":"e")+"'>&nbsp;&nbsp;&nbsp;</div>"),q+="</"+(e?"a":"div")+">",c.left=i,c.outerWidth=j-i,c.startCol=g,c.endCol=h+1;return q}function f(b,c){var d,e,f,g,h,i=b.length;for(d=0;i>d;d++)e=b[d],f=e.event,g=a(c[d]),h=t("eventRender",f,f,g),h===!1?g.remove():(h&&h!==!0&&(h=a(h).css({position:"absolute",left:e.left}),g.replaceWith(h),g=h),e.element=g)}function g(a){var b,c,d,e=a.length;for(b=0;e>b;b++)c=a[b],d=c.element,d&&x(c.event,d)}function h(a,b,c){var d,e,f,g,h=a.length;for(d=0;h>d;d++)e=a[d],f=e.element,f&&(g=e.event,g._id===c?O(g,f,e):f[0]._fci=d);C(b,a,O)}function j(a){var c,d,e,f,g,h=a.length,i={};for(c=0;h>c;c++)d=a[c],e=d.element,e&&(f=d.key=U(e[0]),g=i[f],g===b&&(g=i[f]=F(e,!0)),d.hsides=g)}function k(a){var b,c,d,e=a.length;for(b=0;e>b;b++)c=a[b],d=c.element,d&&(d[0].style.width=Math.max(0,c.outerWidth-c.hsides)+"px")}function l(a){var c,d,e,f,g,h=a.length,i={};for(c=0;h>c;c++)d=a[c],e=d.element,e&&(f=d.key,g=i[f],g===b&&(g=i[f]=L(e)),d.outerHeight=e[0].offsetHeight+g)}function n(){var a,b=B(),c=[];for(a=0;b>a;a++)c[a]=E(a).find("td:first div.fc-day-content > div");return c}function o(a){var b,c=a.length,d=[];for(b=0;c>b;b++)d[b]=a[b][0].offsetTop;return d}function p(a,b){var c,d,e,f,g=a.length;for(c=0;g>c;c++)d=a[c],e=d.element,e&&(e[0].style.top=b[d.row]+(d.top||0)+"px",f=d.event,t("eventAfterRender",f,f,e))}function q(b,c,e){var f=s("isRTL"),g=f?"w":"e",h=c.find("div.ui-resizable-"+g),j=!1;V(c),c.mousedown(function(a){a.preventDefault()}).click(function(a){j&&(a.preventDefault(),a.stopImmediatePropagation())}),h.mousedown(function(h){function k(c){t("eventResizeStop",this,b,c),a("body").css("cursor",""),o.stop(),S(),l&&A(this,b,l,0,c),setTimeout(function(){j=!1},0)}if(1==h.which){j=!0;var l,n,o=r.getHoverListener(),p=B(),q=D(),s=f?-1:1,u=f?q-1:0,v=c.css("top"),x=a.extend({},b),C=K(b.start);W(),a("body").css("cursor",g+"-resize").one("mouseup",k),t("eventResizeStart",this,b,h),o.start(function(a,c){if(a){var h=Math.max(C.row,a.row),j=a.col;1==p&&(h=0),h==C.row&&(j=f?Math.min(C.col,j):Math.max(C.col,j)),l=7*h+j*s+u-(7*c.row+c.col*s+u);var k=i(w(b),l,!0);if(l){x.end=k;var o=n;n=d(M([x]),e.row,v),n.find("*").css("cursor",g+"-resize"),o&&o.remove(),z(b)}else n&&(y(b),n.remove(),n=null);S(),R(b.start,i(m(k),1))}},h)}})}var r=this;r.renderDaySegs=c,r.resizableDayEvent=q;var s=r.opt,t=r.trigger,u=r.isEventDraggable,v=r.isEventResizable,w=r.eventEnd,x=r.reportEventElement,y=r.showEvents,z=r.hideEvents,A=r.eventResize,B=r.getRowCnt,D=r.getColCnt,E=(r.getColWidth,r.allDayRow),G=r.allDayBounds,H=r.colContentLeft,I=r.colContentRight,J=r.dayOfWeekCol,K=r.dateCell,M=r.compileDaySegs,N=r.getDaySegmentContainer,O=r.bindDaySeg,P=r.calendar.formatDates,R=r.renderDayOverlay,S=r.clearOverlays,W=r.clearSelection}function lb(){function b(a,b,e){c(),b||(b=i(a,e)),j(a,b,e),d(a,b,e)}function c(a){l&&(l=!1,k(),h("unselect",null,a))}function d(a,b,c,d){l=!0,h("select",null,a,b,c,d)}function e(b){var e=f.cellDate,h=f.cellIsAllDay,i=f.getHoverListener(),l=f.reportDayClick;if(1==b.which&&g("selectable")){c(b);var m;i.start(function(a,b){k(),a&&h(a)?(m=[e(b),e(a)].sort(P),j(m[0],m[1],!0)):m=null},b),a(document).one("mouseup",function(a){i.stop(),m&&(+m[0]==+m[1]&&l(m[0],!0,a),d(m[0],m[1],!0,a))})}}var f=this;f.select=b,f.unselect=c,f.reportSelection=d,f.daySelectionMousedown=e;var g=f.opt,h=f.trigger,i=f.defaultSelectionEnd,j=f.renderSelection,k=f.clearSelection,l=!1;g("selectable")&&g("unselectAuto")&&a(document).mousedown(function(b){var d=g("unselectCancel");d&&a(b.target).parents(d).length||c(b)})}function mb(){function b(b,c){var d=f.shift();return d||(d=a("<div class='fc-cell-overlay' style='position:absolute;z-index:3'/>")),d[0].parentNode!=c[0]&&d.appendTo(c),e.push(d.css(b).show()),d}function c(){for(var a;a=e.shift();)f.push(a.hide().unbind())}var d=this;d.renderOverlay=b,d.clearOverlays=c;var e=[],f=[]}function nb(a){var b,c,d=this;d.build=function(){b=[],c=[],a(b,c)},d.cell=function(a,d){var e,f=b.length,g=c.length,h=-1,i=-1;for(e=0;f>e;e++)if(d>=b[e][0]&&d<b[e][1]){h=e;break}for(e=0;g>e;e++)if(a>=c[e][0]&&a<c[e][1]){i=e;break}return h>=0&&i>=0?{row:h,col:i}:null},d.rect=function(a,d,e,f,g){var h=g.offset();return{top:b[a][0]-h.top,left:c[d][0]-h.left,width:c[f][1]-c[d][0],height:b[e][1]-b[a][0]}}}function ob(b){function c(a){pb(a);var c=b.cell(a.pageX,a.pageY);(!c!=!g||c&&(c.row!=g.row||c.col!=g.col))&&(c?(f||(f=c),e(c,f,c.row-f.row,c.col-f.col)):e(c,f),g=c)}var d,e,f,g,h=this;h.start=function(h,i,j){e=h,f=g=null,b.build(),c(i),d=j||"mousemove",a(document).bind(d,c)},h.stop=function(){return a(document).unbind(d,c),g}}function pb(a){a.pageX===b&&(a.pageX=a.originalEvent.pageX,a.pageY=a.originalEvent.pageY)}function qb(a){function c(b){return e[b]=e[b]||a(b)}var d=this,e={},f={},g={};d.left=function(a){return f[a]=f[a]===b?c(a).position().left:f[a]},d.right=function(a){return g[a]=g[a]===b?d.left(a)+c(a).width():g[a]},d.clear=function(){e={},f={},g={}}}var rb={defaultView:"month",aspectRatio:1.35,header:{left:"title",center:"",right:"today prev,next"},weekends:!0,allDayDefault:!0,ignoreTimezone:!0,lazyFetching:!0,startParam:"start",endParam:"end",titleFormat:{month:"MMMM yyyy",week:"MMM d[ yyyy]{ '&#8212;'[ MMM] d yyyy}",day:"dddd, MMM d, yyyy"},columnFormat:{month:"ddd",week:"ddd M/d",day:"dddd M/d"},timeFormat:{"":"h(:mm)t"},isRTL:!1,firstDay:0,monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],buttonText:{prev:"&nbsp;&#9668;&nbsp;",next:"&nbsp;&#9658;&nbsp;",prevYear:"&nbsp;&lt;&lt;&nbsp;",nextYear:"&nbsp;&gt;&gt;&nbsp;",today:"today",month:"month",week:"week",day:"day"},theme:!1,buttonIcons:{prev:"circle-triangle-w",next:"circle-triangle-e"},unselectAuto:!0,dropAccept:"*"},sb={header:{left:"next,prev today",center:"",right:"title"},buttonText:{prev:"&nbsp;&#9658;&nbsp;",next:"&nbsp;&#9668;&nbsp;",prevYear:"&nbsp;&gt;&gt;&nbsp;",nextYear:"&nbsp;&lt;&lt;&nbsp;"},buttonIcons:{prev:"circle-triangle-e",next:"circle-triangle-w"}},tb=a.fullCalendar={version:"1.5.4"},ub=tb.views={};a.fn.fullCalendar=function(c){if("string"==typeof c){var e,f=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a.data(this,"fullCalendar");if(d&&a.isFunction(d[c])){var g=d[c].apply(d,f);e===b&&(e=g),"destroy"==c&&a.removeData(this,"fullCalendar")}}),e!==b?e:this}var g=c.eventSources||[];return delete c.eventSources,c.events&&(g.push(c.events),delete c.events),c=a.extend(!0,{},rb,c.isRTL||c.isRTL===b&&rb.isRTL?sb:{},c),this.each(function(b,e){var f=a(e),h=new d(f,c,g);f.data("fullCalendar",h),h.render()}),this},tb.sourceNormalizers=[],tb.sourceFetchers=[];var vb={dataType:"json",cache:!1},wb=1;tb.addDays=i,tb.cloneDate=m,tb.parseDate=r,tb.parseISO8601=s,tb.parseTime=t,tb.formatDate=u,tb.formatDates=v;var xb=["sun","mon","tue","wed","thu","fri","sat"],yb=864e5,zb=36e5,Ab=6e4,Bb={s:function(a){return a.getSeconds()},ss:function(a){return R(a.getSeconds())},m:function(a){return a.getMinutes()},mm:function(a){return R(a.getMinutes())},h:function(a){return a.getHours()%12||12},hh:function(a){return R(a.getHours()%12||12)},H:function(a){return a.getHours()},HH:function(a){return R(a.getHours())},d:function(a){return a.getDate()},dd:function(a){return R(a.getDate())},ddd:function(a,b){return b.dayNamesShort[a.getDay()]},dddd:function(a,b){return b.dayNames[a.getDay()]},M:function(a){return a.getMonth()+1},MM:function(a){return R(a.getMonth()+1)},MMM:function(a,b){return b.monthNamesShort[a.getMonth()]},MMMM:function(a,b){return b.monthNames[a.getMonth()]},yy:function(a){return(a.getFullYear()+"").substring(2)},yyyy:function(a){return a.getFullYear()},t:function(a){return a.getHours()<12?"a":"p"},tt:function(a){return a.getHours()<12?"am":"pm"},T:function(a){return a.getHours()<12?"A":"P"},TT:function(a){return a.getHours()<12?"AM":"PM"},u:function(a){return u(a,"yyyy-MM-dd'T'HH:mm:ss'Z'")},S:function(a){var b=a.getDate();return b>10&&20>b?"th":["st","nd","rd"][b%10-1]||"th"}};tb.applyAll=Z,ub.month=_,ub.basicWeek=ab,ub.basicDay=bb,c({weekMode:"fixed"}),ub.agendaWeek=eb,ub.agendaDay=fb,c({allDaySlot:!0,allDayText:"all-day",firstHour:6,slotMinutes:30,defaultEventMinutes:120,axisFormat:"h(:mm)tt",timeFormat:{agenda:"h:mm{ - h:mm}"},dragOpacity:{agenda:.5},minTime:0,maxTime:24})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a){a.extend(a.fn,{validate:function(b){if(!this.length)return void(b&&b.debug&&window.console&&console.warn("Nothing selected, can't validate, returning nothing."));var c=a.data(this[0],"validator");return c?c:(this.attr("novalidate","novalidate"),c=new a.validator(b,this[0]),a.data(this[0],"validator",c),c.settings.onsubmit&&(this.validateDelegate(":submit","click",function(b){c.settings.submitHandler&&(c.submitButton=b.target),a(b.target).hasClass("cancel")&&(c.cancelSubmit=!0)}),this.submit(function(b){function d(){var d;return c.settings.submitHandler?(c.submitButton&&(d=a("<input type='hidden'/>").attr("name",c.submitButton.name).val(c.submitButton.value).appendTo(c.currentForm)),c.settings.submitHandler.call(c,c.currentForm,b),c.submitButton&&d.remove(),!1):!0}return c.settings.debug&&b.preventDefault(),c.cancelSubmit?(c.cancelSubmit=!1,d()):c.form()?c.pendingRequest?(c.formSubmitted=!0,!1):d():(c.focusInvalid(),!1)})),c)},valid:function(){if(a(this[0]).is("form"))return this.validate().form();var b=!0,c=a(this[0].form).validate();return this.each(function(){b&=c.element(this)}),b},removeAttrs:function(b){var c={},d=this;return a.each(b.split(/\s/),function(a,b){c[b]=d.attr(b),d.removeAttr(b)}),c},rules:function(b,c){var d=this[0];if(b){var e=a.data(d.form,"validator").settings,f=e.rules,g=a.validator.staticRules(d);switch(b){case"add":a.extend(g,a.validator.normalizeRule(c)),f[d.name]=g,c.messages&&(e.messages[d.name]=a.extend(e.messages[d.name],c.messages));break;case"remove":if(!c)return delete f[d.name],g;var h={};return a.each(c.split(/\s/),function(a,b){h[b]=g[b],delete g[b]}),h}}var i=a.validator.normalizeRules(a.extend({},a.validator.classRules(d),a.validator.attributeRules(d),a.validator.dataRules(d),a.validator.staticRules(d)),d);if(i.required){var j=i.required;delete i.required,i=a.extend({required:j},i)}return i}}),a.extend(a.expr[":"],{blank:function(b){return!a.trim(""+b.value)},filled:function(b){return!!a.trim(""+b.value)},unchecked:function(a){return!a.checked}}),a.validator=function(b,c){this.settings=a.extend(!0,{},a.validator.defaults,b),this.currentForm=c,this.init()},a.validator.format=function(b,c){return 1===arguments.length?function(){var c=a.makeArray(arguments);return c.unshift(b),a.validator.format.apply(this,c)}:(arguments.length>2&&c.constructor!==Array&&(c=a.makeArray(arguments).slice(1)),c.constructor!==Array&&(c=[c]),a.each(c,function(a,c){b=b.replace(new RegExp("\\{"+a+"\\}","g"),function(){return c})}),b)},a.extend(a.validator,{defaults:{messages:{},groups:{},rules:{},errorClass:"invalid",validClass:"valid",errorElement:"em",focusInvalid:!0,errorContainer:a([]),errorLabelContainer:a([]),onsubmit:!0,ignore:":hidden",ignoreTitle:!1,onfocusin:function(a){this.lastActive=a,this.settings.focusCleanup&&!this.blockFocusCleanup&&(this.settings.unhighlight&&this.settings.unhighlight.call(this,a,this.settings.errorClass,this.settings.validClass),this.addWrapper(this.errorsFor(a)).hide())},onfocusout:function(a){this.checkable(a)||!(a.name in this.submitted)&&this.optional(a)||this.element(a)},onkeyup:function(a,b){(9!==b.which||""!==this.elementValue(a))&&(a.name in this.submitted||a===this.lastElement)&&this.element(a)},onclick:function(a){a.name in this.submitted?this.element(a):a.parentNode.name in this.submitted&&this.element(a.parentNode)},highlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).addClass(c).removeClass(d).parent().addClass("state-error").removeClass("state-success"):a(b).addClass(c).removeClass(d).parent().addClass("state-error").removeClass("state-success")},unhighlight:function(b,c,d){"radio"===b.type?this.findByName(b.name).removeClass(c).addClass(d).parent().addClass("state-success").removeClass("state-error"):a(b).removeClass(c).addClass(d).parent().addClass("state-success").removeClass("state-error")}},setDefaults:function(b){a.extend(a.validator.defaults,b)},messages:{required:"This field is required",remote:"Please fix this field",email:"Please enter a valid email address",url:"Please enter a valid URL",date:"Please enter a valid date",dateISO:"Please enter a valid date (ISO)",number:"Please enter a valid number",digits:"Please enter only digits",creditcard:"Please enter a valid credit card number",equalTo:"Please enter the same value again",maxlength:a.validator.format("Please enter no more than {0} characters"),minlength:a.validator.format("Please enter at least {0} characters"),rangelength:a.validator.format("Please enter a value between {0} and {1} characters long"),range:a.validator.format("Please enter a value between {0} and {1}"),max:a.validator.format("Please enter a value less than or equal to {0}"),min:a.validator.format("Please enter a value greater than or equal to {0}")},autoCreateRanges:!1,prototype:{init:function(){function b(b){var c=a.data(this[0].form,"validator"),d="on"+b.type.replace(/^validate/,"");c.settings[d]&&c.settings[d].call(c,this[0],b)}this.labelContainer=a(this.settings.errorLabelContainer),this.errorContext=this.labelContainer.length&&this.labelContainer||a(this.currentForm),this.containers=a(this.settings.errorContainer).add(this.settings.errorLabelContainer),this.submitted={},this.valueCache={},this.pendingRequest=0,this.pending={},this.invalid={},this.reset();var c=this.groups={};a.each(this.settings.groups,function(b,d){"string"==typeof d&&(d=d.split(/\s/)),a.each(d,function(a,d){c[d]=b})});var d=this.settings.rules;a.each(d,function(b,c){d[b]=a.validator.normalizeRule(c)}),a(this.currentForm).validateDelegate(":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'] ,[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'] ","focusin focusout keyup",b).validateDelegate("[type='radio'], [type='checkbox'], select, option","click",b),this.settings.invalidHandler&&a(this.currentForm).bind("invalid-form.validate",this.settings.invalidHandler)},form:function(){return this.checkForm(),a.extend(this.submitted,this.errorMap),this.invalid=a.extend({},this.errorMap),this.valid()||a(this.currentForm).triggerHandler("invalid-form",[this]),this.showErrors(),this.valid()},checkForm:function(){this.prepareForm();for(var a=0,b=this.currentElements=this.elements();b[a];a++)this.check(b[a]);return this.valid()},element:function(b){b=this.validationTargetFor(this.clean(b)),this.lastElement=b,this.prepareElement(b),this.currentElements=a(b);var c=this.check(b)!==!1;return c?delete this.invalid[b.name]:this.invalid[b.name]=!0,this.numberOfInvalids()||(this.toHide=this.toHide.add(this.containers)),this.showErrors(),c},showErrors:function(b){if(b){a.extend(this.errorMap,b),this.errorList=[];for(var c in b)this.errorList.push({message:b[c],element:this.findByName(c)[0]});this.successList=a.grep(this.successList,function(a){return!(a.name in b)})}this.settings.showErrors?this.settings.showErrors.call(this,this.errorMap,this.errorList):this.defaultShowErrors()},resetForm:function(){a.fn.resetForm&&a(this.currentForm).resetForm(),this.submitted={},this.lastElement=null,this.prepareForm(),this.hideErrors(),this.elements().removeClass(this.settings.errorClass).removeData("previousValue")},numberOfInvalids:function(){return this.objectLength(this.invalid)},objectLength:function(a){var b=0;for(var c in a)b++;return b},hideErrors:function(){this.addWrapper(this.toHide).hide()},valid:function(){return 0===this.size()},size:function(){return this.errorList.length},focusInvalid:function(){if(this.settings.focusInvalid)try{a(this.findLastActive()||this.errorList.length&&this.errorList[0].element||[]).filter(":visible").focus().trigger("focusin")}catch(b){}},findLastActive:function(){var b=this.lastActive;return b&&1===a.grep(this.errorList,function(a){return a.element.name===b.name}).length&&b},elements:function(){var b=this,c={};return a(this.currentForm).find("input, select, textarea").not(":submit, :reset, :image, [disabled]").not(this.settings.ignore).filter(function(){return!this.name&&b.settings.debug&&window.console&&console.error("%o has no name assigned",this),this.name in c||!b.objectLength(a(this).rules())?!1:(c[this.name]=!0,!0)})},clean:function(b){return a(b)[0]},errors:function(){var b=this.settings.errorClass.replace(" ",".");return a(this.settings.errorElement+"."+b,this.errorContext)},reset:function(){this.successList=[],this.errorList=[],this.errorMap={},this.toShow=a([]),this.toHide=a([]),this.currentElements=a([])},prepareForm:function(){this.reset(),this.toHide=this.errors().add(this.containers)},prepareElement:function(a){this.reset(),this.toHide=this.errorsFor(a)},elementValue:function(b){var c=a(b).attr("type"),d=a(b).val();return"radio"===c||"checkbox"===c?a("input[name='"+a(b).attr("name")+"']:checked").val():"string"==typeof d?d.replace(/\r/g,""):d},check:function(b){b=this.validationTargetFor(this.clean(b));var c,d=a(b).rules(),e=!1,f=this.elementValue(b);for(var g in d){var h={method:g,parameters:d[g]};try{if(c=a.validator.methods[g].call(this,f,b,h.parameters),"dependency-mismatch"===c){e=!0;continue}if(e=!1,"pending"===c)return void(this.toHide=this.toHide.not(this.errorsFor(b)));if(!c)return this.formatAndAdd(b,h),!1}catch(i){throw this.settings.debug&&window.console&&console.log("Exception occured when checking element "+b.id+", check the '"+h.method+"' method.",i),i}}return e?void 0:(this.objectLength(d)&&this.successList.push(b),!0)},customDataMessage:function(b,c){return a(b).data("msg-"+c.toLowerCase())||b.attributes&&a(b).attr("data-msg-"+c.toLowerCase())},customMessage:function(a,b){var c=this.settings.messages[a];return c&&(c.constructor===String?c:c[b])},findDefined:function(){for(var a=0;a<arguments.length;a++)if(void 0!==arguments[a])return arguments[a];return void 0},defaultMessage:function(b,c){return this.findDefined(this.customMessage(b.name,c),this.customDataMessage(b,c),!this.settings.ignoreTitle&&b.title||void 0,a.validator.messages[c],"<strong>Warning: No message defined for "+b.name+"</strong>")},formatAndAdd:function(b,c){var d=this.defaultMessage(b,c.method),e=/\$?\{(\d+)\}/g;"function"==typeof d?d=d.call(this,c.parameters,b):e.test(d)&&(d=a.validator.format(d.replace(e,"{$1}"),c.parameters)),this.errorList.push({message:d,element:b}),this.errorMap[b.name]=d,this.submitted[b.name]=d},addWrapper:function(a){return this.settings.wrapper&&(a=a.add(a.parent(this.settings.wrapper))),a},defaultShowErrors:function(){var a,b;for(a=0;this.errorList[a];a++){var c=this.errorList[a];this.settings.highlight&&this.settings.highlight.call(this,c.element,this.settings.errorClass,this.settings.validClass),this.showLabel(c.element,c.message)}if(this.errorList.length&&(this.toShow=this.toShow.add(this.containers)),this.settings.success)for(a=0;this.successList[a];a++)this.showLabel(this.successList[a]);if(this.settings.unhighlight)for(a=0,b=this.validElements();b[a];a++)this.settings.unhighlight.call(this,b[a],this.settings.errorClass,this.settings.validClass);this.toHide=this.toHide.not(this.toShow),this.hideErrors(),this.addWrapper(this.toShow).show()},validElements:function(){return this.currentElements.not(this.invalidElements())},invalidElements:function(){return a(this.errorList).map(function(){return this.element})},showLabel:function(b,c){var d=this.errorsFor(b);d.length?(d.removeClass(this.settings.validClass).addClass(this.settings.errorClass),d.html(c)):(d=a("<"+this.settings.errorElement+">").attr("for",this.idOrName(b)).addClass(this.settings.errorClass).html(c||""),this.settings.wrapper&&(d=d.hide().show().wrap("<"+this.settings.wrapper+"/>").parent()),this.labelContainer.append(d).length||(this.settings.errorPlacement?this.settings.errorPlacement(d,a(b)):d.insertAfter(b))),!c&&this.settings.success&&(d.text(""),"string"==typeof this.settings.success?d.addClass(this.settings.success):this.settings.success(d,b)),this.toShow=this.toShow.add(d)},errorsFor:function(b){var c=this.idOrName(b);return this.errors().filter(function(){return a(this).attr("for")===c})},idOrName:function(a){return this.groups[a.name]||(this.checkable(a)?a.name:a.id||a.name)},validationTargetFor:function(a){return this.checkable(a)&&(a=this.findByName(a.name).not(this.settings.ignore)[0]),a},checkable:function(a){return/radio|checkbox/i.test(a.type)},findByName:function(b){return a(this.currentForm).find("[name='"+b+"']")},getLength:function(b,c){switch(c.nodeName.toLowerCase()){case"select":return a("option:selected",c).length;case"input":if(this.checkable(c))return this.findByName(c.name).filter(":checked").length}return b.length},depend:function(a,b){return this.dependTypes[typeof a]?this.dependTypes[typeof a](a,b):!0},dependTypes:{"boolean":function(a){return a},string:function(b,c){return!!a(b,c.form).length},"function":function(a,b){return a(b)}},optional:function(b){var c=this.elementValue(b);return!a.validator.methods.required.call(this,c,b)&&"dependency-mismatch"},startRequest:function(a){this.pending[a.name]||(this.pendingRequest++,this.pending[a.name]=!0)},stopRequest:function(b,c){this.pendingRequest--,this.pendingRequest<0&&(this.pendingRequest=0),delete this.pending[b.name],c&&0===this.pendingRequest&&this.formSubmitted&&this.form()?(a(this.currentForm).submit(),this.formSubmitted=!1):!c&&0===this.pendingRequest&&this.formSubmitted&&(a(this.currentForm).triggerHandler("invalid-form",[this]),this.formSubmitted=!1)},previousValue:function(b){return a.data(b,"previousValue")||a.data(b,"previousValue",{old:null,valid:!0,message:this.defaultMessage(b,"remote")})}},classRuleSettings:{required:{required:!0},email:{email:!0},url:{url:!0},date:{date:!0},dateISO:{dateISO:!0},number:{number:!0},digits:{digits:!0},creditcard:{creditcard:!0}},addClassRules:function(b,c){b.constructor===String?this.classRuleSettings[b]=c:a.extend(this.classRuleSettings,b)},classRules:function(b){var c={},d=a(b).attr("class");return d&&a.each(d.split(" "),function(){this in a.validator.classRuleSettings&&a.extend(c,a.validator.classRuleSettings[this])}),c},attributeRules:function(b){var c={},d=a(b);for(var e in a.validator.methods){var f;"required"===e?(f=d.get(0).getAttribute(e),""===f&&(f=!0),f=!!f):f=d.attr(e),f?c[e]=f:d[0].getAttribute("type")===e&&(c[e]=!0)}return c.maxlength&&/-1|2147483647|524288/.test(c.maxlength)&&delete c.maxlength,c},dataRules:function(b){var c,d,e={},f=a(b);for(c in a.validator.methods)d=f.data("rule-"+c.toLowerCase()),void 0!==d&&(e[c]=d);return e},staticRules:function(b){var c={},d=a.data(b.form,"validator");return d.settings.rules&&(c=a.validator.normalizeRule(d.settings.rules[b.name])||{}),c},normalizeRules:function(b,c){return a.each(b,function(d,e){if(e===!1)return void delete b[d];if(e.param||e.depends){var f=!0;switch(typeof e.depends){case"string":f=!!a(e.depends,c.form).length;break;case"function":f=e.depends.call(c,c)}f?b[d]=void 0!==e.param?e.param:!0:delete b[d]}}),a.each(b,function(d,e){b[d]=a.isFunction(e)?e(c):e}),a.each(["minlength","maxlength"],function(){b[this]&&(b[this]=Number(b[this]))}),a.each(["rangelength"],function(){var c;b[this]&&(a.isArray(b[this])?b[this]=[Number(b[this][0]),Number(b[this][1])]:"string"==typeof b[this]&&(c=b[this].split(/[\s,]+/),b[this]=[Number(c[0]),Number(c[1])]))}),a.validator.autoCreateRanges&&(b.min&&b.max&&(b.range=[b.min,b.max],delete b.min,delete b.max),b.minlength&&b.maxlength&&(b.rangelength=[b.minlength,b.maxlength],delete b.minlength,delete b.maxlength)),b},normalizeRule:function(b){if("string"==typeof b){var c={};a.each(b.split(/\s/),function(){c[this]=!0}),b=c}return b},addMethod:function(b,c,d){a.validator.methods[b]=c,a.validator.messages[b]=void 0!==d?d:a.validator.messages[b],c.length<3&&a.validator.addClassRules(b,a.validator.normalizeRule(b))},methods:{required:function(b,c,d){if(!this.depend(d,c))return"dependency-mismatch";if("select"===c.nodeName.toLowerCase()){var e=a(c).val();return e&&e.length>0}return this.checkable(c)?this.getLength(b,c)>0:a.trim(b).length>0},remote:function(b,c,d){if(this.optional(c))return"dependency-mismatch";var e=this.previousValue(c);if(this.settings.messages[c.name]||(this.settings.messages[c.name]={}),e.originalMessage=this.settings.messages[c.name].remote,this.settings.messages[c.name].remote=e.message,d="string"==typeof d&&{url:d}||d,e.old===b)return e.valid;e.old=b;var f=this;this.startRequest(c);var g={};return g[c.name]=b,a.ajax(a.extend(!0,{url:d,mode:"abort",port:"validate"+c.name,dataType:"json",data:g,success:function(d){f.settings.messages[c.name].remote=e.originalMessage;var g=d===!0||"true"===d;if(g){var h=f.formSubmitted;f.prepareElement(c),f.formSubmitted=h,f.successList.push(c),delete f.invalid[c.name],f.showErrors()}else{var i={},j=d||f.defaultMessage(c,"remote");i[c.name]=e.message=a.isFunction(j)?j(b):j,f.invalid[c.name]=!0,f.showErrors(i)}e.valid=g,f.stopRequest(c,g)}},d)),"pending"},minlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(a.trim(b),c);return this.optional(c)||e>=d},maxlength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(a.trim(b),c);return this.optional(c)||d>=e},rangelength:function(b,c,d){var e=a.isArray(b)?b.length:this.getLength(a.trim(b),c);return this.optional(c)||e>=d[0]&&e<=d[1]},min:function(a,b,c){return this.optional(b)||a>=c},max:function(a,b,c){return this.optional(b)||c>=a},range:function(a,b,c){return this.optional(b)||a>=c[0]&&a<=c[1]},email:function(a,b){return this.optional(b)||/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(a)},url:function(a,b){return this.optional(b)||/^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(a)},date:function(a,b){return this.optional(b)||!/Invalid|NaN/.test(new Date(a).toString())},dateISO:function(a,b){return this.optional(b)||/^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/.test(a)},number:function(a,b){return this.optional(b)||/^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(a)},digits:function(a,b){return this.optional(b)||/^\d+$/.test(a)},creditcard:function(a,b){if(this.optional(b))return"dependency-mismatch";if(/[^0-9 \-]+/.test(a))return!1;var c=0,d=0,e=!1;a=a.replace(/\D/g,"");for(var f=a.length-1;f>=0;f--){var g=a.charAt(f);d=parseInt(g,10),e&&(d*=2)>9&&(d-=9),c+=d,e=!e}return c%10===0},equalTo:function(b,c,d){var e=a(d);return this.settings.onfocusout&&e.unbind(".validate-equalTo").bind("blur.validate-equalTo",function(){a(c).valid()}),b===e.val()}}}),a.format=a.validator.format}(jQuery),function(a){var b={};if(a.ajaxPrefilter)a.ajaxPrefilter(function(a,c,d){var e=a.port;"abort"===a.mode&&(b[e]&&b[e].abort(),b[e]=d)});else{var c=a.ajax;a.ajax=function(d){var e=("mode"in d?d:a.ajaxSettings).mode,f=("port"in d?d:a.ajaxSettings).port;return"abort"===e?(b[f]&&b[f].abort(),b[f]=c.apply(this,arguments)):c.apply(this,arguments)}}}(jQuery),function(a){a.extend(a.fn,{validateDelegate:function(b,c,d){return this.bind(c,function(c){var e=a(c.target);return e.is(b)?d.apply(e,arguments):void 0})}})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a){function b(){var a=document.createElement("input"),b="onpaste";return a.setAttribute(b,""),"function"==typeof a[b]?"paste":"input"}var c,d=b()+".mask",e=navigator.userAgent,f=/iphone/i.test(e),g=/android/i.test(e);a.mask={definitions:{9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},dataName:"rawMaskFn",placeholder:"_"},a.fn.extend({caret:function(a,b){var c;if(0!==this.length&&!this.is(":hidden"))return"number"==typeof a?(b="number"==typeof b?b:a,this.each(function(){this.setSelectionRange?this.setSelectionRange(a,b):this.createTextRange&&(c=this.createTextRange(),c.collapse(!0),c.moveEnd("character",b),c.moveStart("character",a),c.select())})):(this[0].setSelectionRange?(a=this[0].selectionStart,b=this[0].selectionEnd):document.selection&&document.selection.createRange&&(c=document.selection.createRange(),a=0-c.duplicate().moveStart("character",-1e5),b=a+c.text.length),{begin:a,end:b})},unmask:function(){return this.trigger("unmask")},mask:function(b,e){var h,i,j,k,l,m;return!b&&this.length>0?(h=a(this[0]),h.data(a.mask.dataName)()):(e=a.extend({placeholder:a.mask.placeholder,completed:null},e),i=a.mask.definitions,j=[],k=m=b.length,l=null,a.each(b.split(""),function(a,b){"?"==b?(m--,k=a):i[b]?(j.push(new RegExp(i[b])),null===l&&(l=j.length-1)):j.push(null)}),this.trigger("unmask").each(function(){function h(a){for(;++a<m&&!j[a];);return a}function n(a){for(;--a>=0&&!j[a];);return a}function o(a,b){var c,d;if(!(0>a)){for(c=a,d=h(b);m>c;c++)if(j[c]){if(!(m>d&&j[c].test(w[d])))break;w[c]=w[d],w[d]=e.placeholder,d=h(d)}t(),v.caret(Math.max(l,a))}}function p(a){var b,c,d,f;for(b=a,c=e.placeholder;m>b;b++)if(j[b]){if(d=h(b),f=w[b],w[b]=c,!(m>d&&j[d].test(f)))break;c=f}}function q(a){var b,c,d,e=a.which;8===e||46===e||f&&127===e?(b=v.caret(),c=b.begin,d=b.end,d-c===0&&(c=46!==e?n(c):d=h(c-1),d=46===e?h(d):d),s(c,d),o(c,d-1),a.preventDefault()):27==e&&(v.val(x),v.caret(0,u()),a.preventDefault())}function r(b){var c,d,f,i=b.which,k=v.caret();b.ctrlKey||b.altKey||b.metaKey||32>i||i&&(k.end-k.begin!==0&&(s(k.begin,k.end),o(k.begin,k.end-1)),c=h(k.begin-1),m>c&&(d=String.fromCharCode(i),j[c].test(d)&&(p(c),w[c]=d,t(),f=h(c),g?setTimeout(a.proxy(a.fn.caret,v,f),0):v.caret(f),e.completed&&f>=m&&e.completed.call(v))),b.preventDefault())}function s(a,b){var c;for(c=a;b>c&&m>c;c++)j[c]&&(w[c]=e.placeholder)}function t(){v.val(w.join(""))}function u(a){var b,c,d=v.val(),f=-1;for(b=0,pos=0;m>b;b++)if(j[b]){for(w[b]=e.placeholder;pos++<d.length;)if(c=d.charAt(pos-1),j[b].test(c)){w[b]=c,f=b;break}if(pos>d.length)break}else w[b]===d.charAt(pos)&&b!==k&&(pos++,f=b);return a?t():k>f+1?(v.val(""),s(0,m)):(t(),v.val(v.val().substring(0,f+1))),k?b:l}var v=a(this),w=a.map(b.split(""),function(a){return"?"!=a?i[a]?e.placeholder:a:void 0}),x=v.val();v.data(a.mask.dataName,function(){return a.map(w,function(a,b){return j[b]&&a!=e.placeholder?a:null}).join("")}),v.attr("readonly")||v.one("unmask",function(){v.unbind(".mask").removeData(a.mask.dataName)}).bind("focus.mask",function(){clearTimeout(c);var a;x=v.val(),a=u(),c=setTimeout(function(){t(),a==b.length?v.caret(0,a):v.caret(a)},10)}).bind("blur.mask",function(){u(),v.val()!=x&&v.change()}).bind("keydown.mask",q).bind("keypress.mask",r).bind(d,function(){setTimeout(function(){var a=u(!0);v.caret(a),e.completed&&a==v.val().length&&e.completed.call(v)},0)}),u()}))}})}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(){if(!jQuery.browser){jQuery.browser={},jQuery.browser.mozilla=!1,jQuery.browser.webkit=!1,jQuery.browser.opera=!1,jQuery.browser.msie=!1;var a=navigator.userAgent;jQuery.browser.name=navigator.appName,jQuery.browser.fullVersion=""+parseFloat(navigator.appVersion),jQuery.browser.majorVersion=parseInt(navigator.appVersion,10);var b,c,d;-1!=(c=a.indexOf("Opera"))?(jQuery.browser.opera=!0,jQuery.browser.name="Opera",jQuery.browser.fullVersion=a.substring(c+6),-1!=(c=a.indexOf("Version"))&&(jQuery.browser.fullVersion=a.substring(c+8))):-1!=(c=a.indexOf("MSIE"))?(jQuery.browser.msie=!0,jQuery.browser.name="Microsoft Internet Explorer",jQuery.browser.fullVersion=a.substring(c+5)):-1!=(c=a.indexOf("Chrome"))?(jQuery.browser.webkit=!0,jQuery.browser.name="Chrome",jQuery.browser.fullVersion=a.substring(c+7)):-1!=(c=a.indexOf("Safari"))?(jQuery.browser.webkit=!0,jQuery.browser.name="Safari",jQuery.browser.fullVersion=a.substring(c+7),-1!=(c=a.indexOf("Version"))&&(jQuery.browser.fullVersion=a.substring(c+8))):-1!=(c=a.indexOf("Firefox"))?(jQuery.browser.mozilla=!0,jQuery.browser.name="Firefox",jQuery.browser.fullVersion=a.substring(c+8)):(b=a.lastIndexOf(" ")+1)<(c=a.lastIndexOf("/"))&&(jQuery.browser.name=a.substring(b,c),jQuery.browser.fullVersion=a.substring(c+1),jQuery.browser.name.toLowerCase()==jQuery.browser.name.toUpperCase()&&(jQuery.browser.name=navigator.appName)),-1!=(d=jQuery.browser.fullVersion.indexOf(";"))&&(jQuery.browser.fullVersion=jQuery.browser.fullVersion.substring(0,d)),-1!=(d=jQuery.browser.fullVersion.indexOf(" "))&&(jQuery.browser.fullVersion=jQuery.browser.fullVersion.substring(0,d)),jQuery.browser.majorVersion=parseInt(""+jQuery.browser.fullVersion,10),isNaN(jQuery.browser.majorVersion)&&(jQuery.browser.fullVersion=""+parseFloat(navigator.appVersion),jQuery.browser.majorVersion=parseInt(navigator.appVersion,10)),jQuery.browser.version=jQuery.browser.majorVersion}}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a){"undefined"==typeof a.fn.each2&&a.extend(a.fn,{each2:function(b){for(var c=a([0]),d=-1,e=this.length;++d<e&&(c.context=c[0]=this[d])&&b.call(c[0],d,c)!==!1;);return this}})}(jQuery),function(a,b){"use strict";function c(b){var c=a(document.createTextNode(""));b.before(c),c.before(b),c.remove()}function d(a){function b(a){return O[a]||a}return a.replace(/[^\u0000-\u007E]/g,b)}function e(a,b){for(var c=0,d=b.length;d>c;c+=1)if(g(a,b[c]))return c;return-1}function f(){var b=a(N);b.appendTo("body");var c={width:b.width()-b[0].clientWidth,height:b.height()-b[0].clientHeight};return b.remove(),c}function g(a,c){return a===c?!0:a===b||c===b?!1:null===a||null===c?!1:a.constructor===String?a+""==c+"":c.constructor===String?c+""==a+"":!1}function h(b,c){var d,e,f;if(null===b||b.length<1)return[];for(d=b.split(c),e=0,f=d.length;f>e;e+=1)d[e]=a.trim(d[e]);return d}function i(a){return a.outerWidth(!1)-a.width()}function j(c){var d="keyup-change-value";c.on("keydown",function(){a.data(c,d)===b&&a.data(c,d,c.val())}),c.on("keyup",function(){var e=a.data(c,d);e!==b&&c.val()!==e&&(a.removeData(c,d),c.trigger("keyup-change"))})}function k(c){c.on("mousemove",function(c){var d=M;(d===b||d.x!==c.pageX||d.y!==c.pageY)&&a(c.target).trigger("mousemove-filtered",c)})}function l(a,c,d){d=d||b;var e;return function(){var b=arguments;window.clearTimeout(e),e=window.setTimeout(function(){c.apply(d,b)},a)}}function m(a,b){var c=l(a,function(a){b.trigger("scroll-debounced",a)});b.on("scroll",function(a){e(a.target,b.get())>=0&&c(a)})}function n(a){a[0]!==document.activeElement&&window.setTimeout(function(){var b,c=a[0],d=a.val().length;a.focus();var e=c.offsetWidth>0||c.offsetHeight>0;e&&c===document.activeElement&&(c.setSelectionRange?c.setSelectionRange(d,d):c.createTextRange&&(b=c.createTextRange(),b.collapse(!1),b.select()))},0)}function o(b){b=a(b)[0];var c=0,d=0;if("selectionStart"in b)c=b.selectionStart,d=b.selectionEnd-c;else if("selection"in document){b.focus();var e=document.selection.createRange();d=document.selection.createRange().text.length,e.moveStart("character",-b.value.length),c=e.text.length-d}return{offset:c,length:d}}function p(a){a.preventDefault(),a.stopPropagation()}function q(a){a.preventDefault(),a.stopImmediatePropagation()}function r(b){if(!J){var c=b[0].currentStyle||window.getComputedStyle(b[0],null);J=a(document.createElement("div")).css({position:"absolute",left:"-10000px",top:"-10000px",display:"none",fontSize:c.fontSize,fontFamily:c.fontFamily,fontStyle:c.fontStyle,fontWeight:c.fontWeight,letterSpacing:c.letterSpacing,textTransform:c.textTransform,whiteSpace:"nowrap"}),J.attr("class","select2-sizer"),a("body").append(J)}return J.text(b.val()),J.width()}function s(b,c,d){var e,f,g=[];e=b.attr("class"),e&&(e=""+e,a(e.split(" ")).each2(function(){0===this.indexOf("select2-")&&g.push(this)})),e=c.attr("class"),e&&(e=""+e,a(e.split(" ")).each2(function(){0!==this.indexOf("select2-")&&(f=d(this),f&&g.push(f))})),b.attr("class",g.join(" "))}function t(a,b,c,e){var f=d(a.toUpperCase()).indexOf(d(b.toUpperCase())),g=b.length;return 0>f?void c.push(e(a)):(c.push(e(a.substring(0,f))),c.push("<span class='select2-match'>"),c.push(e(a.substring(f,f+g))),c.push("</span>"),void c.push(e(a.substring(f+g,a.length))))}function u(a){var b={"\\":"&#92;","&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#47;"};return String(a).replace(/[&<>"'\/\\]/g,function(a){return b[a]})}function v(c){var d,e=null,f=c.quietMillis||100,g=c.url,h=this;return function(i){window.clearTimeout(d),d=window.setTimeout(function(){var d=c.data,f=g,j=c.transport||a.fn.select2.ajaxDefaults.transport,k={type:c.type||"GET",cache:c.cache||!1,jsonpCallback:c.jsonpCallback||b,dataType:c.dataType||"json"},l=a.extend({},a.fn.select2.ajaxDefaults.params,k);d=d?d.call(h,i.term,i.page,i.context):null,f="function"==typeof f?f.call(h,i.term,i.page,i.context):f,e&&"function"==typeof e.abort&&e.abort(),c.params&&(a.isFunction(c.params)?a.extend(l,c.params.call(h)):a.extend(l,c.params)),a.extend(l,{url:f,dataType:c.dataType,data:d,success:function(a){var b=c.results(a,i.page);i.callback(b)}}),e=j.call(h,l)},f)}}function w(b){var c,d,e=b,f=function(a){return""+a.text};a.isArray(e)&&(d=e,e={results:d}),a.isFunction(e)===!1&&(d=e,e=function(){return d});var g=e();return g.text&&(f=g.text,a.isFunction(f)||(c=g.text,f=function(a){return a[c]})),function(b){var c,d=b.term,g={results:[]};return""===d?void b.callback(e()):(c=function(e,g){var h,i;if(e=e[0],e.children){h={};for(i in e)e.hasOwnProperty(i)&&(h[i]=e[i]);h.children=[],a(e.children).each2(function(a,b){c(b,h.children)}),(h.children.length||b.matcher(d,f(h),e))&&g.push(h)}else b.matcher(d,f(e),e)&&g.push(e)},a(e().results).each2(function(a,b){c(b,g.results)}),void b.callback(g))}}function x(c){var d=a.isFunction(c);return function(e){var f=e.term,g={results:[]},h=d?c(e):c;a.isArray(h)&&(a(h).each(function(){var a=this.text!==b,c=a?this.text:this;(""===f||e.matcher(f,c))&&g.results.push(a?this:{id:this,text:this})}),e.callback(g))}}function y(b,c){if(a.isFunction(b))return!0;if(!b)return!1;if("string"==typeof b)return!0;throw new Error(c+" must be a string, function, or falsy value")}function z(b){if(a.isFunction(b)){var c=Array.prototype.slice.call(arguments,1);return b.apply(null,c)}return b}function A(b){var c=0;return a.each(b,function(a,b){b.children?c+=A(b.children):c++}),c}function B(a,c,d,e){var f,h,i,j,k,l=a,m=!1;if(!e.createSearchChoice||!e.tokenSeparators||e.tokenSeparators.length<1)return b;for(;;){for(h=-1,i=0,j=e.tokenSeparators.length;j>i&&(k=e.tokenSeparators[i],h=a.indexOf(k),!(h>=0));i++);if(0>h)break;if(f=a.substring(0,h),a=a.substring(h+k.length),f.length>0&&(f=e.createSearchChoice.call(this,f,c),f!==b&&null!==f&&e.id(f)!==b&&null!==e.id(f))){for(m=!1,i=0,j=c.length;j>i;i++)if(g(e.id(f),e.id(c[i]))){m=!0;break}m||d(f)}}return l!==a?a:void 0}function C(){var a=this;Array.prototype.forEach.call(arguments,function(b){a[b].remove(),a[b]=null})}function D(b,c){var d=function(){};return d.prototype=new b,d.prototype.constructor=d,d.prototype.parent=b.prototype,d.prototype=a.extend(d.prototype,c),d}if(window.Select2===b){var E,F,G,H,I,J,K,L,M={x:0,y:0},E={TAB:9,ENTER:13,ESC:27,SPACE:32,LEFT:37,UP:38,RIGHT:39,DOWN:40,SHIFT:16,CTRL:17,ALT:18,PAGE_UP:33,PAGE_DOWN:34,HOME:36,END:35,BACKSPACE:8,DELETE:46,isArrow:function(a){switch(a=a.which?a.which:a){case E.LEFT:case E.RIGHT:case E.UP:case E.DOWN:return!0}return!1},isControl:function(a){var b=a.which;switch(b){case E.SHIFT:case E.CTRL:case E.ALT:return!0}return a.metaKey?!0:!1},isFunctionKey:function(a){return a=a.which?a.which:a,a>=112&&123>=a}},N="<div class='select2-measure-scrollbar'></div>",O={"Ⓐ":"A",Ａ:"A",À:"A",Á:"A",Â:"A",Ầ:"A",Ấ:"A",Ẫ:"A",Ẩ:"A",Ã:"A",Ā:"A",Ă:"A",Ằ:"A",Ắ:"A",Ẵ:"A",Ẳ:"A",Ȧ:"A",Ǡ:"A",Ä:"A",Ǟ:"A",Ả:"A",Å:"A",Ǻ:"A",Ǎ:"A",Ȁ:"A",Ȃ:"A",Ạ:"A",Ậ:"A",Ặ:"A",Ḁ:"A",Ą:"A",Ⱥ:"A",Ɐ:"A",Ꜳ:"AA",Æ:"AE",Ǽ:"AE",Ǣ:"AE",Ꜵ:"AO",Ꜷ:"AU",Ꜹ:"AV",Ꜻ:"AV",Ꜽ:"AY","Ⓑ":"B",Ｂ:"B",Ḃ:"B",Ḅ:"B",Ḇ:"B",Ƀ:"B",Ƃ:"B",Ɓ:"B","Ⓒ":"C",Ｃ:"C",Ć:"C",Ĉ:"C",Ċ:"C",Č:"C",Ç:"C",Ḉ:"C",Ƈ:"C",Ȼ:"C",Ꜿ:"C","Ⓓ":"D",Ｄ:"D",Ḋ:"D",Ď:"D",Ḍ:"D",Ḑ:"D",Ḓ:"D",Ḏ:"D",Đ:"D",Ƌ:"D",Ɗ:"D",Ɖ:"D",Ꝺ:"D",Ǳ:"DZ",Ǆ:"DZ",ǲ:"Dz",ǅ:"Dz","Ⓔ":"E",Ｅ:"E",È:"E",É:"E",Ê:"E",Ề:"E",Ế:"E",Ễ:"E",Ể:"E",Ẽ:"E",Ē:"E",Ḕ:"E",Ḗ:"E",Ĕ:"E",Ė:"E",Ë:"E",Ẻ:"E",Ě:"E",Ȅ:"E",Ȇ:"E",Ẹ:"E",Ệ:"E",Ȩ:"E",Ḝ:"E",Ę:"E",Ḙ:"E",Ḛ:"E",Ɛ:"E",Ǝ:"E","Ⓕ":"F",Ｆ:"F",Ḟ:"F",Ƒ:"F",Ꝼ:"F","Ⓖ":"G",Ｇ:"G",Ǵ:"G",Ĝ:"G",Ḡ:"G",Ğ:"G",Ġ:"G",Ǧ:"G",Ģ:"G",Ǥ:"G",Ɠ:"G","Ꞡ":"G",Ᵹ:"G",Ꝿ:"G","Ⓗ":"H",Ｈ:"H",Ĥ:"H",Ḣ:"H",Ḧ:"H",Ȟ:"H",Ḥ:"H",Ḩ:"H",Ḫ:"H",Ħ:"H",Ⱨ:"H",Ⱶ:"H","Ɥ":"H","Ⓘ":"I",Ｉ:"I",Ì:"I",Í:"I",Î:"I",Ĩ:"I",Ī:"I",Ĭ:"I",İ:"I",Ï:"I",Ḯ:"I",Ỉ:"I",Ǐ:"I",Ȉ:"I",Ȋ:"I",Ị:"I",Į:"I",Ḭ:"I",Ɨ:"I","Ⓙ":"J",Ｊ:"J",Ĵ:"J",Ɉ:"J","Ⓚ":"K",Ｋ:"K",Ḱ:"K",Ǩ:"K",Ḳ:"K",Ķ:"K",Ḵ:"K",Ƙ:"K",Ⱪ:"K",Ꝁ:"K",Ꝃ:"K",Ꝅ:"K","Ꞣ":"K","Ⓛ":"L",Ｌ:"L",Ŀ:"L",Ĺ:"L",Ľ:"L",Ḷ:"L",Ḹ:"L",Ļ:"L",Ḽ:"L",Ḻ:"L",Ł:"L",Ƚ:"L",Ɫ:"L",Ⱡ:"L",Ꝉ:"L",Ꝇ:"L",Ꞁ:"L",Ǉ:"LJ",ǈ:"Lj","Ⓜ":"M",Ｍ:"M",Ḿ:"M",Ṁ:"M",Ṃ:"M",Ɱ:"M",Ɯ:"M","Ⓝ":"N",Ｎ:"N",Ǹ:"N",Ń:"N",Ñ:"N",Ṅ:"N",Ň:"N",Ṇ:"N",Ņ:"N",Ṋ:"N",Ṉ:"N",Ƞ:"N",Ɲ:"N","Ꞑ":"N","Ꞥ":"N",Ǌ:"NJ",ǋ:"Nj","Ⓞ":"O",Ｏ:"O",Ò:"O",Ó:"O",Ô:"O",Ồ:"O",Ố:"O",Ỗ:"O",Ổ:"O",Õ:"O",Ṍ:"O",Ȭ:"O",Ṏ:"O",Ō:"O",Ṑ:"O",Ṓ:"O",Ŏ:"O",Ȯ:"O",Ȱ:"O",Ö:"O",Ȫ:"O",Ỏ:"O",Ő:"O",Ǒ:"O",Ȍ:"O",Ȏ:"O",Ơ:"O",Ờ:"O",Ớ:"O",Ỡ:"O",Ở:"O",Ợ:"O",Ọ:"O",Ộ:"O",Ǫ:"O",Ǭ:"O",Ø:"O",Ǿ:"O",Ɔ:"O",Ɵ:"O",Ꝋ:"O",Ꝍ:"O",Ƣ:"OI",Ꝏ:"OO",Ȣ:"OU","Ⓟ":"P",Ｐ:"P",Ṕ:"P",Ṗ:"P",Ƥ:"P",Ᵽ:"P",Ꝑ:"P",Ꝓ:"P",Ꝕ:"P","Ⓠ":"Q",Ｑ:"Q",Ꝗ:"Q",Ꝙ:"Q",Ɋ:"Q","Ⓡ":"R",Ｒ:"R",Ŕ:"R",Ṙ:"R",Ř:"R",Ȑ:"R",Ȓ:"R",Ṛ:"R",Ṝ:"R",Ŗ:"R",Ṟ:"R",Ɍ:"R",Ɽ:"R",Ꝛ:"R","Ꞧ":"R",Ꞃ:"R","Ⓢ":"S",Ｓ:"S",ẞ:"S",Ś:"S",Ṥ:"S",Ŝ:"S",Ṡ:"S",Š:"S",Ṧ:"S",Ṣ:"S",Ṩ:"S",Ș:"S",Ş:"S","Ȿ":"S","Ꞩ":"S",Ꞅ:"S","Ⓣ":"T",Ｔ:"T",Ṫ:"T",Ť:"T",Ṭ:"T",Ț:"T",Ţ:"T",Ṱ:"T",Ṯ:"T",Ŧ:"T",Ƭ:"T",Ʈ:"T",Ⱦ:"T",Ꞇ:"T",Ꜩ:"TZ","Ⓤ":"U",Ｕ:"U",Ù:"U",Ú:"U",Û:"U",Ũ:"U",Ṹ:"U",Ū:"U",Ṻ:"U",Ŭ:"U",Ü:"U",Ǜ:"U",Ǘ:"U",Ǖ:"U",Ǚ:"U",Ủ:"U",Ů:"U",Ű:"U",Ǔ:"U",Ȕ:"U",Ȗ:"U",Ư:"U",Ừ:"U",Ứ:"U",Ữ:"U",Ử:"U",Ự:"U",Ụ:"U",Ṳ:"U",Ų:"U",Ṷ:"U",Ṵ:"U",Ʉ:"U","Ⓥ":"V",Ｖ:"V",Ṽ:"V",Ṿ:"V",Ʋ:"V",Ꝟ:"V",Ʌ:"V",Ꝡ:"VY","Ⓦ":"W",Ｗ:"W",Ẁ:"W",Ẃ:"W",Ŵ:"W",Ẇ:"W",Ẅ:"W",Ẉ:"W",Ⱳ:"W","Ⓧ":"X",Ｘ:"X",Ẋ:"X",Ẍ:"X","Ⓨ":"Y",Ｙ:"Y",Ỳ:"Y",Ý:"Y",Ŷ:"Y",Ỹ:"Y",Ȳ:"Y",Ẏ:"Y",Ÿ:"Y",Ỷ:"Y",Ỵ:"Y",Ƴ:"Y",Ɏ:"Y",Ỿ:"Y","Ⓩ":"Z",Ｚ:"Z",Ź:"Z",Ẑ:"Z",Ż:"Z",Ž:"Z",Ẓ:"Z",Ẕ:"Z",Ƶ:"Z",Ȥ:"Z","Ɀ":"Z",Ⱬ:"Z",Ꝣ:"Z","ⓐ":"a",ａ:"a",ẚ:"a",à:"a",á:"a",â:"a",ầ:"a",ấ:"a",ẫ:"a",ẩ:"a",ã:"a",ā:"a",ă:"a",ằ:"a",ắ:"a",ẵ:"a",ẳ:"a",ȧ:"a",ǡ:"a",ä:"a",ǟ:"a",ả:"a",å:"a",ǻ:"a",ǎ:"a",ȁ:"a",ȃ:"a",ạ:"a",ậ:"a",ặ:"a",ḁ:"a",ą:"a",ⱥ:"a",ɐ:"a",ꜳ:"aa",æ:"ae",ǽ:"ae",ǣ:"ae",ꜵ:"ao",ꜷ:"au",ꜹ:"av",ꜻ:"av",ꜽ:"ay","ⓑ":"b",ｂ:"b",ḃ:"b",ḅ:"b",ḇ:"b",ƀ:"b",ƃ:"b",ɓ:"b","ⓒ":"c",ｃ:"c",ć:"c",ĉ:"c",ċ:"c",č:"c",ç:"c",ḉ:"c",ƈ:"c",ȼ:"c",ꜿ:"c",ↄ:"c","ⓓ":"d",ｄ:"d",ḋ:"d",ď:"d",ḍ:"d",ḑ:"d",ḓ:"d",ḏ:"d",đ:"d",ƌ:"d",ɖ:"d",ɗ:"d",ꝺ:"d",ǳ:"dz",ǆ:"dz","ⓔ":"e",ｅ:"e",è:"e",é:"e",ê:"e",ề:"e",ế:"e",ễ:"e",ể:"e",ẽ:"e",ē:"e",ḕ:"e",ḗ:"e",ĕ:"e",ė:"e",ë:"e",ẻ:"e",ě:"e",ȅ:"e",ȇ:"e",ẹ:"e",ệ:"e",ȩ:"e",ḝ:"e",ę:"e",ḙ:"e",ḛ:"e",ɇ:"e",ɛ:"e",ǝ:"e","ⓕ":"f",ｆ:"f",ḟ:"f",ƒ:"f",ꝼ:"f","ⓖ":"g",ｇ:"g",ǵ:"g",ĝ:"g",ḡ:"g",ğ:"g",ġ:"g",ǧ:"g",ģ:"g",ǥ:"g",ɠ:"g","ꞡ":"g",ᵹ:"g",ꝿ:"g","ⓗ":"h",ｈ:"h",ĥ:"h",ḣ:"h",ḧ:"h",ȟ:"h",ḥ:"h",ḩ:"h",ḫ:"h",ẖ:"h",ħ:"h",ⱨ:"h",ⱶ:"h",ɥ:"h",ƕ:"hv","ⓘ":"i",ｉ:"i",ì:"i",í:"i",î:"i",ĩ:"i",ī:"i",ĭ:"i",ï:"i",ḯ:"i",ỉ:"i",ǐ:"i",ȉ:"i",ȋ:"i",ị:"i",į:"i",ḭ:"i",ɨ:"i",ı:"i","ⓙ":"j",ｊ:"j",ĵ:"j",ǰ:"j",ɉ:"j","ⓚ":"k",ｋ:"k",ḱ:"k",ǩ:"k",ḳ:"k",ķ:"k",ḵ:"k",ƙ:"k",ⱪ:"k",ꝁ:"k",ꝃ:"k",ꝅ:"k","ꞣ":"k","ⓛ":"l",ｌ:"l",ŀ:"l",ĺ:"l",ľ:"l",ḷ:"l",ḹ:"l",ļ:"l",ḽ:"l",ḻ:"l",ſ:"l",ł:"l",ƚ:"l",ɫ:"l",ⱡ:"l",ꝉ:"l",ꞁ:"l",ꝇ:"l",ǉ:"lj","ⓜ":"m",ｍ:"m",ḿ:"m",ṁ:"m",ṃ:"m",ɱ:"m",ɯ:"m","ⓝ":"n",ｎ:"n",ǹ:"n",ń:"n",ñ:"n",ṅ:"n",ň:"n",ṇ:"n",ņ:"n",ṋ:"n",ṉ:"n",ƞ:"n",ɲ:"n",ŉ:"n","ꞑ":"n","ꞥ":"n",ǌ:"nj","ⓞ":"o",ｏ:"o",ò:"o",ó:"o",ô:"o",ồ:"o",ố:"o",ỗ:"o",ổ:"o",õ:"o",ṍ:"o",ȭ:"o",ṏ:"o",ō:"o",ṑ:"o",ṓ:"o",ŏ:"o",ȯ:"o",ȱ:"o",ö:"o",ȫ:"o",ỏ:"o",ő:"o",ǒ:"o",ȍ:"o",ȏ:"o",ơ:"o",ờ:"o",ớ:"o",ỡ:"o",ở:"o",ợ:"o",ọ:"o",ộ:"o",ǫ:"o",ǭ:"o",ø:"o",ǿ:"o",ɔ:"o",ꝋ:"o",ꝍ:"o",ɵ:"o",ƣ:"oi",ȣ:"ou",ꝏ:"oo","ⓟ":"p",ｐ:"p",ṕ:"p",ṗ:"p",ƥ:"p",ᵽ:"p",ꝑ:"p",ꝓ:"p",ꝕ:"p","ⓠ":"q",ｑ:"q",ɋ:"q",ꝗ:"q",ꝙ:"q","ⓡ":"r",ｒ:"r",ŕ:"r",ṙ:"r",ř:"r",ȑ:"r",ȓ:"r",ṛ:"r",ṝ:"r",ŗ:"r",ṟ:"r",ɍ:"r",ɽ:"r",ꝛ:"r","ꞧ":"r",ꞃ:"r","ⓢ":"s",ｓ:"s",ß:"s",ś:"s",ṥ:"s",ŝ:"s",ṡ:"s",š:"s",ṧ:"s",ṣ:"s",ṩ:"s",ș:"s",ş:"s",ȿ:"s","ꞩ":"s",ꞅ:"s",ẛ:"s","ⓣ":"t",ｔ:"t",ṫ:"t",ẗ:"t",ť:"t",ṭ:"t",ț:"t",ţ:"t",ṱ:"t",ṯ:"t",ŧ:"t",ƭ:"t",ʈ:"t",ⱦ:"t",ꞇ:"t",ꜩ:"tz","ⓤ":"u",ｕ:"u",ù:"u",ú:"u",û:"u",ũ:"u",ṹ:"u",ū:"u",ṻ:"u",ŭ:"u",ü:"u",ǜ:"u",ǘ:"u",ǖ:"u",ǚ:"u",ủ:"u",ů:"u",ű:"u",ǔ:"u",ȕ:"u",ȗ:"u",ư:"u",ừ:"u",ứ:"u",ữ:"u",ử:"u",ự:"u",ụ:"u",ṳ:"u",ų:"u",ṷ:"u",ṵ:"u",ʉ:"u","ⓥ":"v",ｖ:"v",ṽ:"v",ṿ:"v",ʋ:"v",ꝟ:"v",ʌ:"v",ꝡ:"vy","ⓦ":"w",ｗ:"w",ẁ:"w",ẃ:"w",ŵ:"w",ẇ:"w",ẅ:"w",ẘ:"w",ẉ:"w",ⱳ:"w","ⓧ":"x",ｘ:"x",ẋ:"x",ẍ:"x","ⓨ":"y",ｙ:"y",ỳ:"y",ý:"y",ŷ:"y",ỹ:"y",ȳ:"y",ẏ:"y",ÿ:"y",ỷ:"y",ẙ:"y",ỵ:"y",ƴ:"y",ɏ:"y",ỿ:"y","ⓩ":"z",ｚ:"z",ź:"z",ẑ:"z",ż:"z",ž:"z",ẓ:"z",ẕ:"z",ƶ:"z",ȥ:"z",ɀ:"z",ⱬ:"z",ꝣ:"z"};K=a(document),I=function(){var a=1;return function(){return a++}}(),K.on("mousemove",function(a){M.x=a.pageX,M.y=a.pageY}),F=D(Object,{bind:function(a){var b=this;return function(){a.apply(b,arguments)}},init:function(c){var d,e,g=".select2-results";this.opts=c=this.prepareOpts(c),this.id=c.id,c.element.data("select2")!==b&&null!==c.element.data("select2")&&c.element.data("select2").destroy(),this.container=this.createContainer(),this.liveRegion=a("<span>",{role:"status","aria-live":"polite"}).addClass("select2-hidden-accessible").appendTo(document.body),this.containerId="s2id_"+(c.element.attr("id")||"autogen"+I()),this.containerEventName=this.containerId.replace(/([.])/g,"_").replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g,"\\$1"),this.container.attr("id",this.containerId),this.container.attr("title",c.element.attr("title")),this.body=a("body"),s(this.container,this.opts.element,this.opts.adaptContainerCssClass),this.container.attr("style",c.element.attr("style")),this.container.css(z(c.containerCss)),this.container.addClass(z(c.containerCssClass)),this.elementTabIndex=this.opts.element.attr("tabindex"),this.opts.element.data("select2",this).attr("tabindex","-1").before(this.container).on("click.select2",p),this.container.data("select2",this),this.dropdown=this.container.find(".select2-drop"),s(this.dropdown,this.opts.element,this.opts.adaptDropdownCssClass),this.dropdown.addClass(z(c.dropdownCssClass)),this.dropdown.data("select2",this),this.dropdown.on("click",p),this.results=d=this.container.find(g),this.search=e=this.container.find("input.select2-input"),this.queryCount=0,this.resultsPage=0,this.context=null,this.initContainer(),this.container.on("click",p),k(this.results),this.dropdown.on("mousemove-filtered",g,this.bind(this.highlightUnderEvent)),this.dropdown.on("touchstart touchmove touchend",g,this.bind(function(a){this._touchEvent=!0,this.highlightUnderEvent(a)})),this.dropdown.on("touchmove",g,this.bind(this.touchMoved)),this.dropdown.on("touchstart touchend",g,this.bind(this.clearTouchMoved)),this.dropdown.on("click",this.bind(function(){this._touchEvent&&(this._touchEvent=!1,this.selectHighlighted())})),m(80,this.results),this.dropdown.on("scroll-debounced",g,this.bind(this.loadMoreIfNeeded)),a(this.container).on("change",".select2-input",function(a){a.stopPropagation()}),a(this.dropdown).on("change",".select2-input",function(a){a.stopPropagation()}),a.fn.mousewheel&&d.mousewheel(function(a,b,c,e){var f=d.scrollTop();e>0&&0>=f-e?(d.scrollTop(0),p(a)):0>e&&d.get(0).scrollHeight-d.scrollTop()+e<=d.height()&&(d.scrollTop(d.get(0).scrollHeight-d.height()),p(a))}),j(e),e.on("keyup-change input paste",this.bind(this.updateResults)),e.on("focus",function(){e.addClass("select2-focused")}),e.on("blur",function(){e.removeClass("select2-focused")}),this.dropdown.on("mouseup",g,this.bind(function(b){a(b.target).closest(".select2-result-selectable").length>0&&(this.highlightUnderEvent(b),this.selectHighlighted(b))})),this.dropdown.on("click mouseup mousedown touchstart touchend focusin",function(a){a.stopPropagation()}),this.nextSearchTerm=b,a.isFunction(this.opts.initSelection)&&(this.initSelection(),this.monitorSource()),null!==c.maximumInputLength&&this.search.attr("maxlength",c.maximumInputLength);var h=c.element.prop("disabled");h===b&&(h=!1),this.enable(!h);var i=c.element.prop("readonly");i===b&&(i=!1),this.readonly(i),L=L||f(),this.autofocus=c.element.prop("autofocus"),c.element.prop("autofocus",!1),this.autofocus&&this.focus(),this.search.attr("placeholder",c.searchInputPlaceholder)},destroy:function(){var a=this.opts.element,c=a.data("select2");this.close(),this.propertyObserver&&(this.propertyObserver.disconnect(),this.propertyObserver=null),c!==b&&(c.container.remove(),c.liveRegion.remove(),c.dropdown.remove(),a.removeClass("select2-offscreen").removeData("select2").off(".select2").prop("autofocus",this.autofocus||!1),this.elementTabIndex?a.attr({tabindex:this.elementTabIndex}):a.removeAttr("tabindex"),a.show()),C.call(this,"container","liveRegion","dropdown","results","search")},optionToData:function(a){return a.is("option")?{id:a.prop("value"),text:a.text(),element:a.get(),css:a.attr("class"),disabled:a.prop("disabled"),locked:g(a.attr("locked"),"locked")||g(a.data("locked"),!0)}:a.is("optgroup")?{text:a.attr("label"),children:[],element:a.get(),css:a.attr("class")}:void 0},prepareOpts:function(c){var d,e,f,i,j=this;if(d=c.element,"select"===d.get(0).tagName.toLowerCase()&&(this.select=e=c.element),e&&a.each(["id","multiple","ajax","query","createSearchChoice","initSelection","data","tags"],function(){if(this in c)throw new Error("Option '"+this+"' is not allowed for Select2 when attached to a <select> element.")}),c=a.extend({},{populateResults:function(d,e,f){var g,h=this.opts.id,i=this.liveRegion;(g=function(d,e,k){var l,m,n,o,p,q,r,s,t,u;for(d=c.sortResults(d,e,f),l=0,m=d.length;m>l;l+=1)n=d[l],p=n.disabled===!0,o=!p&&h(n)!==b,q=n.children&&n.children.length>0,r=a("<li></li>"),r.addClass("select2-results-dept-"+k),r.addClass("select2-result"),r.addClass(o?"select2-result-selectable":"select2-result-unselectable"),p&&r.addClass("select2-disabled"),q&&r.addClass("select2-result-with-children"),r.addClass(j.opts.formatResultCssClass(n)),r.attr("role","presentation"),s=a(document.createElement("div")),s.addClass("select2-result-label"),s.attr("id","select2-result-label-"+I()),s.attr("role","option"),u=c.formatResult(n,s,f,j.opts.escapeMarkup),u!==b&&(s.html(u),r.append(s)),q&&(t=a("<ul></ul>"),t.addClass("select2-result-sub"),g(n.children,t,k+1),r.append(t)),r.data("select2-data",n),e.append(r);i.text(c.formatMatches(d.length))})(e,d,0)}},a.fn.select2.defaults,c),"function"!=typeof c.id&&(f=c.id,c.id=function(a){return a[f]}),a.isArray(c.element.data("select2Tags"))){if("tags"in c)throw"tags specified as both an attribute 'data-select2-tags' and in options of Select2 "+c.element.attr("id");c.tags=c.element.data("select2Tags")}if(e?(c.query=this.bind(function(a){var c,e,f,g={results:[],more:!1},h=a.term;f=function(b,c){var d;b.is("option")?a.matcher(h,b.text(),b)&&c.push(j.optionToData(b)):b.is("optgroup")&&(d=j.optionToData(b),b.children().each2(function(a,b){f(b,d.children)}),d.children.length>0&&c.push(d))},c=d.children(),this.getPlaceholder()!==b&&c.length>0&&(e=this.getPlaceholderOption(),e&&(c=c.not(e))),c.each2(function(a,b){f(b,g.results)}),a.callback(g)}),c.id=function(a){return a.id}):"query"in c||("ajax"in c?(i=c.element.data("ajax-url"),i&&i.length>0&&(c.ajax.url=i),c.query=v.call(c.element,c.ajax)):"data"in c?c.query=w(c.data):"tags"in c&&(c.query=x(c.tags),c.createSearchChoice===b&&(c.createSearchChoice=function(b){return{id:a.trim(b),text:a.trim(b)}}),c.initSelection===b&&(c.initSelection=function(b,d){var e=[];a(h(b.val(),c.separator)).each(function(){var b={id:this,text:this},d=c.tags;a.isFunction(d)&&(d=d()),a(d).each(function(){return g(this.id,b.id)?(b=this,!1):void 0}),e.push(b)}),d(e)}))),"function"!=typeof c.query)throw"query function not defined for Select2 "+c.element.attr("id");if("top"===c.createSearchChoicePosition)c.createSearchChoicePosition=function(a,b){a.unshift(b)};else if("bottom"===c.createSearchChoicePosition)c.createSearchChoicePosition=function(a,b){a.push(b)};else if("function"!=typeof c.createSearchChoicePosition)throw"invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";return c},monitorSource:function(){var a,c,d=this.opts.element;d.on("change.select2",this.bind(function(){this.opts.element.data("select2-change-triggered")!==!0&&this.initSelection()})),a=this.bind(function(){var a=d.prop("disabled");a===b&&(a=!1),this.enable(!a);var c=d.prop("readonly");c===b&&(c=!1),this.readonly(c),s(this.container,this.opts.element,this.opts.adaptContainerCssClass),this.container.addClass(z(this.opts.containerCssClass)),s(this.dropdown,this.opts.element,this.opts.adaptDropdownCssClass),this.dropdown.addClass(z(this.opts.dropdownCssClass))}),d.length&&d[0].attachEvent&&d.each(function(){this.attachEvent("onpropertychange",a)}),c=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver,c!==b&&(this.propertyObserver&&(delete this.propertyObserver,this.propertyObserver=null),this.propertyObserver=new c(function(b){b.forEach(a)}),this.propertyObserver.observe(d.get(0),{attributes:!0,subtree:!1}))},triggerSelect:function(b){var c=a.Event("select2-selecting",{val:this.id(b),object:b});return this.opts.element.trigger(c),!c.isDefaultPrevented()},triggerChange:function(b){b=b||{},b=a.extend({},b,{type:"change",val:this.val()}),this.opts.element.data("select2-change-triggered",!0),this.opts.element.trigger(b),this.opts.element.data("select2-change-triggered",!1),this.opts.element.click(),this.opts.blurOnChange&&this.opts.element.blur()},isInterfaceEnabled:function(){return this.enabledInterface===!0},enableInterface:function(){var a=this._enabled&&!this._readonly,b=!a;return a===this.enabledInterface?!1:(this.container.toggleClass("select2-container-disabled",b),this.close(),this.enabledInterface=a,!0)},enable:function(a){a===b&&(a=!0),this._enabled!==a&&(this._enabled=a,this.opts.element.prop("disabled",!a),this.enableInterface())},disable:function(){this.enable(!1)},readonly:function(a){a===b&&(a=!1),this._readonly!==a&&(this._readonly=a,this.opts.element.prop("readonly",a),this.enableInterface())},opened:function(){return this.container.hasClass("select2-dropdown-open")},positionDropdown:function(){var b,c,d,e,f,g=this.dropdown,h=this.container.offset(),i=this.container.outerHeight(!1),j=this.container.outerWidth(!1),k=g.outerHeight(!1),l=a(window),m=l.width(),n=l.height(),o=l.scrollLeft()+m,p=l.scrollTop()+n,q=h.top+i,r=h.left,s=p>=q+k,t=h.top-k>=l.scrollTop(),u=g.outerWidth(!1),v=o>=r+u,w=g.hasClass("select2-drop-above");w?(c=!0,!t&&s&&(d=!0,c=!1)):(c=!1,!s&&t&&(d=!0,c=!0)),d&&(g.hide(),h=this.container.offset(),i=this.container.outerHeight(!1),j=this.container.outerWidth(!1),k=g.outerHeight(!1),o=l.scrollLeft()+m,p=l.scrollTop()+n,q=h.top+i,r=h.left,u=g.outerWidth(!1),v=o>=r+u,g.show(),this.focusSearch()),this.opts.dropdownAutoWidth?(f=a(".select2-results",g)[0],g.addClass("select2-drop-auto-width"),g.css("width",""),u=g.outerWidth(!1)+(f.scrollHeight===f.clientHeight?0:L.width),u>j?j=u:u=j,k=g.outerHeight(!1),v=o>=r+u):this.container.removeClass("select2-drop-auto-width"),"static"!==this.body.css("position")&&(b=this.body.offset(),q-=b.top,r-=b.left),v||(r=h.left+this.container.outerWidth(!1)-u),e={left:r,width:j},c?(e.top=h.top-k,e.bottom="auto",this.container.addClass("select2-drop-above"),g.addClass("select2-drop-above")):(e.top=q,e.bottom="auto",this.container.removeClass("select2-drop-above"),g.removeClass("select2-drop-above")),e=a.extend(e,z(this.opts.dropdownCss)),g.css(e)},shouldOpen:function(){var b;return this.opened()?!1:this._enabled===!1||this._readonly===!0?!1:(b=a.Event("select2-opening"),this.opts.element.trigger(b),!b.isDefaultPrevented())},clearDropdownAlignmentPreference:function(){this.container.removeClass("select2-drop-above"),this.dropdown.removeClass("select2-drop-above")},open:function(){return this.shouldOpen()?(this.opening(),!0):!1},opening:function(){var b,d=this.containerEventName,e="scroll."+d,f="resize."+d,g="orientationchange."+d;this.container.addClass("select2-dropdown-open").addClass("select2-container-active"),this.clearDropdownAlignmentPreference(),this.dropdown[0]!==this.body.children().last()[0]&&this.dropdown.detach().appendTo(this.body),b=a("#select2-drop-mask"),0==b.length&&(b=a(document.createElement("div")),b.attr("id","select2-drop-mask").attr("class","select2-drop-mask"),b.hide(),b.appendTo(this.body),b.on("mousedown touchstart click",function(d){c(b);var e,f=a("#select2-drop");f.length>0&&(e=f.data("select2"),e.opts.selectOnBlur&&e.selectHighlighted({noFocus:!0}),e.close(),d.preventDefault(),d.stopPropagation())})),this.dropdown.prev()[0]!==b[0]&&this.dropdown.before(b),a("#select2-drop").removeAttr("id"),this.dropdown.attr("id","select2-drop"),b.show(),this.positionDropdown(),this.dropdown.show(),this.positionDropdown(),this.dropdown.addClass("select2-drop-active");var h=this;this.container.parents().add(window).each(function(){a(this).on(f+" "+e+" "+g,function(){h.opened()&&h.positionDropdown()})})},close:function(){if(this.opened()){var b=this.containerEventName,c="scroll."+b,d="resize."+b,e="orientationchange."+b;this.container.parents().add(window).each(function(){a(this).off(c).off(d).off(e)}),this.clearDropdownAlignmentPreference(),a("#select2-drop-mask").hide(),this.dropdown.removeAttr("id"),this.dropdown.hide(),this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active"),this.results.empty(),this.clearSearch(),this.search.removeClass("select2-active"),this.opts.element.trigger(a.Event("select2-close"))}},externalSearch:function(a){this.open(),this.search.val(a),this.updateResults(!1)},clearSearch:function(){},getMaximumSelectionSize:function(){return z(this.opts.maximumSelectionSize)},ensureHighlightVisible:function(){var b,c,d,e,f,g,h,i=this.results;if(c=this.highlight(),!(0>c)){if(0==c)return void i.scrollTop(0);b=this.findHighlightableChoices().find(".select2-result-label"),d=a(b[c]),e=d.offset().top+d.outerHeight(!0),c===b.length-1&&(h=i.find("li.select2-more-results"),h.length>0&&(e=h.offset().top+h.outerHeight(!0))),f=i.offset().top+i.outerHeight(!0),e>f&&i.scrollTop(i.scrollTop()+(e-f)),g=d.offset().top-i.offset().top,0>g&&"none"!=d.css("display")&&i.scrollTop(i.scrollTop()+g)}},findHighlightableChoices:function(){return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)")},moveHighlight:function(b){for(var c=this.findHighlightableChoices(),d=this.highlight();d>-1&&d<c.length;){d+=b;var e=a(c[d]);if(e.hasClass("select2-result-selectable")&&!e.hasClass("select2-disabled")&&!e.hasClass("select2-selected")){this.highlight(d);break}}},highlight:function(b){var c,d,f=this.findHighlightableChoices();return 0===arguments.length?e(f.filter(".select2-highlighted")[0],f.get()):(b>=f.length&&(b=f.length-1),0>b&&(b=0),this.removeHighlight(),c=a(f[b]),c.addClass("select2-highlighted"),this.search.attr("aria-activedescendant",c.find(".select2-result-label").attr("id")),this.ensureHighlightVisible(),this.liveRegion.text(c.text()),d=c.data("select2-data"),void(d&&this.opts.element.trigger({type:"select2-highlight",val:this.id(d),choice:d})))},removeHighlight:function(){this.results.find(".select2-highlighted").removeClass("select2-highlighted")},touchMoved:function(){this._touchMoved=!0},clearTouchMoved:function(){this._touchMoved=!1},countSelectableResults:function(){return this.findHighlightableChoices().length},highlightUnderEvent:function(b){var c=a(b.target).closest(".select2-result-selectable");if(c.length>0&&!c.is(".select2-highlighted")){var d=this.findHighlightableChoices();this.highlight(d.index(c))}else 0==c.length&&this.removeHighlight()},loadMoreIfNeeded:function(){var a,b=this.results,c=b.find("li.select2-more-results"),d=this.resultsPage+1,e=this,f=this.search.val(),g=this.context;0!==c.length&&(a=c.offset().top-b.offset().top-b.height(),a<=this.opts.loadMorePadding&&(c.addClass("select2-active"),this.opts.query({element:this.opts.element,term:f,page:d,context:g,matcher:this.opts.matcher,callback:this.bind(function(a){e.opened()&&(e.opts.populateResults.call(this,b,a.results,{term:f,page:d,context:g}),e.postprocessResults(a,!1,!1),a.more===!0?(c.detach().appendTo(b).text(z(e.opts.formatLoadMore,d+1)),window.setTimeout(function(){e.loadMoreIfNeeded()},10)):c.remove(),e.positionDropdown(),e.resultsPage=d,e.context=a.context,this.opts.element.trigger({type:"select2-loaded",items:a}))})})))},tokenize:function(){},updateResults:function(c){function d(){j.removeClass("select2-active"),m.positionDropdown(),m.liveRegion.text(k.find(".select2-no-results,.select2-selection-limit,.select2-searching").length?k.text():m.opts.formatMatches(k.find(".select2-result-selectable").length))}function e(a){k.html(a),d()}var f,h,i,j=this.search,k=this.results,l=this.opts,m=this,n=j.val(),o=a.data(this.container,"select2-last-term");if((c===!0||!o||!g(n,o))&&(a.data(this.container,"select2-last-term",n),c===!0||this.showSearchInput!==!1&&this.opened())){i=++this.queryCount;var p=this.getMaximumSelectionSize();if(p>=1&&(f=this.data(),a.isArray(f)&&f.length>=p&&y(l.formatSelectionTooBig,"formatSelectionTooBig")))return void e("<li class='select2-selection-limit'>"+z(l.formatSelectionTooBig,p)+"</li>");if(j.val().length<l.minimumInputLength)return e(y(l.formatInputTooShort,"formatInputTooShort")?"<li class='select2-no-results'>"+z(l.formatInputTooShort,j.val(),l.minimumInputLength)+"</li>":""),void(c&&this.showSearch&&this.showSearch(!0));if(l.maximumInputLength&&j.val().length>l.maximumInputLength)return void e(y(l.formatInputTooLong,"formatInputTooLong")?"<li class='select2-no-results'>"+z(l.formatInputTooLong,j.val(),l.maximumInputLength)+"</li>":"");l.formatSearching&&0===this.findHighlightableChoices().length&&e("<li class='select2-searching'>"+z(l.formatSearching)+"</li>"),j.addClass("select2-active"),this.removeHighlight(),h=this.tokenize(),h!=b&&null!=h&&j.val(h),this.resultsPage=1,l.query({element:l.element,term:j.val(),page:this.resultsPage,context:null,matcher:l.matcher,callback:this.bind(function(f){var h;if(i==this.queryCount){if(!this.opened())return void this.search.removeClass("select2-active");if(this.context=f.context===b?null:f.context,this.opts.createSearchChoice&&""!==j.val()&&(h=this.opts.createSearchChoice.call(m,j.val(),f.results),h!==b&&null!==h&&m.id(h)!==b&&null!==m.id(h)&&0===a(f.results).filter(function(){return g(m.id(this),m.id(h))}).length&&this.opts.createSearchChoicePosition(f.results,h)),0===f.results.length&&y(l.formatNoMatches,"formatNoMatches"))return void e("<li class='select2-no-results'>"+z(l.formatNoMatches,j.val())+"</li>");k.empty(),m.opts.populateResults.call(this,k,f.results,{term:j.val(),page:this.resultsPage,context:null}),f.more===!0&&y(l.formatLoadMore,"formatLoadMore")&&(k.append("<li class='select2-more-results'>"+m.opts.escapeMarkup(z(l.formatLoadMore,this.resultsPage))+"</li>"),window.setTimeout(function(){m.loadMoreIfNeeded()},10)),this.postprocessResults(f,c),d(),this.opts.element.trigger({type:"select2-loaded",items:f})}})})}},cancel:function(){this.close()},blur:function(){this.opts.selectOnBlur&&this.selectHighlighted({noFocus:!0}),this.close(),this.container.removeClass("select2-container-active"),this.search[0]===document.activeElement&&this.search.blur(),this.clearSearch(),this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus")},focusSearch:function(){n(this.search)},selectHighlighted:function(a){if(this._touchMoved)return void this.clearTouchMoved();var b=this.highlight(),c=this.results.find(".select2-highlighted"),d=c.closest(".select2-result").data("select2-data");d?(this.highlight(b),this.onSelect(d,a)):a&&a.noFocus&&this.close()},getPlaceholder:function(){var a;return this.opts.element.attr("placeholder")||this.opts.element.attr("data-placeholder")||this.opts.element.data("placeholder")||this.opts.placeholder||((a=this.getPlaceholderOption())!==b?a.text():b)},getPlaceholderOption:function(){if(this.select){var c=this.select.children("option").first();if(this.opts.placeholderOption!==b)return"first"===this.opts.placeholderOption&&c||"function"==typeof this.opts.placeholderOption&&this.opts.placeholderOption(this.select);if(""===a.trim(c.text())&&""===c.val())return c}},initContainerWidth:function(){function c(){var c,d,e,f,g,h;if("off"===this.opts.width)return null;if("element"===this.opts.width)return 0===this.opts.element.outerWidth(!1)?"auto":this.opts.element.outerWidth(!1)+"px";if("copy"===this.opts.width||"resolve"===this.opts.width){if(c=this.opts.element.attr("style"),c!==b)for(d=c.split(";"),f=0,g=d.length;g>f;f+=1)if(h=d[f].replace(/\s/g,""),e=h.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i),null!==e&&e.length>=1)return e[1];return"resolve"===this.opts.width?(c=this.opts.element.css("width"),c.indexOf("%")>0?c:0===this.opts.element.outerWidth(!1)?"auto":this.opts.element.outerWidth(!1)+"px"):null
}return a.isFunction(this.opts.width)?this.opts.width():this.opts.width}var d=c.call(this);null!==d&&this.container.css("width",d)}}),G=D(F,{createContainer:function(){var b=a(document.createElement("div")).attr({"class":"select2-container"}).html(["<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>","   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>","   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>","</a>","<label for='' class='select2-offscreen'></label>","<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />","<div class='select2-drop select2-display-none'>","   <div class='select2-search'>","       <label for='' class='select2-offscreen'></label>","       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'","       aria-autocomplete='list' />","   </div>","   <ul class='select2-results' role='listbox'>","   </ul>","</div>"].join(""));return b},enableInterface:function(){this.parent.enableInterface.apply(this,arguments)&&this.focusser.prop("disabled",!this.isInterfaceEnabled())},opening:function(){var c,d,e;this.opts.minimumResultsForSearch>=0&&this.showSearch(!0),this.parent.opening.apply(this,arguments),this.showSearchInput!==!1&&this.search.val(this.focusser.val()),this.opts.shouldFocusInput(this)&&(this.search.focus(),c=this.search.get(0),c.createTextRange?(d=c.createTextRange(),d.collapse(!1),d.select()):c.setSelectionRange&&(e=this.search.val().length,c.setSelectionRange(e,e))),""===this.search.val()&&this.nextSearchTerm!=b&&(this.search.val(this.nextSearchTerm),this.search.select()),this.focusser.prop("disabled",!0).val(""),this.updateResults(!0),this.opts.element.trigger(a.Event("select2-open"))},close:function(){this.opened()&&(this.parent.close.apply(this,arguments),this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus())},focus:function(){this.opened()?this.close():(this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus())},isFocused:function(){return this.container.hasClass("select2-container-active")},cancel:function(){this.parent.cancel.apply(this,arguments),this.focusser.prop("disabled",!1),this.opts.shouldFocusInput(this)&&this.focusser.focus()},destroy:function(){a("label[for='"+this.focusser.attr("id")+"']").attr("for",this.opts.element.attr("id")),this.parent.destroy.apply(this,arguments),C.call(this,"selection","focusser")},initContainer:function(){var b,d,e=this.container,f=this.dropdown,g=I();this.showSearch(this.opts.minimumResultsForSearch<0?!1:!0),this.selection=b=e.find(".select2-choice"),this.focusser=e.find(".select2-focusser"),b.find(".select2-chosen").attr("id","select2-chosen-"+g),this.focusser.attr("aria-labelledby","select2-chosen-"+g),this.results.attr("id","select2-results-"+g),this.search.attr("aria-owns","select2-results-"+g),this.focusser.attr("id","s2id_autogen"+g),d=a("label[for='"+this.opts.element.attr("id")+"']"),this.focusser.prev().text(d.text()).attr("for",this.focusser.attr("id"));var h=this.opts.element.attr("title");this.opts.element.attr("title",h||d.text()),this.focusser.attr("tabindex",this.elementTabIndex),this.search.attr("id",this.focusser.attr("id")+"_search"),this.search.prev().text(a("label[for='"+this.focusser.attr("id")+"']").text()).attr("for",this.search.attr("id")),this.search.on("keydown",this.bind(function(a){if(this.isInterfaceEnabled()){if(a.which===E.PAGE_UP||a.which===E.PAGE_DOWN)return void p(a);switch(a.which){case E.UP:case E.DOWN:return this.moveHighlight(a.which===E.UP?-1:1),void p(a);case E.ENTER:return this.selectHighlighted(),void p(a);case E.TAB:return void this.selectHighlighted({noFocus:!0});case E.ESC:return this.cancel(a),void p(a)}}})),this.search.on("blur",this.bind(function(){document.activeElement===this.body.get(0)&&window.setTimeout(this.bind(function(){this.opened()&&this.search.focus()}),0)})),this.focusser.on("keydown",this.bind(function(a){if(this.isInterfaceEnabled()&&a.which!==E.TAB&&!E.isControl(a)&&!E.isFunctionKey(a)&&a.which!==E.ESC){if(this.opts.openOnEnter===!1&&a.which===E.ENTER)return void p(a);if(a.which==E.DOWN||a.which==E.UP||a.which==E.ENTER&&this.opts.openOnEnter){if(a.altKey||a.ctrlKey||a.shiftKey||a.metaKey)return;return this.open(),void p(a)}return a.which==E.DELETE||a.which==E.BACKSPACE?(this.opts.allowClear&&this.clear(),void p(a)):void 0}})),j(this.focusser),this.focusser.on("keyup-change input",this.bind(function(a){if(this.opts.minimumResultsForSearch>=0){if(a.stopPropagation(),this.opened())return;this.open()}})),b.on("mousedown touchstart","abbr",this.bind(function(a){this.isInterfaceEnabled()&&(this.clear(),q(a),this.close(),this.selection.focus())})),b.on("mousedown touchstart",this.bind(function(d){c(b),this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.opened()?this.close():this.isInterfaceEnabled()&&this.open(),p(d)})),f.on("mousedown touchstart",this.bind(function(){this.opts.shouldFocusInput(this)&&this.search.focus()})),b.on("focus",this.bind(function(a){p(a)})),this.focusser.on("focus",this.bind(function(){this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.container.addClass("select2-container-active")})).on("blur",this.bind(function(){this.opened()||(this.container.removeClass("select2-container-active"),this.opts.element.trigger(a.Event("select2-blur")))})),this.search.on("focus",this.bind(function(){this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.container.addClass("select2-container-active")})),this.initContainerWidth(),this.opts.element.addClass("select2-offscreen"),this.setPlaceholder()},clear:function(b){var c=this.selection.data("select2-data");if(c){var d=a.Event("select2-clearing");if(this.opts.element.trigger(d),d.isDefaultPrevented())return;var e=this.getPlaceholderOption();this.opts.element.val(e?e.val():""),this.selection.find(".select2-chosen").empty(),this.selection.removeData("select2-data"),this.setPlaceholder(),b!==!1&&(this.opts.element.trigger({type:"select2-removed",val:this.id(c),choice:c}),this.triggerChange({removed:c}))}},initSelection:function(){if(this.isPlaceholderOptionSelected())this.updateSelection(null),this.close(),this.setPlaceholder();else{var a=this;this.opts.initSelection.call(null,this.opts.element,function(c){c!==b&&null!==c&&(a.updateSelection(c),a.close(),a.setPlaceholder(),a.nextSearchTerm=a.opts.nextSearchTerm(c,a.search.val()))})}},isPlaceholderOptionSelected:function(){var a;return this.getPlaceholder()===b?!1:(a=this.getPlaceholderOption())!==b&&a.prop("selected")||""===this.opts.element.val()||this.opts.element.val()===b||null===this.opts.element.val()},prepareOpts:function(){var b=this.parent.prepareOpts.apply(this,arguments),c=this;return"select"===b.element.get(0).tagName.toLowerCase()?b.initSelection=function(a,b){var d=a.find("option").filter(function(){return this.selected&&!this.disabled});b(c.optionToData(d))}:"data"in b&&(b.initSelection=b.initSelection||function(c,d){var e=c.val(),f=null;b.query({matcher:function(a,c,d){var h=g(e,b.id(d));return h&&(f=d),h},callback:a.isFunction(d)?function(){d(f)}:a.noop})}),b},getPlaceholder:function(){return this.select&&this.getPlaceholderOption()===b?b:this.parent.getPlaceholder.apply(this,arguments)},setPlaceholder:function(){var a=this.getPlaceholder();if(this.isPlaceholderOptionSelected()&&a!==b){if(this.select&&this.getPlaceholderOption()===b)return;this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(a)),this.selection.addClass("select2-default"),this.container.removeClass("select2-allowclear")}},postprocessResults:function(a,b,c){var d=0,e=this;if(this.findHighlightableChoices().each2(function(a,b){return g(e.id(b.data("select2-data")),e.opts.element.val())?(d=a,!1):void 0}),c!==!1&&this.highlight(b===!0&&d>=0?d:0),b===!0){var f=this.opts.minimumResultsForSearch;f>=0&&this.showSearch(A(a.results)>=f)}},showSearch:function(b){this.showSearchInput!==b&&(this.showSearchInput=b,this.dropdown.find(".select2-search").toggleClass("select2-search-hidden",!b),this.dropdown.find(".select2-search").toggleClass("select2-offscreen",!b),a(this.dropdown,this.container).toggleClass("select2-with-searchbox",b))},onSelect:function(a,b){if(this.triggerSelect(a)){var c=this.opts.element.val(),d=this.data();this.opts.element.val(this.id(a)),this.updateSelection(a),this.opts.element.trigger({type:"select2-selected",val:this.id(a),choice:a}),this.nextSearchTerm=this.opts.nextSearchTerm(a,this.search.val()),this.close(),b&&b.noFocus||!this.opts.shouldFocusInput(this)||this.focusser.focus(),g(c,this.id(a))||this.triggerChange({added:a,removed:d})}},updateSelection:function(a){var c,d,e=this.selection.find(".select2-chosen");this.selection.data("select2-data",a),e.empty(),null!==a&&(c=this.opts.formatSelection(a,e,this.opts.escapeMarkup)),c!==b&&e.append(c),d=this.opts.formatSelectionCssClass(a,e),d!==b&&e.addClass(d),this.selection.removeClass("select2-default"),this.opts.allowClear&&this.getPlaceholder()!==b&&this.container.addClass("select2-allowclear")},val:function(){var a,c=!1,d=null,e=this,f=this.data();if(0===arguments.length)return this.opts.element.val();if(a=arguments[0],arguments.length>1&&(c=arguments[1]),this.select)this.select.val(a).find("option").filter(function(){return this.selected}).each2(function(a,b){return d=e.optionToData(b),!1}),this.updateSelection(d),this.setPlaceholder(),c&&this.triggerChange({added:d,removed:f});else{if(!a&&0!==a)return void this.clear(c);if(this.opts.initSelection===b)throw new Error("cannot call val() if initSelection() is not defined");this.opts.element.val(a),this.opts.initSelection(this.opts.element,function(a){e.opts.element.val(a?e.id(a):""),e.updateSelection(a),e.setPlaceholder(),c&&e.triggerChange({added:a,removed:f})})}},clearSearch:function(){this.search.val(""),this.focusser.val("")},data:function(a){var c,d=!1;return 0===arguments.length?(c=this.selection.data("select2-data"),c==b&&(c=null),c):(arguments.length>1&&(d=arguments[1]),void(a?(c=this.data(),this.opts.element.val(a?this.id(a):""),this.updateSelection(a),d&&this.triggerChange({added:a,removed:c})):this.clear(d)))}}),H=D(F,{createContainer:function(){var b=a(document.createElement("div")).attr({"class":"select2-container select2-container-multi"}).html(["<ul class='select2-choices'>","  <li class='select2-search-field'>","    <label for='' class='select2-offscreen'></label>","    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>","  </li>","</ul>","<div class='select2-drop select2-drop-multi select2-display-none'>","   <ul class='select2-results'>","   </ul>","</div>"].join(""));return b},prepareOpts:function(){var b=this.parent.prepareOpts.apply(this,arguments),c=this;return"select"===b.element.get(0).tagName.toLowerCase()?b.initSelection=function(a,b){var d=[];a.find("option").filter(function(){return this.selected&&!this.disabled}).each2(function(a,b){d.push(c.optionToData(b))}),b(d)}:"data"in b&&(b.initSelection=b.initSelection||function(c,d){var e=h(c.val(),b.separator),f=[];b.query({matcher:function(c,d,h){var i=a.grep(e,function(a){return g(a,b.id(h))}).length;return i&&f.push(h),i},callback:a.isFunction(d)?function(){for(var a=[],c=0;c<e.length;c++)for(var h=e[c],i=0;i<f.length;i++){var j=f[i];if(g(h,b.id(j))){a.push(j),f.splice(i,1);break}}d(a)}:a.noop})}),b},selectChoice:function(a){var b=this.container.find(".select2-search-choice-focus");b.length&&a&&a[0]==b[0]||(b.length&&this.opts.element.trigger("choice-deselected",b),b.removeClass("select2-search-choice-focus"),a&&a.length&&(this.close(),a.addClass("select2-search-choice-focus"),this.opts.element.trigger("choice-selected",a)))},destroy:function(){a("label[for='"+this.search.attr("id")+"']").attr("for",this.opts.element.attr("id")),this.parent.destroy.apply(this,arguments),C.call(this,"searchContainer","selection")},initContainer:function(){var b,c=".select2-choices";this.searchContainer=this.container.find(".select2-search-field"),this.selection=b=this.container.find(c);var d=this;this.selection.on("click",".select2-search-choice:not(.select2-locked)",function(){d.search[0].focus(),d.selectChoice(a(this))}),this.search.attr("id","s2id_autogen"+I()),this.search.prev().text(a("label[for='"+this.opts.element.attr("id")+"']").text()).attr("for",this.search.attr("id")),this.search.on("input paste",this.bind(function(){this.isInterfaceEnabled()&&(this.opened()||this.open())})),this.search.attr("tabindex",this.elementTabIndex),this.keydowns=0,this.search.on("keydown",this.bind(function(a){if(this.isInterfaceEnabled()){++this.keydowns;var c=b.find(".select2-search-choice-focus"),d=c.prev(".select2-search-choice:not(.select2-locked)"),e=c.next(".select2-search-choice:not(.select2-locked)"),f=o(this.search);if(c.length&&(a.which==E.LEFT||a.which==E.RIGHT||a.which==E.BACKSPACE||a.which==E.DELETE||a.which==E.ENTER)){var g=c;return a.which==E.LEFT&&d.length?g=d:a.which==E.RIGHT?g=e.length?e:null:a.which===E.BACKSPACE?this.unselect(c.first())&&(this.search.width(10),g=d.length?d:e):a.which==E.DELETE?this.unselect(c.first())&&(this.search.width(10),g=e.length?e:null):a.which==E.ENTER&&(g=null),this.selectChoice(g),p(a),void(g&&g.length||this.open())}if((a.which===E.BACKSPACE&&1==this.keydowns||a.which==E.LEFT)&&0==f.offset&&!f.length)return this.selectChoice(b.find(".select2-search-choice:not(.select2-locked)").last()),void p(a);if(this.selectChoice(null),this.opened())switch(a.which){case E.UP:case E.DOWN:return this.moveHighlight(a.which===E.UP?-1:1),void p(a);case E.ENTER:return this.selectHighlighted(),void p(a);case E.TAB:return this.selectHighlighted({noFocus:!0}),void this.close();case E.ESC:return this.cancel(a),void p(a)}if(a.which!==E.TAB&&!E.isControl(a)&&!E.isFunctionKey(a)&&a.which!==E.BACKSPACE&&a.which!==E.ESC){if(a.which===E.ENTER){if(this.opts.openOnEnter===!1)return;if(a.altKey||a.ctrlKey||a.shiftKey||a.metaKey)return}this.open(),(a.which===E.PAGE_UP||a.which===E.PAGE_DOWN)&&p(a),a.which===E.ENTER&&p(a)}}})),this.search.on("keyup",this.bind(function(){this.keydowns=0,this.resizeSearch()})),this.search.on("blur",this.bind(function(b){this.container.removeClass("select2-container-active"),this.search.removeClass("select2-focused"),this.selectChoice(null),this.opened()||this.clearSearch(),b.stopImmediatePropagation(),this.opts.element.trigger(a.Event("select2-blur"))})),this.container.on("click",c,this.bind(function(b){this.isInterfaceEnabled()&&(a(b.target).closest(".select2-search-choice").length>0||(this.selectChoice(null),this.clearPlaceholder(),this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.open(),this.focusSearch(),b.preventDefault()))})),this.container.on("focus",c,this.bind(function(){this.isInterfaceEnabled()&&(this.container.hasClass("select2-container-active")||this.opts.element.trigger(a.Event("select2-focus")),this.container.addClass("select2-container-active"),this.dropdown.addClass("select2-drop-active"),this.clearPlaceholder())})),this.initContainerWidth(),this.opts.element.addClass("select2-offscreen"),this.clearSearch()},enableInterface:function(){this.parent.enableInterface.apply(this,arguments)&&this.search.prop("disabled",!this.isInterfaceEnabled())},initSelection:function(){if(""===this.opts.element.val()&&""===this.opts.element.text()&&(this.updateSelection([]),this.close(),this.clearSearch()),this.select||""!==this.opts.element.val()){var a=this;this.opts.initSelection.call(null,this.opts.element,function(c){c!==b&&null!==c&&(a.updateSelection(c),a.close(),a.clearSearch())})}},clearSearch:function(){var a=this.getPlaceholder(),c=this.getMaxSearchWidth();a!==b&&0===this.getVal().length&&this.search.hasClass("select2-focused")===!1?(this.search.val(a).addClass("select2-default"),this.search.width(c>0?c:this.container.css("width"))):this.search.val("").width(10)},clearPlaceholder:function(){this.search.hasClass("select2-default")&&this.search.val("").removeClass("select2-default")},opening:function(){this.clearPlaceholder(),this.resizeSearch(),this.parent.opening.apply(this,arguments),this.focusSearch(),""===this.search.val()&&this.nextSearchTerm!=b&&(this.search.val(this.nextSearchTerm),this.search.select()),this.updateResults(!0),this.opts.shouldFocusInput(this)&&this.search.focus(),this.opts.element.trigger(a.Event("select2-open"))},close:function(){this.opened()&&this.parent.close.apply(this,arguments)},focus:function(){this.close(),this.search.focus()},isFocused:function(){return this.search.hasClass("select2-focused")},updateSelection:function(b){var c=[],d=[],f=this;a(b).each(function(){e(f.id(this),c)<0&&(c.push(f.id(this)),d.push(this))}),b=d,this.selection.find(".select2-search-choice").remove(),a(b).each(function(){f.addSelectedChoice(this)}),f.postprocessResults()},tokenize:function(){var a=this.search.val();a=this.opts.tokenizer.call(this,a,this.data(),this.bind(this.onSelect),this.opts),null!=a&&a!=b&&(this.search.val(a),a.length>0&&this.open())},onSelect:function(a,c){this.triggerSelect(a)&&(this.addSelectedChoice(a),this.opts.element.trigger({type:"selected",val:this.id(a),choice:a}),this.nextSearchTerm=this.opts.nextSearchTerm(a,this.search.val()),this.clearSearch(),this.updateResults(),(this.select||!this.opts.closeOnSelect)&&this.postprocessResults(a,!1,this.opts.closeOnSelect===!0),this.opts.closeOnSelect?(this.close(),this.search.width(10)):this.countSelectableResults()>0?(this.search.width(10),this.resizeSearch(),this.getMaximumSelectionSize()>0&&this.val().length>=this.getMaximumSelectionSize()?this.updateResults(!0):this.nextSearchTerm!=b&&(this.search.val(this.nextSearchTerm),this.updateResults(),this.search.select()),this.positionDropdown()):(this.close(),this.search.width(10)),this.triggerChange({added:a}),c&&c.noFocus||this.focusSearch())},cancel:function(){this.close(),this.focusSearch()},addSelectedChoice:function(c){var d,e,f=!c.locked,g=a("<li class='select2-search-choice'>    <div></div>    <a href='#' class='select2-search-choice-close' tabindex='-1'></a></li>"),h=a("<li class='select2-search-choice select2-locked'><div></div></li>"),i=f?g:h,j=this.id(c),k=this.getVal();d=this.opts.formatSelection(c,i.find("div"),this.opts.escapeMarkup),d!=b&&i.find("div").replaceWith("<div>"+d+"</div>"),e=this.opts.formatSelectionCssClass(c,i.find("div")),e!=b&&i.addClass(e),f&&i.find(".select2-search-choice-close").on("mousedown",p).on("click dblclick",this.bind(function(b){this.isInterfaceEnabled()&&(this.unselect(a(b.target)),this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus"),p(b),this.close(),this.focusSearch())})).on("focus",this.bind(function(){this.isInterfaceEnabled()&&(this.container.addClass("select2-container-active"),this.dropdown.addClass("select2-drop-active"))})),i.data("select2-data",c),i.insertBefore(this.searchContainer),k.push(j),this.setVal(k)},unselect:function(b){var c,d,f=this.getVal();if(b=b.closest(".select2-search-choice"),0===b.length)throw"Invalid argument: "+b+". Must be .select2-search-choice";if(c=b.data("select2-data")){var g=a.Event("select2-removing");if(g.val=this.id(c),g.choice=c,this.opts.element.trigger(g),g.isDefaultPrevented())return!1;for(;(d=e(this.id(c),f))>=0;)f.splice(d,1),this.setVal(f),this.select&&this.postprocessResults();return b.remove(),this.opts.element.trigger({type:"select2-removed",val:this.id(c),choice:c}),this.triggerChange({removed:c}),!0}},postprocessResults:function(a,b,c){var d=this.getVal(),f=this.results.find(".select2-result"),g=this.results.find(".select2-result-with-children"),h=this;f.each2(function(a,b){var c=h.id(b.data("select2-data"));e(c,d)>=0&&(b.addClass("select2-selected"),b.find(".select2-result-selectable").addClass("select2-selected"))}),g.each2(function(a,b){b.is(".select2-result-selectable")||0!==b.find(".select2-result-selectable:not(.select2-selected)").length||b.addClass("select2-selected")}),-1==this.highlight()&&c!==!1&&h.highlight(0),!this.opts.createSearchChoice&&!f.filter(".select2-result:not(.select2-selected)").length>0&&(!a||a&&!a.more&&0===this.results.find(".select2-no-results").length)&&y(h.opts.formatNoMatches,"formatNoMatches")&&this.results.append("<li class='select2-no-results'>"+z(h.opts.formatNoMatches,h.search.val())+"</li>")},getMaxSearchWidth:function(){return this.selection.width()-i(this.search)},resizeSearch:function(){var a,b,c,d,e,f=i(this.search);a=r(this.search)+10,b=this.search.offset().left,c=this.selection.width(),d=this.selection.offset().left,e=c-(b-d)-f,a>e&&(e=c-f),40>e&&(e=c-f),0>=e&&(e=a),this.search.width(Math.floor(e))},getVal:function(){var a;return this.select?(a=this.select.val(),null===a?[]:a):(a=this.opts.element.val(),h(a,this.opts.separator))},setVal:function(b){var c;this.select?this.select.val(b):(c=[],a(b).each(function(){e(this,c)<0&&c.push(this)}),this.opts.element.val(0===c.length?"":c.join(this.opts.separator)))},buildChangeDetails:function(a,b){for(var b=b.slice(0),a=a.slice(0),c=0;c<b.length;c++)for(var d=0;d<a.length;d++)g(this.opts.id(b[c]),this.opts.id(a[d]))&&(b.splice(c,1),c>0&&c--,a.splice(d,1),d--);return{added:b,removed:a}},val:function(c,d){var e,f=this;if(0===arguments.length)return this.getVal();if(e=this.data(),e.length||(e=[]),!c&&0!==c)return this.opts.element.val(""),this.updateSelection([]),this.clearSearch(),void(d&&this.triggerChange({added:this.data(),removed:e}));if(this.setVal(c),this.select)this.opts.initSelection(this.select,this.bind(this.updateSelection)),d&&this.triggerChange(this.buildChangeDetails(e,this.data()));else{if(this.opts.initSelection===b)throw new Error("val() cannot be called if initSelection() is not defined");this.opts.initSelection(this.opts.element,function(b){var c=a.map(b,f.id);f.setVal(c),f.updateSelection(b),f.clearSearch(),d&&f.triggerChange(f.buildChangeDetails(e,f.data()))})}this.clearSearch()},onSortStart:function(){if(this.select)throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");this.search.width(0),this.searchContainer.hide()},onSortEnd:function(){var b=[],c=this;this.searchContainer.show(),this.searchContainer.appendTo(this.searchContainer.parent()),this.resizeSearch(),this.selection.find(".select2-search-choice").each(function(){b.push(c.opts.id(a(this).data("select2-data")))}),this.setVal(b),this.triggerChange()},data:function(b,c){var d,e,f=this;return 0===arguments.length?this.selection.children(".select2-search-choice").map(function(){return a(this).data("select2-data")}).get():(e=this.data(),b||(b=[]),d=a.map(b,function(a){return f.opts.id(a)}),this.setVal(d),this.updateSelection(b),this.clearSearch(),c&&this.triggerChange(this.buildChangeDetails(e,this.data())),void 0)}}),a.fn.select2=function(){var c,d,f,g,h,i=Array.prototype.slice.call(arguments,0),j=["val","destroy","opened","open","close","focus","isFocused","container","dropdown","onSortStart","onSortEnd","enable","disable","readonly","positionDropdown","data","search"],k=["opened","isFocused","container","dropdown"],l=["val","data"],m={search:"externalSearch"};return this.each(function(){if(0===i.length||"object"==typeof i[0])c=0===i.length?{}:a.extend({},i[0]),c.element=a(this),"select"===c.element.get(0).tagName.toLowerCase()?h=c.element.prop("multiple"):(h=c.multiple||!1,"tags"in c&&(c.multiple=h=!0)),d=h?new window.Select2["class"].multi:new window.Select2["class"].single,d.init(c);else{if("string"!=typeof i[0])throw"Invalid arguments to select2 plugin: "+i;if(e(i[0],j)<0)throw"Unknown method: "+i[0];if(g=b,d=a(this).data("select2"),d===b)return;if(f=i[0],"container"===f?g=d.container:"dropdown"===f?g=d.dropdown:(m[f]&&(f=m[f]),g=d[f].apply(d,i.slice(1))),e(i[0],k)>=0||e(i[0],l)>=0&&1==i.length)return!1}}),g===b?this:g},a.fn.select2.defaults={width:"copy",loadMorePadding:0,closeOnSelect:!0,openOnEnter:!0,containerCss:{},dropdownCss:{},containerCssClass:"",dropdownCssClass:"",formatResult:function(a,b,c,d){var e=[];return t(a.text,c.term,e,d),e.join("")},formatSelection:function(a,c,d){return a?d(a.text):b},sortResults:function(a){return a},formatResultCssClass:function(a){return a.css},formatSelectionCssClass:function(){return b},formatMatches:function(a){return a+" results are available, use up and down arrow keys to navigate."},formatNoMatches:function(){return"No matches found"},formatInputTooShort:function(a,b){var c=b-a.length;return"Please enter "+c+" or more character"+(1==c?"":"s")},formatInputTooLong:function(a,b){var c=a.length-b;return"Please delete "+c+" character"+(1==c?"":"s")},formatSelectionTooBig:function(a){return"You can only select "+a+" item"+(1==a?"":"s")},formatLoadMore:function(){return"Loading more results…"},formatSearching:function(){return"Searching…"},minimumResultsForSearch:0,minimumInputLength:0,maximumInputLength:null,maximumSelectionSize:0,id:function(a){return a==b?null:a.id},matcher:function(a,b){return d(""+b).toUpperCase().indexOf(d(""+a).toUpperCase())>=0},separator:",",tokenSeparators:[],tokenizer:B,escapeMarkup:u,blurOnChange:!1,selectOnBlur:!1,adaptContainerCssClass:function(a){return a},adaptDropdownCssClass:function(){return null},nextSearchTerm:function(){return b},searchInputPlaceholder:"",createSearchChoicePosition:"top",shouldFocusInput:function(a){var b="ontouchstart"in window||navigator.msMaxTouchPoints>0;return b&&a.opts.minimumResultsForSearch<0?!1:!0}},a.fn.select2.ajaxDefaults={transport:a.ajax,params:{type:"GET",cache:!1,dataType:"json"}},window.Select2={query:{ajax:v,local:w,tags:x},util:{debounce:l,markMatch:t,escapeMarkup:u,stripDiacritics:d},"class":{"abstract":F,single:G,multi:H}}}}(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! SmartAdmin - v1.4.1 - 2014-06-22 */$.blue="#2e7bcc",$.green="#3FB618",$.red="#FF0039",$.yellow="#FFA500",$.orange="#FF7518",$.pink="#E671B8",$.purple="#9954BB",$.black="#333333",function(a,b,c){!function(a){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):jQuery&&!jQuery.fn.sparkline&&a(jQuery)}(function(d){"use strict";var e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I,J,K={},L=0;e=function(){return{common:{type:"line",lineColor:"#00f",fillColor:"#cdf",defaultPixelsPerValue:3,width:"auto",height:"auto",composite:!1,tagValuesAttribute:"values",tagOptionsPrefix:"spark",enableTagOptions:!1,enableHighlight:!0,highlightLighten:1.4,tooltipSkipNull:!0,tooltipPrefix:"",tooltipSuffix:"",disableHiddenCheck:!1,numberFormatter:!1,numberDigitGroupCount:3,numberDigitGroupSep:",",numberDecimalMark:".",disableTooltips:!1,disableInteraction:!1},line:{spotColor:"#f80",highlightSpotColor:"#5f5",highlightLineColor:"#f22",spotRadius:1.5,minSpotColor:"#f80",maxSpotColor:"#f80",lineWidth:1,normalRangeMin:c,normalRangeMax:c,normalRangeColor:"#ccc",drawNormalOnTop:!1,chartRangeMin:c,chartRangeMax:c,chartRangeMinX:c,chartRangeMaxX:c,tooltipFormat:new g('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{y}}{{suffix}}')},bar:{barColor:d.blue,negBarColor:"#f44",stackedBarColor:[d.blue,d.red,d.yellow,d.green,"#66aa00",d.pink,"#0099c6",d.purple],zeroColor:c,nullColor:c,zeroAxis:!0,barWidth:4,barSpacing:1,chartRangeMax:c,chartRangeMin:c,chartRangeClip:!1,colorMap:c,tooltipFormat:new g('<span style="color: {{color}}">&#9679;</span> {{prefix}}{{value}}{{suffix}}')},tristate:{barWidth:4,barSpacing:1,posBarColor:"#6f6",negBarColor:"#f44",zeroBarColor:"#999",colorMap:{},tooltipFormat:new g('<span style="color: {{color}}">&#9679;</span> {{value:map}}'),tooltipValueLookups:{map:{"-1":"Loss",0:"Draw",1:"Win"}}},discrete:{lineHeight:"auto",thresholdColor:c,thresholdValue:0,chartRangeMax:c,chartRangeMin:c,chartRangeClip:!1,tooltipFormat:new g("{{prefix}}{{value}}{{suffix}}")},bullet:{targetColor:"#f33",targetWidth:3,performanceColor:"#33f",rangeColors:["#d3dafe","#a8b6ff","#7f94ff"],base:c,tooltipFormat:new g("{{fieldkey:fields}} - {{value}}"),tooltipValueLookups:{fields:{r:"Range",p:"Performance",t:"Target"}}},pie:{offset:0,sliceColors:[d.blue,d.red,d.yellow,d.green,"#66aa00",d.pink,"#0099c6",d.purple],borderWidth:0,borderColor:"#000",tooltipFormat:new g('<span style="color: {{color}}">&#9679;</span> {{value}} ({{percent.1}}%)')},box:{raw:!1,boxLineColor:"#000",boxFillColor:"#cdf",whiskerColor:"#000",outlierLineColor:"#333",outlierFillColor:"#fff",medianColor:"#f00",showOutliers:!0,outlierIQR:1.5,spotRadius:1.5,target:c,targetColor:"#4a2",chartRangeMax:c,chartRangeMin:c,tooltipFormat:new g("{{field:fields}}: {{value}}"),tooltipFormatFieldlistKey:"field",tooltipValueLookups:{fields:{lq:"Lower Quartile",med:"Median",uq:"Upper Quartile",lo:"Left Outlier",ro:"Right Outlier",lw:"Left Whisker",rw:"Right Whisker"}}}}},D='.jqstooltip { position: absolute;left: 0px;top: 0px;visibility: hidden;background: rgb(0, 0, 0) transparent;background-color: rgba(0,0,0,0.6);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000);-ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#99000000, endColorstr=#99000000)";color: white;font: 10px arial, san serif;text-align: left;white-space: nowrap;padding: 5px;border: 1px solid white;z-index: 10000;}.jqsfield { color: white;font: 10px arial, san serif;text-align: left;}',f=function(){var a,b;return a=function(){this.init.apply(this,arguments)},arguments.length>1?(arguments[0]?(a.prototype=d.extend(new arguments[0],arguments[arguments.length-1]),a._super=arguments[0].prototype):a.prototype=arguments[arguments.length-1],arguments.length>2&&(b=Array.prototype.slice.call(arguments,1,-1),b.unshift(a.prototype),d.extend.apply(d,b))):a.prototype=arguments[0],a.prototype.cls=a,a},d.SPFormatClass=g=f({fre:/\{\{([\w.]+?)(:(.+?))?\}\}/g,precre:/(\w+)\.(\d+)/,init:function(a,b){this.format=a,this.fclass=b},render:function(a,b,d){var e,f,g,h,i,j=this,k=a;return this.format.replace(this.fre,function(){var a;return f=arguments[1],g=arguments[3],e=j.precre.exec(f),e?(i=e[2],f=e[1]):i=!1,h=k[f],h===c?"":g&&b&&b[g]?(a=b[g],a.get?b[g].get(h)||h:b[g][h]||h):(m(h)&&(h=d.get("numberFormatter")?d.get("numberFormatter")(h):r(h,i,d.get("numberDigitGroupCount"),d.get("numberDigitGroupSep"),d.get("numberDecimalMark"))),h)})}}),d.spformat=function(a,b){return new g(a,b)},h=function(a,b,c){return b>a?b:a>c?c:a},i=function(a,c){var d;return 2===c?(d=b.floor(a.length/2),a.length%2?a[d]:(a[d-1]+a[d])/2):a.length%2?(d=(a.length*c+c)/4,d%1?(a[b.floor(d)]+a[b.floor(d)-1])/2:a[d-1]):(d=(a.length*c+2)/4,d%1?(a[b.floor(d)]+a[b.floor(d)-1])/2:a[d-1])},j=function(a){var b;switch(a){case"undefined":a=c;break;case"null":a=null;break;case"true":a=!0;break;case"false":a=!1;break;default:b=parseFloat(a),a==b&&(a=b)}return a},k=function(a){var b,c=[];for(b=a.length;b--;)c[b]=j(a[b]);return c},l=function(a,b){var c,d,e=[];for(c=0,d=a.length;d>c;c++)a[c]!==b&&e.push(a[c]);return e},m=function(a){return!isNaN(parseFloat(a))&&isFinite(a)},r=function(a,b,c,e,f){var g,h;for(a=(b===!1?parseFloat(a).toString():a.toFixed(b)).split(""),g=(g=d.inArray(".",a))<0?a.length:g,g<a.length&&(a[g]=f),h=g-c;h>0;h-=c)a.splice(h,0,e);return a.join("")},n=function(a,b,c){var d;for(d=b.length;d--;)if((!c||null!==b[d])&&b[d]!==a)return!1;return!0},o=function(a){var b,c=0;for(b=a.length;b--;)c+="number"==typeof a[b]?a[b]:0;return c},q=function(a){return d.isArray(a)?a:[a]},p=function(b){var c;a.createStyleSheet?a.createStyleSheet().cssText=b:(c=a.createElement("style"),c.type="text/css",a.getElementsByTagName("head")[0].appendChild(c),c["string"==typeof a.body.style.WebkitAppearance?"innerText":"innerHTML"]=b)},d.fn.simpledraw=function(b,e,f,g){var h,i;if(f&&(h=this.data("_jqs_vcanvas")))return h;if(d.fn.sparkline.canvas===!1)return!1;if(d.fn.sparkline.canvas===c){var j=a.createElement("canvas");if(j.getContext&&j.getContext("2d"))d.fn.sparkline.canvas=function(a,b,c,d){return new H(a,b,c,d)};else{if(!a.namespaces||a.namespaces.v)return d.fn.sparkline.canvas=!1,!1;a.namespaces.add("v","urn:schemas-microsoft-com:vml","#default#VML"),d.fn.sparkline.canvas=function(a,b,c){return new I(a,b,c)}}}return b===c&&(b=d(this).innerWidth()),e===c&&(e=d(this).innerHeight()),h=d.fn.sparkline.canvas(b,e,this,g),i=d(this).data("_jqs_mhandler"),i&&i.registerCanvas(h),h},d.fn.cleardraw=function(){var a=this.data("_jqs_vcanvas");a&&a.reset()},d.RangeMapClass=s=f({init:function(a){var b,c,d=[];for(b in a)a.hasOwnProperty(b)&&"string"==typeof b&&b.indexOf(":")>-1&&(c=b.split(":"),c[0]=0===c[0].length?-1/0:parseFloat(c[0]),c[1]=0===c[1].length?1/0:parseFloat(c[1]),c[2]=a[b],d.push(c));this.map=a,this.rangelist=d||!1},get:function(a){var b,d,e,f=this.rangelist;if((e=this.map[a])!==c)return e;if(f)for(b=f.length;b--;)if(d=f[b],d[0]<=a&&d[1]>=a)return d[2];return c}}),d.range_map=function(a){return new s(a)},t=f({init:function(a,b){var c=d(a);this.$el=c,this.options=b,this.currentPageX=0,this.currentPageY=0,this.el=a,this.splist=[],this.tooltip=null,this.over=!1,this.displayTooltips=!b.get("disableTooltips"),this.highlightEnabled=!b.get("disableHighlight")},registerSparkline:function(a){this.splist.push(a),this.over&&this.updateDisplay()},registerCanvas:function(a){var b=d(a.canvas);this.canvas=a,this.$canvas=b,b.mouseenter(d.proxy(this.mouseenter,this)),b.mouseleave(d.proxy(this.mouseleave,this)),b.click(d.proxy(this.mouseclick,this))},reset:function(a){this.splist=[],this.tooltip&&a&&(this.tooltip.remove(),this.tooltip=c)},mouseclick:function(a){var b=d.Event("sparklineClick");b.originalEvent=a,b.sparklines=this.splist,this.$el.trigger(b)},mouseenter:function(b){d(a.body).unbind("mousemove.jqs"),d(a.body).bind("mousemove.jqs",d.proxy(this.mousemove,this)),this.over=!0,this.currentPageX=b.pageX,this.currentPageY=b.pageY,this.currentEl=b.target,!this.tooltip&&this.displayTooltips&&(this.tooltip=new u(this.options),this.tooltip.updatePosition(b.pageX,b.pageY)),this.updateDisplay()},mouseleave:function(){d(a.body).unbind("mousemove.jqs");var b,c,e=this.splist,f=e.length,g=!1;for(this.over=!1,this.currentEl=null,this.tooltip&&(this.tooltip.remove(),this.tooltip=null),c=0;f>c;c++)b=e[c],b.clearRegionHighlight()&&(g=!0);g&&this.canvas.render()},mousemove:function(a){this.currentPageX=a.pageX,this.currentPageY=a.pageY,this.currentEl=a.target,this.tooltip&&this.tooltip.updatePosition(a.pageX,a.pageY),this.updateDisplay()},updateDisplay:function(){var a,b,c,e,f,g=this.splist,h=g.length,i=!1,j=this.$canvas.offset(),k=this.currentPageX-j.left,l=this.currentPageY-j.top;if(this.over){for(c=0;h>c;c++)b=g[c],e=b.setRegionHighlight(this.currentEl,k,l),e&&(i=!0);if(i){if(f=d.Event("sparklineRegionChange"),f.sparklines=this.splist,this.$el.trigger(f),this.tooltip){for(a="",c=0;h>c;c++)b=g[c],a+=b.getCurrentRegionTooltip();this.tooltip.setContent(a)}this.disableHighlight||this.canvas.render()}null===e&&this.mouseleave()}}}),u=f({sizeStyle:"position: static !important;display: block !important;visibility: hidden !important;float: left !important;",init:function(b){var c,e=b.get("tooltipClassname","jqstooltip"),f=this.sizeStyle;this.container=b.get("tooltipContainer")||a.body,this.tooltipOffsetX=b.get("tooltipOffsetX",10),this.tooltipOffsetY=b.get("tooltipOffsetY",12),d("#jqssizetip").remove(),d("#jqstooltip").remove(),this.sizetip=d("<div/>",{id:"jqssizetip",style:f,"class":e}),this.tooltip=d("<div/>",{id:"jqstooltip","class":e}).appendTo(this.container),c=this.tooltip.offset(),this.offsetLeft=c.left,this.offsetTop=c.top,this.hidden=!0,d(window).unbind("resize.jqs scroll.jqs"),d(window).bind("resize.jqs scroll.jqs",d.proxy(this.updateWindowDims,this)),this.updateWindowDims()},updateWindowDims:function(){this.scrollTop=d(window).scrollTop(),this.scrollLeft=d(window).scrollLeft(),this.scrollRight=this.scrollLeft+d(window).width(),this.updatePosition()},getSize:function(a){this.sizetip.html(a).appendTo(this.container),this.width=this.sizetip.width()+1,this.height=this.sizetip.height(),this.sizetip.remove()},setContent:function(a){return a?(this.getSize(a),this.tooltip.html(a).css({width:this.width,height:this.height,visibility:"visible"}),void(this.hidden&&(this.hidden=!1,this.updatePosition()))):(this.tooltip.css("visibility","hidden"),void(this.hidden=!0))},updatePosition:function(a,b){if(a===c){if(this.mousex===c)return;a=this.mousex-this.offsetLeft,b=this.mousey-this.offsetTop}else this.mousex=a-=this.offsetLeft,this.mousey=b-=this.offsetTop;this.height&&this.width&&!this.hidden&&(b-=this.height+this.tooltipOffsetY,a+=this.tooltipOffsetX,b<this.scrollTop&&(b=this.scrollTop),a<this.scrollLeft?a=this.scrollLeft:a+this.width>this.scrollRight&&(a=this.scrollRight-this.width),this.tooltip.css({left:a,top:b}))},remove:function(){this.tooltip.remove(),this.sizetip.remove(),this.sizetip=this.tooltip=c,d(window).unbind("resize.jqs scroll.jqs")}}),E=function(){p(D)},d(E),J=[],d.fn.sparkline=function(b,e){return this.each(function(){var f,g,h=new d.fn.sparkline.options(this,e),i=d(this);if(f=function(){var e,f,g,j,k,l,m;return"html"===b||b===c?(m=this.getAttribute(h.get("tagValuesAttribute")),(m===c||null===m)&&(m=i.html()),e=m.replace(/(^\s*<!--)|(-->\s*$)|\s+/g,"").split(",")):e=b,f="auto"===h.get("width")?e.length*h.get("defaultPixelsPerValue"):h.get("width"),"auto"===h.get("height")?h.get("composite")&&d.data(this,"_jqs_vcanvas")||(j=a.createElement("span"),j.innerHTML="a",i.html(j),g=d(j).innerHeight()||d(j).height(),d(j).remove(),j=null):g=h.get("height"),h.get("disableInteraction")?k=!1:(k=d.data(this,"_jqs_mhandler"),k?h.get("composite")||k.reset():(k=new t(this,h),d.data(this,"_jqs_mhandler",k))),h.get("composite")&&!d.data(this,"_jqs_vcanvas")?void(d.data(this,"_jqs_errnotify")||(alert("Attempted to attach a composite sparkline to an element with no existing sparkline"),d.data(this,"_jqs_errnotify",!0))):(l=new(d.fn.sparkline[h.get("type")])(this,e,h,f,g),l.render(),void(k&&k.registerSparkline(l)))},d(this).html()&&!h.get("disableHiddenCheck")&&d(this).is(":hidden")||!d(this).parents("body").length){if(!h.get("composite")&&d.data(this,"_jqs_pending"))for(g=J.length;g;g--)J[g-1][0]==this&&J.splice(g-1,1);J.push([this,f]),d.data(this,"_jqs_pending",!0)}else f.call(this)})},d.fn.sparkline.defaults=e(),d.sparkline_display_visible=function(){var a,b,c,e=[];for(b=0,c=J.length;c>b;b++)a=J[b][0],d(a).is(":visible")&&!d(a).parents().is(":hidden")?(J[b][1].call(a),d.data(J[b][0],"_jqs_pending",!1),e.push(b)):d(a).closest("html").length||d.data(a,"_jqs_pending")||(d.data(J[b][0],"_jqs_pending",!1),e.push(b));for(b=e.length;b;b--)J.splice(e[b-1],1)},d.fn.sparkline.options=f({init:function(a,b){var c,e,f,g;this.userOptions=b=b||{},this.tag=a,this.tagValCache={},e=d.fn.sparkline.defaults,f=e.common,this.tagOptionsPrefix=b.enableTagOptions&&(b.tagOptionsPrefix||f.tagOptionsPrefix),g=this.getTagSetting("type"),c=g===K?e[b.type||f.type]:e[g],this.mergedOptions=d.extend({},f,c,b)},getTagSetting:function(a){var b,d,e,f,g=this.tagOptionsPrefix;if(g===!1||g===c)return K;if(this.tagValCache.hasOwnProperty(a))b=this.tagValCache.key;else{if(b=this.tag.getAttribute(g+a),b===c||null===b)b=K;else if("["===b.substr(0,1))for(b=b.substr(1,b.length-2).split(","),d=b.length;d--;)b[d]=j(b[d].replace(/(^\s*)|(\s*$)/g,""));else if("{"===b.substr(0,1))for(e=b.substr(1,b.length-2).split(","),b={},d=e.length;d--;)f=e[d].split(":",2),b[f[0].replace(/(^\s*)|(\s*$)/g,"")]=j(f[1].replace(/(^\s*)|(\s*$)/g,""));else b=j(b);this.tagValCache.key=b}return b},get:function(a,b){var d,e=this.getTagSetting(a);return e!==K?e:(d=this.mergedOptions[a])===c?b:d}}),d.fn.sparkline._base=f({disabled:!1,init:function(a,b,e,f,g){this.el=a,this.$el=d(a),this.values=b,this.options=e,this.width=f,this.height=g,this.currentRegion=c},initTarget:function(){var a=!this.options.get("disableInteraction");(this.target=this.$el.simpledraw(this.width,this.height,this.options.get("composite"),a))?(this.canvasWidth=this.target.pixelWidth,this.canvasHeight=this.target.pixelHeight):this.disabled=!0},render:function(){return this.disabled?(this.el.innerHTML="",!1):!0},getRegion:function(){},setRegionHighlight:function(a,b,d){var e,f=this.currentRegion,g=!this.options.get("disableHighlight");return b>this.canvasWidth||d>this.canvasHeight||0>b||0>d?null:(e=this.getRegion(a,b,d),f!==e?(f!==c&&g&&this.removeHighlight(),this.currentRegion=e,e!==c&&g&&this.renderHighlight(),!0):!1)},clearRegionHighlight:function(){return this.currentRegion!==c?(this.removeHighlight(),this.currentRegion=c,!0):!1},renderHighlight:function(){this.changeHighlight(!0)},removeHighlight:function(){this.changeHighlight(!1)},changeHighlight:function(){},getCurrentRegionTooltip:function(){var a,b,e,f,h,i,j,k,l,m,n,o,p,q,r=this.options,s="",t=[];if(this.currentRegion===c)return"";if(a=this.getCurrentRegionFields(),n=r.get("tooltipFormatter"))return n(this,r,a);if(r.get("tooltipChartTitle")&&(s+='<div class="jqs jqstitle">'+r.get("tooltipChartTitle")+"</div>\n"),b=this.options.get("tooltipFormat"),!b)return"";if(d.isArray(b)||(b=[b]),d.isArray(a)||(a=[a]),j=this.options.get("tooltipFormatFieldlist"),k=this.options.get("tooltipFormatFieldlistKey"),j&&k){for(l=[],i=a.length;i--;)m=a[i][k],-1!=(q=d.inArray(m,j))&&(l[q]=a[i]);a=l}for(e=b.length,p=a.length,i=0;e>i;i++)for(o=b[i],"string"==typeof o&&(o=new g(o)),f=o.fclass||"jqsfield",q=0;p>q;q++)a[q].isNull&&r.get("tooltipSkipNull")||(d.extend(a[q],{prefix:r.get("tooltipPrefix"),suffix:r.get("tooltipSuffix")}),h=o.render(a[q],r.get("tooltipValueLookups"),r),t.push('<div class="'+f+'">'+h+"</div>"));return t.length?s+t.join("\n"):""},getCurrentRegionFields:function(){},calcHighlightColor:function(a,c){var d,e,f,g,i=c.get("highlightColor"),j=c.get("highlightLighten");if(i)return i;if(j&&(d=/^#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(a)||/^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(a))){for(f=[],e=4===a.length?16:1,g=0;3>g;g++)f[g]=h(b.round(parseInt(d[g+1],16)*e*j),0,255);return"rgb("+f.join(",")+")"}return a}}),v={changeHighlight:function(a){var b,c=this.currentRegion,e=this.target,f=this.regionShapes[c];f&&(b=this.renderRegion(c,a),d.isArray(b)||d.isArray(f)?(e.replaceWithShapes(f,b),this.regionShapes[c]=d.map(b,function(a){return a.id})):(e.replaceWithShape(f,b),this.regionShapes[c]=b.id))},render:function(){var a,b,c,e,f=this.values,g=this.target,h=this.regionShapes;if(this.cls._super.render.call(this)){for(c=f.length;c--;)if(a=this.renderRegion(c))if(d.isArray(a)){for(b=[],e=a.length;e--;)a[e].append(),b.push(a[e].id);h[c]=b}else a.append(),h[c]=a.id;else h[c]=null;g.render()}}},d.fn.sparkline.line=w=f(d.fn.sparkline._base,{type:"line",init:function(a,b,c,d,e){w._super.init.call(this,a,b,c,d,e),this.vertices=[],this.regionMap=[],this.xvalues=[],this.yvalues=[],this.yminmax=[],this.hightlightSpotId=null,this.lastShapeId=null,this.initTarget()},getRegion:function(a,b){var d,e=this.regionMap;for(d=e.length;d--;)if(null!==e[d]&&b>=e[d][0]&&b<=e[d][1])return e[d][2];return c},getCurrentRegionFields:function(){var a=this.currentRegion;return{isNull:null===this.yvalues[a],x:this.xvalues[a],y:this.yvalues[a],color:this.options.get("lineColor"),fillColor:this.options.get("fillColor"),offset:a}},renderHighlight:function(){var a,b,d=this.currentRegion,e=this.target,f=this.vertices[d],g=this.options,h=g.get("spotRadius"),i=g.get("highlightSpotColor"),j=g.get("highlightLineColor");f&&(h&&i&&(a=e.drawCircle(f[0],f[1],h,c,i),this.highlightSpotId=a.id,e.insertAfterShape(this.lastShapeId,a)),j&&(b=e.drawLine(f[0],this.canvasTop,f[0],this.canvasTop+this.canvasHeight,j),this.highlightLineId=b.id,e.insertAfterShape(this.lastShapeId,b)))},removeHighlight:function(){var a=this.target;this.highlightSpotId&&(a.removeShapeId(this.highlightSpotId),this.highlightSpotId=null),this.highlightLineId&&(a.removeShapeId(this.highlightLineId),this.highlightLineId=null)},scanValues:function(){var a,c,d,e,f,g=this.values,h=g.length,i=this.xvalues,j=this.yvalues,k=this.yminmax;for(a=0;h>a;a++)c=g[a],d="string"==typeof g[a],e="object"==typeof g[a]&&g[a]instanceof Array,f=d&&g[a].split(":"),d&&2===f.length?(i.push(Number(f[0])),j.push(Number(f[1])),k.push(Number(f[1]))):e?(i.push(c[0]),j.push(c[1]),k.push(c[1])):(i.push(a),null===g[a]||"null"===g[a]?j.push(null):(j.push(Number(c)),k.push(Number(c))));this.options.get("xvalues")&&(i=this.options.get("xvalues")),this.maxy=this.maxyorg=b.max.apply(b,k),this.miny=this.minyorg=b.min.apply(b,k),this.maxx=b.max.apply(b,i),this.minx=b.min.apply(b,i),this.xvalues=i,this.yvalues=j,this.yminmax=k},processRangeOptions:function(){var a=this.options,b=a.get("normalRangeMin"),d=a.get("normalRangeMax");b!==c&&(b<this.miny&&(this.miny=b),d>this.maxy&&(this.maxy=d)),a.get("chartRangeMin")!==c&&(a.get("chartRangeClip")||a.get("chartRangeMin")<this.miny)&&(this.miny=a.get("chartRangeMin")),a.get("chartRangeMax")!==c&&(a.get("chartRangeClip")||a.get("chartRangeMax")>this.maxy)&&(this.maxy=a.get("chartRangeMax")),a.get("chartRangeMinX")!==c&&(a.get("chartRangeClipX")||a.get("chartRangeMinX")<this.minx)&&(this.minx=a.get("chartRangeMinX")),a.get("chartRangeMaxX")!==c&&(a.get("chartRangeClipX")||a.get("chartRangeMaxX")>this.maxx)&&(this.maxx=a.get("chartRangeMaxX"))},drawNormalRange:function(a,d,e,f,g){var h=this.options.get("normalRangeMin"),i=this.options.get("normalRangeMax"),j=d+b.round(e-e*((i-this.miny)/g)),k=b.round(e*(i-h)/g);this.target.drawRect(a,j,f,k,c,this.options.get("normalRangeColor")).append()},render:function(){var a,e,f,g,h,i,j,k,l,m,n,o,p,q,r,t,u,v,x,y,z,A,B,C,D,E=this.options,F=this.target,G=this.canvasWidth,H=this.canvasHeight,I=this.vertices,J=E.get("spotRadius"),K=this.regionMap;if(w._super.render.call(this)&&(this.scanValues(),this.processRangeOptions(),B=this.xvalues,C=this.yvalues,this.yminmax.length&&!(this.yvalues.length<2))){for(g=h=0,a=this.maxx-this.minx===0?1:this.maxx-this.minx,e=this.maxy-this.miny===0?1:this.maxy-this.miny,f=this.yvalues.length-1,J&&(4*J>G||4*J>H)&&(J=0),J&&(z=E.get("highlightSpotColor")&&!E.get("disableInteraction"),(z||E.get("minSpotColor")||E.get("spotColor")&&C[f]===this.miny)&&(H-=b.ceil(J)),(z||E.get("maxSpotColor")||E.get("spotColor")&&C[f]===this.maxy)&&(H-=b.ceil(J),g+=b.ceil(J)),(z||(E.get("minSpotColor")||E.get("maxSpotColor"))&&(C[0]===this.miny||C[0]===this.maxy))&&(h+=b.ceil(J),G-=b.ceil(J)),(z||E.get("spotColor")||E.get("minSpotColor")||E.get("maxSpotColor")&&(C[f]===this.miny||C[f]===this.maxy))&&(G-=b.ceil(J))),H--,E.get("normalRangeMin")===c||E.get("drawNormalOnTop")||this.drawNormalRange(h,g,H,G,e),j=[],k=[j],q=r=null,t=C.length,D=0;t>D;D++)l=B[D],n=B[D+1],m=C[D],o=h+b.round((l-this.minx)*(G/a)),p=t-1>D?h+b.round((n-this.minx)*(G/a)):G,r=o+(p-o)/2,K[D]=[q||0,r,D],q=r,null===m?D&&(null!==C[D-1]&&(j=[],k.push(j)),I.push(null)):(m<this.miny&&(m=this.miny),m>this.maxy&&(m=this.maxy),j.length||j.push([o,g+H]),i=[o,g+b.round(H-H*((m-this.miny)/e))],j.push(i),I.push(i));for(u=[],v=[],x=k.length,D=0;x>D;D++)j=k[D],j.length&&(E.get("fillColor")&&(j.push([j[j.length-1][0],g+H]),v.push(j.slice(0)),j.pop()),j.length>2&&(j[0]=[j[0][0],j[1][1]]),u.push(j));for(x=v.length,D=0;x>D;D++)F.drawShape(v[D],E.get("fillColor"),E.get("fillColor")).append();for(E.get("normalRangeMin")!==c&&E.get("drawNormalOnTop")&&this.drawNormalRange(h,g,H,G,e),x=u.length,D=0;x>D;D++)F.drawShape(u[D],E.get("lineColor"),c,E.get("lineWidth")).append();if(J&&E.get("valueSpots"))for(y=E.get("valueSpots"),y.get===c&&(y=new s(y)),D=0;t>D;D++)A=y.get(C[D]),A&&F.drawCircle(h+b.round((B[D]-this.minx)*(G/a)),g+b.round(H-H*((C[D]-this.miny)/e)),J,c,A).append();J&&E.get("spotColor")&&null!==C[f]&&F.drawCircle(h+b.round((B[B.length-1]-this.minx)*(G/a)),g+b.round(H-H*((C[f]-this.miny)/e)),J,c,E.get("spotColor")).append(),this.maxy!==this.minyorg&&(J&&E.get("minSpotColor")&&(l=B[d.inArray(this.minyorg,C)],F.drawCircle(h+b.round((l-this.minx)*(G/a)),g+b.round(H-H*((this.minyorg-this.miny)/e)),J,c,E.get("minSpotColor")).append()),J&&E.get("maxSpotColor")&&(l=B[d.inArray(this.maxyorg,C)],F.drawCircle(h+b.round((l-this.minx)*(G/a)),g+b.round(H-H*((this.maxyorg-this.miny)/e)),J,c,E.get("maxSpotColor")).append())),this.lastShapeId=F.getLastShapeId(),this.canvasTop=g,F.render()}}}),d.fn.sparkline.bar=x=f(d.fn.sparkline._base,v,{type:"bar",init:function(a,e,f,g,i){var m,n,o,p,q,r,t,u,v,w,y,z,A,B,C,D,E,F,G,H,I,J,K=parseInt(f.get("barWidth"),10),L=parseInt(f.get("barSpacing"),10),M=f.get("chartRangeMin"),N=f.get("chartRangeMax"),O=f.get("chartRangeClip"),P=1/0,Q=-1/0;for(x._super.init.call(this,a,e,f,g,i),r=0,t=e.length;t>r;r++)H=e[r],m="string"==typeof H&&H.indexOf(":")>-1,(m||d.isArray(H))&&(C=!0,m&&(H=e[r]=k(H.split(":"))),H=l(H,null),n=b.min.apply(b,H),o=b.max.apply(b,H),P>n&&(P=n),o>Q&&(Q=o));this.stacked=C,this.regionShapes={},this.barWidth=K,this.barSpacing=L,this.totalBarWidth=K+L,this.width=g=e.length*K+(e.length-1)*L,this.initTarget(),O&&(A=M===c?-1/0:M,B=N===c?1/0:N),q=[],p=C?[]:q;var R=[],S=[];for(r=0,t=e.length;t>r;r++)if(C)for(D=e[r],e[r]=G=[],R[r]=0,p[r]=S[r]=0,E=0,F=D.length;F>E;E++)H=G[E]=O?h(D[E],A,B):D[E],null!==H&&(H>0&&(R[r]+=H),0>P&&Q>0?0>H?S[r]+=b.abs(H):p[r]+=H:p[r]+=b.abs(H-(0>H?Q:P)),q.push(H));else H=O?h(e[r],A,B):e[r],H=e[r]=j(H),null!==H&&q.push(H);this.max=z=b.max.apply(b,q),this.min=y=b.min.apply(b,q),this.stackMax=Q=C?b.max.apply(b,R):z,this.stackMin=P=C?b.min.apply(b,q):y,f.get("chartRangeMin")!==c&&(f.get("chartRangeClip")||f.get("chartRangeMin")<y)&&(y=f.get("chartRangeMin")),f.get("chartRangeMax")!==c&&(f.get("chartRangeClip")||f.get("chartRangeMax")>z)&&(z=f.get("chartRangeMax")),this.zeroAxis=v=f.get("zeroAxis",!0),w=0>=y&&z>=0&&v?0:0==v?y:y>0?y:z,this.xaxisOffset=w,u=C?b.max.apply(b,p)+b.max.apply(b,S):z-y,this.canvasHeightEf=v&&0>y?this.canvasHeight-2:this.canvasHeight-1,w>y?(J=C&&z>=0?Q:z,I=(J-w)/u*this.canvasHeight,I!==b.ceil(I)&&(this.canvasHeightEf-=2,I=b.ceil(I))):I=this.canvasHeight,this.yoffset=I,d.isArray(f.get("colorMap"))?(this.colorMapByIndex=f.get("colorMap"),this.colorMapByValue=null):(this.colorMapByIndex=null,this.colorMapByValue=f.get("colorMap"),this.colorMapByValue&&this.colorMapByValue.get===c&&(this.colorMapByValue=new s(this.colorMapByValue))),this.range=u},getRegion:function(a,d){var e=b.floor(d/this.totalBarWidth);return 0>e||e>=this.values.length?c:e},getCurrentRegionFields:function(){var a,b,c=this.currentRegion,d=q(this.values[c]),e=[];for(b=d.length;b--;)a=d[b],e.push({isNull:null===a,value:a,color:this.calcColor(b,a,c),offset:c});return e},calcColor:function(a,b,e){var f,g,h=this.colorMapByIndex,i=this.colorMapByValue,j=this.options;return f=j.get(this.stacked?"stackedBarColor":0>b?"negBarColor":"barColor"),0===b&&j.get("zeroColor")!==c&&(f=j.get("zeroColor")),i&&(g=i.get(b))?f=g:h&&h.length>e&&(f=h[e]),d.isArray(f)?f[a%f.length]:f},renderRegion:function(a,e){var f,g,h,i,j,k,l,m,o,p,q=this.values[a],r=this.options,s=this.xaxisOffset,t=[],u=this.range,v=this.stacked,w=this.target,x=a*this.totalBarWidth,y=this.canvasHeightEf,z=this.yoffset;if(q=d.isArray(q)?q:[q],l=q.length,m=q[0],i=n(null,q),p=n(s,q,!0),i)return r.get("nullColor")?(h=e?r.get("nullColor"):this.calcHighlightColor(r.get("nullColor"),r),f=z>0?z-1:z,w.drawRect(x,f,this.barWidth-1,0,h,h)):c;for(j=z,k=0;l>k;k++){if(m=q[k],v&&m===s){if(!p||o)continue;o=!0}g=u>0?b.floor(y*(b.abs(m-s)/u))+1:1,s>m||m===s&&0===z?(f=j,j+=g):(f=z-g,z-=g),h=this.calcColor(k,m,a),e&&(h=this.calcHighlightColor(h,r)),t.push(w.drawRect(x,f,this.barWidth-1,g-1,h,h))}return 1===t.length?t[0]:t}}),d.fn.sparkline.tristate=y=f(d.fn.sparkline._base,v,{type:"tristate",init:function(a,b,e,f,g){var h=parseInt(e.get("barWidth"),10),i=parseInt(e.get("barSpacing"),10);y._super.init.call(this,a,b,e,f,g),this.regionShapes={},this.barWidth=h,this.barSpacing=i,this.totalBarWidth=h+i,this.values=d.map(b,Number),this.width=f=b.length*h+(b.length-1)*i,d.isArray(e.get("colorMap"))?(this.colorMapByIndex=e.get("colorMap"),this.colorMapByValue=null):(this.colorMapByIndex=null,this.colorMapByValue=e.get("colorMap"),this.colorMapByValue&&this.colorMapByValue.get===c&&(this.colorMapByValue=new s(this.colorMapByValue))),this.initTarget()},getRegion:function(a,c){return b.floor(c/this.totalBarWidth)},getCurrentRegionFields:function(){var a=this.currentRegion;return{isNull:this.values[a]===c,value:this.values[a],color:this.calcColor(this.values[a],a),offset:a}},calcColor:function(a,b){var c,d,e=this.values,f=this.options,g=this.colorMapByIndex,h=this.colorMapByValue;return c=h&&(d=h.get(a))?d:g&&g.length>b?g[b]:f.get(e[b]<0?"negBarColor":e[b]>0?"posBarColor":"zeroBarColor")},renderRegion:function(a,c){var d,e,f,g,h,i,j=this.values,k=this.options,l=this.target;return d=l.pixelHeight,f=b.round(d/2),g=a*this.totalBarWidth,j[a]<0?(h=f,e=f-1):j[a]>0?(h=0,e=f-1):(h=f-1,e=2),i=this.calcColor(j[a],a),null!==i?(c&&(i=this.calcHighlightColor(i,k)),l.drawRect(g,h,this.barWidth-1,e-1,i,i)):void 0}}),d.fn.sparkline.discrete=z=f(d.fn.sparkline._base,v,{type:"discrete",init:function(a,e,f,g,h){z._super.init.call(this,a,e,f,g,h),this.regionShapes={},this.values=e=d.map(e,Number),this.min=b.min.apply(b,e),this.max=b.max.apply(b,e),this.range=this.max-this.min,this.width=g="auto"===f.get("width")?2*e.length:this.width,this.interval=b.floor(g/e.length),this.itemWidth=g/e.length,f.get("chartRangeMin")!==c&&(f.get("chartRangeClip")||f.get("chartRangeMin")<this.min)&&(this.min=f.get("chartRangeMin")),f.get("chartRangeMax")!==c&&(f.get("chartRangeClip")||f.get("chartRangeMax")>this.max)&&(this.max=f.get("chartRangeMax")),this.initTarget(),this.target&&(this.lineHeight="auto"===f.get("lineHeight")?b.round(.3*this.canvasHeight):f.get("lineHeight"))},getRegion:function(a,c){return b.floor(c/this.itemWidth)},getCurrentRegionFields:function(){var a=this.currentRegion;return{isNull:this.values[a]===c,value:this.values[a],offset:a}},renderRegion:function(a,c){var d,e,f,g,i=this.values,j=this.options,k=this.min,l=this.max,m=this.range,n=this.interval,o=this.target,p=this.canvasHeight,q=this.lineHeight,r=p-q;return e=h(i[a],k,l),g=a*n,d=b.round(r-r*((e-k)/m)),f=j.get(j.get("thresholdColor")&&e<j.get("thresholdValue")?"thresholdColor":"lineColor"),c&&(f=this.calcHighlightColor(f,j)),o.drawLine(g,d,g,d+q,f)}}),d.fn.sparkline.bullet=A=f(d.fn.sparkline._base,{type:"bullet",init:function(a,d,e,f,g){var h,i,j;A._super.init.call(this,a,d,e,f,g),this.values=d=k(d),j=d.slice(),j[0]=null===j[0]?j[2]:j[0],j[1]=null===d[1]?j[2]:j[1],h=b.min.apply(b,d),i=b.max.apply(b,d),h=e.get("base")===c?0>h?h:0:e.get("base"),this.min=h,this.max=i,this.range=i-h,this.shapes={},this.valueShapes={},this.regiondata={},this.width=f="auto"===e.get("width")?"4.0em":f,this.target=this.$el.simpledraw(f,g,e.get("composite")),d.length||(this.disabled=!0),this.initTarget()},getRegion:function(a,b,d){var e=this.target.getShapeAt(a,b,d);return e!==c&&this.shapes[e]!==c?this.shapes[e]:c},getCurrentRegionFields:function(){var a=this.currentRegion;return{fieldkey:a.substr(0,1),value:this.values[a.substr(1)],region:a}},changeHighlight:function(a){var b,c=this.currentRegion,d=this.valueShapes[c];switch(delete this.shapes[d],c.substr(0,1)){case"r":b=this.renderRange(c.substr(1),a);break;case"p":b=this.renderPerformance(a);break;case"t":b=this.renderTarget(a)}this.valueShapes[c]=b.id,this.shapes[b.id]=c,this.target.replaceWithShape(d,b)},renderRange:function(a,c){var d=this.values[a],e=b.round(this.canvasWidth*((d-this.min)/this.range)),f=this.options.get("rangeColors")[a-2];return c&&(f=this.calcHighlightColor(f,this.options)),this.target.drawRect(0,0,e-1,this.canvasHeight-1,f,f)},renderPerformance:function(a){var c=this.values[1],d=b.round(this.canvasWidth*((c-this.min)/this.range)),e=this.options.get("performanceColor");return a&&(e=this.calcHighlightColor(e,this.options)),this.target.drawRect(0,b.round(.3*this.canvasHeight),d-1,b.round(.4*this.canvasHeight)-1,e,e)},renderTarget:function(a){var c=this.values[0],d=b.round(this.canvasWidth*((c-this.min)/this.range)-this.options.get("targetWidth")/2),e=b.round(.1*this.canvasHeight),f=this.canvasHeight-2*e,g=this.options.get("targetColor");return a&&(g=this.calcHighlightColor(g,this.options)),this.target.drawRect(d,e,this.options.get("targetWidth")-1,f-1,g,g)},render:function(){var a,b,c=this.values.length,d=this.target;if(A._super.render.call(this)){for(a=2;c>a;a++)b=this.renderRange(a).append(),this.shapes[b.id]="r"+a,this.valueShapes["r"+a]=b.id;null!==this.values[1]&&(b=this.renderPerformance().append(),this.shapes[b.id]="p1",this.valueShapes.p1=b.id),null!==this.values[0]&&(b=this.renderTarget().append(),this.shapes[b.id]="t0",this.valueShapes.t0=b.id),d.render()}}}),d.fn.sparkline.pie=B=f(d.fn.sparkline._base,{type:"pie",init:function(a,c,e,f,g){var h,i=0;if(B._super.init.call(this,a,c,e,f,g),this.shapes={},this.valueShapes={},this.values=c=d.map(c,Number),"auto"===e.get("width")&&(this.width=this.height),c.length>0)for(h=c.length;h--;)i+=c[h];this.total=i,this.initTarget(),this.radius=b.floor(b.min(this.canvasWidth,this.canvasHeight)/2)},getRegion:function(a,b,d){var e=this.target.getShapeAt(a,b,d);return e!==c&&this.shapes[e]!==c?this.shapes[e]:c},getCurrentRegionFields:function(){var a=this.currentRegion;return{isNull:this.values[a]===c,value:this.values[a],percent:this.values[a]/this.total*100,color:this.options.get("sliceColors")[a%this.options.get("sliceColors").length],offset:a}},changeHighlight:function(a){var b=this.currentRegion,c=this.renderSlice(b,a),d=this.valueShapes[b];delete this.shapes[d],this.target.replaceWithShape(d,c),this.valueShapes[b]=c.id,this.shapes[c.id]=b},renderSlice:function(a,d){var e,f,g,h,i,j=this.target,k=this.options,l=this.radius,m=k.get("borderWidth"),n=k.get("offset"),o=2*b.PI,p=this.values,q=this.total,r=n?2*b.PI*(n/360):0;for(h=p.length,g=0;h>g;g++){if(e=r,f=r,q>0&&(f=r+o*(p[g]/q)),a===g)return i=k.get("sliceColors")[g%k.get("sliceColors").length],d&&(i=this.calcHighlightColor(i,k)),j.drawPieSlice(l,l,l-m,e,f,c,i);r=f}},render:function(){var a,d,e=this.target,f=this.values,g=this.options,h=this.radius,i=g.get("borderWidth");
if(B._super.render.call(this)){for(i&&e.drawCircle(h,h,b.floor(h-i/2),g.get("borderColor"),c,i).append(),d=f.length;d--;)f[d]&&(a=this.renderSlice(d).append(),this.valueShapes[d]=a.id,this.shapes[a.id]=d);e.render()}}}),d.fn.sparkline.box=C=f(d.fn.sparkline._base,{type:"box",init:function(a,b,c,e,f){C._super.init.call(this,a,b,c,e,f),this.values=d.map(b,Number),this.width="auto"===c.get("width")?"4.0em":e,this.initTarget(),this.values.length||(this.disabled=1)},getRegion:function(){return 1},getCurrentRegionFields:function(){var a=[{field:"lq",value:this.quartiles[0]},{field:"med",value:this.quartiles[1]},{field:"uq",value:this.quartiles[2]}];return this.loutlier!==c&&a.push({field:"lo",value:this.loutlier}),this.routlier!==c&&a.push({field:"ro",value:this.routlier}),this.lwhisker!==c&&a.push({field:"lw",value:this.lwhisker}),this.rwhisker!==c&&a.push({field:"rw",value:this.rwhisker}),a},render:function(){var a,d,e,f,g,h,j,k,l,m,n,o=this.target,p=this.values,q=p.length,r=this.options,s=this.canvasWidth,t=this.canvasHeight,u=r.get("chartRangeMin")===c?b.min.apply(b,p):r.get("chartRangeMin"),v=r.get("chartRangeMax")===c?b.max.apply(b,p):r.get("chartRangeMax"),w=0;if(C._super.render.call(this)){if(r.get("raw"))r.get("showOutliers")&&p.length>5?(d=p[0],a=p[1],f=p[2],g=p[3],h=p[4],j=p[5],k=p[6]):(a=p[0],f=p[1],g=p[2],h=p[3],j=p[4]);else if(p.sort(function(a,b){return a-b}),f=i(p,1),g=i(p,2),h=i(p,3),e=h-f,r.get("showOutliers")){for(a=j=c,l=0;q>l;l++)a===c&&p[l]>f-e*r.get("outlierIQR")&&(a=p[l]),p[l]<h+e*r.get("outlierIQR")&&(j=p[l]);d=p[0],k=p[q-1]}else a=p[0],j=p[q-1];this.quartiles=[f,g,h],this.lwhisker=a,this.rwhisker=j,this.loutlier=d,this.routlier=k,n=s/(v-u+1),r.get("showOutliers")&&(w=b.ceil(r.get("spotRadius")),s-=2*b.ceil(r.get("spotRadius")),n=s/(v-u+1),a>d&&o.drawCircle((d-u)*n+w,t/2,r.get("spotRadius"),r.get("outlierLineColor"),r.get("outlierFillColor")).append(),k>j&&o.drawCircle((k-u)*n+w,t/2,r.get("spotRadius"),r.get("outlierLineColor"),r.get("outlierFillColor")).append()),o.drawRect(b.round((f-u)*n+w),b.round(.1*t),b.round((h-f)*n),b.round(.8*t),r.get("boxLineColor"),r.get("boxFillColor")).append(),o.drawLine(b.round((a-u)*n+w),b.round(t/2),b.round((f-u)*n+w),b.round(t/2),r.get("lineColor")).append(),o.drawLine(b.round((a-u)*n+w),b.round(t/4),b.round((a-u)*n+w),b.round(t-t/4),r.get("whiskerColor")).append(),o.drawLine(b.round((j-u)*n+w),b.round(t/2),b.round((h-u)*n+w),b.round(t/2),r.get("lineColor")).append(),o.drawLine(b.round((j-u)*n+w),b.round(t/4),b.round((j-u)*n+w),b.round(t-t/4),r.get("whiskerColor")).append(),o.drawLine(b.round((g-u)*n+w),b.round(.1*t),b.round((g-u)*n+w),b.round(.9*t),r.get("medianColor")).append(),r.get("target")&&(m=b.ceil(r.get("spotRadius")),o.drawLine(b.round((r.get("target")-u)*n+w),b.round(t/2-m),b.round((r.get("target")-u)*n+w),b.round(t/2+m),r.get("targetColor")).append(),o.drawLine(b.round((r.get("target")-u)*n+w-m),b.round(t/2),b.round((r.get("target")-u)*n+w+m),b.round(t/2),r.get("targetColor")).append()),o.render()}}}),F=f({init:function(a,b,c,d){this.target=a,this.id=b,this.type=c,this.args=d},append:function(){return this.target.appendShape(this),this}}),G=f({_pxregex:/(\d+)(px)?\s*$/i,init:function(a,b,c){a&&(this.width=a,this.height=b,this.target=c,this.lastShapeId=null,c[0]&&(c=c[0]),d.data(c,"_jqs_vcanvas",this))},drawLine:function(a,b,c,d,e,f){return this.drawShape([[a,b],[c,d]],e,f)},drawShape:function(a,b,c,d){return this._genShape("Shape",[a,b,c,d])},drawCircle:function(a,b,c,d,e,f){return this._genShape("Circle",[a,b,c,d,e,f])},drawPieSlice:function(a,b,c,d,e,f,g){return this._genShape("PieSlice",[a,b,c,d,e,f,g])},drawRect:function(a,b,c,d,e,f){return this._genShape("Rect",[a,b,c,d,e,f])},getElement:function(){return this.canvas},getLastShapeId:function(){return this.lastShapeId},reset:function(){alert("reset not implemented")},_insert:function(a,b){d(b).html(a)},_calculatePixelDims:function(a,b,c){var e;e=this._pxregex.exec(b),this.pixelHeight=e?e[1]:d(c).height(),e=this._pxregex.exec(a),this.pixelWidth=e?e[1]:d(c).width()},_genShape:function(a,b){var c=L++;return b.unshift(c),new F(this,c,a,b)},appendShape:function(){alert("appendShape not implemented")},replaceWithShape:function(){alert("replaceWithShape not implemented")},insertAfterShape:function(){alert("insertAfterShape not implemented")},removeShapeId:function(){alert("removeShapeId not implemented")},getShapeAt:function(){alert("getShapeAt not implemented")},render:function(){alert("render not implemented")}}),H=f(G,{init:function(b,e,f,g){H._super.init.call(this,b,e,f),this.canvas=a.createElement("canvas"),f[0]&&(f=f[0]),d.data(f,"_jqs_vcanvas",this),d(this.canvas).css({display:"inline-block",width:b,height:e,verticalAlign:"top"}),this._insert(this.canvas,f),this._calculatePixelDims(b,e,this.canvas),this.canvas.width=this.pixelWidth,this.canvas.height=this.pixelHeight,this.interact=g,this.shapes={},this.shapeseq=[],this.currentTargetShapeId=c,d(this.canvas).css({width:this.pixelWidth,height:this.pixelHeight})},_getContext:function(a,b,d){var e=this.canvas.getContext("2d");return a!==c&&(e.strokeStyle=a),e.lineWidth=d===c?1:d,b!==c&&(e.fillStyle=b),e},reset:function(){var a=this._getContext();a.clearRect(0,0,this.pixelWidth,this.pixelHeight),this.shapes={},this.shapeseq=[],this.currentTargetShapeId=c},_drawShape:function(a,b,d,e,f){var g,h,i=this._getContext(d,e,f);for(i.beginPath(),i.moveTo(b[0][0]+.5,b[0][1]+.5),g=1,h=b.length;h>g;g++)i.lineTo(b[g][0]+.5,b[g][1]+.5);d!==c&&i.stroke(),e!==c&&i.fill(),this.targetX!==c&&this.targetY!==c&&i.isPointInPath(this.targetX,this.targetY)&&(this.currentTargetShapeId=a)},_drawCircle:function(a,d,e,f,g,h,i){var j=this._getContext(g,h,i);j.beginPath(),j.arc(d,e,f,0,2*b.PI,!1),this.targetX!==c&&this.targetY!==c&&j.isPointInPath(this.targetX,this.targetY)&&(this.currentTargetShapeId=a),g!==c&&j.stroke(),h!==c&&j.fill()},_drawPieSlice:function(a,b,d,e,f,g,h,i){var j=this._getContext(h,i);j.beginPath(),j.moveTo(b,d),j.arc(b,d,e,f,g,!1),j.lineTo(b,d),j.closePath(),h!==c&&j.stroke(),i&&j.fill(),this.targetX!==c&&this.targetY!==c&&j.isPointInPath(this.targetX,this.targetY)&&(this.currentTargetShapeId=a)},_drawRect:function(a,b,c,d,e,f,g){return this._drawShape(a,[[b,c],[b+d,c],[b+d,c+e],[b,c+e],[b,c]],f,g)},appendShape:function(a){return this.shapes[a.id]=a,this.shapeseq.push(a.id),this.lastShapeId=a.id,a.id},replaceWithShape:function(a,b){var c,d=this.shapeseq;for(this.shapes[b.id]=b,c=d.length;c--;)d[c]==a&&(d[c]=b.id);delete this.shapes[a]},replaceWithShapes:function(a,b){var c,d,e,f=this.shapeseq,g={};for(d=a.length;d--;)g[a[d]]=!0;for(d=f.length;d--;)c=f[d],g[c]&&(f.splice(d,1),delete this.shapes[c],e=d);for(d=b.length;d--;)f.splice(e,0,b[d].id),this.shapes[b[d].id]=b[d]},insertAfterShape:function(a,b){var c,d=this.shapeseq;for(c=d.length;c--;)if(d[c]===a)return d.splice(c+1,0,b.id),void(this.shapes[b.id]=b)},removeShapeId:function(a){var b,c=this.shapeseq;for(b=c.length;b--;)if(c[b]===a){c.splice(b,1);break}delete this.shapes[a]},getShapeAt:function(a,b,c){return this.targetX=b,this.targetY=c,this.render(),this.currentTargetShapeId},render:function(){var a,b,c,d=this.shapeseq,e=this.shapes,f=d.length,g=this._getContext();for(g.clearRect(0,0,this.pixelWidth,this.pixelHeight),c=0;f>c;c++)a=d[c],b=e[a],this["_draw"+b.type].apply(this,b.args);this.interact||(this.shapes={},this.shapeseq=[])}}),I=f(G,{init:function(b,c,e){var f;I._super.init.call(this,b,c,e),e[0]&&(e=e[0]),d.data(e,"_jqs_vcanvas",this),this.canvas=a.createElement("span"),d(this.canvas).css({display:"inline-block",position:"relative",overflow:"hidden",width:b,height:c,margin:"0px",padding:"0px",verticalAlign:"top"}),this._insert(this.canvas,e),this._calculatePixelDims(b,c,this.canvas),this.canvas.width=this.pixelWidth,this.canvas.height=this.pixelHeight,f='<v:group coordorigin="0 0" coordsize="'+this.pixelWidth+" "+this.pixelHeight+'" style="position:absolute;top:0;left:0;width:'+this.pixelWidth+"px;height="+this.pixelHeight+'px;"></v:group>',this.canvas.insertAdjacentHTML("beforeEnd",f),this.group=d(this.canvas).children()[0],this.rendered=!1,this.prerender=""},_drawShape:function(a,b,d,e,f){var g,h,i,j,k,l,m,n=[];for(m=0,l=b.length;l>m;m++)n[m]=""+b[m][0]+","+b[m][1];return g=n.splice(0,1),f=f===c?1:f,h=d===c?' stroked="false" ':' strokeWeight="'+f+'px" strokeColor="'+d+'" ',i=e===c?' filled="false"':' fillColor="'+e+'" filled="true" ',j=n[0]===n[n.length-1]?"x ":"",k='<v:shape coordorigin="0 0" coordsize="'+this.pixelWidth+" "+this.pixelHeight+'"  id="jqsshape'+a+'" '+h+i+' style="position:absolute;left:0px;top:0px;height:'+this.pixelHeight+"px;width:"+this.pixelWidth+'px;padding:0px;margin:0px;"  path="m '+g+" l "+n.join(", ")+" "+j+'e"> </v:shape>'},_drawCircle:function(a,b,d,e,f,g,h){var i,j,k;return b-=e,d-=e,i=f===c?' stroked="false" ':' strokeWeight="'+h+'px" strokeColor="'+f+'" ',j=g===c?' filled="false"':' fillColor="'+g+'" filled="true" ',k='<v:oval  id="jqsshape'+a+'" '+i+j+' style="position:absolute;top:'+d+"px; left:"+b+"px; width:"+2*e+"px; height:"+2*e+'px"></v:oval>'},_drawPieSlice:function(a,d,e,f,g,h,i,j){var k,l,m,n,o,p,q,r;if(g===h)return"";if(h-g===2*b.PI&&(g=0,h=2*b.PI),l=d+b.round(b.cos(g)*f),m=e+b.round(b.sin(g)*f),n=d+b.round(b.cos(h)*f),o=e+b.round(b.sin(h)*f),l===n&&m===o){if(h-g<b.PI)return"";l=n=d+f,m=o=e}return l===n&&m===o&&h-g<b.PI?"":(k=[d-f,e-f,d+f,e+f,l,m,n,o],p=i===c?' stroked="false" ':' strokeWeight="1px" strokeColor="'+i+'" ',q=j===c?' filled="false"':' fillColor="'+j+'" filled="true" ',r='<v:shape coordorigin="0 0" coordsize="'+this.pixelWidth+" "+this.pixelHeight+'"  id="jqsshape'+a+'" '+p+q+' style="position:absolute;left:0px;top:0px;height:'+this.pixelHeight+"px;width:"+this.pixelWidth+'px;padding:0px;margin:0px;"  path="m '+d+","+e+" wa "+k.join(", ")+' x e"> </v:shape>')},_drawRect:function(a,b,c,d,e,f,g){return this._drawShape(a,[[b,c],[b,c+e],[b+d,c+e],[b+d,c],[b,c]],f,g)},reset:function(){this.group.innerHTML=""},appendShape:function(a){var b=this["_draw"+a.type].apply(this,a.args);return this.rendered?this.group.insertAdjacentHTML("beforeEnd",b):this.prerender+=b,this.lastShapeId=a.id,a.id},replaceWithShape:function(a,b){var c=d("#jqsshape"+a),e=this["_draw"+b.type].apply(this,b.args);c[0].outerHTML=e},replaceWithShapes:function(a,b){var c,e=d("#jqsshape"+a[0]),f="",g=b.length;for(c=0;g>c;c++)f+=this["_draw"+b[c].type].apply(this,b[c].args);for(e[0].outerHTML=f,c=1;c<a.length;c++)d("#jqsshape"+a[c]).remove()},insertAfterShape:function(a,b){var c=d("#jqsshape"+a),e=this["_draw"+b.type].apply(this,b.args);c[0].insertAdjacentHTML("afterEnd",e)},removeShapeId:function(a){var b=d("#jqsshape"+a);this.group.removeChild(b[0])},getShapeAt:function(a){var b=a.id.substr(8);return b},render:function(){this.rendered||(this.group.innerHTML=this.prerender,this.rendered=!0)}})})}(document,Math);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, $) {(function(e){var t={set:{colors:1,values:1,backgroundColor:1,scaleColors:1,normalizeFunction:1,focus:1},get:{selectedRegions:1,selectedMarkers:1,mapObject:1,regionName:1}};e.fn.vectorMap=function(e){var n,r,i,n=this.children(".jvectormap-container").data("mapObject");if(e==="addMap"){jvm.WorldMap.maps[arguments[1]]=arguments[2]}else{if(!(e!=="set"&&e!=="get"||!t[e][arguments[1]])){return r=arguments[1].charAt(0).toUpperCase()+arguments[1].substr(1),n[e+r].apply(n,Array.prototype.slice.call(arguments,2))}e=e||{},e.container=this,n=new jvm.WorldMap(e)}return this}})(jQuery),function(e){function r(t){var n=t||window.event,r=[].slice.call(arguments,1),i=0,s=!0,o=0,u=0;return t=e.event.fix(n),t.type="mousewheel",n.wheelDelta&&(i=n.wheelDelta/120),n.detail&&(i=-n.detail/3),u=i,n.axis!==undefined&&n.axis===n.HORIZONTAL_AXIS&&(u=0,o=-1*i),n.wheelDeltaY!==undefined&&(u=n.wheelDeltaY/120),n.wheelDeltaX!==undefined&&(o=-1*n.wheelDeltaX/120),r.unshift(t,i,o,u),(e.event.dispatch||e.event.handle).apply(this,r)}var t=["DOMMouseScroll","mousewheel"];if(e.event.fixHooks){for(var n=t.length;n;){e.event.fixHooks[t[--n]]=e.event.mouseHooks}}e.event.special.mousewheel={setup:function(){if(this.addEventListener){for(var e=t.length;e;){this.addEventListener(t[--e],r,!1)}}else{this.onmousewheel=r}},teardown:function(){if(this.removeEventListener){for(var e=t.length;e;){this.removeEventListener(t[--e],r,!1)}}else{this.onmousewheel=null}}},e.fn.extend({mousewheel:function(e){return e?this.bind("mousewheel",e):this.trigger("mousewheel")},unmousewheel:function(e){return this.unbind("mousewheel",e)}})}(jQuery);var jvm={inherits:function(e,t){function n(){}n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e,e.parentClass=t},mixin:function(e,t){var n;for(n in t.prototype){t.prototype.hasOwnProperty(n)&&(e.prototype[n]=t.prototype[n])}},min:function(e){var t=Number.MAX_VALUE,n;if(e instanceof Array){for(n=0;n<e.length;n++){e[n]<t&&(t=e[n])}}else{for(n in e){e[n]<t&&(t=e[n])}}return t},max:function(e){var t=Number.MIN_VALUE,n;if(e instanceof Array){for(n=0;n<e.length;n++){e[n]>t&&(t=e[n])}}else{for(n in e){e[n]>t&&(t=e[n])}}return t},keys:function(e){var t=[],n;for(n in e){t.push(n)}return t},values:function(e){var t=[],n,r;for(r=0;r<arguments.length;r++){e=arguments[r];for(n in e){t.push(e[n])}}return t}};jvm.$=jQuery,jvm.AbstractElement=function(e,t){this.node=this.createElement(e),this.name=e,this.properties={},t&&this.set(t)},jvm.AbstractElement.prototype.set=function(e,t){var n;if(typeof e=="object"){for(n in e){this.properties[n]=e[n],this.applyAttr(n,e[n])}}else{this.properties[e]=t,this.applyAttr(e,t)}},jvm.AbstractElement.prototype.get=function(e){return this.properties[e]},jvm.AbstractElement.prototype.applyAttr=function(e,t){this.node.setAttribute(e,t)},jvm.AbstractElement.prototype.remove=function(){jvm.$(this.node).remove()},jvm.AbstractCanvasElement=function(e,t,n){this.container=e,this.setSize(t,n),this.rootElement=new jvm[this.classPrefix+"GroupElement"],this.node.appendChild(this.rootElement.node),this.container.appendChild(this.node)},jvm.AbstractCanvasElement.prototype.add=function(e,t){t=t||this.rootElement,t.add(e),e.canvas=this},jvm.AbstractCanvasElement.prototype.addPath=function(e,t,n){var r=new jvm[this.classPrefix+"PathElement"](e,t);return this.add(r,n),r},jvm.AbstractCanvasElement.prototype.addCircle=function(e,t,n){var r=new jvm[this.classPrefix+"CircleElement"](e,t);return this.add(r,n),r},jvm.AbstractCanvasElement.prototype.addGroup=function(e){var t=new jvm[this.classPrefix+"GroupElement"];return e?e.node.appendChild(t.node):this.node.appendChild(t.node),t.canvas=this,t},jvm.AbstractShapeElement=function(e,t,n){this.style=n||{},this.style.current={},this.isHovered=!1,this.isSelected=!1,this.updateStyle()},jvm.AbstractShapeElement.prototype.setHovered=function(e){this.isHovered!==e&&(this.isHovered=e,this.updateStyle())},jvm.AbstractShapeElement.prototype.setSelected=function(e){this.isSelected!==e&&(this.isSelected=e,this.updateStyle(),jvm.$(this.node).trigger("selected",[e]))},jvm.AbstractShapeElement.prototype.setStyle=function(e,t){var n={};typeof e=="object"?n=e:n[e]=t,jvm.$.extend(this.style.current,n),this.updateStyle()},jvm.AbstractShapeElement.prototype.updateStyle=function(){var e={};jvm.AbstractShapeElement.mergeStyles(e,this.style.initial),jvm.AbstractShapeElement.mergeStyles(e,this.style.current),this.isHovered&&jvm.AbstractShapeElement.mergeStyles(e,this.style.hover),this.isSelected&&(jvm.AbstractShapeElement.mergeStyles(e,this.style.selected),this.isHovered&&jvm.AbstractShapeElement.mergeStyles(e,this.style.selectedHover)),this.set(e)},jvm.AbstractShapeElement.mergeStyles=function(e,t){var n;t=t||{};for(n in t){t[n]===null?delete e[n]:e[n]=t[n]}},jvm.SVGElement=function(e,t){jvm.SVGElement.parentClass.apply(this,arguments)},jvm.inherits(jvm.SVGElement,jvm.AbstractElement),jvm.SVGElement.svgns="http://www.w3.org/2000/svg",jvm.SVGElement.prototype.createElement=function(e){return document.createElementNS(jvm.SVGElement.svgns,e)},jvm.SVGElement.prototype.addClass=function(e){this.node.setAttribute("class",e)},jvm.SVGElement.prototype.getElementCtr=function(e){return jvm["SVG"+e]},jvm.SVGElement.prototype.getBBox=function(){return this.node.getBBox()},jvm.SVGGroupElement=function(){jvm.SVGGroupElement.parentClass.call(this,"g")},jvm.inherits(jvm.SVGGroupElement,jvm.SVGElement),jvm.SVGGroupElement.prototype.add=function(e){this.node.appendChild(e.node)},jvm.SVGCanvasElement=function(e,t,n){this.classPrefix="SVG",jvm.SVGCanvasElement.parentClass.call(this,"svg"),jvm.AbstractCanvasElement.apply(this,arguments)},jvm.inherits(jvm.SVGCanvasElement,jvm.SVGElement),jvm.mixin(jvm.SVGCanvasElement,jvm.AbstractCanvasElement),jvm.SVGCanvasElement.prototype.setSize=function(e,t){this.width=e,this.height=t,this.node.setAttribute("width",e),this.node.setAttribute("height",t)},jvm.SVGCanvasElement.prototype.applyTransformParams=function(e,t,n){this.scale=e,this.transX=t,this.transY=n,this.rootElement.node.setAttribute("transform","scale("+e+") translate("+t+", "+n+")")},jvm.SVGShapeElement=function(e,t,n){jvm.SVGShapeElement.parentClass.call(this,e,t),jvm.AbstractShapeElement.apply(this,arguments)},jvm.inherits(jvm.SVGShapeElement,jvm.SVGElement),jvm.mixin(jvm.SVGShapeElement,jvm.AbstractShapeElement),jvm.SVGPathElement=function(e,t){jvm.SVGPathElement.parentClass.call(this,"path",e,t),this.node.setAttribute("fill-rule","evenodd")},jvm.inherits(jvm.SVGPathElement,jvm.SVGShapeElement),jvm.SVGCircleElement=function(e,t){jvm.SVGCircleElement.parentClass.call(this,"circle",e,t)},jvm.inherits(jvm.SVGCircleElement,jvm.SVGShapeElement),jvm.VMLElement=function(e,t){jvm.VMLElement.VMLInitialized||jvm.VMLElement.initializeVML(),jvm.VMLElement.parentClass.apply(this,arguments)},jvm.inherits(jvm.VMLElement,jvm.AbstractElement),jvm.VMLElement.VMLInitialized=!1,jvm.VMLElement.initializeVML=function(){try{document.namespaces.rvml||document.namespaces.add("rvml","urn:schemas-microsoft-com:vml"),jvm.VMLElement.prototype.createElement=function(e){return document.createElement("<rvml:"+e+' class="rvml">')}}catch(e){jvm.VMLElement.prototype.createElement=function(e){return document.createElement("<"+e+' xmlns="urn:schemas-microsoft.com:vml" class="rvml">')}}document.createStyleSheet().addRule(".rvml","behavior:url(#default#VML)"),jvm.VMLElement.VMLInitialized=!0},jvm.VMLElement.prototype.getElementCtr=function(e){return jvm["VML"+e]},jvm.VMLElement.prototype.addClass=function(e){jvm.$(this.node).addClass(e)},jvm.VMLElement.prototype.applyAttr=function(e,t){this.node[e]=t},jvm.VMLElement.prototype.getBBox=function(){var e=jvm.$(this.node);return{x:e.position().left/this.canvas.scale,y:e.position().top/this.canvas.scale,width:e.width()/this.canvas.scale,height:e.height()/this.canvas.scale}},jvm.VMLGroupElement=function(){jvm.VMLGroupElement.parentClass.call(this,"group"),this.node.style.left="0px",this.node.style.top="0px",this.node.coordorigin="0 0"},jvm.inherits(jvm.VMLGroupElement,jvm.VMLElement),jvm.VMLGroupElement.prototype.add=function(e){this.node.appendChild(e.node)},jvm.VMLCanvasElement=function(e,t,n){this.classPrefix="VML",jvm.VMLCanvasElement.parentClass.call(this,"group"),jvm.AbstractCanvasElement.apply(this,arguments),this.node.style.position="absolute"},jvm.inherits(jvm.VMLCanvasElement,jvm.VMLElement),jvm.mixin(jvm.VMLCanvasElement,jvm.AbstractCanvasElement),jvm.VMLCanvasElement.prototype.setSize=function(e,t){var n,r,i,s;this.width=e,this.height=t,this.node.style.width=e+"px",this.node.style.height=t+"px",this.node.coordsize=e+" "+t,this.node.coordorigin="0 0";if(this.rootElement){n=this.rootElement.node.getElementsByTagName("shape");for(i=0,s=n.length;i<s;i++){n[i].coordsize=e+" "+t,n[i].style.width=e+"px",n[i].style.height=t+"px"}r=this.node.getElementsByTagName("group");for(i=0,s=r.length;i<s;i++){r[i].coordsize=e+" "+t,r[i].style.width=e+"px",r[i].style.height=t+"px"}}},jvm.VMLCanvasElement.prototype.applyTransformParams=function(e,t,n){this.scale=e,this.transX=t,this.transY=n,this.rootElement.node.coordorigin=this.width-t-this.width/100+","+(this.height-n-this.height/100),this.rootElement.node.coordsize=this.width/e+","+this.height/e},jvm.VMLShapeElement=function(e,t){jvm.VMLShapeElement.parentClass.call(this,e,t),this.fillElement=new jvm.VMLElement("fill"),this.strokeElement=new jvm.VMLElement("stroke"),this.node.appendChild(this.fillElement.node),this.node.appendChild(this.strokeElement.node),this.node.stroked=!1,jvm.AbstractShapeElement.apply(this,arguments)},jvm.inherits(jvm.VMLShapeElement,jvm.VMLElement),jvm.mixin(jvm.VMLShapeElement,jvm.AbstractShapeElement),jvm.VMLShapeElement.prototype.applyAttr=function(e,t){switch(e){case"fill":this.node.fillcolor=t;break;case"fill-opacity":this.fillElement.node.opacity=Math.round(t*100)+"%";break;case"stroke":t==="none"?this.node.stroked=!1:this.node.stroked=!0,this.node.strokecolor=t;break;case"stroke-opacity":this.strokeElement.node.opacity=Math.round(t*100)+"%";break;case"stroke-width":parseInt(t,10)===0?this.node.stroked=!1:this.node.stroked=!0,this.node.strokeweight=t;break;case"d":this.node.path=jvm.VMLPathElement.pathSvgToVml(t);break;default:jvm.VMLShapeElement.parentClass.prototype.applyAttr.apply(this,arguments)}},jvm.VMLPathElement=function(e,t){var n=new jvm.VMLElement("skew");jvm.VMLPathElement.parentClass.call(this,"shape",e,t),this.node.coordorigin="0 0",n.node.on=!0,n.node.matrix="0.01,0,0,0.01,0,0",n.node.offset="0,0",this.node.appendChild(n.node)},jvm.inherits(jvm.VMLPathElement,jvm.VMLShapeElement),jvm.VMLPathElement.prototype.applyAttr=function(e,t){e==="d"?this.node.path=jvm.VMLPathElement.pathSvgToVml(t):jvm.VMLShapeElement.prototype.applyAttr.call(this,e,t)},jvm.VMLPathElement.pathSvgToVml=function(e){var t="",n=0,r=0,i,s;return e=e.replace(/(-?\d+)e(-?\d+)/g,"0"),e.replace(/([MmLlHhVvCcSs])\s*((?:-?\d*(?:\.\d+)?\s*,?\s*)+)/g,function(e,t,o,u){o=o.replace(/(\d)-/g,"$1,-").replace(/^\s+/g,"").replace(/\s+$/g,"").replace(/\s+/g,",").split(","),o[0]||o.shift();for(var a=0,f=o.length;a<f;a++){o[a]=Math.round(100*o[a])}switch(t){case"m":return n+=o[0],r+=o[1],"t"+o.join(",");case"M":return n=o[0],r=o[1],"m"+o.join(",");case"l":return n+=o[0],r+=o[1],"r"+o.join(",");case"L":return n=o[0],r=o[1],"l"+o.join(",");case"h":return n+=o[0],"r"+o[0]+",0";case"H":return n=o[0],"l"+n+","+r;case"v":return r+=o[0],"r0,"+o[0];case"V":return r=o[0],"l"+n+","+r;case"c":return i=n+o[o.length-4],s=r+o[o.length-3],n+=o[o.length-2],r+=o[o.length-1],"v"+o.join(",");case"C":return i=o[o.length-4],s=o[o.length-3],n=o[o.length-2],r=o[o.length-1],"c"+o.join(",");case"s":return o.unshift(r-s),o.unshift(n-i),i=n+o[o.length-4],s=r+o[o.length-3],n+=o[o.length-2],r+=o[o.length-1],"v"+o.join(",");case"S":return o.unshift(r+r-s),o.unshift(n+n-i),i=o[o.length-4],s=o[o.length-3],n=o[o.length-2],r=o[o.length-1],"c"+o.join(",")}return""}).replace(/z/g,"e")},jvm.VMLCircleElement=function(e,t){jvm.VMLCircleElement.parentClass.call(this,"oval",e,t)},jvm.inherits(jvm.VMLCircleElement,jvm.VMLShapeElement),jvm.VMLCircleElement.prototype.applyAttr=function(e,t){switch(e){case"r":this.node.style.width=t*2+"px",this.node.style.height=t*2+"px",this.applyAttr("cx",this.get("cx")||0),this.applyAttr("cy",this.get("cy")||0);break;case"cx":if(!t){return}this.node.style.left=t-(this.get("r")||0)+"px";break;case"cy":if(!t){return}this.node.style.top=t-(this.get("r")||0)+"px";break;default:jvm.VMLCircleElement.parentClass.prototype.applyAttr.call(this,e,t)}},jvm.VectorCanvas=function(e,t,n){return this.mode=window.SVGAngle?"svg":"vml",this.mode=="svg"?this.impl=new jvm.SVGCanvasElement(e,t,n):this.impl=new jvm.VMLCanvasElement(e,t,n),this.impl},jvm.SimpleScale=function(e){this.scale=e},jvm.SimpleScale.prototype.getValue=function(e){return e},jvm.OrdinalScale=function(e){this.scale=e},jvm.OrdinalScale.prototype.getValue=function(e){return this.scale[e]},jvm.NumericScale=function(e,t,n,r){this.scale=[],t=t||"linear",e&&this.setScale(e),t&&this.setNormalizeFunction(t),n&&this.setMin(n),r&&this.setMax(r)},jvm.NumericScale.prototype={setMin:function(e){this.clearMinValue=e,typeof this.normalize=="function"?this.minValue=this.normalize(e):this.minValue=e},setMax:function(e){this.clearMaxValue=e,typeof this.normalize=="function"?this.maxValue=this.normalize(e):this.maxValue=e},setScale:function(e){var t;for(t=0;t<e.length;t++){this.scale[t]=[e[t]]}},setNormalizeFunction:function(e){e==="polynomial"?this.normalize=function(e){return Math.pow(e,0.2)}:e==="linear"?delete this.normalize:this.normalize=e,this.setMin(this.clearMinValue),this.setMax(this.clearMaxValue)},getValue:function(e){var t=[],n=0,r,i=0,s;typeof this.normalize=="function"&&(e=this.normalize(e));for(i=0;i<this.scale.length-1;i++){r=this.vectorLength(this.vectorSubtract(this.scale[i+1],this.scale[i])),t.push(r),n+=r}s=(this.maxValue-this.minValue)/n;for(i=0;i<t.length;i++){t[i]*=s}i=0,e-=this.minValue;while(e-t[i]>=0){e-=t[i],i++}return i==this.scale.length-1?e=this.vectorToNum(this.scale[i]):e=this.vectorToNum(this.vectorAdd(this.scale[i],this.vectorMult(this.vectorSubtract(this.scale[i+1],this.scale[i]),e/t[i]))),e},vectorToNum:function(e){var t=0,n;for(n=0;n<e.length;n++){t+=Math.round(e[n])*Math.pow(256,e.length-n-1)}return t},vectorSubtract:function(e,t){var n=[],r;for(r=0;r<e.length;r++){n[r]=e[r]-t[r]}return n},vectorAdd:function(e,t){var n=[],r;for(r=0;r<e.length;r++){n[r]=e[r]+t[r]}return n},vectorMult:function(e,t){var n=[],r;for(r=0;r<e.length;r++){n[r]=e[r]*t}return n},vectorLength:function(e){var t=0,n;for(n=0;n<e.length;n++){t+=e[n]*e[n]}return Math.sqrt(t)}},jvm.ColorScale=function(e,t,n,r){jvm.ColorScale.parentClass.apply(this,arguments)},jvm.inherits(jvm.ColorScale,jvm.NumericScale),jvm.ColorScale.prototype.setScale=function(e){var t;for(t=0;t<e.length;t++){this.scale[t]=jvm.ColorScale.rgbToArray(e[t])}},jvm.ColorScale.prototype.getValue=function(e){return jvm.ColorScale.numToRgb(jvm.ColorScale.parentClass.prototype.getValue.call(this,e))},jvm.ColorScale.arrayToRgb=function(e){var t="#",n,r;for(r=0;r<e.length;r++){n=e[r].toString(16),t+=n.length==1?"0"+n:n}return t},jvm.ColorScale.numToRgb=function(e){e=e.toString(16);while(e.length<6){e="0"+e}return"#"+e},jvm.ColorScale.rgbToArray=function(e){return e=e.substr(1),[parseInt(e.substr(0,2),16),parseInt(e.substr(2,2),16),parseInt(e.substr(4,2),16)]},jvm.DataSeries=function(e,t){var n;e=e||{},e.attribute=e.attribute||"fill",this.elements=t,this.params=e,e.attributes&&this.setAttributes(e.attributes),jvm.$.isArray(e.scale)?(n=e.attribute==="fill"||e.attribute==="stroke"?jvm.ColorScale:jvm.NumericScale,this.scale=new n(e.scale,e.normalizeFunction,e.min,e.max)):e.scale?this.scale=new jvm.OrdinalScale(e.scale):this.scale=new jvm.SimpleScale(e.scale),this.values=e.values||{},this.setValues(this.values)},jvm.DataSeries.prototype={setAttributes:function(e,t){var n=e,r;if(typeof e=="string"){this.elements[e]&&this.elements[e].setStyle(this.params.attribute,t)}else{for(r in n){this.elements[r]&&this.elements[r].element.setStyle(this.params.attribute,n[r])}}},setValues:function(e){var t=Number.MIN_VALUE,n=Number.MAX_VALUE,r,i,s={};if(this.scale instanceof jvm.OrdinalScale||this.scale instanceof jvm.SimpleScale){for(i in e){e[i]?s[i]=this.scale.getValue(e[i]):s[i]=this.elements[i].element.style.initial[this.params.attribute]}}else{if(!this.params.min||!this.params.max){for(i in e){r=parseFloat(e[i]),r>t&&(t=e[i]),r<n&&(n=r)}this.params.min||this.scale.setMin(n),this.params.max||this.scale.setMax(t),this.params.min=n,this.params.max=t}for(i in e){r=parseFloat(e[i]),isNaN(r)?s[i]=this.elements[i].element.style.initial[this.params.attribute]:s[i]=this.scale.getValue(r)}}this.setAttributes(s),jvm.$.extend(this.values,e)},clear:function(){var e,t={};for(e in this.values){this.elements[e]&&(t[e]=this.elements[e].element.style.initial[this.params.attribute])}this.setAttributes(t),this.values={}},setScale:function(e){this.scale.setScale(e),this.values&&this.setValues(this.values)},setNormalizeFunction:function(e){this.scale.setNormalizeFunction(e),this.values&&this.setValues(this.values)}},jvm.Proj={degRad:180/Math.PI,radDeg:Math.PI/180,radius:6381372,sgn:function(e){return e>0?1:e<0?-1:e},mill:function(e,t,n){return{x:this.radius*(t-n)*this.radDeg,y:-this.radius*Math.log(Math.tan((45+0.4*e)*this.radDeg))/0.8}},mill_inv:function(e,t,n){return{lat:(2.5*Math.atan(Math.exp(0.8*t/this.radius))-5*Math.PI/8)*this.degRad,lng:(n*this.radDeg+e/this.radius)*this.degRad}},merc:function(e,t,n){return{x:this.radius*(t-n)*this.radDeg,y:-this.radius*Math.log(Math.tan(Math.PI/4+e*Math.PI/360))}},merc_inv:function(e,t,n){return{lat:(2*Math.atan(Math.exp(t/this.radius))-Math.PI/2)*this.degRad,lng:(n*this.radDeg+e/this.radius)*this.degRad}},aea:function(e,t,n){var r=0,i=n*this.radDeg,s=29.5*this.radDeg,o=45.5*this.radDeg,u=e*this.radDeg,a=t*this.radDeg,f=(Math.sin(s)+Math.sin(o))/2,l=Math.cos(s)*Math.cos(s)+2*f*Math.sin(s),c=f*(a-i),h=Math.sqrt(l-2*f*Math.sin(u))/f,p=Math.sqrt(l-2*f*Math.sin(r))/f;return{x:h*Math.sin(c)*this.radius,y:-(p-h*Math.cos(c))*this.radius}},aea_inv:function(e,t,n){var r=e/this.radius,i=t/this.radius,s=0,o=n*this.radDeg,u=29.5*this.radDeg,a=45.5*this.radDeg,f=(Math.sin(u)+Math.sin(a))/2,l=Math.cos(u)*Math.cos(u)+2*f*Math.sin(u),c=Math.sqrt(l-2*f*Math.sin(s))/f,h=Math.sqrt(r*r+(c-i)*(c-i)),p=Math.atan(r/(c-i));return{lat:Math.asin((l-h*h*f*f)/(2*f))*this.degRad,lng:(o+p/f)*this.degRad}},lcc:function(e,t,n){var r=0,i=n*this.radDeg,s=t*this.radDeg,o=33*this.radDeg,u=45*this.radDeg,a=e*this.radDeg,f=Math.log(Math.cos(o)*(1/Math.cos(u)))/Math.log(Math.tan(Math.PI/4+u/2)*(1/Math.tan(Math.PI/4+o/2))),l=Math.cos(o)*Math.pow(Math.tan(Math.PI/4+o/2),f)/f,c=l*Math.pow(1/Math.tan(Math.PI/4+a/2),f),h=l*Math.pow(1/Math.tan(Math.PI/4+r/2),f);return{x:c*Math.sin(f*(s-i))*this.radius,y:-(h-c*Math.cos(f*(s-i)))*this.radius}},lcc_inv:function(e,t,n){var r=e/this.radius,i=t/this.radius,s=0,o=n*this.radDeg,u=33*this.radDeg,a=45*this.radDeg,f=Math.log(Math.cos(u)*(1/Math.cos(a)))/Math.log(Math.tan(Math.PI/4+a/2)*(1/Math.tan(Math.PI/4+u/2))),l=Math.cos(u)*Math.pow(Math.tan(Math.PI/4+u/2),f)/f,c=l*Math.pow(1/Math.tan(Math.PI/4+s/2),f),h=this.sgn(f)*Math.sqrt(r*r+(c-i)*(c-i)),p=Math.atan(r/(c-i));return{lat:(2*Math.atan(Math.pow(l/h,1/f))-Math.PI/2)*this.degRad,lng:(o+p/f)*this.degRad}}},jvm.WorldMap=function(e){var t=this,n;this.params=jvm.$.extend(!0,{},jvm.WorldMap.defaultParams,e);if(!jvm.WorldMap.maps[this.params.map]){throw new Error("Attempt to use map which was not loaded: "+this.params.map)}this.mapData=jvm.WorldMap.maps[this.params.map],this.markers={},this.regions={},this.regionsColors={},this.regionsData={},this.container=jvm.$("<div>").css({width:"100%",height:"100%"}).addClass("jvectormap-container"),this.params.container.append(this.container),this.container.data("mapObject",this),this.container.css({position:"relative",overflow:"hidden"}),this.defaultWidth=this.mapData.width,this.defaultHeight=this.mapData.height,this.setBackgroundColor(this.params.backgroundColor),this.onResize=function(){t.setSize()},jvm.$(window).resize(this.onResize);for(n in jvm.WorldMap.apiEvents){this.params[n]&&this.container.bind(jvm.WorldMap.apiEvents[n]+".jvectormap",this.params[n])}this.canvas=new jvm.VectorCanvas(this.container[0],this.width,this.height),"ontouchstart" in window||window.DocumentTouch&&document instanceof DocumentTouch?this.params.bindTouchEvents&&this.bindContainerTouchEvents():this.bindContainerEvents(),this.bindElementEvents(),this.createLabel(),this.params.zoomButtons&&this.bindZoomButtons(),this.createRegions(),this.createMarkers(this.params.markers||{}),this.setSize(),this.params.focusOn&&(typeof this.params.focusOn=="object"?this.setFocus.call(this,this.params.focusOn.scale,this.params.focusOn.x,this.params.focusOn.y):this.setFocus.call(this,this.params.focusOn)),this.params.selectedRegions&&this.setSelectedRegions(this.params.selectedRegions),this.params.selectedMarkers&&this.setSelectedMarkers(this.params.selectedMarkers),this.params.series&&this.createSeries()},jvm.WorldMap.prototype={transX:0,transY:0,scale:1,baseTransX:0,baseTransY:0,baseScale:1,width:0,height:0,setBackgroundColor:function(e){this.container.css("background-color",e)},resize:function(){var e=this.baseScale;this.width/this.height>this.defaultWidth/this.defaultHeight?(this.baseScale=this.height/this.defaultHeight,this.baseTransX=Math.abs(this.width-this.defaultWidth*this.baseScale)/(2*this.baseScale)):(this.baseScale=this.width/this.defaultWidth,this.baseTransY=Math.abs(this.height-this.defaultHeight*this.baseScale)/(2*this.baseScale)),this.scale*=this.baseScale/e,this.transX*=this.baseScale/e,this.transY*=this.baseScale/e},setSize:function(){this.width=this.container.width(),this.height=this.container.height(),this.resize(),this.canvas.setSize(this.width,this.height),this.applyTransform()},reset:function(){var e,t;for(e in this.series){for(t=0;t<this.series[e].length;t++){this.series[e][t].clear()}}this.scale=this.baseScale,this.transX=this.baseTransX,this.transY=this.baseTransY,this.applyTransform()},applyTransform:function(){var e,t,n,r;this.defaultWidth*this.scale<=this.width?(e=(this.width-this.defaultWidth*this.scale)/(2*this.scale),n=(this.width-this.defaultWidth*this.scale)/(2*this.scale)):(e=0,n=(this.width-this.defaultWidth*this.scale)/this.scale),this.defaultHeight*this.scale<=this.height?(t=(this.height-this.defaultHeight*this.scale)/(2*this.scale),r=(this.height-this.defaultHeight*this.scale)/(2*this.scale)):(t=0,r=(this.height-this.defaultHeight*this.scale)/this.scale),this.transY>t?this.transY=t:this.transY<r&&(this.transY=r),this.transX>e?this.transX=e:this.transX<n&&(this.transX=n),this.canvas.applyTransformParams(this.scale,this.transX,this.transY),this.markers&&this.repositionMarkers(),this.container.trigger("viewportChange",[this.scale/this.baseScale,this.transX,this.transY])},bindContainerEvents:function(){var e=!1,t,n,r=this;this.container.mousemove(function(i){return e&&(r.transX-=(t-i.pageX)/r.scale,r.transY-=(n-i.pageY)/r.scale,r.applyTransform(),t=i.pageX,n=i.pageY),!1}).mousedown(function(r){return e=!0,t=r.pageX,n=r.pageY,!1}),jvm.$("body").mouseup(function(){e=!1}),this.params.zoomOnScroll&&this.container.mousewheel(function(e,t,n,i){var s=jvm.$(r.container).offset(),o=e.pageX-s.left,u=e.pageY-s.top,a=Math.pow(1.3,i);r.label.hide(),r.setScale(r.scale*a,o,u),e.preventDefault()})},bindContainerTouchEvents:function(){var e,t,n=this,r,i,s,o,u,a=function(a){var f=a.originalEvent.touches,l,c,h,p;a.type=="touchstart"&&(u=0),f.length==1?(u==1&&(h=n.transX,p=n.transY,n.transX-=(r-f[0].pageX)/n.scale,n.transY-=(i-f[0].pageY)/n.scale,n.applyTransform(),n.label.hide(),(h!=n.transX||p!=n.transY)&&a.preventDefault()),r=f[0].pageX,i=f[0].pageY):f.length==2&&(u==2?(c=Math.sqrt(Math.pow(f[0].pageX-f[1].pageX,2)+Math.pow(f[0].pageY-f[1].pageY,2))/t,n.setScale(e*c,s,o),n.label.hide(),a.preventDefault()):(l=jvm.$(n.container).offset(),f[0].pageX>f[1].pageX?s=f[1].pageX+(f[0].pageX-f[1].pageX)/2:s=f[0].pageX+(f[1].pageX-f[0].pageX)/2,f[0].pageY>f[1].pageY?o=f[1].pageY+(f[0].pageY-f[1].pageY)/2:o=f[0].pageY+(f[1].pageY-f[0].pageY)/2,s-=l.left,o-=l.top,e=n.scale,t=Math.sqrt(Math.pow(f[0].pageX-f[1].pageX,2)+Math.pow(f[0].pageY-f[1].pageY,2)))),u=f.length};jvm.$(this.container).bind("touchstart",a),jvm.$(this.container).bind("touchmove",a)},bindElementEvents:function(){var e=this,t;this.container.mousemove(function(){t=!0}),this.container.delegate("[class~='jvectormap-element']","mouseover mouseout",function(t){var n=this,r=jvm.$(this).attr("class").baseVal?jvm.$(this).attr("class").baseVal:jvm.$(this).attr("class"),i=r.indexOf("jvectormap-region")===-1?"marker":"region",s=i=="region"?jvm.$(this).attr("data-code"):jvm.$(this).attr("data-index"),o=i=="region"?e.regions[s].element:e.markers[s].element,u=i=="region"?e.mapData.paths[s].name:e.markers[s].config.name||"",a=jvm.$.Event(i+"LabelShow.jvectormap"),f=jvm.$.Event(i+"Over.jvectormap");t.type=="mouseover"?(e.container.trigger(f,[s]),f.isDefaultPrevented()||o.setHovered(!0),e.label.text(u),e.container.trigger(a,[e.label,s]),a.isDefaultPrevented()||(e.label.show(),e.labelWidth=e.label.width(),e.labelHeight=e.label.height())):(o.setHovered(!1),e.label.hide(),e.container.trigger(i+"Out.jvectormap",[s]))}),this.container.delegate("[class~='jvectormap-element']","mousedown",function(e){t=!1}),this.container.delegate("[class~='jvectormap-element']","mouseup",function(n){var r=this,i=jvm.$(this).attr("class").baseVal?jvm.$(this).attr("class").baseVal:jvm.$(this).attr("class"),s=i.indexOf("jvectormap-region")===-1?"marker":"region",o=s=="region"?jvm.$(this).attr("data-code"):jvm.$(this).attr("data-index"),u=jvm.$.Event(s+"Click.jvectormap"),a=s=="region"?e.regions[o].element:e.markers[o].element;if(!t){e.container.trigger(u,[o]);if(s==="region"&&e.params.regionsSelectable||s==="marker"&&e.params.markersSelectable){u.isDefaultPrevented()||(e.params[s+"sSelectableOne"]&&e.clearSelected(s+"s"),a.setSelected(!a.isSelected))}}})},bindZoomButtons:function(){var e=this;jvm.$("<div/>").addClass("jvectormap-zoomin").html("<i class='fa fa-plus'></i>").appendTo(this.container),jvm.$("<div/>").addClass("jvectormap-zoomout").html("<i class='fa fa-minus'></i>").appendTo(this.container),this.container.find(".jvectormap-zoomin").click(function(){e.setScale(e.scale*e.params.zoomStep,e.width/2,e.height/2)}),this.container.find(".jvectormap-zoomout").click(function(){e.setScale(e.scale/e.params.zoomStep,e.width/2,e.height/2)})},createLabel:function(){if($(".jvectormap-label").length){$(".jvectormap-label").remove()}var e=this;this.label=jvm.$("<div/>").addClass("jvectormap-label").appendTo(jvm.$("body")),this.container.mousemove(function(t){var n=t.pageX-15-e.labelWidth,r=t.pageY-15-e.labelHeight;n<5&&(n=t.pageX+15),r<5&&(r=t.pageY+15),e.label.is(":visible")&&e.label.css({left:n,top:r})})},setScale:function(e,t,n,r){var i,s=jvm.$.Event("zoom.jvectormap");e>this.params.zoomMax*this.baseScale?e=this.params.zoomMax*this.baseScale:e<this.params.zoomMin*this.baseScale&&(e=this.params.zoomMin*this.baseScale),typeof t!="undefined"&&typeof n!="undefined"&&(i=e/this.scale,r?(this.transX=t+this.defaultWidth*(this.width/(this.defaultWidth*e))/2,this.transY=n+this.defaultHeight*(this.height/(this.defaultHeight*e))/2):(this.transX-=(i-1)/e*t,this.transY-=(i-1)/e*n)),this.scale=e,this.applyTransform(),this.container.trigger(s,[e/this.baseScale])},setFocus:function(e,t,n){var r,i,s,o,u;if(jvm.$.isArray(e)||this.regions[e]){jvm.$.isArray(e)?o=e:o=[e];for(u=0;u<o.length;u++){this.regions[o[u]]&&(i=this.regions[o[u]].element.getBBox(),i&&(typeof r=="undefined"?r=i:(s={x:Math.min(r.x,i.x),y:Math.min(r.y,i.y),width:Math.max(r.x+r.width,i.x+i.width)-Math.min(r.x,i.x),height:Math.max(r.y+r.height,i.y+i.height)-Math.min(r.y,i.y)},r=s)))}this.setScale(Math.min(this.width/r.width,this.height/r.height),-(r.x+r.width/2),-(r.y+r.height/2),!0)}else{e*=this.baseScale,this.setScale(e,-t*this.defaultWidth,-n*this.defaultHeight,!0)}},getSelected:function(e){var t,n=[];for(t in this[e]){this[e][t].element.isSelected&&n.push(t)}return n},getSelectedRegions:function(){return this.getSelected("regions")},getSelectedMarkers:function(){return this.getSelected("markers")},setSelected:function(e,t){var n;typeof t!="object"&&(t=[t]);if(jvm.$.isArray(t)){for(n=0;n<t.length;n++){this[e][t[n]].element.setSelected(!0)}}else{for(n in t){this[e][n].element.setSelected(!!t[n])}}},setSelectedRegions:function(e){this.setSelected("regions",e)},setSelectedMarkers:function(e){this.setSelected("markers",e)},clearSelected:function(e){var t={},n=this.getSelected(e),r;for(r=0;r<n.length;r++){t[n[r]]=!1}this.setSelected(e,t)},clearSelectedRegions:function(){this.clearSelected("regions")},clearSelectedMarkers:function(){this.clearSelected("markers")},getMapObject:function(){return this},getRegionName:function(e){return this.mapData.paths[e].name},createRegions:function(){var e,t,n=this;for(e in this.mapData.paths){t=this.canvas.addPath({d:this.mapData.paths[e].path,"data-code":e},jvm.$.extend(!0,{},this.params.regionStyle)),jvm.$(t.node).bind("selected",function(e,t){n.container.trigger("regionSelected.jvectormap",[jvm.$(this).attr("data-code"),t,n.getSelectedRegions()])}),t.addClass("jvectormap-region jvectormap-element"),this.regions[e]={element:t,config:this.mapData.paths[e]}}},createMarkers:function(e){var t,n,r,i,s,o=this;this.markersGroup=this.markersGroup||this.canvas.addGroup();if(jvm.$.isArray(e)){s=e.slice(),e={};for(t=0;t<s.length;t++){e[t]=s[t]}}for(t in e){i=e[t] instanceof Array?{latLng:e[t]}:e[t],r=this.getMarkerPosition(i),r!==!1&&(n=this.canvas.addCircle({"data-index":t,cx:r.x,cy:r.y},jvm.$.extend(!0,{},this.params.markerStyle,{initial:i.style||{}}),this.markersGroup),n.addClass("jvectormap-marker jvectormap-element"),jvm.$(n.node).bind("selected",function(e,t){o.container.trigger("markerSelected.jvectormap",[jvm.$(this).attr("data-index"),t,o.getSelectedMarkers()])}),this.markers[t]&&this.removeMarkers([t]),this.markers[t]={element:n,config:i})}},repositionMarkers:function(){var e,t;for(e in this.markers){t=this.getMarkerPosition(this.markers[e].config),t!==!1&&this.markers[e].element.setStyle({cx:t.x,cy:t.y})}},getMarkerPosition:function(e){return jvm.WorldMap.maps[this.params.map].projection?this.latLngToPoint.apply(this,e.latLng||[0,0]):{x:e.coords[0]*this.scale+this.transX*this.scale,y:e.coords[1]*this.scale+this.transY*this.scale}},addMarker:function(e,t,n){var r={},i=[],s,o,n=n||[];r[e]=t;for(o=0;o<n.length;o++){s={},s[e]=n[o],i.push(s)}this.addMarkers(r,i)},addMarkers:function(e,t){var n;t=t||[],this.createMarkers(e);for(n=0;n<t.length;n++){this.series.markers[n].setValues(t[n]||{})}},removeMarkers:function(e){var t;for(t=0;t<e.length;t++){this.markers[e[t]].element.remove(),delete this.markers[e[t]]}},removeAllMarkers:function(){var e,t=[];for(e in this.markers){t.push(e)}this.removeMarkers(t)},latLngToPoint:function(e,t){var n,r=jvm.WorldMap.maps[this.params.map].projection,i=r.centralMeridian,s=this.width-this.baseTransX*2*this.baseScale,o=this.height-this.baseTransY*2*this.baseScale,u,a,f=this.scale/this.baseScale;return t<-180+i&&(t+=360),n=jvm.Proj[r.type](e,t,i),u=this.getInsetForPoint(n.x,n.y),u?(a=u.bbox,n.x=(n.x-a[0].x)/(a[1].x-a[0].x)*u.width*this.scale,n.y=(n.y-a[0].y)/(a[1].y-a[0].y)*u.height*this.scale,{x:n.x+this.transX*this.scale+u.left*this.scale,y:n.y+this.transY*this.scale+u.top*this.scale}):!1},pointToLatLng:function(e,t){var n=jvm.WorldMap.maps[this.params.map].projection,r=n.centralMeridian,i=jvm.WorldMap.maps[this.params.map].insets,s,o,u,a,f;for(s=0;s<i.length;s++){o=i[s],u=o.bbox,a=e-(this.transX*this.scale+o.left*this.scale),f=t-(this.transY*this.scale+o.top*this.scale),a=a/(o.width*this.scale)*(u[1].x-u[0].x)+u[0].x,f=f/(o.height*this.scale)*(u[1].y-u[0].y)+u[0].y;if(a>u[0].x&&a<u[1].x&&f>u[0].y&&f<u[1].y){return jvm.Proj[n.type+"_inv"](a,-f,r)}}return !1},getInsetForPoint:function(e,t){var n=jvm.WorldMap.maps[this.params.map].insets,r,i;for(r=0;r<n.length;r++){i=n[r].bbox;if(e>i[0].x&&e<i[1].x&&t>i[0].y&&t<i[1].y){return n[r]}}},createSeries:function(){var e,t;this.series={markers:[],regions:[]};for(t in this.params.series){for(e=0;e<this.params.series[t].length;e++){this.series[t][e]=new jvm.DataSeries(this.params.series[t][e],this[t])}}},remove:function(){this.label.remove(),this.container.remove(),jvm.$(window).unbind("resize",this.onResize)}},jvm.WorldMap.maps={},jvm.WorldMap.defaultParams={map:"world_mill_en",backgroundColor:"#505050",zoomButtons:!0,zoomOnScroll:!0,zoomMax:8,zoomMin:1,zoomStep:1.6,regionsSelectable:!1,markersSelectable:!1,bindTouchEvents:!0,regionStyle:{initial:{fill:"white","fill-opacity":1,stroke:"none","stroke-width":0,"stroke-opacity":1},hover:{"fill-opacity":0.8},selected:{fill:"yellow"},selectedHover:{}},markerStyle:{initial:{fill:"grey",stroke:"#505050","fill-opacity":1,"stroke-width":1,"stroke-opacity":1,r:5},hover:{stroke:"black","stroke-width":2},selected:{fill:"blue"},selectedHover:{}}},jvm.WorldMap.apiEvents={onRegionLabelShow:"regionLabelShow",onRegionOver:"regionOver",onRegionOut:"regionOut",onRegionClick:"regionClick",onRegionSelected:"regionSelected",onMarkerLabelShow:"markerLabelShow",onMarkerOver:"markerOver",onMarkerOut:"markerOut",onMarkerClick:"markerClick",onMarkerSelected:"markerSelected",onViewportChange:"viewportChange"};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(2)))

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {$.fn.vectorMap('addMap', 'world_mill_en',{"insets": [{"width": 900.0, "top": 0, "height": 440.7063107441331, "bbox": [{"y": -12671671.123330014, "x": -20004297.151525836}, {"y": 6930392.02513512, "x": 20026572.394749384}], "left": 0}], "paths": {"BD": {"path": "M652.71,228.85l-0.04,1.38l-0.46,-0.21l-0.42,0.3l0.05,0.65l-0.17,-1.37l-0.48,-1.26l-1.08,-1.6l-0.23,-0.13l-2.31,-0.11l-0.31,0.36l0.21,0.98l-0.6,1.11l-0.8,-0.4l-0.37,0.09l-0.23,0.3l-0.54,-0.21l-0.78,-0.19l-0.38,-2.04l-0.83,-1.89l0.4,-1.5l-0.16,-0.35l-1.24,-0.57l0.36,-0.62l1.5,-0.95l0.02,-0.49l-1.62,-1.26l0.64,-1.31l1.7,1.0l0.12,0.04l0.96,0.11l0.19,1.62l0.25,0.26l2.38,0.37l2.32,-0.04l1.06,0.33l-0.92,1.79l-0.97,0.13l-0.23,0.16l-0.77,1.51l0.05,0.35l1.37,1.37l0.5,-0.14l0.35,-1.46l0.24,-0.0l1.24,3.92Z", "name": "Bangladesh"}, "BE": {"path": "M429.28,143.95l1.76,0.25l0.13,-0.01l2.16,-0.64l1.46,1.34l1.26,0.71l-0.23,1.8l-0.44,0.08l-0.24,0.25l-0.2,1.36l-1.8,-1.22l-0.23,-0.05l-1.14,0.23l-1.62,-1.43l-1.15,-1.31l-0.21,-0.1l-0.95,-0.04l-0.21,-0.68l1.66,-0.54Z", "name": "Belgium"}, "BF": {"path": "M413.48,260.21l-1.22,-0.46l-0.13,-0.02l-1.17,0.1l-0.15,0.06l-0.73,0.53l-0.87,-0.41l-0.39,-0.75l-0.13,-0.13l-0.98,-0.48l-0.14,-1.2l0.63,-0.99l0.05,-0.18l-0.05,-0.73l1.9,-2.01l0.08,-0.14l0.35,-1.65l0.49,-0.44l1.05,0.3l0.21,-0.02l1.05,-0.52l0.13,-0.13l0.3,-0.58l1.87,-1.1l0.11,-0.1l0.43,-0.72l2.23,-1.01l1.21,-0.32l0.51,0.4l0.19,0.06l1.25,-0.01l-0.14,0.89l0.01,0.13l0.34,1.16l0.06,0.11l1.35,1.59l0.07,1.13l0.24,0.28l2.64,0.53l-0.05,1.39l-0.42,0.59l-1.11,0.21l-0.22,0.17l-0.46,0.99l-0.69,0.23l-2.12,-0.05l-1.14,-0.2l-0.19,0.03l-0.72,0.36l-1.07,-0.17l-4.35,0.12l-0.29,0.29l-0.06,1.44l0.25,1.45Z", "name": "Burkina Faso"}, "BG": {"path": "M477.63,166.84l0.51,0.9l0.33,0.14l0.9,-0.21l1.91,0.47l3.68,0.16l0.17,-0.05l1.2,-0.75l2.78,-0.67l1.72,1.05l1.02,0.24l-0.97,0.97l-0.91,2.17l0.0,0.24l0.56,1.19l-1.58,-0.3l-0.16,0.01l-2.55,0.95l-0.2,0.28l-0.02,1.23l-1.92,0.24l-1.68,-0.99l-0.27,-0.02l-1.94,0.8l-1.52,-0.07l-0.15,-1.72l-0.12,-0.21l-0.99,-0.76l0.18,-0.18l0.02,-0.39l-0.17,-0.22l0.33,-0.75l0.91,-0.91l0.01,-0.42l-1.16,-1.25l-0.18,-0.89l0.24,-0.27Z", "name": "Bulgaria"}, "BA": {"path": "M468.39,164.66l0.16,0.04l0.43,-0.0l-0.43,0.93l0.06,0.34l1.08,1.06l-0.28,1.09l-0.5,0.13l-0.47,0.28l-0.86,0.74l-0.1,0.16l-0.28,1.29l-1.81,-0.94l-0.9,-1.22l-1.0,-0.73l-1.1,-1.1l-0.55,-0.96l-1.11,-1.3l0.3,-0.75l0.59,0.46l0.42,-0.04l0.46,-0.54l1.0,-0.06l2.11,0.5l1.72,-0.03l1.06,0.64Z", "name": "Bosnia and Herzegovina"}, "BN": {"path": "M707.34,273.57l0.76,-0.72l1.59,-1.03l-0.18,1.93l-0.9,-0.06l-0.28,0.14l-0.31,0.51l-0.68,-0.78Z", "name": "Brunei"}, "BO": {"path": "M263.83,340.79l-0.23,-0.12l-2.86,-0.11l-0.28,0.17l-0.77,1.67l-1.17,-1.51l-0.18,-0.11l-3.28,-0.64l-0.28,0.1l-2.02,2.3l-1.43,0.29l-0.91,-3.35l-1.31,-2.88l0.75,-2.41l-0.09,-0.32l-1.23,-1.03l-0.31,-1.76l-0.05,-0.12l-1.12,-1.6l1.49,-2.62l0.01,-0.28l-1.0,-2.0l0.48,-0.72l0.02,-0.29l-0.37,-0.78l0.87,-1.13l0.06,-0.18l0.05,-2.17l0.12,-1.71l0.5,-0.8l0.01,-0.3l-1.9,-3.58l1.3,0.15l1.34,-0.05l0.23,-0.12l0.51,-0.7l2.12,-0.99l1.31,-0.93l2.81,-0.37l-0.21,1.51l0.01,0.13l0.29,0.91l-0.19,1.64l0.11,0.27l2.72,2.27l0.15,0.07l2.71,0.41l0.92,0.88l0.12,0.07l1.64,0.49l1.0,0.71l0.18,0.06l1.5,-0.02l1.24,0.64l0.1,1.31l0.05,0.14l0.44,0.68l0.02,0.73l-0.44,0.03l-0.27,0.39l0.96,2.99l0.28,0.21l4.43,0.1l-0.28,1.12l0.0,0.15l0.27,1.02l0.15,0.19l1.27,0.67l0.52,1.42l-0.42,1.91l-0.66,1.1l-0.04,0.2l0.21,1.3l-0.19,0.13l-0.01,-0.27l-0.15,-0.24l-2.33,-1.33l-0.14,-0.04l-2.38,-0.03l-4.36,0.76l-0.21,0.16l-1.2,2.29l-0.03,0.13l-0.06,1.37l-0.79,2.53l-0.05,-0.08Z", "name": "Bolivia"}, "JP": {"path": "M781.17,166.78l1.8,0.67l0.28,-0.04l1.38,-1.01l0.43,2.67l-3.44,0.77l-0.18,0.12l-2.04,2.79l-3.71,-1.94l-0.42,0.15l-1.29,3.11l-2.32,0.04l-0.3,-2.63l1.12,-2.1l2.51,-0.16l0.28,-0.25l0.73,-4.22l0.58,-1.9l2.59,2.84l2.0,1.1ZM773.66,187.36l-0.92,2.24l-0.01,0.2l0.4,1.3l-1.18,1.81l-3.06,1.28l-4.35,0.17l-0.19,0.08l-3.4,3.06l-1.36,-0.87l-0.1,-1.95l-0.34,-0.28l-4.35,0.62l-2.99,1.33l-2.87,0.05l-0.28,0.2l0.09,0.33l2.37,1.93l-1.57,4.44l-1.35,0.97l-0.9,-0.79l0.57,-2.32l-0.15,-0.34l-1.5,-0.77l-0.81,-1.53l2.04,-0.75l0.14,-0.1l1.28,-1.72l2.47,-1.43l1.84,-1.92l4.83,-0.82l2.62,0.57l0.33,-0.16l2.45,-4.77l1.38,1.14l0.38,0.0l5.1,-4.02l0.09,-0.11l1.57,-3.57l0.02,-0.16l-0.42,-3.22l0.94,-1.67l2.27,-0.47l1.26,3.82l-0.07,2.23l-2.26,2.86l-0.06,0.19l0.04,2.93ZM757.85,196.18l0.22,0.66l-1.11,1.33l-0.8,-0.7l-0.33,-0.04l-1.28,0.65l-0.14,0.15l-0.54,1.34l-1.17,-0.57l0.02,-1.03l1.2,-1.45l1.24,0.28l0.29,-0.1l0.9,-1.03l1.51,0.5Z", "name": "Japan"}, "BI": {"path": "M494.7,295.83l-0.14,-2.71l-0.04,-0.13l-0.34,-0.62l0.93,0.12l0.3,-0.16l0.67,-1.25l0.9,0.11l0.11,0.76l0.08,0.16l0.46,0.48l0.02,0.56l-0.55,0.48l-0.96,1.29l-0.82,0.82l-0.61,0.07Z", "name": "Burundi"}, "BJ": {"path": "M427.4,268.94l-1.58,0.22l-0.52,-1.45l0.11,-5.73l-0.08,-0.21l-0.43,-0.44l-0.09,-1.13l-0.09,-0.19l-1.52,-1.52l0.24,-1.01l0.7,-0.23l0.18,-0.16l0.45,-0.97l1.07,-0.21l0.19,-0.12l0.53,-0.73l0.73,-0.65l0.68,-0.0l1.69,1.3l-0.08,0.67l0.02,0.14l0.52,1.38l-0.44,0.9l-0.01,0.24l0.2,0.52l-1.1,1.42l-0.76,0.76l-0.08,0.13l-0.47,1.59l0.05,1.69l-0.13,3.79Z", "name": "Benin"}, "BT": {"path": "M650.38,213.78l0.88,0.75l-0.13,1.24l-1.77,0.07l-2.1,-0.18l-1.57,0.4l-2.02,-0.91l-0.02,-0.24l1.54,-1.87l1.18,-0.6l1.67,0.59l1.32,0.08l1.01,0.67Z", "name": "Bhutan"}, "JM": {"path": "M226.67,238.37l1.64,0.23l1.2,0.56l0.11,0.19l-1.25,0.03l-0.14,0.04l-0.65,0.37l-1.24,-0.37l-1.17,-0.77l0.11,-0.22l0.86,-0.15l0.52,0.08Z", "name": "Jamaica"}, "BW": {"path": "M484.91,331.96l0.53,0.52l0.82,1.53l2.83,2.86l0.14,0.08l0.85,0.22l0.03,0.81l0.74,1.66l0.21,0.17l1.87,0.39l1.17,0.87l-3.13,1.71l-2.3,2.01l-0.07,0.1l-0.82,1.74l-0.66,0.88l-1.24,0.19l-0.24,0.2l-0.65,1.98l-1.4,0.55l-1.9,-0.12l-1.2,-0.74l-1.06,-0.32l-0.22,0.02l-1.22,0.62l-0.14,0.14l-0.58,1.21l-1.16,0.79l-1.18,1.13l-1.5,0.23l-0.4,-0.68l0.22,-1.53l-0.04,-0.19l-1.48,-2.54l-0.11,-0.11l-0.53,-0.31l-0.0,-7.25l2.18,-0.08l0.29,-0.3l0.07,-9.0l1.63,-0.08l3.69,-0.86l0.84,0.93l0.38,0.05l1.53,-0.97l0.79,-0.03l1.3,-0.53l0.23,0.1l0.92,1.96Z", "name": "Botswana"}, "BR": {"path": "M259.49,274.87l1.42,0.25l1.97,0.62l0.28,-0.05l0.67,-0.55l1.76,-0.38l2.8,-0.94l0.12,-0.08l0.92,-0.96l0.05,-0.33l-0.15,-0.32l0.73,-0.06l0.36,0.35l-0.27,0.93l0.17,0.36l0.76,0.34l0.44,0.9l-0.58,0.73l-0.06,0.13l-0.4,2.13l0.03,0.19l0.62,1.22l0.17,1.11l0.11,0.19l1.54,1.18l0.15,0.06l1.23,0.12l0.29,-0.15l0.2,-0.36l0.71,-0.11l1.13,-0.44l0.79,-0.63l1.25,0.19l0.65,-0.08l1.32,0.2l0.32,-0.18l0.23,-0.51l-0.05,-0.31l-0.31,-0.37l0.11,-0.31l0.75,0.17l0.13,0.0l1.1,-0.24l1.34,0.5l1.08,0.51l0.33,-0.05l0.67,-0.58l0.27,0.05l0.28,0.57l0.31,0.17l1.2,-0.18l0.17,-0.08l1.03,-1.05l0.76,-1.82l1.39,-2.16l0.49,-0.07l0.52,1.17l1.4,4.37l0.2,0.2l1.14,0.35l0.05,1.39l-1.8,1.97l0.01,0.42l0.78,0.75l0.18,0.08l4.16,0.37l0.08,2.25l0.5,0.22l1.78,-1.54l2.98,0.85l4.07,1.5l1.07,1.28l-0.37,1.23l0.36,0.38l2.83,-0.75l4.8,1.3l3.75,-0.09l3.6,2.02l3.27,2.84l1.93,0.72l2.13,0.11l0.76,0.66l1.22,4.56l-0.96,4.03l-1.22,1.58l-3.52,3.51l-1.63,2.91l-1.75,2.09l-0.5,0.04l-0.26,0.19l-0.72,1.99l0.18,4.76l-0.95,5.56l-0.74,0.96l-0.06,0.15l-0.43,3.39l-2.49,3.34l-0.06,0.13l-0.4,2.56l-1.9,1.07l-0.13,0.16l-0.51,1.38l-2.59,0.0l-3.94,1.01l-1.82,1.19l-2.85,0.81l-3.01,2.17l-2.12,2.65l-0.06,0.13l-0.36,2.0l0.01,0.13l0.4,1.42l-0.45,2.63l-0.53,1.23l-1.76,1.53l-2.76,4.79l-2.16,2.15l-1.69,1.29l-0.09,0.12l-1.12,2.6l-1.3,1.26l-0.45,-1.02l0.99,-1.18l0.01,-0.37l-1.5,-1.95l-1.98,-1.54l-2.58,-1.77l-0.2,-0.05l-0.81,0.07l-2.42,-2.05l-0.25,-0.07l-0.77,0.14l2.75,-3.07l2.8,-2.61l1.67,-1.09l2.11,-1.49l0.13,-0.24l0.05,-2.15l-0.07,-0.2l-1.26,-1.54l-0.35,-0.09l-0.64,0.27l0.3,-0.95l0.34,-1.57l0.01,-1.52l-0.16,-0.26l-0.9,-0.48l-0.27,-0.01l-0.86,0.39l-0.65,-0.08l-0.23,-0.8l-0.23,-2.39l-0.04,-0.12l-0.47,-0.79l-0.14,-0.12l-1.69,-0.71l-0.25,0.01l-0.93,0.47l-2.29,-0.44l0.15,-3.3l-0.03,-0.15l-0.62,-1.22l0.57,-0.39l0.13,-0.3l-0.22,-1.37l0.67,-1.13l0.44,-2.04l-0.01,-0.17l-0.59,-1.61l-0.14,-0.16l-1.25,-0.66l-0.22,-0.82l0.35,-1.41l-0.28,-0.37l-4.59,-0.1l-0.78,-2.41l0.34,-0.02l0.28,-0.31l-0.03,-1.1l-0.05,-0.16l-0.45,-0.68l-0.1,-1.4l-0.16,-0.24l-1.45,-0.76l-0.14,-0.03l-1.48,0.02l-1.04,-0.73l-1.62,-0.48l-0.93,-0.9l-0.16,-0.08l-2.72,-0.41l-2.53,-2.12l0.18,-1.54l-0.01,-0.13l-0.29,-0.91l0.26,-1.83l-0.34,-0.34l-3.28,0.43l-0.14,0.05l-1.3,0.93l-2.16,1.01l-0.12,0.09l-0.47,0.65l-1.12,0.05l-1.84,-0.21l-0.12,0.01l-1.33,0.41l-0.82,-0.21l0.16,-3.6l-0.48,-0.26l-1.97,1.43l-1.96,-0.06l-0.86,-1.23l-0.22,-0.13l-1.23,-0.11l0.34,-0.69l-0.05,-0.33l-1.36,-1.5l-0.92,-2.0l0.45,-0.32l0.13,-0.25l-0.0,-0.87l1.34,-0.64l0.17,-0.32l-0.23,-1.23l0.56,-0.77l0.05,-0.13l0.16,-1.03l2.7,-1.61l2.01,-0.47l0.16,-0.09l0.24,-0.27l2.11,0.11l0.31,-0.25l1.13,-6.87l0.06,-1.12l-0.4,-1.53l-0.1,-0.15l-1.0,-0.82l0.01,-1.45l1.08,-0.32l0.39,0.2l0.44,-0.24l0.08,-0.96l-0.25,-0.32l-1.22,-0.22l-0.02,-1.01l4.57,0.05l0.22,-0.09l0.6,-0.63l0.44,0.5l0.47,1.42l0.45,0.16l0.27,-0.18l1.21,1.16l0.23,0.08l1.95,-0.16l0.23,-0.14l0.43,-0.67l1.76,-0.55l1.05,-0.42l0.18,-0.2l0.25,-0.92l1.65,-0.66l0.18,-0.35l-0.14,-0.53l-0.26,-0.22l-1.91,-0.19l-0.29,-1.33l0.1,-1.64l-0.15,-0.28l-0.44,-0.25Z", "name": "Brazil"}, "BS": {"path": "M227.51,216.69l0.3,0.18l-0.24,1.07l0.03,-1.04l-0.09,-0.21ZM226.5,224.03l-0.13,0.03l-0.54,-1.3l-0.09,-0.12l-0.78,-0.64l0.4,-1.26l0.33,0.05l0.79,2.0l0.01,1.24ZM225.76,216.5l-2.16,0.34l-0.07,-0.41l0.85,-0.16l1.36,0.07l0.02,0.16Z", "name": "The Bahamas"}, "BY": {"path": "M480.08,135.28l2.09,0.02l0.13,-0.03l2.72,-1.3l0.16,-0.19l0.55,-1.83l1.94,-1.06l0.15,-0.31l-0.2,-1.33l1.33,-0.52l2.58,-1.3l2.39,0.8l0.3,0.75l0.37,0.17l1.22,-0.39l2.18,0.75l0.2,1.36l-0.48,0.85l0.01,0.32l1.57,2.26l0.92,0.6l-0.1,0.41l0.19,0.35l1.61,0.57l0.48,0.6l-0.64,0.49l-1.91,-0.11l-0.18,0.05l-0.48,0.32l-0.1,0.39l0.57,1.1l0.51,1.78l-1.79,0.17l-0.18,0.08l-0.77,0.73l-0.09,0.19l-0.13,1.31l-0.75,-0.22l-2.11,0.15l-0.56,-0.66l-0.39,-0.06l-0.8,0.49l-0.79,-0.4l-0.13,-0.03l-1.94,-0.07l-2.76,-0.79l-2.58,-0.27l-1.98,0.07l-0.15,0.05l-1.31,0.86l-0.8,0.09l-0.04,-1.16l-0.03,-0.12l-0.63,-1.28l1.22,-0.56l0.17,-0.27l0.01,-1.35l-0.04,-0.15l-0.66,-1.24l-0.08,-1.12Z", "name": "Belarus"}, "BZ": {"path": "M198.03,239.7l0.28,0.19l0.43,-0.1l0.82,-1.42l0.0,0.07l0.29,0.29l0.16,0.0l-0.02,0.35l-0.39,1.08l0.02,0.25l0.16,0.29l-0.23,0.8l0.04,0.24l0.09,0.14l-0.25,1.12l-0.38,0.53l-0.33,0.06l-0.21,0.15l-0.41,0.74l-0.25,0.0l0.17,-2.58l0.01,-2.2Z", "name": "Belize"}, "RU": {"path": "M688.57,38.85l0.63,2.39l0.44,0.19l2.22,-1.23l7.18,0.07l5.54,2.49l1.85,1.77l-0.55,2.34l-2.64,1.42l-6.57,2.76l-1.95,1.5l0.12,0.53l3.09,0.68l3.69,1.23l0.21,-0.01l1.98,-0.81l1.16,2.84l0.5,0.08l1.03,-1.18l3.86,-0.74l7.79,0.78l0.56,2.05l0.27,0.22l10.47,0.71l0.32,-0.29l0.13,-3.34l4.98,0.8l3.96,-0.02l3.88,2.43l1.06,2.79l-1.38,1.83l0.01,0.38l3.15,3.64l0.1,0.08l3.94,1.86l0.4,-0.14l2.28,-4.56l3.75,1.94l0.22,0.02l4.18,-1.22l4.76,1.4l0.26,-0.04l1.74,-1.23l3.98,0.63l0.32,-0.41l-1.71,-4.1l3.0,-1.86l22.39,3.04l2.06,2.67l0.1,0.08l6.55,3.51l0.17,0.03l10.08,-0.86l4.86,0.73l1.91,1.72l-0.29,3.13l0.18,0.31l3.08,1.26l0.19,0.01l3.32,-0.9l4.37,-0.11l4.78,0.87l4.61,-0.48l4.26,3.82l0.32,0.05l3.1,-1.4l0.12,-0.45l-1.91,-2.67l0.92,-1.64l7.78,1.22l5.22,-0.26l7.12,2.1l9.6,5.22l6.4,4.15l-0.2,2.44l0.14,0.28l1.69,1.04l0.45,-0.31l-0.51,-2.66l6.31,0.58l4.52,3.61l-2.1,1.52l-4.02,0.42l-0.27,0.29l-0.06,3.83l-0.81,0.67l-2.14,-0.11l-1.91,-1.39l-3.19,-1.13l-0.51,-1.63l-0.21,-0.2l-2.54,-0.67l-0.13,-0.0l-2.69,0.5l-1.12,-1.19l0.48,-1.36l-0.38,-0.39l-3.0,0.98l-0.17,0.44l1.02,1.76l-1.27,1.55l-3.09,1.71l-3.15,-0.29l-0.3,0.18l0.07,0.34l2.22,2.1l1.47,3.22l1.15,1.09l0.25,1.41l-0.48,0.76l-4.47,-0.81l-0.17,0.02l-6.97,2.9l-2.2,0.44l-0.11,0.05l-3.83,2.68l-3.63,2.32l-0.1,0.11l-0.76,1.4l-3.3,-2.4l-0.3,-0.03l-6.31,2.85l-0.99,-1.21l-0.4,-0.06l-2.32,1.54l-3.23,-0.49l-0.33,0.2l-0.79,2.39l-2.97,3.51l-0.07,0.21l0.09,1.47l0.22,0.27l2.62,0.74l-0.3,4.7l-2.06,0.12l-0.26,0.2l-1.07,2.94l0.04,0.27l0.83,1.19l-4.03,1.63l-0.18,0.21l-0.83,3.72l-3.55,0.79l-0.23,0.23l-0.73,3.32l-3.22,2.76l-0.76,-1.88l-1.07,-4.88l-1.39,-7.59l1.17,-4.76l2.05,-2.08l0.09,-0.19l0.11,-1.46l3.67,-0.77l0.15,-0.08l4.47,-4.61l4.29,-3.82l4.48,-3.01l0.11,-0.14l2.01,-5.43l-0.31,-0.4l-3.04,0.33l-0.24,0.17l-1.47,3.11l-5.98,3.94l-1.91,-4.36l-0.33,-0.17l-6.46,1.3l-0.15,0.08l-6.27,6.33l-0.01,0.41l1.7,1.87l-5.04,0.87l-3.51,0.34l0.16,-2.32l-0.26,-0.32l-3.89,-0.56l-0.19,0.04l-3.02,1.77l-7.63,-0.63l-8.24,1.1l-0.16,0.07l-8.11,7.09l-9.6,8.31l0.16,0.52l3.79,0.42l1.16,2.03l0.17,0.14l2.43,0.76l0.31,-0.08l1.5,-1.61l2.49,0.2l3.46,3.6l0.08,2.67l-1.91,3.26l-0.04,0.14l-0.21,3.91l-1.11,5.09l-3.73,4.55l-0.87,2.21l-6.73,7.14l-1.59,1.77l-3.23,1.72l-1.38,0.03l-1.48,-1.39l-0.37,-0.03l-3.36,2.22l-0.11,0.14l-0.16,0.42l-0.01,-1.09l1.0,-0.06l0.28,-0.27l0.36,-3.6l-0.61,-2.51l1.85,-0.94l2.94,0.53l0.32,-0.15l1.71,-3.1l0.84,-3.38l0.97,-1.18l1.32,-2.88l-0.34,-0.42l-4.14,0.95l-2.18,1.25l-3.51,-0.0l-0.95,-2.81l-0.1,-0.14l-2.97,-2.3l-0.11,-0.05l-4.19,-1.0l-0.89,-3.08l-0.87,-2.03l-0.95,-1.46l-1.54,-3.37l-0.12,-0.14l-2.27,-1.28l-3.83,-1.02l-3.37,0.1l-3.11,0.61l-0.13,0.06l-2.07,1.69l0.04,0.49l1.23,0.72l0.03,1.53l-1.34,1.05l-2.26,3.51l-0.05,0.17l0.02,1.27l-3.25,1.9l-2.87,-1.17l-0.14,-0.02l-2.86,0.26l-1.22,-1.02l-0.12,-0.06l-1.5,-0.35l-0.23,0.04l-3.62,2.27l-3.24,0.53l-2.28,0.79l-3.08,-0.51l-2.24,0.03l-1.49,-1.61l-2.45,-1.57l-0.11,-0.04l-2.6,-0.43l-3.17,0.43l-2.31,0.59l-3.31,-1.28l-0.45,-2.31l-0.21,-0.23l-2.94,-0.85l-2.26,-0.39l-2.77,-1.36l-0.37,0.09l-2.59,3.45l-0.03,0.32l0.91,1.74l-2.15,2.01l-3.47,-0.79l-2.44,-0.12l-1.59,-1.46l-0.2,-0.08l-2.55,-0.05l-2.12,-0.98l-0.24,-0.01l-3.85,1.57l-4.74,2.79l-2.59,0.55l-0.79,0.21l-1.21,-1.81l-0.29,-0.13l-3.05,0.41l-0.96,-1.25l-0.14,-0.1l-1.65,-0.6l-1.15,-1.82l-0.13,-0.12l-1.38,-0.6l-0.19,-0.02l-3.49,0.82l-3.35,-1.85l-0.38,0.08l-1.08,1.4l-5.36,-8.17l-3.02,-2.52l0.72,-0.85l0.01,-0.38l-0.37,-0.08l-6.22,3.21l-1.98,0.16l0.17,-1.51l-0.2,-0.31l-3.22,-1.17l-0.19,-0.0l-2.3,0.74l-0.72,-3.27l-0.24,-0.23l-4.5,-0.75l-0.21,0.04l-2.2,1.42l-6.21,1.27l-0.11,0.05l-1.16,0.81l-9.3,1.19l-0.18,0.09l-1.15,1.17l-0.02,0.39l1.56,2.01l-2.02,0.74l-0.16,0.42l0.35,0.68l-2.18,1.49l0.02,0.51l3.83,2.16l-0.45,1.13l-3.31,-0.13l-0.25,0.12l-0.57,0.77l-2.97,-1.59l-0.15,-0.04l-3.97,0.07l-0.13,0.03l-2.53,1.32l-2.84,-1.28l-5.52,-2.3l-0.12,-0.02l-3.91,0.09l-0.16,0.05l-5.17,3.6l-0.13,0.21l-0.25,1.89l-2.17,-1.6l-0.44,0.1l-2.0,3.59l0.06,0.37l0.55,0.5l-1.32,2.23l0.04,0.36l2.13,2.17l0.23,0.09l1.7,-0.08l1.42,1.89l-0.23,1.5l0.19,0.32l0.94,0.38l-0.89,1.44l-2.3,0.49l-0.17,0.11l-2.49,3.2l0.0,0.37l2.2,2.81l-0.23,1.93l0.06,0.22l2.56,3.32l-1.27,1.02l-0.4,0.66l-0.8,-0.15l-1.65,-1.75l-0.18,-0.09l-0.66,-0.09l-1.45,-0.64l-0.72,-1.16l-0.18,-0.13l-2.34,-0.63l-0.17,0.0l-1.32,0.41l-0.31,-0.4l-0.12,-0.09l-3.49,-1.48l-3.67,-0.49l-2.1,-0.52l-0.3,0.1l-0.12,0.14l-2.96,-2.4l-2.89,-1.19l-1.69,-1.42l1.27,-0.35l0.16,-0.1l2.08,-2.61l-0.04,-0.41l-1.02,-0.9l3.21,-1.12l0.2,-0.31l-0.07,-0.69l-0.37,-0.26l-1.86,0.42l0.05,-0.86l1.11,-0.76l2.35,-0.23l0.25,-0.19l0.39,-1.07l0.0,-0.19l-0.51,-1.64l0.95,-1.58l0.04,-0.16l-0.03,-0.95l-0.22,-0.28l-3.69,-1.06l-1.43,0.02l-1.45,-1.44l-0.29,-0.08l-1.83,0.49l-2.88,-1.04l0.04,-0.42l-0.04,-0.18l-0.89,-1.43l-0.23,-0.14l-1.77,-0.14l-0.13,-0.66l0.52,-0.56l0.01,-0.4l-1.6,-1.9l-0.27,-0.1l-2.55,0.32l-0.71,-0.16l-0.3,0.1l-0.53,0.63l-0.58,-0.08l-0.56,-1.97l-0.48,-0.94l0.17,-0.11l1.92,0.11l0.2,-0.06l0.97,-0.74l0.05,-0.42l-0.72,-0.91l-0.13,-0.1l-1.43,-0.51l0.09,-0.36l-0.13,-0.33l-0.97,-0.59l-1.43,-2.06l0.44,-0.77l0.04,-0.19l-0.25,-1.64l-0.2,-0.24l-2.45,-0.84l-0.19,-0.0l-1.05,0.34l-0.25,-0.62l-0.18,-0.17l-2.5,-0.84l-0.74,-1.93l-0.21,-1.7l-0.13,-0.21l-0.92,-0.63l0.83,-0.89l0.07,-0.27l-0.71,-3.26l1.69,-2.01l0.03,-0.34l-0.24,-0.41l2.63,-1.9l-0.01,-0.49l-2.31,-1.57l5.08,-4.61l2.33,-2.24l1.01,-2.08l-0.09,-0.37l-3.52,-2.56l0.94,-2.38l-0.04,-0.29l-2.14,-2.86l1.61,-3.35l-0.01,-0.29l-2.81,-4.58l2.19,-3.04l-0.06,-0.42l-3.7,-2.76l0.32,-2.67l1.87,-0.38l4.26,-1.77l2.46,-1.47l3.96,2.58l0.12,0.05l6.81,1.04l9.37,4.87l1.81,1.92l0.15,2.55l-2.61,2.06l-3.95,1.07l-11.1,-3.15l-0.17,0.0l-1.84,0.53l-0.1,0.53l3.97,2.97l0.15,1.77l0.16,4.14l0.19,0.27l3.21,1.22l1.94,1.03l0.44,-0.22l0.32,-1.94l-0.07,-0.25l-1.32,-1.52l1.25,-1.2l5.87,2.45l0.24,-0.01l2.11,-0.98l0.13,-0.42l-1.55,-2.75l5.52,-3.84l2.13,0.22l2.28,1.42l0.43,-0.12l1.46,-2.87l-0.04,-0.33l-1.97,-2.37l1.14,-2.38l-0.02,-0.3l-1.42,-2.07l6.15,1.22l1.14,1.92l-2.74,0.46l-0.25,0.3l0.02,2.36l0.12,0.24l1.97,1.44l0.25,0.05l3.87,-0.91l0.22,-0.23l0.58,-2.55l5.09,-1.98l8.67,-3.69l1.22,0.14l-2.06,2.2l0.18,0.5l3.11,0.45l0.23,-0.07l1.71,-1.41l4.59,-0.12l0.12,-0.03l3.53,-1.72l2.7,2.48l0.42,-0.01l2.85,-2.88l-0.0,-0.43l-2.42,-2.35l1.0,-1.13l7.2,1.31l3.42,1.36l9.06,4.97l0.39,-0.08l1.67,-2.27l-0.04,-0.4l-2.46,-2.23l-0.06,-0.82l-0.26,-0.27l-2.64,-0.38l0.69,-1.76l0.0,-0.22l-1.32,-3.47l-0.07,-1.27l4.52,-4.09l0.08,-0.11l1.6,-4.18l1.67,-0.84l6.33,1.2l0.46,2.31l-2.31,3.67l0.05,0.38l1.49,1.41l0.77,3.04l-0.56,6.05l0.09,0.24l2.62,2.54l-0.99,2.65l-4.87,5.96l0.17,0.48l2.86,0.61l0.31,-0.13l0.94,-1.42l2.67,-1.04l0.18,-0.19l0.64,-2.01l2.11,-1.98l0.05,-0.37l-1.38,-2.32l1.11,-2.74l-0.24,-0.41l-2.53,-0.33l-0.53,-2.16l1.96,-4.42l-0.05,-0.32l-3.03,-3.48l4.21,-2.94l0.12,-0.3l-0.52,-3.04l0.72,-0.06l1.18,2.35l-0.97,4.39l0.2,0.35l2.68,0.84l0.37,-0.38l-1.05,-3.07l3.89,-1.71l5.05,-0.24l4.55,2.62l0.36,-0.05l0.05,-0.36l-2.19,-3.84l-0.23,-4.78l4.07,-0.92l5.98,0.21l5.47,-0.64l0.2,-0.48l-1.88,-2.37l2.65,-2.99l2.75,-0.13l0.12,-0.03l4.82,-2.48l6.56,-0.67l0.23,-0.14l0.76,-1.27l6.33,-0.46l1.97,1.11l0.28,0.01l5.55,-2.71l4.53,0.08l0.29,-0.21l0.67,-2.18l2.29,-2.15l5.75,-2.13l3.48,1.4l-2.7,1.03l-0.19,0.31l0.26,0.26l5.47,0.78ZM871.83,65.73l0.25,-0.15l1.99,0.01l3.3,1.2l-0.08,0.22l-2.41,1.03l-5.73,0.49l-0.31,-1.0l2.99,-1.8ZM797.64,48.44l-2.22,1.51l-3.85,-0.43l-4.35,-1.85l0.42,-1.13l4.42,0.72l5.59,1.17ZM783.82,46.06l-1.71,3.25l-9.05,-0.14l-4.11,1.15l-4.64,-3.04l1.21,-3.13l3.11,-0.91l6.53,0.22l8.66,2.59ZM780.37,145.71l2.28,5.23l-3.09,-0.89l-0.37,0.19l-1.54,4.65l0.04,0.27l2.38,3.17l-0.05,1.4l-1.41,-1.41l-0.46,0.04l-1.23,1.81l-0.33,-1.86l0.28,-3.1l-0.28,-3.41l0.58,-2.46l0.11,-4.39l-0.03,-0.13l-1.44,-3.2l0.21,-4.39l2.19,-1.49l0.09,-0.41l-0.81,-1.3l0.48,-0.21l0.56,1.94l0.86,3.23l-0.05,3.36l1.03,3.35ZM780.16,57.18l-3.4,0.03l-5.06,-0.53l1.97,-1.59l2.95,-0.42l3.35,1.75l0.18,0.77ZM683.84,31.18l-13.29,1.97l4.16,-6.56l1.88,-0.58l1.77,0.34l6.08,3.02l-0.6,1.8ZM670.94,28.02l-5.18,0.65l-6.89,-1.58l-4.03,-2.07l-1.88,-3.98l-0.18,-0.16l-2.8,-0.93l5.91,-3.62l5.25,-1.29l4.73,2.88l5.63,5.44l-0.57,4.66ZM564.37,68.98l-0.85,0.23l-7.93,-0.57l-0.6,-1.84l-0.21,-0.2l-4.34,-1.18l-0.3,-2.08l2.34,-0.92l0.19,-0.29l-0.08,-2.43l4.85,-4.0l-0.12,-0.52l-1.68,-0.43l5.47,-3.94l0.11,-0.33l-0.6,-2.02l5.36,-2.55l8.22,-3.27l8.29,-0.96l4.34,-1.94l4.67,-0.65l1.45,1.72l-1.43,1.37l-8.8,2.52l-7.65,2.42l-7.92,4.84l-3.73,4.75l-3.92,4.58l-0.07,0.23l0.51,3.88l0.11,0.2l4.32,3.39ZM548.86,18.57l-3.28,0.75l-2.25,0.44l-0.22,0.19l-0.3,0.81l-2.67,0.86l-2.27,-1.14l1.2,-1.51l-0.23,-0.49l-3.14,-0.1l2.48,-0.54l3.55,-0.07l0.44,1.36l0.49,0.12l1.4,-1.35l2.2,-0.9l3.13,1.08l-0.54,0.49ZM477.5,133.25l-4.21,0.05l-2.69,-0.34l0.39,-1.03l3.24,-1.06l2.51,0.58l0.85,0.43l-0.2,0.71l-0.0,0.15l0.12,0.52Z", "name": "Russia"}, "RW": {"path": "M497.03,288.12l0.78,1.11l-0.12,1.19l-0.49,0.21l-1.25,-0.15l-0.3,0.16l-0.67,1.24l-1.01,-0.13l0.16,-0.92l0.22,-0.12l0.15,-0.24l0.09,-1.37l0.49,-0.48l0.42,0.18l0.25,-0.01l1.26,-0.65Z", "name": "Rwanda"}, "RS": {"path": "M469.75,168.65l0.21,-0.21l0.36,-1.44l-0.08,-0.29l-1.06,-1.03l0.54,-1.16l-0.28,-0.43l-0.26,0.0l0.55,-0.67l-0.01,-0.39l-0.77,-0.86l-0.45,-0.89l1.56,-0.67l1.39,0.12l1.22,1.1l0.26,0.91l0.16,0.19l1.38,0.66l0.17,1.12l0.14,0.21l1.46,0.9l0.35,-0.03l0.62,-0.54l0.09,0.06l-0.28,0.25l-0.03,0.42l0.29,0.34l-0.44,0.5l-0.07,0.26l0.22,1.12l0.07,0.14l1.02,1.1l-0.81,0.84l-0.42,0.96l0.04,0.3l0.12,0.15l-0.15,0.16l-1.04,0.04l-0.39,0.08l0.33,-0.81l-0.29,-0.41l-0.21,0.01l-0.39,-0.45l-0.13,-0.09l-0.32,-0.11l-0.27,-0.4l-0.14,-0.11l-0.4,-0.16l-0.31,-0.37l-0.34,-0.09l-0.45,0.17l-0.18,0.18l-0.29,0.84l-0.96,-0.65l-0.81,-0.33l-0.32,-0.37l-0.22,-0.18Z", "name": "Republic of Serbia"}, "LT": {"path": "M478.13,133.31l-0.14,-0.63l0.25,-0.88l-0.15,-0.35l-1.17,-0.58l-2.43,-0.57l-0.45,-2.51l2.58,-0.97l4.14,0.22l2.3,-0.32l0.26,0.54l0.22,0.17l1.26,0.22l2.25,1.6l0.19,1.23l-1.87,1.01l-0.14,0.18l-0.54,1.83l-2.54,1.21l-2.18,-0.02l-0.52,-0.91l-0.18,-0.14l-1.11,-0.32Z", "name": "Lithuania"}, "LU": {"path": "M435.95,147.99l0.33,0.49l-0.11,1.07l-0.39,0.04l-0.29,-0.15l0.21,-1.4l0.25,-0.05Z", "name": "Luxembourg"}, "LR": {"path": "M401.37,273.67l-0.32,0.01l-2.48,-1.15l-2.24,-1.89l-2.14,-1.38l-1.47,-1.42l0.44,-0.59l0.05,-0.13l0.12,-0.65l1.07,-1.3l1.08,-1.09l0.52,-0.07l0.43,-0.18l0.84,1.24l-0.15,0.89l0.07,0.25l0.49,0.54l0.22,0.1l0.71,0.01l0.27,-0.16l0.42,-0.83l0.19,0.02l-0.06,0.52l0.23,1.12l-0.5,1.03l0.06,0.35l0.73,0.69l0.14,0.08l0.71,0.15l0.92,0.91l0.06,0.76l-0.17,0.22l-0.06,0.15l-0.17,1.8Z", "name": "Liberia"}, "RO": {"path": "M477.94,155.19l1.02,-0.64l1.49,0.33l1.52,0.01l1.09,0.73l0.32,0.01l0.81,-0.46l1.8,-0.3l0.18,-0.1l0.54,-0.64l0.86,0.0l0.64,0.26l0.71,0.87l0.8,1.35l1.39,1.81l0.07,1.25l-0.26,1.3l0.01,0.15l0.45,1.42l0.15,0.18l1.12,0.57l0.25,0.01l1.05,-0.45l0.86,0.4l0.03,0.43l-0.92,0.51l-0.63,-0.24l-0.4,0.22l-0.64,3.41l-1.12,-0.24l-1.78,-1.09l-0.23,-0.04l-2.95,0.71l-1.25,0.77l-3.55,-0.16l-1.89,-0.47l-0.14,-0.0l-0.75,0.17l-0.61,-1.07l-0.3,-0.36l0.36,-0.32l-0.04,-0.48l-0.62,-0.38l-0.36,0.03l-0.62,0.54l-1.15,-0.71l-0.18,-1.14l-0.17,-0.22l-1.4,-0.67l-0.24,-0.86l-0.09,-0.14l-0.96,-0.87l1.49,-0.44l0.16,-0.11l1.51,-2.14l1.15,-2.09l1.44,-0.63Z", "name": "Romania"}, "GW": {"path": "M383.03,256.73l-1.12,-0.88l-0.14,-0.06l-0.94,-0.15l-0.43,-0.54l0.01,-0.27l-0.13,-0.26l-0.68,-0.48l-0.05,-0.16l0.99,-0.31l0.77,0.08l0.15,-0.02l0.61,-0.26l4.25,0.1l-0.02,0.44l-0.19,0.18l-0.08,0.29l0.17,0.66l-0.17,0.14l-0.44,0.0l-0.16,0.05l-0.57,0.37l-0.66,-0.04l-0.24,0.1l-0.92,1.03Z", "name": "Guinea Bissau"}, "GT": {"path": "M195.13,249.89l-1.05,-0.35l-1.5,-0.04l-1.06,-0.47l-1.19,-0.93l0.04,-0.53l0.27,-0.55l-0.03,-0.31l-0.24,-0.32l1.02,-1.77l3.04,-0.01l0.3,-0.28l0.06,-0.88l-0.19,-0.3l-0.3,-0.11l-0.23,-0.45l-0.11,-0.12l-0.9,-0.58l-0.35,-0.33l0.37,-0.0l0.3,-0.3l0.0,-1.15l4.05,0.02l-0.02,1.74l-0.2,2.89l0.3,0.32l0.67,-0.0l0.75,0.42l0.4,-0.11l-0.62,0.53l-1.17,0.7l-0.13,0.16l-0.18,0.49l0.0,0.21l0.14,0.34l-0.35,0.44l-0.49,0.13l-0.2,0.41l0.03,0.06l-0.27,0.16l-0.86,0.64l-0.12,0.22ZM199.35,245.38l0.07,-0.13l0.05,0.02l-0.13,0.11Z", "name": "Guatemala"}, "GR": {"path": "M487.2,174.55l-0.64,1.54l-0.43,0.24l-1.41,-0.08l-1.28,-0.28l-0.14,0.0l-3.03,0.77l-0.13,0.51l1.39,1.34l-0.78,0.29l-1.2,0.0l-1.23,-1.42l-0.47,0.02l-0.47,0.65l-0.04,0.27l0.56,1.76l0.06,0.11l1.02,1.12l-0.66,0.45l-0.04,0.46l1.39,1.35l1.15,0.79l0.02,1.06l-1.91,-0.63l-0.36,0.42l0.56,1.12l-1.2,0.23l-0.22,0.4l0.8,2.14l-1.15,0.02l-1.89,-1.15l-0.89,-2.19l-0.43,-1.91l-0.05,-0.11l-0.98,-1.35l-1.24,-1.62l-0.13,-0.63l1.07,-1.32l0.06,-0.14l0.13,-0.81l0.68,-0.36l0.16,-0.25l0.03,-0.54l1.4,-0.23l0.12,-0.05l0.87,-0.6l1.26,0.05l0.25,-0.11l0.34,-0.43l0.33,-0.07l1.81,0.08l0.13,-0.02l1.87,-0.77l1.64,0.97l0.19,0.04l2.28,-0.28l0.26,-0.29l0.02,-0.95l0.56,0.36ZM480.44,192.0l1.05,0.74l0.01,0.0l-1.26,-0.23l0.2,-0.51ZM481.76,192.79l1.86,-0.15l1.53,0.17l-0.02,0.19l0.34,0.3l-2.28,0.15l0.01,-0.13l-0.25,-0.31l-1.19,-0.22ZM485.65,193.28l0.65,-0.16l-0.05,0.12l-0.6,0.04Z", "name": "Greece"}, "GQ": {"path": "M444.81,282.04l-0.21,-0.17l0.74,-2.4l3.56,0.05l0.02,2.42l-3.34,-0.02l-0.76,0.13Z", "name": "Equatorial Guinea"}, "GY": {"path": "M271.34,264.25l1.43,0.81l1.44,1.53l0.06,1.19l0.28,0.28l0.84,0.05l2.13,1.92l-0.34,1.93l-1.37,0.59l-0.17,0.34l0.12,0.51l-0.43,1.21l0.03,0.26l1.11,1.82l0.26,0.14l0.56,0.0l0.32,1.29l1.25,1.78l-0.08,0.01l-1.34,-0.21l-0.24,0.06l-0.78,0.64l-1.06,0.41l-0.76,0.1l-0.22,0.15l-0.18,0.32l-0.95,-0.1l-1.38,-1.05l-0.19,-1.13l-0.6,-1.18l0.37,-1.96l0.65,-0.83l0.03,-0.32l-0.57,-1.17l-0.15,-0.14l-0.62,-0.27l0.25,-0.85l-0.08,-0.3l-0.58,-0.58l-0.24,-0.09l-1.15,0.1l-1.41,-1.58l0.48,-0.49l0.09,-0.22l-0.04,-0.92l1.31,-0.34l0.73,-0.52l0.04,-0.44l-0.75,-0.82l0.16,-0.66l1.74,-1.3Z", "name": "Guyana"}, "GE": {"path": "M525.41,174.19l0.26,-0.88l-0.0,-0.17l-0.63,-2.06l-0.1,-0.15l-1.45,-1.12l-0.11,-0.05l-1.31,-0.33l-0.66,-0.69l1.97,0.48l3.65,0.49l3.3,1.41l0.39,0.5l0.33,0.1l1.43,-0.45l2.14,0.58l0.7,1.14l0.13,0.12l1.06,0.47l-0.18,0.11l-0.08,0.43l1.08,1.41l-0.06,0.06l-1.16,-0.15l-1.82,-0.84l-0.31,0.04l-0.55,0.44l-3.29,0.44l-2.32,-1.41l-0.17,-0.04l-2.25,0.12Z", "name": "Georgia"}, "GB": {"path": "M412.82,118.6l-2.31,3.4l-0.0,0.33l0.31,0.13l2.52,-0.49l2.34,0.02l-0.56,2.51l-2.22,3.13l0.22,0.47l2.43,0.21l2.35,4.35l0.17,0.14l1.58,0.51l1.49,3.78l0.73,1.37l0.2,0.15l2.76,0.59l-0.25,1.75l-1.18,0.91l-0.08,0.39l0.87,1.49l-1.96,1.51l-3.31,-0.02l-4.15,0.88l-1.07,-0.59l-0.35,0.04l-1.55,1.44l-2.17,-0.35l-0.22,0.05l-1.61,1.15l-0.78,-0.38l3.31,-3.12l2.18,-0.7l0.21,-0.31l-0.26,-0.27l-3.78,-0.54l-0.48,-0.9l2.3,-0.92l0.13,-0.46l-1.29,-1.71l0.39,-1.83l3.46,0.29l0.32,-0.24l0.37,-1.99l-0.06,-0.24l-1.71,-2.17l-0.18,-0.11l-2.91,-0.58l-0.43,-0.68l0.82,-1.4l-0.03,-0.35l-0.82,-0.97l-0.46,0.01l-0.85,1.05l-0.11,-2.6l-0.05,-0.16l-1.19,-1.7l0.86,-3.53l1.81,-2.75l1.88,0.26l2.38,-0.24ZM406.39,132.84l-1.09,1.92l-1.65,-0.62l-1.26,0.02l0.41,-1.46l0.0,-0.16l-0.42,-1.51l1.62,-0.11l2.39,1.92Z", "name": "United Kingdom"}, "GA": {"path": "M448.76,294.47l-2.38,-2.34l-1.63,-2.04l-1.46,-2.48l0.06,-0.66l0.54,-0.81l0.61,-1.82l0.46,-1.69l0.63,-0.11l3.62,0.03l0.3,-0.3l-0.02,-2.75l0.88,-0.12l1.47,0.32l0.13,0.0l1.39,-0.3l-0.13,0.87l0.03,0.19l0.7,1.29l0.3,0.16l1.74,-0.19l0.36,0.29l-1.01,2.7l0.05,0.29l1.13,1.42l0.25,1.82l-0.3,1.56l-0.64,0.99l-1.93,-0.09l-1.26,-1.13l-0.5,0.17l-0.16,0.91l-1.48,0.27l-0.12,0.05l-0.86,0.63l-0.08,0.39l0.81,1.42l-1.48,1.08Z", "name": "Gabon"}, "GN": {"path": "M399.83,265.31l-0.69,-0.06l-0.3,0.16l-0.43,0.85l-0.39,-0.01l-0.3,-0.33l0.14,-0.87l-0.05,-0.22l-1.05,-1.54l-0.37,-0.11l-0.61,0.27l-0.84,0.12l0.02,-0.54l-0.04,-0.17l-0.35,-0.57l0.07,-0.63l-0.03,-0.17l-0.57,-1.11l-0.7,-0.9l-0.24,-0.12l-2.0,-0.0l-0.19,0.07l-0.51,0.42l-0.6,0.05l-0.21,0.11l-0.43,0.55l-0.3,0.7l-1.04,0.86l-0.91,-1.24l-1.0,-1.02l-0.69,-0.37l-0.52,-0.42l-0.3,-1.11l-0.37,-0.56l-0.1,-0.1l-0.4,-0.23l0.77,-0.85l0.62,0.04l0.18,-0.05l0.58,-0.38l0.46,-0.0l0.19,-0.07l0.39,-0.34l0.1,-0.3l-0.17,-0.67l0.15,-0.14l0.09,-0.2l0.03,-0.57l0.87,0.02l1.76,0.6l0.13,0.01l0.55,-0.06l0.22,-0.13l0.08,-0.12l1.18,0.17l0.17,-0.02l0.09,0.56l0.3,0.25l0.4,-0.0l0.14,-0.03l0.56,-0.29l0.23,0.05l0.63,0.59l0.15,0.07l1.07,0.2l0.24,-0.06l0.65,-0.52l0.77,-0.32l0.55,-0.32l0.3,0.04l0.44,0.45l0.34,0.74l0.84,0.87l-0.35,0.45l-0.06,0.15l-0.1,0.82l0.42,0.31l0.35,-0.16l0.05,0.04l-0.1,0.59l0.09,0.27l0.42,0.4l-0.06,0.02l-0.18,0.21l-0.2,0.86l0.03,0.21l0.56,1.02l0.52,1.71l-0.65,0.21l-0.15,0.12l-0.24,0.35l-0.03,0.28l0.16,0.41l-0.1,0.76l-0.12,0.0Z", "name": "Guinea"}, "GM": {"path": "M379.18,251.48l0.15,-0.55l2.51,-0.07l0.21,-0.09l0.48,-0.52l0.58,-0.03l0.91,0.58l0.16,0.05l0.78,0.01l0.14,-0.03l0.59,-0.31l0.16,0.24l-0.71,0.38l-0.94,-0.04l-1.02,-0.51l-0.3,0.01l-0.86,0.55l-0.37,0.02l-0.14,0.04l-0.53,0.31l-1.81,-0.04Z", "name": "Gambia"}, "GL": {"path": "M304.13,6.6l8.19,-3.63l8.72,0.28l0.19,-0.06l3.12,-2.28l8.75,-0.61l19.94,0.8l14.93,4.75l-3.92,2.01l-9.52,0.27l-13.48,0.6l-0.27,0.2l0.09,0.33l1.26,1.09l0.22,0.07l8.81,-0.67l7.49,2.07l0.19,-0.01l4.68,-1.78l1.76,1.84l-2.59,3.26l-0.01,0.36l0.34,0.11l6.35,-2.2l12.09,-2.32l7.31,1.14l1.17,2.13l-9.9,4.05l-1.43,1.32l-7.91,0.98l-0.26,0.31l0.29,0.29l5.25,0.25l-2.63,3.72l-2.02,3.61l-0.04,0.15l0.08,6.05l0.07,0.19l2.61,3.0l-3.4,0.2l-4.12,1.66l-0.04,0.54l4.5,2.67l0.53,3.9l-2.39,0.42l-0.19,0.48l2.91,3.83l-5.0,0.32l-0.27,0.22l0.12,0.33l2.69,1.84l-0.65,1.35l-3.36,0.71l-3.46,0.01l-0.21,0.51l3.05,3.15l0.02,1.53l-4.54,-1.79l-0.32,0.06l-1.29,1.26l0.11,0.5l3.33,1.15l3.17,2.74l0.85,3.29l-4.0,0.78l-1.83,-1.66l-3.1,-2.64l-0.36,-0.02l-0.13,0.33l0.8,2.92l-2.76,2.26l-0.09,0.33l0.28,0.2l6.59,0.19l2.47,0.18l-5.86,3.38l-6.76,3.43l-7.26,1.48l-2.73,0.02l-0.16,0.05l-2.67,1.72l-3.44,4.42l-5.28,2.86l-1.73,0.18l-3.33,1.01l-3.59,0.96l-0.15,0.1l-2.15,2.52l-0.07,0.19l-0.03,2.76l-1.21,2.49l-4.03,3.1l-0.1,0.33l0.98,2.94l-2.31,6.57l-3.21,0.21l-3.6,-3.0l-0.19,-0.07l-4.9,-0.02l-2.29,-1.97l-1.69,-3.78l-4.31,-4.86l-1.23,-2.52l-0.34,-3.58l-0.08,-0.17l-3.35,-3.67l0.85,-2.92l-0.09,-0.31l-1.5,-1.34l2.33,-4.7l3.67,-1.57l0.15,-0.13l1.02,-1.93l0.52,-3.47l-0.44,-0.31l-2.85,1.57l-1.33,0.64l-2.12,0.59l-2.81,-1.32l-0.15,-2.79l0.88,-2.17l2.09,-0.06l5.07,1.2l0.34,-0.17l-0.11,-0.37l-4.3,-2.9l-2.24,-1.58l-0.25,-0.05l-2.38,0.62l-1.7,-0.93l2.62,-4.1l-0.03,-0.36l-1.51,-1.75l-1.97,-3.3l-3.01,-5.21l-0.1,-0.11l-3.04,-1.85l0.03,-1.94l-0.18,-0.28l-6.82,-3.01l-5.35,-0.38l-6.69,0.21l-6.03,0.37l-2.81,-1.59l-3.84,-2.9l5.94,-1.5l5.01,-0.28l0.28,-0.29l-0.26,-0.31l-10.68,-1.38l-5.38,-2.1l0.27,-1.68l9.3,-2.6l9.18,-2.68l0.19,-0.16l0.97,-2.05l-0.18,-0.42l-6.29,-1.91l1.81,-1.9l8.58,-4.05l3.6,-0.63l0.23,-0.4l-0.92,-2.37l5.59,-1.5l7.66,-0.95l7.58,-0.05l2.65,1.84l0.31,0.02l6.52,-3.29l5.85,2.24l3.55,0.49l5.17,1.95l0.38,-0.16l-0.13,-0.39l-5.77,-3.16l0.29,-2.26Z", "name": "Greenland"}, "KW": {"path": "M540.87,207.81l0.41,0.94l-0.18,0.51l0.0,0.21l0.65,1.66l-1.15,0.05l-0.54,-1.12l-0.24,-0.17l-1.73,-0.2l1.44,-2.06l1.33,0.18Z", "name": "Kuwait"}, "GH": {"path": "M423.16,269.88l-3.58,1.34l-1.41,0.87l-2.13,0.69l-1.91,-0.61l0.09,-0.75l-0.03,-0.17l-1.04,-2.07l0.62,-2.7l1.04,-2.08l0.03,-0.19l-1.0,-5.46l0.05,-1.12l4.04,-0.11l1.08,0.18l0.18,-0.03l0.72,-0.36l0.75,0.13l-0.11,0.48l0.06,0.26l0.98,1.22l-0.0,1.77l0.24,1.99l0.05,0.13l0.55,0.81l-0.52,2.14l0.19,1.37l0.69,1.66l0.38,0.62Z", "name": "Ghana"}, "OM": {"path": "M568.16,231.0l-0.08,0.1l-0.84,1.61l-0.93,-0.11l-0.27,0.11l-0.58,0.73l-0.4,1.32l-0.01,0.14l0.29,1.61l-0.07,0.09l-1.0,-0.01l-0.16,0.04l-1.56,0.97l-0.14,0.2l-0.23,1.17l-0.41,0.4l-1.44,-0.02l-0.17,0.05l-0.98,0.65l-0.13,0.25l0.01,0.87l-0.97,0.57l-1.27,-0.22l-0.19,0.03l-1.63,0.84l-0.88,0.11l-2.55,-5.57l7.2,-2.49l0.19,-0.19l1.67,-5.23l-0.03,-0.25l-1.1,-1.78l0.05,-0.89l0.68,-1.03l0.05,-0.16l0.01,-0.89l0.96,-0.44l0.07,-0.5l-0.32,-0.26l0.16,-1.31l0.85,-0.01l1.03,1.67l0.09,0.09l1.4,0.96l0.11,0.05l1.82,0.34l1.37,0.45l1.75,2.32l0.13,0.1l0.7,0.26l-0.0,0.3l-1.25,2.19l-1.01,0.8ZM561.88,218.47l-0.01,0.02l-0.15,-0.29l0.3,-0.38l-0.14,0.65Z", "name": "Oman"}, "_3": {"path": "M543.2,261.06l-1.07,1.46l-1.65,1.99l-1.91,0.01l-8.08,-2.95l-0.89,-0.84l-0.9,-1.19l-0.81,-1.23l0.44,-0.73l0.76,-1.12l0.49,0.28l0.52,1.05l1.13,1.06l0.2,0.08l1.24,0.01l2.42,-0.65l2.77,-0.31l2.17,-0.78l1.31,-0.19l0.84,-0.43l1.03,-0.06l-0.01,4.54Z", "name": "Somaliland"}, "_2": {"path": "M384.23,230.37l0.07,-0.06l0.28,-0.89l0.99,-1.13l0.07,-0.13l0.8,-3.54l3.4,-2.8l0.09,-0.13l0.76,-2.17l0.07,5.5l-2.07,0.21l-0.24,0.17l-0.61,1.36l-0.02,0.16l0.43,3.46l-4.01,-0.01ZM391.82,218.2l0.07,-0.06l0.75,-1.93l1.86,-0.25l0.94,0.34l1.14,0.0l0.18,-0.06l0.73,-0.56l1.41,-0.08l-0.0,2.72l-7.08,-0.12Z", "name": "Western Sahara"}, "_1": {"path": "M472.71,172.84l-0.07,-0.43l-0.16,-0.22l-0.53,-0.27l-0.38,-0.58l0.3,-0.43l0.51,-0.19l0.18,-0.18l0.3,-0.87l0.12,-0.04l0.22,0.26l0.12,0.09l0.38,0.15l0.28,0.41l0.15,0.12l0.34,0.12l0.43,0.5l0.15,0.07l-0.12,0.3l-0.27,0.32l-0.03,0.18l-0.31,0.06l-1.48,0.47l-0.15,0.17Z", "name": "Kosovo"}, "_0": {"path": "M503.54,192.92l0.09,-0.17l0.41,0.01l-0.08,0.01l-0.42,0.15ZM504.23,192.76l1.02,0.02l0.4,-0.13l-0.09,0.29l0.03,0.08l-0.35,0.16l-0.24,-0.04l-0.06,-0.1l-0.18,-0.17l-0.19,-0.08l-0.33,-0.02Z", "name": "Northern Cyprus"}, "JO": {"path": "M510.26,200.93l0.28,-0.57l2.53,1.0l0.27,-0.02l4.57,-2.77l0.84,2.84l-0.28,0.25l-4.95,1.37l-0.14,0.49l2.24,2.48l-0.5,0.28l-0.13,0.14l-0.35,0.78l-1.76,0.35l-0.2,0.14l-0.57,0.94l-0.94,0.73l-2.45,-0.38l-0.03,-0.12l1.23,-4.32l-0.04,-1.1l0.34,-0.75l0.03,-0.12l0.0,-1.63Z", "name": "Jordan"}, "HR": {"path": "M455.49,162.73l1.53,0.09l0.24,-0.1l0.29,-0.34l0.64,0.38l0.14,0.04l0.98,0.06l0.32,-0.3l-0.01,-0.66l0.67,-0.25l0.19,-0.22l0.21,-1.11l1.72,-0.72l0.65,0.32l1.94,1.37l2.07,0.6l0.22,-0.02l0.67,-0.33l0.47,0.94l0.67,0.76l-0.63,0.77l-0.91,-0.55l-0.16,-0.04l-1.69,0.04l-2.2,-0.51l-1.17,0.07l-0.21,0.11l-0.36,0.42l-0.67,-0.53l-0.46,0.12l-0.52,1.29l0.05,0.31l1.21,1.42l0.58,0.99l1.15,1.14l0.95,0.68l0.92,1.23l0.1,0.09l1.75,0.91l-1.87,-0.89l-1.5,-1.11l-2.23,-0.88l-1.77,-1.9l0.12,-0.06l0.1,-0.47l-1.07,-1.22l-0.04,-0.94l-0.21,-0.27l-1.61,-0.49l-0.35,0.14l-0.53,0.93l-0.41,-0.57l0.04,-0.73Z", "name": "Croatia"}, "HT": {"path": "M237.82,234.68l1.35,0.1l1.95,0.37l0.18,1.15l-0.16,0.83l-0.51,0.37l-0.06,0.44l0.57,0.68l-0.02,0.22l-1.31,-0.35l-1.26,0.17l-1.49,-0.18l-0.15,0.02l-1.03,0.43l-1.02,-0.61l0.09,-0.36l2.04,0.32l1.9,0.21l0.19,-0.05l0.9,-0.58l0.05,-0.47l-1.05,-1.03l0.02,-0.86l-0.23,-0.3l-1.13,-0.29l0.18,-0.23Z", "name": "Haiti"}, "HU": {"path": "M461.96,157.92l0.68,-1.66l-0.03,-0.29l-0.15,-0.22l0.84,-0.0l0.3,-0.26l0.12,-0.84l0.88,0.57l0.98,0.38l0.16,0.01l2.1,-0.39l0.23,-0.21l0.14,-0.45l0.88,-0.1l1.06,-0.43l0.13,0.1l0.28,0.04l1.18,-0.4l0.14,-0.1l0.52,-0.67l0.63,-0.15l2.6,0.95l0.26,-0.03l0.38,-0.23l1.12,0.7l0.1,0.49l-1.31,0.57l-0.14,0.13l-1.18,2.14l-1.44,2.04l-1.85,0.55l-1.51,-0.13l-0.14,0.02l-1.92,0.82l-0.85,0.42l-1.91,-0.55l-1.83,-1.31l-0.74,-0.37l-0.44,-0.97l-0.26,-0.18Z", "name": "Hungary"}, "HN": {"path": "M202.48,251.87l-0.33,-0.62l-0.18,-0.14l-0.5,-0.15l0.13,-0.76l-0.11,-0.28l-0.34,-0.28l-0.6,-0.23l-0.18,-0.01l-0.81,0.22l-0.16,-0.24l-0.72,-0.39l-0.51,-0.48l-0.12,-0.07l-0.31,-0.09l0.24,-0.3l0.04,-0.3l-0.16,-0.4l0.1,-0.28l1.14,-0.69l1.0,-0.86l0.09,0.04l0.3,-0.05l0.47,-0.39l0.49,-0.03l0.14,0.13l0.29,0.06l0.31,-0.1l1.16,0.22l1.24,-0.08l0.81,-0.28l0.29,-0.25l0.63,0.1l0.69,0.18l0.65,-0.06l0.49,-0.2l1.04,0.32l0.38,0.06l0.7,0.44l0.71,0.56l0.92,0.41l0.1,0.11l-0.11,-0.01l-0.23,0.09l-0.3,0.3l-0.76,0.29l-0.58,0.0l-0.15,0.04l-0.45,0.26l-0.31,-0.07l-0.37,-0.34l-0.28,-0.07l-0.26,0.07l-0.18,0.15l-0.23,0.43l-0.04,-0.0l-0.33,0.28l-0.03,0.4l-0.76,0.61l-0.45,0.3l-0.15,0.16l-0.51,-0.36l-0.41,0.06l-0.45,0.56l-0.41,-0.01l-0.59,0.06l-0.27,0.31l0.04,0.96l-0.07,0.0l-0.25,0.16l-0.24,0.45l-0.42,0.06Z", "name": "Honduras"}, "PR": {"path": "M254.95,238.31l1.15,0.21l0.2,0.23l-0.36,0.36l-1.76,-0.01l-1.2,0.07l-0.09,-0.69l0.17,-0.18l1.89,0.01Z", "name": "Puerto Rico"}, "PS": {"path": "M509.66,201.06l-0.0,1.44l-0.29,0.63l-0.59,0.19l0.02,-0.11l0.52,-0.31l-0.02,-0.53l-0.41,-0.2l0.36,-1.28l0.41,0.17Z", "name": "West Bank"}, "PT": {"path": "M398.65,173.6l0.75,-0.63l0.7,-0.3l0.51,1.2l0.28,0.18l1.48,-0.0l0.2,-0.08l0.33,-0.3l1.16,0.08l0.52,1.11l-0.95,0.66l-0.13,0.24l-0.03,2.2l-0.33,0.35l-0.08,0.18l-0.08,1.17l-0.86,0.19l-0.2,0.44l0.93,1.64l-0.64,1.79l0.07,0.31l0.72,0.72l-0.24,0.56l-0.9,1.05l-0.07,0.26l0.17,0.77l-0.73,0.54l-1.18,-0.36l-0.16,-0.0l-0.85,0.21l0.31,-1.81l-0.23,-1.87l-0.23,-0.25l-0.99,-0.24l-0.49,-0.91l0.18,-1.72l0.93,-0.99l0.08,-0.16l0.17,-1.17l0.52,-1.76l-0.04,-1.36l-0.51,-1.14l-0.09,-0.8Z", "name": "Portugal"}, "PY": {"path": "M264.33,341.43l0.93,-2.96l0.07,-1.42l1.1,-2.1l4.19,-0.73l2.22,0.04l2.12,1.21l0.07,0.76l0.7,1.38l-0.16,3.48l0.24,0.31l2.64,0.5l0.19,-0.03l0.9,-0.45l1.47,0.62l0.38,0.64l0.23,2.35l0.3,1.07l0.25,0.21l0.93,0.12l0.16,-0.02l0.8,-0.37l0.61,0.33l-0.0,1.25l-0.33,1.53l-0.5,1.57l-0.39,2.26l-2.14,1.94l-1.85,0.4l-2.74,-0.4l-2.13,-0.62l2.26,-3.75l0.03,-0.24l-0.36,-1.18l-0.17,-0.19l-2.55,-1.03l-3.04,-1.95l-2.07,-0.43l-4.4,-4.12Z", "name": "Paraguay"}, "PA": {"path": "M213.65,263.79l0.18,-0.43l0.02,-0.18l-0.06,-0.28l0.23,-0.18l-0.01,-0.48l-0.4,-0.29l-0.01,-0.62l0.57,-0.13l0.68,0.69l-0.04,0.39l0.26,0.33l1.0,0.11l0.27,-0.1l0.49,0.44l0.24,0.07l1.34,-0.22l1.04,-0.62l1.49,-0.5l0.86,-0.73l0.99,0.11l0.18,0.28l1.35,0.08l1.02,0.4l0.78,0.72l0.71,0.53l-0.1,0.12l-0.05,0.3l0.53,1.34l-0.28,0.44l-0.6,-0.13l-0.36,0.22l-0.2,0.76l-0.41,-0.36l-0.44,-1.12l0.49,-0.53l-0.14,-0.49l-0.51,-0.14l-0.41,-0.72l-0.11,-0.11l-1.25,-0.7l-0.19,-0.04l-1.1,0.16l-0.22,0.15l-0.47,0.81l-0.9,0.56l-0.49,0.08l-0.22,0.17l-0.25,0.52l0.05,0.32l0.93,1.07l-0.41,0.21l-0.29,0.3l-0.81,0.09l-0.36,-1.26l-0.53,-0.1l-0.21,0.28l-0.5,-0.09l-0.44,-0.88l-0.22,-0.16l-0.99,-0.16l-0.61,-0.28l-0.13,-0.03l-1.0,0.0Z", "name": "Panama"}, "PG": {"path": "M808.4,298.6l0.62,0.46l1.19,1.56l1.04,0.77l-0.18,0.37l-0.42,0.15l-0.92,-0.82l-1.05,-1.53l-0.27,-0.96ZM804.09,296.06l-0.3,0.26l-0.36,-1.11l-0.66,-1.06l-2.55,-1.89l-1.42,-0.59l0.17,-0.15l1.16,0.6l0.85,0.55l1.01,0.58l0.97,1.02l0.9,0.76l0.24,1.03ZM796.71,297.99l0.15,0.82l0.34,0.24l1.43,-0.19l0.19,-0.11l0.68,-0.82l1.36,-0.87l0.13,-0.31l-0.21,-1.13l1.04,-0.03l0.3,0.25l-0.04,1.17l-0.74,1.34l-1.17,0.18l-0.22,0.15l-0.35,0.62l-2.51,1.13l-1.21,-0.0l-1.99,-0.71l-1.19,-0.58l0.07,-0.28l1.98,0.32l1.46,-0.2l0.24,-0.21l0.25,-0.79ZM789.24,303.52l0.11,0.15l2.19,1.62l1.6,2.62l0.27,0.14l1.09,-0.06l-0.07,0.77l0.23,0.32l1.23,0.27l-0.14,0.09l0.05,0.53l2.39,0.95l-0.11,0.28l-1.33,0.14l-0.51,-0.55l-0.18,-0.09l-4.59,-0.65l-1.87,-1.55l-1.38,-1.35l-1.28,-2.17l-0.16,-0.13l-3.27,-1.1l-0.19,0.0l-2.12,0.72l-1.58,0.85l-0.15,0.31l0.28,1.63l-1.65,0.73l-1.37,-0.4l-2.3,-0.09l-0.08,-15.65l3.95,1.57l4.58,1.42l1.67,1.25l1.32,1.19l0.36,1.39l0.19,0.21l4.06,1.51l0.39,0.85l-1.9,0.22l-0.25,0.39l0.55,1.68Z", "name": "Papua New Guinea"}, "PE": {"path": "M246.44,329.21l-0.63,1.25l-1.05,0.54l-2.25,-1.33l-0.19,-0.93l-0.16,-0.21l-4.95,-2.58l-4.46,-2.79l-1.87,-1.52l-0.94,-1.91l0.33,-0.6l-0.01,-0.31l-2.11,-3.33l-2.46,-4.66l-2.36,-5.02l-1.04,-1.18l-0.77,-1.81l-0.08,-0.11l-1.95,-1.64l-1.54,-0.88l0.61,-0.85l0.02,-0.31l-1.15,-2.27l0.69,-1.56l1.59,-1.26l0.12,0.42l-0.56,0.47l-0.11,0.25l0.07,0.92l0.36,0.27l0.97,-0.19l0.85,0.23l0.99,1.19l0.41,0.05l1.42,-1.03l0.11,-0.16l0.46,-1.64l1.45,-2.06l2.92,-0.96l0.11,-0.07l2.73,-2.62l0.84,-1.72l0.02,-0.18l-0.3,-1.65l0.28,-0.1l1.49,1.06l0.77,1.14l0.1,0.09l1.08,0.6l1.43,2.55l0.21,0.15l1.86,0.31l0.18,-0.03l1.25,-0.6l0.77,0.37l0.17,0.03l1.4,-0.2l1.57,0.96l-1.45,2.29l0.23,0.46l0.63,0.05l0.66,0.7l-1.51,-0.08l-0.24,0.1l-0.27,0.31l-1.96,0.46l-2.95,1.74l-0.14,0.21l-0.17,1.1l-0.6,0.82l-0.05,0.23l0.21,1.13l-1.31,0.63l-0.17,0.27l0.0,0.91l-0.53,0.37l-0.1,0.37l1.04,2.27l1.31,1.46l-0.44,0.9l0.24,0.43l1.52,0.13l0.87,1.23l0.24,0.13l2.21,0.07l0.18,-0.06l1.55,-1.13l-0.14,3.22l0.23,0.3l1.14,0.29l0.16,-0.0l1.18,-0.36l1.97,3.71l-0.45,0.71l-0.04,0.14l-0.12,1.8l-0.05,2.07l-0.92,1.2l-0.03,0.31l0.38,0.8l-0.48,0.72l-0.02,0.3l1.01,2.02l-1.5,2.64Z", "name": "Peru"}, "PK": {"path": "M609.08,187.76l1.66,1.21l0.71,2.11l0.2,0.19l3.62,1.01l-1.98,1.95l-2.65,0.4l-3.75,-0.68l-0.26,0.08l-1.23,1.22l-0.07,0.31l0.89,2.46l0.88,1.92l0.1,0.12l1.67,1.14l-1.8,1.35l-0.12,0.25l0.04,1.85l-2.35,2.67l-1.59,2.79l-2.5,2.72l-2.76,-0.2l-0.24,0.09l-2.76,2.83l0.04,0.45l1.54,1.13l0.27,1.94l0.09,0.17l1.34,1.29l0.4,1.83l-5.14,-0.01l-0.22,0.09l-1.53,1.63l-1.52,-0.56l-0.76,-1.88l-1.93,-2.03l-0.25,-0.09l-4.6,0.5l-4.05,0.05l-3.1,0.33l0.77,-2.53l3.48,-1.33l0.19,-0.33l-0.21,-1.24l-0.19,-0.23l-1.01,-0.37l-0.06,-2.18l-0.17,-0.26l-2.32,-1.16l-0.96,-1.57l-0.56,-0.65l3.16,1.05l0.14,0.01l2.45,-0.4l1.44,0.33l0.3,-0.1l0.4,-0.47l1.58,0.22l0.14,-0.01l3.25,-1.14l0.2,-0.27l0.08,-2.23l1.23,-1.38l1.73,0.0l0.28,-0.2l0.22,-0.61l1.68,-0.32l0.86,0.24l0.27,-0.05l0.98,-0.78l0.11,-0.26l-0.13,-1.57l0.96,-1.52l1.51,-0.67l0.14,-0.41l-0.74,-1.4l1.86,0.07l0.26,-0.13l0.69,-1.01l0.05,-0.2l-0.09,-0.94l1.14,-1.09l0.09,-0.28l-0.29,-1.41l-0.51,-1.07l1.23,-1.05l2.6,-0.58l2.86,-0.33l1.33,-0.54l1.3,-0.29Z", "name": "Pakistan"}, "PH": {"path": "M737.11,263.82l0.25,1.66l0.14,1.34l-0.54,1.46l-0.64,-1.79l-0.5,-0.1l-1.17,1.28l-0.05,0.32l0.74,1.71l-0.49,0.81l-2.6,-1.28l-0.61,-1.57l0.68,-1.07l-0.07,-0.4l-1.59,-1.19l-0.42,0.06l-0.69,0.91l-1.01,-0.08l-0.21,0.06l-1.58,1.2l-0.17,-0.3l0.87,-1.88l1.48,-0.66l1.18,-0.81l0.71,0.92l0.34,0.1l1.9,-0.69l0.18,-0.18l0.34,-0.94l1.57,-0.06l0.29,-0.32l-0.1,-1.38l1.41,0.83l0.36,2.06ZM734.94,254.42l0.56,2.24l-1.41,-0.49l-0.4,0.3l0.07,0.94l0.51,1.3l-0.54,0.26l-0.08,-1.34l-0.25,-0.28l-0.56,-0.1l-0.23,-0.91l1.03,0.14l0.34,-0.31l-0.03,-0.96l-0.06,-0.18l-1.14,-1.44l1.62,0.04l0.57,0.78ZM724.68,238.33l1.48,0.71l0.33,-0.04l0.44,-0.38l0.05,0.13l-0.37,0.97l0.01,0.23l0.81,1.75l-0.59,1.92l-1.37,0.79l-0.14,0.2l-0.39,2.07l0.01,0.14l0.56,2.04l0.23,0.21l1.33,0.28l0.14,-0.0l1.0,-0.27l2.82,1.28l-0.2,1.16l0.12,0.29l0.66,0.5l-0.13,0.56l-1.54,-0.99l-0.89,-1.29l-0.49,0.0l-0.44,0.65l-1.34,-1.28l-0.26,-0.08l-2.18,0.36l-0.96,-0.44l0.09,-0.72l0.69,-0.57l-0.01,-0.47l-0.75,-0.59l-0.47,0.14l-0.15,0.43l-0.86,-1.02l-0.34,-1.02l-0.07,-1.74l0.49,0.41l0.49,-0.21l0.26,-3.99l0.73,-2.1l1.23,0.0ZM731.12,258.92l-0.82,0.75l-0.83,1.64l-0.52,0.5l-1.17,-1.33l0.36,-0.47l0.62,-0.7l0.07,-0.15l0.24,-1.35l0.73,-0.08l-0.31,1.29l0.16,0.34l0.37,-0.09l1.21,-1.6l-0.12,1.24ZM726.66,255.58l0.85,0.45l0.14,0.03l1.28,-0.0l-0.03,0.62l-1.04,0.96l-1.15,0.55l-0.05,-0.71l0.17,-1.26l-0.01,-0.13l-0.16,-0.51ZM724.92,252.06l-0.45,1.5l-0.7,-0.83l-0.95,-1.43l1.44,0.06l0.67,0.7ZM717.48,261.28l-1.87,1.35l0.21,-0.3l1.81,-1.57l1.5,-1.75l0.97,-1.84l0.23,1.08l-1.56,1.33l-1.29,1.7Z", "name": "Philippines"}, "PL": {"path": "M458.8,144.25l-0.96,-1.98l0.18,-1.06l-0.01,-0.15l-0.62,-1.8l-0.82,-1.11l0.56,-0.73l0.05,-0.28l-0.51,-1.51l1.48,-0.87l3.88,-1.58l3.06,-1.14l2.23,0.52l0.15,0.66l0.29,0.23l2.4,0.04l3.11,0.39l4.56,-0.05l1.12,0.32l0.51,0.89l0.1,1.45l0.03,0.12l0.66,1.23l-0.01,1.08l-1.33,0.61l-0.14,0.41l0.74,1.5l0.07,1.53l1.22,2.79l-0.19,0.66l-1.09,0.33l-0.14,0.09l-2.27,2.72l-0.04,0.31l0.35,0.8l-2.22,-1.16l-0.21,-0.02l-1.72,0.44l-1.1,-0.31l-0.21,0.02l-1.3,0.61l-1.11,-1.02l-0.32,-0.05l-0.81,0.35l-1.15,-1.61l-0.21,-0.12l-1.65,-0.17l-0.19,-0.82l-0.23,-0.23l-1.72,-0.37l-0.34,0.17l-0.25,0.56l-0.88,-0.44l0.12,-0.69l-0.25,-0.35l-1.78,-0.27l-1.08,-0.97Z", "name": "Poland"}, "ZM": {"path": "M502.81,308.32l1.09,1.04l0.58,1.94l-0.39,0.66l-0.5,2.05l-0.0,0.14l0.45,1.95l-0.69,0.77l-0.06,0.11l-0.76,2.37l0.15,0.36l0.62,0.31l-6.85,1.9l-0.22,0.33l0.2,1.54l-1.62,0.3l-0.12,0.05l-1.43,1.02l-0.11,0.15l-0.25,0.73l-0.73,0.17l-0.14,0.08l-2.18,2.12l-1.33,1.6l-0.65,0.05l-0.83,-0.29l-2.75,-0.28l-0.24,-0.1l-0.15,-0.27l-0.99,-0.58l-0.12,-0.04l-1.73,-0.14l-1.88,0.54l-1.5,-1.48l-1.61,-2.01l0.11,-7.73l4.92,0.03l0.29,-0.37l-0.19,-0.79l0.34,-0.86l0.0,-0.21l-0.41,-1.11l0.26,-1.14l-0.01,-0.16l-0.12,-0.36l0.18,0.01l0.1,0.56l0.31,0.25l1.14,-0.06l1.44,0.21l0.76,1.05l0.19,0.12l2.01,0.35l0.19,-0.03l1.24,-0.65l0.44,1.03l0.22,0.18l1.81,0.34l0.85,0.99l1.02,1.39l0.24,0.12l1.92,0.02l0.3,-0.32l-0.21,-2.74l-0.47,-0.23l-0.53,0.36l-1.58,-0.89l-0.51,-0.34l0.29,-2.36l0.44,-2.99l-0.03,-0.18l-0.5,-0.99l0.61,-1.38l0.53,-0.24l3.26,-0.41l0.89,0.23l1.01,0.62l1.04,0.44l1.6,0.43l1.35,0.72Z", "name": "Zambia"}, "EE": {"path": "M482.19,120.88l0.23,-1.68l-0.43,-0.31l-0.75,0.37l-1.34,-1.1l-0.18,-1.75l2.92,-0.95l3.07,-0.53l2.66,0.6l2.48,-0.1l0.18,0.31l-1.65,1.96l-0.06,0.26l0.71,3.25l-0.88,0.94l-1.85,-0.01l-2.08,-1.3l-1.14,-0.47l-0.2,-0.01l-1.69,0.51Z", "name": "Estonia"}, "EG": {"path": "M508.07,208.8l-0.66,1.06l-0.53,2.03l-0.64,1.32l-0.32,0.26l-1.74,-1.85l-1.77,-3.86l-0.48,-0.09l-0.26,0.25l-0.07,0.32l1.04,2.88l1.55,2.76l1.89,4.18l0.94,1.48l0.83,1.54l2.08,2.73l-0.3,0.28l-0.1,0.23l0.08,1.72l0.11,0.22l2.91,2.37l-28.78,0.0l0.0,-19.06l-0.73,-2.2l0.61,-1.59l0.0,-0.2l-0.34,-1.04l0.73,-1.08l3.13,-0.04l2.36,0.72l2.48,0.81l1.15,0.43l0.23,-0.01l1.93,-0.87l1.02,-0.78l2.08,-0.21l1.59,0.31l0.62,1.24l0.52,0.03l0.46,-0.71l1.86,0.59l1.95,0.16l0.17,-0.04l0.92,-0.52l1.48,4.24Z", "name": "Egypt"}, "ZA": {"path": "M467.06,373.27l-0.13,-0.29l0.01,-1.58l-0.02,-0.12l-0.71,-1.64l0.59,-0.37l0.14,-0.26l-0.07,-2.13l-0.05,-0.15l-1.63,-2.58l-1.25,-2.31l-1.71,-3.37l0.88,-0.98l0.7,0.52l0.39,1.08l0.23,0.19l1.1,0.19l1.55,0.51l0.14,0.01l1.35,-0.2l0.11,-0.04l2.24,-1.39l0.14,-0.25l0.0,-9.4l0.16,0.09l1.39,2.38l-0.22,1.53l0.04,0.19l0.56,0.94l0.3,0.14l1.79,-0.27l0.16,-0.08l1.23,-1.18l1.17,-0.79l0.1,-0.12l0.57,-1.19l1.02,-0.52l0.9,0.28l1.16,0.73l0.14,0.05l2.04,0.13l0.13,-0.02l1.6,-0.62l0.18,-0.19l0.63,-1.93l1.18,-0.19l0.19,-0.12l0.78,-1.05l0.81,-1.71l2.18,-1.91l3.44,-1.88l0.89,0.02l1.17,0.43l0.21,-0.0l0.76,-0.29l1.07,0.21l1.15,3.55l0.63,1.82l-0.44,2.9l0.1,0.52l-0.74,-0.29l-0.18,-0.01l-0.72,0.19l-0.21,0.2l-0.22,0.74l-0.66,0.97l-0.05,0.18l0.02,0.93l0.09,0.21l1.49,1.46l0.27,0.08l1.47,-0.29l0.22,-0.18l0.43,-1.01l1.29,0.02l-0.51,1.63l-0.29,2.2l-0.59,1.12l-2.2,1.78l-1.06,1.39l-0.72,1.44l-1.39,1.93l-2.81,2.84l-1.75,1.65l-1.85,1.24l-2.55,1.06l-1.23,0.14l-0.24,0.18l-0.22,0.54l-1.27,-0.35l-0.2,0.01l-1.15,0.5l-2.62,-0.52l-0.12,0.0l-1.46,0.33l-0.98,-0.14l-0.16,0.02l-2.55,1.1l-2.11,0.44l-1.59,1.07l-0.93,0.06l-0.97,-0.92l-0.19,-0.08l-0.72,-0.04l-1.0,-1.16l-0.25,0.05ZM493.72,359.24l-1.12,-0.86l-0.31,-0.03l-1.23,0.59l-1.36,1.07l-1.39,1.78l0.01,0.38l1.88,2.11l0.31,0.09l0.9,-0.27l0.18,-0.15l0.4,-0.77l1.28,-0.39l0.18,-0.16l0.42,-0.88l0.76,-1.32l-0.05,-0.37l-0.87,-0.82Z", "name": "South Africa"}, "EC": {"path": "M220.2,293.48l1.25,-1.76l0.02,-0.31l-0.54,-1.09l-0.5,-0.06l-0.78,0.94l-1.03,-0.75l0.33,-0.46l0.05,-0.23l-0.38,-2.04l0.66,-0.28l0.17,-0.19l0.45,-1.52l0.93,-1.58l0.04,-0.2l-0.13,-0.78l1.19,-0.47l1.57,-0.91l2.35,1.34l0.17,0.04l0.28,-0.02l0.52,0.91l0.21,0.15l2.12,0.35l0.2,-0.03l0.55,-0.31l1.08,0.73l0.97,0.54l0.31,1.67l-0.71,1.49l-2.64,2.54l-2.95,0.97l-0.15,0.11l-1.53,2.18l-0.49,1.68l-1.1,0.8l-0.87,-1.05l-0.15,-0.1l-1.01,-0.27l-0.13,-0.0l-0.7,0.14l-0.03,-0.43l0.6,-0.5l0.1,-0.31l-0.26,-0.91Z", "name": "Ecuador"}, "AL": {"path": "M470.27,171.7l0.38,0.19l0.45,-0.18l0.4,0.61l0.11,0.1l0.46,0.24l0.13,0.87l-0.3,0.95l-0.0,0.17l0.36,1.28l0.12,0.17l0.9,0.63l-0.03,0.44l-0.67,0.35l-0.16,0.22l-0.14,0.88l-0.96,1.18l-0.06,-0.03l-0.04,-0.48l-0.12,-0.22l-1.28,-0.92l-0.19,-1.25l0.2,-1.96l0.33,-0.89l-0.06,-0.3l-0.36,-0.41l-0.13,-0.75l0.66,-0.9Z", "name": "Albania"}, "AO": {"path": "M461.62,299.93l0.55,1.67l0.73,1.54l1.56,2.18l0.28,0.12l1.66,-0.2l0.81,-0.34l1.28,0.33l0.33,-0.14l0.39,-0.67l0.56,-1.3l1.37,-0.09l0.27,-0.21l0.07,-0.23l0.67,-0.01l-0.13,0.53l0.29,0.37l2.74,-0.02l0.04,1.29l0.03,0.13l0.46,0.87l-0.35,1.52l0.18,1.55l0.07,0.16l0.75,0.85l-0.13,2.89l0.41,0.29l0.56,-0.21l1.11,0.05l1.5,-0.37l0.9,0.12l0.18,0.53l-0.27,1.15l0.01,0.17l0.4,1.08l-0.33,0.85l-0.01,0.18l0.12,0.51l-4.83,-0.03l-0.3,0.3l-0.12,8.13l0.07,0.19l1.69,2.1l1.27,1.25l-4.03,0.92l-5.93,-0.36l-1.66,-1.19l-0.18,-0.06l-10.15,0.11l-0.34,0.13l-1.35,-1.05l-0.17,-0.06l-1.62,-0.08l-1.6,0.45l-0.88,0.36l-0.17,-1.2l0.34,-2.19l0.85,-2.32l0.14,-1.13l0.79,-2.24l0.57,-1.0l1.42,-1.64l0.82,-1.15l0.05,-0.13l0.26,-1.88l-0.13,-1.51l-0.07,-0.16l-0.72,-0.87l-1.23,-2.91l0.09,-0.37l0.73,-0.95l0.05,-0.27l-1.27,-4.12l-1.19,-1.54l0.1,-0.2l0.86,-0.28l0.78,0.03l0.83,-0.29l7.12,0.03ZM451.81,298.94l-0.17,0.07l-0.5,-1.42l0.85,-0.92l0.53,-0.29l0.48,0.44l-0.56,0.32l-0.1,0.1l-0.41,0.65l-0.05,0.14l-0.07,0.91Z", "name": "Angola"}, "KZ": {"path": "M598.42,172.08l-1.37,0.54l-3.3,2.09l-0.11,0.12l-1.01,1.97l-0.56,0.01l-0.6,-1.24l-0.26,-0.17l-2.95,-0.09l-0.46,-2.22l-0.29,-0.24l-0.91,-0.02l0.17,-2.72l-0.12,-0.26l-3.0,-2.22l-0.2,-0.06l-4.29,0.24l-2.8,0.42l-2.36,-2.7l-6.4,-3.65l-0.23,-0.03l-6.45,1.83l-0.22,0.29l0.1,10.94l-0.84,0.1l-1.65,-2.21l-0.11,-0.09l-1.69,-0.84l-0.2,-0.02l-2.84,0.63l-0.14,0.07l-0.71,0.64l-0.02,-0.11l0.57,-1.17l0.0,-0.26l-0.48,-1.05l-0.17,-0.16l-2.78,-0.99l-1.08,-2.62l-0.13,-0.15l-1.24,-0.7l-0.04,-0.48l2.07,0.25l0.34,-0.29l0.09,-2.03l1.84,-0.44l2.12,0.45l0.36,-0.25l0.45,-3.04l-0.45,-2.06l-0.31,-0.23l-2.44,0.15l-2.07,-0.75l-0.23,0.01l-2.88,1.38l-2.21,0.62l-0.96,-0.38l0.22,-1.39l-0.06,-0.23l-1.6,-2.12l-0.25,-0.12l-1.72,0.08l-1.87,-1.91l1.33,-2.24l-0.06,-0.38l-0.55,-0.5l1.72,-3.08l2.3,1.7l0.48,-0.2l0.29,-2.26l4.99,-3.48l3.76,-0.08l5.46,2.27l2.96,1.33l0.26,-0.01l2.59,-1.36l3.82,-0.06l3.13,1.67l0.38,-0.09l0.63,-0.85l3.36,0.14l0.29,-0.19l0.63,-1.57l-0.13,-0.37l-3.64,-2.05l2.0,-1.36l0.1,-0.38l-0.32,-0.62l2.09,-0.76l0.13,-0.47l-1.65,-2.13l0.89,-0.91l9.27,-1.18l0.13,-0.05l1.17,-0.82l6.2,-1.27l2.26,-1.43l4.19,0.7l0.74,3.39l0.38,0.22l2.52,-0.81l2.9,1.06l-0.18,1.63l0.32,0.33l2.52,-0.23l5.0,-2.58l0.03,0.39l3.16,2.62l5.57,8.48l0.49,0.02l1.18,-1.53l3.22,1.78l0.21,0.03l3.5,-0.83l1.21,0.52l1.16,1.82l0.15,0.12l1.67,0.61l1.01,1.32l0.28,0.11l3.04,-0.41l1.1,1.64l-1.68,1.89l-1.97,0.28l-0.26,0.29l-0.12,3.09l-1.2,1.23l-4.81,-1.01l-0.35,0.2l-1.77,5.51l-1.14,0.62l-4.92,1.23l-0.2,0.41l2.14,5.06l-1.45,0.67l-0.17,0.31l0.15,1.28l-1.05,-0.3l-1.21,-1.04l-0.17,-0.07l-3.73,-0.32l-4.15,-0.08l-0.92,0.31l-3.46,-1.24l-0.22,0.01l-1.42,0.63l-0.17,0.21l-0.32,1.49l-3.82,-0.97l-0.15,0.0l-1.65,0.43l-0.2,0.17l-0.51,1.21Z", "name": "Kazakhstan"}, "ET": {"path": "M516.0,247.63l1.21,0.92l0.3,0.04l1.3,-0.53l0.46,0.41l0.19,0.08l1.65,0.03l2.05,0.96l0.67,0.88l1.07,0.79l1.0,1.45l0.7,0.68l-0.72,0.92l-0.85,1.19l-0.04,0.25l0.19,0.67l0.04,0.74l0.29,0.28l1.4,0.04l0.55,-0.15l0.23,0.19l-0.41,0.67l0.01,0.32l0.92,1.39l0.93,1.23l0.99,0.94l0.1,0.06l8.19,2.99l1.51,0.01l-6.51,6.95l-3.14,0.11l-0.18,0.06l-2.15,1.71l-1.51,0.04l-0.22,0.1l-0.6,0.69l-1.46,-0.0l-0.93,-0.78l-0.32,-0.04l-2.29,1.05l-0.12,0.1l-0.64,0.9l-1.44,-0.17l-0.51,-0.26l-0.17,-0.03l-0.56,0.07l-0.68,-0.02l-3.1,-2.08l-0.17,-0.05l-1.62,0.0l-0.68,-0.65l0.0,-1.28l-0.21,-0.29l-1.19,-0.38l-1.42,-2.63l-0.13,-0.12l-1.05,-0.53l-0.46,-1.0l-1.27,-1.23l-0.17,-0.08l-1.08,-0.13l0.53,-0.9l1.17,-0.05l0.26,-0.17l0.37,-0.77l0.03,-0.14l-0.03,-2.23l0.7,-2.49l1.08,-0.65l0.14,-0.19l0.24,-1.0l1.03,-1.85l1.47,-1.22l0.09,-0.12l1.02,-2.51l0.36,-1.96l2.62,0.48l0.33,-0.18l0.63,-1.55Z", "name": "Ethiopia"}, "ZW": {"path": "M498.95,341.2l-1.16,-0.23l-0.16,0.01l-0.74,0.28l-1.11,-0.41l-1.02,-0.04l-1.52,-1.13l-0.12,-0.05l-1.79,-0.37l-0.65,-1.46l-0.01,-0.86l-0.22,-0.29l-0.99,-0.26l-2.74,-2.77l-0.77,-1.46l-0.52,-0.5l-0.72,-1.54l2.24,0.23l0.78,0.28l0.12,0.02l0.85,-0.06l0.21,-0.11l1.38,-1.66l2.11,-2.05l0.81,-0.18l0.22,-0.2l0.27,-0.8l1.29,-0.93l1.53,-0.28l0.11,0.66l0.3,0.25l2.02,-0.05l1.04,0.48l0.5,0.59l0.18,0.1l1.13,0.18l1.11,0.7l0.01,3.06l-0.49,1.82l-0.11,1.94l0.03,0.16l0.35,0.68l-0.24,1.3l-0.27,0.17l-0.12,0.15l-0.64,1.83l-2.49,2.8Z", "name": "Zimbabwe"}, "ES": {"path": "M398.67,172.8l0.09,-1.45l-0.06,-0.2l-0.82,-1.05l3.16,-1.96l3.01,0.54l3.33,-0.02l2.64,0.52l2.14,-0.15l3.9,0.1l0.91,1.08l0.14,0.09l4.61,1.38l0.26,-0.04l0.77,-0.55l2.66,1.29l0.17,0.03l2.59,-0.35l0.1,1.28l-2.2,1.85l-3.13,0.62l-0.23,0.23l-0.21,0.92l-1.54,1.68l-0.97,2.4l0.02,0.26l0.85,1.46l-1.27,1.14l-0.09,0.14l-0.5,1.73l-1.73,0.53l-0.15,0.1l-1.68,2.1l-3.03,0.04l-2.38,-0.05l-0.17,0.05l-1.57,1.01l-0.9,1.01l-0.96,-0.19l-0.82,-0.86l-0.69,-1.6l-0.22,-0.18l-2.14,-0.41l-0.13,-0.62l0.83,-0.97l0.39,-0.86l-0.06,-0.33l-0.73,-0.73l0.63,-1.74l-0.02,-0.25l-0.8,-1.41l0.69,-0.15l0.23,-0.27l0.09,-1.29l0.33,-0.36l0.08,-0.2l0.03,-2.16l1.03,-0.72l0.1,-0.37l-0.7,-1.5l-0.25,-0.17l-1.46,-0.11l-0.22,0.07l-0.34,0.3l-1.17,0.0l-0.55,-1.29l-0.39,-0.16l-1.02,0.44l-0.45,0.36Z", "name": "Spain"}, "ER": {"path": "M527.15,253.05l-0.77,-0.74l-1.01,-1.47l-1.14,-0.86l-0.62,-0.84l-0.11,-0.09l-2.18,-1.02l-0.12,-0.03l-1.61,-0.03l-0.52,-0.46l-0.31,-0.05l-1.31,0.54l-1.38,-1.06l-0.46,0.12l-0.69,1.68l-2.49,-0.46l-0.2,-0.76l1.06,-3.69l0.24,-1.65l0.66,-0.66l1.76,-0.4l0.16,-0.1l0.97,-1.13l1.24,2.55l0.68,2.34l0.09,0.14l1.4,1.27l3.39,2.4l1.37,1.43l2.14,2.34l0.94,0.6l-0.32,0.26l-0.85,-0.17Z", "name": "Eritrea"}, "ME": {"path": "M469.05,172.9l-0.57,-0.8l-0.1,-0.09l-0.82,-0.46l0.16,-0.33l0.35,-1.57l0.72,-0.62l0.27,-0.16l0.48,0.38l0.35,0.4l0.12,0.08l0.79,0.32l0.66,0.43l-0.43,0.62l-0.28,0.11l-0.07,-0.25l-0.53,-0.1l-1.09,1.49l-0.05,0.23l0.06,0.32Z", "name": "Montenegro"}, "MD": {"path": "M488.2,153.75l0.14,-0.11l1.49,-0.28l1.75,0.95l1.06,0.14l0.92,0.7l-0.15,0.9l0.15,0.31l0.8,0.46l0.33,1.2l0.09,0.14l0.72,0.66l-0.11,0.28l0.1,0.33l-0.06,0.02l-1.25,-0.08l-0.17,-0.29l-0.39,-0.12l-0.52,0.25l-0.16,0.36l0.13,0.42l-0.6,0.88l-0.43,1.03l-0.22,0.12l-0.32,-1.0l0.25,-1.34l-0.08,-1.38l-0.06,-0.17l-1.43,-1.87l-0.81,-1.36l-0.78,-0.95l-0.12,-0.09l-0.29,-0.12Z", "name": "Moldova"}, "MG": {"path": "M544.77,316.45l0.64,1.04l0.6,1.62l0.4,3.04l0.63,1.21l-0.22,1.07l-0.15,0.26l-0.59,-1.05l-0.52,-0.01l-0.47,0.76l-0.04,0.23l0.46,1.84l-0.19,0.92l-0.61,0.53l-0.1,0.21l-0.16,2.15l-0.97,2.98l-1.24,3.59l-1.55,4.97l-0.96,3.67l-1.08,2.93l-1.94,0.61l-2.05,1.06l-3.2,-1.53l-0.62,-1.26l-0.18,-2.39l-0.87,-2.07l-0.22,-1.8l0.4,-1.69l1.01,-0.4l0.19,-0.28l0.01,-0.79l1.15,-1.91l0.04,-0.11l0.23,-1.66l-0.03,-0.17l-0.57,-1.21l-0.46,-1.58l-0.19,-2.25l0.82,-1.36l0.33,-1.51l1.11,-0.1l1.4,-0.53l0.9,-0.45l1.03,-0.03l0.21,-0.09l1.41,-1.45l2.12,-1.65l0.75,-1.29l0.03,-0.24l-0.17,-0.56l0.53,0.15l0.32,-0.1l1.38,-1.77l0.06,-0.18l0.04,-1.44l0.54,-0.74l0.62,0.77Z", "name": "Madagascar"}, "MA": {"path": "M378.66,230.13l0.07,-0.75l0.93,-0.72l0.82,-1.37l0.04,-0.21l-0.14,-0.8l0.8,-1.74l1.33,-1.61l0.79,-0.4l0.14,-0.15l0.66,-1.55l0.08,-1.46l0.83,-1.52l1.6,-0.94l0.11,-0.11l1.56,-2.71l1.2,-0.99l2.24,-0.29l0.17,-0.08l1.95,-1.83l1.3,-0.77l2.09,-2.28l0.07,-0.26l-0.61,-3.34l0.92,-2.3l0.33,-1.44l1.52,-1.79l2.48,-1.27l1.86,-1.16l0.1,-0.11l1.67,-2.93l0.72,-1.59l1.54,0.01l1.43,1.14l0.21,0.06l2.33,-0.19l2.55,0.62l0.97,0.03l0.83,1.6l0.15,1.71l0.86,2.96l0.09,0.14l0.5,0.45l-0.31,0.73l-3.11,0.44l-0.16,0.07l-1.07,0.97l-1.36,0.23l-0.25,0.28l-0.1,1.85l-2.74,1.02l-0.14,0.11l-0.9,1.3l-1.93,0.69l-2.56,0.44l-4.04,2.01l-0.17,0.27l0.02,2.91l-0.08,0.0l-0.3,0.31l0.05,1.15l-1.25,0.07l-0.16,0.06l-0.73,0.55l-0.98,0.0l-0.85,-0.33l-0.15,-0.02l-2.11,0.29l-0.24,0.19l-0.76,1.95l-0.63,0.16l-0.21,0.19l-1.15,3.29l-3.42,2.81l-0.1,0.17l-0.81,3.57l-0.98,1.12l-0.3,0.85l-5.13,0.19Z", "name": "Morocco"}, "UZ": {"path": "M587.83,186.48l0.06,-1.46l-0.19,-0.29l-3.31,-1.24l-2.57,-1.4l-1.63,-1.38l-2.79,-1.98l-1.2,-2.98l-0.12,-0.14l-0.84,-0.54l-0.18,-0.05l-2.61,0.13l-0.76,-0.48l-0.25,-2.25l-0.17,-0.24l-3.37,-1.6l-0.32,0.04l-2.08,1.73l-2.11,1.02l-0.16,0.35l0.31,1.14l-2.14,0.03l-0.09,-10.68l6.1,-1.74l6.25,3.57l2.36,2.72l0.27,0.1l2.92,-0.44l4.17,-0.23l2.78,2.06l-0.18,2.87l0.29,0.32l0.98,0.02l0.46,2.22l0.28,0.24l3.0,0.09l0.61,1.25l0.28,0.17l0.93,-0.02l0.26,-0.16l1.06,-2.06l3.21,-2.03l1.3,-0.5l0.19,0.08l-1.75,1.62l0.05,0.48l1.85,1.12l0.27,0.02l1.65,-0.69l2.4,1.27l-2.69,1.79l-1.79,-0.27l-0.89,0.06l-0.22,-0.52l0.48,-1.26l-0.34,-0.4l-3.35,0.69l-0.22,0.18l-0.78,1.87l-1.07,1.47l-1.93,-0.13l-0.29,0.16l-0.65,1.29l0.16,0.42l1.69,0.64l0.48,1.91l-1.25,2.6l-1.64,-0.53l-1.18,-0.03Z", "name": "Uzbekistan"}, "MM": {"path": "M670.1,233.39l-1.46,1.11l-1.68,0.11l-0.26,0.19l-1.1,2.7l-0.95,0.42l-0.14,0.42l1.21,2.27l1.61,1.92l0.94,1.55l-0.82,1.99l-0.77,0.42l-0.13,0.39l0.64,1.35l1.62,1.97l0.26,1.32l-0.04,1.15l0.02,0.13l0.92,2.18l-1.3,2.23l-0.79,1.69l-0.1,-0.77l0.74,-1.87l-0.02,-0.26l-0.8,-1.42l0.2,-2.68l-0.06,-0.2l-0.98,-1.27l-0.8,-2.98l-0.45,-3.22l-1.11,-2.22l-0.45,-0.1l-1.64,1.28l-2.74,1.76l-1.26,-0.2l-1.27,-0.49l0.79,-2.93l0.0,-0.14l-0.52,-2.42l-1.93,-2.97l0.26,-0.8l-0.22,-0.39l-1.37,-0.31l-1.65,-1.98l-0.12,-1.5l0.41,0.19l0.42,-0.26l0.05,-1.7l1.08,-0.54l0.16,-0.34l-0.24,-1.0l0.5,-0.79l0.05,-0.15l0.08,-2.35l1.58,0.49l0.36,-0.15l1.12,-2.19l0.15,-1.34l1.35,-2.18l0.04,-0.17l-0.07,-1.35l2.97,-1.71l1.67,0.45l0.38,-0.33l-0.18,-1.46l0.7,-0.4l0.15,-0.32l-0.13,-0.72l0.94,-0.13l0.74,1.41l0.11,0.12l0.95,0.56l0.07,1.89l-0.09,2.08l-2.28,2.15l-0.09,0.19l-0.3,3.15l0.35,0.32l2.37,-0.39l0.53,2.17l0.2,0.21l1.3,0.42l-0.63,1.9l0.14,0.36l1.86,0.99l1.1,0.49l0.24,0.0l1.45,-0.6l0.04,0.51l-2.01,1.6l-0.56,0.96l-1.34,0.56Z", "name": "Myanmar"}, "ML": {"path": "M390.79,248.2l0.67,-0.37l0.14,-0.18l0.36,-1.31l0.51,-0.04l1.68,0.69l0.21,0.0l1.34,-0.48l0.89,0.16l0.3,-0.13l0.29,-0.44l9.89,-0.04l0.29,-0.21l0.56,-1.8l-0.11,-0.33l-0.33,-0.24l-2.37,-22.1l3.41,-0.04l8.37,5.73l8.38,5.68l0.56,1.15l0.14,0.14l1.56,0.75l0.99,0.36l0.03,1.45l0.33,0.29l2.45,-0.22l0.01,5.52l-1.3,1.64l-0.06,0.15l-0.18,1.37l-1.99,0.36l-3.4,0.22l-0.19,0.09l-0.85,0.83l-1.48,0.09l-1.49,0.01l-0.54,-0.43l-0.26,-0.05l-1.38,0.36l-2.39,1.08l-0.13,0.12l-0.44,0.73l-1.88,1.11l-0.11,0.12l-0.3,0.57l-0.86,0.42l-1.1,-0.31l-0.28,0.07l-0.69,0.62l-0.09,0.16l-0.35,1.66l-1.93,2.04l-0.08,0.23l0.05,0.76l-0.63,0.99l-0.04,0.19l0.14,1.23l-0.81,0.29l-0.32,0.17l-0.27,-0.75l-0.39,-0.18l-0.65,0.26l-0.36,-0.04l-0.29,0.14l-0.37,0.6l-1.69,-0.02l-0.63,-0.34l-0.32,0.02l-0.12,0.09l-0.47,-0.45l0.1,-0.6l-0.09,-0.27l-0.31,-0.3l-0.33,-0.05l-0.05,0.02l0.02,-0.21l0.46,-0.59l-0.02,-0.39l-0.99,-1.02l-0.34,-0.74l-0.56,-0.56l-0.17,-0.09l-0.5,-0.07l-0.19,0.04l-0.58,0.35l-0.79,0.33l-0.65,0.51l-0.85,-0.16l-0.63,-0.59l-0.14,-0.07l-0.41,-0.08l-0.2,0.03l-0.59,0.31l-0.07,0.0l-0.1,-0.63l0.11,-0.85l-0.21,-0.98l-0.11,-0.17l-0.86,-0.66l-0.45,-1.34l-0.1,-1.36Z", "name": "Mali"}, "MN": {"path": "M641.06,150.59l2.41,-0.53l4.76,-2.8l3.67,-1.49l2.06,0.96l0.12,0.03l2.5,0.05l1.59,1.45l0.19,0.08l2.47,0.12l3.59,0.81l0.27,-0.07l2.43,-2.28l0.06,-0.36l-0.93,-1.77l2.33,-3.1l2.66,1.3l2.26,0.39l2.75,0.8l0.44,2.3l0.19,0.22l3.56,1.38l0.18,0.01l2.35,-0.6l3.1,-0.42l2.4,0.41l2.37,1.52l1.49,1.63l0.23,0.1l2.29,-0.03l3.13,0.52l0.15,-0.01l2.28,-0.79l3.27,-0.53l0.11,-0.04l3.56,-2.23l1.31,0.31l1.26,1.05l0.22,0.07l2.45,-0.22l-0.98,1.96l-1.77,3.21l-0.01,0.28l0.64,1.31l0.35,0.16l1.35,-0.38l2.4,0.48l0.22,-0.04l1.78,-1.09l1.82,0.92l2.11,2.07l-0.17,0.68l-1.79,-0.31l-3.74,0.45l-1.85,0.96l-1.78,2.01l-3.74,1.18l-2.46,1.61l-2.45,-0.6l-1.42,-0.28l-0.31,0.13l-1.31,1.99l0.0,0.33l0.78,1.15l0.3,0.74l-1.58,0.93l-1.75,1.59l-2.83,1.03l-3.77,0.12l-4.05,1.05l-2.81,1.54l-0.95,-0.8l-0.19,-0.07l-2.96,0.0l-3.64,-1.8l-2.55,-0.48l-3.38,0.41l-5.13,-0.67l-2.66,0.06l-1.35,-1.65l-1.12,-2.78l-0.21,-0.18l-1.5,-0.33l-2.98,-1.89l-0.12,-0.04l-3.37,-0.43l-2.84,-0.51l-0.75,-1.13l0.93,-3.54l-0.04,-0.24l-1.73,-2.55l-0.15,-0.12l-3.52,-1.18l-1.99,-1.61l-0.54,-1.85Z", "name": "Mongolia"}, "MK": {"path": "M472.73,173.87l0.08,0.01l0.32,-0.25l0.08,-0.44l1.29,-0.41l1.37,-0.28l1.03,-0.04l1.06,0.82l0.14,1.59l-0.22,0.04l-0.17,0.11l-0.32,0.4l-1.2,-0.05l-0.18,0.05l-0.9,0.61l-1.45,0.23l-0.85,-0.59l-0.3,-1.09l0.22,-0.71Z", "name": "Macedonia"}, "MW": {"path": "M507.18,313.84l-0.67,1.85l-0.01,0.16l0.7,3.31l0.31,0.24l0.75,-0.03l0.78,0.71l0.99,1.75l0.2,3.03l-0.91,0.45l-0.14,0.15l-0.59,1.38l-1.24,-1.21l-0.17,-1.62l0.49,-1.12l0.02,-0.16l-0.15,-1.03l-0.13,-0.21l-0.99,-0.65l-0.26,-0.03l-0.53,0.18l-1.31,-1.12l-1.15,-0.59l0.66,-2.06l0.75,-0.84l0.07,-0.27l-0.47,-2.04l0.48,-1.94l0.4,-0.65l0.03,-0.24l-0.64,-2.15l-0.08,-0.13l-0.44,-0.42l1.34,0.26l1.25,1.73l0.67,3.3Z", "name": "Malawi"}, "MR": {"path": "M390.54,247.66l-1.48,-1.58l-1.51,-1.88l-0.12,-0.09l-1.64,-0.67l-1.17,-0.74l-0.17,-0.05l-1.4,0.03l-0.12,0.03l-1.14,0.52l-1.15,-0.21l-0.26,0.08l-0.44,0.43l-0.11,-0.72l0.68,-1.29l0.31,-2.43l-0.28,-2.63l-0.29,-1.27l0.24,-1.24l-0.03,-0.2l-0.65,-1.24l-1.19,-1.05l0.32,-0.51l9.64,0.02l0.3,-0.34l-0.46,-3.71l0.51,-1.12l2.17,-0.22l0.27,-0.3l-0.08,-6.5l7.91,0.13l0.31,-0.3l0.01,-3.5l8.17,5.63l-2.89,0.04l-0.29,0.33l2.42,22.56l0.12,0.21l0.26,0.19l-0.43,1.38l-9.83,0.04l-0.25,0.13l-0.27,0.41l-0.77,-0.14l-0.15,0.01l-1.3,0.47l-1.64,-0.67l-0.14,-0.02l-0.79,0.06l-0.27,0.22l-0.39,1.39l-0.53,0.29Z", "name": "Mauritania"}, "UG": {"path": "M500.74,287.17l-2.84,-0.02l-0.92,0.32l-1.37,0.71l-0.29,-0.12l0.02,-1.6l0.54,-0.89l0.04,-0.13l0.14,-1.96l0.49,-1.09l0.91,-1.24l0.97,-0.68l0.8,-0.89l-0.13,-0.49l-0.79,-0.27l0.13,-2.55l0.78,-0.52l1.45,0.51l0.18,0.01l1.97,-0.57l1.72,0.01l0.18,-0.06l1.29,-0.97l0.98,1.44l0.29,1.24l1.05,2.75l-0.84,1.68l-1.94,2.66l-0.06,0.18l0.02,2.36l-4.8,0.18Z", "name": "Uganda"}, "MY": {"path": "M717.6,273.52l-1.51,0.7l-2.13,-0.41l-2.88,-0.0l-0.29,0.21l-0.84,2.77l-0.9,0.82l-0.08,0.12l-1.23,3.34l-1.81,0.47l-2.29,-0.68l-0.14,-0.01l-1.2,0.22l-0.14,0.07l-1.36,1.18l-1.47,-0.17l-0.12,0.01l-1.46,0.46l-1.51,-1.25l-0.24,-0.97l1.26,0.59l0.2,0.02l1.93,-0.47l0.22,-0.22l0.47,-1.98l0.9,-0.4l2.97,-0.54l0.17,-0.09l1.8,-1.98l1.02,-1.32l0.9,1.03l0.48,-0.04l0.43,-0.7l1.02,0.07l0.32,-0.27l0.25,-2.72l1.84,-1.67l1.23,-1.89l0.73,-0.01l1.12,1.11l0.1,0.99l0.18,0.24l1.66,0.71l1.85,0.67l-0.09,0.51l-1.45,0.11l-0.26,0.4l0.35,0.97ZM673.78,269.53l0.17,1.14l0.35,0.25l1.65,-0.3l0.18,-0.11l0.68,-0.86l0.31,0.13l1.41,1.45l0.99,1.59l0.13,1.57l-0.26,1.09l0.0,0.15l0.24,0.84l0.18,1.46l0.11,0.2l0.82,0.64l0.92,2.08l-0.03,0.52l-1.4,0.13l-2.29,-1.79l-2.86,-1.92l-0.27,-1.16l-0.07,-0.13l-1.39,-1.61l-0.33,-1.99l-0.05,-0.12l-0.84,-1.27l0.26,-1.72l-0.03,-0.18l-0.45,-0.87l0.13,-0.13l1.71,0.92Z", "name": "Malaysia"}, "MX": {"path": "M133.41,213.83l0.61,0.09l0.27,-0.09l0.93,-1.01l0.08,-0.18l0.09,-1.22l-0.09,-0.23l-1.93,-1.94l-1.46,-0.77l-2.96,-5.62l-0.86,-2.1l2.44,-0.18l2.68,-0.25l-0.03,0.08l0.17,0.4l3.79,1.35l5.81,1.97l6.96,-0.02l0.3,-0.3l0.0,-0.84l3.91,0.0l0.87,0.93l1.27,0.87l1.44,1.17l0.79,1.37l0.62,1.49l0.12,0.14l1.35,0.85l2.08,0.82l0.35,-0.1l1.49,-2.04l1.81,-0.05l1.63,1.01l1.21,1.8l0.86,1.58l1.47,1.55l0.53,1.82l0.73,1.32l0.14,0.13l1.98,0.84l1.78,0.59l0.61,-0.03l-0.78,1.89l-0.45,1.96l-0.19,3.58l-0.24,1.27l0.01,0.14l0.43,1.43l0.78,1.31l0.49,1.98l0.06,0.12l1.63,1.9l0.61,1.51l0.98,1.28l0.16,0.11l2.58,0.67l0.98,1.02l0.31,0.08l2.17,-0.71l1.91,-0.26l1.87,-0.47l1.67,-0.49l1.59,-1.06l0.11,-0.14l0.6,-1.52l0.22,-2.21l0.35,-0.62l1.58,-0.64l2.59,-0.59l2.18,0.09l1.43,-0.2l0.39,0.36l-0.07,1.02l-1.28,1.48l-0.65,1.68l0.07,0.32l0.33,0.32l-0.79,2.49l-0.28,-0.3l-0.24,-0.09l-1.0,0.08l-0.24,0.15l-0.74,1.28l-0.19,-0.13l-0.28,-0.03l-0.3,0.12l-0.19,0.29l0.0,0.06l-4.34,-0.02l-0.3,0.3l-0.0,1.16l-0.83,0.0l-0.28,0.19l0.08,0.33l0.93,0.86l0.9,0.58l0.24,0.48l0.16,0.15l0.2,0.08l-0.03,0.38l-2.94,0.01l-0.26,0.15l-1.21,2.09l0.02,0.33l0.25,0.33l-0.21,0.44l-0.04,0.22l-2.42,-2.35l-1.36,-0.87l-2.04,-0.67l-0.13,-0.01l-1.4,0.19l-2.07,0.98l-1.14,0.23l-1.72,-0.66l-1.85,-0.48l-2.31,-1.16l-1.92,-0.38l-2.79,-1.18l-2.04,-1.2l-0.6,-0.66l-0.19,-0.1l-1.37,-0.15l-2.45,-0.78l-1.07,-1.18l-2.63,-1.44l-1.2,-1.56l-0.44,-0.93l0.5,-0.15l0.2,-0.39l-0.2,-0.58l0.46,-0.55l0.07,-0.19l0.01,-0.91l-0.06,-0.18l-0.81,-1.13l-0.25,-1.08l-0.86,-1.36l-2.21,-2.63l-2.53,-2.09l-1.2,-1.63l-0.11,-0.09l-2.08,-1.06l-0.34,-0.48l0.35,-1.53l-0.16,-0.34l-1.24,-0.61l-1.39,-1.23l-0.6,-1.81l-0.24,-0.2l-1.25,-0.2l-1.38,-1.35l-1.11,-1.25l-0.1,-0.76l-0.05,-0.13l-1.33,-2.04l-0.85,-2.02l0.04,-0.99l-0.14,-0.27l-1.81,-1.1l-0.2,-0.04l-0.74,0.11l-1.34,-0.72l-0.42,0.16l-0.4,1.12l-0.0,0.19l0.41,1.3l0.24,2.04l0.06,0.15l0.88,1.16l1.84,1.86l0.4,0.61l0.12,0.1l0.27,0.14l0.29,0.82l0.31,0.2l0.2,-0.02l0.43,1.51l0.09,0.14l0.72,0.65l0.51,0.91l1.58,1.4l0.8,2.42l0.77,1.23l0.66,1.19l0.13,1.34l0.28,0.27l1.08,0.08l0.92,1.1l0.83,1.08l-0.03,0.24l-0.88,0.81l-0.13,-0.0l-0.59,-1.42l-0.07,-0.11l-1.67,-1.53l-1.81,-1.28l-1.15,-0.61l0.07,-1.85l-0.38,-1.45l-0.12,-0.17l-2.91,-2.03l-0.39,0.04l-0.11,0.11l-0.42,-0.46l-0.11,-0.08l-1.49,-0.63l-1.09,-1.16Z", "name": "Mexico"}, "VU": {"path": "M839.92,325.66l0.78,0.73l-0.18,0.07l-0.6,-0.8ZM839.13,322.74l0.27,1.36l-0.13,-0.06l-0.21,-0.02l-0.29,0.08l-0.22,-0.43l-0.03,-1.32l0.61,0.4Z", "name": "Vanuatu"}, "FR": {"path": "M444.58,172.63l-0.68,1.92l-0.72,-0.38l-0.51,-1.79l0.43,-0.95l1.15,-0.83l0.33,2.04ZM429.71,147.03l1.77,1.57l0.26,0.07l1.16,-0.23l2.12,1.44l0.56,0.28l0.16,0.03l0.61,-0.06l1.09,0.78l0.13,0.05l3.18,0.53l-1.09,1.94l-0.3,2.16l-0.48,0.38l-1.0,-0.26l-0.37,0.32l0.07,0.66l-1.73,1.68l-0.09,0.21l-0.04,1.42l0.41,0.29l0.96,-0.4l0.67,1.07l-0.09,0.78l0.04,0.19l0.61,0.97l-0.71,0.78l-0.07,0.28l0.65,2.39l0.21,0.21l1.09,0.31l-0.2,0.95l-2.08,1.58l-4.81,-0.8l-0.13,0.01l-3.65,0.99l-0.22,0.24l-0.25,1.6l-2.59,0.35l-2.74,-1.33l-0.31,0.03l-0.79,0.57l-4.38,-1.31l-0.79,-0.94l1.16,-1.64l0.05,-0.15l0.48,-6.17l-0.06,-0.21l-2.58,-3.3l-1.89,-1.65l-0.11,-0.06l-3.64,-1.17l-0.2,-1.88l2.92,-0.63l4.14,0.82l0.35,-0.36l-0.65,-3.0l1.77,1.05l0.27,0.02l5.83,-2.54l0.17,-0.19l0.71,-2.54l1.75,-0.53l0.27,0.88l0.27,0.21l1.04,0.05l1.08,1.23ZM289.1,278.45l-0.85,0.84l-0.88,0.13l-0.25,-0.51l-0.21,-0.16l-0.56,-0.1l-0.25,0.07l-0.63,0.55l-0.62,-0.29l0.5,-0.88l0.21,-1.11l0.42,-1.05l-0.03,-0.28l-0.93,-1.42l-0.18,-1.54l1.13,-1.87l2.42,0.78l2.55,2.04l0.33,0.81l-1.4,2.16l-0.77,1.84Z", "name": "France"}, "FI": {"path": "M492.26,76.42l-0.38,3.12l0.12,0.28l3.6,2.69l-2.14,2.96l-0.01,0.33l2.83,4.61l-1.61,3.36l0.03,0.31l2.15,2.87l-0.96,2.44l0.1,0.35l3.51,2.55l-0.81,1.72l-2.28,2.19l-5.28,4.79l-4.51,0.31l-4.39,1.37l-3.87,0.75l-1.34,-1.89l-0.11,-0.09l-2.23,-1.14l0.53,-3.54l-0.01,-0.14l-1.17,-3.37l1.12,-2.13l2.23,-2.44l5.69,-4.33l1.65,-0.84l0.16,-0.31l-0.26,-1.73l-0.15,-0.22l-3.4,-1.91l-0.77,-1.47l-0.07,-6.45l-0.12,-0.24l-3.91,-2.94l-3.0,-1.92l0.97,-0.76l2.6,2.17l0.21,0.07l3.2,-0.21l2.63,1.03l0.3,-0.05l2.39,-1.94l0.09,-0.13l1.18,-3.12l3.63,-1.42l2.87,1.59l-0.98,2.87Z", "name": "Finland"}, "FJ": {"path": "M869.98,327.07l-1.31,0.44l-0.14,-0.41l0.96,-0.41l0.85,-0.17l1.43,-0.78l-0.16,0.65l-1.64,0.67ZM867.58,329.12l0.54,0.47l-0.31,1.0l-1.32,0.3l-1.13,-0.26l-0.17,-0.78l0.72,-0.66l0.98,0.27l0.25,-0.04l0.43,-0.29Z", "name": "Fiji"}, "FK": {"path": "M268.15,427.89l2.6,-1.73l1.98,0.77l0.31,-0.05l1.32,-1.17l1.58,1.18l-0.54,0.84l-3.1,0.92l-1.0,-1.04l-0.39,-0.04l-1.9,1.35l-0.86,-1.04Z", "name": "Falkland Islands"}, "NI": {"path": "M202.1,252.6l0.23,-0.0l0.12,-0.11l0.68,-0.09l0.22,-0.15l0.23,-0.43l0.2,-0.01l0.28,-0.31l-0.04,-0.97l0.29,-0.03l0.5,0.02l0.25,-0.11l0.37,-0.46l0.51,0.35l0.4,-0.06l0.23,-0.28l0.45,-0.29l0.87,-0.7l0.11,-0.21l0.02,-0.26l0.23,-0.12l0.25,-0.48l0.29,0.27l0.14,0.07l0.5,0.12l0.22,-0.03l0.48,-0.28l0.66,-0.02l0.87,-0.33l0.36,-0.32l0.21,0.01l-0.11,0.48l0.0,0.14l0.22,0.8l-0.54,0.85l-0.27,1.03l-0.09,1.18l0.14,0.72l0.05,0.95l-0.24,0.15l-0.13,0.19l-0.23,1.09l0.0,0.14l0.14,0.53l-0.42,0.53l-0.06,0.24l0.12,0.69l0.08,0.15l0.18,0.19l-0.26,0.23l-0.49,-0.11l-0.35,-0.44l-0.16,-0.1l-0.79,-0.21l-0.23,0.03l-0.45,0.26l-1.51,-0.62l-0.31,0.05l-0.17,0.15l-1.81,-1.62l-0.6,-0.9l-1.04,-0.79l-0.77,-0.71Z", "name": "Nicaragua"}, "NL": {"path": "M436.22,136.65l1.82,0.08l0.36,0.89l-0.6,2.96l-0.53,1.06l-1.32,0.0l-0.3,0.34l0.35,2.89l-0.83,-0.47l-1.56,-1.43l-0.29,-0.07l-2.26,0.67l-1.02,-0.15l0.68,-0.48l0.1,-0.12l2.14,-4.84l3.25,-1.35Z", "name": "Netherlands"}, "NO": {"path": "M491.45,67.31l7.06,3.0l-2.52,0.94l-0.11,0.49l2.43,2.49l-3.82,1.59l-1.48,0.3l0.89,-2.61l-0.14,-0.36l-3.21,-1.78l-0.25,-0.02l-3.89,1.52l-0.17,0.17l-1.2,3.17l-2.19,1.78l-2.53,-0.99l-0.13,-0.02l-3.15,0.21l-2.69,-2.25l-0.38,-0.01l-1.43,1.11l-1.47,0.17l-0.26,0.26l-0.33,2.57l-4.42,-0.65l-0.33,0.22l-0.6,2.19l-2.17,-0.01l-0.27,0.16l-4.15,7.68l-3.88,5.76l-0.0,0.33l0.81,1.23l-0.7,1.27l-2.3,-0.06l-0.28,0.18l-1.63,3.72l-0.02,0.13l0.15,5.17l0.07,0.18l1.51,1.84l-0.79,4.24l-2.04,2.5l-0.92,1.75l-1.39,-1.88l-0.44,-0.05l-4.89,4.21l-3.16,0.81l-3.24,-1.74l-0.86,-3.82l-0.78,-8.6l2.18,-2.36l6.56,-3.28l5.0,-4.16l4.63,-5.74l5.99,-8.09l4.17,-3.23l6.84,-5.49l5.39,-1.92l4.06,0.24l0.23,-0.09l3.72,-3.67l4.51,0.19l4.4,-0.89ZM484.58,19.95l4.42,1.82l-3.25,2.68l-7.14,0.65l-7.16,-0.91l-0.39,-1.37l-0.28,-0.22l-3.48,-0.1l-2.25,-2.15l7.09,-1.48l3.55,1.36l0.28,-0.03l2.42,-1.66l6.18,1.41ZM481.99,33.92l-4.73,1.85l-3.76,-1.06l1.27,-1.02l0.04,-0.43l-1.18,-1.35l4.46,-0.94l0.89,1.83l0.17,0.15l2.83,0.96ZM466.5,23.95l7.64,3.87l-5.63,1.94l-0.19,0.19l-1.35,3.88l-2.08,0.96l-0.16,0.19l-1.14,4.18l-2.71,0.18l-4.94,-2.95l1.95,-1.63l-0.08,-0.51l-3.7,-1.54l-4.79,-4.54l-1.78,-4.01l6.29,-1.88l1.25,1.81l0.25,0.13l3.57,-0.08l0.26,-0.17l0.87,-1.79l3.41,-0.18l3.08,1.94Z", "name": "Norway"}, "NA": {"path": "M461.88,357.98l-1.61,-1.77l-0.94,-1.9l-0.54,-2.58l-0.62,-1.95l-0.83,-4.05l-0.06,-3.13l-0.33,-1.5l-0.07,-0.14l-0.95,-1.06l-1.27,-2.12l-1.3,-3.1l-0.59,-1.71l-1.98,-2.46l-0.13,-1.67l0.99,-0.4l1.44,-0.42l1.48,0.07l1.42,1.11l0.31,0.03l0.32,-0.15l9.99,-0.11l1.66,1.18l0.16,0.06l6.06,0.37l4.69,-1.06l2.01,-0.57l1.5,0.14l0.63,0.37l-1.0,0.41l-0.7,0.01l-0.16,0.05l-1.38,0.88l-0.79,-0.88l-0.29,-0.09l-3.83,0.9l-1.84,0.08l-0.29,0.3l-0.07,8.99l-2.18,0.08l-0.29,0.3l-0.0,17.47l-2.04,1.27l-1.21,0.18l-1.51,-0.49l-0.99,-0.18l-0.36,-1.0l-0.1,-0.14l-0.99,-0.74l-0.4,0.04l-0.98,1.09Z", "name": "Namibia"}, "NC": {"path": "M835.87,338.68l2.06,1.63l1.01,0.94l-0.49,0.32l-1.21,-0.62l-1.76,-1.16l-1.58,-1.36l-1.61,-1.79l-0.16,-0.41l0.54,0.02l1.32,0.83l1.08,0.87l0.79,0.73Z", "name": "New Caledonia"}, "NE": {"path": "M426.67,254.17l0.03,-1.04l-0.24,-0.3l-2.66,-0.53l-0.06,-1.0l-0.07,-0.17l-1.37,-1.62l-0.3,-1.04l0.15,-0.94l1.37,-0.09l0.19,-0.09l0.85,-0.83l3.34,-0.22l2.22,-0.41l0.24,-0.26l0.2,-1.5l1.32,-1.65l0.07,-0.19l-0.01,-5.74l3.4,-1.13l7.24,-5.12l8.46,-4.95l3.76,1.08l1.35,1.39l0.36,0.05l1.39,-0.77l0.55,3.66l0.12,0.2l0.82,0.6l0.03,0.69l0.1,0.21l0.87,0.74l-0.47,0.99l-0.96,5.26l-0.13,3.25l-3.08,2.34l-0.1,0.15l-1.08,3.37l0.08,0.31l0.94,0.86l-0.01,1.51l0.29,0.3l1.25,0.05l-0.14,0.66l-0.51,0.11l-0.24,0.26l-0.06,0.57l-0.04,0.0l-1.59,-2.62l-0.21,-0.14l-0.59,-0.1l-0.23,0.05l-1.83,1.33l-1.79,-0.68l-1.42,-0.17l-0.17,0.03l-0.65,0.32l-1.39,-0.07l-0.19,0.06l-1.4,1.03l-1.12,0.05l-2.97,-1.29l-0.26,0.01l-1.12,0.59l-1.08,-0.04l-0.85,-0.88l-0.11,-0.07l-2.51,-0.95l-0.14,-0.02l-2.69,0.3l-0.16,0.07l-0.65,0.55l-0.1,0.16l-0.34,1.41l-0.69,0.98l-0.05,0.15l-0.13,1.72l-1.47,-1.13l-0.18,-0.06l-0.9,0.01l-0.2,0.08l-0.32,0.28Z", "name": "Niger"}, "NG": {"path": "M442.0,272.7l-2.4,0.83l-0.88,-0.12l-0.19,0.04l-0.89,0.52l-1.78,-0.05l-1.23,-1.44l-0.88,-1.87l-1.77,-1.66l-0.21,-0.08l-3.78,0.03l0.13,-3.75l-0.06,-1.58l0.44,-1.47l0.74,-0.75l1.21,-1.56l0.04,-0.29l-0.22,-0.56l0.44,-0.9l0.01,-0.24l-0.54,-1.44l0.26,-2.97l0.72,-1.06l0.33,-1.37l0.51,-0.43l2.53,-0.28l2.38,0.9l0.89,0.91l0.2,0.09l1.28,0.04l0.15,-0.03l1.06,-0.56l2.9,1.26l0.13,0.02l1.28,-0.06l0.16,-0.06l1.39,-1.02l1.36,0.07l0.15,-0.03l0.64,-0.32l1.22,0.13l1.9,0.73l0.28,-0.04l1.86,-1.35l0.33,0.06l1.62,2.67l0.29,0.14l0.32,-0.04l0.73,0.74l-0.19,0.37l-0.12,0.74l-2.03,1.89l-0.07,0.11l-0.66,1.62l-0.35,1.28l-0.48,0.51l-0.07,0.12l-0.48,1.67l-1.26,0.98l-0.1,0.15l-0.38,1.24l-0.58,1.07l-0.2,0.91l-1.43,0.7l-1.26,-0.93l-0.19,-0.06l-0.95,0.04l-0.2,0.09l-1.41,1.39l-0.61,0.02l-0.26,0.17l-1.19,2.42l-0.61,1.67Z", "name": "Nigeria"}, "NZ": {"path": "M857.9,379.62l1.85,3.1l0.33,0.14l0.22,-0.28l0.04,-1.41l0.57,0.4l0.35,2.06l0.17,0.22l2.02,0.94l1.78,0.26l0.22,-0.06l1.31,-1.01l0.84,0.22l-0.53,2.27l-0.67,1.5l-1.71,-0.05l-0.25,0.12l-0.67,0.89l-0.05,0.23l0.21,1.15l-0.31,0.46l-2.15,3.57l-1.6,0.99l-0.28,-0.51l-0.15,-0.13l-0.72,-0.3l1.27,-2.15l0.01,-0.29l-0.82,-1.63l-0.15,-0.14l-2.5,-1.09l0.05,-0.69l1.67,-0.94l0.15,-0.21l0.42,-2.24l-0.11,-1.95l-0.03,-0.12l-0.97,-1.85l0.05,-0.41l-0.09,-0.25l-1.18,-1.17l-1.94,-2.49l-0.86,-1.64l0.38,-0.09l1.24,1.43l0.12,0.08l1.81,0.68l0.67,2.39ZM853.93,393.55l0.57,1.24l0.44,0.12l1.51,-1.03l0.52,0.91l0.0,1.09l-0.88,1.31l-1.62,2.2l-1.26,1.2l-0.05,0.38l0.64,1.02l-1.4,0.03l-0.14,0.04l-2.14,1.16l-0.14,0.17l-0.67,2.0l-1.38,3.06l-3.07,2.19l-2.12,-0.06l-1.55,-0.99l-0.14,-0.05l-2.53,-0.2l-0.31,-0.84l1.25,-2.15l3.07,-2.97l1.62,-0.59l1.81,-1.17l2.18,-1.63l1.55,-1.65l1.08,-2.18l0.9,-0.72l0.11,-0.17l0.35,-1.56l1.37,-1.07l0.4,0.91Z", "name": "New Zealand"}, "NP": {"path": "M641.26,213.53l-0.14,0.95l0.32,1.64l-0.21,0.78l-1.83,0.04l-2.98,-0.62l-1.86,-0.25l-1.37,-1.3l-0.18,-0.08l-3.38,-0.34l-3.21,-1.49l-2.38,-1.34l-2.16,-0.92l0.84,-2.2l1.51,-1.18l0.89,-0.57l1.83,0.77l2.5,1.76l1.39,0.41l0.78,1.21l0.17,0.13l1.91,0.53l2.0,1.17l2.92,0.66l2.63,0.24Z", "name": "Nepal"}, "CI": {"path": "M413.53,272.08l-0.83,0.02l-1.79,-0.49l-1.64,0.03l-3.04,0.46l-1.73,0.72l-2.4,0.89l-0.12,-0.02l0.16,-1.7l0.19,-0.25l0.06,-0.2l-0.08,-0.99l-0.09,-0.19l-1.06,-1.05l-0.15,-0.08l-0.71,-0.15l-0.51,-0.48l0.45,-0.92l0.02,-0.19l-0.24,-1.16l0.07,-0.43l0.14,-0.0l0.3,-0.26l0.15,-1.1l-0.02,-0.15l-0.13,-0.34l0.09,-0.13l0.83,-0.27l0.19,-0.37l-0.62,-2.02l-0.55,-1.0l0.14,-0.59l0.35,-0.14l0.24,-0.16l0.53,0.29l0.14,0.04l1.93,0.02l0.26,-0.14l0.36,-0.58l0.39,0.01l0.43,-0.17l0.28,0.79l0.43,0.16l0.56,-0.31l0.89,-0.32l0.92,0.45l0.39,0.75l0.14,0.13l1.13,0.53l0.3,-0.03l0.81,-0.59l1.02,-0.08l1.49,0.57l0.62,3.33l-1.03,2.09l-0.65,2.84l0.02,0.2l1.05,2.08l-0.07,0.64Z", "name": "Ivory Coast"}, "CH": {"path": "M444.71,156.27l0.05,0.3l-0.34,0.69l0.13,0.4l1.13,0.58l1.07,0.1l-0.12,0.81l-0.87,0.42l-1.75,-0.37l-0.34,0.18l-0.47,1.1l-0.86,0.07l-0.33,-0.38l-0.41,-0.04l-1.34,1.01l-1.02,0.13l-0.93,-0.58l-0.82,-1.32l-0.37,-0.12l-0.77,0.32l0.02,-0.84l1.74,-1.69l0.09,-0.25l-0.04,-0.38l0.73,0.19l0.26,-0.06l0.6,-0.48l2.02,0.02l0.24,-0.12l0.38,-0.51l2.31,0.84Z", "name": "Switzerland"}, "CO": {"path": "M232.24,284.95l-0.94,-0.52l-1.22,-0.82l-0.31,-0.01l-0.62,0.35l-1.88,-0.31l-0.54,-0.95l-0.29,-0.15l-0.37,0.03l-2.34,-1.33l-0.15,-0.35l0.57,-0.11l0.24,-0.32l-0.1,-1.15l0.46,-0.71l1.11,-0.15l0.21,-0.13l1.05,-1.57l0.95,-1.31l-0.08,-0.43l-0.73,-0.47l0.4,-1.24l0.01,-0.16l-0.53,-2.15l0.44,-0.54l0.06,-0.24l-0.4,-2.13l-0.06,-0.13l-0.93,-1.22l0.21,-0.8l0.52,0.12l0.32,-0.13l0.47,-0.75l0.03,-0.27l-0.52,-1.32l0.09,-0.11l1.14,0.07l0.22,-0.08l1.82,-1.71l0.96,-0.25l0.22,-0.28l0.02,-0.81l0.43,-2.01l1.28,-1.04l1.48,-0.05l0.27,-0.19l0.12,-0.31l1.73,0.19l0.2,-0.05l1.96,-1.28l0.97,-0.56l1.16,-1.16l0.64,0.11l0.43,0.44l-0.31,0.55l-1.49,0.39l-0.19,0.16l-0.6,1.2l-0.97,0.74l-0.73,0.94l-0.06,0.13l-0.3,1.76l-0.68,1.44l0.23,0.43l1.1,0.14l0.27,0.97l0.08,0.13l0.49,0.49l0.17,0.85l-0.27,0.86l-0.01,0.14l0.09,0.53l0.2,0.23l0.52,0.18l0.54,0.79l0.27,0.13l3.18,-0.24l1.31,0.29l1.7,2.08l0.31,0.1l0.96,-0.26l1.75,0.13l1.41,-0.27l0.56,0.27l-0.36,1.07l-0.54,0.81l-0.05,0.13l-0.2,1.8l0.51,1.79l0.07,0.12l0.65,0.68l0.05,0.32l-1.16,1.14l0.05,0.47l0.86,0.52l0.6,0.79l0.31,1.01l-0.7,-0.81l-0.44,-0.01l-0.74,0.77l-4.75,-0.05l-0.3,0.31l0.03,1.57l0.25,0.29l1.2,0.21l-0.02,0.24l-0.1,-0.05l-0.22,-0.02l-1.41,0.41l-0.22,0.29l-0.01,1.82l0.11,0.23l1.04,0.85l0.35,1.3l-0.06,1.02l-1.02,6.26l-0.84,-0.89l-0.19,-0.09l-0.25,-0.02l1.35,-2.13l-0.1,-0.42l-1.92,-1.17l-0.2,-0.04l-1.41,0.2l-0.82,-0.39l-0.26,0.0l-1.29,0.62l-1.63,-0.27l-1.4,-2.5l-0.12,-0.12l-1.1,-0.61l-0.83,-1.2l-1.67,-1.19l-0.27,-0.04l-0.54,0.19Z", "name": "Colombia"}, "CN": {"path": "M740.32,148.94l0.22,0.21l4.3,1.03l2.84,2.2l0.99,2.92l0.28,0.2l3.8,0.0l0.15,-0.04l2.13,-1.24l3.5,-0.8l-1.05,2.29l-0.95,1.13l-0.06,0.12l-0.85,3.41l-1.56,2.81l-2.83,-0.51l-0.19,0.03l-2.15,1.09l-0.15,0.34l0.65,2.59l-0.33,3.3l-1.03,0.07l-0.28,0.3l0.01,0.75l-1.09,-1.2l-0.48,0.05l-0.94,1.6l-3.76,1.26l-0.2,0.36l0.29,1.19l-1.67,-0.08l-1.11,-0.88l-0.42,0.05l-1.69,2.08l-2.71,1.57l-2.04,1.88l-3.42,0.84l-0.11,0.05l-1.8,1.34l-1.54,0.46l0.52,-0.53l0.06,-0.33l-0.44,-0.96l1.84,-1.84l0.02,-0.41l-1.32,-1.56l-0.36,-0.08l-2.23,1.08l-2.83,2.06l-1.52,1.85l-2.32,0.13l-0.2,0.09l-1.28,1.37l-0.03,0.37l1.32,1.97l0.18,0.13l1.83,0.43l0.07,1.08l0.18,0.26l1.98,0.84l0.3,-0.03l2.66,-1.96l2.06,1.04l0.12,0.03l1.4,0.07l0.27,1.0l-3.24,0.73l-0.17,0.11l-1.13,1.5l-2.38,1.4l-0.1,0.1l-1.29,1.99l0.1,0.42l2.6,1.5l0.97,2.72l1.52,2.56l1.66,2.08l-0.03,1.76l-1.4,0.67l-0.15,0.38l0.6,1.47l0.13,0.15l1.29,0.75l-0.35,2.0l-0.58,1.96l-1.22,0.21l-0.2,0.14l-1.83,2.93l-2.02,3.51l-2.29,3.13l-3.4,2.42l-3.42,2.18l-2.75,0.3l-0.15,0.06l-1.32,1.01l-0.68,-0.67l-0.41,-0.01l-1.37,1.27l-3.42,1.28l-2.62,0.4l-0.24,0.21l-0.8,2.57l-0.95,0.11l-0.53,-1.54l0.52,-0.89l-0.19,-0.44l-3.36,-0.84l-0.17,0.01l-1.09,0.4l-2.36,-0.64l-1.0,-0.9l0.35,-1.34l-0.23,-0.37l-2.22,-0.47l-1.15,-0.94l-0.36,-0.02l-2.08,1.37l-2.35,0.29l-1.98,-0.01l-0.13,0.03l-1.32,0.63l-1.28,0.38l-0.21,0.33l0.33,2.65l-0.78,-0.04l-0.14,-0.39l-0.07,-1.04l-0.41,-0.26l-1.72,0.71l-0.96,-0.43l-1.63,-0.86l0.65,-1.95l-0.19,-0.38l-1.43,-0.46l-0.56,-2.27l-0.34,-0.22l-2.26,0.38l0.25,-2.65l2.29,-2.15l0.09,-0.2l0.1,-2.21l-0.07,-2.09l-0.15,-0.25l-1.02,-0.6l-0.8,-1.52l-0.31,-0.16l-1.42,0.2l-2.16,-0.32l0.55,-0.74l0.01,-0.35l-1.17,-1.7l-0.41,-0.08l-1.67,1.07l-1.97,-0.63l-0.25,0.03l-2.89,1.73l-2.26,1.99l-1.82,0.3l-1.0,-0.66l-0.15,-0.05l-1.28,-0.06l-1.75,-0.61l-0.24,0.02l-1.35,0.69l-0.1,0.08l-1.2,1.45l-0.14,-1.41l-0.4,-0.25l-1.46,0.55l-2.83,-0.26l-2.77,-0.61l-1.99,-1.17l-1.91,-0.54l-0.78,-1.21l-0.17,-0.13l-1.36,-0.38l-2.54,-1.79l-2.01,-0.84l-0.28,0.02l-0.89,0.56l-3.31,-1.83l-2.35,-1.67l-0.57,-2.49l1.34,0.28l0.36,-0.28l0.08,-1.42l-0.05,-0.19l-0.93,-1.34l0.24,-2.18l-0.07,-0.22l-2.69,-3.32l-0.15,-0.1l-3.97,-1.11l-0.69,-2.05l-0.11,-0.15l-1.79,-1.3l-0.39,-0.73l-0.36,-1.57l0.08,-1.09l-0.18,-0.3l-1.52,-0.66l-0.22,-0.01l-0.51,0.18l-0.52,-2.21l0.59,-0.55l0.06,-0.35l-0.22,-0.44l2.12,-1.24l1.63,-0.55l2.58,0.39l0.31,-0.16l0.87,-1.75l3.05,-0.34l0.21,-0.12l0.84,-1.12l3.87,-1.59l0.15,-0.14l0.35,-0.68l0.03,-0.17l-0.17,-1.51l1.52,-0.7l0.15,-0.39l-2.12,-5.0l4.62,-1.15l1.35,-0.72l0.14,-0.17l1.72,-5.37l4.7,0.99l0.28,-0.08l1.39,-1.43l0.08,-0.2l0.11,-2.95l1.83,-0.26l0.18,-0.1l1.85,-2.08l0.61,-0.17l0.57,1.97l0.1,0.15l2.2,1.75l3.48,1.17l1.59,2.36l-0.93,3.53l0.04,0.24l0.9,1.35l0.2,0.13l2.98,0.53l3.32,0.43l2.97,1.89l1.49,0.35l1.08,2.67l1.52,1.88l0.24,0.11l2.74,-0.07l5.15,0.67l3.36,-0.41l2.39,0.43l3.67,1.81l0.13,0.03l2.92,-0.0l1.02,0.86l0.34,0.03l2.88,-1.59l3.98,-1.03l3.81,-0.13l3.02,-1.12l1.77,-1.61l1.73,-1.01l0.13,-0.37l-0.41,-1.01l-0.72,-1.07l1.09,-1.66l1.21,0.24l2.57,0.63l0.24,-0.04l2.46,-1.62l3.78,-1.19l0.13,-0.09l1.8,-2.03l1.66,-0.84l3.54,-0.41l1.93,0.35l0.34,-0.22l0.27,-1.12l-0.08,-0.29l-2.27,-2.22l-2.08,-1.07l-0.29,0.01l-1.82,1.12l-2.36,-0.47l-0.14,0.01l-1.18,0.34l-0.46,-0.94l1.69,-3.08l1.1,-2.21l2.75,1.12l0.26,-0.02l3.53,-2.06l0.15,-0.26l-0.02,-1.35l2.18,-3.39l1.35,-1.04l0.12,-0.24l-0.03,-1.85l-0.15,-0.25l-1.0,-0.58l1.68,-1.37l3.01,-0.59l3.25,-0.09l3.67,0.99l2.08,1.18l1.51,3.3l0.95,1.45l0.85,1.99l0.92,3.19ZM697.0,237.37l-1.95,1.12l-1.74,-0.68l-0.06,-1.9l1.08,-1.03l2.62,-0.7l1.23,0.05l0.37,0.65l-1.01,1.08l-0.54,1.4Z", "name": "China"}, "CM": {"path": "M453.76,278.92l-0.26,-0.11l-0.18,-0.02l-1.42,0.31l-1.56,-0.33l-1.17,0.16l-3.7,-0.05l0.3,-1.63l-0.04,-0.21l-0.98,-1.66l-0.15,-0.13l-1.03,-0.38l-0.46,-1.01l-0.13,-0.14l-0.48,-0.27l0.02,-0.46l0.62,-1.72l1.1,-2.25l0.54,-0.02l0.2,-0.09l1.41,-1.39l0.73,-0.03l1.32,0.97l0.31,0.03l1.72,-0.85l0.16,-0.2l0.22,-1.0l0.57,-1.03l0.36,-1.18l1.26,-0.98l0.1,-0.15l0.49,-1.7l0.48,-0.51l0.07,-0.13l0.35,-1.3l0.63,-1.54l2.06,-1.92l0.09,-0.17l0.12,-0.79l0.24,-0.41l-0.04,-0.36l-0.89,-0.91l0.04,-0.45l0.28,-0.06l0.85,1.39l0.16,1.59l-0.09,1.66l0.04,0.17l1.09,1.84l-0.86,-0.02l-0.72,0.17l-1.07,-0.24l-0.34,0.17l-0.54,1.19l0.06,0.34l1.48,1.47l1.06,0.44l0.32,0.94l0.73,1.6l-0.32,0.57l-1.23,2.49l-0.54,0.41l-0.12,0.21l-0.19,1.95l0.24,1.08l-0.18,0.67l0.07,0.28l1.13,1.25l0.24,0.93l0.92,1.29l1.1,0.8l0.1,1.01l0.26,0.73l-0.12,0.93l-1.65,-0.49l-2.02,-0.66l-3.19,-0.11Z", "name": "Cameroon"}, "CL": {"path": "M246.8,429.1l-1.14,0.78l-2.25,1.21l-0.16,0.23l-0.37,2.94l-0.75,0.06l-2.72,-1.07l-2.83,-2.34l-3.06,-1.9l-0.71,-1.92l0.67,-1.84l-0.02,-0.25l-1.22,-2.13l-0.31,-5.41l1.02,-2.95l2.59,-2.4l-0.13,-0.51l-3.32,-0.8l2.06,-2.4l0.07,-0.15l0.79,-4.77l2.44,0.95l0.4,-0.22l1.31,-6.31l-0.16,-0.33l-1.68,-0.8l-0.42,0.21l-0.72,3.47l-1.01,-0.27l0.74,-4.06l0.85,-5.46l1.12,-1.96l0.03,-0.22l-0.71,-2.82l-0.19,-2.94l0.76,-0.07l0.26,-0.2l1.53,-4.62l1.73,-4.52l1.07,-4.2l-0.56,-4.2l0.73,-2.2l0.01,-0.12l-0.29,-3.3l1.46,-3.34l0.45,-5.19l0.8,-5.52l0.78,-5.89l-0.18,-4.33l-0.49,-3.47l1.1,-0.56l0.13,-0.13l0.44,-0.88l0.9,1.29l0.32,1.8l0.1,0.18l1.16,0.97l-0.73,2.33l0.01,0.21l1.33,2.91l0.97,3.6l0.35,0.22l1.57,-0.31l0.16,0.34l-0.79,2.51l-2.61,1.25l-0.17,0.28l0.08,4.36l-0.48,0.79l0.01,0.33l0.6,0.84l-1.62,1.55l-1.67,2.6l-0.89,2.47l-0.02,0.13l0.23,2.56l-1.5,2.76l-0.03,0.21l1.15,4.8l0.11,0.17l0.54,0.42l-0.01,2.37l-1.4,2.7l-0.03,0.15l0.06,2.25l-1.8,1.78l-0.09,0.21l0.02,2.73l0.71,2.63l-1.33,0.94l-0.12,0.17l-0.67,2.64l-0.59,3.03l0.4,3.55l-0.84,0.51l-0.14,0.31l0.58,3.5l0.08,0.16l0.96,0.99l-0.7,1.08l0.11,0.43l1.04,0.55l0.19,0.8l-0.89,0.48l-0.16,0.31l0.26,1.77l-0.89,4.06l-1.31,2.67l-0.03,0.19l0.28,1.53l-0.73,1.88l-1.85,1.37l-0.12,0.26l0.22,3.46l0.06,0.16l0.88,1.19l0.28,0.12l1.32,-0.17l-0.04,2.13l0.04,0.15l1.04,1.95l0.24,0.16l5.94,0.44ZM248.79,430.71l0.0,7.41l0.3,0.3l2.67,0.0l1.01,0.06l-0.54,0.91l-1.99,1.01l-1.13,-0.1l-1.42,-0.27l-1.87,-1.06l-2.57,-0.49l-3.09,-1.9l-2.52,-1.83l-2.65,-2.93l0.93,0.32l3.54,2.29l3.32,1.23l0.34,-0.09l1.29,-1.57l0.83,-2.32l2.11,-1.28l1.43,0.32Z", "name": "Chile"}, "CA": {"path": "M280.14,145.66l-1.66,2.88l0.06,0.37l0.37,0.03l1.5,-1.01l1.17,0.49l-0.64,0.83l0.13,0.46l2.22,0.89l0.28,-0.03l1.02,-0.7l2.09,0.83l-0.69,2.1l0.37,0.38l1.43,-0.45l0.27,1.43l0.74,1.88l-0.95,2.5l-0.88,0.09l-1.34,-0.48l0.49,-2.34l-0.14,-0.32l-0.7,-0.4l-0.36,0.04l-2.81,2.66l-0.63,-0.05l1.2,-1.01l-0.1,-0.52l-2.4,-0.77l-2.79,0.18l-4.65,-0.09l-0.22,-0.54l1.37,-0.99l0.01,-0.48l-0.82,-0.65l1.91,-1.79l2.57,-5.17l1.49,-1.81l2.04,-1.07l0.63,0.08l-0.27,0.51l-1.33,2.07ZM193.92,74.85l-0.01,4.24l0.19,0.28l0.33,-0.07l3.14,-3.22l2.65,2.5l-0.71,3.04l0.06,0.26l2.42,2.88l0.46,0.0l2.66,-3.14l1.83,-3.74l0.03,-0.12l0.13,-4.53l3.23,0.31l3.63,0.64l3.18,2.08l0.13,1.91l-1.79,2.22l-0.0,0.37l1.69,2.2l-0.28,1.8l-4.74,2.84l-3.33,0.62l-2.5,-1.21l-0.41,0.17l-0.73,2.05l-2.39,3.44l-0.74,1.78l-2.78,2.61l-3.48,0.26l-0.17,0.07l-1.98,1.68l-0.1,0.21l-0.15,2.33l-2.68,0.45l-0.17,0.09l-3.1,3.2l-2.75,4.38l-0.99,3.06l-0.14,4.31l0.25,0.31l3.5,0.58l1.07,3.24l1.18,2.76l0.34,0.18l3.43,-0.69l4.55,1.52l2.45,1.32l1.76,1.65l0.12,0.07l3.11,0.96l2.63,1.46l0.13,0.04l4.12,0.2l2.41,0.3l-0.36,2.81l0.8,3.51l1.81,3.78l0.08,0.1l3.73,3.17l0.34,0.03l1.93,-1.08l0.13,-0.15l1.35,-3.44l0.01,-0.18l-1.31,-5.38l-0.08,-0.14l-1.46,-1.5l3.68,-1.51l2.84,-2.46l1.45,-2.55l0.04,-0.17l-0.2,-2.39l-0.04,-0.12l-1.7,-3.07l-2.9,-2.64l2.79,-3.66l0.05,-0.27l-1.08,-3.38l-0.8,-5.75l1.45,-0.75l4.18,1.03l2.6,0.38l0.18,-0.03l1.93,-0.95l2.18,1.23l3.01,2.18l0.73,1.42l0.25,0.16l4.18,0.27l-0.06,2.95l0.83,4.7l0.22,0.24l2.19,0.55l1.75,2.08l0.38,0.07l3.63,-2.03l0.11,-0.11l2.38,-4.06l1.36,-1.43l1.76,3.01l3.26,4.68l2.68,4.19l-0.94,2.09l0.12,0.38l3.31,1.98l2.23,1.98l0.13,0.07l3.94,0.89l1.48,1.02l0.96,2.82l0.22,0.2l1.85,0.43l0.88,1.13l0.17,3.53l-1.68,1.16l-1.76,1.14l-4.08,1.17l-0.11,0.06l-3.08,2.65l-4.11,0.52l-5.35,-0.69l-3.76,-0.02l-2.62,0.23l-0.2,0.1l-2.05,2.29l-3.13,1.41l-0.11,0.08l-3.6,4.24l-2.87,2.92l-0.05,0.36l0.33,0.14l2.13,-0.52l0.15,-0.08l3.98,-4.15l5.16,-2.63l3.58,-0.31l1.82,1.3l-2.09,1.91l-0.09,0.29l0.8,3.46l0.82,2.37l0.15,0.17l3.25,1.56l0.16,0.03l4.14,-0.45l0.21,-0.12l2.03,-2.86l0.11,1.46l0.13,0.22l1.26,0.88l-2.7,1.78l-5.51,1.83l-2.52,1.26l-2.75,2.16l-1.52,-0.18l-0.08,-2.16l4.19,-2.47l0.14,-0.34l-0.3,-0.22l-4.01,0.1l-2.66,0.36l-1.45,-1.56l0.0,-4.16l-0.11,-0.23l-1.11,-0.91l-0.28,-0.05l-1.5,0.48l-0.7,-0.7l-0.45,0.02l-1.91,2.39l-0.8,2.5l-0.82,1.31l-0.95,0.43l-0.77,0.15l-0.23,0.2l-0.18,0.56l-8.2,0.02l-0.13,0.03l-1.19,0.61l-2.95,2.45l-0.78,1.13l-4.6,0.01l-0.12,0.02l-1.13,0.48l-0.13,0.44l0.37,0.55l0.2,0.82l-0.01,0.09l-3.1,1.42l-2.63,0.5l-2.84,1.57l-0.47,0.0l-0.72,-0.4l-0.18,-0.27l0.03,-0.15l0.52,-1.0l1.2,-1.71l0.73,-1.8l0.02,-0.17l-1.03,-5.47l-0.15,-0.21l-2.35,-1.32l0.16,-0.29l-0.05,-0.35l-0.37,-0.38l-0.22,-0.09l-0.56,0.0l-0.35,-0.34l-0.11,-0.65l-0.46,-0.2l-0.39,0.26l-0.2,-0.03l-0.11,-0.33l-0.48,-0.25l-0.21,-0.71l-0.15,-0.18l-3.97,-2.07l-4.8,-2.39l-0.25,-0.01l-2.19,0.89l-0.72,0.03l-3.04,-0.82l-0.14,-0.0l-1.94,0.4l-2.4,-0.98l-2.56,-0.51l-1.7,-0.19l-0.62,-0.44l-0.42,-1.67l-0.3,-0.23l-0.85,0.02l-0.29,0.3l-0.01,0.95l-69.26,-0.01l-4.77,-3.14l-1.78,-1.41l-4.51,-1.38l-1.3,-2.73l0.34,-1.96l-0.17,-0.33l-3.06,-1.37l-0.41,-2.58l-0.11,-0.18l-2.92,-2.4l-0.05,-1.53l1.32,-1.59l0.07,-0.2l-0.07,-2.21l-0.16,-0.26l-4.19,-2.22l-2.52,-4.02l-1.56,-2.6l-0.08,-0.09l-2.28,-1.64l-1.65,-1.48l-1.31,-1.89l-0.38,-0.1l-2.51,1.21l-2.28,1.92l-2.03,-2.22l-1.85,-1.71l-2.44,-1.04l-2.28,-0.12l0.03,-37.72l4.27,0.98l4.0,2.13l2.61,0.4l0.24,-0.07l2.17,-1.81l2.92,-1.33l3.63,0.53l0.18,-0.03l3.72,-1.94l3.89,-1.06l1.6,1.72l0.37,0.06l1.87,-1.04l0.14,-0.19l0.48,-1.83l1.37,0.38l4.18,3.96l0.41,0.0l2.89,-2.62l0.28,2.79l0.37,0.26l3.08,-0.73l0.17,-0.12l0.85,-1.16l2.81,0.24l3.83,1.86l5.86,1.61l3.46,0.75l2.44,-0.26l2.89,1.89l-3.12,1.89l-0.14,0.31l0.24,0.24l4.53,0.92l6.84,-0.5l2.04,-0.71l2.54,2.44l0.39,0.02l2.72,-2.16l-0.01,-0.48l-2.26,-1.61l1.27,-1.16l2.94,-0.19l1.94,-0.42l1.89,0.97l2.49,2.32l0.24,0.08l2.71,-0.33l4.35,1.9l0.17,0.02l3.86,-0.67l3.62,0.1l0.31,-0.33l-0.26,-2.44l1.9,-0.65l3.58,1.36l-0.01,3.84l0.23,0.29l0.34,-0.17l1.51,-3.23l1.81,0.1l0.31,-0.22l1.13,-4.37l-0.08,-0.29l-2.68,-2.73l-2.83,-1.76l0.19,-4.73l2.77,-3.15l3.06,0.69l2.44,1.97l3.24,4.88l-2.05,2.02l0.15,0.51l4.41,0.85ZM265.85,150.7l-0.84,0.04l-3.15,-0.99l-1.77,-1.17l0.19,-0.06l3.17,0.79l2.39,1.27l0.01,0.12ZM249.41,3.71l6.68,0.49l5.34,0.79l4.34,1.6l-0.08,1.24l-5.91,2.56l-6.03,1.21l-2.36,1.38l-0.14,0.34l0.29,0.22l4.37,-0.02l-4.96,3.01l-4.06,1.64l-0.11,0.08l-4.21,4.62l-5.07,0.92l-0.12,0.05l-1.53,1.1l-7.5,0.59l-0.28,0.28l0.24,0.31l2.67,0.54l-1.04,0.6l-0.09,0.44l1.89,2.49l-2.11,1.66l-3.83,1.52l-0.15,0.13l-1.14,2.01l-3.41,1.55l-0.16,0.36l0.35,1.19l0.3,0.22l3.98,-0.19l0.03,0.78l-6.42,2.99l-6.44,-1.41l-7.41,0.79l-3.72,-0.62l-4.48,-0.26l-0.25,-2.0l4.37,-1.13l0.21,-0.38l-1.14,-3.55l1.13,-0.28l6.61,2.29l0.35,-0.12l-0.04,-0.37l-3.41,-3.45l-0.14,-0.08l-3.57,-0.92l1.62,-1.7l4.36,-1.3l0.2,-0.18l0.71,-1.94l-0.12,-0.36l-3.45,-2.15l-0.88,-2.43l6.36,0.23l1.94,0.61l0.23,-0.02l3.91,-2.1l0.15,-0.32l-0.26,-0.24l-5.69,-0.67l-8.69,0.37l-4.3,-1.92l-2.12,-2.39l-2.82,-1.68l-0.44,-1.65l3.41,-1.06l2.93,-0.2l4.91,-0.99l3.69,-2.28l2.93,0.31l2.64,1.68l0.42,-0.1l1.84,-3.23l3.17,-0.96l4.45,-0.69l7.56,-0.26l1.26,0.64l0.18,0.03l7.2,-1.06l10.81,0.8ZM203.94,57.59l0.01,0.32l1.97,2.97l0.51,-0.01l2.26,-3.75l6.05,-1.89l4.08,4.72l-0.36,2.95l0.38,0.33l4.95,-1.36l0.11,-0.05l2.23,-1.77l5.37,2.31l3.32,2.14l0.3,1.89l0.36,0.25l4.48,-1.01l2.49,2.8l0.14,0.09l5.99,1.78l2.09,1.74l2.18,3.83l-4.29,1.91l-0.01,0.54l5.9,2.83l3.95,0.94l3.54,3.84l0.2,0.1l3.58,0.25l-0.67,2.51l-4.18,4.54l-2.84,-1.61l-3.91,-3.95l-0.26,-0.09l-3.24,0.52l-0.25,0.26l-0.32,2.37l0.1,0.26l2.63,2.38l3.42,1.89l0.96,1.0l1.57,3.8l-0.74,2.43l-2.85,-0.96l-6.26,-3.15l-0.38,0.09l0.04,0.39l3.54,3.4l2.55,2.31l0.23,0.78l-6.26,-1.43l-5.33,-2.25l-2.73,-1.73l0.67,-0.86l-0.09,-0.45l-7.38,-4.01l-0.44,0.27l0.03,0.89l-6.85,0.61l-1.8,-1.17l1.43,-2.6l4.56,-0.07l5.15,-0.52l0.23,-0.45l-0.76,-1.34l0.8,-1.89l3.21,-4.06l0.05,-0.29l-0.72,-1.95l-0.97,-1.47l-0.11,-0.1l-3.84,-2.1l-4.53,-1.33l1.09,-0.75l0.05,-0.45l-2.65,-2.75l-0.18,-0.09l-2.12,-0.24l-1.91,-1.47l-0.39,0.02l-1.27,1.25l-4.4,0.56l-9.06,-0.99l-5.28,-1.31l-4.01,-0.67l-1.72,-1.31l2.32,-1.85l0.1,-0.33l-0.28,-0.2l-3.3,-0.02l-0.74,-4.36l1.86,-4.09l2.46,-1.88l5.74,-1.15l-1.5,2.55ZM261.28,159.28l0.19,0.14l1.82,0.42l1.66,-0.05l-0.66,0.68l-0.75,0.16l-3.0,-1.25l-0.46,-0.77l0.51,-0.52l0.68,1.19ZM230.87,84.48l-2.48,0.19l-0.52,-1.74l0.96,-2.17l2.03,-0.53l1.71,1.04l0.02,1.6l-0.22,0.46l-1.5,1.16ZM229.52,58.19l0.14,0.82l-4.99,-0.22l-2.73,0.63l-0.59,-0.23l-2.61,-2.4l0.08,-1.38l0.94,-0.25l5.61,0.51l4.14,2.54ZM222.12,105.0l-0.79,1.63l-0.75,-0.22l-0.52,-0.91l0.04,-0.09l0.84,-1.01l0.74,0.06l0.44,0.55ZM183.77,38.22l2.72,1.65l0.16,0.04l4.83,-0.01l1.92,1.52l-0.51,1.75l0.18,0.36l2.84,1.14l1.56,1.19l0.16,0.06l3.37,0.22l3.65,0.42l4.07,-1.1l5.05,-0.43l3.96,0.35l2.53,1.8l0.48,1.79l-1.37,1.16l-3.6,1.03l-3.22,-0.59l-7.17,0.76l-5.1,0.09l-4.0,-0.6l-6.48,-1.56l-0.81,-2.57l-0.3,-2.49l-0.1,-0.19l-2.51,-2.25l-0.16,-0.07l-5.12,-0.63l-2.61,-1.45l0.75,-1.71l4.88,0.32ZM207.46,91.26l0.42,1.62l0.42,0.19l1.12,-0.55l1.35,0.99l2.74,1.39l2.73,1.2l0.2,1.74l0.35,0.26l1.72,-0.29l1.31,0.97l-1.72,0.96l-3.68,-0.9l-1.34,-1.71l-0.43,-0.04l-2.46,2.1l-3.23,1.85l-0.74,-1.98l-0.31,-0.19l-2.47,0.28l1.49,-1.34l0.1,-0.19l0.32,-3.15l0.79,-3.45l1.34,0.25ZM215.59,102.66l-2.73,2.0l-1.49,-0.08l-0.37,-0.7l1.61,-1.56l3.0,0.03l-0.02,0.3ZM202.79,24.07l0.11,0.12l2.54,1.53l-3.01,1.47l-4.55,4.07l-4.3,0.38l-5.07,-0.68l-2.51,-2.09l0.03,-1.72l1.86,-1.4l0.1,-0.34l-0.29,-0.2l-4.49,0.04l-2.63,-1.79l-1.45,-2.36l1.61,-2.38l1.65,-1.69l2.47,-0.4l0.19,-0.48l-0.72,-0.89l5.1,-0.26l3.1,3.05l0.13,0.07l4.21,1.25l3.99,1.06l1.92,3.65ZM187.5,59.3l-0.15,0.1l-2.59,3.4l-2.5,-0.15l-1.47,-3.92l0.04,-2.24l1.22,-1.92l2.34,-1.26l5.11,0.17l4.28,1.06l-3.36,3.86l-2.9,0.9ZM186.19,48.8l-1.15,1.63l-3.42,-0.35l-2.68,-1.15l1.11,-1.88l3.34,-1.27l2.01,1.63l0.79,1.38ZM185.78,35.41l-0.95,0.13l-4.48,-0.33l-0.4,-0.91l4.5,0.07l1.45,0.82l-0.1,0.21ZM180.76,32.56l-3.43,1.03l-1.85,-1.14l-1.01,-1.92l-0.16,-1.87l2.87,0.2l1.39,0.35l2.75,1.75l-0.55,1.6ZM181.03,76.32l-1.21,1.2l-3.19,-1.26l-0.18,-0.01l-1.92,0.45l-2.88,-1.67l1.84,-1.16l1.6,-1.77l2.45,1.17l1.45,0.77l2.05,2.28ZM169.72,54.76l2.83,0.97l0.14,0.01l4.25,-0.58l0.47,1.01l-2.19,2.16l0.07,0.48l3.61,1.95l-0.41,3.84l-3.87,1.68l-2.23,-0.36l-1.73,-1.75l-6.07,-3.53l0.03,-1.01l4.79,0.55l0.3,-0.16l-0.04,-0.34l-2.55,-2.89l2.59,-2.05ZM174.44,40.56l1.49,1.87l0.07,2.48l-1.07,3.52l-3.87,0.48l-2.41,-0.72l0.05,-2.72l-0.33,-0.3l-3.79,0.36l-0.13,-3.31l2.36,0.14l0.15,-0.03l3.7,-1.74l3.44,0.29l0.31,-0.22l0.03,-0.12ZM170.14,31.5l0.75,1.74l-3.52,-0.52l-4.19,-1.77l-4.65,-0.17l1.65,-1.11l-0.05,-0.52l-2.86,-1.26l-0.13,-1.58l4.52,0.7l6.66,1.99l1.84,2.5ZM134.64,58.08l-1.08,1.93l0.34,0.44l5.44,-1.41l3.37,2.32l0.37,-0.02l2.66,-2.28l2.03,1.38l2.01,4.53l0.53,0.04l1.26,-1.93l0.03,-0.27l-1.67,-4.55l1.82,-0.58l2.36,0.73l2.69,1.84l1.53,4.46l0.77,3.24l0.15,0.19l4.22,2.26l4.32,2.04l-0.21,1.51l-3.87,0.34l-0.19,0.5l1.45,1.54l-0.65,1.23l-4.3,-0.65l-4.4,-1.19l-2.97,0.28l-4.67,1.48l-6.31,0.65l-4.27,0.39l-1.26,-1.91l-0.15,-0.12l-3.42,-1.2l-0.16,-0.01l-2.05,0.45l-2.66,-3.02l1.2,-0.34l3.82,-0.76l3.58,0.19l3.27,-0.78l0.23,-0.29l-0.24,-0.29l-4.84,-1.06l-5.42,0.35l-3.4,-0.09l-0.97,-1.22l5.39,-1.7l0.21,-0.33l-0.3,-0.25l-3.82,0.06l-3.95,-1.1l1.88,-3.13l1.68,-1.81l6.54,-2.84l2.11,0.77ZM158.85,56.58l-1.82,2.62l-3.38,-2.9l0.49,-0.39l3.17,-0.18l1.54,0.86ZM149.71,42.7l1.0,1.87l0.37,0.14l2.17,-0.83l2.33,0.2l0.38,2.16l-1.38,2.17l-8.33,0.76l-6.34,2.15l-3.51,0.1l-0.22,-1.13l4.98,-2.12l0.17,-0.34l-0.31,-0.23l-11.27,0.6l-3.04,-0.78l3.14,-4.57l2.2,-1.35l6.87,1.7l4.4,3.0l0.14,0.05l4.37,0.39l0.27,-0.48l-3.41,-4.68l1.96,-1.62l2.28,0.53l0.79,2.32ZM145.44,29.83l-2.18,0.77l-3.79,-0.0l0.02,-0.31l2.34,-1.5l1.2,0.23l2.42,0.83ZM144.83,34.5l-4.44,1.46l-3.18,-1.48l1.6,-1.36l3.51,-0.53l3.1,0.75l-0.6,1.16ZM119.02,65.87l-6.17,2.07l-1.19,-1.82l-0.13,-0.11l-5.48,-2.32l0.92,-1.7l1.73,-3.44l2.16,-3.15l-0.02,-0.36l-2.09,-2.56l7.84,-0.71l3.59,1.02l6.32,0.27l2.35,1.37l2.25,1.71l-2.68,1.04l-6.21,3.41l-3.1,3.28l-0.08,0.21l0.0,1.81ZM129.66,35.4l-0.3,3.55l-1.77,1.67l-2.34,0.27l-4.62,2.2l-3.89,0.76l-2.83,-0.93l3.85,-3.52l5.04,-3.36l3.75,0.07l3.11,-0.7ZM111.24,152.74l-0.82,0.29l-3.92,-1.39l-0.7,-1.06l-0.12,-0.1l-2.15,-1.09l-0.41,-0.84l-0.2,-0.16l-2.44,-0.56l-0.84,-1.56l0.1,-0.36l2.34,0.64l1.53,0.5l2.28,0.34l0.78,1.04l1.24,1.55l0.09,0.08l2.42,1.3l0.81,1.39ZM88.54,134.82l0.14,0.02l2.0,-0.23l-0.67,3.48l0.06,0.24l1.78,2.22l-0.24,-0.0l-1.4,-1.42l-0.91,-1.53l-1.26,-1.08l-0.42,-1.35l0.09,-0.66l0.82,0.31Z", "name": "Canada"}, "CG": {"path": "M453.66,296.61l-0.9,-0.82l-0.35,-0.04l-0.83,0.48l-0.77,0.83l-1.65,-2.13l1.66,-1.2l0.08,-0.39l-0.81,-1.43l0.59,-0.43l1.62,-0.29l0.24,-0.24l0.1,-0.58l0.94,0.84l0.19,0.08l2.21,0.11l0.27,-0.14l0.81,-1.29l0.32,-1.76l-0.27,-1.96l-0.06,-0.15l-1.08,-1.35l1.02,-2.74l-0.09,-0.34l-0.62,-0.5l-0.22,-0.06l-1.66,0.18l-0.55,-1.03l0.12,-0.73l2.85,0.09l1.98,0.65l2.0,0.59l0.38,-0.25l0.17,-1.3l1.26,-2.24l1.34,-1.19l1.54,0.38l1.35,0.12l-0.11,1.15l-0.74,1.34l-0.5,1.61l-0.31,2.22l0.12,1.41l-0.4,0.9l-0.06,0.88l-0.24,0.67l-1.57,1.15l-1.24,1.41l-1.09,2.43l-0.03,0.13l0.08,1.95l-0.55,0.69l-1.46,1.23l-1.32,1.41l-0.61,-0.29l-0.13,-0.57l-0.29,-0.23l-1.36,-0.02l-0.23,0.1l-0.72,0.81l-0.41,-0.16Z", "name": "Republic of the Congo"}, "CF": {"path": "M459.41,266.56l1.9,-0.17l0.22,-0.12l0.36,-0.5l0.14,0.02l0.55,0.51l0.29,0.07l3.15,-0.96l0.12,-0.07l1.05,-0.97l1.29,-0.87l0.12,-0.33l-0.17,-0.61l0.38,-0.12l2.36,0.15l0.15,-0.03l2.36,-1.17l0.12,-0.1l1.78,-2.72l1.18,-0.96l1.23,-0.34l0.21,0.79l0.07,0.13l1.37,1.5l0.01,0.86l-0.39,1.0l-0.01,0.17l0.16,0.78l0.1,0.17l0.91,0.76l1.89,1.09l1.24,0.92l0.02,0.67l0.12,0.23l1.67,1.3l0.99,1.03l0.61,1.46l0.14,0.15l1.79,0.95l0.2,0.4l-0.44,0.14l-1.54,-0.06l-1.98,-0.26l-0.93,0.22l-0.19,0.14l-0.3,0.48l-0.57,0.05l-0.91,-0.49l-0.26,-0.01l-2.7,1.21l-1.04,-0.23l-0.21,0.03l-0.34,0.19l-0.12,0.13l-0.64,1.3l-1.67,-0.43l-1.77,-0.24l-1.58,-0.91l-2.06,-0.85l-0.27,0.02l-1.42,0.88l-0.97,1.27l-0.06,0.14l-0.19,1.46l-1.3,-0.11l-1.67,-0.42l-0.27,0.07l-1.55,1.41l-0.99,1.76l-0.14,-1.18l-0.13,-0.22l-1.1,-0.78l-0.86,-1.2l-0.2,-0.84l-0.07,-0.13l-1.07,-1.19l0.16,-0.59l0.0,-0.15l-0.24,-1.01l0.18,-1.77l0.5,-0.38l0.09,-0.11l1.18,-2.4Z", "name": "Central African Republic"}, "CD": {"path": "M497.85,276.25l-0.14,2.77l0.2,0.3l0.57,0.19l-0.47,0.52l-1.0,0.71l-0.96,1.31l-0.56,1.22l-0.16,2.04l-0.54,0.89l-0.04,0.15l-0.02,1.76l-0.63,0.61l-0.09,0.2l-0.08,1.33l-0.2,0.11l-0.15,0.21l-0.23,1.37l0.03,0.2l0.6,1.08l0.16,2.96l0.44,2.29l-0.24,1.25l0.01,0.15l0.5,1.46l0.07,0.12l1.41,1.37l1.09,2.56l-0.51,-0.11l-3.45,0.45l-0.67,0.3l-0.15,0.15l-0.71,1.61l0.01,0.26l0.52,1.03l-0.43,2.9l-0.31,2.55l0.13,0.29l0.7,0.46l1.75,0.99l0.31,-0.01l0.26,-0.17l0.15,1.9l-1.44,-0.02l-0.94,-1.28l-0.94,-1.1l-0.17,-0.1l-1.76,-0.33l-0.5,-1.18l-0.42,-0.15l-1.44,0.75l-1.79,-0.32l-0.77,-1.05l-0.2,-0.12l-1.59,-0.23l-0.97,0.04l-0.1,-0.53l-0.27,-0.25l-0.86,-0.06l-1.13,-0.15l-1.62,0.37l-1.04,-0.06l-0.32,0.09l0.11,-2.56l-0.08,-0.21l-0.77,-0.87l-0.17,-1.41l0.36,-1.47l-0.03,-0.21l-0.48,-0.91l-0.04,-1.52l-0.3,-0.29l-2.65,0.02l0.13,-0.53l-0.29,-0.37l-1.28,0.01l-0.28,0.21l-0.07,0.24l-1.35,0.09l-0.26,0.18l-0.62,1.45l-0.25,0.42l-1.17,-0.3l-0.19,0.01l-0.79,0.34l-1.44,0.18l-1.41,-1.96l-0.7,-1.47l-0.61,-1.86l-0.28,-0.21l-7.39,-0.03l-0.92,0.3l-0.78,-0.03l-0.78,0.25l-0.11,-0.25l0.35,-0.15l0.18,-0.26l0.07,-1.02l0.33,-0.52l0.72,-0.42l0.52,0.2l0.33,-0.08l0.76,-0.86l0.99,0.02l0.11,0.48l0.16,0.2l0.94,0.44l0.35,-0.07l1.46,-1.56l1.44,-1.21l0.68,-0.85l0.06,-0.2l-0.08,-1.99l1.04,-2.33l1.1,-1.23l1.62,-1.19l0.11,-0.14l0.29,-0.8l0.08,-0.94l0.38,-0.82l0.03,-0.16l-0.13,-1.38l0.3,-2.16l0.47,-1.51l0.73,-1.31l0.04,-0.12l0.15,-1.51l0.21,-1.66l0.89,-1.16l1.16,-0.7l1.9,0.79l1.69,0.95l1.81,0.24l1.85,0.48l0.35,-0.16l0.71,-1.43l0.16,-0.09l1.03,0.23l0.19,-0.02l2.65,-1.19l0.86,0.46l0.17,0.03l0.81,-0.08l0.23,-0.14l0.31,-0.5l0.75,-0.17l1.83,0.26l1.64,0.06l0.72,-0.21l1.39,1.9l0.16,0.11l1.12,0.3l0.24,-0.04l0.58,-0.36l1.05,0.15l0.15,-0.02l1.15,-0.44l0.47,0.84l0.08,0.09l2.08,1.57Z", "name": "Democratic Republic of the Congo"}, "CZ": {"path": "M463.29,152.22l-0.88,-0.47l-0.18,-0.03l-1.08,0.15l-1.86,-0.94l-0.21,-0.02l-0.88,0.24l-0.13,0.07l-1.25,1.17l-1.63,-0.91l-1.38,-1.36l-1.22,-0.75l-0.24,-1.24l-0.33,-0.75l1.53,-0.6l0.98,-0.84l1.74,-0.62l0.11,-0.07l0.47,-0.47l0.46,0.27l0.24,0.03l0.96,-0.3l1.06,0.95l0.15,0.07l1.57,0.24l-0.1,0.6l0.16,0.32l1.36,0.68l0.41,-0.15l0.28,-0.62l1.29,0.28l0.19,0.84l0.26,0.23l1.73,0.18l0.74,1.02l-0.17,0.0l-0.25,0.13l-0.32,0.49l-0.46,0.11l-0.22,0.23l-0.13,0.57l-0.32,0.1l-0.2,0.22l-0.03,0.14l-0.65,0.25l-1.05,-0.05l-0.28,0.17l-0.22,0.43Z", "name": "Czech Republic"}, "CY": {"path": "M505.03,193.75l-1.51,0.68l-1.0,-0.3l-0.32,-0.63l0.69,-0.06l0.41,0.13l0.19,-0.0l0.62,-0.22l0.31,0.02l0.06,0.22l0.49,0.17l0.06,-0.01Z", "name": "Cyprus"}, "CR": {"path": "M213.0,263.84l-0.98,-0.4l-0.3,-0.31l0.16,-0.24l0.05,-0.21l-0.09,-0.56l-0.1,-0.18l-0.76,-0.65l-0.99,-0.5l-0.74,-0.28l-0.13,-0.58l-0.12,-0.18l-0.66,-0.45l-0.34,-0.0l-0.13,0.31l0.13,0.59l-0.17,0.21l-0.34,-0.42l-0.14,-0.1l-0.7,-0.22l-0.23,-0.34l0.01,-0.62l0.31,-0.74l-0.14,-0.38l-0.3,-0.15l0.47,-0.4l1.48,0.6l0.26,-0.02l0.47,-0.27l0.58,0.15l0.35,0.44l0.17,0.11l0.74,0.17l0.27,-0.07l0.3,-0.27l0.52,1.09l0.97,1.02l0.77,0.71l-0.41,0.1l-0.23,0.3l0.01,1.02l0.12,0.24l0.2,0.14l-0.07,0.05l-0.11,0.3l0.08,0.37l-0.23,0.63Z", "name": "Costa Rica"}, "CU": {"path": "M215.01,226.09l2.08,0.18l1.94,0.03l2.24,0.86l0.95,0.92l0.25,0.08l2.22,-0.28l0.79,0.55l3.68,2.81l0.19,0.06l0.77,-0.03l1.18,0.42l-0.12,0.47l0.27,0.37l1.78,0.1l1.59,0.9l-0.11,0.22l-1.5,0.3l-1.64,0.13l-1.75,-0.2l-2.69,0.19l1.0,-0.86l-0.03,-0.48l-1.02,-0.68l-0.13,-0.05l-1.52,-0.16l-0.74,-0.64l-0.57,-1.42l-0.3,-0.19l-1.36,0.1l-2.23,-0.67l-0.71,-0.52l-0.14,-0.06l-3.2,-0.4l-0.42,-0.25l0.56,-0.39l0.12,-0.33l-0.27,-0.22l-2.46,-0.13l-0.2,0.06l-1.72,1.31l-0.94,0.03l-0.25,0.15l-0.29,0.53l-1.04,0.24l-0.29,-0.07l0.7,-0.43l0.1,-0.11l0.5,-0.87l1.04,-0.54l1.23,-0.49l1.86,-0.25l0.62,-0.28Z", "name": "Cuba"}, "SZ": {"path": "M500.95,353.41l-0.41,0.97l-1.16,0.23l-1.29,-1.26l-0.02,-0.71l0.63,-0.93l0.23,-0.7l0.47,-0.12l1.04,0.4l0.32,1.05l0.2,1.08Z", "name": "Swaziland"}, "SY": {"path": "M510.84,199.83l0.09,-0.11l0.07,-0.2l-0.04,-1.08l0.56,-1.4l1.3,-1.01l0.1,-0.34l-0.41,-1.11l-0.24,-0.19l-0.89,-0.11l-0.2,-1.84l0.55,-1.05l1.3,-1.22l0.09,-0.19l0.09,-1.09l0.39,0.27l0.25,0.04l2.66,-0.77l1.35,0.52l2.06,-0.01l2.93,-1.08l1.35,0.04l2.14,-0.34l-0.83,1.16l-1.31,0.68l-0.16,0.3l0.23,2.03l-0.9,3.25l-5.43,2.87l-4.79,2.91l-2.32,-0.92Z", "name": "Syria"}, "KG": {"path": "M599.04,172.15l0.38,-0.9l1.43,-0.37l4.04,1.02l0.37,-0.23l0.36,-1.64l1.17,-0.52l3.45,1.24l0.2,-0.0l0.86,-0.31l4.09,0.08l3.61,0.31l1.18,1.02l0.11,0.06l1.19,0.34l-0.13,0.26l-3.84,1.58l-0.13,0.1l-0.81,1.08l-3.08,0.34l-0.24,0.16l-0.85,1.7l-2.43,-0.37l-0.14,0.01l-1.79,0.61l-2.39,1.4l-0.12,0.39l0.25,0.49l-0.48,0.45l-4.57,0.43l-3.04,-0.94l-2.45,0.18l0.14,-1.02l2.42,0.44l0.27,-0.08l0.81,-0.81l1.76,0.27l0.21,-0.05l3.21,-2.14l-0.03,-0.51l-2.97,-1.57l-0.26,-0.01l-1.64,0.69l-1.38,-0.84l1.81,-1.67l-0.09,-0.5l-0.46,-0.18Z", "name": "Kyrgyzstan"}, "KE": {"path": "M523.3,287.04l0.06,0.17l1.29,1.8l-1.46,0.84l-0.11,0.11l-0.55,0.93l-0.81,0.16l-0.24,0.24l-0.34,1.69l-0.81,1.06l-0.46,1.58l-0.76,0.63l-3.3,-2.3l-0.16,-1.32l-0.15,-0.23l-9.35,-5.28l-0.02,-2.4l1.92,-2.63l0.91,-1.83l0.01,-0.24l-1.09,-2.86l-0.29,-1.24l-1.09,-1.63l2.93,-2.85l0.92,0.3l0.0,1.19l0.09,0.22l0.86,0.83l0.21,0.08l1.65,0.0l3.09,2.08l0.16,0.05l0.79,0.03l0.54,-0.06l0.58,0.28l1.67,0.2l0.28,-0.12l0.69,-0.98l2.04,-0.94l0.86,0.73l0.19,0.07l1.1,0.0l-1.82,2.36l-0.06,0.18l0.03,9.12Z", "name": "Kenya"}, "SS": {"path": "M505.7,261.39l0.02,1.64l-0.27,0.55l-1.15,0.05l-0.24,0.15l-0.85,1.44l0.22,0.45l1.44,0.17l1.15,1.12l0.42,0.95l0.14,0.15l1.06,0.54l1.33,2.45l-3.06,2.98l-1.44,1.08l-1.75,0.01l-1.92,0.56l-1.5,-0.53l-0.27,0.03l-0.85,0.57l-1.98,-1.5l-0.56,-1.02l-0.37,-0.13l-1.32,0.5l-1.08,-0.15l-0.2,0.04l-0.56,0.35l-0.9,-0.24l-1.44,-1.97l-0.39,-0.77l-0.13,-0.13l-1.78,-0.94l-0.65,-1.5l-1.08,-1.12l-1.57,-1.22l-0.02,-0.68l-0.12,-0.23l-1.37,-1.02l-1.17,-0.68l0.2,-0.08l0.86,-0.48l0.14,-0.18l0.63,-2.22l0.6,-1.02l1.47,-0.28l0.35,0.56l1.29,1.48l0.14,0.09l0.69,0.22l0.22,-0.02l0.83,-0.4l1.58,0.08l0.26,0.39l0.25,0.13l2.49,0.0l0.3,-0.25l0.06,-0.35l1.13,-0.42l0.18,-0.18l0.22,-0.63l0.68,-0.38l1.95,1.37l0.23,0.05l1.29,-0.26l0.19,-0.12l1.23,-1.8l1.36,-1.37l0.08,-0.25l-0.21,-1.52l-0.06,-0.15l-0.25,-0.3l0.94,-0.08l0.26,-0.21l0.1,-0.32l0.6,0.09l-0.25,1.67l0.3,1.83l0.11,0.19l1.22,0.94l0.25,0.73l-0.04,1.2l0.26,0.31l0.09,0.01Z", "name": "South Sudan"}, "SR": {"path": "M278.1,270.26l2.71,0.45l0.31,-0.14l0.19,-0.32l1.82,-0.16l2.25,0.56l-1.09,1.81l-0.04,0.19l0.2,1.72l0.05,0.13l0.9,1.35l-0.39,0.99l-0.21,1.09l-0.48,0.8l-1.2,-0.44l-0.17,-0.01l-1.12,0.24l-0.95,-0.21l-0.35,0.2l-0.25,0.73l0.05,0.29l0.3,0.35l-0.06,0.13l-1.01,-0.15l-1.42,-2.03l-0.32,-1.36l-0.29,-0.23l-0.63,-0.0l-0.95,-1.56l0.41,-1.16l0.01,-0.17l-0.08,-0.35l1.29,-0.56l0.18,-0.22l0.35,-1.97Z", "name": "Suriname"}, "KH": {"path": "M680.28,257.89l-0.93,-1.2l-1.24,-2.56l-0.56,-2.9l1.45,-1.92l3.07,-0.46l2.26,0.35l2.03,0.98l0.38,-0.11l1.0,-1.55l1.86,0.79l0.52,1.51l-0.28,2.82l-4.05,1.88l-0.12,0.45l0.79,1.1l-2.2,0.17l-2.08,0.98l-1.89,-0.33Z", "name": "Cambodia"}, "SV": {"path": "M197.02,248.89l0.18,-0.05l0.59,0.17l0.55,0.51l0.64,0.35l0.06,0.22l0.37,0.21l1.01,-0.28l0.38,0.13l0.16,0.13l-0.14,0.81l-0.18,0.38l-1.22,-0.03l-0.84,-0.23l-1.11,-0.52l-1.31,-0.15l-0.49,-0.38l0.02,-0.08l0.76,-0.57l0.46,-0.27l0.11,-0.35Z", "name": "El Salvador"}, "SK": {"path": "M468.01,150.02l0.05,0.07l0.36,0.1l0.85,-0.37l1.12,1.02l0.33,0.05l1.38,-0.65l1.07,0.3l0.16,0.0l1.69,-0.43l1.95,1.02l-0.51,0.64l-0.45,1.2l-0.32,0.2l-2.55,-0.93l-0.17,-0.01l-0.82,0.2l-0.17,0.11l-0.53,0.68l-0.94,0.32l-0.14,-0.11l-0.29,-0.04l-1.18,0.48l-0.95,0.09l-0.26,0.21l-0.15,0.47l-1.84,0.34l-0.82,-0.31l-1.14,-0.73l-0.2,-0.89l0.42,-0.84l0.91,0.05l0.12,-0.02l0.86,-0.33l0.18,-0.21l0.03,-0.13l0.32,-0.1l0.2,-0.22l0.12,-0.55l0.39,-0.1l0.18,-0.13l0.3,-0.45l0.43,-0.0Z", "name": "Slovakia"}, "KR": {"path": "M737.31,185.72l0.84,0.08l0.27,-0.12l0.89,-1.2l1.63,-0.13l1.1,-0.2l0.21,-0.16l0.12,-0.24l1.86,2.95l0.59,1.79l0.02,3.17l-0.84,1.38l-2.23,0.55l-1.95,1.14l-1.91,0.21l-0.22,-1.21l0.45,-2.07l-0.01,-0.17l-0.99,-2.67l1.54,-0.4l0.17,-0.46l-1.55,-2.24Z", "name": "South Korea"}, "SI": {"path": "M455.77,159.59l1.79,0.21l0.18,-0.04l1.2,-0.68l2.12,-0.08l0.21,-0.1l0.38,-0.42l0.1,0.01l0.28,0.62l-1.71,0.71l-0.18,0.22l-0.21,1.1l-0.71,0.26l-0.2,0.28l0.01,0.55l-0.59,-0.04l-0.79,-0.47l-0.38,0.06l-0.36,0.41l-0.84,-0.05l0.05,-0.15l-0.56,-1.24l0.21,-1.17Z", "name": "Slovenia"}, "KP": {"path": "M747.76,172.02l-0.23,-0.04l-0.26,0.08l-1.09,1.02l-0.78,1.06l-0.06,0.19l0.09,1.95l-1.12,0.57l-0.53,0.58l-0.88,0.82l-1.69,0.51l-1.09,0.79l-0.12,0.22l-0.07,1.17l-0.22,0.25l0.09,0.47l0.96,0.46l1.22,1.1l-0.19,0.37l-0.91,0.16l-1.75,0.14l-0.22,0.12l-0.87,1.18l-0.95,-0.09l-0.3,0.18l-0.97,-0.44l-0.39,0.13l-0.25,0.44l-0.29,0.09l-0.03,-0.2l-0.18,-0.23l-0.62,-0.25l-0.43,-0.29l0.52,-0.97l0.52,-0.3l0.13,-0.38l-0.18,-0.42l0.59,-1.47l0.01,-0.21l-0.16,-0.48l-0.22,-0.2l-1.41,-0.31l-0.82,-0.55l1.74,-1.62l2.73,-1.58l1.62,-1.96l0.96,0.76l0.17,0.06l2.17,0.11l0.31,-0.37l-0.32,-1.31l3.61,-1.21l0.16,-0.13l0.79,-1.34l1.25,1.38Z", "name": "North Korea"}, "SO": {"path": "M543.8,256.48l0.61,-0.05l1.14,-0.37l1.31,-0.25l0.12,-0.05l1.11,-0.81l0.57,-0.0l0.03,0.39l-0.23,1.49l0.01,1.25l-0.52,0.92l-0.7,2.71l-1.19,2.79l-1.54,3.2l-2.13,3.66l-2.12,2.79l-2.92,3.39l-2.47,2.0l-3.76,2.5l-2.33,1.9l-2.77,3.06l-0.61,1.35l-0.28,0.29l-1.22,-1.69l-0.03,-8.92l2.12,-2.76l0.59,-0.68l1.47,-0.04l0.18,-0.06l2.15,-1.71l3.16,-0.11l0.21,-0.09l7.08,-7.55l1.76,-2.12l1.14,-1.57l0.06,-0.18l0.01,-4.67Z", "name": "Somalia"}, "SN": {"path": "M379.28,250.34l-0.95,-1.82l-0.09,-0.1l-0.83,-0.6l0.62,-0.28l0.13,-0.11l1.21,-1.8l0.6,-1.31l0.71,-0.68l1.09,0.2l0.18,-0.02l1.17,-0.53l1.25,-0.03l1.17,0.73l1.59,0.65l1.47,1.83l1.59,1.7l0.12,1.56l0.49,1.46l0.1,0.14l0.85,0.65l0.18,0.82l-0.08,0.57l-0.13,0.05l-1.29,-0.19l-0.29,0.13l-0.11,0.16l-0.35,0.04l-1.83,-0.61l-5.84,-0.13l-0.12,0.02l-0.6,0.26l-0.87,-0.06l-1.01,0.32l-0.26,-1.26l1.9,0.04l0.16,-0.04l0.54,-0.32l0.37,-0.02l0.15,-0.05l0.78,-0.5l0.92,0.46l0.12,0.03l1.09,0.04l0.15,-0.03l1.08,-0.57l0.11,-0.44l-0.51,-0.74l-0.39,-0.1l-0.76,0.39l-0.62,-0.01l-0.92,-0.58l-0.18,-0.05l-0.79,0.04l-0.2,0.09l-0.48,0.51l-2.41,0.06Z", "name": "Senegal"}, "SL": {"path": "M392.19,267.53l-0.44,-0.12l-1.73,-0.97l-1.24,-1.28l-0.4,-0.84l-0.27,-1.65l1.21,-1.0l0.09,-0.12l0.27,-0.66l0.32,-0.41l0.56,-0.05l0.16,-0.07l0.5,-0.41l1.75,0.0l0.59,0.77l0.49,0.96l-0.07,0.64l0.04,0.19l0.36,0.58l-0.03,0.84l0.24,0.2l-0.64,0.65l-1.13,1.37l-0.06,0.14l-0.12,0.66l-0.43,0.58Z", "name": "Sierra Leone"}, "SB": {"path": "M826.74,311.51l0.23,0.29l-0.95,-0.01l-0.39,-0.63l0.65,0.27l0.45,0.09ZM825.01,308.52l-1.18,-1.39l-0.37,-1.06l0.24,0.0l0.82,1.84l0.49,0.6ZM823.21,309.42l-0.44,0.03l-1.43,-0.24l-0.32,-0.24l0.08,-0.5l1.29,0.31l0.72,0.47l0.11,0.18ZM817.9,303.81l2.59,1.44l0.3,0.41l-1.21,-0.66l-1.34,-0.89l-0.34,-0.3ZM813.77,302.4l0.48,0.34l0.1,0.08l-0.33,-0.17l-0.25,-0.25Z", "name": "Solomon Islands"}, "SA": {"path": "M528.24,243.1l-0.2,-0.69l-0.07,-0.12l-0.69,-0.71l-0.18,-0.94l-0.12,-0.19l-1.24,-0.89l-1.28,-2.09l-0.7,-2.08l-0.07,-0.11l-1.73,-1.79l-0.11,-0.07l-1.03,-0.39l-1.57,-2.36l-0.27,-1.72l0.1,-1.53l-0.03,-0.15l-1.44,-2.93l-1.25,-1.13l-1.34,-0.56l-0.72,-1.33l0.11,-0.49l-0.02,-0.2l-0.7,-1.38l-0.08,-0.1l-0.68,-0.56l-0.97,-1.98l-2.8,-4.03l-0.25,-0.13l-0.85,0.01l0.29,-1.11l0.12,-0.97l0.23,-0.81l2.52,0.39l0.23,-0.06l1.08,-0.84l0.6,-0.95l1.78,-0.35l0.22,-0.17l0.37,-0.83l0.74,-0.42l0.08,-0.46l-2.17,-2.4l4.55,-1.26l0.12,-0.06l0.36,-0.32l2.83,0.71l3.67,1.91l7.04,5.5l0.17,0.06l4.64,0.22l2.06,0.24l0.55,1.15l0.28,0.17l1.56,-0.06l0.9,2.15l0.14,0.15l1.14,0.57l0.39,0.85l0.11,0.13l1.59,1.06l0.12,0.91l-0.23,0.83l0.01,0.18l0.32,0.9l0.07,0.11l0.68,0.7l0.33,0.86l0.37,0.65l0.09,0.1l0.76,0.53l0.25,0.04l0.45,-0.12l0.35,0.75l0.1,0.63l0.96,2.68l0.23,0.19l7.53,1.33l0.27,-0.09l0.24,-0.26l0.87,1.41l-1.58,4.96l-7.34,2.54l-7.28,1.02l-2.34,1.17l-0.12,0.1l-1.74,2.63l-0.86,0.32l-0.49,-0.68l-0.28,-0.12l-0.92,0.12l-2.32,-0.25l-0.41,-0.23l-0.15,-0.04l-2.89,0.06l-0.63,0.2l-0.91,-0.59l-0.43,0.11l-0.66,1.27l-0.03,0.21l0.21,0.89l-0.6,0.45Z", "name": "Saudi Arabia"}, "SE": {"path": "M476.42,90.44l-0.15,0.1l-2.43,2.86l-0.07,0.24l0.36,2.31l-3.84,3.1l-4.83,3.38l-0.11,0.15l-1.82,5.45l0.03,0.26l1.78,2.68l2.27,1.99l-2.13,3.88l-2.49,0.82l-0.2,0.24l-0.95,6.05l-1.32,3.09l-2.82,-0.32l-0.3,0.16l-1.34,2.64l-2.48,0.14l-0.76,-3.15l-2.09,-4.04l-1.85,-5.01l1.03,-1.98l2.06,-2.53l0.06,-0.13l0.83,-4.45l-0.06,-0.25l-1.54,-1.86l-0.15,-5.0l1.52,-3.48l2.28,0.06l0.27,-0.16l0.87,-1.59l-0.01,-0.31l-0.8,-1.21l3.79,-5.63l4.07,-7.54l2.23,0.01l0.29,-0.22l0.59,-2.15l4.46,0.66l0.34,-0.26l0.34,-2.64l1.21,-0.14l3.24,2.08l3.78,2.85l0.06,6.37l0.03,0.14l0.67,1.29l-3.95,1.07Z", "name": "Sweden"}, "SD": {"path": "M505.98,259.75l-0.31,-0.9l-0.1,-0.14l-1.2,-0.93l-0.27,-1.66l0.29,-1.83l-0.25,-0.34l-1.16,-0.17l-0.33,0.21l-0.11,0.37l-1.3,0.11l-0.21,0.49l0.55,0.68l0.18,1.29l-1.31,1.33l-1.18,1.72l-1.04,0.21l-2.0,-1.4l-0.32,-0.02l-0.95,0.52l-0.14,0.16l-0.21,0.6l-1.16,0.43l-0.19,0.23l-0.04,0.27l-2.08,0.0l-0.25,-0.39l-0.24,-0.13l-1.81,-0.09l-0.14,0.03l-0.8,0.38l-0.49,-0.16l-1.22,-1.39l-0.42,-0.67l-0.31,-0.14l-1.81,0.35l-0.2,0.14l-0.72,1.24l-0.61,2.14l-0.73,0.4l-0.62,0.22l-0.83,-0.68l-0.12,-0.6l0.38,-0.97l0.01,-1.14l-0.08,-0.2l-1.39,-1.53l-0.25,-0.97l0.03,-0.57l-0.11,-0.25l-0.81,-0.66l-0.03,-1.34l-0.04,-0.14l-0.52,-0.98l-0.31,-0.15l-0.42,0.07l0.12,-0.44l0.63,-1.03l0.03,-0.23l-0.24,-0.88l0.69,-0.66l0.02,-0.41l-0.4,-0.46l0.58,-1.39l1.04,-1.71l1.97,0.16l0.32,-0.3l-0.12,-10.24l0.02,-0.8l2.59,-0.01l0.3,-0.3l0.0,-4.92l29.19,0.0l0.68,2.17l-0.4,0.35l-0.1,0.27l0.36,2.69l0.93,3.15l0.12,0.16l2.05,1.4l-0.99,1.15l-1.75,0.4l-0.15,0.08l-0.79,0.79l-0.08,0.17l-0.24,1.69l-1.07,3.75l-0.0,0.16l0.25,0.96l-0.38,2.1l-0.98,2.41l-1.52,1.3l-1.07,1.94l-0.25,0.99l-1.08,0.64l-0.13,0.18l-0.46,1.65Z", "name": "Sudan"}, "DO": {"path": "M241.7,234.97l0.15,-0.22l1.73,0.01l1.43,0.64l0.15,0.03l0.45,-0.04l0.36,0.74l0.28,0.17l1.02,-0.04l-0.04,0.43l0.27,0.33l1.03,0.09l0.91,0.7l-0.57,0.64l-0.99,-0.47l-0.16,-0.03l-1.11,0.11l-0.79,-0.12l-0.26,0.09l-0.38,0.4l-0.66,0.11l-0.28,-0.45l-0.38,-0.12l-0.83,0.37l-0.14,0.13l-0.85,1.49l-0.27,-0.17l-0.1,-0.58l0.05,-0.67l-0.07,-0.21l-0.44,-0.53l0.35,-0.25l0.12,-0.19l0.19,-1.0l-0.2,-1.4Z", "name": "Dominican Republic"}, "DJ": {"path": "M528.78,253.36l0.34,0.45l-0.06,0.76l-1.26,0.54l-0.05,0.53l0.82,0.53l-0.57,0.83l-0.3,-0.25l-0.27,-0.05l-0.56,0.17l-1.07,-0.03l-0.04,-0.56l-0.16,-0.56l0.76,-1.07l0.76,-0.97l0.89,0.18l0.25,-0.06l0.51,-0.42Z", "name": "Djibouti"}, "DK": {"path": "M452.4,129.07l-1.27,2.39l-2.25,-1.69l-0.26,-1.08l3.15,-1.0l0.63,1.39ZM447.87,126.25l-0.35,0.76l-0.47,-0.24l-0.38,0.09l-1.8,2.53l-0.03,0.29l0.56,1.4l-1.22,0.4l-1.68,-0.41l-0.92,-1.76l-0.07,-3.47l0.38,-0.88l0.62,-0.93l2.07,-0.21l0.19,-0.1l0.84,-0.95l1.5,-0.76l-0.06,1.26l-0.7,1.1l-0.03,0.25l0.3,1.0l0.18,0.19l1.06,0.42Z", "name": "Denmark"}, "DE": {"path": "M445.51,131.69l0.03,0.94l0.21,0.28l2.32,0.74l-0.02,1.0l0.37,0.3l2.55,-0.65l1.36,-0.89l2.63,1.27l1.09,1.01l0.51,1.51l-0.6,0.78l-0.0,0.36l0.88,1.17l0.58,1.68l-0.18,1.08l0.03,0.18l0.87,1.81l-0.66,0.2l-0.55,-0.32l-0.36,0.05l-0.58,0.58l-1.73,0.62l-0.99,0.84l-1.77,0.7l-0.16,0.4l0.42,0.94l0.26,1.34l0.14,0.2l1.25,0.76l1.22,1.2l-0.71,1.2l-0.81,0.37l-0.17,0.32l0.34,1.99l-0.04,0.09l-0.47,-0.39l-0.17,-0.07l-1.2,-0.1l-1.85,0.57l-2.15,-0.13l-0.29,0.18l-0.21,0.5l-0.96,-0.67l-0.24,-0.05l-0.67,0.16l-2.6,-0.94l-0.34,0.1l-0.42,0.57l-1.64,-0.02l0.26,-1.88l1.24,-2.15l-0.21,-0.45l-3.54,-0.58l-0.98,-0.71l0.12,-1.26l-0.05,-0.2l-0.44,-0.64l0.27,-2.18l-0.38,-3.14l1.17,-0.0l0.27,-0.17l0.63,-1.26l0.65,-3.17l-0.02,-0.17l-0.41,-1.0l0.32,-0.47l1.77,-0.16l0.37,0.6l0.47,0.06l1.7,-1.69l0.06,-0.33l-0.55,-1.24l-0.09,-1.51l1.5,0.36l0.16,-0.01l1.22,-0.4Z", "name": "Germany"}, "YE": {"path": "M553.53,242.65l-1.51,0.58l-0.17,0.16l-0.48,1.14l-0.07,0.79l-2.31,1.0l-3.98,1.19l-2.28,1.8l-0.97,0.12l-0.7,-0.14l-0.23,0.05l-1.42,1.03l-1.51,0.47l-2.07,0.13l-0.68,0.15l-0.17,0.1l-0.49,0.6l-0.57,0.16l-0.18,0.13l-0.3,0.49l-1.06,-0.05l-0.13,0.02l-0.73,0.32l-1.48,-0.11l-0.55,-1.26l0.07,-1.32l-0.04,-0.16l-0.39,-0.72l-0.48,-1.85l-0.52,-0.79l0.08,-0.02l0.22,-0.36l-0.23,-1.05l0.24,-0.39l0.04,-0.19l-0.09,-0.95l0.96,-0.72l0.11,-0.31l-0.23,-0.98l0.46,-0.88l0.75,0.49l0.26,0.03l0.63,-0.22l2.76,-0.06l0.5,0.25l2.42,0.26l0.85,-0.11l0.52,0.71l0.35,0.1l1.17,-0.43l0.15,-0.12l1.75,-2.64l2.22,-1.11l6.95,-0.96l2.55,5.58Z", "name": "Yemen"}, "AT": {"path": "M463.17,154.15l-0.14,0.99l-1.15,0.01l-0.24,0.47l0.39,0.56l-0.75,1.84l-0.36,0.4l-2.06,0.07l-0.14,0.04l-1.18,0.67l-1.96,-0.23l-3.43,-0.78l-0.5,-0.97l-0.33,-0.16l-2.47,0.55l-0.2,0.16l-0.18,0.37l-1.27,-0.38l-1.28,-0.09l-0.81,-0.41l0.25,-0.51l0.03,-0.18l-0.05,-0.28l0.35,-0.08l1.16,0.81l0.45,-0.13l0.27,-0.64l2.0,0.12l1.84,-0.57l1.05,0.09l0.71,0.59l0.47,-0.11l0.23,-0.54l0.02,-0.17l-0.32,-1.85l0.69,-0.31l0.13,-0.12l0.73,-1.23l1.61,0.89l0.35,-0.04l1.35,-1.27l0.7,-0.19l1.84,0.93l0.18,0.03l1.08,-0.15l0.81,0.43l-0.07,0.15l-0.02,0.2l0.24,1.06Z", "name": "Austria"}, "DZ": {"path": "M450.58,224.94l-8.31,4.86l-7.23,5.12l-3.46,1.13l-2.42,0.22l-0.02,-1.33l-0.2,-0.28l-1.15,-0.42l-1.45,-0.69l-0.55,-1.13l-0.1,-0.12l-8.45,-5.72l-17.72,-12.17l0.03,-0.38l-0.02,-3.21l3.84,-1.91l2.46,-0.41l2.1,-0.75l0.14,-0.11l0.9,-1.3l2.84,-1.06l0.19,-0.27l0.09,-1.81l1.21,-0.2l0.15,-0.07l1.06,-0.96l3.19,-0.46l0.23,-0.18l0.46,-1.08l-0.08,-0.34l-0.6,-0.54l-0.83,-2.85l-0.18,-1.8l-0.82,-1.57l2.13,-1.37l2.65,-0.49l0.13,-0.05l1.55,-1.15l2.34,-0.85l4.2,-0.51l4.07,-0.23l1.21,0.41l0.23,-0.01l2.3,-1.11l2.52,-0.02l0.94,0.62l0.2,0.05l1.25,-0.13l-0.36,1.03l-0.01,0.14l0.39,2.66l-0.56,2.2l-1.49,1.52l-0.08,0.24l0.22,2.12l0.11,0.2l1.94,1.58l0.02,0.54l0.12,0.23l1.45,1.06l1.04,4.85l0.81,2.42l0.13,1.19l-0.43,2.17l0.17,1.28l-0.31,1.53l0.2,1.56l-0.9,1.02l-0.01,0.38l1.43,1.88l0.09,1.06l0.04,0.13l0.89,1.48l0.37,0.12l1.03,-0.43l1.79,1.12l0.89,1.34Z", "name": "Algeria"}, "US": {"path": "M892.64,99.05l1.16,0.57l0.21,0.02l1.45,-0.38l1.92,0.99l2.17,0.47l-1.65,0.72l-1.75,-0.79l-0.93,-0.7l-0.21,-0.06l-2.11,0.22l-0.35,-0.2l0.09,-0.87ZM183.29,150.37l0.39,1.54l0.12,0.17l0.78,0.55l0.14,0.05l1.74,0.2l2.52,0.5l2.4,0.98l0.17,0.02l1.96,-0.4l3.01,0.81l0.91,-0.02l2.22,-0.88l4.67,2.33l3.86,2.01l0.21,0.71l0.15,0.18l0.33,0.17l-0.02,0.05l0.23,0.43l0.67,0.1l0.21,-0.05l0.1,-0.07l0.05,0.29l0.09,0.16l0.5,0.5l0.21,0.09l0.56,0.0l0.13,0.13l-0.2,0.36l0.12,0.41l2.49,1.39l0.99,5.24l-0.69,1.68l-1.16,1.64l-0.6,1.18l-0.06,0.31l0.04,0.22l0.28,0.43l0.11,0.1l0.85,0.47l0.15,0.04l0.63,0.0l0.14,-0.04l2.87,-1.58l2.6,-0.49l3.28,-1.5l0.17,-0.23l0.04,-0.43l-0.23,-0.93l-0.24,-0.39l0.74,-0.32l4.7,-0.01l0.25,-0.13l0.77,-1.15l2.9,-2.41l1.04,-0.52l8.35,-0.02l0.28,-0.21l0.2,-0.6l0.7,-0.14l1.06,-0.48l0.13,-0.11l0.92,-1.49l0.75,-2.39l1.67,-2.08l0.59,0.6l0.3,0.07l1.52,-0.49l0.88,0.72l-0.0,4.14l0.08,0.2l1.6,1.72l0.31,0.72l-2.42,1.35l-2.55,1.05l-2.64,0.9l-0.14,0.11l-1.33,1.81l-0.44,0.7l-0.05,0.15l-0.03,1.6l0.03,0.14l0.83,1.59l0.24,0.16l0.78,0.06l-1.15,0.33l-1.25,-0.04l-1.83,0.52l-2.51,0.29l-2.17,0.88l-0.17,0.36l0.33,0.22l3.55,-0.54l0.15,0.11l-2.87,0.73l-1.19,0.0l-0.16,-0.33l-0.36,0.06l-0.76,0.82l0.17,0.5l0.42,0.08l-0.45,1.75l-1.4,1.74l-0.04,-0.17l-0.21,-0.22l-0.48,-0.13l-0.77,-0.69l-0.36,-0.03l-0.12,0.34l0.52,1.58l0.09,0.14l0.52,0.43l0.03,0.87l-0.74,1.05l-0.39,0.63l0.05,-0.12l-0.08,-0.34l-1.19,-1.03l-0.28,-2.31l-0.26,-0.26l-0.32,0.19l-0.48,1.27l-0.01,0.19l0.39,1.33l-1.14,-0.31l-0.36,0.18l0.14,0.38l1.57,0.85l0.1,2.58l0.22,0.28l0.55,0.15l0.21,0.81l0.33,2.72l-1.46,1.94l-2.5,0.81l-0.12,0.07l-1.58,1.58l-1.15,0.17l-0.15,0.06l-1.27,1.03l-0.09,0.13l-0.32,0.85l-2.71,1.79l-1.45,1.37l-1.18,1.64l-0.05,0.12l-0.39,1.96l0.0,0.13l0.44,1.91l0.85,2.37l1.1,1.91l0.03,1.2l1.16,3.07l-0.08,1.74l-0.1,0.99l-0.57,1.48l-0.54,0.24l-0.97,-0.26l-0.34,-1.02l-0.12,-0.16l-0.89,-0.58l-2.44,-4.28l-0.34,-0.94l0.49,-1.71l-0.02,-0.21l-0.7,-1.5l-2.0,-2.35l-0.11,-0.08l-0.98,-0.42l-0.25,0.01l-2.42,1.19l-0.26,-0.08l-1.26,-1.29l-1.57,-0.68l-0.16,-0.02l-2.79,0.34l-2.18,-0.3l-1.98,0.19l-1.12,0.45l-0.14,0.44l0.4,0.65l-0.04,1.02l0.09,0.22l0.29,0.3l-0.06,0.05l-0.77,-0.33l-0.26,0.01l-0.87,0.48l-1.64,-0.08l-1.79,-1.39l-0.23,-0.06l-2.11,0.33l-1.75,-0.61l-0.14,-0.01l-1.61,0.2l-2.11,0.64l-0.11,0.06l-2.25,1.99l-2.53,1.21l-1.43,1.38l-0.58,1.22l-0.03,0.12l-0.03,1.86l0.13,1.32l0.3,0.62l-0.46,0.04l-1.71,-0.57l-1.85,-0.79l-0.63,-1.14l-0.54,-1.85l-0.07,-0.12l-1.45,-1.51l-0.86,-1.58l-1.26,-1.87l-0.09,-0.09l-1.76,-1.09l-0.17,-0.04l-2.05,0.05l-0.23,0.12l-1.44,1.97l-1.84,-0.72l-1.19,-0.76l-0.6,-1.45l-0.9,-1.52l-1.49,-1.21l-1.27,-0.87l-0.89,-0.96l-0.22,-0.1l-4.34,-0.0l-0.3,0.3l-0.0,0.84l-6.62,0.02l-5.66,-1.93l-3.48,-1.24l0.11,-0.25l-0.3,-0.42l-3.18,0.3l-2.6,0.2l-0.35,-1.19l-0.08,-0.13l-1.62,-1.61l-0.13,-0.08l-1.02,-0.29l-0.22,-0.66l-0.25,-0.2l-1.31,-0.13l-0.82,-0.7l-0.16,-0.07l-2.25,-0.27l-0.48,-0.34l-0.28,-1.44l-0.07,-0.14l-2.41,-2.84l-2.03,-3.89l0.08,-0.58l-0.1,-0.27l-1.08,-0.94l-1.87,-2.36l-0.33,-2.31l-0.07,-0.15l-1.24,-1.5l0.52,-2.4l-0.09,-2.57l-0.78,-2.3l0.96,-2.83l0.61,-5.66l-0.46,-4.26l-0.79,-2.71l-0.68,-1.4l0.13,-0.26l3.24,0.97l1.28,2.88l0.52,0.06l0.62,-0.84l0.06,-0.22l-0.4,-2.61l-0.74,-2.29l68.9,-0.0l0.3,-0.3l0.01,-0.95l0.32,-0.01ZM32.5,67.43l1.75,1.99l0.41,0.04l1.02,-0.81l3.79,0.25l-0.1,0.72l0.24,0.34l3.83,0.77l2.6,-0.44l5.21,1.41l4.84,0.43l1.9,0.57l0.15,0.01l3.25,-0.71l3.72,1.32l2.52,0.58l-0.03,38.14l0.29,0.3l2.41,0.11l2.34,1.0l1.7,1.59l2.22,2.42l0.42,0.03l2.41,-2.04l2.25,-1.08l1.23,1.76l1.71,1.53l2.24,1.62l1.54,2.56l2.56,4.09l0.11,0.11l4.1,2.17l0.06,1.93l-1.12,1.35l-1.22,-1.14l-2.08,-1.05l-0.68,-2.94l-0.09,-0.16l-3.18,-2.84l-1.32,-3.35l-0.25,-0.19l-2.43,-0.24l-3.93,-0.09l-2.85,-1.02l-5.24,-3.85l-6.77,-2.04l-3.52,0.3l-4.84,-1.7l-2.96,-1.6l-0.23,-0.02l-2.78,0.8l-0.21,0.35l0.46,2.31l-1.11,0.19l-2.9,0.78l-2.24,1.26l-2.42,0.68l-0.29,-1.79l1.07,-3.49l2.54,-1.11l0.12,-0.45l-0.69,-0.96l-0.41,-0.07l-3.19,2.12l-1.76,2.54l-3.57,2.62l-0.03,0.46l1.63,1.59l-2.14,2.38l-2.64,1.49l-2.49,1.09l-0.16,0.17l-0.58,1.48l-3.8,1.79l-0.14,0.14l-0.75,1.57l-2.75,1.41l-1.62,-0.25l-0.16,0.02l-2.35,0.98l-2.54,1.19l-2.06,1.15l-4.05,0.93l-0.1,-0.15l2.45,-1.45l2.49,-1.1l2.61,-1.88l3.03,-0.39l0.19,-0.1l1.2,-1.41l3.43,-2.11l0.61,-0.75l1.81,-1.24l0.13,-0.2l0.42,-2.7l1.24,-2.12l-0.03,-0.35l-0.34,-0.09l-2.73,1.05l-0.67,-0.53l-0.39,0.02l-1.13,1.11l-1.43,-1.62l-0.49,0.06l-0.41,0.8l-0.67,-1.31l-0.42,-0.12l-2.43,1.43l-1.18,-0.0l-0.18,-1.86l0.43,-1.3l-0.09,-0.33l-1.61,-1.33l-0.26,-0.06l-3.11,0.68l-2.0,-1.66l-1.61,-0.85l-0.01,-1.97l-0.11,-0.23l-1.76,-1.48l0.86,-1.96l2.01,-2.13l0.88,-1.94l1.79,-0.25l1.65,0.6l0.31,-0.06l1.91,-1.8l1.67,0.31l0.22,-0.04l1.91,-1.23l0.13,-0.33l-0.47,-1.82l-0.15,-0.19l-1.0,-0.52l1.51,-1.27l0.09,-0.34l-0.29,-0.19l-1.62,0.06l-2.66,0.88l-0.13,0.09l-0.62,0.72l-1.77,-0.8l-0.16,-0.02l-3.48,0.44l-3.5,-0.92l-1.06,-1.61l-2.78,-2.09l3.07,-1.51l5.52,-2.01l1.65,0.0l-0.28,1.73l0.31,0.35l5.29,-0.16l0.23,-0.49l-2.03,-2.59l-0.1,-0.08l-3.03,-1.58l-1.79,-2.12l-2.4,-1.83l-3.18,-1.27l1.13,-1.84l4.28,-0.14l0.15,-0.05l3.16,-2.0l0.13,-0.17l0.57,-2.07l2.43,-2.02l2.42,-0.52l4.67,-1.98l2.22,0.29l0.2,-0.04l3.74,-2.37l3.57,0.91ZM37.66,123.49l-2.31,1.26l-1.04,-0.75l-0.31,-1.35l2.06,-1.16l1.24,-0.51l1.48,0.22l0.76,0.81l-1.89,1.49ZM30.89,233.84l1.2,0.57l0.35,0.3l0.48,0.69l-1.6,0.86l-0.3,0.31l-0.24,-0.14l0.05,-0.54l-0.02,-0.15l-0.36,-0.83l0.05,-0.12l0.39,-0.38l0.07,-0.31l-0.09,-0.27ZM29.06,231.89l0.5,0.14l0.31,0.19l-0.46,0.1l-0.34,-0.43ZM25.02,230.13l0.2,-0.11l0.4,0.47l-0.43,-0.05l-0.17,-0.31ZM21.29,228.68l0.1,-0.07l0.22,0.02l0.02,0.21l-0.02,0.02l-0.32,-0.18ZM6.0,113.33l-1.19,0.45l-1.5,-0.64l-0.94,-0.63l1.76,-0.46l1.71,0.29l0.16,0.98Z", "name": "United States of America"}, "LV": {"path": "M473.99,127.16l0.07,-2.15l1.15,-2.11l2.05,-1.07l1.84,2.48l0.25,0.12l2.01,-0.07l0.29,-0.25l0.45,-2.58l1.85,-0.56l0.98,0.4l2.13,1.33l0.16,0.05l1.97,0.01l1.02,0.7l0.21,1.67l0.71,1.84l-2.44,1.23l-1.36,0.53l-2.28,-1.62l-0.12,-0.05l-1.18,-0.2l-0.28,-0.6l-0.31,-0.17l-2.43,0.35l-4.17,-0.23l-0.12,0.02l-2.45,0.93Z", "name": "Latvia"}, "UY": {"path": "M276.9,363.17l1.3,-0.23l2.4,2.04l0.22,0.07l0.82,-0.07l2.48,1.7l1.93,1.5l1.28,1.67l-0.95,1.14l-0.04,0.31l0.63,1.45l-0.96,1.57l-2.65,1.47l-1.73,-0.53l-0.15,-0.01l-1.25,0.28l-2.22,-1.16l-0.16,-0.03l-1.56,0.08l-1.33,-1.36l0.17,-1.58l0.48,-0.55l0.07,-0.2l-0.02,-2.74l0.66,-2.8l0.57,-2.02Z", "name": "Uruguay"}, "LB": {"path": "M510.44,198.11l-0.48,0.03l-0.26,0.17l-0.15,0.32l-0.21,-0.0l0.72,-1.85l1.19,-1.9l0.74,0.09l0.27,0.73l-1.19,0.93l-0.09,0.13l-0.54,1.36Z", "name": "Lebanon"}, "LA": {"path": "M684.87,248.8l0.61,-0.86l0.05,-0.16l0.11,-2.17l-0.08,-0.22l-1.96,-2.16l-0.15,-2.44l-0.08,-0.18l-1.9,-2.1l-0.19,-0.1l-1.89,-0.18l-0.29,0.15l-0.42,0.76l-1.21,0.06l-0.67,-0.41l-0.31,-0.0l-2.2,1.29l-0.05,-1.77l0.61,-2.7l-0.27,-0.37l-1.44,-0.1l-0.12,-1.31l-0.12,-0.21l-0.87,-0.65l0.38,-0.68l1.76,-1.41l0.08,0.22l0.27,0.2l1.33,0.07l0.31,-0.34l-0.35,-2.75l0.85,-0.25l1.32,1.88l1.11,2.36l0.27,0.17l2.89,0.02l0.78,1.82l-1.32,0.56l-0.12,0.09l-0.72,0.93l0.1,0.45l2.93,1.52l3.62,5.27l1.88,1.78l0.58,1.67l-0.38,2.11l-1.87,-0.79l-0.37,0.11l-0.99,1.54l-1.51,-0.73Z", "name": "Laos"}, "TW": {"path": "M725.6,222.5l-1.5,4.22l-0.82,1.65l-1.01,-1.7l-0.26,-1.8l1.4,-2.48l1.8,-1.81l0.76,0.53l-0.38,1.39Z", "name": "Taiwan"}, "TT": {"path": "M266.35,259.46l0.41,-0.39l0.09,-0.23l-0.04,-0.75l1.14,-0.26l0.2,0.03l-0.07,1.37l-1.73,0.23Z", "name": "Trinidad and Tobago"}, "TR": {"path": "M513.25,175.38l3.63,1.17l0.14,0.01l2.88,-0.45l2.11,0.26l0.18,-0.03l2.9,-1.53l2.51,-0.13l2.25,1.37l0.36,0.88l-0.23,1.36l0.19,0.33l1.81,0.72l0.61,0.53l-1.31,0.64l-0.16,0.34l0.76,3.24l-0.44,0.8l0.01,0.3l1.19,2.02l-0.71,0.29l-0.74,-0.62l-0.15,-0.07l-2.91,-0.37l-0.15,0.02l-1.04,0.43l-2.78,0.44l-1.44,-0.03l-2.83,1.06l-1.95,0.01l-1.28,-0.52l-0.2,-0.01l-2.62,0.76l-0.7,-0.48l-0.47,0.22l-0.13,1.49l-1.01,0.94l-0.58,-0.82l0.79,-0.9l0.04,-0.34l-0.31,-0.15l-1.46,0.23l-2.03,-0.64l-0.3,0.07l-1.65,1.58l-3.58,0.3l-1.94,-1.47l-0.17,-0.06l-2.7,-0.1l-0.28,0.17l-0.51,1.06l-1.47,0.29l-2.32,-1.46l-0.17,-0.05l-2.55,0.05l-1.4,-2.7l-1.72,-1.54l1.11,-2.06l-0.07,-0.37l-1.35,-1.19l2.47,-2.51l3.74,-0.11l0.26,-0.17l0.96,-2.07l4.56,0.38l0.19,-0.05l2.97,-1.92l2.84,-0.83l4.03,-0.06l4.31,2.08ZM488.85,176.8l-1.81,1.38l-0.57,-1.01l0.02,-0.36l0.45,-0.25l0.13,-0.15l0.78,-1.87l-0.11,-0.37l-0.72,-0.47l1.91,-0.71l1.89,0.35l0.25,0.97l0.17,0.2l1.87,0.83l-0.19,0.31l-2.82,0.16l-0.18,0.07l-1.06,0.91Z", "name": "Turkey"}, "LK": {"path": "M625.44,266.07l-0.35,2.4l-0.9,0.61l-1.91,0.5l-1.04,-1.75l-0.43,-3.5l1.0,-3.6l1.34,1.09l1.13,1.72l1.16,2.52Z", "name": "Sri Lanka"}, "TN": {"path": "M444.91,206.18l-0.99,-4.57l-0.12,-0.18l-1.43,-1.04l-0.02,-0.53l-0.11,-0.22l-1.95,-1.59l-0.19,-1.85l1.44,-1.47l0.08,-0.14l0.59,-2.34l-0.38,-2.77l0.44,-1.28l2.52,-1.08l1.41,0.28l-0.06,1.2l0.43,0.28l1.81,-0.9l0.02,0.06l-1.14,1.28l-0.08,0.2l-0.02,1.32l0.11,0.24l0.74,0.6l-0.29,2.18l-1.56,1.35l-0.09,0.32l0.48,1.54l0.28,0.21l1.11,0.04l0.55,1.17l0.15,0.14l0.76,0.35l-0.12,1.79l-1.1,0.72l-0.8,0.91l-1.68,1.04l-0.13,0.32l0.25,1.08l-0.18,0.96l-0.74,0.39Z", "name": "Tunisia"}, "TL": {"path": "M734.21,307.22l0.17,-0.34l1.99,-0.52l1.72,-0.08l0.78,-0.3l0.29,0.1l-0.43,0.32l-2.57,1.09l-1.71,0.59l-0.05,-0.49l-0.19,-0.36Z", "name": "East Timor"}, "TM": {"path": "M553.16,173.51l-0.12,1.0l-0.26,-0.65l0.38,-0.34ZM553.54,173.16l0.13,-0.12l0.43,-0.09l-0.56,0.21ZM555.68,172.6l0.65,-0.14l1.53,0.76l1.71,2.29l0.27,0.12l1.27,-0.14l2.81,-0.04l0.29,-0.38l-0.35,-1.27l1.98,-0.97l1.96,-1.63l3.05,1.44l0.25,2.23l0.14,0.22l0.96,0.61l0.18,0.05l2.61,-0.13l0.68,0.44l1.2,2.97l0.1,0.13l2.85,2.03l1.67,1.41l2.66,1.45l3.13,1.17l-0.05,1.23l-0.36,-0.04l-1.12,-0.73l-0.44,0.14l-0.34,0.89l-1.96,0.52l-0.22,0.23l-0.47,2.17l-1.26,0.78l-1.93,0.42l-0.21,0.18l-0.46,1.14l-1.64,0.33l-2.3,-0.97l-0.2,-2.23l-0.28,-0.27l-1.76,-0.1l-2.78,-2.48l-0.15,-0.07l-1.95,-0.31l-2.82,-1.48l-1.78,-0.27l-0.18,0.03l-1.03,0.51l-1.6,-0.08l-0.22,0.08l-1.72,1.6l-1.83,0.46l-0.39,-1.7l0.36,-3.0l-0.16,-0.3l-1.73,-0.88l0.57,-1.77l-0.25,-0.39l-1.33,-0.14l0.41,-1.85l2.05,0.63l0.21,-0.01l2.2,-0.95l0.09,-0.49l-1.78,-1.75l-0.69,-1.66l-0.07,-0.03Z", "name": "Turkmenistan"}, "TJ": {"path": "M597.99,178.71l-0.23,0.23l-2.57,-0.47l-0.35,0.25l-0.24,1.7l0.32,0.34l2.66,-0.22l3.15,0.95l4.47,-0.42l0.58,2.45l0.39,0.21l0.71,-0.25l1.22,0.53l-0.06,1.01l0.29,1.28l-2.19,-0.0l-1.71,-0.21l-0.23,0.07l-1.51,1.25l-1.05,0.27l-0.77,0.51l-0.71,-0.67l0.22,-2.28l-0.24,-0.32l-0.43,-0.08l0.17,-0.57l-0.16,-0.36l-1.36,-0.66l-0.34,0.05l-1.08,1.01l-0.09,0.15l-0.25,1.09l-0.24,0.26l-1.36,-0.05l-0.27,0.14l-0.65,1.06l-0.58,-0.39l-0.3,-0.02l-1.68,0.86l-0.36,-0.16l1.28,-2.65l0.02,-0.2l-0.54,-2.17l-0.18,-0.21l-1.53,-0.58l0.41,-0.82l1.89,0.13l0.26,-0.12l1.19,-1.63l0.77,-1.82l2.66,-0.55l-0.33,0.87l0.01,0.23l0.36,0.82l0.3,0.18l0.23,-0.02Z", "name": "Tajikistan"}, "LS": {"path": "M493.32,359.69l0.69,0.65l-0.65,1.12l-0.38,0.8l-1.27,0.39l-0.18,0.15l-0.4,0.77l-0.59,0.18l-1.59,-1.78l1.16,-1.5l1.3,-1.02l0.97,-0.46l0.94,0.72Z", "name": "Lesotho"}, "TH": {"path": "M677.42,253.68l-1.7,-0.88l-0.14,-0.03l-1.77,0.04l0.3,-1.64l-0.3,-0.35l-2.21,0.01l-0.3,0.28l-0.2,2.76l-2.15,5.9l-0.02,0.13l0.17,1.83l0.28,0.27l1.45,0.07l0.93,2.1l0.44,2.15l0.08,0.15l1.4,1.44l0.16,0.09l1.43,0.27l1.04,1.05l-0.58,0.73l-1.24,0.22l-0.15,-0.99l-0.15,-0.22l-2.04,-1.1l-0.36,0.06l-0.23,0.23l-0.72,-0.71l-0.41,-1.18l-0.06,-0.11l-1.33,-1.42l-1.22,-1.2l-0.5,0.13l-0.15,0.54l-0.14,-0.41l0.26,-1.48l0.73,-2.38l1.2,-2.57l1.37,-2.35l0.02,-0.27l-0.95,-2.26l0.03,-1.19l-0.29,-1.42l-0.06,-0.13l-1.65,-2.0l-0.46,-0.99l0.62,-0.34l0.13,-0.15l0.92,-2.23l-0.02,-0.27l-1.05,-1.74l-1.57,-1.86l-1.04,-1.96l0.76,-0.34l0.16,-0.16l1.07,-2.63l1.58,-0.1l0.16,-0.06l1.43,-1.11l1.24,-0.52l0.84,0.62l0.13,1.43l0.28,0.27l1.34,0.09l-0.54,2.39l0.05,2.39l0.45,0.25l2.48,-1.45l0.6,0.36l0.17,0.04l1.47,-0.07l0.25,-0.15l0.41,-0.73l1.58,0.15l1.76,1.93l0.15,2.44l0.08,0.18l1.94,2.15l-0.1,1.96l-0.66,0.93l-2.25,-0.34l-3.24,0.49l-0.19,0.12l-1.6,2.12l-0.06,0.24l0.48,2.46Z", "name": "Thailand"}, "TF": {"path": "M593.76,417.73l1.38,0.84l2.15,0.37l0.04,0.31l-0.59,1.24l-3.36,0.19l-0.05,-1.38l0.43,-1.56Z", "name": "French Southern and Antarctic Lands"}, "TG": {"path": "M425.23,269.29l-1.49,0.4l-0.43,-0.68l-0.64,-1.54l-0.18,-1.16l0.54,-2.21l-0.04,-0.24l-0.59,-0.86l-0.23,-1.9l0.0,-1.82l-0.07,-0.19l-0.95,-1.19l0.1,-0.41l1.58,0.04l-0.23,0.97l0.08,0.28l1.55,1.55l0.09,1.13l0.08,0.19l0.42,0.43l-0.11,5.66l0.52,1.53Z", "name": "Togo"}, "TD": {"path": "M457.57,252.46l0.23,-1.08l-0.28,-0.36l-1.32,-0.05l0.0,-1.35l-0.1,-0.22l-0.9,-0.82l0.99,-3.1l3.12,-2.37l0.12,-0.23l0.13,-3.33l0.95,-5.2l0.53,-1.09l-0.07,-0.36l-0.94,-0.81l-0.03,-0.7l-0.12,-0.23l-0.84,-0.61l-0.57,-3.76l2.21,-1.26l19.67,9.88l0.12,9.74l-1.83,-0.15l-0.28,0.14l-1.14,1.89l-0.68,1.62l0.05,0.31l0.33,0.38l-0.61,0.58l-0.08,0.3l0.25,0.93l-0.58,0.95l-0.29,1.01l0.34,0.37l0.67,-0.11l0.39,0.73l0.03,1.4l0.11,0.23l0.8,0.65l-0.01,0.24l-1.38,0.37l-0.11,0.06l-1.27,1.03l-1.83,2.76l-2.21,1.1l-2.34,-0.15l-0.82,0.25l-0.2,0.37l0.19,0.68l-1.16,0.79l-1.01,0.94l-2.92,0.89l-0.5,-0.46l-0.17,-0.08l-0.41,-0.05l-0.28,0.12l-0.38,0.54l-1.36,0.12l0.1,-0.18l0.01,-0.27l-0.78,-1.72l-0.35,-1.03l-0.17,-0.18l-1.03,-0.41l-1.29,-1.28l0.36,-0.78l0.9,0.2l0.14,-0.0l0.67,-0.17l1.36,0.02l0.26,-0.45l-1.32,-2.22l0.09,-1.64l-0.17,-1.68l-0.04,-0.13l-0.93,-1.53Z", "name": "Chad"}, "LY": {"path": "M457.99,226.38l-1.57,0.87l-1.25,-1.28l-0.13,-0.08l-3.85,-1.11l-1.04,-1.57l-0.09,-0.09l-1.98,-1.23l-0.27,-0.02l-0.93,0.39l-0.72,-1.2l-0.09,-1.07l-0.06,-0.16l-1.33,-1.75l0.83,-0.94l0.07,-0.24l-0.21,-1.64l0.31,-1.43l-0.17,-1.29l0.43,-2.26l-0.15,-1.33l-0.73,-2.18l0.99,-0.52l0.16,-0.21l0.22,-1.16l-0.22,-1.06l1.54,-0.95l0.81,-0.92l1.19,-0.78l0.14,-0.23l0.12,-1.76l2.57,0.84l0.16,0.01l0.99,-0.23l2.01,0.45l3.19,1.2l1.12,2.36l0.2,0.16l2.24,0.53l3.5,1.14l2.65,1.36l0.29,-0.01l1.22,-0.71l1.27,-1.32l0.07,-0.29l-0.55,-2.0l0.69,-1.19l1.7,-1.23l1.61,-0.35l3.2,0.54l0.78,1.14l0.24,0.13l0.85,0.01l0.84,0.47l2.35,0.31l0.42,0.63l-0.79,1.16l-0.04,0.26l0.35,1.08l-0.61,1.6l-0.0,0.2l0.73,2.16l0.0,24.24l-2.58,0.01l-0.3,0.29l-0.02,0.62l-19.55,-9.83l-0.28,0.01l-2.53,1.44Z", "name": "Libya"}, "AE": {"path": "M550.59,223.8l0.12,0.08l1.92,-0.41l3.54,0.15l0.23,-0.09l1.71,-1.79l1.86,-1.7l1.31,-1.36l0.26,0.5l0.28,1.72l-0.93,0.01l-0.3,0.26l-0.21,1.73l0.11,0.27l0.08,0.06l-0.7,0.32l-0.17,0.27l-0.01,0.99l-0.68,1.02l-0.05,0.15l-0.06,0.96l-0.32,0.36l-7.19,-1.27l-0.79,-2.22Z", "name": "United Arab Emirates"}, "VE": {"path": "M240.66,256.5l0.65,0.91l-0.03,1.13l-1.05,1.39l-0.03,0.31l0.95,2.0l0.32,0.17l1.08,-0.16l0.24,-0.21l0.56,-1.83l-0.06,-0.29l-0.71,-0.81l-0.1,-1.58l2.9,-0.96l0.19,-0.37l-0.29,-1.02l0.45,-0.41l0.72,1.43l0.26,0.16l1.65,0.04l1.46,1.27l0.08,0.72l0.3,0.27l2.28,0.02l2.55,-0.25l1.34,1.06l0.14,0.06l1.92,0.31l0.2,-0.03l1.4,-0.79l0.15,-0.25l0.02,-0.36l2.82,-0.14l1.17,-0.01l-0.41,0.14l-0.14,0.46l0.86,1.19l0.22,0.12l1.93,0.18l1.73,1.13l0.37,1.9l0.31,0.24l1.21,-0.05l0.52,0.32l-1.63,1.21l-0.11,0.17l-0.22,0.92l0.07,0.27l0.63,0.69l-0.31,0.24l-1.48,0.39l-0.22,0.3l0.04,1.03l-0.59,0.6l-0.01,0.41l1.67,1.87l0.23,0.48l-0.72,0.76l-2.71,0.91l-1.78,0.39l-0.13,0.06l-0.6,0.49l-1.84,-0.58l-1.89,-0.33l-0.18,0.03l-0.47,0.23l-0.02,0.53l0.96,0.56l-0.08,1.58l0.35,1.58l0.26,0.23l1.91,0.19l0.02,0.07l-1.54,0.62l-0.18,0.2l-0.25,0.92l-0.88,0.35l-1.85,0.58l-0.16,0.13l-0.4,0.64l-1.66,0.14l-1.22,-1.18l-0.79,-2.52l-0.67,-0.88l-0.66,-0.43l0.99,-0.98l0.09,-0.26l-0.09,-0.56l-0.08,-0.16l-0.66,-0.69l-0.47,-1.54l0.18,-1.67l0.55,-0.85l0.45,-1.35l-0.15,-0.36l-0.89,-0.43l-0.19,-0.02l-1.39,0.28l-1.76,-0.13l-0.92,0.23l-1.64,-2.01l-0.17,-0.1l-1.54,-0.33l-3.05,0.23l-0.5,-0.73l-0.15,-0.12l-0.45,-0.15l-0.05,-0.28l0.28,-0.86l0.01,-0.15l-0.2,-1.01l-0.08,-0.15l-0.5,-0.5l-0.3,-1.08l-0.25,-0.22l-0.89,-0.12l0.54,-1.18l0.29,-1.73l0.66,-0.85l0.94,-0.7l0.09,-0.11l0.3,-0.6Z", "name": "Venezuela"}, "AF": {"path": "M574.42,192.1l2.24,0.95l0.18,0.02l1.89,-0.38l0.22,-0.18l0.46,-1.14l1.82,-0.4l1.5,-0.91l0.14,-0.19l0.46,-2.12l1.93,-0.51l0.2,-0.18l0.26,-0.68l0.87,0.57l0.13,0.05l0.79,0.09l1.35,0.02l1.83,0.59l0.75,0.34l0.26,-0.01l1.66,-0.85l0.7,0.46l0.42,-0.09l0.72,-1.17l1.32,0.05l0.23,-0.1l0.39,-0.43l0.07,-0.14l0.24,-1.08l0.86,-0.81l0.94,0.46l-0.2,0.64l0.23,0.38l0.49,0.09l-0.21,2.15l0.09,0.25l0.99,0.94l0.38,0.03l0.83,-0.57l1.06,-0.27l0.12,-0.06l1.46,-1.21l1.63,0.2l2.4,0.0l0.17,0.32l-1.12,0.25l-1.23,0.52l-2.86,0.33l-2.69,0.6l-0.13,0.06l-1.46,1.25l-0.07,0.36l0.58,1.18l0.25,1.21l-1.13,1.08l-0.09,0.25l0.09,0.98l-0.53,0.79l-2.22,-0.08l-0.28,0.44l0.83,1.57l-1.3,0.58l-0.13,0.11l-1.06,1.69l-0.05,0.18l0.13,1.51l-0.73,0.58l-0.78,-0.22l-0.14,-0.01l-1.91,0.36l-0.23,0.19l-0.2,0.57l-1.65,-0.0l-0.22,0.1l-1.4,1.56l-0.08,0.19l-0.08,2.13l-2.99,1.05l-1.67,-0.23l-0.27,0.1l-0.39,0.46l-1.43,-0.31l-2.43,0.4l-3.69,-1.23l1.96,-2.15l0.08,-0.24l-0.21,-1.78l-0.23,-0.26l-1.69,-0.42l-0.19,-1.62l-0.77,-2.08l0.98,-1.41l-0.14,-0.45l-0.82,-0.31l0.6,-1.79l0.93,-3.21Z", "name": "Afghanistan"}, "IQ": {"path": "M534.42,190.89l0.13,0.14l1.5,0.78l0.15,1.34l-1.13,0.87l-0.11,0.16l-0.58,2.2l0.04,0.24l1.73,2.67l0.12,0.1l2.99,1.49l1.18,1.94l-0.39,1.89l0.29,0.36l0.5,-0.0l0.02,1.17l0.08,0.2l0.83,0.86l-2.36,-0.29l-0.29,0.13l-1.74,2.49l-4.4,-0.21l-7.03,-5.49l-3.73,-1.94l-2.92,-0.74l-0.89,-3.0l5.33,-2.81l0.15,-0.19l0.95,-3.43l-0.2,-2.0l1.19,-0.61l0.11,-0.09l1.23,-1.73l0.92,-0.38l2.75,0.35l0.81,0.68l0.31,0.05l0.94,-0.38l1.5,3.17Z", "name": "Iraq"}, "IS": {"path": "M384.26,87.96l-0.51,2.35l0.08,0.28l2.61,2.58l-2.99,2.83l-7.16,2.72l-2.08,0.7l-9.51,-1.71l1.89,-1.36l-0.07,-0.53l-4.4,-1.59l3.33,-0.59l0.25,-0.32l-0.11,-1.2l-0.25,-0.27l-4.82,-0.88l1.38,-2.2l3.54,-0.57l3.8,2.74l0.33,0.01l3.68,-2.18l3.02,1.12l0.25,-0.02l4.01,-2.18l3.72,0.27Z", "name": "Iceland"}, "IR": {"path": "M556.2,187.5l2.05,-0.52l0.13,-0.07l1.69,-1.57l1.55,0.08l0.15,-0.03l1.02,-0.5l1.64,0.25l2.82,1.48l1.91,0.3l2.8,2.49l0.18,0.08l1.61,0.09l0.19,2.09l-1.0,3.47l-0.69,2.04l0.18,0.38l0.73,0.28l-0.85,1.22l-0.04,0.28l0.81,2.19l0.19,1.72l0.23,0.26l1.69,0.42l0.17,1.43l-2.18,2.39l-0.01,0.4l1.22,1.42l1.0,1.62l0.12,0.11l2.23,1.11l0.06,2.2l0.2,0.27l1.03,0.38l0.14,0.83l-3.38,1.3l-0.18,0.19l-0.87,2.85l-4.44,-0.76l-2.75,-0.62l-2.64,-0.32l-1.01,-3.11l-0.17,-0.19l-1.2,-0.48l-0.18,-0.01l-1.99,0.51l-2.42,1.25l-2.89,-0.84l-2.48,-2.03l-2.41,-0.79l-1.61,-2.47l-1.84,-3.63l-0.36,-0.15l-1.22,0.4l-1.48,-0.84l-0.37,0.06l-0.72,0.82l-1.08,-1.12l-0.02,-1.35l-0.3,-0.29l-0.43,0.0l0.34,-1.64l-0.04,-0.22l-1.29,-2.11l-0.12,-0.11l-3.0,-1.49l-1.62,-2.49l0.52,-1.98l1.18,-0.92l0.11,-0.27l-0.19,-1.66l-0.16,-0.23l-1.55,-0.81l-1.58,-3.33l-1.3,-2.2l0.41,-0.75l0.03,-0.21l-0.73,-3.12l1.2,-0.59l0.35,0.9l1.26,1.35l0.15,0.09l1.81,0.39l0.91,-0.09l0.15,-0.06l2.9,-2.13l0.7,-0.16l0.48,0.56l-0.75,1.26l0.05,0.37l1.56,1.53l0.28,0.08l0.37,-0.09l0.7,1.89l0.21,0.19l2.31,0.59l1.69,1.4l0.15,0.07l3.66,0.49l3.91,-0.76l0.23,-0.19l0.19,-0.52Z", "name": "Iran"}, "AM": {"path": "M530.51,176.08l2.91,-0.39l0.41,0.63l0.11,0.1l0.66,0.36l-0.32,0.47l0.07,0.41l1.1,0.84l-0.53,0.7l0.06,0.42l1.06,0.8l1.01,0.44l0.04,1.56l-0.44,0.04l-0.88,-1.46l0.01,-0.37l-0.3,-0.31l-0.98,0.01l-0.65,-0.69l-0.26,-0.09l-0.38,0.06l-0.97,-0.82l-1.64,-0.65l0.2,-1.2l-0.02,-0.16l-0.28,-0.69Z", "name": "Armenia"}, "IT": {"path": "M451.68,158.58l0.2,0.16l3.3,0.75l-0.22,1.26l0.02,0.18l0.35,0.78l-1.4,-0.32l-0.21,0.03l-2.04,1.1l-0.16,0.29l0.13,1.47l-0.29,0.82l0.02,0.24l0.82,1.57l0.1,0.11l2.28,1.5l1.29,2.53l2.79,2.43l0.2,0.07l1.83,-0.02l0.31,0.34l-0.46,0.39l0.06,0.5l4.06,1.97l2.06,1.49l0.17,0.36l-0.24,0.53l-1.08,-1.07l-0.15,-0.08l-2.18,-0.49l-0.33,0.15l-1.05,1.91l0.11,0.4l1.63,0.98l-0.22,1.12l-0.84,0.14l-0.22,0.15l-1.27,2.38l-0.54,0.12l0.01,-0.47l0.48,-1.46l0.5,-0.58l0.03,-0.35l-0.97,-1.69l-0.76,-1.48l-0.17,-0.15l-0.94,-0.33l-0.68,-1.18l-0.16,-0.13l-1.53,-0.52l-1.03,-1.14l-0.19,-0.1l-1.78,-0.19l-1.88,-1.3l-2.27,-1.94l-1.64,-1.68l-0.76,-2.94l-0.21,-0.21l-1.22,-0.35l-2.01,-1.0l-0.24,-0.01l-1.15,0.42l-0.11,0.07l-1.38,1.36l-0.5,0.11l0.19,-0.87l-0.21,-0.35l-1.19,-0.34l-0.56,-2.06l0.76,-0.82l0.03,-0.36l-0.68,-1.08l0.04,-0.31l0.68,0.42l0.19,0.04l1.21,-0.15l0.14,-0.06l1.18,-0.89l0.25,0.29l0.25,0.1l1.19,-0.1l0.25,-0.18l0.45,-1.04l1.61,0.34l0.19,-0.02l1.1,-0.53l0.17,-0.22l0.15,-0.95l1.19,0.35l0.35,-0.16l0.23,-0.47l2.11,-0.47l0.45,0.89ZM459.35,184.63l-0.71,1.81l0.0,0.23l0.33,0.79l-0.37,1.03l-1.6,-0.91l-1.33,-0.34l-3.24,-1.36l0.23,-0.99l2.73,0.24l3.95,-0.5ZM443.95,175.91l1.26,1.77l-0.31,3.47l-0.82,-0.13l-0.26,0.08l-0.83,0.79l-0.64,-0.52l-0.1,-3.42l-0.44,-1.34l0.91,0.1l0.21,-0.06l1.01,-0.74Z", "name": "Italy"}, "VN": {"path": "M690.8,230.21l-2.86,1.93l-2.09,2.46l-0.06,0.11l-0.55,1.8l0.04,0.26l4.26,6.1l2.31,1.63l1.46,1.97l1.12,4.62l-0.32,4.3l-1.97,1.57l-2.85,1.62l-2.09,2.14l-2.83,2.13l-0.67,-1.19l0.65,-1.58l-0.09,-0.35l-1.47,-1.14l1.67,-0.79l2.57,-0.18l0.22,-0.47l-0.89,-1.24l3.88,-1.8l0.17,-0.24l0.31,-3.05l-0.01,-0.13l-0.56,-1.63l0.44,-2.48l-0.01,-0.15l-0.63,-1.81l-0.08,-0.12l-1.87,-1.77l-3.64,-5.3l-0.11,-0.1l-2.68,-1.39l0.45,-0.59l1.53,-0.65l0.16,-0.39l-0.97,-2.27l-0.27,-0.18l-2.89,-0.02l-1.04,-2.21l-1.28,-1.83l0.96,-0.46l1.97,0.01l2.43,-0.3l0.13,-0.05l1.95,-1.29l1.04,0.85l0.13,0.06l1.98,0.42l-0.32,1.21l0.09,0.3l1.19,1.07l0.12,0.07l1.88,0.51Z", "name": "Vietnam"}, "AR": {"path": "M258.11,341.34l1.4,1.81l0.51,-0.06l0.89,-1.94l2.51,0.1l0.36,0.49l4.6,4.31l0.15,0.08l1.99,0.39l3.01,1.93l2.5,1.01l0.28,0.91l-2.4,3.97l0.17,0.44l2.57,0.74l2.81,0.41l2.09,-0.44l0.14,-0.07l2.27,-2.06l0.09,-0.17l0.38,-2.2l0.88,-0.36l1.05,1.29l-0.04,1.88l-1.98,1.4l-1.72,1.13l-2.84,2.65l-3.34,3.73l-0.07,0.12l-0.63,2.22l-0.67,2.85l0.02,2.73l-0.47,0.54l-0.07,0.17l-0.36,3.28l0.12,0.27l3.03,2.32l-0.31,1.78l0.11,0.29l1.44,1.15l-0.11,1.17l-2.32,3.57l-3.59,1.51l-4.95,0.6l-2.72,-0.29l-0.32,0.38l0.5,1.67l-0.49,2.13l0.01,0.16l0.4,1.29l-1.27,0.88l-2.41,0.39l-2.33,-1.05l-0.31,0.04l-0.97,0.78l-0.11,0.27l0.35,2.98l0.16,0.23l1.69,0.91l0.31,-0.02l1.08,-0.75l0.46,0.96l-2.1,0.88l-2.01,1.89l-0.09,0.18l-0.36,3.05l-0.51,1.42l-2.16,0.01l-0.19,0.07l-1.96,1.59l-0.1,0.15l-0.72,2.34l0.08,0.31l2.46,2.31l0.13,0.07l2.09,0.56l-0.74,2.45l-2.86,1.75l-0.12,0.14l-1.59,3.71l-2.2,1.24l-0.1,0.09l-1.03,1.54l-0.04,0.23l0.81,3.45l0.06,0.13l1.13,1.32l-2.59,-0.57l-5.89,-0.44l-0.92,-1.73l0.05,-2.4l-0.34,-0.3l-1.49,0.19l-0.72,-0.98l-0.2,-3.21l1.79,-1.33l0.1,-0.13l0.79,-2.04l0.02,-0.16l-0.27,-1.52l1.31,-2.69l0.91,-4.15l-0.23,-1.72l0.91,-0.49l0.15,-0.33l-0.27,-1.16l-0.15,-0.2l-0.87,-0.46l0.65,-1.01l-0.04,-0.37l-1.06,-1.09l-0.54,-3.2l0.83,-0.51l0.14,-0.29l-0.42,-3.6l0.58,-2.98l0.64,-2.5l1.41,-1.0l0.12,-0.32l-0.75,-2.8l-0.01,-2.48l1.81,-1.78l0.09,-0.22l-0.06,-2.3l1.39,-2.69l0.03,-0.14l0.01,-2.58l-0.11,-0.24l-0.57,-0.45l-1.1,-4.59l1.49,-2.73l0.04,-0.17l-0.23,-2.59l0.86,-2.38l1.6,-2.48l1.74,-1.65l0.04,-0.39l-0.64,-0.89l0.42,-0.7l0.04,-0.16l-0.08,-4.26l2.55,-1.23l0.16,-0.18l0.86,-2.75l-0.01,-0.22l-0.22,-0.48l1.84,-2.1l3.0,0.59ZM256.77,438.98l-2.1,0.15l-1.18,-1.14l-0.19,-0.08l-1.53,-0.09l-2.38,-0.0l-0.0,-6.28l0.4,0.65l1.25,2.55l0.11,0.12l3.26,2.07l3.19,0.8l-0.82,1.26Z", "name": "Argentina"}, "AU": {"path": "M705.55,353.06l0.09,0.09l0.37,0.05l0.13,-0.35l-0.57,-1.69l0.48,0.3l0.71,0.99l0.34,0.11l0.2,-0.29l-0.04,-1.37l-0.04,-0.14l-1.22,-2.07l-0.28,-0.9l-0.51,-0.69l0.24,-1.33l0.52,-0.7l0.34,-1.32l0.01,-0.13l-0.25,-1.44l0.51,-0.94l0.1,1.03l0.23,0.26l0.32,-0.14l1.01,-1.72l1.94,-0.84l1.27,-1.14l1.84,-0.92l1.0,-0.18l0.6,0.28l0.26,-0.0l1.94,-0.96l1.48,-0.28l0.19,-0.13l0.32,-0.49l0.51,-0.18l1.42,0.05l2.63,-0.76l0.11,-0.06l1.36,-1.15l0.08,-0.1l0.61,-1.33l1.42,-1.27l0.1,-0.19l0.11,-1.03l0.06,-1.32l1.39,-1.74l0.85,1.79l0.4,0.14l1.07,-0.51l0.11,-0.45l-0.77,-1.05l0.53,-0.84l0.86,0.43l0.43,-0.22l0.29,-1.85l1.29,-1.19l0.6,-0.98l1.16,-0.4l0.2,-0.27l0.02,-0.34l0.74,0.2l0.38,-0.27l0.03,-0.44l1.98,-0.61l1.7,1.08l1.36,1.48l0.22,0.1l1.55,0.02l1.57,0.24l0.33,-0.4l-0.48,-1.27l1.09,-1.86l1.06,-0.63l0.1,-0.42l-0.28,-0.46l0.93,-1.24l1.36,-0.8l1.16,0.27l0.14,0.0l2.1,-0.48l0.23,-0.3l-0.05,-1.3l-0.18,-0.26l-1.08,-0.49l0.44,-0.12l1.52,0.58l1.39,1.06l2.11,0.65l0.19,-0.0l0.59,-0.21l1.44,0.72l0.27,0.0l1.37,-0.68l0.84,0.2l0.26,-0.06l0.37,-0.3l0.82,0.89l-0.56,1.14l-0.84,0.91l-0.75,0.07l-0.26,0.38l0.26,0.9l-0.67,1.15l-0.88,1.24l-0.05,0.25l0.18,0.72l0.12,0.17l1.99,1.42l1.96,0.84l1.25,0.86l1.8,1.51l0.19,0.07l0.63,-0.0l1.15,0.58l0.34,0.7l0.17,0.15l2.39,0.88l0.24,-0.02l1.65,-0.88l0.14,-0.16l0.49,-1.37l0.52,-1.19l0.31,-1.39l0.75,-2.02l0.01,-0.19l-0.33,-1.16l0.16,-0.67l0.0,-0.13l-0.28,-1.41l0.3,-1.78l0.42,-0.45l0.05,-0.33l-0.33,-0.73l0.56,-1.25l0.48,-1.39l0.07,-0.69l0.58,-0.59l0.48,0.84l0.17,1.53l0.17,0.24l0.47,0.23l0.09,0.9l0.05,0.14l0.87,1.23l0.17,1.33l-0.09,0.89l0.03,0.15l0.9,2.0l0.43,0.13l1.38,-0.83l0.71,0.92l1.06,0.88l-0.22,0.96l0.0,0.14l0.53,2.2l0.38,1.3l0.15,0.18l0.52,0.26l0.62,2.01l-0.23,1.27l0.02,0.18l0.81,1.76l0.14,0.14l2.69,1.35l3.21,2.21l-0.2,0.4l0.04,0.34l1.39,1.6l0.95,2.78l0.43,0.16l0.79,-0.46l0.85,0.96l0.39,0.05l0.22,-0.15l0.36,2.33l0.09,0.18l1.78,1.63l1.16,1.01l1.9,2.1l0.67,2.05l0.06,1.47l-0.17,1.64l0.03,0.17l1.16,2.22l-0.14,2.28l-0.43,1.24l-0.68,2.44l0.04,1.63l-0.48,1.92l-1.06,2.43l-1.79,1.32l-0.1,0.12l-0.91,2.15l-0.82,1.37l-0.76,2.47l-0.98,1.46l-0.63,2.14l-0.33,2.02l0.1,0.82l-1.21,0.85l-2.71,0.1l-0.13,0.03l-2.31,1.19l-1.21,1.17l-1.34,1.11l-1.89,-1.18l-1.33,-0.46l0.32,-1.24l-0.4,-0.35l-1.46,0.61l-2.06,1.98l-1.99,-0.73l-1.43,-0.46l-1.45,-0.22l-2.32,-0.81l-1.51,-1.67l-0.45,-2.11l-0.6,-1.5l-0.07,-0.11l-1.23,-1.16l-0.16,-0.08l-1.96,-0.28l0.59,-0.99l0.03,-0.24l-0.61,-2.1l-0.54,-0.08l-1.16,1.85l-1.23,0.29l0.73,-0.88l0.06,-0.12l0.37,-1.57l0.93,-1.33l0.05,-0.2l-0.2,-2.07l-0.53,-0.17l-2.01,2.35l-1.52,0.94l-0.12,0.14l-0.82,1.93l-1.5,-0.9l0.07,-1.32l-0.06,-0.2l-1.57,-2.04l-1.15,-0.92l0.3,-0.41l-0.1,-0.44l-3.21,-1.69l-0.13,-0.03l-1.69,-0.08l-2.35,-1.31l-0.16,-0.04l-4.55,0.27l-3.24,0.99l-2.8,0.91l-2.33,-0.18l-0.17,0.03l-2.63,1.41l-2.14,0.64l-0.2,0.19l-0.47,1.42l-0.8,0.99l-1.99,0.06l-1.55,0.24l-2.27,-0.5l-1.79,0.3l-1.71,0.13l-0.19,0.09l-1.38,1.39l-0.58,-0.1l-0.21,0.04l-1.26,0.8l-1.13,0.85l-1.72,-0.1l-1.6,-0.0l-2.58,-1.76l-1.21,-0.49l0.04,-1.19l1.04,-0.32l0.16,-0.12l0.42,-0.64l0.05,-0.19l-0.09,-0.97l0.3,-2.0l-0.28,-1.64l-1.34,-2.84l-0.39,-1.49l0.1,-1.51l-0.04,-0.17l-0.96,-1.72l-0.06,-0.73l-0.09,-0.19l-1.04,-1.01l-0.3,-2.02l-0.05,-0.12l-1.23,-1.83ZM784.95,393.35l2.39,1.01l0.2,0.01l3.26,-0.96l1.19,0.16l0.16,3.19l-0.78,0.95l-0.07,0.16l-0.19,1.83l-0.43,-0.41l-0.44,0.03l-1.61,1.96l-0.4,-0.12l-1.38,-0.09l-1.43,-2.42l-0.37,-2.03l-1.4,-2.53l0.04,-0.94l1.27,0.2Z", "name": "Australia"}, "IL": {"path": "M509.04,199.22l0.71,0.0l0.27,-0.17l0.15,-0.33l0.19,-0.01l0.02,0.73l-0.27,0.34l0.02,0.08l-0.32,0.62l-0.65,-0.27l-0.41,0.19l-0.52,1.85l0.16,0.35l0.14,0.07l-0.17,0.1l-0.14,0.21l-0.11,0.73l0.39,0.33l0.81,-0.26l0.03,0.64l-0.97,3.43l-1.28,-3.67l0.62,-0.78l-0.03,-0.41l0.58,-1.16l0.5,-2.07l0.27,-0.54Z", "name": "Israel"}, "IN": {"path": "M615.84,192.58l2.4,2.97l-0.24,2.17l0.05,0.2l0.94,1.35l-0.06,0.97l-1.46,-0.3l-0.35,0.36l0.7,3.06l0.12,0.18l2.46,1.75l3.11,1.72l-1.23,0.96l-0.1,0.13l-0.97,2.55l0.16,0.38l2.41,1.02l2.37,1.33l3.27,1.52l3.43,0.37l1.37,1.3l0.17,0.08l1.92,0.25l3.0,0.62l2.15,-0.04l0.28,-0.22l0.29,-1.06l0.0,-0.13l-0.32,-1.66l0.16,-0.94l1.0,-0.37l0.23,2.28l0.18,0.24l2.28,1.02l0.2,0.02l1.52,-0.41l2.06,0.18l2.08,-0.08l0.29,-0.27l0.18,-1.66l-0.1,-0.26l-0.53,-0.44l1.38,-0.23l0.15,-0.07l2.26,-2.0l2.75,-1.65l1.97,0.63l0.25,-0.03l1.54,-0.99l0.89,1.28l-0.72,0.97l0.2,0.48l2.49,0.37l0.11,0.61l-0.69,0.39l-0.15,0.3l0.15,1.22l-1.36,-0.37l-0.23,0.03l-3.24,1.86l-0.15,0.28l0.07,1.44l-1.33,2.16l-0.04,0.13l-0.12,1.24l-0.98,1.91l-1.72,-0.53l-0.39,0.28l-0.09,2.66l-0.52,0.83l-0.04,0.23l0.21,0.89l-0.71,0.36l-1.21,-3.85l-0.29,-0.21l-0.69,0.01l-0.29,0.23l-0.28,1.17l-0.84,-0.84l0.6,-1.17l0.97,-0.13l0.23,-0.16l1.15,-2.25l-0.18,-0.42l-1.54,-0.47l-2.3,0.04l-2.13,-0.33l-0.19,-1.63l-0.26,-0.26l-1.13,-0.13l-1.93,-1.13l-0.42,0.13l-0.88,1.82l0.08,0.37l1.47,1.15l-1.21,0.77l-0.1,0.1l-0.56,0.97l0.13,0.42l1.31,0.61l-0.36,1.35l0.01,0.2l0.85,1.95l0.37,2.05l-0.26,0.68l-1.55,-0.02l-3.09,0.54l-0.25,0.32l0.13,1.84l-1.21,1.4l-3.64,1.79l-2.79,3.04l-1.86,1.61l-2.48,1.68l-0.13,0.25l-0.0,1.0l-1.07,0.55l-2.21,0.9l-1.13,0.13l-0.25,0.19l-0.75,1.96l-0.02,0.15l0.52,3.31l0.13,2.03l-1.03,2.35l-0.03,0.12l-0.01,4.03l-1.02,0.1l-0.23,0.15l-1.14,1.93l0.04,0.36l0.44,0.48l-1.83,0.57l-0.18,0.15l-0.81,1.65l-0.74,0.53l-2.14,-2.12l-1.14,-3.47l-0.96,-2.57l-0.9,-1.26l-1.3,-2.38l-0.61,-3.14l-0.44,-1.62l-2.29,-3.56l-1.03,-4.94l-0.74,-3.29l0.01,-3.12l-0.49,-2.51l-0.41,-0.22l-3.56,1.53l-1.59,-0.28l-2.96,-2.87l0.94,-0.74l0.06,-0.41l-0.74,-1.03l-2.73,-2.1l1.35,-1.43l5.38,0.01l0.29,-0.36l-0.5,-2.29l-0.09,-0.15l-1.33,-1.28l-0.27,-1.96l-0.12,-0.2l-1.36,-1.0l2.42,-2.48l2.77,0.2l0.24,-0.1l2.62,-2.85l1.59,-2.8l2.41,-2.74l0.07,-0.2l-0.04,-1.82l2.01,-1.51l-0.01,-0.49l-1.95,-1.33l-0.83,-1.81l-0.82,-2.27l0.98,-0.97l3.64,0.66l2.89,-0.42l0.17,-0.08l2.18,-2.15Z", "name": "India"}, "TZ": {"path": "M505.77,287.58l0.36,0.23l8.95,5.03l0.15,1.3l0.13,0.21l3.4,2.37l-1.07,2.88l-0.02,0.14l0.15,1.42l0.15,0.23l1.47,0.84l0.05,0.42l-0.66,1.44l-0.02,0.18l0.13,0.72l-0.16,1.16l0.03,0.19l0.87,1.57l1.03,2.48l0.12,0.14l0.53,0.32l-1.59,1.18l-2.64,0.95l-1.45,-0.04l-0.2,0.07l-0.81,0.69l-1.64,0.06l-0.68,0.3l-2.9,-0.69l-1.71,0.17l-0.65,-3.18l-0.05,-0.12l-1.35,-1.88l-0.19,-0.12l-2.41,-0.46l-1.38,-0.74l-1.63,-0.44l-0.96,-0.41l-0.95,-0.58l-1.31,-3.09l-1.47,-1.46l-0.45,-1.31l0.24,-1.34l-0.39,-1.99l0.71,-0.08l0.18,-0.09l0.91,-0.91l0.98,-1.31l0.59,-0.5l0.11,-0.24l-0.02,-0.81l-0.08,-0.2l-0.47,-0.5l-0.1,-0.67l0.51,-0.23l0.18,-0.25l0.14,-1.47l-0.05,-0.2l-0.76,-1.09l0.45,-0.15l2.71,0.03l5.01,-0.19Z", "name": "Tanzania"}, "AZ": {"path": "M539.36,175.66l0.16,0.09l1.11,0.2l0.32,-0.15l0.4,-0.71l1.22,-0.99l1.11,1.33l1.26,2.09l0.22,0.14l1.06,0.13l0.28,0.29l-1.46,0.17l-0.26,0.24l-0.43,2.26l-0.39,0.92l-0.85,0.63l-0.12,0.25l0.06,1.2l-0.22,0.05l-1.28,-1.25l0.74,-1.25l-0.03,-0.35l-0.74,-0.86l-0.3,-0.1l-1.05,0.27l-2.49,1.82l-0.04,-1.46l-0.18,-0.27l-1.09,-0.47l-0.8,-0.6l0.53,-0.7l-0.06,-0.42l-1.11,-0.84l0.34,-0.51l-0.11,-0.43l-0.89,-0.48l-0.33,-0.49l0.25,-0.2l1.78,0.81l1.35,0.18l0.25,-0.09l0.34,-0.35l0.02,-0.39l-1.04,-1.36l0.28,-0.18l0.49,0.07l1.65,1.74ZM533.53,180.16l0.63,0.67l0.22,0.09l0.8,-0.0l0.04,0.31l0.66,1.09l-0.94,-0.21l-1.16,-1.24l-0.25,-0.71Z", "name": "Azerbaijan"}, "IE": {"path": "M405.17,135.35l0.36,2.16l-1.78,2.84l-4.28,1.91l-3.02,-0.43l1.81,-3.13l0.02,-0.26l-1.23,-3.26l3.24,-2.56l1.54,-1.32l0.37,1.33l-0.49,1.77l0.3,0.38l1.49,-0.05l1.68,0.63Z", "name": "Ireland"}, "ID": {"path": "M756.56,287.86l0.69,4.02l0.15,0.21l2.59,1.5l0.39,-0.07l2.05,-2.61l2.75,-1.45l2.09,-0.0l2.08,0.85l1.85,0.89l2.52,0.46l0.08,15.44l-1.72,-1.6l-0.15,-0.07l-2.54,-0.51l-0.29,0.1l-0.53,0.62l-2.53,0.06l0.78,-1.51l1.48,-0.66l0.17,-0.34l-0.65,-2.74l-1.23,-2.19l-0.14,-0.13l-4.85,-2.13l-2.09,-0.23l-3.7,-2.28l-0.41,0.1l-0.67,1.11l-0.63,0.14l-0.41,-0.67l-0.01,-1.01l-0.14,-0.25l-1.39,-0.89l2.05,-0.69l1.73,0.05l0.29,-0.39l-0.21,-0.66l-0.29,-0.21l-3.5,-0.0l-0.9,-1.36l-0.19,-0.13l-2.14,-0.44l-0.65,-0.76l2.86,-0.51l1.28,-0.79l3.75,0.96l0.32,0.76ZM758.01,300.37l-0.79,1.04l-0.14,-1.07l0.4,-0.81l0.29,-0.47l0.24,0.31l-0.0,1.0ZM747.45,292.9l0.48,1.02l-1.45,-0.69l-2.09,-0.21l-1.45,0.16l-1.28,-0.07l0.35,-0.81l2.86,-0.1l2.58,0.68ZM741.15,285.69l-0.16,-0.25l-0.72,-3.08l0.47,-1.86l0.35,-0.38l0.1,0.73l0.25,0.26l1.28,0.19l0.18,0.78l-0.11,1.8l-0.96,-0.18l-0.35,0.22l-0.38,1.52l0.05,0.24ZM741.19,285.75l0.76,0.97l-0.11,0.05l-0.65,-1.02ZM739.18,293.52l-0.61,0.54l-1.44,-0.38l-0.25,-0.55l1.93,-0.09l0.36,0.48ZM728.4,295.87l-0.27,-0.07l-2.26,0.89l-0.37,-0.41l0.27,-0.8l-0.09,-0.33l-1.68,-1.37l0.17,-2.29l-0.42,-0.3l-1.67,0.76l-0.17,0.29l0.21,2.92l0.09,3.34l-1.22,0.28l-0.78,-0.54l0.65,-2.1l0.01,-0.14l-0.39,-2.42l-0.29,-0.25l-0.86,-0.02l-0.63,-1.4l0.99,-1.61l0.35,-1.97l1.24,-3.73l0.49,-0.96l1.95,-1.7l1.86,0.69l3.16,0.35l2.92,-0.1l0.17,-0.06l2.24,-1.65l0.11,0.14l-1.8,2.22l-1.72,0.44l-2.41,-0.48l-4.21,0.13l-2.19,0.36l-0.25,0.24l-0.36,1.9l0.08,0.27l2.24,2.23l0.4,0.02l1.29,-1.08l3.19,-0.58l-0.19,0.06l-1.04,1.4l-2.13,0.94l-0.12,0.45l2.26,3.06l-0.37,0.69l0.03,0.32l1.51,1.95ZM728.48,295.97l0.59,0.76l-0.02,1.37l-1.0,0.55l-0.64,-0.58l1.09,-1.84l-0.02,-0.26ZM728.64,286.95l0.79,-0.14l-0.07,0.39l-0.72,-0.24ZM732.38,310.1l-1.89,0.49l-0.06,-0.06l0.17,-0.64l1.0,-1.42l2.14,-0.87l0.1,0.2l0.04,0.58l-1.49,1.72ZM728.26,305.71l-0.17,0.63l-3.53,0.67l-3.02,-0.28l-0.0,-0.42l1.66,-0.44l1.47,0.71l0.16,0.03l1.75,-0.21l1.69,-0.69ZM722.98,310.33l-0.74,0.03l-2.52,-1.35l1.42,-0.3l1.19,0.7l0.72,0.63l-0.06,0.28ZM716.24,305.63l0.66,0.49l0.22,0.06l1.35,-0.18l0.31,0.53l-4.18,0.77l-0.8,-0.01l0.51,-0.86l1.2,-0.02l0.24,-0.12l0.49,-0.65ZM715.84,280.21l0.09,0.34l2.25,1.86l-2.25,0.22l-0.24,0.17l-0.84,1.71l-0.03,0.15l0.1,2.11l-2.27,1.62l-0.13,0.24l-0.06,2.46l-0.74,2.92l-0.02,-0.05l-0.39,-0.16l-2.62,1.04l-0.86,-1.33l-0.23,-0.14l-1.71,-0.14l-1.19,-0.76l-0.25,-0.03l-2.78,0.84l-0.79,-1.05l-0.26,-0.12l-1.61,0.13l-1.8,-0.25l-0.36,-3.13l-0.15,-0.23l-1.18,-0.65l-1.13,-2.02l-0.33,-2.1l0.27,-2.19l1.05,-1.17l0.28,1.12l0.1,0.16l1.71,1.41l0.28,0.05l1.55,-0.49l1.54,0.17l0.23,-0.07l1.4,-1.21l1.05,-0.19l2.3,0.68l0.16,0.0l2.04,-0.53l0.21,-0.19l1.26,-3.41l0.91,-0.82l0.09,-0.14l0.8,-2.64l2.63,0.0l1.71,0.33l-1.19,1.89l0.02,0.34l1.74,2.24l-0.37,1.0ZM692.67,302.0l0.26,0.19l4.8,0.25l0.28,-0.16l0.44,-0.83l4.29,1.12l0.85,1.52l0.23,0.15l3.71,0.45l2.37,1.15l-2.06,0.69l-2.77,-1.0l-2.25,0.07l-2.57,-0.18l-2.31,-0.45l-2.94,-0.97l-1.84,-0.25l-0.13,0.01l-0.97,0.29l-4.34,-0.98l-0.38,-0.94l-0.25,-0.19l-1.76,-0.14l1.31,-1.84l2.81,0.14l1.97,0.96l0.95,0.19l0.28,0.74ZM685.63,299.27l-2.36,0.04l-2.07,-2.05l-3.17,-2.02l-1.06,-1.5l-1.88,-2.02l-1.22,-1.85l-1.9,-3.49l-2.2,-2.11l-0.71,-2.08l-0.94,-1.99l-0.1,-0.12l-2.21,-1.54l-1.35,-2.17l-1.86,-1.39l-2.53,-2.68l-0.14,-0.81l1.22,0.08l3.76,0.47l2.16,2.4l1.94,1.7l1.37,1.04l2.35,2.67l0.22,0.1l2.44,0.04l1.99,1.62l1.42,2.06l0.09,0.09l1.67,1.0l-0.88,1.8l0.11,0.39l1.44,0.87l0.13,0.04l0.68,0.05l0.41,1.62l0.87,1.4l0.22,0.14l1.71,0.21l1.06,1.38l-0.61,3.04l-0.09,3.6Z", "name": "Indonesia"}, "UA": {"path": "M500.54,141.42l0.9,0.13l0.27,-0.11l0.52,-0.62l0.68,0.13l2.43,-0.3l1.32,1.57l-0.45,0.48l-0.07,0.26l0.21,1.03l0.27,0.24l1.85,0.15l0.76,1.22l-0.05,0.55l0.2,0.31l3.18,1.15l0.18,0.01l1.75,-0.47l1.42,1.41l0.22,0.09l1.42,-0.03l3.44,0.99l0.02,0.65l-0.97,1.62l-0.03,0.24l0.52,1.67l-0.29,0.79l-2.24,0.22l-0.14,0.05l-1.29,0.89l-0.13,0.23l-0.07,1.16l-1.75,0.22l-0.12,0.04l-1.6,0.98l-2.27,0.16l-0.12,0.04l-2.16,1.17l-0.16,0.29l0.15,1.94l0.14,0.23l1.23,0.75l0.18,0.04l2.06,-0.15l-0.22,0.51l-2.67,0.54l-3.27,1.72l-1.0,-0.45l0.45,-1.19l-0.19,-0.39l-2.34,-0.78l0.15,-0.2l2.32,-1.0l0.09,-0.49l-0.73,-0.72l-0.15,-0.08l-3.69,-0.75l-0.14,-0.96l-0.35,-0.25l-2.32,0.39l-0.21,0.15l-0.91,1.7l-1.77,2.1l-0.93,-0.44l-0.24,-0.0l-1.05,0.45l-0.48,-0.25l0.13,-0.07l0.14,-0.15l0.43,-1.04l0.67,-0.97l0.04,-0.26l-0.1,-0.31l0.04,-0.02l0.11,0.19l0.24,0.15l1.48,0.09l0.78,-0.25l0.07,-0.53l-0.27,-0.19l0.09,-0.25l-0.08,-0.33l-0.81,-0.74l-0.34,-1.24l-0.14,-0.18l-0.73,-0.42l0.15,-0.87l-0.11,-0.29l-1.13,-0.86l-0.15,-0.06l-0.97,-0.11l-1.79,-0.97l-0.2,-0.03l-1.66,0.32l-0.13,0.06l-0.52,0.41l-0.95,-0.0l-0.23,0.11l-0.56,0.66l-1.74,0.29l-0.79,0.43l-1.01,-0.68l-0.16,-0.05l-1.57,-0.01l-1.52,-0.35l-0.23,0.04l-0.71,0.45l-0.09,-0.43l-0.13,-0.19l-1.18,-0.74l0.38,-1.02l0.53,-0.64l0.35,0.12l0.37,-0.41l-0.57,-1.29l2.1,-2.5l1.16,-0.36l0.2,-0.2l0.27,-0.92l-0.01,-0.2l-1.1,-2.52l0.79,-0.09l0.13,-0.05l1.3,-0.86l1.83,-0.07l2.48,0.26l2.84,0.8l1.91,0.06l0.88,0.45l0.29,-0.01l0.72,-0.44l0.49,0.58l0.25,0.11l2.2,-0.16l0.94,0.3l0.39,-0.26l0.15,-1.57l0.61,-0.59l2.01,-0.19Z", "name": "Ukraine"}, "QA": {"path": "M548.47,221.47l-0.15,-1.72l0.59,-1.23l0.38,-0.16l0.54,0.6l0.04,1.4l-0.47,1.37l-0.41,0.11l-0.53,-0.37Z", "name": "Qatar"}, "MZ": {"path": "M507.71,314.14l1.65,-0.18l2.96,0.7l0.2,-0.02l0.6,-0.29l1.68,-0.06l0.18,-0.07l0.8,-0.69l1.5,0.02l2.74,-0.98l1.74,-1.27l0.25,0.7l-0.1,2.47l0.31,2.27l0.1,3.97l0.42,1.24l-0.7,1.71l-0.94,1.73l-1.52,1.52l-5.06,2.21l-2.88,2.8l-1.01,0.51l-1.72,1.81l-0.99,0.58l-0.15,0.23l-0.21,1.86l0.04,0.19l1.17,1.95l0.47,1.47l0.03,0.74l0.39,0.28l0.05,-0.01l-0.06,2.13l-0.39,1.19l0.1,0.33l0.42,0.32l-0.28,0.83l-0.95,0.86l-2.03,0.88l-3.08,1.49l-1.1,0.99l-0.09,0.28l0.21,1.13l0.21,0.23l0.38,0.11l-0.14,0.89l-1.39,-0.02l-0.17,-0.94l-0.38,-1.23l-0.2,-0.89l0.44,-2.91l-0.01,-0.14l-0.65,-1.88l-1.15,-3.55l2.52,-2.85l0.68,-1.89l0.29,-0.18l0.14,-0.2l0.28,-1.53l-0.03,-0.19l-0.36,-0.7l0.1,-1.83l0.49,-1.84l-0.01,-3.26l-0.14,-0.25l-1.3,-0.83l-0.11,-0.04l-1.08,-0.17l-0.47,-0.55l-0.1,-0.08l-1.16,-0.54l-0.13,-0.03l-1.83,0.04l-0.32,-2.25l7.19,-1.99l1.32,1.12l0.29,0.06l0.55,-0.19l0.75,0.49l0.11,0.81l-0.49,1.11l-0.02,0.15l0.19,1.81l0.09,0.18l1.63,1.59l0.48,-0.1l0.72,-1.68l0.99,-0.49l0.17,-0.29l-0.21,-3.29l-0.04,-0.13l-1.11,-1.92l-0.9,-0.82l-0.21,-0.08l-0.62,0.03l-0.63,-2.98l0.61,-1.67Z", "name": "Mozambique"}}, "height": 440.7063107441331, "projection": {"type": "mill", "centralMeridian": 11.5}, "width": 900.0});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! SmartAdmin - v1.4.1 - 2014-06-22 */!function(a,b,c,d){function e(b,c){this.obj=a(b),this.o=a.extend({},a.fn[f].defaults,c),this.objId=this.obj.attr("id"),this.pwCtrls=".jarviswidget-ctrls",this.widget=this.obj.find(this.o.widgets),this.toggleClass=this.o.toggleClass.split("|"),this.editClass=this.o.editClass.split("|"),this.fullscreenClass=this.o.fullscreenClass.split("|"),this.customClass=this.o.customClass.split("|"),this.init()}var f="jarvisWidgets";e.prototype={_settings:function(){var a=this;storage=!!function(){var a,b=+new Date;try{return localStorage.setItem(b,b),a=localStorage.getItem(b)==b,localStorage.removeItem(b),a}catch(c){}}()&&localStorage,storage&&a.o.localStorage&&(a.o.ajaxnav===!0?(widget_url=location.hash.replace(/^#/,""),keySettings="Plugin_settings_"+widget_url+"_"+a.objId,getKeySettings=localStorage.getItem(keySettings),keyPosition="Plugin_position_"+widget_url+"_"+a.objId,getKeyPosition=localStorage.getItem(keyPosition)):(keySettings="jarvisWidgets_settings_"+location.pathname+"_"+a.objId,getKeySettings=localStorage.getItem(keySettings),keyPosition="jarvisWidgets_position_"+location.pathname+"_"+a.objId,getKeyPosition=localStorage.getItem(keyPosition))),clickEvent="ontouchstart"in b||b.DocumentTouch&&c instanceof DocumentTouch?"touchstart":"click"},_runLoaderWidget:function(a){var b=this;b.o.indicator===!0&&a.parents(b.o.widgets).find(".jarviswidget-loader").stop(!0,!0).fadeIn(100).delay(b.o.indicatorTime).fadeOut(100)},_getPastTimestamp:function(a){var b=this,c=new Date(a),d=c.getMonth()+1,e=c.getDate(),f=c.getFullYear(),g=c.getHours(),h=c.getMinutes(),i=c.getUTCSeconds();10>d&&(d="0"+d),10>e&&(e="0"+e),10>g&&(g="0"+g),10>h&&(h="0"+h),10>i&&(i="0"+i);var j=b.o.timestampFormat.replace(/%d%/g,e).replace(/%m%/g,d).replace(/%y%/g,f).replace(/%h%/g,g).replace(/%i%/g,h).replace(/%s%/g,i);return j},_loadAjaxFile:function(b,c,d){var e=this;b.find(".widget-body").load(c,function(c,d,f){var g=a(this);if("error"==d&&g.html('<h4 class="alert alert-danger">'+e.o.labelError+"<b> "+f.status+" "+f.statusText+"</b></h4>"),"success"==d){var h=b.find(e.o.timestampPlaceholder);h.length&&h.html(e._getPastTimestamp(new Date)),"function"==typeof e.o.afterLoad&&e.o.afterLoad.call(this,b)}}),e._runLoaderWidget(d)},_saveSettingsWidget:function(){var b=this;if(b._settings(),storage&&b.o.localStorage){var c=[];b.obj.find(b.o.widgets).each(function(){var b={};b.id=a(this).attr("id"),b.style=a(this).attr("data-widget-attstyle"),b.title=a(this).children("header").children("h2").text(),b.hidden=a(this).is(":hidden")?1:0,b.collapsed=a(this).hasClass("jarviswidget-collapsed")?1:0,c.push(b)}),storeSettingsObj=JSON.stringify({widget:c}),getKeySettings!=storeSettingsObj&&localStorage.setItem(keySettings,storeSettingsObj)}"function"==typeof b.o.onSave&&b.o.onSave.call(this,null,storeSettingsObj)},_savePositionWidget:function(){var b=this;if(b._settings(),storage&&b.o.localStorage){var c=[];b.obj.find(b.o.grid+".sortable-grid").each(function(){var d=[];a(this).children(b.o.widgets).each(function(){var b={};b.id=a(this).attr("id"),d.push(b)});var e={section:d};c.push(e)});var d=JSON.stringify({grid:c});getKeyPosition!=d&&localStorage.setItem(keyPosition,d,null)}"function"==typeof b.o.onSave&&b.o.onSave.call(this,d)},init:function(){var b=this;if(b._settings(),a("#"+b.objId).length||alert("It looks like your using a class instead of an ID, dont do that!"),b.o.rtl===!0&&a("body").addClass("rtl"),a(b.o.grid).each(function(){a(this).find(b.o.widgets).length&&a(this).addClass("sortable-grid")}),storage&&b.o.localStorage&&getKeyPosition){var c=JSON.parse(getKeyPosition);for(var e in c.grid){var f=b.obj.find(b.o.grid+".sortable-grid").eq(e);for(var g in c.grid[e].section)f.append(a("#"+c.grid[e].section[g].id))}}if(storage&&b.o.localStorage&&getKeySettings){var h=JSON.parse(getKeySettings);for(var e in h.widget){var i=a("#"+h.widget[e].id);h.widget[e].style&&i.removeClassPrefix("jarviswidget-color-").addClass(h.widget[e].style).attr("data-widget-attstyle",""+h.widget[e].style),1==h.widget[e].hidden?i.hide(1):i.show(1).removeAttr("data-widget-hidden"),1==h.widget[e].collapsed&&i.addClass("jarviswidget-collapsed").children("div").hide(1),i.children("header").children("h2").text()!=h.widget[e].title&&i.children("header").children("h2").text(h.widget[e].title)}}if(b.widget.each(function(){var c,e,f,g,h,i,j,k,l=a(this),m=a(this).children("header");if(!m.parent().attr("role")){l.data("widget-hidden")===!0&&l.hide(),l.data("widget-collapsed")===!0&&l.addClass("jarviswidget-collapsed").children("div").hide(),c=b.o.customButton===!0&&l.data("widget-custombutton")===d&&0!==b.customClass[0].length?'<a href="javascript:void(0);" class="button-icon jarviswidget-custom-btn"><i class="'+b.customClass[0]+'"></i></a>':"",e=b.o.deleteButton===!0&&l.data("widget-deletebutton")===d?'<a href="javascript:void(0);" class="button-icon jarviswidget-delete-btn" rel="tooltip" title="Delete" data-placement="bottom"><i class="'+b.o.deleteClass+'"></i></a>':"",f=b.o.editButton===!0&&l.data("widget-editbutton")===d?'<a href="javascript:void(0);" class="button-icon jarviswidget-edit-btn" rel="tooltip" title="Edit Title" data-placement="bottom"><i class="'+b.editClass[0]+'"></i></a>':"",g=b.o.fullscreenButton===!0&&l.data("widget-fullscreenbutton")===d?'<a href="javascript:void(0);" class="button-icon jarviswidget-fullscreen-btn" rel="tooltip" title="Fullscreen" data-placement="bottom"><i class="'+b.fullscreenClass[0]+'"></i></a>':"",b.o.colorButton===!0&&l.data("widget-colorbutton")===d?(h='<a data-toggle="dropdown" class="dropdown-toggle color-box selector" href="javascript:void(0);"></a><ul class="dropdown-menu arrow-box-up-right color-select pull-right"><li><span class="bg-color-green" data-widget-setstyle="jarviswidget-color-green" rel="tooltip" data-placement="left" data-original-title="Green Grass"></span></li><li><span class="bg-color-greenDark" data-widget-setstyle="jarviswidget-color-greenDark" rel="tooltip" data-placement="top" data-original-title="Dark Green"></span></li><li><span class="bg-color-greenLight" data-widget-setstyle="jarviswidget-color-greenLight" rel="tooltip" data-placement="top" data-original-title="Light Green"></span></li><li><span class="bg-color-purple" data-widget-setstyle="jarviswidget-color-purple" rel="tooltip" data-placement="top" data-original-title="Purple"></span></li><li><span class="bg-color-magenta" data-widget-setstyle="jarviswidget-color-magenta" rel="tooltip" data-placement="top" data-original-title="Magenta"></span></li><li><span class="bg-color-pink" data-widget-setstyle="jarviswidget-color-pink" rel="tooltip" data-placement="right" data-original-title="Pink"></span></li><li><span class="bg-color-pinkDark" data-widget-setstyle="jarviswidget-color-pinkDark" rel="tooltip" data-placement="left" data-original-title="Fade Pink"></span></li><li><span class="bg-color-blueLight" data-widget-setstyle="jarviswidget-color-blueLight" rel="tooltip" data-placement="top" data-original-title="Light Blue"></span></li><li><span class="bg-color-teal" data-widget-setstyle="jarviswidget-color-teal" rel="tooltip" data-placement="top" data-original-title="Teal"></span></li><li><span class="bg-color-blue" data-widget-setstyle="jarviswidget-color-blue" rel="tooltip" data-placement="top" data-original-title="Ocean Blue"></span></li><li><span class="bg-color-blueDark" data-widget-setstyle="jarviswidget-color-blueDark" rel="tooltip" data-placement="top" data-original-title="Night Sky"></span></li><li><span class="bg-color-darken" data-widget-setstyle="jarviswidget-color-darken" rel="tooltip" data-placement="right" data-original-title="Night"></span></li><li><span class="bg-color-yellow" data-widget-setstyle="jarviswidget-color-yellow" rel="tooltip" data-placement="left" data-original-title="Day Light"></span></li><li><span class="bg-color-orange" data-widget-setstyle="jarviswidget-color-orange" rel="tooltip" data-placement="bottom" data-original-title="Orange"></span></li><li><span class="bg-color-orangeDark" data-widget-setstyle="jarviswidget-color-orangeDark" rel="tooltip" data-placement="bottom" data-original-title="Dark Orange"></span></li><li><span class="bg-color-red" data-widget-setstyle="jarviswidget-color-red" rel="tooltip" data-placement="bottom" data-original-title="Red Rose"></span></li><li><span class="bg-color-redLight" data-widget-setstyle="jarviswidget-color-redLight" rel="tooltip" data-placement="bottom" data-original-title="Light Red"></span></li><li><span class="bg-color-white" data-widget-setstyle="jarviswidget-color-white" rel="tooltip" data-placement="right" data-original-title="Purity"></span></li><li><a href="javascript:void(0);" class="jarviswidget-remove-colors" data-widget-setstyle="" rel="tooltip" data-placement="bottom" data-original-title="Reset widget color to default">Remove</a></li></ul>',m.prepend('<div class="widget-toolbar">'+h+"</div>")):h="",b.o.toggleButton===!0&&l.data("widget-togglebutton")===d?(j=l.data("widget-collapsed")===!0||l.hasClass("jarviswidget-collapsed")?b.toggleClass[1]:b.toggleClass[0],i='<a href="javascript:void(0);" class="button-icon jarviswidget-toggle-btn" rel="tooltip" title="Collapse" data-placement="bottom"><i class="'+j+'"></i></a>'):i="",k=b.o.refreshButton===!0&&l.data("widget-refreshbutton")!==!1&&l.data("widget-load")?'<a href="javascript:void(0);" class="button-icon jarviswidget-refresh-btn" data-loading-text="&nbsp;&nbsp;Loading...&nbsp;" rel="tooltip" title="Refresh" data-placement="bottom"><i class="'+b.o.refreshButtonClass+'"></i></a>':"";var n=b.o.buttonOrder.replace(/%refresh%/g,k).replace(/%delete%/g,e).replace(/%custom%/g,c).replace(/%fullscreen%/g,g).replace(/%edit%/g,f).replace(/%toggle%/g,i);(""!==k||""!==e||""!==c||""!==g||""!==f||""!==i)&&m.prepend('<div class="jarviswidget-ctrls">'+n+"</div>"),b.o.sortable===!0&&l.data("widget-sortable")===d&&l.addClass("jarviswidget-sortable"),l.find(b.o.editPlaceholder).length&&l.find(b.o.editPlaceholder).find("input").val(a.trim(m.children("h2").text())),m.append('<span class="jarviswidget-loader"><i class="fa fa-refresh fa-spin"></i></span>'),l.attr("role","widget").children("div").attr("role","content").prev("header").attr("role","heading").children("div").attr("role","menu")}}),b.o.buttonsHidden===!0&&a(b.o.pwCtrls).hide(),a(".jarviswidget header [rel=tooltip]").tooltip(),b.obj.find("[data-widget-load]").each(function(){{var c=a(this),d=c.children(),e=c.data("widget-load"),f=1e3*c.data("widget-refresh");c.children()}c.find(".jarviswidget-ajax-placeholder").length||(c.children("widget-body").append('<div class="jarviswidget-ajax-placeholder">'+b.o.loadingLabel+"</div>"),c.data("widget-refresh")>0?(b._loadAjaxFile(c,e,d),a.intervalArr.push(setInterval(function(){b._loadAjaxFile(c,e,d)},f))):b._loadAjaxFile(c,e,d))}),b.o.sortable===!0&&jQuery.ui){var j=b.obj.find(".sortable-grid").not("[data-widget-excludegrid]");j.sortable({items:j.find(".jarviswidget-sortable"),connectWith:j,placeholder:b.o.placeholderClass,cursor:"move",revert:!0,opacity:b.o.opacity,delay:200,cancel:".button-icon, #jarviswidget-fullscreen-mode > div",zIndex:1e4,handle:b.o.dragHandle,forcePlaceholderSize:!0,forceHelperSize:!0,update:function(a,c){b._runLoaderWidget(c.item.children()),b._savePositionWidget(),"function"==typeof b.o.onChange&&b.o.onChange.call(this,c.item)}})}b.o.buttonsHidden===!0&&b.widget.children("header").hover(function(){a(this).children(b.o.pwCtrls).stop(!0,!0).fadeTo(100,1)},function(){a(this).children(b.o.pwCtrls).stop(!0,!0).fadeTo(100,0)}),b._clickEvents(),a(b.o.deleteSettingsKey).on(clickEvent,this,function(a){if(storage&&b.o.localStorage){var c=confirm(b.o.settingsKeyLabel);c&&localStorage.removeItem(keySettings)}a.preventDefault()}),a(b.o.deletePositionKey).on(clickEvent,this,function(a){if(storage&&b.o.localStorage){var c=confirm(b.o.positionKeyLabel);c&&localStorage.removeItem(keyPosition)}a.preventDefault()}),storage&&b.o.localStorage&&((null===getKeySettings||getKeySettings.length<1)&&b._saveSettingsWidget(),(null===getKeyPosition||getKeyPosition.length<1)&&b._savePositionWidget())},_clickEvents:function(){function c(){if(a("#jarviswidget-fullscreen-mode").length){var c=a(b).height(),e=a("#jarviswidget-fullscreen-mode").find(d.o.widgets).children("header").height();a("#jarviswidget-fullscreen-mode").find(d.o.widgets).children("div").height(c-e-15)}}var d=this;d._settings(),d.widget.on(clickEvent,".jarviswidget-toggle-btn",function(b){var c=a(this),e=c.parents(d.o.widgets);d._runLoaderWidget(c),e.hasClass("jarviswidget-collapsed")?c.children().removeClass(d.toggleClass[1]).addClass(d.toggleClass[0]).parents(d.o.widgets).removeClass("jarviswidget-collapsed").children("[role=content]").slideDown(d.o.toggleSpeed,function(){d._saveSettingsWidget()}):c.children().removeClass(d.toggleClass[0]).addClass(d.toggleClass[1]).parents(d.o.widgets).addClass("jarviswidget-collapsed").children("[role=content]").slideUp(d.o.toggleSpeed,function(){d._saveSettingsWidget()}),"function"==typeof d.o.onToggle&&d.o.onToggle.call(this,e),b.preventDefault()}),d.widget.on(clickEvent,".jarviswidget-fullscreen-btn",function(b){var e=a(this).parents(d.o.widgets),f=e.children("div");d._runLoaderWidget(a(this)),a("#jarviswidget-fullscreen-mode").length?(a(".nooverflow").removeClass("nooverflow"),e.unwrap("<div>").children("div").removeAttr("style").end().find(".jarviswidget-fullscreen-btn").children().removeClass(d.fullscreenClass[1]).addClass(d.fullscreenClass[0]).parents(d.pwCtrls).children("a").show(),f.hasClass("jarviswidget-visible")&&f.hide().removeClass("jarviswidget-visible")):(a("body").addClass("nooverflow"),e.wrap('<div id="jarviswidget-fullscreen-mode"/>').parent().find(".jarviswidget-fullscreen-btn").children().removeClass(d.fullscreenClass[0]).addClass(d.fullscreenClass[1]).parents(d.pwCtrls).children("a:not(.jarviswidget-fullscreen-btn)").hide(),f.is(":hidden")&&f.show().addClass("jarviswidget-visible")),c(),"function"==typeof d.o.onFullscreen&&d.o.onFullscreen.call(this,e),b.preventDefault()}),a(b).resize(function(){c()}),d.widget.on(clickEvent,".jarviswidget-edit-btn",function(b){var c=a(this).parents(d.o.widgets);d._runLoaderWidget(a(this)),c.find(d.o.editPlaceholder).is(":visible")?a(this).children().removeClass(d.editClass[1]).addClass(d.editClass[0]).parents(d.o.widgets).find(d.o.editPlaceholder).slideUp(d.o.editSpeed,function(){d._saveSettingsWidget()}):a(this).children().removeClass(d.editClass[0]).addClass(d.editClass[1]).parents(d.o.widgets).find(d.o.editPlaceholder).slideDown(d.o.editSpeed),"function"==typeof d.o.onEdit&&d.o.onEdit.call(this,c),b.preventDefault()}),a(d.o.editPlaceholder).find("input").keyup(function(){a(this).parents(d.o.widgets).children("header").children("h2").text(a(this).val())}),d.widget.on(clickEvent,"[data-widget-setstyle]",function(b){var c=a(this).data("widget-setstyle"),e="";a(this).parents(d.o.editPlaceholder).find("[data-widget-setstyle]").each(function(){e+=a(this).data("widget-setstyle")+" "}),a(this).parents(d.o.widgets).attr("data-widget-attstyle",""+c).removeClassPrefix("jarviswidget-color-").addClass(c),d._runLoaderWidget(a(this)),d._saveSettingsWidget(),b.preventDefault()}),d.widget.on(clickEvent,".jarviswidget-custom-btn",function(b){var c=a(this).parents(d.o.widgets);d._runLoaderWidget(a(this)),a(this).children("."+d.customClass[0]).length?(a(this).children().removeClass(d.customClass[0]).addClass(d.customClass[1]),"function"==typeof d.o.customStart&&d.o.customStart.call(this,c)):(a(this).children().removeClass(d.customClass[1]).addClass(d.customClass[0]),"function"==typeof d.o.customEnd&&d.o.customEnd.call(this,c)),d._saveSettingsWidget(),b.preventDefault()}),d.widget.on(clickEvent,".jarviswidget-delete-btn",function(b){var c=a(this).parents(d.o.widgets),e=c.attr("id"),f=c.children("header").children("h2").text();a.SmartMessageBox?a.SmartMessageBox({title:"<i class='fa fa-times' style='color:#ed1c24'></i> "+d.o.labelDelete+' "'+f+'"',content:"Warning: This action cannot be undone",buttons:"[No][Yes]"},function(b){"Yes"==b&&(d._runLoaderWidget(a(this)),a("#"+e).fadeOut(d.o.deleteSpeed,function(){a(this).remove(),"function"==typeof d.o.onDelete&&d.o.onDelete.call(this,c)}))}):a("#"+e).fadeOut(d.o.deleteSpeed,function(){a(this).remove(),"function"==typeof d.o.onDelete&&d.o.onDelete.call(this,c)}),b.preventDefault()}),d.widget.on(clickEvent,".jarviswidget-refresh-btn",function(b){var c=a(this).parents(d.o.widgets),e=c.data("widget-load"),f=c.children(),g=a(this);g.button("loading"),f.addClass("widget-body-ajax-loading"),setTimeout(function(){g.button("reset"),f.removeClass("widget-body-ajax-loading"),d._loadAjaxFile(c,e,f)},1e3),b.preventDefault()})},destroy:function(){var a=this;a.widget.off("click",a._clickEvents()),a.obj.removeData(f)}},a.fn[f]=function(b){return this.each(function(){var c=a(this),d=c.data(f),g="object"==typeof b&&b;d||c.data(f,d=new e(this,g)),"string"==typeof b&&d[b]()})},a.fn[f].defaults={grid:"section",widgets:".jarviswidget",localStorage:!0,deleteSettingsKey:"",settingsKeyLabel:"Reset settings?",deletePositionKey:"",positionKeyLabel:"Reset position?",sortable:!0,buttonsHidden:!1,toggleButton:!0,toggleClass:"min-10 | plus-10",toggleSpeed:200,onToggle:function(){},deleteButton:!0,deleteClass:"trashcan-10",deleteSpeed:200,onDelete:function(){},editButton:!0,editPlaceholder:".jarviswidget-editbox",editClass:"pencil-10 | delete-10",editSpeed:200,onEdit:function(){},colorButton:!0,fullscreenButton:!0,fullscreenClass:"fullscreen-10 | normalscreen-10",fullscreenDiff:3,onFullscreen:function(){},customButton:!0,customClass:"",customStart:function(){},customEnd:function(){},buttonOrder:"%refresh% %delete% %custom% %edit% %fullscreen% %toggle%",opacity:1,dragHandle:"> header",placeholderClass:"jarviswidget-placeholder",indicator:!0,indicatorTime:600,ajax:!0,loadingLabel:"loading...",timestampPlaceholder:".jarviswidget-timestamp",timestampFormat:"Last update: %m%/%d%/%y% %h%:%i%:%s%",refreshButton:!0,refreshButtonClass:"refresh-10",labelError:"Sorry but there was a error:",labelUpdated:"Last Update:",labelRefresh:"Refresh",labelDelete:"Delete widget:",afterLoad:function(){},rtl:!1,onChange:function(){},onSave:function(){},ajaxnav:!0},a.fn.removeClassPrefix=function(b){return this.each(function(c,d){var e=d.className.split(" ").map(function(a){return 0===a.indexOf(b)?"":a});d.className=a.trim(e.join(" "))}),this}}(jQuery,window,document);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ })
],[414]);


// WEBPACK FOOTER //
// static/js/app.13278ecd5641c8b3349b.js